/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AnkorstoreInternalFailure {
  /** @uniqueItems true */
  errors: {
    /** An application-specific error code, expressed as a string value. */
    code?: string;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string;
    /** The HTTP status code applicable to this problem, expressed as a string value. */
    status?: string;
    /** The HTTP status code description applicable to this problem */
    title?: string;
    /** Optional object pointing towards the problematic field */
    source?: {
      /** The field key */
      pointer?: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Non-standard meta-information that can not be represented as an attribute or relationship. */
export type AnkorstoreInternalMeta = Record<string, any>;

/** Offset-based pagination details. */
export interface AnkorstoreInternalMetaPageOffset {
  /** The number of the current page. */
  currentPage?: number;
  /** The number of the last page. */
  lastPage?: number;
  /** The number of resources on a page. */
  perPage?: number;
  /** The total number of resources. */
  total?: number;
  /** The ordinal number of the first resource on the current page. */
  from?: number;
  /** The ordinal number of the last resource on the current page. */
  to?: number;
}

/** References to other resource objects in a to-one (`relationship`). Relationships can be specified by including a member in a resource's links object. */
export interface AnkorstoreInternalRelationshipToOne {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/**
 * An array of objects each containing `type` and `id` members for to-many relationships.
 * @uniqueItems true
 */
export type AnkorstoreInternalRelationshipToMany = {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}[];

/** Resource identification present in Resource Objects and Resource Identifier Objects. */
export interface AnkorstoreInternalLinkage {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/** The links to resource pages. A link might be omitted to indicate that it is unavailable. */
export interface AnkorstoreInternalLinks {
  /**
   * The link to the first page of resources.
   * @format url
   */
  first?: string;
  /**
   * The link to the previous page of resources.
   * @format url
   */
  prev?: string;
  /**
   * The link to the next page of resources.
   * @format url
   */
  next?: string;
  /**
   * The link to the last page of resources.
   * @format url
   */
  last?: string;
}

/** An object describing the server's implementation */
export interface AnkorstoreInternalJsonapi {
  /** @example "1.0" */
  version?: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

export interface AnkorstoreInternalError {
  /** An application-specific error code, expressed as a string value. */
  code?: string;
  /** A human-readable explanation specific to this occurrence of the problem. */
  detail?: string;
  /** The HTTP status code applicable to this problem, expressed as a string value. */
  status?: string;
  /** The HTTP status code description applicable to this problem */
  title?: string;
  /** Optional object pointing towards the problematic field */
  source?: {
    /** The field key */
    pointer?: string;
  };
}

/**
 * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
 * @format uuid
 */
export type AnkorstoreInternalId = string;

/** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
export type AnkorstoreInternalType = string;

export enum AnkorstoreInternalCarouselTypeEnum {
  DiscoveryBrand = 'discovery-brand',
  ReorderBrand = 'reorder-brand',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreInternalInventoryPolicy {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * An object used to detail pricing information for various Resources.
 * @example {"currency":"EUR","amount":142}
 */
export interface AnkorstoreInternalAmount {
  /**
   * ISO 3-Letter Currency Code
   * @example "EUR"
   */
  currency: string;
  /** Lowest denomination of the currency this amount belongs to. */
  amount: number;
}

/**
 * ISO 3-Letter Currency Code
 * @example "EUR"
 */
export type AnkorstoreInternalCurrency = string;

/** Lowest denomination of the currency this amount belongs to. */
export type AnkorstoreInternalMoney = number;

/**
 * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
 * @pattern ^[A-Z]{2}$
 * @example "FR"
 */
export type AnkorstoreInternalCountryCode = string;

export interface AnkorstoreInternalMasterOrder {
  /** Type of wrapped order */
  type: AnkorstoreInternalMasterOrderTypeEnum;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  preorderCreatedAt?: null | string;
  /** @pattern ^[EI][A-NP-Z]{3}[1-9]{7}$ */
  reference?: string;
  customReference?: null | string;
  masterStatus?: AnkorstoreInternalMasterOrderMasterStatusEnum;
  status: {
    name: string;
    shortTitle?: string;
    title: null | string;
    details: null | string;
    subStatus?: {
      shortTitle?: string;
    };
  };
  /** The `amounts` property of the `ExternalOrder`, if set. */
  amounts?: {
    /** @example "EUR" */
    brandCurrency: string;
    /** @example 1 */
    brandCurrencyRate: number;
    /** @example "€546.20" */
    brandTotalAmount: string;
    /** @example "€126.33" */
    brandTotalAmountVat: string;
    /** @example "€672.53" */
    brandTotalAmountWithVat: string;
    /** @example "EUR" */
    customerCurrency: string;
    /** @example 1 */
    customerCurrencyRate: number;
    /** @example "€546.20" */
    customerTotalAmount: string;
    /** @example "€126.33" */
    customerTotalAmountVat: string;
    /** @example "€672.53" */
    customerTotalAmountWithVat: string;
    /** @example "€2.20" */
    shippingFeesAmount: string;
    /** @example "€0.44" */
    shippingFeesAmountVat: string;
    /** @example "€2.64" */
    shippingFeesAmountWithVat: string;
    /** @example "€548.40" */
    customerGrandTotalAmount: string;
    /** @example "€126.77" */
    customerGrandTotalAmountVat: string;
    /** @example "€675.17" */
    customerGrandTotalAmountWithVat: string;
  };
  /** The `metadata` property of the `ExternalOrder`, if set. */
  metadata?: {
    /** @example "fulfillment" */
    shippingMethod: string;
    address: {
      /** @example "FR" */
      countryCode: string;
      /** @example "75116" */
      postalCode: string;
      /** @example "Paris" */
      city: string;
      /** @example "av Kleber" */
      addressLine: string;
      /** @example null */
      company: string | null;
    };
    contactPerson: {
      /** @example "John" */
      firstName: string;
      /** @example "Smith" */
      lastName: string;
      /** @example "foo@bar.com" */
      email: string;
      /** @example null */
      phone: string | null;
    };
  };
  internalId: null | number;
  /** @format uuid */
  internalUuid?: string | null;
  /** @format uuid */
  externalOrderUuid?: string | null;
  isDiscovery?: null | boolean;
  isDiscoveryForRetailer?: null | boolean;
  isBelongingToReferral?: null | boolean;
  totals: null | {
    totalAmount: {
      amount: number;
      currency: string;
    };
    totalVatAmount: {
      amount: number;
      currency: string;
    };
    totalAmountWithVat: {
      amount: number;
      currency: string;
    };
    netAmount: {
      amount: number;
      currency: string;
    };
  };
  brand: {
    id: string | number;
    name: string;
    /** @format url */
    link: string;
    display_address: {
      city: string;
    };
  };
  user?: {
    /** @format uuid */
    uuid: string;
    /** @example "John" */
    firstName: string;
    /** @example "Smith" */
    lastName: string;
    /**
     * @format email
     * @example "john@smith.com"
     */
    email: string;
  };
  updates: null | {
    oldTotalAmount: {
      amount: number;
      currency: string;
    };
    oldTotalAmountVat: {
      amount: number;
      currency: string;
    };
    oldTotalAmountWithVat: {
      amount: number;
      currency: string;
    };
    oldRecargoAmount: null | {
      amount: number;
      currency: string;
    };
    itemUpdates: {
      itemId: string;
      productName: string;
      sku: string;
      productImage: string | null;
      productUrl: string;
      oldQuantity: number;
      newQuantity: number;
      oldMultipliedQuantity: number;
      newMultipliedQuantity: number;
      unitPrice: {
        amount: number;
        currency: string;
      };
      oldAmount: {
        amount: number;
        currency: string;
      };
      newAmount: {
        amount: number;
        currency: string;
      };
    }[];
  };
  taxes:
    | null
    | {
        name: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
  priorityTag?: null | {
    name: string;
  };
  vat: null | {
    isShifted: boolean;
    applicationDetails: null | {
      message: string;
      link: null | {
        href: string;
        text: string;
      };
    };
  };
  deadlines?: null | {
    /** @format date-time */
    toShip: null | string;
    /** @format date-time */
    toAccept: null | string;
    /** @format date-time */
    toActOnIssue: null | string;
  };
  synchronizations?:
    | null
    | {
        type?: AnkorstoreInternalMasterOrderTypeEnum1;
        platformName?: AnkorstoreInternalMasterOrderPlatformNameEnum;
        error?: null | string;
      }[];
  invoices?:
    | null
    | {
        isGenerated: boolean;
        title: string;
        number: null | string;
        path: null | string;
      }[];
  shipping: null | {
    shippingProvider: null | string;
    isInternational?: boolean;
    hasShippingLabelGenerationError?: boolean;
    hasRevertedShippingLabels?: boolean;
    fees?: null | {
      refundAmount: null | {
        amount: number;
        currency: string;
      };
    };
    /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
    billedWeightFee?: {
      amount: number;
      currency: string;
    };
    shippingAddress: {
      address: {
        countryCode: null | string;
        postalCode: null | string;
        city: null | string;
        addressLine: null | string;
      };
      company: null | string;
      contactPerson: {
        firstName: null | string;
        lastName: null | string;
        fullName: null | string;
        phoneNumber: null | string;
        /** @format email */
        email: null | string;
      };
    };
    availableShippingMethods?:
      | null
      | {
          name: AnkorstoreInternalMasterOrderNameEnum;
          canBeUsed: boolean;
          errors: object[] | object;
        }[];
    shipmentEstimation?: null | {
      collectionMethods: AnkorstoreInternalMasterOrderCollectionMethodsEnum[];
      rateProvider: null | string;
      rateAmount: null | {
        amount: number;
        currency: string;
      };
      estimatedParcels: {
        weight: null | number;
        height: null | number;
        length: null | number;
        width: null | number;
        distanceUnit?: AnkorstoreInternalMasterOrderDistanceUnitEnum;
      }[];
    };
    shipment: null | {
      /** @format date-time */
      shippedAt: null | string;
      labelPrintingFormat: AnkorstoreInternalMasterOrderLabelPrintingFormatEnum;
      trackedPackages: {
        /** @format url */
        labelUrl?: null | string;
        parcel?: {
          weight: null | number;
          height: null | number;
          length: null | number;
          width: null | number;
          distanceUnit?: AnkorstoreInternalMasterOrderDistanceUnitEnum1;
        };
      }[];
      shipFromAddress: {
        address: {
          countryCode: null | string;
          postalCode: null | string;
          city: null | string;
          addressLine: null | string;
        };
        company: null | string;
        contactPerson: {
          firstName: null | string;
          lastName: null | string;
          fullName: null | string;
          phoneNumber: null | string;
          /** @format email */
          email: null | string;
        };
      };
      pickup: null | {
        /** @format date-time */
        date: string;
        readyTime: string;
        closeTime: string;
      };
      labelRevertReasons: {
        actionType: string;
        actionReason: string;
      }[];
    };
  };
  tracking: null | {
    trackingNumber: null | string;
    trackingLink: null | string;
    status: null | string;
  };
  billing: null | {
    billingItems: {
      id: number;
      type: string;
      label: string;
      displayVat: boolean;
      isVatShifted: boolean;
      amount: null | {
        amount: number;
        currency: string;
      };
      amountVat: null | {
        amount: number;
        currency: string;
      };
      amountWithVat: null | {
        amount: number;
        currency: string;
      };
      /** Amount of the billing item in percents */
      percentage: null | number;
      /** Whether the billing item was created as part of a special deal */
      isSpecialDeal: boolean;
      francoSetting?: null | {
        francoAmount?: null | {
          amount: number;
          currency: string;
        };
        francoFlatFeeAmount?: null | {
          amount: number;
          currency: string;
        };
      };
    }[];
  };
  issue?: null | {
    casesVisibleToBrand: string[];
    casesAllowedToBeSentToBrand: string[];
    current: null | {
      status: string;
      escalatedToCsByBrand: boolean;
      escalatedToCsToAdjustQuantityByBrand: boolean;
      escalatedToCsOnReship: boolean;
      autoEscalatedToCs: boolean;
      autoEscalatedToCsOnReship: boolean;
      sendToBrandEnabled: boolean;
      escalatedNewClaimToCs: null | boolean;
      reason: string;
      shippedDate: string;
      autoEscalateDate: string;
      trackingLink: null | string;
      trackingNumber: null | string;
      shippingProvider: null | string;
      reshippedDate: null | string;
      products: {
        id: number;
        name: string;
        sku: string;
        description: string;
        quantity: number;
        files: {
          url: string;
        }[];
      }[];
      packagingFiles: {
        url: string;
      }[];
      parcelReservationFiles: {
        url: string;
      }[];
      parcelContentFiles: {
        url: string;
      }[];
      options: {
        label: string;
        text: string;
      }[];
    };
  };
  retailer: null | {
    id: null | number;
    /** @format uuid */
    uuid?: string | null;
    name: string;
    /** @format email */
    email: string;
    phone_number: string;
    city: string;
    business: {
      user_first_name?: string;
      user_last_name?: string;
      vat_number: null | string;
      tax_number: null | string;
      country: {
        iso_code: string;
      };
    };
    /** The opening times of the customer for delivery. */
    deliverySchedule?: {
      /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
      timeSlots:
        | {
            /**
             * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "09:30"
             */
            startTime: string;
            /**
             * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "12:30"
             */
            endTime: string;
          }[]
        | null;
      /**
       * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
       * @minItems 1
       * @uniqueItems true
       * @example [1,2,3]
       */
      openDays: number[];
    } | null;
    /** The packing instruction of the customer. */
    packingInstruction?: {
      /**
       * List of packing instruction services
       * @minItems 1
       */
      services: AnkorstoreInternalMasterOrderServicesEnum[];
      /**
       * Additional packing instruction (can be empty)
       * @example "Instruction text"
       */
      instruction: string;
    } | null;
    deliveryAppointment?: {
      /**
       * Whether a delivery appointment is requested for this customer.
       * @example true
       */
      requested: boolean;
      /**
       * Additional instruction for the delivery appointment (can be empty)
       * @maxLength 1000
       * @example "Please call before delivery"
       */
      instruction: string;
    } | null;
  };
  rejection: null | {
    brandRejectType: null | string;
    availableBrandRejectReasons?: {
      rejectType: string;
      rejectTypeLabel: string;
    }[];
    isRetailerCancellationRequestOpened?: boolean;
  };
  meta: null | {
    showAlcoholWarning?: boolean;
    showManualInvoiceDownloadWarning?: boolean;
    casesVisibleToBrand?: string[];
    casesAllowedToBeSentToBrand?: string[];
    isSplitAllowed?: boolean;
    businessModel?: AnkorstoreInternalMasterOrderBusinessModelEnum;
  };
}

export interface AnkorstoreInternalBrandCardResource {
  type: string;
  id: string;
  attributes: {
    brand_id: number;
    brand_link: string;
    brand_name: string;
    brand_logo: string;
    brand_is_new: boolean;
    brand_discount: number;
    brand_images: {
      src: string;
    }[];
    brand_total_products_count?: number;
    brand_has_new_products?: boolean;
    is_first_order?: boolean;
    last_order_on?: string;
  };
}

export interface AnkorstoreInternalProductCardResource {
  type: string;
  id: string;
  attributes: {
    uuid: string;
    id: number;
    retail_price: {
      currency?: string;
      amount?: number;
    };
    retail_prices: {
      EUR?: number;
      GBP?: number;
      SEK?: number;
    };
    wholesale_price: {
      currency?: string;
      amount?: number;
    };
    original_wholesale_price: {
      currency?: string;
      amount?: number;
    };
    discount_rate: number;
    discount_type: string;
    is_discounted: boolean;
    unit_multiplier: number;
    link: string;
    name: string;
    out_of_stock: boolean;
    is_new: boolean;
    brand: {
      id?: number;
      name?: string;
      brandLocation?: {
        lon?: number;
        lat?: number;
      };
      link?: string;
      minimum?: number;
      country_code?: string;
      segment?: string;
      country?: object;
      opened_countries?: string[];
      images?: {
        squared?: string;
        rounded?: string;
        large?: string;
      };
      business_events?: object;
      business_events_eligible?: number[];
      business_events_rankings?: object;
      location?: string[];
      shipping_lead_time?: string[];
      brand_tags?: string[];
      synonyms?: string[];
      aks_plus?: string[];
    };
    options: {
      id?: number;
      variation?: string | null;
      ian?: string;
      sku?: string;
      out_of_stock?: boolean;
      stock?: {
        id?: number;
        /**
         * Whether stock is tracked at all for this product variant.
         *
         * - `true`: stock is not tracked — a retailer can order as
         *
         *
         *   much of this variant as they want, with no restriction
         *   at all.
         * - `false`: stock is tracked — whether a retailer can order
         *
         *
         *   the variant depends on the available stock quantity and
         *   the `inventory_policy`.
         */
        is_always_in_stock?: boolean;
        /**
         * Whether a retailer can order the variant backing this
         * option for which stock is not available.
         *
         * - `deny` (default): no. A retailer cannot order a quantity
         *
         *
         *   larger than the currently available stock quantity, so
         *   the variant cannot be ordered when it is out of stock, or
         *   when the desired quantity exceeds the available quantity.
         * - `continue`: yes. The retailer can order any quantity,
         *
         *
         *   even when stock is insufficient (desired quantity >
         *   available quantity > 0) or the variant is out of stock
         *   (available quantity <= 0).
         *
         * Only meaningful when stock is tracked
         * (`is_always_in_stock = false`).
         * @default "deny"
         */
        inventory_policy?: AnkorstoreInternalProductCardResourceInventoryPolicyEnum;
        available_quantity?: number | null;
        /**
         * Product-scoped stock status, derived from the currently
         * available stock, `is_always_in_stock` and
         * `inventory_policy`.
         *
         * - `out_of_stock`: there is no stock available to order,
         *
         *
         *   i.e. stock is tracked (`is_always_in_stock=false`), the
         *   `inventory_policy` is `deny`, and the available quantity
         *   is <= 0.
         * - `low_in_stock`: there is little stock left to order, i.e.
         *
         *
         *   stock is tracked (`is_always_in_stock=false`) and stock
         *   is low (available quantity <= 10, or available quantity
         *   < 10% of the on-hand quantity).
         * - `in_stock`: there is plenty of stock to order (every
         *
         *
         *   other case).
         */
        status?: string;
      };
    }[];
    variants: {
      id?: number;
      uuid?: string;
      sku?: string;
      ian?: string;
      out_of_stock?: boolean;
      retail_prices?: {
        EUR?: number;
        GBP?: number;
        SEK?: number;
      };
      retail_price?: {
        currency?: string;
        amount?: number;
      };
      wholesale_price?: {
        currency?: string;
        amount?: number;
      };
      stock?: {
        id?: number;
        /**
         * Whether stock is tracked at all for this product variant.
         *
         * - `true`: stock is not tracked — a retailer can order as
         *
         *
         *   much of this variant as they want, with no restriction
         *   at all.
         * - `false`: stock is tracked — whether a retailer can order
         *
         *
         *   the variant depends on the available stock quantity and
         *   the `inventory_policy`.
         */
        is_always_in_stock?: boolean;
        /**
         * Whether a retailer can order a product variant for which
         * stock is not available.
         *
         * - `deny` (default): no. A retailer cannot order a quantity
         *
         *
         *   larger than the currently available stock quantity, so
         *   the variant cannot be ordered when it is out of stock, or
         *   when the desired quantity exceeds the available quantity.
         * - `continue`: yes. The retailer can order any quantity,
         *
         *
         *   even when stock is insufficient (desired quantity >
         *   available quantity > 0) or the variant is out of stock
         *   (available quantity <= 0).
         *
         * Only meaningful when stock is tracked
         * (`is_always_in_stock = false`).
         * @default "deny"
         */
        inventory_policy?: AnkorstoreInternalProductCardResourceInventoryPolicyEnum1;
        available_quantity?: number | null;
        /**
         * Product-scoped stock status, derived from the currently
         * available stock, `is_always_in_stock` and
         * `inventory_policy`.
         *
         * - `out_of_stock`: there is no stock available to order,
         *
         *
         *   i.e. stock is tracked (`is_always_in_stock=false`), the
         *   `inventory_policy` is `deny`, and the available quantity
         *   is <= 0.
         * - `low_in_stock`: there is little stock left to order, i.e.
         *
         *
         *   stock is tracked (`is_always_in_stock=false`) and stock
         *   is low (available quantity <= 10, or available quantity
         *   < 10% of the on-hand quantity).
         * - `in_stock`: there is plenty of stock to order (every
         *
         *
         *   other case).
         */
        status?: string;
      };
      options?: object[];
    }[];
    images: string[];
    discount_event_price?: {
      currency?: string | null;
      amount?: number | null;
    };
  };
}

export interface AnkorstoreInternalBrandCardAttributes {
  brand_id: number;
  brand_link: string;
  brand_name: string;
  brand_logo: string;
  brand_is_new: boolean;
  brand_discount: number;
  brand_images: {
    src: string;
  }[];
  brand_total_products_count?: number;
  brand_has_new_products?: boolean;
  is_first_order?: boolean;
  last_order_on?: string;
}

export interface AnkorstoreInternalProductCardAttributes {
  uuid: string;
  id: number;
  retail_price: {
    currency?: string;
    amount?: number;
  };
  retail_prices: {
    EUR?: number;
    GBP?: number;
    SEK?: number;
  };
  wholesale_price: {
    currency?: string;
    amount?: number;
  };
  original_wholesale_price: {
    currency?: string;
    amount?: number;
  };
  discount_rate: number;
  discount_type: string;
  is_discounted: boolean;
  unit_multiplier: number;
  link: string;
  name: string;
  out_of_stock: boolean;
  is_new: boolean;
  brand: {
    id?: number;
    name?: string;
    brandLocation?: {
      lon?: number;
      lat?: number;
    };
    link?: string;
    minimum?: number;
    country_code?: string;
    segment?: string;
    country?: object;
    opened_countries?: string[];
    images?: {
      squared?: string;
      rounded?: string;
      large?: string;
    };
    business_events?: object;
    business_events_eligible?: number[];
    business_events_rankings?: object;
    location?: string[];
    shipping_lead_time?: string[];
    brand_tags?: string[];
    synonyms?: string[];
    aks_plus?: string[];
  };
  options: {
    id?: number;
    variation?: string | null;
    ian?: string;
    sku?: string;
    out_of_stock?: boolean;
    stock?: {
      id?: number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as
       *   much of this variant as they want, with no restriction
       *   at all.
       * - `false`: stock is tracked — whether a retailer can order
       *   the variant depends on the available stock quantity and
       *   the `inventory_policy`.
       */
      is_always_in_stock?: boolean;
      /**
       * Whether a retailer can order the variant backing this
       * option for which stock is not available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity
       *   larger than the currently available stock quantity, so
       *   the variant cannot be ordered when it is out of stock, or
       *   when the desired quantity exceeds the available quantity.
       * - `continue`: yes. The retailer can order any quantity,
       *   even when stock is insufficient (desired quantity >
       *   available quantity > 0) or the variant is out of stock
       *   (available quantity <= 0).
       *
       * Only meaningful when stock is tracked
       * (`is_always_in_stock = false`).
       * @default "deny"
       */
      inventory_policy?: AnkorstoreInternalProductCardAttributesInventoryPolicyEnum;
      available_quantity?: number | null;
      /**
       * Product-scoped stock status, derived from the currently
       * available stock, `is_always_in_stock` and
       * `inventory_policy`.
       *
       * - `out_of_stock`: there is no stock available to order,
       *
       *
       *   i.e. stock is tracked (`is_always_in_stock=false`), the
       *   `inventory_policy` is `deny`, and the available quantity
       *   is <= 0.
       * - `low_in_stock`: there is little stock left to order, i.e.
       *
       *
       *   stock is tracked (`is_always_in_stock=false`) and stock
       *   is low (available quantity <= 10, or available quantity
       *   < 10% of the on-hand quantity).
       * - `in_stock`: there is plenty of stock to order (every
       *
       *
       *   other case).
       */
      status?: string;
    };
  }[];
  variants: {
    id?: number;
    uuid?: string;
    sku?: string;
    ian?: string;
    out_of_stock?: boolean;
    retail_prices?: {
      EUR?: number;
      GBP?: number;
      SEK?: number;
    };
    retail_price?: {
      currency?: string;
      amount?: number;
    };
    wholesale_price?: {
      currency?: string;
      amount?: number;
    };
    stock?: {
      id?: number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as
       *   much of this variant as they want, with no restriction
       *   at all.
       * - `false`: stock is tracked — whether a retailer can order
       *   the variant depends on the available stock quantity and
       *   the `inventory_policy`.
       */
      is_always_in_stock?: boolean;
      /**
       * Whether a retailer can order a product variant for which
       * stock is not available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity
       *   larger than the currently available stock quantity, so
       *   the variant cannot be ordered when it is out of stock, or
       *   when the desired quantity exceeds the available quantity.
       * - `continue`: yes. The retailer can order any quantity,
       *   even when stock is insufficient (desired quantity >
       *   available quantity > 0) or the variant is out of stock
       *   (available quantity <= 0).
       *
       * Only meaningful when stock is tracked
       * (`is_always_in_stock = false`).
       * @default "deny"
       */
      inventory_policy?: AnkorstoreInternalProductCardAttributesInventoryPolicyEnum1;
      available_quantity?: number | null;
      /**
       * Product-scoped stock status, derived from the currently
       * available stock, `is_always_in_stock` and
       * `inventory_policy`.
       *
       * - `out_of_stock`: there is no stock available to order,
       *
       *
       *   i.e. stock is tracked (`is_always_in_stock=false`), the
       *   `inventory_policy` is `deny`, and the available quantity
       *   is <= 0.
       * - `low_in_stock`: there is little stock left to order, i.e.
       *
       *
       *   stock is tracked (`is_always_in_stock=false`) and stock
       *   is low (available quantity <= 10, or available quantity
       *   < 10% of the on-hand quantity).
       * - `in_stock`: there is plenty of stock to order (every
       *
       *
       *   other case).
       */
      status?: string;
    };
    options?: object[];
  }[];
  images: string[];
  discount_event_price?: {
    currency?: string | null;
    amount?: number | null;
  };
}

export interface AnkorstoreInternalCollectionCardResource {
  type: string;
  id: string;
  attributes: {
    collection_uuid: string;
    collection_link: string;
    collection_name: string;
    collection_image: string;
    collection_count: number;
    collection_type: AnkorstoreInternalCollectionCardResourceCollectionTypeEnum;
  };
}

export interface AnkorstoreInternalCollectionCardAttributes {
  collection_uuid: string;
  collection_link: string;
  collection_name: string;
  collection_image: string;
  collection_count: number;
  collection_type: AnkorstoreInternalCollectionCardAttributesCollectionTypeEnum;
}

export interface AnkorstoreInternalBrandDiscoverySelectionResource {
  type: 'brand-discovery-selection';
  /** @format uuid */
  id: string;
  attributes: {
    /** @format date */
    week: string;
    /** @format date */
    next_selection_date: string;
    status: {
      completed: boolean;
      counts: {
        liked: number;
        disliked: number;
        skipped: number;
      };
    };
  };
  relationships: {
    brands: {
      data: {
        type: 'brand';
        /** @format uuid */
        id: string;
      }[];
    };
  };
}

export interface AnkorstoreInternalBrandDiscoveryDisplayAddress {
  city: string;
  country: string;
  region: string;
  postal_code: string;
}

export interface AnkorstoreInternalBrandDiscoveryMoney {
  /** Amount in cents */
  amount: number;
  /** @example "EUR" */
  currency: string;
}

export interface AnkorstoreInternalBrandDiscoveryEstimatedDelivery {
  minDays?: number | null;
  maxDays?: number | null;
}

export interface AnkorstoreInternalBrandDiscoveryBrandResource {
  type: 'brand';
  /** @format uuid */
  id: string;
  attributes: {
    brand_id: number;
    feedback: AnkorstoreInternalBrandDiscoveryBrandResourceFeedbackEnum;
    name: string;
    link: string;
    /** @format uri */
    logo_url: string;
    story: string;
    display_address: {
      city: string;
      country: string;
      region: string;
      postal_code: string;
    };
    made_in: string[];
    minimum?: {
      /** Amount in cents */
      amount: number;
      /** @example "EUR" */
      currency: string;
    } | null;
    estimated_delivery: {
      minDays?: number | null;
      maxDays?: number | null;
    };
    instagram_username?: string | null;
    product_count: number;
    has_product_collection: boolean;
  };
  relationships: {
    products: {
      data: {
        type: 'product';
        /** @format uuid */
        id: string;
      }[];
    };
  };
}

export interface AnkorstoreInternalBrandDiscoveryProductResource {
  type: 'product';
  /** @format uuid */
  id: string;
  attributes: {
    title: string;
    link: string;
    /** @format uri */
    image: string;
    wholesale_price: {
      /** Amount in cents */
      amount: number;
      /** @example "EUR" */
      currency: string;
    };
    discount_rate: number;
  };
}

/**
 * ApplicationResource
 * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"applications","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"}}
 */
export interface AnkorstoreInternalApplicationResource {
  type: 'applications';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Custom application name (should be unique within user applications) */
    name: string;
    /**
     * Email of the developer to contact in context of any issues with this application
     * @format email
     * @example "developer@application.com"
     */
    developerEmail: string;
    /** Client ID to be used for access token issuance */
    clientId: string;
    /** Secret to be used for access token issuance. Can be invoked only once, when application is created or credentials re-generated. */
    clientSecret: string | null;
  };
  /** Only presented if asked explicitly in the request */
  relationships?: {
    webhookSubscriptions?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/**
 * ApplicationWebhookSubscriptionResource
 * Application webhook subscription resource
 */
export interface AnkorstoreInternalApplicationWebhookSubscriptionResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * URL of the service where webhook request will be sent when one of the events from the list occurs
     * @format uri
     * @example "https://my.app/webhook/listener"
     */
    webhookUrl: string;
    /** @uniqueItems true */
    events: string[];
    signingSecret: string;
  };
}

/** OnboardingResource */
export interface AnkorstoreInternalOnboardingResource {
  type: AnkorstoreInternalOnboardingResourceTypeEnum;
  /** @format uuid */
  id: string;
  attributes: {
    status: AnkorstoreInternalOnboardingResourceStatusEnum;
    steps: {
      name?: string;
      progress?: number;
      isComplete?: boolean;
    }[];
    /** @format date */
    createdAt: string;
    /** @format date */
    completedAt: string | null;
  };
}

/** FrancoSettingsSummary */
export interface AnkorstoreInternalFrancoSettingsSummary {
  type: AnkorstoreInternalFrancoSettingsSummaryTypeEnum;
  /** @format uuid */
  id: string;
  attributes: {
    hasFrancoSettings: boolean;
  };
}

/** BrandContactResource */
export interface AnkorstoreInternalBrandContactResource {
  type: 'brand-contacts';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format email */
    email: string;
    /** @minItems 1 */
    purposes: AnkorstoreInternalBrandContactResourcePurposesEnum[];
  };
}

/** CompanyResource */
export interface AnkorstoreInternalCompanyResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    founded_in_year: number;
    company_name: string;
    company_invoice_description: string;
    legal_form?: string;
    city_of_registration?: string;
    tax_number: string | null;
    vat_exemption: boolean;
    vat_number: string | null;
    sole_trader_number: string | null;
    above_intracomm_threshold: boolean;
  };
}

export interface AnkorstoreInternalMediaResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    originalFilename: string;
    /** @format url */
    url: string;
    /** @format date-time */
    createdAt: string;
  };
}

export interface AnkorstoreInternalVideoResource {
  type: AnkorstoreInternalVideoResourceTypeEnum;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** The context in which the video is displayed */
    displayContext: AnkorstoreInternalVideoResourceDisplayContextEnum;
    /** The sort order of the video */
    sortOrder?: string;
    /**
     * The YouTube video URL
     * @format url
     */
    videoUrl: string;
    /** The original filename or title of the video */
    videoFilename?: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  };
}

/** JSON:API resource representing a user agreement and its status for a user */
export interface AnkorstoreInternalUserAgreement {
  /**
   * @default "user-agreements"
   * @example "user-agreements"
   */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @example "terms-and-conditions-bm-25" */
    agreementId: string;
    /** @example "accepted" */
    status: AnkorstoreInternalUserAgreementStatusEnum;
  };
}

export interface AnkorstoreInternalTierResource {
  /**
   * @min 1
   * @max 70
   * @example 5
   */
  percentage: number;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":10000}
   */
  minimumOrderValue: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  } | null;
}

export interface AnkorstoreInternalTieredDiscountResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: 'tiered-discount';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  id: string;
  attributes: {
    /** @format uuid */
    brandUuid?: string;
    /** @example false */
    isGlobal: boolean;
    /** @example "Volume Discount" */
    name: string;
    /**
     * The highest percentage value among all tiers
     * @example 10
     */
    maxPercentage: number;
    /** @example [{"percentage":5,"minimumOrderValue":{"currency":"EUR","amount":10000}},{"percentage":10,"minimumOrderValue":{"currency":"EUR","amount":20000}}] */
    tiers: {
      /**
       * @min 1
       * @max 70
       * @example 5
       */
      percentage: number;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":10000}
       */
      minimumOrderValue: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      } | null;
    }[];
  };
}

/**
 * The name should be unique
 * @minLength 2
 * @maxLength 15
 */
export type AnkorstoreInternalNameRequestAttribute = string;

/**
 * @min 1
 * @max 70
 */
export type AnkorstoreInternalPercentageRequestAttribute = number;

/** @min 0 */
export type AnkorstoreInternalMinimumOrderValueAmountRequestAttribute = number | null;

export interface AnkorstoreInternalBrandSegmentItem {
  /** Internal brand ID */
  brand_id?: number | null;
  /**
   * Brand UUID
   * @format uuid
   */
  brand_uuid: string;
  /** Brand display name */
  brand_name: string;
  /** URL path to brand page */
  brand_link?: string | null;
  /** URL to brand logo image */
  brand_logo?: string | null;
  /** Brand images with source URLs */
  brand_images: {
    /** URL to brand image */
    src: string;
  }[];
  /** Whether the brand is new to the platform */
  brand_is_new: boolean;
  /** Total number of products from this brand */
  brand_total_products_count: number;
  /** Whether the brand has new products */
  brand_has_new_products: boolean;
  /** Brand story/description */
  story?: string | null;
  /** Brand's country code (ISO 3166-1 alpha-2) */
  country_code?: string | null;
  /**
   * Date of last order from this brand (YYYY-MM-DD)
   * @format date
   */
  last_order_on?: string | null;
  /** Whether the retailer is a new one for the brand */
  is_first_order?: boolean;
  /** Total number of completed orders from this brand */
  total_orders: number;
  /** Total amount spent with this brand (in minor units) */
  total_spent_amount: number;
  /** Currency of total spent amount (ISO 4217) */
  total_spent_currency: string;
  /**
   * When the discount was last updated (ISO 8601)
   * @format date-time
   */
  discount_updated_at: string;
}

export interface AnkorstoreInternalBrandSegmentsResource {
  /** @example "brand-segments" */
  type: string;
  /** @example "brand-segments" */
  id: string;
  attributes: {
    /** Brands in network with no orders */
    network_prospects: {
      /** Internal brand ID */
      brand_id?: number | null;
      /**
       * Brand UUID
       * @format uuid
       */
      brand_uuid: string;
      /** Brand display name */
      brand_name: string;
      /** URL path to brand page */
      brand_link?: string | null;
      /** URL to brand logo image */
      brand_logo?: string | null;
      /** Brand images with source URLs */
      brand_images: {
        /** URL to brand image */
        src: string;
      }[];
      /** Whether the brand is new to the platform */
      brand_is_new: boolean;
      /** Total number of products from this brand */
      brand_total_products_count: number;
      /** Whether the brand has new products */
      brand_has_new_products: boolean;
      /** Brand story/description */
      story?: string | null;
      /** Brand's country code (ISO 3166-1 alpha-2) */
      country_code?: string | null;
      /**
       * Date of last order from this brand (YYYY-MM-DD)
       * @format date
       */
      last_order_on?: string | null;
      /** Whether the retailer is a new one for the brand */
      is_first_order?: boolean;
      /** Total number of completed orders from this brand */
      total_orders: number;
      /** Total amount spent with this brand (in minor units) */
      total_spent_amount: number;
      /** Currency of total spent amount (ISO 4217) */
      total_spent_currency: string;
      /**
       * When the discount was last updated (ISO 8601)
       * @format date-time
       */
      discount_updated_at: string;
    }[];
    /** Brands in network with order history */
    network_customers: {
      /** Internal brand ID */
      brand_id?: number | null;
      /**
       * Brand UUID
       * @format uuid
       */
      brand_uuid: string;
      /** Brand display name */
      brand_name: string;
      /** URL path to brand page */
      brand_link?: string | null;
      /** URL to brand logo image */
      brand_logo?: string | null;
      /** Brand images with source URLs */
      brand_images: {
        /** URL to brand image */
        src: string;
      }[];
      /** Whether the brand is new to the platform */
      brand_is_new: boolean;
      /** Total number of products from this brand */
      brand_total_products_count: number;
      /** Whether the brand has new products */
      brand_has_new_products: boolean;
      /** Brand story/description */
      story?: string | null;
      /** Brand's country code (ISO 3166-1 alpha-2) */
      country_code?: string | null;
      /**
       * Date of last order from this brand (YYYY-MM-DD)
       * @format date
       */
      last_order_on?: string | null;
      /** Whether the retailer is a new one for the brand */
      is_first_order?: boolean;
      /** Total number of completed orders from this brand */
      total_orders: number;
      /** Total amount spent with this brand (in minor units) */
      total_spent_amount: number;
      /** Currency of total spent amount (ISO 4217) */
      total_spent_currency: string;
      /**
       * When the discount was last updated (ISO 8601)
       * @format date-time
       */
      discount_updated_at: string;
    }[];
    /** Brands with global discounts not in network */
    global_discovery: {
      /** Internal brand ID */
      brand_id?: number | null;
      /**
       * Brand UUID
       * @format uuid
       */
      brand_uuid: string;
      /** Brand display name */
      brand_name: string;
      /** URL path to brand page */
      brand_link?: string | null;
      /** URL to brand logo image */
      brand_logo?: string | null;
      /** Brand images with source URLs */
      brand_images: {
        /** URL to brand image */
        src: string;
      }[];
      /** Whether the brand is new to the platform */
      brand_is_new: boolean;
      /** Total number of products from this brand */
      brand_total_products_count: number;
      /** Whether the brand has new products */
      brand_has_new_products: boolean;
      /** Brand story/description */
      story?: string | null;
      /** Brand's country code (ISO 3166-1 alpha-2) */
      country_code?: string | null;
      /**
       * Date of last order from this brand (YYYY-MM-DD)
       * @format date
       */
      last_order_on?: string | null;
      /** Whether the retailer is a new one for the brand */
      is_first_order?: boolean;
      /** Total number of completed orders from this brand */
      total_orders: number;
      /** Total amount spent with this brand (in minor units) */
      total_spent_amount: number;
      /** Currency of total spent amount (ISO 4217) */
      total_spent_currency: string;
      /**
       * When the discount was last updated (ISO 8601)
       * @format date-time
       */
      discount_updated_at: string;
    }[];
  };
}

export interface AnkorstoreInternalBrandRetailer {
  automaticOrderValidationMode?: boolean | null;
  repeatFeesPercentage?: number | null;
  firstFeesPercentage?: number | null;
  type?: AnkorstoreInternalBrandRetailerTypeEnum;
  /** @format date-time */
  expiresAt?: string | null;
}

export interface AnkorstoreInternalBrandRetailerResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    automaticOrderValidationMode?: boolean | null;
    repeatFeesPercentage?: number | null;
    firstFeesPercentage?: number | null;
    type?: AnkorstoreInternalBrandRetailerResourceTypeEnum;
    /** @format date-time */
    expiresAt?: string | null;
  };
}

/** CampaignPerformanceCard */
export interface AnkorstoreInternalCampaignPerformanceCardResource {
  type: 'marketing-cards';
  id: 'campaign-performance';
  attributes: {
    /**
     * Total number of orders created after campaigns
     * @min 0
     */
    totalOrders: number;
  };
}

export interface AnkorstoreInternalPillarScore {
  /**
   * Points awarded for this pillar
   * @example 3
   */
  score: number;
  /**
   * Maximum points available for this pillar
   * @example 22
   */
  max: number;
  /**
   * Product content the judge used to derive this pillar score
   * @example "Title: 'pillow'. Description: 'This is an organ but also a pillow.'"
   */
  evidence: string;
}

export interface AnkorstoreInternalCriterionResult {
  /**
   * Unique identifier for the scoring criterion
   * @example "title_structure"
   */
  criterionId: string;
  /**
   * Pillar this criterion belongs to
   * @example "seo"
   */
  pillarId: AnkorstoreInternalCriterionResultPillarIdEnum;
  /** @example 2 */
  pointsAwarded: number;
  /** @example 8 */
  maxPoints: number;
}

export interface AnkorstoreInternalBrandReactivationResource {
  type: 'reactivations';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format uuid */
    brandUuid: string;
    status: AnkorstoreInternalBrandReactivationResourceStatusEnum;
    previousStatus: AnkorstoreInternalBrandReactivationResourcePreviousStatusEnum;
    /** @format date-time */
    createdAt: string;
  };
  meta?: {
    /**
     * Current status of the brand (online|offline|onboarding)
     * @example "online"
     */
    brandStatus?: string;
    [key: string]: any;
  };
}

/**
 * ItemCounterResource
 * Item Counter resource
 */
export interface AnkorstoreInternalItemCounterResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    main: number;
    savedForLater: number;
  };
}

export interface AnkorstoreInternalCheckoutValidations {
  /** @example true */
  shouldShowTaxNumberQuestion?: boolean;
  /** @example "HRA10526" */
  taxNumber?: string | null;
  /** @example false */
  shouldShowVatNumberQuestion?: boolean;
  /** @example "DE279778283" */
  vatNumber?: string | null;
  /** @example true */
  shouldShowVatExemptionCheckbox?: boolean;
  /** @example false */
  vatExemption?: boolean;
  /** @example true */
  shouldDisableNoNumberOption?: boolean;
  /** @example false */
  isSoleTrader?: boolean;
  /** @example true */
  shouldShowCompanySelect?: boolean;
  /** @example false */
  shouldShowCompanyRegistrationForm?: boolean;
  /** @example false */
  shouldShowCompanyRegistrationBusinessNameInput?: boolean;
  /** @example null */
  eoriNumber?: string | null;
  /** @example false */
  shouldShowEoriNumberQuestion?: boolean;
  /** @example null */
  isPayingRecargo?: boolean | null;
  /** @example false */
  shouldShowRecargoQuestion?: boolean;
}

/**
 * CheckoutValidationsResource
 * Checkout validations resource
 */
export interface AnkorstoreInternalCheckoutValidationsResource {
  /**
   * [resource object type](https://jsonapi.org/format/#document-resource-object-identification)
   * @example "checkout-validations"
   */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** @example true */
    shouldShowTaxNumberQuestion?: boolean;
    /** @example "HRA10526" */
    taxNumber?: string | null;
    /** @example false */
    shouldShowVatNumberQuestion?: boolean;
    /** @example "DE279778283" */
    vatNumber?: string | null;
    /** @example true */
    shouldShowVatExemptionCheckbox?: boolean;
    /** @example false */
    vatExemption?: boolean;
    /** @example true */
    shouldDisableNoNumberOption?: boolean;
    /** @example false */
    isSoleTrader?: boolean;
    /** @example true */
    shouldShowCompanySelect?: boolean;
    /** @example false */
    shouldShowCompanyRegistrationForm?: boolean;
    /** @example false */
    shouldShowCompanyRegistrationBusinessNameInput?: boolean;
    /** @example null */
    eoriNumber?: string | null;
    /** @example false */
    shouldShowEoriNumberQuestion?: boolean;
    /** @example null */
    isPayingRecargo?: boolean | null;
    /** @example false */
    shouldShowRecargoQuestion?: boolean;
  };
}

export interface AnkorstoreInternalBaseFeeResource {
  type: string;
  label?: string;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amount: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
}

export type AnkorstoreInternalShippingFeeResource = {
  type: string;
  label?: string;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amount: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
} & {
  type?: AnkorstoreInternalShippingFeeResourceTypeEnum;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amountLeftForFreeShipping?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  metadata?: {
    offerName?: string;
    isShippingFree?: boolean;
    isEligibleForDiscoveryFreeShipping?: boolean;
    brandNonEligibleForAkPlusFreeShipping?: boolean;
    francoAmount?: number;
    francoFeeAmount?: number;
    francoMaxFeeAmount?: number;
  };
};

export interface AnkorstoreInternalTaxResource {
  type: AnkorstoreInternalTaxResourceTypeEnum;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amount: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
}

export interface AnkorstoreInternalDiscountResource {
  type: AnkorstoreInternalDiscountResourceTypeEnum;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amount: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  metadata?: {
    label: string;
  };
}

export interface AnkorstoreInternalCartSummaryMeta {
  isFirstPurchase: boolean;
  isShippable: boolean;
  [key: string]: any;
}

/**
 * CartSummaryResource
 * Cart Summary resource
 */
export interface AnkorstoreInternalCartSummaryResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    summary: {
      /**
       * sum of product taxes (vat) + sum of individual fees (and their respective vat) + sum of global taxes (recargo, ...)
       * @example {"currency":"EUR","amount":142}
       */
      feesAndTaxesTotal?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * sum of discounts (promocode, offers, ...)
       * @example {"currency":"EUR","amount":142}
       */
      discountsTotal?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * everything considered, taxes included
       * @example {"currency":"EUR","amount":142}
       */
      grandTotal?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
    };
    fees: ({
      type: string;
      label?: string;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amount: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
    } & {
      type?: AnkorstoreInternalCartSummaryResourceTypeEnum;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amountLeftForFreeShipping?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      metadata?: {
        offerName?: string;
        isShippingFree?: boolean;
        isEligibleForDiscoveryFreeShipping?: boolean;
        brandNonEligibleForAkPlusFreeShipping?: boolean;
        francoAmount?: number;
        francoFeeAmount?: number;
        francoMaxFeeAmount?: number;
      };
    })[];
    taxes: {
      type: AnkorstoreInternalCartSummaryResourceTypeEnum1;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amount: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
    }[];
    discounts: {
      type: AnkorstoreInternalCartSummaryResourceTypeEnum2;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amount: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      metadata?: {
        label: string;
      };
    }[];
  };
  meta: {
    isFirstPurchase: boolean;
    isShippable: boolean;
    [key: string]: any;
  };
}

/**
 * PurchasingListResource
 * Purchasing List resource
 */
export interface AnkorstoreInternalPurchasingListResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  id: string;
  attributes: {
    /** Type of the Purchasing List */
    type?: AnkorstoreInternalPurchasingListResourceTypeEnum;
    /** Custom name of Purchasing List */
    name?: string | null;
    /**
     * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
     * @example {"currency":"EUR","amount":142}
     */
    totalAmount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
     * @example {"currency":"EUR","amount":142}
     */
    selectionTotalAmount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
    totalItemCount?: number;
  };
  relationships?: {
    items?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    itemAggregates?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
  links?: {
    self: string;
  };
}

/**
 * CountryObject
 * Country object
 */
export interface AnkorstoreInternalCountryObject {
  /**
   * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
   * @pattern ^[A-Z]{2}$
   * @example "FR"
   */
  isoCode: string;
  name: string;
}

/**
 * PurchasableAggregateBrandHolidayMode
 * Brand's holiday mode information
 */
export interface AnkorstoreInternalPurchasableAggregateBrandHolidayMode {
  /** Whether the brand is currently on holiday mode */
  isEnabled: boolean;
  /**
   * End date of the holiday mode
   * @format date
   */
  endDate: string | null;
}

/**
 * PurchasableAggregateBrandResource
 * Linked brand of an aggregate
 */
export interface AnkorstoreInternalPurchasableAggregateBrandResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Name of the brand */
    name?: string;
    /** Path to the logo image of the brand */
    logoImagePath?: string;
    /**
     * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
     * @example {"currency":"EUR","amount":142}
     */
    minimumOrderValue?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * CountryObject
     * Country object
     */
    country?: {
      /**
       * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
       * @pattern ^[A-Z]{2}$
       * @example "FR"
       */
      isoCode: string;
      name: string;
    };
    /** Whether the brand is enabled (i.e. has been accepted) or not */
    isEnabled?: boolean;
    /**
     * PurchasableAggregateBrandHolidayMode
     * Brand's holiday mode information
     */
    holidayMode?: {
      /** Whether the brand is currently on holiday mode */
      isEnabled: boolean;
      /**
       * End date of the holiday mode
       * @format date
       */
      endDate: string | null;
    };
  };
}

/**
 * PurchasingListItemLongDistanceFee
 * Fee applied on a given Purchasable Item if the brand's shipping country is far away from the retailer country
 */
export interface AnkorstoreInternalPurchasingListItemLongDistanceFee {
  /** Type of the fee */
  type?: AnkorstoreInternalPurchasingListItemLongDistanceFeeTypeEnum;
  /**
   * Amount of the fee
   * @example {"currency":"EUR","amount":142}
   */
  amount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * Country where the fee is applied
   * @pattern ^[A-Z]{2}$
   * @example "FR"
   */
  shippingCountryIsoCode?: string;
}

/**
 * PurchasingListItemHeavyBulkFee
 * Fee applied on a given Purchasable Item if the product is heavy or bulky
 */
export interface AnkorstoreInternalPurchasingListItemHeavyBulkFee {
  /** Type of the fee */
  type?: AnkorstoreInternalPurchasingListItemHeavyBulkFeeTypeEnum;
  /**
   * Amount of the fee
   * @example {"currency":"EUR","amount":142}
   */
  amount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
}

/**
 * PurchasingListShippingFee
 * Shipping Fee applied on a given Purchasable Item if the amount is below Brand Franco
 */
export interface AnkorstoreInternalPurchasingListShippingFee {
  /** Type of the fee */
  type: AnkorstoreInternalPurchasingListShippingFeeTypeEnum;
  /**
   * Amount of the fee
   * @example {"currency":"EUR","amount":142}
   */
  amount: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * Amount left to reach the free shipping
   * @example {"currency":"EUR","amount":142}
   */
  amountLeftForFreeShipping: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  } | null;
  metadata: {
    /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
    offerName?: AnkorstoreInternalPurchasingListShippingFeeOfferNameEnum;
    brandNonEligibleForAkPlusFreeShipping: boolean;
    isDiscovery: boolean;
    isEligibleForDiscoveryFreeShipping: boolean;
    /** Minimum order amount to qualify for free shipping (cents) */
    francoAmount?: number | null;
    /** Shipping fee amount when below franco threshold (cents) */
    francoFeeAmount?: number | null;
    /** Maximum shipping fee amount (cents) */
    francoMaxFeeAmount?: number | null;
  };
}

/**
 * PurchasableAggregateResource
 * Aggregate (grouped by brand) of Purchasing List items
 */
export interface AnkorstoreInternalPurchasableAggregateResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
     * @example {"currency":"EUR","amount":142}
     */
    totalAmountBeforeDiscount: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
     * @example {"currency":"EUR","amount":142}
     */
    totalAmountAfterDiscount: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /** Whether the aggregate is part of the selection or not */
    selected: boolean;
    /** Whether the aggregate contains items with differents discounts */
    hasMultiDiscounts: boolean;
    /**
     * Resulting global discount percentage applied on the total amount of the aggregate
     * @format float
     */
    globalDiscountPercentage: number;
    /** Type of the global discount applied on the aggregate, null when no global discount applies */
    globalDiscountType: AnkorstoreInternalPurchasableAggregateResourceGlobalDiscountTypeEnum | null;
    /** Repeat offer information, absent when no repeat offer applies to this aggregate */
    repeatOffer?: {
      /**
       * Total amount to spend in order to unlock AKS+ repeat offer
       * @example {"currency":"EUR","amount":142}
       */
      amountLeftToReachThreshold: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Discount the brand will give to retailer for the AKS+ repeat offer
       * @format float
       */
      percentage: number;
      activeDiscount: {
        /**
         * Percentage of the current active discount
         * @format float
         */
        percentage: number;
        /** EndDate of the current active discount */
        endDate: string;
      } | null;
    };
    /** Total number of items contained in the aggregate */
    itemCount: number;
    /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
    hasReachedBrandMinimumOrderValue: boolean;
    /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
    applicableFees: (
      | {
          /** Type of the fee */
          type?: AnkorstoreInternalPurchasableAggregateResourceTypeEnum;
          /**
           * Amount of the fee
           * @example {"currency":"EUR","amount":142}
           */
          amount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Country where the fee is applied
           * @pattern ^[A-Z]{2}$
           * @example "FR"
           */
          shippingCountryIsoCode?: string;
        }
      | {
          /** Type of the fee */
          type?: AnkorstoreInternalPurchasableAggregateResourceTypeEnum1;
          /**
           * Amount of the fee
           * @example {"currency":"EUR","amount":142}
           */
          amount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        }
      | {
          /** Type of the fee */
          type: AnkorstoreInternalPurchasableAggregateResourceTypeEnum2;
          /**
           * Amount of the fee
           * @example {"currency":"EUR","amount":142}
           */
          amount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount left to reach the free shipping
           * @example {"currency":"EUR","amount":142}
           */
          amountLeftForFreeShipping: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          } | null;
          metadata: {
            /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
            offerName?: AnkorstoreInternalPurchasableAggregateResourceOfferNameEnum;
            brandNonEligibleForAkPlusFreeShipping: boolean;
            isDiscovery: boolean;
            isEligibleForDiscoveryFreeShipping: boolean;
            /** Minimum order amount to qualify for free shipping (cents) */
            francoAmount?: number | null;
            /** Shipping fee amount when below franco threshold (cents) */
            francoFeeAmount?: number | null;
            /** Maximum shipping fee amount (cents) */
            francoMaxFeeAmount?: number | null;
          };
        }
    )[];
    /** Whether the brand can ship to the retailer country */
    canShipToRetailerCountry: boolean;
    /** Whether the items in this brand aggregate belong to a prepared order */
    isPreparedOrder: boolean;
    /** Whether all products in this brand aggregate are out of stock */
    everyProductOutOfStock: boolean;
    /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
    unavailableItemsCount: number;
    /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
    hasFreshProducts: boolean;
    /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
    hasInsufficientStockItems: boolean;
    /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
    hasNeedsFreshInputProducts: boolean;
    /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
    estimatedDelivery: {
      /** Minimum estimated delivery days for this brand aggregate */
      minDays: number | null;
      /** Maximum estimated delivery days for this brand aggregate */
      maxDays: number | null;
    };
  };
  relationships?: {
    brand?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    items?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/**
 * PromocodeResource
 * Promocode resource
 */
export interface AnkorstoreInternalPromocodeResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    code: string;
    message?: string | null;
    status?: string | null;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    amount: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * When the code stops working. Null if it never expires.
     * @format datetime
     */
    expiresAt: string | null;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    minimumOrder: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    minimumCheckout?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
  };
}

/**
 * AddressResource
 * Address resource
 */
export interface AnkorstoreInternalAddressResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    name: string;
    organisationName: string;
    city: string;
    postalCode: string;
    street: string;
    /**
     * CountryObject
     * Country object
     */
    country: {
      /**
       * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
       * @pattern ^[A-Z]{2}$
       * @example "FR"
       */
      isoCode: string;
      name: string;
    };
  };
}

/**
 * CartResource
 * Cart resource
 */
export interface AnkorstoreInternalCartResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Optional note from the brand to the retailer (max 800 characters) */
    note?: string | null;
  };
  relationships?: {
    list?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/**
 * PurchasingListItemResource
 * Purchasing List item resource
 */
export interface AnkorstoreInternalPurchasingListItemResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * ID of the linked Purchasable Item (product variant)
     * @format uuid
     */
    purchasableItemID?: string;
    /** @format uuid */
    productID?: string;
    /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
    quantity?: number;
    /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
    multipliedQuantity?: number;
    /**
     * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
     * @example {"currency":"EUR","amount":142}
     */
    amountBeforeDiscount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
     * @example {"currency":"EUR","amount":142}
     */
    amountAfterDiscount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
  };
  relationships?: {
    purchasableItem?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/**
 * PurchasableItemOption
 * Option details of a given Purchasable Item
 */
export interface AnkorstoreInternalPurchasableItemOption {
  /** Type of the option assigned to this item (ex: size) */
  type?: string;
  /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
  name?: string;
  /** Value of the option assigned to this item (ex: 42 FR) */
  value?: string;
}

/**
 * PurchasableItemDiscount
 * Discount applied on a given Purchasable Item
 */
export interface AnkorstoreInternalPurchasableItemDiscount {
  /** Type of the discount */
  type?: AnkorstoreInternalPurchasableItemDiscountTypeEnum;
  /**
   * Value (percentage) of the discount
   * @format float
   */
  percentage?: number;
}

/**
 * PurchasableItemPricing
 * Pricing details of a given Purchasable Item
 */
export interface AnkorstoreInternalPurchasableItemPricing {
  /** Optional discount applied on the Purchasable Item */
  discount?: null | {
    /** Type of the discount */
    type?: AnkorstoreInternalPurchasableItemPricingTypeEnum;
    /**
     * Value (percentage) of the discount
     * @format float
     */
    percentage?: number;
  };
  /**
   * Unit price (excl. taxes) of the Purchasable Item, before any discount
   * @example {"currency":"EUR","amount":142}
   */
  unitPriceBeforeDiscount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
   * @example {"currency":"EUR","amount":142}
   */
  unitPriceAfterDiscount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /** If product discount is higher than brand global discount */
  isUpperThanGlobalBrandDiscount?: boolean;
}

/**
 * PurchasableItemStock
 * Stock details of a given Purchasable Item
 */
export interface AnkorstoreInternalPurchasableItemStock {
  /**
   * Product-scoped stock status, derived from the currently available
   * stock, `isAlwaysInStock` and `inventoryPolicy`.
   *
   * - `out_of_stock`: there is no stock available to order, i.e. stock is
   *
   *
   *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
   *   and the available quantity is <= 0.
   * - `low_in_stock`: there is little stock left to order, i.e. stock is
   *
   *
   *   tracked (`isAlwaysInStock=false`) and stock is low (available
   *   quantity <= 10, or available quantity < 10% of the on-hand
   *   quantity).
   * - `in_stock`: there is plenty of stock to order (every other case).
   */
  status: AnkorstoreInternalPurchasableItemStockStatusEnum;
  /**
   * Whether stock is tracked at all for this product variant.
   *
   * - `true`: stock is not tracked — a retailer can order as much of this
   *
   *
   *   variant as they want, with no restriction at all.
   * - `false`: stock is tracked — whether a retailer can order the
   *
   *
   *   variant depends on the available stock quantity and the
   *   `inventoryPolicy`.
   */
  isAlwaysInStock: boolean;
  /**
   * Whether a retailer can order a product variant for which stock is not
   * available.
   *
   * - `deny` (default): no. A retailer cannot order a quantity larger than
   *
   *
   *   the currently available stock quantity, so the variant cannot be
   *   ordered when it is out of stock, or when the desired quantity exceeds
   *   the available quantity.
   * - `continue`: yes. The retailer can order any quantity, even when stock
   *
   *
   *   is insufficient (desired quantity > available quantity > 0) or the
   *   variant is out of stock (available quantity <= 0).
   *
   * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
   * @default "deny"
   */
  inventoryPolicy: AnkorstoreInternalPurchasableItemStockInventoryPolicyEnum;
  /** Available quantity of the item in the stock (non-present if the product is always in stock) */
  availableQuantity?: number;
}

/**
 * PurchasableItemResource
 * Purchasable Item (product variant) resource
 */
export interface AnkorstoreInternalPurchasableItemResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Name of the item */
    name?: string;
    /** Path of the item */
    path?: string;
    /** Options of the item */
    options?: {
      /** Type of the option assigned to this item (ex: size) */
      type?: string;
      /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
      name?: string;
      /** Value of the option assigned to this item (ex: 42 FR) */
      value?: string;
    }[];
    /** Path to the main image of the item */
    imagePath?: string | null;
    /**
     * Whether the product variant can be ordered with the quantity
     * currently in the cart.
     *
     * - `available`: it can be ordered with the current cart quantity.
     * - `available_for_preorder`: same, for a pre-order cart.
     *   Deprecated and no longer relevant.
     * - `out_of_stock`: it cannot be ordered with the current cart
     *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
     *   `inventoryPolicy` is `deny`, and the available quantity is
     *   lower than or equal to the cart quantity.
     * - `variant_disabled`: the variant is disabled (archived).
     * - `product_disabled`: the product is disabled (offline, ...).
     * - `brand_disabled`: the brand is disabled (offline, coming soon,
     *   ...).
     * - `country_blacklisted`: the retailer's shipping country is not
     *   allowed by the brand's settings.
     * - `brand_in_holiday`: the brand is in holiday mode.
     */
    availability?: AnkorstoreInternalPurchasableItemResourceAvailabilityEnum;
    /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
    unitMultiplier?: number;
    /**
     * Shipping date(in future) of a preorder product e.g. 2024-12-01
     * @format date
     */
    availableAt?: string | null;
    /**
     * PurchasableItemPricing
     * Pricing details of the Purchasable Item
     */
    pricing?: {
      /** Optional discount applied on the Purchasable Item */
      discount?: null | {
        /** Type of the discount */
        type?: AnkorstoreInternalPurchasableItemResourceTypeEnum;
        /**
         * Value (percentage) of the discount
         * @format float
         */
        percentage?: number;
      };
      /**
       * Unit price (excl. taxes) of the Purchasable Item, before any discount
       * @example {"currency":"EUR","amount":142}
       */
      unitPriceBeforeDiscount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
       * @example {"currency":"EUR","amount":142}
       */
      unitPriceAfterDiscount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** If product discount is higher than brand global discount */
      isUpperThanGlobalBrandDiscount?: boolean;
    };
    /**
     * PurchasableItemStock
     * Stock details of the Purchasable Item
     */
    stock?: {
      /**
       * Product-scoped stock status, derived from the currently available
       * stock, `isAlwaysInStock` and `inventoryPolicy`.
       *
       * - `out_of_stock`: there is no stock available to order, i.e. stock is
       *
       *
       *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
       *   and the available quantity is <= 0.
       * - `low_in_stock`: there is little stock left to order, i.e. stock is
       *
       *
       *   tracked (`isAlwaysInStock=false`) and stock is low (available
       *   quantity <= 10, or available quantity < 10% of the on-hand
       *   quantity).
       * - `in_stock`: there is plenty of stock to order (every other case).
       */
      status: AnkorstoreInternalPurchasableItemResourceStatusEnum;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of this
       *
       *
       *   variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy: AnkorstoreInternalPurchasableItemResourceInventoryPolicyEnum;
      /** Available quantity of the item in the stock (non-present if the product is always in stock) */
      availableQuantity?: number;
    };
    /** Optional extra fees applied on the Purchasable Item */
    applicableFees?: (
      | {
          /** Type of the fee */
          type?: AnkorstoreInternalPurchasableItemResourceTypeEnum1;
          /**
           * Amount of the fee
           * @example {"currency":"EUR","amount":142}
           */
          amount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Country where the fee is applied
           * @pattern ^[A-Z]{2}$
           * @example "FR"
           */
          shippingCountryIsoCode?: string;
        }
      | {
          /** Type of the fee */
          type?: AnkorstoreInternalPurchasableItemResourceTypeEnum2;
          /**
           * Amount of the fee
           * @example {"currency":"EUR","amount":142}
           */
          amount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        }
      | {
          /** Type of the fee */
          type: AnkorstoreInternalPurchasableItemResourceTypeEnum3;
          /**
           * Amount of the fee
           * @example {"currency":"EUR","amount":142}
           */
          amount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount left to reach the free shipping
           * @example {"currency":"EUR","amount":142}
           */
          amountLeftForFreeShipping: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          } | null;
          metadata: {
            /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
            offerName?: AnkorstoreInternalPurchasableItemResourceOfferNameEnum;
            brandNonEligibleForAkPlusFreeShipping: boolean;
            isDiscovery: boolean;
            isEligibleForDiscoveryFreeShipping: boolean;
            /** Minimum order amount to qualify for free shipping (cents) */
            francoAmount?: number | null;
            /** Shipping fee amount when below franco threshold (cents) */
            francoFeeAmount?: number | null;
            /** Maximum shipping fee amount (cents) */
            francoMaxFeeAmount?: number | null;
          };
        }
    )[];
    /** Storage temperature requirement of the product, if set by the brand */
    storageTemperature?: AnkorstoreInternalPurchasableItemResourceStorageTemperatureEnum;
    /** Whether this product needs fresh input (temperature-controlled shipping) */
    needsFreshInput?: boolean;
  };
}

/**
 * Linkage
 * Resource identification present in Resource Objects and Resource Identifier Objects.
 */
export interface AnkorstoreInternalLinkage {
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/**
 * PurchasingListCrossListOperationResultResource
 * Cross list operation resource
 */
export interface AnkorstoreInternalPurchasingListCrossListOperationResultResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: object;
  relationships?: {
    sourceList?: {
      /**
       * Linkage
       * Resource identification present in Resource Objects and Resource Identifier Objects.
       */
      data: {
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    destinationList?: {
      /**
       * Linkage
       * Resource identification present in Resource Objects and Resource Identifier Objects.
       */
      data: {
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/** PreparedOrderItemProduct */
export interface AnkorstoreInternalPreparedOrderItemProduct {
  id?: number;
  type?: 'product';
  /** @format date-time */
  createdAt?: string;
  name?: string;
  images?: string[];
  link?: string | null;
  unitMultiplier?: number;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  originalWholesalePrice?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  wholesalePrice?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  retailPrice?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  discountEventPrice?: object | null;
  discountType?: string | null;
  discountRate?: number;
}

/** PreparedOrderItemProductVariant */
export interface AnkorstoreInternalPreparedOrderItemProductVariant {
  id?: number | null;
  sku?: string;
  ian?: string | null;
  /** @format date-time */
  createdAt?: string;
  name?: string;
  unitMultiplier?: number;
  price?: {
    currency?: string;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    retailPrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    wholesalePrice?: object | null;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    originalWholesalePrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
  };
  /** @format date-time */
  availableAt?: string | null;
  outOfStock?: boolean;
}

/** PreparedOrderItem */
export interface AnkorstoreInternalPreparedOrderItem {
  id?: number;
  type?: 'order_item';
  /** PreparedOrderItemProduct */
  product?: {
    id?: number;
    type?: 'product';
    /** @format date-time */
    createdAt?: string;
    name?: string;
    images?: string[];
    link?: string | null;
    unitMultiplier?: number;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    originalWholesalePrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    wholesalePrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    retailPrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    discountEventPrice?: object | null;
    discountType?: string | null;
    discountRate?: number;
  };
  /** PreparedOrderItemProductVariant */
  variant?: {
    id?: number | null;
    sku?: string;
    ian?: string | null;
    /** @format date-time */
    createdAt?: string;
    name?: string;
    unitMultiplier?: number;
    price?: {
      currency?: string;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      retailPrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      wholesalePrice?: object | null;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      originalWholesalePrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
    };
    /** @format date-time */
    availableAt?: string | null;
    outOfStock?: boolean;
  };
  /** The number of packs. */
  quantity?: number;
  /** The number of units (packs multiplied by the pack size). */
  multipliedQuantity?: number;
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  unitPriceBeforeDiscount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  unitPrice?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amountBeforeDiscount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amountVat?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  amountWithVat?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
}

/**
 * PreparedOrder
 * A brand's prepared-order cart.
 */
export interface AnkorstoreInternalPreparedOrder {
  /**
   * The cart lifecycle state.
   * @example "draft"
   */
  state?: AnkorstoreInternalPreparedOrderStateEnum;
  /** Public preview URL, present once the cart is submitted or confirmed. */
  permalink?: string | null;
  /** The retailer the cart is prepared for, or `null` when unassigned. */
  customer?: object | null;
  items?: {
    id?: number;
    type?: 'order_item';
    /** PreparedOrderItemProduct */
    product?: {
      id?: number;
      type?: 'product';
      /** @format date-time */
      createdAt?: string;
      name?: string;
      images?: string[];
      link?: string | null;
      unitMultiplier?: number;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      originalWholesalePrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      wholesalePrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      retailPrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      discountEventPrice?: object | null;
      discountType?: string | null;
      discountRate?: number;
    };
    /** PreparedOrderItemProductVariant */
    variant?: {
      id?: number | null;
      sku?: string;
      ian?: string | null;
      /** @format date-time */
      createdAt?: string;
      name?: string;
      unitMultiplier?: number;
      price?: {
        currency?: string;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        retailPrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        wholesalePrice?: object | null;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        originalWholesalePrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
      };
      /** @format date-time */
      availableAt?: string | null;
      outOfStock?: boolean;
    };
    /** The number of packs. */
    quantity?: number;
    /** The number of units (packs multiplied by the pack size). */
    multipliedQuantity?: number;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    unitPriceBeforeDiscount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    unitPrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    amountBeforeDiscount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    amount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    amountVat?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    amountWithVat?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
  }[];
  billingItems?: Record<string, any>[];
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  totalAmountBeforeDiscount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  totalAmount?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  totalAmountVat?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  totalAmountWithVat?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  submittedAt?: string | null;
  /** @format date-time */
  paidAt?: string | null;
}

/**
 * UnavailableItem
 * A source product that could not be re-added to the duplicated cart.
 */
export interface AnkorstoreInternalUnavailableItem {
  /**
   * Why the product could not be re-added.
   * - `unavailable`: the variant no longer exists or is no longer sold by the brand.
   */
  reason: AnkorstoreInternalUnavailableItemReasonEnum;
  /** PreparedOrderItemProduct */
  product: {
    id?: number;
    type?: 'product';
    /** @format date-time */
    createdAt?: string;
    name?: string;
    images?: string[];
    link?: string | null;
    unitMultiplier?: number;
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    originalWholesalePrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    wholesalePrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    retailPrice?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    discountEventPrice?: object | null;
    discountType?: string | null;
    discountRate?: number;
  };
  /** PreparedOrderItemProductVariant */
  variant: {
    id?: number | null;
    sku?: string;
    ian?: string | null;
    /** @format date-time */
    createdAt?: string;
    name?: string;
    unitMultiplier?: number;
    price?: {
      currency?: string;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      retailPrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      wholesalePrice?: object | null;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      originalWholesalePrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
    };
    /** @format date-time */
    availableAt?: string | null;
    outOfStock?: boolean;
  };
}

/** PreparedOrderResource */
export interface AnkorstoreInternalPreparedOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /**
   * PreparedOrder
   * A brand's prepared-order cart.
   */
  attributes: {
    /**
     * The cart lifecycle state.
     * @example "draft"
     */
    state?: AnkorstoreInternalPreparedOrderResourceStateEnum;
    /** Public preview URL, present once the cart is submitted or confirmed. */
    permalink?: string | null;
    /** The retailer the cart is prepared for, or `null` when unassigned. */
    customer?: object | null;
    items?: {
      id?: number;
      type?: 'order_item';
      /** PreparedOrderItemProduct */
      product?: {
        id?: number;
        type?: 'product';
        /** @format date-time */
        createdAt?: string;
        name?: string;
        images?: string[];
        link?: string | null;
        unitMultiplier?: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        originalWholesalePrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        wholesalePrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        retailPrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        discountEventPrice?: object | null;
        discountType?: string | null;
        discountRate?: number;
      };
      /** PreparedOrderItemProductVariant */
      variant?: {
        id?: number | null;
        sku?: string;
        ian?: string | null;
        /** @format date-time */
        createdAt?: string;
        name?: string;
        unitMultiplier?: number;
        price?: {
          currency?: string;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          retailPrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          wholesalePrice?: object | null;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          originalWholesalePrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        /** @format date-time */
        availableAt?: string | null;
        outOfStock?: boolean;
      };
      /** The number of packs. */
      quantity?: number;
      /** The number of units (packs multiplied by the pack size). */
      multipliedQuantity?: number;
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      unitPriceBeforeDiscount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      unitPrice?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amountBeforeDiscount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amountVat?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      amountWithVat?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
    }[];
    billingItems?: Record<string, any>[];
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    totalAmountBeforeDiscount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    totalAmount?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    totalAmountVat?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    totalAmountWithVat?: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    updatedAt?: string;
    /** @format date-time */
    submittedAt?: string | null;
    /** @format date-time */
    paidAt?: string | null;
  };
  meta?: {
    /** Source products that could not be re-added to the duplicate. */
    unavailableItems?: {
      /**
       * Why the product could not be re-added.
       * - `unavailable`: the variant no longer exists or is no longer sold by the brand.
       */
      reason: AnkorstoreInternalPreparedOrderResourceReasonEnum;
      /** PreparedOrderItemProduct */
      product: {
        id?: number;
        type?: 'product';
        /** @format date-time */
        createdAt?: string;
        name?: string;
        images?: string[];
        link?: string | null;
        unitMultiplier?: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        originalWholesalePrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        wholesalePrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        retailPrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        discountEventPrice?: object | null;
        discountType?: string | null;
        discountRate?: number;
      };
      /** PreparedOrderItemProductVariant */
      variant: {
        id?: number | null;
        sku?: string;
        ian?: string | null;
        /** @format date-time */
        createdAt?: string;
        name?: string;
        unitMultiplier?: number;
        price?: {
          currency?: string;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          retailPrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          wholesalePrice?: object | null;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          originalWholesalePrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        /** @format date-time */
        availableAt?: string | null;
        outOfStock?: boolean;
      };
    }[];
    [key: string]: any;
  };
}

/** ValueFilter */
export interface AnkorstoreInternalSearchValueFilter {
  /**
   * The type of filter.
   *
   * This filter returns results that contain a specific attribute value.<br/>
   * Available on **text**, **number** or **date** attributes and supports arrays.
   */
  type: AnkorstoreInternalSearchValueFilterTypeEnum;
  /** The name of the attribute upon which to apply the filter. */
  name: string;
  /**
   * The negation operator. When set to `true` it selects all results
   * that do not satisfy the filter condition.
   * @default false
   */
  not?: boolean;
  /**
   * The value upon which to filter.
   *
   * The value must be an exact match. When operating on strings, the filter
   * is case-sensitive (i.e. *“French”* will not match on *“french”*).
   */
  value: string | number | (string | number)[];
}

/** RangeFilter */
export interface AnkorstoreInternalSearchRangeFilter {
  /**
   * The type of filter.
   *
   * This filter returns results over a range of dates or numbers.<br/>
   * Available on **number** or **date** attributes.
   */
  type: AnkorstoreInternalSearchRangeFilterTypeEnum;
  /** The name of the attribute upon which to apply the filter. */
  name: string;
  /**
   * Inclusive lower bound of the range.<br/>
   * Required if `max` or `exclusiveMax` is not given.
   */
  min?: number | string;
  /**
   * Inclusive upper bound of the range.<br/>
   * Required if `min` or `exclusiveMin` is not given.
   */
  max?: number | string;
  /**
   * Exclusive lower bound of the range.<br/>
   * Required if `max` or `exclusiveMax` is not given.
   */
  exclusiveMin?: number | string;
  /**
   * Exclusive upper bound of the range.<br/>
   * Required if `min` or `exclusiveMin` is not given.
   */
  exclusiveMax?: number | string;
}

/** BooleanFilter */
export interface AnkorstoreInternalSearchBooleanFilter {
  /** The type of filter. */
  type: AnkorstoreInternalSearchBooleanFilterTypeEnum;
  /** The name of the attribute upon which to apply the filter. */
  name: string;
  /** The value upon which to filter. */
  value: boolean;
}

export type AnkorstoreInternalSearchFilter =
  | {
      /**
       * The type of filter.
       *
       * This filter returns results that contain a specific attribute value.<br/>
       * Available on **text**, **number** or **date** attributes and supports arrays.
       */
      type: AnkorstoreInternalSearchFilterTypeEnum;
      /** The name of the attribute upon which to apply the filter. */
      name: string;
      /**
       * The negation operator. When set to `true` it selects all results
       * that do not satisfy the filter condition.
       * @default false
       */
      not?: boolean;
      /**
       * The value upon which to filter.
       *
       * The value must be an exact match. When operating on strings, the filter
       * is case-sensitive (i.e. *“French”* will not match on *“french”*).
       */
      value: string | number | (string | number)[];
    }
  | {
      /**
       * The type of filter.
       *
       * This filter returns results over a range of dates or numbers.<br/>
       * Available on **number** or **date** attributes.
       */
      type: AnkorstoreInternalSearchFilterTypeEnum1;
      /** The name of the attribute upon which to apply the filter. */
      name: string;
      /**
       * Inclusive lower bound of the range.<br/>
       * Required if `max` or `exclusiveMax` is not given.
       */
      min?: number | string;
      /**
       * Inclusive upper bound of the range.<br/>
       * Required if `min` or `exclusiveMin` is not given.
       */
      max?: number | string;
      /**
       * Exclusive lower bound of the range.<br/>
       * Required if `max` or `exclusiveMax` is not given.
       */
      exclusiveMin?: number | string;
      /**
       * Exclusive upper bound of the range.<br/>
       * Required if `min` or `exclusiveMin` is not given.
       */
      exclusiveMax?: number | string;
    }
  | {
      /** The type of filter. */
      type: AnkorstoreInternalSearchFilterTypeEnum2;
      /** The name of the attribute upon which to apply the filter. */
      name: string;
      /** The value upon which to filter. */
      value: boolean;
    };

export interface AnkorstoreInternalCampaignMessage {
  /** The type of message. */
  type: AnkorstoreInternalCampaignMessageTypeEnum;
  /**
   * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
   * @example "en"
   */
  language?: string;
}

export type AnkorstoreInternalCampaignMessageEmail = {
  /** The type of message. */
  type: AnkorstoreInternalCampaignMessageEmailTypeEnum;
  /**
   * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
   * @example "en"
   */
  language?: string;
} & {
  /** The name to display as the sender name for the email. */
  from?: string;
  /** The subject of this email message. */
  subject?: string;
  /** The HTML body for this email message. */
  body?: string;
  /** The HTML footer for this email message, used on version 1 templates. */
  footer?: null | string;
  /** The label of the call-to-action button, used on version 1 templates. */
  ctaText?: null | string;
};

/** A campaign resource */
export interface AnkorstoreInternalCampaignResource {
  /**
   * A globally-unique identifier for the campaign.
   * @format uuid
   * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
   */
  id?: string;
  type: AnkorstoreInternalCampaignResourceTypeEnum;
  attributes: {
    /** Readable name of the campaign. */
    name?: string;
    /** The type of campaign. */
    type?: AnkorstoreInternalCampaignResourceTypeEnum1;
    /** The current status of the campaign. */
    status?: AnkorstoreInternalCampaignResourceStatusEnum;
    /**
     * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
     * @format date-time
     */
    scheduledAt?: null | string;
    /** The template version that this campaign uses. */
    templateVersion?: AnkorstoreInternalCampaignResourceTemplateVersionEnum;
    /** The target audience for this campaign. */
    audience?: {
      /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
      filters?: (
        | {
            /**
             * The type of filter.
             *
             * This filter returns results that contain a specific attribute value.<br/>
             * Available on **text**, **number** or **date** attributes and supports arrays.
             */
            type: AnkorstoreInternalCampaignResourceTypeEnum2;
            /** The name of the attribute upon which to apply the filter. */
            name: string;
            /**
             * The negation operator. When set to `true` it selects all results
             * that do not satisfy the filter condition.
             * @default false
             */
            not?: boolean;
            /**
             * The value upon which to filter.
             *
             * The value must be an exact match. When operating on strings, the filter
             * is case-sensitive (i.e. *“French”* will not match on *“french”*).
             */
            value: string | number | (string | number)[];
          }
        | {
            /**
             * The type of filter.
             *
             * This filter returns results over a range of dates or numbers.<br/>
             * Available on **number** or **date** attributes.
             */
            type: AnkorstoreInternalCampaignResourceTypeEnum3;
            /** The name of the attribute upon which to apply the filter. */
            name: string;
            /**
             * Inclusive lower bound of the range.<br/>
             * Required if `max` or `exclusiveMax` is not given.
             */
            min?: number | string;
            /**
             * Inclusive upper bound of the range.<br/>
             * Required if `min` or `exclusiveMin` is not given.
             */
            max?: number | string;
            /**
             * Exclusive lower bound of the range.<br/>
             * Required if `max` or `exclusiveMax` is not given.
             */
            exclusiveMin?: number | string;
            /**
             * Exclusive upper bound of the range.<br/>
             * Required if `min` or `exclusiveMin` is not given.
             */
            exclusiveMax?: number | string;
          }
        | {
            /** The type of filter. */
            type: AnkorstoreInternalCampaignResourceTypeEnum4;
            /** The name of the attribute upon which to apply the filter. */
            name: string;
            /** The value upon which to filter. */
            value: boolean;
          }
      )[];
    };
    /** Content of the campaign. */
    content?: {
      /**
       * The default language for this campaign.
       * @example "en"
       */
      defaultLanguage?: string;
      /** The campaign messages. */
      messages?: ({
        /** The type of message. */
        type: AnkorstoreInternalCampaignResourceTypeEnum5;
        /**
         * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
         * @example "en"
         */
        language?: string;
      } & {
        /** The name to display as the sender name for the email. */
        from?: string;
        /** The subject of this email message. */
        subject?: string;
        /** The HTML body for this email message. */
        body?: string;
        /** The HTML footer for this email message, used on version 1 templates. */
        footer?: null | string;
        /** The label of the call-to-action button, used on version 1 templates. */
        ctaText?: null | string;
      })[];
    };
  };
  meta?: {
    /**
     * The date when this campaign was created.
     * @format date-time
     */
    createdAt?: string;
    /**
     * The date when this campaign was verified.
     * @format date-time
     */
    verifiedAt?: null | string;
    /**
     * The date when this campaign was completed.
     * @format date-time
     */
    completedAt?: null | string;
    /**
     * The number of languages this campaign targets.
     * @min 0
     */
    languageCount?: number;
    /** The report summary. */
    report?: {
      /**
       * The total number of recipients for this campaign.
       * @min 0
       */
      recipientCount?: number;
      /**
       * The total number of successful deliveries.
       * @min 0
       */
      totalDelivered?: number;
      /**
       * The number of unique opens.
       * @min 0
       */
      opens?: number;
      /**
       * The number of unique clicks.
       * @min 0
       */
      clicks?: number;
      /**
       * The number of unique opens divided by the total number of successful deliveries.
       * @format float
       * @min 0
       * @max 100
       */
      openRate?: number;
      /**
       * The number of unique clicks divided by the total number of successful deliveries.
       * @format float
       * @min 0
       * @max 100
       */
      clickRate?: number;
    };
    [key: string]: any;
  };
}

export interface AnkorstoreInternalCampaignCollectionDocument {
  /** A collection of campaign resources. */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: AnkorstoreInternalCampaignCollectionDocumentTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: AnkorstoreInternalCampaignCollectionDocumentTypeEnum1;
      /** The current status of the campaign. */
      status?: AnkorstoreInternalCampaignCollectionDocumentStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: AnkorstoreInternalCampaignCollectionDocumentTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: AnkorstoreInternalCampaignCollectionDocumentTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: AnkorstoreInternalCampaignCollectionDocumentTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: AnkorstoreInternalCampaignCollectionDocumentTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: AnkorstoreInternalCampaignCollectionDocumentTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface AnkorstoreInternalCampaignDocument {
  /** A campaign resource */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: AnkorstoreInternalCampaignDocumentTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: AnkorstoreInternalCampaignDocumentTypeEnum1;
      /** The current status of the campaign. */
      status?: AnkorstoreInternalCampaignDocumentStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: AnkorstoreInternalCampaignDocumentTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: AnkorstoreInternalCampaignDocumentTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: AnkorstoreInternalCampaignDocumentTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: AnkorstoreInternalCampaignDocumentTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: AnkorstoreInternalCampaignDocumentTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A campaign delivery resource */
export interface AnkorstoreInternalCampaignDeliveryResource {
  /**
   * A globally-unique identifier for the delivery.
   * @format uuid
   * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
   */
  id?: string;
  type: AnkorstoreInternalCampaignDeliveryResourceTypeEnum;
  attributes: {
    /** The current status of the delivery. */
    status?: AnkorstoreInternalCampaignDeliveryResourceStatusEnum;
    /**
     * The recipient's email address.
     * @format email
     */
    email?: string;
    /**
     * The recipient's language represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
     * @example "en"
     */
    language?: string;
  };
}

export interface AnkorstoreInternalCampaignDeliveryCollectionDocument {
  /** A collection of campaign delivery resources. */
  data: {
    /**
     * A globally-unique identifier for the delivery.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: AnkorstoreInternalCampaignDeliveryCollectionDocumentTypeEnum;
    attributes: {
      /** The current status of the delivery. */
      status?: AnkorstoreInternalCampaignDeliveryCollectionDocumentStatusEnum;
      /**
       * The recipient's email address.
       * @format email
       */
      email?: string;
      /**
       * The recipient's language represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
       * @example "en"
       */
      language?: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** The content of a template */
export interface AnkorstoreInternalTemplateContent {
  /** The iso-2 language code of the content */
  language: string;
  /** The type of the content */
  type: string;
}

/** A campaign template resource */
export interface AnkorstoreInternalTemplateResource {
  /** The unique identifier for the template */
  id?: string;
  /** The localized name of the template */
  name?: string;
  /** A localized description of the template */
  description?: string;
  /** A collection of template contents */
  contents?: {
    /** The iso-2 language code of the content */
    language: string;
    /** The type of the content */
    type: string;
  }[];
  /** A collection of allowed segment types */
  allowedSegments?: string[];
  /** A collection of segments for which this template is the default one */
  defaultForSegments?: string[];
}

export interface AnkorstoreInternalTemplateCollectionDocument {
  /** A collection of campaign resources. */
  data: {
    /** The unique identifier for the template */
    id?: string;
    /** The localized name of the template */
    name?: string;
    /** A localized description of the template */
    description?: string;
    /** A collection of template contents */
    contents?: {
      /** The iso-2 language code of the content */
      language: string;
      /** The type of the content */
      type: string;
    }[];
    /** A collection of allowed segment types */
    allowedSegments?: string[];
    /** A collection of segments for which this template is the default one */
    defaultForSegments?: string[];
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface AnkorstoreInternalTemplateDocument {
  /** A campaign template resource */
  data: {
    /** The unique identifier for the template */
    id?: string;
    /** The localized name of the template */
    name?: string;
    /** A localized description of the template */
    description?: string;
    /** A collection of template contents */
    contents?: {
      /** The iso-2 language code of the content */
      language: string;
      /** The type of the content */
      type: string;
    }[];
    /** A collection of allowed segment types */
    allowedSegments?: string[];
    /** A collection of segments for which this template is the default one */
    defaultForSegments?: string[];
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * Rutter Order Tags
 * List of order tags to be added to each new order synchronized to external Rutter platform
 * @maxItems 5
 * @uniqueItems true
 */
export type AnkorstoreInternalRutterOrderTags = string[];

/** Configuration parameters for the integration */
export type AnkorstoreInternalRutterConfiguration = null | {
  /** Initial financial status for all order synced to Shopify */
  order_default_financial_status?: string;
  /** Inventory policy for new orders created on Shopify. */
  inventory_policy?: string;
  /** To enable/disable synchronization of Shopify inventory to Ankorstore. */
  inventory_synchronization?: boolean;
  /** To initiate full catalog synchronization from Shopify to Ankorstore. */
  catalog_synchronization?: boolean;
  /** To enable/disable continuous catalog synchronization (prices) from Shopify to Ankorstore. */
  catalog_continuous_synchronization?: boolean;
  /** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
  catalog_synchronization_workflow?: AnkorstoreInternalRutterConfigurationCatalogSynchronizationWorkflowEnum;
  /** Strategy to use for price synchronization from Shopify to Ankorstore. */
  shopify_catalog_price_strategy?: AnkorstoreInternalRutterConfigurationShopifyCatalogPriceStrategyEnum;
  /** Multiplier (as float) to use for price synchronization from Shopify to Ankorstore. */
  shopify_catalog_price_multiplier?: number;
};

export interface AnkorstoreInternalRutterIntegration {
  /**
   * @default "rutter-integrations"
   * @example "rutter-integrations"
   */
  type: string;
  /** In the current implementation this ID matches the ID of the target brand. In the future most probably will be replaced with Rutter ingeration entity identifier. */
  id: string;
  attributes: {
    /**
     * Access token received from Rutter API
     * @example "937c5af4-d0a4-46b5-820d-300e75d982a5"
     */
    accessToken: string;
    /**
     * Target platform name
     * @example "SHOPIFY"
     */
    platformName: string;
    /**
     * Rutter Order Tags
     * List of order tags to be added to each new order synchronized to external Rutter platform
     * @maxItems 5
     * @uniqueItems true
     */
    orderTags?: string[];
    /** Configuration parameters for the integration */
    configuration?: null | {
      /** Initial financial status for all order synced to Shopify */
      order_default_financial_status?: string;
      /** Inventory policy for new orders created on Shopify. */
      inventory_policy?: string;
      /** To enable/disable synchronization of Shopify inventory to Ankorstore. */
      inventory_synchronization?: boolean;
      /** To initiate full catalog synchronization from Shopify to Ankorstore. */
      catalog_synchronization?: boolean;
      /** To enable/disable continuous catalog synchronization (prices) from Shopify to Ankorstore. */
      catalog_continuous_synchronization?: boolean;
      /** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
      catalog_synchronization_workflow?: AnkorstoreInternalRutterIntegrationCatalogSynchronizationWorkflowEnum;
      /** Strategy to use for price synchronization from Shopify to Ankorstore. */
      shopify_catalog_price_strategy?: AnkorstoreInternalRutterIntegrationShopifyCatalogPriceStrategyEnum;
      /** Multiplier (as float) to use for price synchronization from Shopify to Ankorstore. */
      shopify_catalog_price_multiplier?: number;
    };
  };
}

export interface AnkorstoreInternalPlatformVerificationError {
  code: AnkorstoreInternalPlatformVerificationErrorCodeEnum;
  detail: string;
  status: string;
}

export interface AnkorstoreInternalFulfillableProductVariant {
  /** @format uuid */
  fulfillableId?: string;
  fulfillableType?: AnkorstoreInternalFulfillableProductVariantFulfillableTypeEnum;
  /** Available batch quantity in the warehouse */
  availableQuantity?: number;
  /** Whether the product is archived in the catalog */
  productArchived?: boolean;
  /** Images from the catalog (as relative path) */
  productImages?: string[];
  /** Name of the product in the catalog */
  productName?: string;
  /** Stock Keeping Unit */
  sku?: string;
}

export type AnkorstoreInternalProductVariantFulfillmentItem = {
  /** @format uuid */
  fulfillableId?: string;
  fulfillableType?: AnkorstoreInternalProductVariantFulfillmentItemFulfillableTypeEnum;
  /** Available batch quantity in the warehouse */
  availableQuantity?: number;
  /** Whether the product is archived in the catalog */
  productArchived?: boolean;
  /** Images from the catalog (as relative path) */
  productImages?: string[];
  /** Name of the product in the catalog */
  productName?: string;
  /** Stock Keeping Unit */
  sku?: string;
} & {
  /**
   * Unique barcode (EAN13 or ITF14)
   * @pattern ^\d{13,14}$
   */
  barcode?: string;
  /** Number of units in a batch. This indicates the lowest denominator of items that can be fulfilled */
  unitsPerBatch?: number;
  /**
   * Margin (as a percentage) between the cost price and wholesale price. Used for insurance purposes
   * @format float
   * @min 0
   * @max 100
   */
  unitCostMargin?: number;
  /** Name of the product shared with warehouse systems */
  warehouseProductName?: string;
  /** Name of the category shared with warehouse systems */
  warehouseCategoryName?: string;
  classificationCode?: AnkorstoreInternalProductVariantFulfillmentItemClassificationCodeEnum;
  /**
   * Whether the item in the warehouse is tracked for expiry
   * @default false
   */
  expiryTracked?: boolean | null;
  /** Shelf life of the item in days */
  shelfLife?: number | null;
  /**
   * Whether the item in the warehouse is tracked by lot
   * @default false
   */
  lotTracked?: boolean | null;
  /**
   * Whether the item is considered fragile
   * @default false
   */
  isFragile?: boolean | null;
  /**
   * Whether the item is considered organic
   * @default false
   */
  isOrganic?: boolean | null;
  /**
   * Whether the item needs to be repacked before shipping
   * @default false
   */
  needRepack?: boolean | null;
  /**
   * Whether the item needs to be relabeled before shipping
   * @default false
   */
  needRelabel?: boolean | null;
  /**
   * Code for alcohol classification, as used in the warehouse
   * @min 1
   * @max 11
   */
  alcoholCode?: number | null;
  /**
   * Percentage of alcohol in the item
   * @format float
   * @min 0
   * @max 100
   */
  alcoholPercentage?: number | null;
  /**
   * Volume of liquid per pack in liter
   * @format float
   * @min 0
   * @max 100
   */
  volumeOfLiquidPerPack?: number | null;
  /**
   * Installation Classified for the Protection of the Environment, as used in the warehouse
   * @min 1000
   * @max 4999
   */
  icpeCode?: number | null;
  status?: AnkorstoreInternalProductVariantFulfillmentItemStatusEnum;
  /** How many days stock is expected to last, based on historical data.  Null if insufficient data available to create an estimate */
  expectedStockForDays?: number | null;
  stockStatus?: AnkorstoreInternalProductVariantFulfillmentItemStockStatusEnum;
  /** Reference for the fulfillment item, used in the warehouse */
  referenceId?: string;
};

export interface AnkorstoreInternalFulfillmentBundleItem {
  /** @format uuid */
  fulfillmentItemId?: string;
  /** number of batches of this item included in the bundle */
  quantity?: number;
}

export type AnkorstoreInternalProductVariantFulfillmentBundle = {
  /** @format uuid */
  fulfillableId?: string;
  fulfillableType?: AnkorstoreInternalProductVariantFulfillmentBundleFulfillableTypeEnum;
  /** Available batch quantity in the warehouse */
  availableQuantity?: number;
  /** Whether the product is archived in the catalog */
  productArchived?: boolean;
  /** Images from the catalog (as relative path) */
  productImages?: string[];
  /** Name of the product in the catalog */
  productName?: string;
  /** Stock Keeping Unit */
  sku?: string;
} & {
  bundleItems?: {
    /** @format uuid */
    fulfillmentItemId?: string;
    /** number of batches of this item included in the bundle */
    quantity?: number;
  }[];
};

export interface AnkorstoreInternalFulfillableProductVariantResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes:
    | ({
        /** @format uuid */
        fulfillableId?: string;
        fulfillableType?: AnkorstoreInternalFulfillableProductVariantResourceFulfillableTypeEnum;
        /** Available batch quantity in the warehouse */
        availableQuantity?: number;
        /** Whether the product is archived in the catalog */
        productArchived?: boolean;
        /** Images from the catalog (as relative path) */
        productImages?: string[];
        /** Name of the product in the catalog */
        productName?: string;
        /** Stock Keeping Unit */
        sku?: string;
      } & {
        /**
         * Unique barcode (EAN13 or ITF14)
         * @pattern ^\d{13,14}$
         */
        barcode?: string;
        /** Number of units in a batch. This indicates the lowest denominator of items that can be fulfilled */
        unitsPerBatch?: number;
        /**
         * Margin (as a percentage) between the cost price and wholesale price. Used for insurance purposes
         * @format float
         * @min 0
         * @max 100
         */
        unitCostMargin?: number;
        /** Name of the product shared with warehouse systems */
        warehouseProductName?: string;
        /** Name of the category shared with warehouse systems */
        warehouseCategoryName?: string;
        classificationCode?: AnkorstoreInternalFulfillableProductVariantResourceClassificationCodeEnum;
        /**
         * Whether the item in the warehouse is tracked for expiry
         * @default false
         */
        expiryTracked?: boolean | null;
        /** Shelf life of the item in days */
        shelfLife?: number | null;
        /**
         * Whether the item in the warehouse is tracked by lot
         * @default false
         */
        lotTracked?: boolean | null;
        /**
         * Whether the item is considered fragile
         * @default false
         */
        isFragile?: boolean | null;
        /**
         * Whether the item is considered organic
         * @default false
         */
        isOrganic?: boolean | null;
        /**
         * Whether the item needs to be repacked before shipping
         * @default false
         */
        needRepack?: boolean | null;
        /**
         * Whether the item needs to be relabeled before shipping
         * @default false
         */
        needRelabel?: boolean | null;
        /**
         * Code for alcohol classification, as used in the warehouse
         * @min 1
         * @max 11
         */
        alcoholCode?: number | null;
        /**
         * Percentage of alcohol in the item
         * @format float
         * @min 0
         * @max 100
         */
        alcoholPercentage?: number | null;
        /**
         * Volume of liquid per pack in liter
         * @format float
         * @min 0
         * @max 100
         */
        volumeOfLiquidPerPack?: number | null;
        /**
         * Installation Classified for the Protection of the Environment, as used in the warehouse
         * @min 1000
         * @max 4999
         */
        icpeCode?: number | null;
        status?: AnkorstoreInternalFulfillableProductVariantResourceStatusEnum;
        /** How many days stock is expected to last, based on historical data.  Null if insufficient data available to create an estimate */
        expectedStockForDays?: number | null;
        stockStatus?: AnkorstoreInternalFulfillableProductVariantResourceStockStatusEnum;
        /** Reference for the fulfillment item, used in the warehouse */
        referenceId?: string;
      })
    | ({
        /** @format uuid */
        fulfillableId?: string;
        fulfillableType?: AnkorstoreInternalFulfillableProductVariantResourceFulfillableTypeEnum1;
        /** Available batch quantity in the warehouse */
        availableQuantity?: number;
        /** Whether the product is archived in the catalog */
        productArchived?: boolean;
        /** Images from the catalog (as relative path) */
        productImages?: string[];
        /** Name of the product in the catalog */
        productName?: string;
        /** Stock Keeping Unit */
        sku?: string;
      } & {
        bundleItems?: {
          /** @format uuid */
          fulfillmentItemId?: string;
          /** number of batches of this item included in the bundle */
          quantity?: number;
        }[];
      });
}

export interface AnkorstoreInternalFulfillmentOrderAddress {
  /** @minLength 1 */
  firstName?: string;
  /** @minLength 1 */
  lastName?: string;
  company?: string;
  /** @minLength 1 */
  phone?: string;
  email?: string;
  /** @minLength 1 */
  street?: string;
  /** @minLength 1 */
  city?: string;
  postalCode?: string;
  /** @pattern ^[A-Z]{2}$ */
  country?: string;
}

export type AnkorstoreInternalFulfillmentOrderShippingAddress = {
  /** @minLength 1 */
  firstName?: string;
  /** @minLength 1 */
  lastName?: string;
  company?: string;
  /** @minLength 1 */
  phone?: string;
  email?: string;
  /** @minLength 1 */
  street?: string;
  /** @minLength 1 */
  city?: string;
  postalCode?: string;
  /** @pattern ^[A-Z]{2}$ */
  country?: string;
};

export interface AnkorstoreInternalFulfillableBatchesSpecification {
  /** @format uuid */
  fulfillableId: string;
  /** quantity in batches */
  batchQuantity: number;
}

export interface AnkorstoreInternalFulfillableUnitsSpecification {
  /** @format uuid */
  fulfillableId: string;
  /** quantity in units */
  unitQuantity: number;
}

/**
 * Use a specification with unitQuantity or batchQuantity instead
 * @deprecated
 */
export interface AnkorstoreInternalFulfillableSpecification {
  /** @format uuid */
  fulfillableId: string;
  /** quantity in batches */
  quantity: number;
}

export interface AnkorstoreInternalFulfillableBatchesSpecificationByProductVariant {
  /** @format uuid */
  productVariantUuid: string;
  /** quantity in batches */
  batchQuantity: number;
}

export interface AnkorstoreInternalFulfillableUnitsSpecificationByProductVariant {
  /** @format uuid */
  productVariantUuid: string;
  /** quantity in units */
  unitQuantity: number;
}

export interface AnkorstoreInternalDeliverySchedule {
  /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
  timeSlots:
    | {
        /**
         * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
         * @example "09:30"
         */
        startTime: string;
        /**
         * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
         * @example "12:30"
         */
        endTime: string;
      }[]
    | null;
  /**
   * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
   * @minItems 1
   * @uniqueItems true
   * @example [1,2,3]
   */
  openDays: number[];
}

export interface AnkorstoreInternalPackingInstruction {
  /**
   * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
   * @minItems 1
   */
  services: AnkorstoreInternalPackingInstructionServicesEnum[];
  /** Instruction text for packing the order. */
  instruction?: string;
}

export interface AnkorstoreInternalDeliveryAppointment {
  /** Is an appointment requested? */
  requested: boolean;
  /** Instruction text for booking an appointment. */
  instruction: string;
}

export interface AnkorstoreInternalInstructions {
  externalReference?: string | null;
  /**
   * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
   * @default false
   */
  pickupAtDock?: boolean;
  deliverySchedule?: {
    /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
    timeSlots:
      | {
          /**
           * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "09:30"
           */
          startTime: string;
          /**
           * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "12:30"
           */
          endTime: string;
        }[]
      | null;
    /**
     * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
     * @minItems 1
     * @uniqueItems true
     * @example [1,2,3]
     */
    openDays: number[];
  } | null;
  packingInstruction?: {
    /**
     * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
     * @minItems 1
     */
    services: AnkorstoreInternalInstructionsServicesEnum[];
    /** Instruction text for packing the order. */
    instruction?: string;
  } | null;
  deliveryAppointment?: {
    /** Is an appointment requested? */
    requested: boolean;
    /** Instruction text for booking an appointment. */
    instruction: string;
  } | null;
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalRecipientType {
  Consumer = 'consumer',
  Business = 'business',
}

export interface AnkorstoreInternalFulfillmentOrderAttributes {
  reference?: string;
  /** Ankorstore order ID, or null for direct fulfillment order */
  orderId?: number | null;
  /**
   * Ankorstore master order uuid
   * @format uuid
   */
  masterOrderUuid: string;
  /** @format uuid */
  fulfillmentBrandId?: string;
  /** Is shipping fee charged for order, default to true */
  shippingCharged?: boolean;
  /** Shipping address for the recipient. Required for order creation */
  shippingAddress: {
    /** @minLength 1 */
    firstName?: string;
    /** @minLength 1 */
    lastName?: string;
    company?: string;
    /** @minLength 1 */
    phone?: string;
    email?: string;
    /** @minLength 1 */
    street?: string;
    /** @minLength 1 */
    city?: string;
    postalCode?: string;
    /** @pattern ^[A-Z]{2}$ */
    country?: string;
  };
  /** Optional billing address for the recipient */
  billingAddress?: {
    /** @minLength 1 */
    firstName?: string;
    /** @minLength 1 */
    lastName?: string;
    company?: string;
    /** @minLength 1 */
    phone?: string;
    email?: string;
    /** @minLength 1 */
    street?: string;
    /** @minLength 1 */
    city?: string;
    postalCode?: string;
    /** @pattern ^[A-Z]{2}$ */
    country?: string;
  } | null;
  items: (
    | {
        /** @format uuid */
        fulfillableId: string;
        /** quantity in batches */
        batchQuantity: number;
      }
    | {
        /** @format uuid */
        fulfillableId: string;
        /** quantity in units */
        unitQuantity: number;
      }
    | {
        /** @format uuid */
        fulfillableId: string;
        /** quantity in batches */
        quantity: number;
      }
    | {
        /** @format uuid */
        productVariantUuid: string;
        /** quantity in batches */
        batchQuantity: number;
      }
    | {
        /** @format uuid */
        productVariantUuid: string;
        /** quantity in units */
        unitQuantity: number;
      }
  )[];
  externalReference?: string | null;
  /**
   * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
   * @deprecated
   */
  instructionText?: string | null;
  instructions?: {
    externalReference?: string | null;
    /**
     * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
     * @default false
     */
    pickupAtDock?: boolean;
    deliverySchedule?: {
      /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
      timeSlots:
        | {
            /**
             * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "09:30"
             */
            startTime: string;
            /**
             * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "12:30"
             */
            endTime: string;
          }[]
        | null;
      /**
       * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
       * @minItems 1
       * @uniqueItems true
       * @example [1,2,3]
       */
      openDays: number[];
    } | null;
    packingInstruction?: {
      /**
       * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
       * @minItems 1
       */
      services: AnkorstoreInternalFulfillmentOrderAttributesServicesEnum[];
      /** Instruction text for packing the order. */
      instruction?: string;
    } | null;
    deliveryAppointment?: {
      /** Is an appointment requested? */
      requested: boolean;
      /** Instruction text for booking an appointment. */
      instruction: string;
    } | null;
  } | null;
  /**
   * The type of recipient for a fulfillment order
   * @default "business"
   */
  recipientType?: AnkorstoreInternalFulfillmentOrderAttributesRecipientTypeEnum;
}

/** JSON:API compliant request format */
export interface AnkorstoreInternalFulfillmentOrderJsonApiRequest {
  data: {
    type: AnkorstoreInternalFulfillmentOrderJsonApiRequestTypeEnum;
    /**
     * Optional client-specified fulfillment order ID. When provided, the server uses this UUID as the order identifier. If a FulfillmentOrder with this UUID already exists, the existing order is returned with a 200 status (idempotent).
     * @format uuid
     */
    id?: string;
    attributes: {
      reference?: string;
      /** Ankorstore order ID, or null for direct fulfillment order */
      orderId?: number | null;
      /**
       * Ankorstore master order uuid
       * @format uuid
       */
      masterOrderUuid: string;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /** Is shipping fee charged for order, default to true */
      shippingCharged?: boolean;
      /** Shipping address for the recipient. Required for order creation */
      shippingAddress: {
        /** @minLength 1 */
        firstName?: string;
        /** @minLength 1 */
        lastName?: string;
        company?: string;
        /** @minLength 1 */
        phone?: string;
        email?: string;
        /** @minLength 1 */
        street?: string;
        /** @minLength 1 */
        city?: string;
        postalCode?: string;
        /** @pattern ^[A-Z]{2}$ */
        country?: string;
      };
      /** Optional billing address for the recipient */
      billingAddress?: {
        /** @minLength 1 */
        firstName?: string;
        /** @minLength 1 */
        lastName?: string;
        company?: string;
        /** @minLength 1 */
        phone?: string;
        email?: string;
        /** @minLength 1 */
        street?: string;
        /** @minLength 1 */
        city?: string;
        postalCode?: string;
        /** @pattern ^[A-Z]{2}$ */
        country?: string;
      } | null;
      items: (
        | {
            /** @format uuid */
            fulfillableId: string;
            /** quantity in batches */
            batchQuantity: number;
          }
        | {
            /** @format uuid */
            fulfillableId: string;
            /** quantity in units */
            unitQuantity: number;
          }
        | {
            /** @format uuid */
            fulfillableId: string;
            /** quantity in batches */
            quantity: number;
          }
        | {
            /** @format uuid */
            productVariantUuid: string;
            /** quantity in batches */
            batchQuantity: number;
          }
        | {
            /** @format uuid */
            productVariantUuid: string;
            /** quantity in units */
            unitQuantity: number;
          }
      )[];
      externalReference?: string | null;
      /**
       * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
       * @deprecated
       */
      instructionText?: string | null;
      instructions?: {
        externalReference?: string | null;
        /**
         * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
         * @default false
         */
        pickupAtDock?: boolean;
        deliverySchedule?: {
          /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
          timeSlots:
            | {
                /**
                 * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "09:30"
                 */
                startTime: string;
                /**
                 * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "12:30"
                 */
                endTime: string;
              }[]
            | null;
          /**
           * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
           * @minItems 1
           * @uniqueItems true
           * @example [1,2,3]
           */
          openDays: number[];
        } | null;
        packingInstruction?: {
          /**
           * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
           * @minItems 1
           */
          services: AnkorstoreInternalFulfillmentOrderJsonApiRequestServicesEnum[];
          /** Instruction text for packing the order. */
          instruction?: string;
        } | null;
        deliveryAppointment?: {
          /** Is an appointment requested? */
          requested: boolean;
          /** Instruction text for booking an appointment. */
          instruction: string;
        } | null;
      } | null;
      /**
       * The type of recipient for a fulfillment order
       * @default "business"
       */
      recipientType?: AnkorstoreInternalFulfillmentOrderJsonApiRequestRecipientTypeEnum;
    };
  };
}

/**
 * Legacy flat request format. Use JSON:API format instead.
 * @deprecated
 */
export type AnkorstoreInternalFulfillmentOrderFlatRequest = {
  reference?: string;
  /** Ankorstore order ID, or null for direct fulfillment order */
  orderId?: number | null;
  /**
   * Ankorstore master order uuid
   * @format uuid
   */
  masterOrderUuid: string;
  /** @format uuid */
  fulfillmentBrandId?: string;
  /** Is shipping fee charged for order, default to true */
  shippingCharged?: boolean;
  /** Shipping address for the recipient. Required for order creation */
  shippingAddress: {
    /** @minLength 1 */
    firstName?: string;
    /** @minLength 1 */
    lastName?: string;
    company?: string;
    /** @minLength 1 */
    phone?: string;
    email?: string;
    /** @minLength 1 */
    street?: string;
    /** @minLength 1 */
    city?: string;
    postalCode?: string;
    /** @pattern ^[A-Z]{2}$ */
    country?: string;
  };
  /** Optional billing address for the recipient */
  billingAddress?: {
    /** @minLength 1 */
    firstName?: string;
    /** @minLength 1 */
    lastName?: string;
    company?: string;
    /** @minLength 1 */
    phone?: string;
    email?: string;
    /** @minLength 1 */
    street?: string;
    /** @minLength 1 */
    city?: string;
    postalCode?: string;
    /** @pattern ^[A-Z]{2}$ */
    country?: string;
  } | null;
  items: (
    | {
        /** @format uuid */
        fulfillableId: string;
        /** quantity in batches */
        batchQuantity: number;
      }
    | {
        /** @format uuid */
        fulfillableId: string;
        /** quantity in units */
        unitQuantity: number;
      }
    | {
        /** @format uuid */
        fulfillableId: string;
        /** quantity in batches */
        quantity: number;
      }
    | {
        /** @format uuid */
        productVariantUuid: string;
        /** quantity in batches */
        batchQuantity: number;
      }
    | {
        /** @format uuid */
        productVariantUuid: string;
        /** quantity in units */
        unitQuantity: number;
      }
  )[];
  externalReference?: string | null;
  /**
   * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
   * @deprecated
   */
  instructionText?: string | null;
  instructions?: {
    externalReference?: string | null;
    /**
     * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
     * @default false
     */
    pickupAtDock?: boolean;
    deliverySchedule?: {
      /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
      timeSlots:
        | {
            /**
             * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "09:30"
             */
            startTime: string;
            /**
             * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "12:30"
             */
            endTime: string;
          }[]
        | null;
      /**
       * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
       * @minItems 1
       * @uniqueItems true
       * @example [1,2,3]
       */
      openDays: number[];
    } | null;
    packingInstruction?: {
      /**
       * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
       * @minItems 1
       */
      services: AnkorstoreInternalFulfillmentOrderFlatRequestServicesEnum[];
      /** Instruction text for packing the order. */
      instruction?: string;
    } | null;
    deliveryAppointment?: {
      /** Is an appointment requested? */
      requested: boolean;
      /** Instruction text for booking an appointment. */
      instruction: string;
    } | null;
  } | null;
  /**
   * The type of recipient for a fulfillment order
   * @default "business"
   */
  recipientType?: AnkorstoreInternalFulfillmentOrderFlatRequestRecipientTypeEnum;
};

/** JSON:API compliant request format */
export type AnkorstoreInternalFulfillmentOrderRequest =
  | {
      data: {
        type: AnkorstoreInternalFulfillmentOrderRequestTypeEnum;
        /**
         * Optional client-specified fulfillment order ID. When provided, the server uses this UUID as the order identifier. If a FulfillmentOrder with this UUID already exists, the existing order is returned with a 200 status (idempotent).
         * @format uuid
         */
        id?: string;
        attributes: {
          reference?: string;
          /** Ankorstore order ID, or null for direct fulfillment order */
          orderId?: number | null;
          /**
           * Ankorstore master order uuid
           * @format uuid
           */
          masterOrderUuid: string;
          /** @format uuid */
          fulfillmentBrandId?: string;
          /** Is shipping fee charged for order, default to true */
          shippingCharged?: boolean;
          /** Shipping address for the recipient. Required for order creation */
          shippingAddress: {
            /** @minLength 1 */
            firstName?: string;
            /** @minLength 1 */
            lastName?: string;
            company?: string;
            /** @minLength 1 */
            phone?: string;
            email?: string;
            /** @minLength 1 */
            street?: string;
            /** @minLength 1 */
            city?: string;
            postalCode?: string;
            /** @pattern ^[A-Z]{2}$ */
            country?: string;
          };
          /** Optional billing address for the recipient */
          billingAddress?: {
            /** @minLength 1 */
            firstName?: string;
            /** @minLength 1 */
            lastName?: string;
            company?: string;
            /** @minLength 1 */
            phone?: string;
            email?: string;
            /** @minLength 1 */
            street?: string;
            /** @minLength 1 */
            city?: string;
            postalCode?: string;
            /** @pattern ^[A-Z]{2}$ */
            country?: string;
          } | null;
          items: (
            | {
                /** @format uuid */
                fulfillableId: string;
                /** quantity in batches */
                batchQuantity: number;
              }
            | {
                /** @format uuid */
                fulfillableId: string;
                /** quantity in units */
                unitQuantity: number;
              }
            | {
                /** @format uuid */
                fulfillableId: string;
                /** quantity in batches */
                quantity: number;
              }
            | {
                /** @format uuid */
                productVariantUuid: string;
                /** quantity in batches */
                batchQuantity: number;
              }
            | {
                /** @format uuid */
                productVariantUuid: string;
                /** quantity in units */
                unitQuantity: number;
              }
          )[];
          externalReference?: string | null;
          /**
           * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
           * @deprecated
           */
          instructionText?: string | null;
          instructions?: {
            externalReference?: string | null;
            /**
             * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
             * @default false
             */
            pickupAtDock?: boolean;
            deliverySchedule?: {
              /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
              timeSlots:
                | {
                    /**
                     * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "09:30"
                     */
                    startTime: string;
                    /**
                     * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "12:30"
                     */
                    endTime: string;
                  }[]
                | null;
              /**
               * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
               * @minItems 1
               * @uniqueItems true
               * @example [1,2,3]
               */
              openDays: number[];
            } | null;
            packingInstruction?: {
              /**
               * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
               * @minItems 1
               */
              services: AnkorstoreInternalFulfillmentOrderRequestServicesEnum[];
              /** Instruction text for packing the order. */
              instruction?: string;
            } | null;
            deliveryAppointment?: {
              /** Is an appointment requested? */
              requested: boolean;
              /** Instruction text for booking an appointment. */
              instruction: string;
            } | null;
          } | null;
          /**
           * The type of recipient for a fulfillment order
           * @default "business"
           */
          recipientType?: AnkorstoreInternalFulfillmentOrderRequestRecipientTypeEnum;
        };
      };
    }
  | {
      reference?: string;
      /** Ankorstore order ID, or null for direct fulfillment order */
      orderId?: number | null;
      /**
       * Ankorstore master order uuid
       * @format uuid
       */
      masterOrderUuid: string;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /** Is shipping fee charged for order, default to true */
      shippingCharged?: boolean;
      /** Shipping address for the recipient. Required for order creation */
      shippingAddress: {
        /** @minLength 1 */
        firstName?: string;
        /** @minLength 1 */
        lastName?: string;
        company?: string;
        /** @minLength 1 */
        phone?: string;
        email?: string;
        /** @minLength 1 */
        street?: string;
        /** @minLength 1 */
        city?: string;
        postalCode?: string;
        /** @pattern ^[A-Z]{2}$ */
        country?: string;
      };
      /** Optional billing address for the recipient */
      billingAddress?: {
        /** @minLength 1 */
        firstName?: string;
        /** @minLength 1 */
        lastName?: string;
        company?: string;
        /** @minLength 1 */
        phone?: string;
        email?: string;
        /** @minLength 1 */
        street?: string;
        /** @minLength 1 */
        city?: string;
        postalCode?: string;
        /** @pattern ^[A-Z]{2}$ */
        country?: string;
      } | null;
      items: (
        | {
            /** @format uuid */
            fulfillableId: string;
            /** quantity in batches */
            batchQuantity: number;
          }
        | {
            /** @format uuid */
            fulfillableId: string;
            /** quantity in units */
            unitQuantity: number;
          }
        | {
            /** @format uuid */
            fulfillableId: string;
            /** quantity in batches */
            quantity: number;
          }
        | {
            /** @format uuid */
            productVariantUuid: string;
            /** quantity in batches */
            batchQuantity: number;
          }
        | {
            /** @format uuid */
            productVariantUuid: string;
            /** quantity in units */
            unitQuantity: number;
          }
      )[];
      externalReference?: string | null;
      /**
       * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
       * @deprecated
       */
      instructionText?: string | null;
      instructions?: {
        externalReference?: string | null;
        /**
         * Indicates whether the shipment should be picked up at the dock. Defaults to false if not provided.
         * @default false
         */
        pickupAtDock?: boolean;
        deliverySchedule?: {
          /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
          timeSlots:
            | {
                /**
                 * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "09:30"
                 */
                startTime: string;
                /**
                 * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "12:30"
                 */
                endTime: string;
              }[]
            | null;
          /**
           * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
           * @minItems 1
           * @uniqueItems true
           * @example [1,2,3]
           */
          openDays: number[];
        } | null;
        packingInstruction?: {
          /**
           * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
           * @minItems 1
           */
          services: AnkorstoreInternalFulfillmentOrderRequestServicesEnum1[];
          /** Instruction text for packing the order. */
          instruction?: string;
        } | null;
        deliveryAppointment?: {
          /** Is an appointment requested? */
          requested: boolean;
          /** Instruction text for booking an appointment. */
          instruction: string;
        } | null;
      } | null;
      /**
       * The type of recipient for a fulfillment order
       * @default "business"
       */
      recipientType?: AnkorstoreInternalFulfillmentOrderRequestRecipientTypeEnum1;
    };

export enum AnkorstoreInternalFulfillmentOrderStatus {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

export interface AnkorstoreInternalFulfillmentOrderItem {
  /** @format uuid */
  fulfillmentItemId: string;
  /** quantity in batches */
  quantity: number;
}

export interface AnkorstoreInternalFulfillmentOrder {
  /**
   * Unique human readable reference for the fulfillment order, used for communication with the warehouse
   * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
   */
  reference?: string;
  /** @format uuid */
  masterOrderUuid: string;
  /** @format uuid */
  fulfillmentBrandId?: string;
  /**
   * [Deprecated] This concept no longer exists. Please refer to the related master order if you need to distinguish between internal and external orders
   * @deprecated
   */
  isDirect?: boolean;
  /** Is shipping fee charged for order, default to true */
  shippingCharged?: boolean;
  status?: AnkorstoreInternalFulfillmentOrderStatusEnum;
  /** @format date-time */
  createdAt?: string;
  /** Shipping address for the recipient. Required for order creation */
  shippingAddress?: {
    /** @minLength 1 */
    firstName?: string;
    /** @minLength 1 */
    lastName?: string;
    company?: string;
    /** @minLength 1 */
    phone?: string;
    email?: string;
    /** @minLength 1 */
    street?: string;
    /** @minLength 1 */
    city?: string;
    postalCode?: string;
    /** @pattern ^[A-Z]{2}$ */
    country?: string;
  } | null;
  /** Optional billing address for the recipient */
  billingAddress?: {
    /** @minLength 1 */
    firstName?: string;
    /** @minLength 1 */
    lastName?: string;
    company?: string;
    /** @minLength 1 */
    phone?: string;
    email?: string;
    /** @minLength 1 */
    street?: string;
    /** @minLength 1 */
    city?: string;
    postalCode?: string;
    /** @pattern ^[A-Z]{2}$ */
    country?: string;
  } | null;
  items: {
    /** @format uuid */
    fulfillmentItemId: string;
    /** quantity in batches */
    quantity: number;
  }[];
  /**
   * The type of recipient for a fulfillment order
   * @default "business"
   */
  recipientType?: AnkorstoreInternalFulfillmentOrderRecipientTypeEnum;
}

export interface AnkorstoreInternalFulfillmentOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Unique human readable reference for the fulfillment order, used for communication with the warehouse
     * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
     */
    reference?: string;
    /** @format uuid */
    masterOrderUuid: string;
    /** @format uuid */
    fulfillmentBrandId?: string;
    /**
     * [Deprecated] This concept no longer exists. Please refer to the related master order if you need to distinguish between internal and external orders
     * @deprecated
     */
    isDirect?: boolean;
    /** Is shipping fee charged for order, default to true */
    shippingCharged?: boolean;
    status?: AnkorstoreInternalFulfillmentOrderResourceStatusEnum;
    /** @format date-time */
    createdAt?: string;
    /** Shipping address for the recipient. Required for order creation */
    shippingAddress?: {
      /** @minLength 1 */
      firstName?: string;
      /** @minLength 1 */
      lastName?: string;
      company?: string;
      /** @minLength 1 */
      phone?: string;
      email?: string;
      /** @minLength 1 */
      street?: string;
      /** @minLength 1 */
      city?: string;
      postalCode?: string;
      /** @pattern ^[A-Z]{2}$ */
      country?: string;
    } | null;
    /** Optional billing address for the recipient */
    billingAddress?: {
      /** @minLength 1 */
      firstName?: string;
      /** @minLength 1 */
      lastName?: string;
      company?: string;
      /** @minLength 1 */
      phone?: string;
      email?: string;
      /** @minLength 1 */
      street?: string;
      /** @minLength 1 */
      city?: string;
      postalCode?: string;
      /** @pattern ^[A-Z]{2}$ */
      country?: string;
    } | null;
    items: {
      /** @format uuid */
      fulfillmentItemId: string;
      /** quantity in batches */
      quantity: number;
    }[];
    /**
     * The type of recipient for a fulfillment order
     * @default "business"
     */
    recipientType?: AnkorstoreInternalFulfillmentOrderResourceRecipientTypeEnum;
  };
  links?: {
    order?: string;
  };
  relationships?: {
    statusUpdates?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    shipments?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/** Shipment tracking info. Will be null until this information is available */
export interface AnkorstoreInternalFulfillmentShipment {
  trackingNumber?: string;
  trackingLink?: string | null;
  /** Shipping provider identifier */
  provider?: string;
  /** Shipping provider display name */
  providerName?: string;
  /** Parcel or pallet width (in MM) */
  width?: number;
  /** Parcel or pallet length (in MM) */
  length?: number;
  /** Parcel or pallet height (in MM) */
  height?: number;
  /** Parcel or pallet weight (in GR) */
  weight?: number;
  /** @format date-time */
  createdAt?: string;
}

export interface AnkorstoreInternalFulfillmentShipmentResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  /** Shipment tracking info. Will be null until this information is available */
  attributes?: {
    trackingNumber?: string;
    trackingLink?: string | null;
    /** Shipping provider identifier */
    provider?: string;
    /** Shipping provider display name */
    providerName?: string;
    /** Parcel or pallet width (in MM) */
    width?: number;
    /** Parcel or pallet length (in MM) */
    length?: number;
    /** Parcel or pallet height (in MM) */
    height?: number;
    /** Parcel or pallet weight (in GR) */
    weight?: number;
    /** @format date-time */
    createdAt?: string;
  };
}

/** Fulfillment order status update */
export interface AnkorstoreInternalFulfillmentOrderStatusUpdate {
  status?: AnkorstoreInternalFulfillmentOrderStatusUpdateStatusEnum;
  /** @format date-time */
  receivedAt?: string;
}

export interface AnkorstoreInternalFulfillmentOrderStatusUpdateResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  /** Fulfillment order status update */
  attributes?: {
    status?: AnkorstoreInternalFulfillmentOrderStatusUpdateResourceStatusEnum;
    /** @format date-time */
    receivedAt?: string;
  };
}

/** FulfillmentItem */
export interface AnkorstoreInternalWarehouse {
  code: string;
  name: string;
  addresseLine1?: string;
  addresseLine2?: string;
  postalCode: string;
  city: string;
  /** @pattern ^[A-Z]{2}$ */
  countryCode: string;
  email: string;
  phone: string;
  /** @format uuid */
  astralLocationId: string | null;
}

export interface AnkorstoreInternalWarehouseResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** FulfillmentItem */
  attributes: {
    code: string;
    name: string;
    addresseLine1?: string;
    addresseLine2?: string;
    postalCode: string;
    city: string;
    /** @pattern ^[A-Z]{2}$ */
    countryCode: string;
    email: string;
    phone: string;
    /** @format uuid */
    astralLocationId: string | null;
  };
}

export enum AnkorstoreInternalBillingCategory {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum AnkorstoreInternalParcelCarrier {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum AnkorstoreInternalPalletCarrier {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export interface AnkorstoreInternalFulfillmentBrand {
  /** @format uuid */
  warehouseId: string;
  billingCategory: AnkorstoreInternalFulfillmentBrandBillingCategoryEnum;
  reference: string;
  parcelCarrier?: AnkorstoreInternalFulfillmentBrandParcelCarrierEnum;
  palletCarrier?: AnkorstoreInternalFulfillmentBrandPalletCarrierEnum;
  maxParcelShipmentWeight?: number | null;
}

export interface AnkorstoreInternalFulfillmentBrandResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format uuid */
    warehouseId: string;
    billingCategory: AnkorstoreInternalFulfillmentBrandResourceBillingCategoryEnum;
    reference: string;
    parcelCarrier?: AnkorstoreInternalFulfillmentBrandResourceParcelCarrierEnum;
    palletCarrier?: AnkorstoreInternalFulfillmentBrandResourcePalletCarrierEnum;
    maxParcelShipmentWeight?: number | null;
  };
  relationships?: {
    warehouse?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

export interface AnkorstoreInternalFulfillmentBrandStoreRequest {
  /** Ankorstore brand ID */
  brandId: number;
  brandName: string;
  /** @format uuid */
  warehouseId?: string;
  billingCategory?: AnkorstoreInternalFulfillmentBrandStoreRequestBillingCategoryEnum;
  parcelCarrier?: AnkorstoreInternalFulfillmentBrandStoreRequestParcelCarrierEnum;
  palletCarrier?: AnkorstoreInternalFulfillmentBrandStoreRequestPalletCarrierEnum;
  maxParcelShipmentWeight?: number | null;
}

export interface AnkorstoreInternalExternalIntegration {
  platform: AnkorstoreInternalExternalIntegrationPlatformEnum;
  status: AnkorstoreInternalExternalIntegrationStatusEnum;
}

export interface AnkorstoreInternalExternalIntegrationResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    platform: AnkorstoreInternalExternalIntegrationResourcePlatformEnum;
    status: AnkorstoreInternalExternalIntegrationResourceStatusEnum;
  };
}

export enum AnkorstoreInternalOrderPayAccountStatus {
  Active = 'active',
  Trialling = 'trialling',
  Churned = 'churned',
}

export enum AnkorstoreInternalOrderPaySubscriptionStatus {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

export interface AnkorstoreInternalDuration {
  /**
   * Amount of time.
   * @min 0
   */
  amount?: number;
  /** Unit of time. */
  unit?: AnkorstoreInternalDurationUnitEnum;
}

/** OrderPayAccountResource */
export interface AnkorstoreInternalOrderPayAccountResource {
  type: 'order-pay-account';
  /**
   * A globally-unique identifier for the account.
   * @format uuid
   * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
   */
  id?: string;
  attributes?: {
    status?: AnkorstoreInternalOrderPayAccountResourceStatusEnum;
    /**
     * Date when the account was created.
     * @format date-time
     */
    createdAt?: string;
    /** The user's acceptance of the terms and conditions. */
    termsAcceptance?: {
      /**
       * The version of the terms and conditions. Defaults to the latest version.
       * @example "2025.04"
       */
      termsVersion?: string;
      /**
       * Date when the user accepted the terms and conditions.
       * @format date-time
       */
      acceptedAt?: string;
    } | null;
    subscription?: {
      /** The current status of the subscription. */
      status?: AnkorstoreInternalOrderPayAccountResourceStatusEnum1;
      /**
       * Date when the subscription started or `null` if it hasn't started yet.
       * @format date-time
       */
      startedAt?: null | string;
      /**
       * Date when the subscription has ended or `null` if it's active.
       * @format date-time
       */
      expiresAt?: null | string;
      /** The recurring frequency with which the subscription is charged. */
      billingCycle?: {
        /**
         * Amount of time.
         * @min 0
         */
        amount?: number;
        /** Unit of time. */
        unit?: AnkorstoreInternalOrderPayAccountResourceUnitEnum;
      };
      /** The trial period or `null` if there is no trial for this subscription. */
      trialPeriod?: {
        /** The duration of the trial period if any. */
        duration?: {
          /**
           * Amount of time.
           * @min 0
           */
          amount?: number;
          /** Unit of time. */
          unit?: AnkorstoreInternalOrderPayAccountResourceUnitEnum1;
        };
        /**
         * Date when the trial period has started.
         * @format date-time
         */
        startedAt?: null | string;
        /**
         * Date when the trial period has expired.
         * @format date-time
         */
        expiresAt?: null | string;
      };
    };
  };
}

/** UpdateOrderPayAccountResource */
export interface AnkorstoreInternalUpdateOrderPayAccountResource {
  type: 'order-pay-account';
  /**
   * A globally-unique identifier for the account.
   * @format uuid
   * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
   */
  id?: string;
  attributes?: {
    /** Subscription information for the account (read-only). */
    subscription?: {
      /** The status expected for the subscription. */
      status?: AnkorstoreInternalUpdateOrderPayAccountResourceStatusEnum;
    };
  };
}

/**
 * PaymentResource
 * The resource of a payment object
 */
export interface AnkorstoreInternalPaymentResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * External order uuid
     * @format uuid
     */
    orderUuid: string;
    /**
     * OrderPay customer uuid (external)
     * @format uuid
     */
    customerUuid: string;
    /**
     * Brand uuid
     * @format uuid
     */
    brandUuid: string;
    /**
     * Creation date of the payment
     * @format date-time
     */
    createdAt: string;
    /** The payment service provider selected for the payment */
    psp: AnkorstoreInternalPaymentResourcePspEnum;
    /** Status of the payment */
    status: AnkorstoreInternalPaymentResourceStatusEnum;
    amount: number;
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** @format float */
    currencyRate: number;
    /** The payment method selected for the payment */
    paymentMethod: AnkorstoreInternalPaymentResourcePaymentMethodEnum;
    fundedBy?: string | null;
    paymentTerms?: string | null;
  };
  relationships?: {
    transactions?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/**
 * TransactionResource
 * The resource of a transaction object
 */
export interface AnkorstoreInternalTransactionResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Creation date of the transaction
     * @format date-time
     */
    createdAt: string;
    /** The payment service provider transaction id */
    pspId: string;
    amount: number;
    currency: string;
    type: string;
    status: string;
    pspData?: {
      client_secret?: string;
      iban?: {
        bic?: string;
        iban?: string;
        country?: string;
        reference?: string;
      };
    };
  };
}

/** OrderResource */
export interface AnkorstoreInternalOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  relationships?: any;
  attributes?: {
    brand: {
      /**
       * @format uuid
       * @example "1ef2e44a-b396-6b56-80d5-c66dfcccaea9"
       */
      brandUuid: string;
      /**
       * Brand name.
       * @example "Chevalier"
       */
      name: string;
      /**
       * Brand rounded logo image path.
       * @example "/brands/rounded/rounded.jpg"
       */
      imageRoundedPath: string;
    };
    /**
     * @format date-time
     * @example "2024-07-01T13:00:50.000000Z"
     */
    createdAt: string;
    /**
     * @format uuid
     * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
     */
    customerUuid: string;
    /** @example 20 */
    discountRate: number;
    /** List of items with their corresponding quantities and unit amounts. */
    items: {
      /**
       * Product variant UUID.
       * @format uuid
       * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
       */
      productVariantUuid: string;
      /**
       * Product variant name.
       * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
       */
      productVariantName: string;
      /**
       * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
       * @example 7
       */
      quantity: number;
      /**
       * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
       * @example 7
       */
      multipliedQuantity: number;
      /** Total amounts of the order item. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 1700 */
        brandUnitPriceBeforeDiscount: number;
        /** @example "€17.00" */
        brandUnitPriceBeforeDiscountFormatted: string;
        /** @example 1360 */
        brandUnitPrice: number;
        /** @example "€13.60" */
        brandUnitPriceFormatted: string;
        /** @example 11900 */
        brandAmountBeforeDiscount: number;
        /** @example "€119.00" */
        brandAmountBeforeDiscountFormatted: string;
        /** @example 2380 */
        brandDiscountAmount: number;
        /** @example "€23.80" */
        brandDiscountAmountFormatted: string;
        /** @example 9520 */
        brandAmount: number;
        /** @example "€95.20" */
        brandAmountFormatted: string;
        /** @example 1809 */
        brandAmountVat: number;
        /** @example "€18.09" */
        brandAmountVatFormatted: string;
        /** @example 11329 */
        brandAmountWithVat: number;
        /** @example "€113.29" */
        brandAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 1700 */
        customerUnitPriceBeforeDiscount: number;
        /** @example "€17.00" */
        customerUnitPriceBeforeDiscountFormatted: string;
        /** @example 1360 */
        customerUnitPrice: number;
        /** @example "€13.60" */
        customerUnitPriceFormatted: string;
        /** @example 11900 */
        customerAmountBeforeDiscount: number;
        /** @example "€119.00" */
        customerAmountBeforeDiscountFormatted: string;
        /** @example 2380 */
        customerDiscountAmount: number;
        /** @example "€23.80" */
        customerDiscountAmountFormatted: string;
        /** @example 9520 */
        customerAmount: number;
        /** @example "€95.20" */
        customerAmountFormatted: string;
        /** @example 1809 */
        customerAmountVat: number;
        /** @example "€18.09" */
        customerAmountVatFormatted: string;
        /** @example 11329 */
        customerAmountWithVat: number;
        /** @example "€113.29" */
        customerAmountWithVatFormatted: string;
        /** @example 19 */
        vatRate: number;
        /** @example 20 */
        discountRate: number;
        /** @example 100 */
        discountAmount: number;
        /** @example "€1.00" */
        discountAmountFormatted: string;
      };
    }[];
    status?: AnkorstoreInternalOrderResourceStatusEnum;
    /** @example "EACN9214515" */
    masterOrderReference?: string | null;
    /** Total amounts of the order. */
    amounts: {
      /** @example "EUR" */
      brandCurrency: string;
      /** @example 1 */
      brandCurrencyRate: number;
      /** @example 54620 */
      brandTotalAmountBeforeDiscount: number;
      /** @example "€546.20" */
      brandTotalAmountBeforeDiscountFormatted: string;
      /** @example 0 */
      brandTotalDiscountAmount: number;
      /** @example "€0.00" */
      brandTotalDiscountAmountFormatted: string;
      /** @example 54620 */
      brandTotalAmount: number;
      /** @example "€546.20" */
      brandTotalAmountFormatted: string;
      /** @example 12633 */
      brandTotalAmountVat: number;
      /** @example "€126.33" */
      brandTotalAmountVatFormatted: string;
      /** @example 67253 */
      brandTotalAmountWithVat: number;
      /** @example "€672.53" */
      brandTotalAmountWithVatFormatted: string;
      /** @example "EUR" */
      customerCurrency: string;
      /** @example 1 */
      customerCurrencyRate: number;
      /** @example 54620 */
      customerTotalAmountBeforeDiscount: number;
      /** @example "€546.20" */
      customerTotalAmountBeforeDiscountFormatted: string;
      /** @example 54620 */
      customerTotalDiscountAmount: number;
      /** @example "€0.00" */
      customerTotalDiscountAmountFormatted: string;
      /** @example 54620 */
      customerTotalAmount: number;
      /** @example "€546.20" */
      customerTotalAmountFormatted: string;
      /** @example 12633 */
      customerTotalAmountVat: number;
      /** @example "€126.33" */
      customerTotalAmountVatFormatted: string;
      /** @example 67253 */
      customerTotalAmountWithVat: number;
      /** @example "€672.53" */
      customerTotalAmountWithVatFormatted: string;
      /** @example 220 */
      shippingFeesAmount: number;
      /** @example "€2.20" */
      shippingFeesAmountFormatted: string;
      /** @example 44 */
      shippingFeesAmountVat: number;
      /** @example "€0.44" */
      shippingFeesAmountVatFormatted: string;
      /** @example 264 */
      shippingFeesAmountWithVat: number;
      /** @example "€2.64" */
      shippingFeesAmountWithVatFormatted: string;
      /** @example 54840 */
      customerGrandTotalAmount: number;
      /** @example "€548.40" */
      customerGrandTotalAmountFormatted: string;
      /** @example 12677 */
      customerGrandTotalAmountVat: number;
      /** @example "€126.77" */
      customerGrandTotalAmountVatFormatted: string;
      /** @example 67517 */
      customerGrandTotalAmountWithVat: number;
      /** @example "€675.17" */
      customerGrandTotalAmountWithVatFormatted: string;
    };
    shipping: {
      /** @example "fulfillment" */
      shippingMethod: string;
      shippingAddress: {
        /** @example "FR" */
        countryCode: string;
        /** @example "92100" */
        postalCode: string;
        /** @example "Boulogne-Billancourt" */
        city: string;
        /** @example "105, rue de Sevres" */
        street: string;
        addressLine?: string | null;
      };
      contactPerson: {
        /** @example "etienne.guillou@roy.com" */
        email: string;
        /** @example "Etienne" */
        firstName: string;
        /** @example "Guillou" */
        lastName: string;
        company?: string | null;
        phoneNumber?: string | null;
      };
    };
    tracking?: {
      /** @example "1Z999AA10123456784" */
      trackingNumber: string;
      /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
      trackingLink?: string;
      /** @example "shipped" */
      status: string;
      /** @example false */
      isDelivered: boolean;
    };
  };
}

/** OrderSchema */
export interface AnkorstoreInternalOrderSchema {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      brand: {
        /**
         * @format uuid
         * @example "1ef2e44a-b396-6b56-80d5-c66dfcccaea9"
         */
        brandUuid: string;
        /**
         * Brand name.
         * @example "Chevalier"
         */
        name: string;
        /**
         * Brand rounded logo image path.
         * @example "/brands/rounded/rounded.jpg"
         */
        imageRoundedPath: string;
      };
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      status?: AnkorstoreInternalOrderSchemaStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: string;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: AnkorstoreInternalOrderSchemaPspEnum;
          /** Status of the payment */
          status: AnkorstoreInternalOrderSchemaStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: AnkorstoreInternalOrderSchemaPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

export interface AnkorstoreInternalSchemasPackingInstruction {
  /**
   * List of packing instruction services
   * @minItems 1
   */
  services: AnkorstoreInternalSchemasPackingInstructionServicesEnum[];
  /**
   * Additional packing instruction (can be empty)
   * @example "Instruction text"
   */
  instruction: string;
}

export interface AnkorstoreInternalSchemasDeliveryAppointment {
  /**
   * Whether a delivery appointment is requested for this customer.
   * @example true
   */
  requested: boolean;
  /**
   * Additional instruction for the delivery appointment (can be empty)
   * @maxLength 1000
   * @example "Please call before delivery"
   */
  instruction: string;
}

export interface AnkorstoreInternalExternalCustomer {
  firstName: string;
  lastName: string;
  street: string;
  additionalAddress: null | string;
  postalCode: string;
  city: string;
  countryCode: string;
  businessName: null | string;
  email: string;
  phoneNumber: string;
  type?: AnkorstoreInternalExternalCustomerTypeEnum;
  deliverySchedule?: {
    /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
    timeSlots:
      | {
          /**
           * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "09:30"
           */
          startTime: string;
          /**
           * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "12:30"
           */
          endTime: string;
        }[]
      | null;
    /**
     * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
     * @minItems 1
     * @uniqueItems true
     * @example [1,2,3]
     */
    openDays: number[];
  } | null;
  packingInstruction?: {
    /**
     * List of packing instruction services
     * @minItems 1
     */
    services: AnkorstoreInternalExternalCustomerServicesEnum[];
    /**
     * Additional packing instruction (can be empty)
     * @example "Instruction text"
     */
    instruction: string;
  } | null;
  deliveryAppointment?: {
    /**
     * Whether a delivery appointment is requested for this customer.
     * @example true
     */
    requested: boolean;
    /**
     * Additional instruction for the delivery appointment (can be empty)
     * @maxLength 1000
     * @example "Please call before delivery"
     */
    instruction: string;
  } | null;
  /** Whether the customer receives deliveries directly at the loading dock. */
  pickupAtDock: boolean;
}

export interface AnkorstoreInternalExternalCustomerResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    firstName: string;
    lastName: string;
    street: string;
    additionalAddress: null | string;
    postalCode: string;
    city: string;
    countryCode: string;
    businessName: null | string;
    email: string;
    phoneNumber: string;
    type?: AnkorstoreInternalExternalCustomerResourceTypeEnum;
    deliverySchedule?: {
      /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
      timeSlots:
        | {
            /**
             * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "09:30"
             */
            startTime: string;
            /**
             * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "12:30"
             */
            endTime: string;
          }[]
        | null;
      /**
       * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
       * @minItems 1
       * @uniqueItems true
       * @example [1,2,3]
       */
      openDays: number[];
    } | null;
    packingInstruction?: {
      /**
       * List of packing instruction services
       * @minItems 1
       */
      services: AnkorstoreInternalExternalCustomerResourceServicesEnum[];
      /**
       * Additional packing instruction (can be empty)
       * @example "Instruction text"
       */
      instruction: string;
    } | null;
    deliveryAppointment?: {
      /**
       * Whether a delivery appointment is requested for this customer.
       * @example true
       */
      requested: boolean;
      /**
       * Additional instruction for the delivery appointment (can be empty)
       * @maxLength 1000
       * @example "Please call before delivery"
       */
      instruction: string;
    } | null;
    /** Whether the customer receives deliveries directly at the loading dock. */
    pickupAtDock: boolean;
  };
}

export interface AnkorstoreInternalCreateExternalCustomerRequest {
  firstName: string;
  lastName: string;
  street: string;
  additionalAddress?: string;
  postalCode: string;
  city: string;
  countryCode: string;
  businessName?: string;
  email: string;
  phoneNumber: string;
  type?: AnkorstoreInternalCreateExternalCustomerRequestTypeEnum;
  deliverySchedule?: {
    /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
    timeSlots:
      | {
          /**
           * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "09:30"
           */
          startTime: string;
          /**
           * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "12:30"
           */
          endTime: string;
        }[]
      | null;
    /**
     * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
     * @minItems 1
     * @uniqueItems true
     * @example [1,2,3]
     */
    openDays: number[];
  } | null;
  packingInstruction?: {
    /**
     * List of packing instruction services
     * @minItems 1
     */
    services: AnkorstoreInternalCreateExternalCustomerRequestServicesEnum[];
    /**
     * Additional packing instruction (can be empty)
     * @example "Instruction text"
     */
    instruction: string;
  } | null;
  deliveryAppointment?: {
    /**
     * Whether a delivery appointment is requested for this customer.
     * @example true
     */
    requested: boolean;
    /**
     * Additional instruction for the delivery appointment (can be empty)
     * @maxLength 1000
     * @example "Please call before delivery"
     */
    instruction: string;
  } | null;
  /** Whether the customer receives deliveries directly at the loading dock. */
  pickupAtDock?: boolean;
}

export interface AnkorstoreInternalUpdateExternalCustomerRequest {
  firstName?: string;
  lastName?: string;
  street?: string;
  additionalAddress?: string;
  postalCode?: string;
  city?: string;
  countryCode?: string;
  businessName?: string;
  email?: string;
  phoneNumber?: string;
  type?: AnkorstoreInternalUpdateExternalCustomerRequestTypeEnum;
  deliverySchedule?: {
    /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
    timeSlots:
      | {
          /**
           * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "09:30"
           */
          startTime: string;
          /**
           * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "12:30"
           */
          endTime: string;
        }[]
      | null;
    /**
     * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
     * @minItems 1
     * @uniqueItems true
     * @example [1,2,3]
     */
    openDays: number[];
  } | null;
  packingInstruction?: {
    /**
     * List of packing instruction services
     * @minItems 1
     */
    services: AnkorstoreInternalUpdateExternalCustomerRequestServicesEnum[];
    /**
     * Additional packing instruction (can be empty)
     * @example "Instruction text"
     */
    instruction: string;
  } | null;
  deliveryAppointment?: {
    /**
     * Whether a delivery appointment is requested for this customer.
     * @example true
     */
    requested: boolean;
    /**
     * Additional instruction for the delivery appointment (can be empty)
     * @maxLength 1000
     * @example "Please call before delivery"
     */
    instruction: string;
  } | null;
  /** Whether the customer receives deliveries directly at the loading dock. When omitted, the existing value is preserved. */
  pickupAtDock?: boolean;
}

export interface AnkorstoreInternalMoneyBag {
  amount: number;
  currency: string;
}

export interface AnkorstoreInternalBrandOrderTotals {
  totalAmount: {
    amount: number;
    currency: string;
  };
  totalVatAmount: {
    amount: number;
    currency: string;
  };
  totalAmountWithVat: {
    amount: number;
    currency: string;
  };
  netAmount: {
    amount: number;
    currency: string;
  };
}

export interface AnkorstoreInternalBrandOrderBrand {
  id: string | number;
  name: string;
  /** @format url */
  link: string;
  display_address: {
    city: string;
  };
}

export interface AnkorstoreInternalBrandOrderUser {
  /** @format uuid */
  uuid: string;
  /** @example "John" */
  firstName: string;
  /** @example "Smith" */
  lastName: string;
  /**
   * @format email
   * @example "john@smith.com"
   */
  email: string;
}

export type AnkorstoreInternalNullableMoneyBag = null | {
  amount: number;
  currency: string;
};

export interface AnkorstoreInternalOrderUpdates {
  oldTotalAmount: {
    amount: number;
    currency: string;
  };
  oldTotalAmountVat: {
    amount: number;
    currency: string;
  };
  oldTotalAmountWithVat: {
    amount: number;
    currency: string;
  };
  oldRecargoAmount: null | {
    amount: number;
    currency: string;
  };
  itemUpdates: {
    itemId: string;
    productName: string;
    sku: string;
    productImage: string | null;
    productUrl: string;
    oldQuantity: number;
    newQuantity: number;
    oldMultipliedQuantity: number;
    newMultipliedQuantity: number;
    unitPrice: {
      amount: number;
      currency: string;
    };
    oldAmount: {
      amount: number;
      currency: string;
    };
    newAmount: {
      amount: number;
      currency: string;
    };
  }[];
}

export interface AnkorstoreInternalAddressSet {
  address: {
    countryCode: null | string;
    postalCode: null | string;
    city: null | string;
    addressLine: null | string;
  };
  company: null | string;
  contactPerson: {
    firstName: null | string;
    lastName: null | string;
    fullName: null | string;
    phoneNumber: null | string;
    /** @format email */
    email: null | string;
  };
}

export interface AnkorstoreInternalParcel {
  weight: null | number;
  height: null | number;
  length: null | number;
  width: null | number;
  distanceUnit?: AnkorstoreInternalParcelDistanceUnitEnum;
}

export interface AnkorstoreInternalOrderShipmentEstimation {
  collectionMethods: AnkorstoreInternalOrderShipmentEstimationCollectionMethodsEnum[];
  rateProvider: null | string;
  rateAmount: null | {
    amount: number;
    currency: string;
  };
  estimatedParcels: {
    weight: null | number;
    height: null | number;
    length: null | number;
    width: null | number;
    distanceUnit?: AnkorstoreInternalOrderShipmentEstimationDistanceUnitEnum;
  }[];
}

export interface AnkorstoreInternalBrandOrderShipment {
  /** @format date-time */
  shippedAt: null | string;
  labelPrintingFormat: AnkorstoreInternalBrandOrderShipmentLabelPrintingFormatEnum;
  trackedPackages: {
    /** @format url */
    labelUrl?: null | string;
    parcel?: {
      weight: null | number;
      height: null | number;
      length: null | number;
      width: null | number;
      distanceUnit?: AnkorstoreInternalBrandOrderShipmentDistanceUnitEnum;
    };
  }[];
  shipFromAddress: {
    address: {
      countryCode: null | string;
      postalCode: null | string;
      city: null | string;
      addressLine: null | string;
    };
    company: null | string;
    contactPerson: {
      firstName: null | string;
      lastName: null | string;
      fullName: null | string;
      phoneNumber: null | string;
      /** @format email */
      email: null | string;
    };
  };
  pickup: null | {
    /** @format date-time */
    date: string;
    readyTime: string;
    closeTime: string;
  };
  labelRevertReasons: {
    actionType: string;
    actionReason: string;
  }[];
}

export interface AnkorstoreInternalBrandOrderShipping {
  shippingProvider: null | string;
  isInternational?: boolean;
  hasShippingLabelGenerationError?: boolean;
  hasRevertedShippingLabels?: boolean;
  fees?: null | {
    refundAmount: null | {
      amount: number;
      currency: string;
    };
  };
  /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
  billedWeightFee?: {
    amount: number;
    currency: string;
  };
  shippingAddress: {
    address: {
      countryCode: null | string;
      postalCode: null | string;
      city: null | string;
      addressLine: null | string;
    };
    company: null | string;
    contactPerson: {
      firstName: null | string;
      lastName: null | string;
      fullName: null | string;
      phoneNumber: null | string;
      /** @format email */
      email: null | string;
    };
  };
  availableShippingMethods?:
    | null
    | {
        name: AnkorstoreInternalBrandOrderShippingNameEnum;
        canBeUsed: boolean;
        errors: object[] | object;
      }[];
  shipmentEstimation?: null | {
    collectionMethods: AnkorstoreInternalBrandOrderShippingCollectionMethodsEnum[];
    rateProvider: null | string;
    rateAmount: null | {
      amount: number;
      currency: string;
    };
    estimatedParcels: {
      weight: null | number;
      height: null | number;
      length: null | number;
      width: null | number;
      distanceUnit?: AnkorstoreInternalBrandOrderShippingDistanceUnitEnum;
    }[];
  };
  shipment: null | {
    /** @format date-time */
    shippedAt: null | string;
    labelPrintingFormat: AnkorstoreInternalBrandOrderShippingLabelPrintingFormatEnum;
    trackedPackages: {
      /** @format url */
      labelUrl?: null | string;
      parcel?: {
        weight: null | number;
        height: null | number;
        length: null | number;
        width: null | number;
        distanceUnit?: AnkorstoreInternalBrandOrderShippingDistanceUnitEnum1;
      };
    }[];
    shipFromAddress: {
      address: {
        countryCode: null | string;
        postalCode: null | string;
        city: null | string;
        addressLine: null | string;
      };
      company: null | string;
      contactPerson: {
        firstName: null | string;
        lastName: null | string;
        fullName: null | string;
        phoneNumber: null | string;
        /** @format email */
        email: null | string;
      };
    };
    pickup: null | {
      /** @format date-time */
      date: string;
      readyTime: string;
      closeTime: string;
    };
    labelRevertReasons: {
      actionType: string;
      actionReason: string;
    }[];
  };
}

export interface AnkorstoreInternalOrderBillingItem {
  id: number;
  type: string;
  label: string;
  displayVat: boolean;
  isVatShifted: boolean;
  amount: null | {
    amount: number;
    currency: string;
  };
  amountVat: null | {
    amount: number;
    currency: string;
  };
  amountWithVat: null | {
    amount: number;
    currency: string;
  };
  /** Amount of the billing item in percents */
  percentage: null | number;
  /** Whether the billing item was created as part of a special deal */
  isSpecialDeal: boolean;
  francoSetting?: null | {
    francoAmount?: null | {
      amount: number;
      currency: string;
    };
    francoFlatFeeAmount?: null | {
      amount: number;
      currency: string;
    };
  };
}

export interface AnkorstoreInternalOrderIssueAttributes {
  status: string;
  escalatedToCsByBrand: boolean;
  escalatedToCsToAdjustQuantityByBrand: boolean;
  escalatedToCsOnReship: boolean;
  autoEscalatedToCs: boolean;
  autoEscalatedToCsOnReship: boolean;
  sendToBrandEnabled: boolean;
  escalatedNewClaimToCs: null | boolean;
  reason: string;
  shippedDate: string;
  autoEscalateDate: string;
  trackingLink: null | string;
  trackingNumber: null | string;
  shippingProvider: null | string;
  reshippedDate: null | string;
  products: {
    id: number;
    name: string;
    sku: string;
    description: string;
    quantity: number;
    files: {
      url: string;
    }[];
  }[];
  packagingFiles: {
    url: string;
  }[];
  parcelReservationFiles: {
    url: string;
  }[];
  parcelContentFiles: {
    url: string;
  }[];
  options: {
    label: string;
    text: string;
  }[];
}

export interface AnkorstoreInternalOrderIssue {
  casesVisibleToBrand: string[];
  casesAllowedToBeSentToBrand: string[];
  current: null | {
    status: string;
    escalatedToCsByBrand: boolean;
    escalatedToCsToAdjustQuantityByBrand: boolean;
    escalatedToCsOnReship: boolean;
    autoEscalatedToCs: boolean;
    autoEscalatedToCsOnReship: boolean;
    sendToBrandEnabled: boolean;
    escalatedNewClaimToCs: null | boolean;
    reason: string;
    shippedDate: string;
    autoEscalateDate: string;
    trackingLink: null | string;
    trackingNumber: null | string;
    shippingProvider: null | string;
    reshippedDate: null | string;
    products: {
      id: number;
      name: string;
      sku: string;
      description: string;
      quantity: number;
      files: {
        url: string;
      }[];
    }[];
    packagingFiles: {
      url: string;
    }[];
    parcelReservationFiles: {
      url: string;
    }[];
    parcelContentFiles: {
      url: string;
    }[];
    options: {
      label: string;
      text: string;
    }[];
  };
}

export interface AnkorstoreInternalBrandOrderRetailer {
  id: null | number;
  /** @format uuid */
  uuid?: string | null;
  name: string;
  /** @format email */
  email: string;
  phone_number: string;
  city: string;
  business: {
    user_first_name?: string;
    user_last_name?: string;
    vat_number: null | string;
    tax_number: null | string;
    country: {
      iso_code: string;
    };
  };
  /** The opening times of the customer for delivery. */
  deliverySchedule?: {
    /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
    timeSlots:
      | {
          /**
           * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "09:30"
           */
          startTime: string;
          /**
           * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "12:30"
           */
          endTime: string;
        }[]
      | null;
    /**
     * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
     * @minItems 1
     * @uniqueItems true
     * @example [1,2,3]
     */
    openDays: number[];
  } | null;
  /** The packing instruction of the customer. */
  packingInstruction?: {
    /**
     * List of packing instruction services
     * @minItems 1
     */
    services: AnkorstoreInternalBrandOrderRetailerServicesEnum[];
    /**
     * Additional packing instruction (can be empty)
     * @example "Instruction text"
     */
    instruction: string;
  } | null;
  deliveryAppointment?: {
    /**
     * Whether a delivery appointment is requested for this customer.
     * @example true
     */
    requested: boolean;
    /**
     * Additional instruction for the delivery appointment (can be empty)
     * @maxLength 1000
     * @example "Please call before delivery"
     */
    instruction: string;
  } | null;
}

export interface AnkorstoreInternalBrandMasterOrder {
  /** Type of wrapped order */
  type: AnkorstoreInternalBrandMasterOrderTypeEnum;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  preorderCreatedAt?: null | string;
  /** @pattern ^[EI][A-NP-Z]{3}[1-9]{7}$ */
  reference?: string;
  customReference?: null | string;
  masterStatus?: AnkorstoreInternalBrandMasterOrderMasterStatusEnum;
  status: {
    name: string;
    shortTitle?: string;
    title: null | string;
    details: null | string;
    subStatus?: {
      shortTitle?: string;
    };
  };
  /** The `amounts` property of the `ExternalOrder`, if set. */
  amounts?: {
    /** @example "EUR" */
    brandCurrency: string;
    /** @example 1 */
    brandCurrencyRate: number;
    /** @example "€546.20" */
    brandTotalAmount: string;
    /** @example "€126.33" */
    brandTotalAmountVat: string;
    /** @example "€672.53" */
    brandTotalAmountWithVat: string;
    /** @example "EUR" */
    customerCurrency: string;
    /** @example 1 */
    customerCurrencyRate: number;
    /** @example "€546.20" */
    customerTotalAmount: string;
    /** @example "€126.33" */
    customerTotalAmountVat: string;
    /** @example "€672.53" */
    customerTotalAmountWithVat: string;
    /** @example "€2.20" */
    shippingFeesAmount: string;
    /** @example "€0.44" */
    shippingFeesAmountVat: string;
    /** @example "€2.64" */
    shippingFeesAmountWithVat: string;
    /** @example "€548.40" */
    customerGrandTotalAmount: string;
    /** @example "€126.77" */
    customerGrandTotalAmountVat: string;
    /** @example "€675.17" */
    customerGrandTotalAmountWithVat: string;
  };
  /** The `metadata` property of the `ExternalOrder`, if set. */
  metadata?: {
    /** @example "fulfillment" */
    shippingMethod: string;
    address: {
      /** @example "FR" */
      countryCode: string;
      /** @example "75116" */
      postalCode: string;
      /** @example "Paris" */
      city: string;
      /** @example "av Kleber" */
      addressLine: string;
      /** @example null */
      company: string | null;
    };
    contactPerson: {
      /** @example "John" */
      firstName: string;
      /** @example "Smith" */
      lastName: string;
      /** @example "foo@bar.com" */
      email: string;
      /** @example null */
      phone: string | null;
    };
  };
  internalId: null | number;
  /** @format uuid */
  internalUuid?: string | null;
  /** @format uuid */
  externalOrderUuid?: string | null;
  isDiscovery?: null | boolean;
  isDiscoveryForRetailer?: null | boolean;
  isBelongingToReferral?: null | boolean;
  totals: null | {
    totalAmount: {
      amount: number;
      currency: string;
    };
    totalVatAmount: {
      amount: number;
      currency: string;
    };
    totalAmountWithVat: {
      amount: number;
      currency: string;
    };
    netAmount: {
      amount: number;
      currency: string;
    };
  };
  brand: {
    id: string | number;
    name: string;
    /** @format url */
    link: string;
    display_address: {
      city: string;
    };
  };
  user?: {
    /** @format uuid */
    uuid: string;
    /** @example "John" */
    firstName: string;
    /** @example "Smith" */
    lastName: string;
    /**
     * @format email
     * @example "john@smith.com"
     */
    email: string;
  };
  updates: null | {
    oldTotalAmount: {
      amount: number;
      currency: string;
    };
    oldTotalAmountVat: {
      amount: number;
      currency: string;
    };
    oldTotalAmountWithVat: {
      amount: number;
      currency: string;
    };
    oldRecargoAmount: null | {
      amount: number;
      currency: string;
    };
    itemUpdates: {
      itemId: string;
      productName: string;
      sku: string;
      productImage: string | null;
      productUrl: string;
      oldQuantity: number;
      newQuantity: number;
      oldMultipliedQuantity: number;
      newMultipliedQuantity: number;
      unitPrice: {
        amount: number;
        currency: string;
      };
      oldAmount: {
        amount: number;
        currency: string;
      };
      newAmount: {
        amount: number;
        currency: string;
      };
    }[];
  };
  taxes:
    | null
    | {
        name: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
  priorityTag?: null | {
    name: string;
  };
  vat: null | {
    isShifted: boolean;
    applicationDetails: null | {
      message: string;
      link: null | {
        href: string;
        text: string;
      };
    };
  };
  deadlines?: null | {
    /** @format date-time */
    toShip: null | string;
    /** @format date-time */
    toAccept: null | string;
    /** @format date-time */
    toActOnIssue: null | string;
  };
  synchronizations?:
    | null
    | {
        type?: AnkorstoreInternalBrandMasterOrderTypeEnum1;
        platformName?: AnkorstoreInternalBrandMasterOrderPlatformNameEnum;
        error?: null | string;
      }[];
  invoices?:
    | null
    | {
        isGenerated: boolean;
        title: string;
        number: null | string;
        path: null | string;
      }[];
  shipping: null | {
    shippingProvider: null | string;
    isInternational?: boolean;
    hasShippingLabelGenerationError?: boolean;
    hasRevertedShippingLabels?: boolean;
    fees?: null | {
      refundAmount: null | {
        amount: number;
        currency: string;
      };
    };
    /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
    billedWeightFee?: {
      amount: number;
      currency: string;
    };
    shippingAddress: {
      address: {
        countryCode: null | string;
        postalCode: null | string;
        city: null | string;
        addressLine: null | string;
      };
      company: null | string;
      contactPerson: {
        firstName: null | string;
        lastName: null | string;
        fullName: null | string;
        phoneNumber: null | string;
        /** @format email */
        email: null | string;
      };
    };
    availableShippingMethods?:
      | null
      | {
          name: AnkorstoreInternalBrandMasterOrderNameEnum;
          canBeUsed: boolean;
          errors: object[] | object;
        }[];
    shipmentEstimation?: null | {
      collectionMethods: AnkorstoreInternalBrandMasterOrderCollectionMethodsEnum[];
      rateProvider: null | string;
      rateAmount: null | {
        amount: number;
        currency: string;
      };
      estimatedParcels: {
        weight: null | number;
        height: null | number;
        length: null | number;
        width: null | number;
        distanceUnit?: AnkorstoreInternalBrandMasterOrderDistanceUnitEnum;
      }[];
    };
    shipment: null | {
      /** @format date-time */
      shippedAt: null | string;
      labelPrintingFormat: AnkorstoreInternalBrandMasterOrderLabelPrintingFormatEnum;
      trackedPackages: {
        /** @format url */
        labelUrl?: null | string;
        parcel?: {
          weight: null | number;
          height: null | number;
          length: null | number;
          width: null | number;
          distanceUnit?: AnkorstoreInternalBrandMasterOrderDistanceUnitEnum1;
        };
      }[];
      shipFromAddress: {
        address: {
          countryCode: null | string;
          postalCode: null | string;
          city: null | string;
          addressLine: null | string;
        };
        company: null | string;
        contactPerson: {
          firstName: null | string;
          lastName: null | string;
          fullName: null | string;
          phoneNumber: null | string;
          /** @format email */
          email: null | string;
        };
      };
      pickup: null | {
        /** @format date-time */
        date: string;
        readyTime: string;
        closeTime: string;
      };
      labelRevertReasons: {
        actionType: string;
        actionReason: string;
      }[];
    };
  };
  tracking: null | {
    trackingNumber: null | string;
    trackingLink: null | string;
    status: null | string;
  };
  billing: null | {
    billingItems: {
      id: number;
      type: string;
      label: string;
      displayVat: boolean;
      isVatShifted: boolean;
      amount: null | {
        amount: number;
        currency: string;
      };
      amountVat: null | {
        amount: number;
        currency: string;
      };
      amountWithVat: null | {
        amount: number;
        currency: string;
      };
      /** Amount of the billing item in percents */
      percentage: null | number;
      /** Whether the billing item was created as part of a special deal */
      isSpecialDeal: boolean;
      francoSetting?: null | {
        francoAmount?: null | {
          amount: number;
          currency: string;
        };
        francoFlatFeeAmount?: null | {
          amount: number;
          currency: string;
        };
      };
    }[];
  };
  issue?: null | {
    casesVisibleToBrand: string[];
    casesAllowedToBeSentToBrand: string[];
    current: null | {
      status: string;
      escalatedToCsByBrand: boolean;
      escalatedToCsToAdjustQuantityByBrand: boolean;
      escalatedToCsOnReship: boolean;
      autoEscalatedToCs: boolean;
      autoEscalatedToCsOnReship: boolean;
      sendToBrandEnabled: boolean;
      escalatedNewClaimToCs: null | boolean;
      reason: string;
      shippedDate: string;
      autoEscalateDate: string;
      trackingLink: null | string;
      trackingNumber: null | string;
      shippingProvider: null | string;
      reshippedDate: null | string;
      products: {
        id: number;
        name: string;
        sku: string;
        description: string;
        quantity: number;
        files: {
          url: string;
        }[];
      }[];
      packagingFiles: {
        url: string;
      }[];
      parcelReservationFiles: {
        url: string;
      }[];
      parcelContentFiles: {
        url: string;
      }[];
      options: {
        label: string;
        text: string;
      }[];
    };
  };
  retailer: null | {
    id: null | number;
    /** @format uuid */
    uuid?: string | null;
    name: string;
    /** @format email */
    email: string;
    phone_number: string;
    city: string;
    business: {
      user_first_name?: string;
      user_last_name?: string;
      vat_number: null | string;
      tax_number: null | string;
      country: {
        iso_code: string;
      };
    };
    /** The opening times of the customer for delivery. */
    deliverySchedule?: {
      /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
      timeSlots:
        | {
            /**
             * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "09:30"
             */
            startTime: string;
            /**
             * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "12:30"
             */
            endTime: string;
          }[]
        | null;
      /**
       * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
       * @minItems 1
       * @uniqueItems true
       * @example [1,2,3]
       */
      openDays: number[];
    } | null;
    /** The packing instruction of the customer. */
    packingInstruction?: {
      /**
       * List of packing instruction services
       * @minItems 1
       */
      services: AnkorstoreInternalBrandMasterOrderServicesEnum[];
      /**
       * Additional packing instruction (can be empty)
       * @example "Instruction text"
       */
      instruction: string;
    } | null;
    deliveryAppointment?: {
      /**
       * Whether a delivery appointment is requested for this customer.
       * @example true
       */
      requested: boolean;
      /**
       * Additional instruction for the delivery appointment (can be empty)
       * @maxLength 1000
       * @example "Please call before delivery"
       */
      instruction: string;
    } | null;
  };
  rejection: null | {
    brandRejectType: null | string;
    availableBrandRejectReasons?: {
      rejectType: string;
      rejectTypeLabel: string;
    }[];
    isRetailerCancellationRequestOpened?: boolean;
  };
  meta: null | {
    showAlcoholWarning?: boolean;
    showManualInvoiceDownloadWarning?: boolean;
    casesVisibleToBrand?: string[];
    casesAllowedToBeSentToBrand?: string[];
    isSplitAllowed?: boolean;
    businessModel?: AnkorstoreInternalBrandMasterOrderBusinessModelEnum;
  };
}

export interface AnkorstoreInternalRetailerOrderTotals {
  totalAmount: {
    amount: number;
    currency: string;
  };
  totalVatAmount: {
    amount: number;
    currency: string;
  };
  totalAmountWithVat: {
    amount: number;
    currency: string;
  };
  netAmount: {
    amount: number;
    currency: string;
  };
  retailerTotalAmountBeforeDiscount?: {
    amount: number;
    currency: string;
  };
}

export interface AnkorstoreInternalRetailerOrderBrand {
  id: number;
  name: string;
  /** @format url */
  link: string;
  display_address: {
    city: string;
  };
  images?: {
    rounded: null | string;
  };
}

export interface AnkorstoreInternalOrderEvent {
  type: string;
  updates: {
    oldTotalAmount: {
      amount: number;
      currency: string;
    };
    oldTotalAmountVat: {
      amount: number;
      currency: string;
    };
    oldTotalAmountWithVat: {
      amount: number;
      currency: string;
    };
    oldRecargoAmount: null | {
      amount: number;
      currency: string;
    };
    itemUpdates: {
      itemId: string;
      productName: string;
      sku: string;
      productImage: string | null;
      productUrl: string;
      oldQuantity: number;
      newQuantity: number;
      oldMultipliedQuantity: number;
      newMultipliedQuantity: number;
      unitPrice: {
        amount: number;
        currency: string;
      };
      oldAmount: {
        amount: number;
        currency: string;
      };
      newAmount: {
        amount: number;
        currency: string;
      };
    }[];
  };
}

export interface AnkorstoreInternalRetailerOrderShipment {
  trackedPackages: {
    /** @format url */
    labelUrl?: null | string;
    parcel?: {
      weight: null | number;
      height: null | number;
      length: null | number;
      width: null | number;
      distanceUnit?: AnkorstoreInternalRetailerOrderShipmentDistanceUnitEnum;
    };
  }[];
}

export interface AnkorstoreInternalRetailerOrderShipping {
  shippingProvider: null | string;
  /** @format date-time */
  shippedAt: null | string;
  shippingMethod: null | string;
  shippingAddress: {
    address: {
      countryCode: null | string;
      postalCode: null | string;
      city: null | string;
      addressLine: null | string;
    };
    company: null | string;
    contactPerson: {
      firstName: null | string;
      lastName: null | string;
      fullName: null | string;
      phoneNumber: null | string;
      /** @format email */
      email: null | string;
    };
  };
  shipment: null | {
    trackedPackages: {
      /** @format url */
      labelUrl?: null | string;
      parcel?: {
        weight: null | number;
        height: null | number;
        length: null | number;
        width: null | number;
        distanceUnit?: AnkorstoreInternalRetailerOrderShippingDistanceUnitEnum;
      };
    }[];
  };
}

export interface AnkorstoreInternalOrderRetailer {
  id: null | number;
  name: string;
  store_url: null | string;
  /** @format email */
  email: string;
  phone_number: string;
  city: string;
  postal_code?: string;
  address_line?: string;
  company_name?: string;
  business: {
    vat_number: null | string;
    tax_number: null | string;
    user_first_name?: null | string;
    user_last_name?: null | string;
    country: {
      iso_code: string;
    };
  };
}

export interface AnkorstoreInternalRetailerMasterOrder {
  /** Type of wrapped order */
  type: AnkorstoreInternalRetailerMasterOrderTypeEnum;
  /** @format date-time */
  createdAt: string;
  orderItemCount?: number;
  internalId: null | number;
  checkoutId?: null | number;
  /**
   * The AnkorPay payment operation UUID associated with this order's checkout. Null if no payment operation is found.
   * @format uuid
   */
  externalPaymentUuid?: null | string;
  status: {
    name: string;
    shortTitle?: string;
    title: null | string;
    details: null | string;
    subStatus?: {
      shortTitle?: string;
    };
    /** @format datetime */
    transitionedAt?: null | string;
  };
  totals: null | {
    totalAmount: {
      amount: number;
      currency: string;
    };
    totalVatAmount: {
      amount: number;
      currency: string;
    };
    totalAmountWithVat: {
      amount: number;
      currency: string;
    };
    netAmount: {
      amount: number;
      currency: string;
    };
    retailerTotalAmountBeforeDiscount?: {
      amount: number;
      currency: string;
    };
  };
  brand: {
    id: number;
    name: string;
    /** @format url */
    link: string;
    display_address: {
      city: string;
    };
    images?: {
      rounded: null | string;
    };
  };
  updates: null | {
    oldTotalAmount: {
      amount: number;
      currency: string;
    };
    oldTotalAmountVat: {
      amount: number;
      currency: string;
    };
    oldTotalAmountWithVat: {
      amount: number;
      currency: string;
    };
    oldRecargoAmount: null | {
      amount: number;
      currency: string;
    };
    itemUpdates: {
      itemId: string;
      productName: string;
      sku: string;
      productImage: string | null;
      productUrl: string;
      oldQuantity: number;
      newQuantity: number;
      oldMultipliedQuantity: number;
      newMultipliedQuantity: number;
      unitPrice: {
        amount: number;
        currency: string;
      };
      oldAmount: {
        amount: number;
        currency: string;
      };
      newAmount: {
        amount: number;
        currency: string;
      };
    }[];
  };
  events?: {
    type: string;
    updates: {
      oldTotalAmount: {
        amount: number;
        currency: string;
      };
      oldTotalAmountVat: {
        amount: number;
        currency: string;
      };
      oldTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
      oldRecargoAmount: null | {
        amount: number;
        currency: string;
      };
      itemUpdates: {
        itemId: string;
        productName: string;
        sku: string;
        productImage: string | null;
        productUrl: string;
        oldQuantity: number;
        newQuantity: number;
        oldMultipliedQuantity: number;
        newMultipliedQuantity: number;
        unitPrice: {
          amount: number;
          currency: string;
        };
        oldAmount: {
          amount: number;
          currency: string;
        };
        newAmount: {
          amount: number;
          currency: string;
        };
      }[];
    };
  }[];
  taxes:
    | null
    | {
        name: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
  shipping: {
    shippingProvider: null | string;
    /** @format date-time */
    shippedAt: null | string;
    shippingMethod: null | string;
    shippingAddress: {
      address: {
        countryCode: null | string;
        postalCode: null | string;
        city: null | string;
        addressLine: null | string;
      };
      company: null | string;
      contactPerson: {
        firstName: null | string;
        lastName: null | string;
        fullName: null | string;
        phoneNumber: null | string;
        /** @format email */
        email: null | string;
      };
    };
    shipment: null | {
      trackedPackages: {
        /** @format url */
        labelUrl?: null | string;
        parcel?: {
          weight: null | number;
          height: null | number;
          length: null | number;
          width: null | number;
          distanceUnit?: AnkorstoreInternalRetailerMasterOrderDistanceUnitEnum;
        };
      }[];
    };
  };
  tracking: null | {
    trackingNumber: null | string;
    trackingLink: null | string;
    status: null | string;
  };
  billing: null | {
    billingItems: {
      id: number;
      type: string;
      label: string;
      displayVat: boolean;
      isVatShifted: boolean;
      amount: null | {
        amount: number;
        currency: string;
      };
      amountVat: null | {
        amount: number;
        currency: string;
      };
      amountWithVat: null | {
        amount: number;
        currency: string;
      };
      /** Amount of the billing item in percents */
      percentage: null | number;
      /** Whether the billing item was created as part of a special deal */
      isSpecialDeal: boolean;
      francoSetting?: null | {
        francoAmount?: null | {
          amount: number;
          currency: string;
        };
        francoFlatFeeAmount?: null | {
          amount: number;
          currency: string;
        };
      };
    }[];
  };
  issue?: null | {
    casesVisibleToBrand: string[];
    casesAllowedToBeSentToBrand: string[];
    current: null | {
      status: string;
      escalatedToCsByBrand: boolean;
      escalatedToCsToAdjustQuantityByBrand: boolean;
      escalatedToCsOnReship: boolean;
      autoEscalatedToCs: boolean;
      autoEscalatedToCsOnReship: boolean;
      sendToBrandEnabled: boolean;
      escalatedNewClaimToCs: null | boolean;
      reason: string;
      shippedDate: string;
      autoEscalateDate: string;
      trackingLink: null | string;
      trackingNumber: null | string;
      shippingProvider: null | string;
      reshippedDate: null | string;
      products: {
        id: number;
        name: string;
        sku: string;
        description: string;
        quantity: number;
        files: {
          url: string;
        }[];
      }[];
      packagingFiles: {
        url: string;
      }[];
      parcelReservationFiles: {
        url: string;
      }[];
      parcelContentFiles: {
        url: string;
      }[];
      options: {
        label: string;
        text: string;
      }[];
    };
  };
  retailer: {
    id: null | number;
    name: string;
    store_url: null | string;
    /** @format email */
    email: string;
    phone_number: string;
    city: string;
    postal_code?: string;
    address_line?: string;
    company_name?: string;
    business: {
      vat_number: null | string;
      tax_number: null | string;
      user_first_name?: null | string;
      user_last_name?: null | string;
      country: {
        iso_code: string;
      };
    };
  };
  rejection: null | {
    brandRejectType: null | string;
  };
  cancellation?: null | {
    retailerCanOpenCancellationRequest: boolean;
  };
  meta: null | {
    showManualInvoiceDownloadWarning?: boolean;
    casesVisibleToBrand?: string[];
    casesAllowedToBeSentToBrand?: string[];
  };
}

export interface AnkorstoreInternalMasterOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes:
    | {
        /** Type of wrapped order */
        type: AnkorstoreInternalMasterOrderResourceTypeEnum;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        preorderCreatedAt?: null | string;
        /** @pattern ^[EI][A-NP-Z]{3}[1-9]{7}$ */
        reference?: string;
        customReference?: null | string;
        masterStatus?: AnkorstoreInternalMasterOrderResourceMasterStatusEnum;
        status: {
          name: string;
          shortTitle?: string;
          title: null | string;
          details: null | string;
          subStatus?: {
            shortTitle?: string;
          };
        };
        /** The `amounts` property of the `ExternalOrder`, if set. */
        amounts?: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example "€546.20" */
          brandTotalAmount: string;
          /** @example "€126.33" */
          brandTotalAmountVat: string;
          /** @example "€672.53" */
          brandTotalAmountWithVat: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example "€546.20" */
          customerTotalAmount: string;
          /** @example "€126.33" */
          customerTotalAmountVat: string;
          /** @example "€672.53" */
          customerTotalAmountWithVat: string;
          /** @example "€2.20" */
          shippingFeesAmount: string;
          /** @example "€0.44" */
          shippingFeesAmountVat: string;
          /** @example "€2.64" */
          shippingFeesAmountWithVat: string;
          /** @example "€548.40" */
          customerGrandTotalAmount: string;
          /** @example "€126.77" */
          customerGrandTotalAmountVat: string;
          /** @example "€675.17" */
          customerGrandTotalAmountWithVat: string;
        };
        /** The `metadata` property of the `ExternalOrder`, if set. */
        metadata?: {
          /** @example "fulfillment" */
          shippingMethod: string;
          address: {
            /** @example "FR" */
            countryCode: string;
            /** @example "75116" */
            postalCode: string;
            /** @example "Paris" */
            city: string;
            /** @example "av Kleber" */
            addressLine: string;
            /** @example null */
            company: string | null;
          };
          contactPerson: {
            /** @example "John" */
            firstName: string;
            /** @example "Smith" */
            lastName: string;
            /** @example "foo@bar.com" */
            email: string;
            /** @example null */
            phone: string | null;
          };
        };
        internalId: null | number;
        /** @format uuid */
        internalUuid?: string | null;
        /** @format uuid */
        externalOrderUuid?: string | null;
        isDiscovery?: null | boolean;
        isDiscoveryForRetailer?: null | boolean;
        isBelongingToReferral?: null | boolean;
        totals: null | {
          totalAmount: {
            amount: number;
            currency: string;
          };
          totalVatAmount: {
            amount: number;
            currency: string;
          };
          totalAmountWithVat: {
            amount: number;
            currency: string;
          };
          netAmount: {
            amount: number;
            currency: string;
          };
        };
        brand: {
          id: string | number;
          name: string;
          /** @format url */
          link: string;
          display_address: {
            city: string;
          };
        };
        user?: {
          /** @format uuid */
          uuid: string;
          /** @example "John" */
          firstName: string;
          /** @example "Smith" */
          lastName: string;
          /**
           * @format email
           * @example "john@smith.com"
           */
          email: string;
        };
        updates: null | {
          oldTotalAmount: {
            amount: number;
            currency: string;
          };
          oldTotalAmountVat: {
            amount: number;
            currency: string;
          };
          oldTotalAmountWithVat: {
            amount: number;
            currency: string;
          };
          oldRecargoAmount: null | {
            amount: number;
            currency: string;
          };
          itemUpdates: {
            itemId: string;
            productName: string;
            sku: string;
            productImage: string | null;
            productUrl: string;
            oldQuantity: number;
            newQuantity: number;
            oldMultipliedQuantity: number;
            newMultipliedQuantity: number;
            unitPrice: {
              amount: number;
              currency: string;
            };
            oldAmount: {
              amount: number;
              currency: string;
            };
            newAmount: {
              amount: number;
              currency: string;
            };
          }[];
        };
        taxes:
          | null
          | {
              name: string;
              amount: {
                amount: number;
                currency: string;
              };
            }[];
        priorityTag?: null | {
          name: string;
        };
        vat: null | {
          isShifted: boolean;
          applicationDetails: null | {
            message: string;
            link: null | {
              href: string;
              text: string;
            };
          };
        };
        deadlines?: null | {
          /** @format date-time */
          toShip: null | string;
          /** @format date-time */
          toAccept: null | string;
          /** @format date-time */
          toActOnIssue: null | string;
        };
        synchronizations?:
          | null
          | {
              type?: AnkorstoreInternalMasterOrderResourceTypeEnum1;
              platformName?: AnkorstoreInternalMasterOrderResourcePlatformNameEnum;
              error?: null | string;
            }[];
        invoices?:
          | null
          | {
              isGenerated: boolean;
              title: string;
              number: null | string;
              path: null | string;
            }[];
        shipping: null | {
          shippingProvider: null | string;
          isInternational?: boolean;
          hasShippingLabelGenerationError?: boolean;
          hasRevertedShippingLabels?: boolean;
          fees?: null | {
            refundAmount: null | {
              amount: number;
              currency: string;
            };
          };
          /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
          billedWeightFee?: {
            amount: number;
            currency: string;
          };
          shippingAddress: {
            address: {
              countryCode: null | string;
              postalCode: null | string;
              city: null | string;
              addressLine: null | string;
            };
            company: null | string;
            contactPerson: {
              firstName: null | string;
              lastName: null | string;
              fullName: null | string;
              phoneNumber: null | string;
              /** @format email */
              email: null | string;
            };
          };
          availableShippingMethods?:
            | null
            | {
                name: AnkorstoreInternalMasterOrderResourceNameEnum;
                canBeUsed: boolean;
                errors: object[] | object;
              }[];
          shipmentEstimation?: null | {
            collectionMethods: AnkorstoreInternalMasterOrderResourceCollectionMethodsEnum[];
            rateProvider: null | string;
            rateAmount: null | {
              amount: number;
              currency: string;
            };
            estimatedParcels: {
              weight: null | number;
              height: null | number;
              length: null | number;
              width: null | number;
              distanceUnit?: AnkorstoreInternalMasterOrderResourceDistanceUnitEnum;
            }[];
          };
          shipment: null | {
            /** @format date-time */
            shippedAt: null | string;
            labelPrintingFormat: AnkorstoreInternalMasterOrderResourceLabelPrintingFormatEnum;
            trackedPackages: {
              /** @format url */
              labelUrl?: null | string;
              parcel?: {
                weight: null | number;
                height: null | number;
                length: null | number;
                width: null | number;
                distanceUnit?: AnkorstoreInternalMasterOrderResourceDistanceUnitEnum1;
              };
            }[];
            shipFromAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            pickup: null | {
              /** @format date-time */
              date: string;
              readyTime: string;
              closeTime: string;
            };
            labelRevertReasons: {
              actionType: string;
              actionReason: string;
            }[];
          };
        };
        tracking: null | {
          trackingNumber: null | string;
          trackingLink: null | string;
          status: null | string;
        };
        billing: null | {
          billingItems: {
            id: number;
            type: string;
            label: string;
            displayVat: boolean;
            isVatShifted: boolean;
            amount: null | {
              amount: number;
              currency: string;
            };
            amountVat: null | {
              amount: number;
              currency: string;
            };
            amountWithVat: null | {
              amount: number;
              currency: string;
            };
            /** Amount of the billing item in percents */
            percentage: null | number;
            /** Whether the billing item was created as part of a special deal */
            isSpecialDeal: boolean;
            francoSetting?: null | {
              francoAmount?: null | {
                amount: number;
                currency: string;
              };
              francoFlatFeeAmount?: null | {
                amount: number;
                currency: string;
              };
            };
          }[];
        };
        issue?: null | {
          casesVisibleToBrand: string[];
          casesAllowedToBeSentToBrand: string[];
          current: null | {
            status: string;
            escalatedToCsByBrand: boolean;
            escalatedToCsToAdjustQuantityByBrand: boolean;
            escalatedToCsOnReship: boolean;
            autoEscalatedToCs: boolean;
            autoEscalatedToCsOnReship: boolean;
            sendToBrandEnabled: boolean;
            escalatedNewClaimToCs: null | boolean;
            reason: string;
            shippedDate: string;
            autoEscalateDate: string;
            trackingLink: null | string;
            trackingNumber: null | string;
            shippingProvider: null | string;
            reshippedDate: null | string;
            products: {
              id: number;
              name: string;
              sku: string;
              description: string;
              quantity: number;
              files: {
                url: string;
              }[];
            }[];
            packagingFiles: {
              url: string;
            }[];
            parcelReservationFiles: {
              url: string;
            }[];
            parcelContentFiles: {
              url: string;
            }[];
            options: {
              label: string;
              text: string;
            }[];
          };
        };
        retailer: null | {
          id: null | number;
          /** @format uuid */
          uuid?: string | null;
          name: string;
          /** @format email */
          email: string;
          phone_number: string;
          city: string;
          business: {
            user_first_name?: string;
            user_last_name?: string;
            vat_number: null | string;
            tax_number: null | string;
            country: {
              iso_code: string;
            };
          };
          /** The opening times of the customer for delivery. */
          deliverySchedule?: {
            /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
            timeSlots:
              | {
                  /**
                   * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                   * @example "09:30"
                   */
                  startTime: string;
                  /**
                   * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                   * @example "12:30"
                   */
                  endTime: string;
                }[]
              | null;
            /**
             * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
             * @minItems 1
             * @uniqueItems true
             * @example [1,2,3]
             */
            openDays: number[];
          } | null;
          /** The packing instruction of the customer. */
          packingInstruction?: {
            /**
             * List of packing instruction services
             * @minItems 1
             */
            services: AnkorstoreInternalMasterOrderResourceServicesEnum[];
            /**
             * Additional packing instruction (can be empty)
             * @example "Instruction text"
             */
            instruction: string;
          } | null;
          deliveryAppointment?: {
            /**
             * Whether a delivery appointment is requested for this customer.
             * @example true
             */
            requested: boolean;
            /**
             * Additional instruction for the delivery appointment (can be empty)
             * @maxLength 1000
             * @example "Please call before delivery"
             */
            instruction: string;
          } | null;
        };
        rejection: null | {
          brandRejectType: null | string;
          availableBrandRejectReasons?: {
            rejectType: string;
            rejectTypeLabel: string;
          }[];
          isRetailerCancellationRequestOpened?: boolean;
        };
        meta: null | {
          showAlcoholWarning?: boolean;
          showManualInvoiceDownloadWarning?: boolean;
          casesVisibleToBrand?: string[];
          casesAllowedToBeSentToBrand?: string[];
          isSplitAllowed?: boolean;
          businessModel?: AnkorstoreInternalMasterOrderResourceBusinessModelEnum;
        };
      }
    | {
        /** Type of wrapped order */
        type: AnkorstoreInternalMasterOrderResourceTypeEnum2;
        /** @format date-time */
        createdAt: string;
        orderItemCount?: number;
        internalId: null | number;
        checkoutId?: null | number;
        /**
         * The AnkorPay payment operation UUID associated with this order's checkout. Null if no payment operation is found.
         * @format uuid
         */
        externalPaymentUuid?: null | string;
        status: {
          name: string;
          shortTitle?: string;
          title: null | string;
          details: null | string;
          subStatus?: {
            shortTitle?: string;
          };
          /** @format datetime */
          transitionedAt?: null | string;
        };
        totals: null | {
          totalAmount: {
            amount: number;
            currency: string;
          };
          totalVatAmount: {
            amount: number;
            currency: string;
          };
          totalAmountWithVat: {
            amount: number;
            currency: string;
          };
          netAmount: {
            amount: number;
            currency: string;
          };
          retailerTotalAmountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        brand: {
          id: number;
          name: string;
          /** @format url */
          link: string;
          display_address: {
            city: string;
          };
          images?: {
            rounded: null | string;
          };
        };
        updates: null | {
          oldTotalAmount: {
            amount: number;
            currency: string;
          };
          oldTotalAmountVat: {
            amount: number;
            currency: string;
          };
          oldTotalAmountWithVat: {
            amount: number;
            currency: string;
          };
          oldRecargoAmount: null | {
            amount: number;
            currency: string;
          };
          itemUpdates: {
            itemId: string;
            productName: string;
            sku: string;
            productImage: string | null;
            productUrl: string;
            oldQuantity: number;
            newQuantity: number;
            oldMultipliedQuantity: number;
            newMultipliedQuantity: number;
            unitPrice: {
              amount: number;
              currency: string;
            };
            oldAmount: {
              amount: number;
              currency: string;
            };
            newAmount: {
              amount: number;
              currency: string;
            };
          }[];
        };
        events?: {
          type: string;
          updates: {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
        }[];
        taxes:
          | null
          | {
              name: string;
              amount: {
                amount: number;
                currency: string;
              };
            }[];
        shipping: {
          shippingProvider: null | string;
          /** @format date-time */
          shippedAt: null | string;
          shippingMethod: null | string;
          shippingAddress: {
            address: {
              countryCode: null | string;
              postalCode: null | string;
              city: null | string;
              addressLine: null | string;
            };
            company: null | string;
            contactPerson: {
              firstName: null | string;
              lastName: null | string;
              fullName: null | string;
              phoneNumber: null | string;
              /** @format email */
              email: null | string;
            };
          };
          shipment: null | {
            trackedPackages: {
              /** @format url */
              labelUrl?: null | string;
              parcel?: {
                weight: null | number;
                height: null | number;
                length: null | number;
                width: null | number;
                distanceUnit?: AnkorstoreInternalMasterOrderResourceDistanceUnitEnum2;
              };
            }[];
          };
        };
        tracking: null | {
          trackingNumber: null | string;
          trackingLink: null | string;
          status: null | string;
        };
        billing: null | {
          billingItems: {
            id: number;
            type: string;
            label: string;
            displayVat: boolean;
            isVatShifted: boolean;
            amount: null | {
              amount: number;
              currency: string;
            };
            amountVat: null | {
              amount: number;
              currency: string;
            };
            amountWithVat: null | {
              amount: number;
              currency: string;
            };
            /** Amount of the billing item in percents */
            percentage: null | number;
            /** Whether the billing item was created as part of a special deal */
            isSpecialDeal: boolean;
            francoSetting?: null | {
              francoAmount?: null | {
                amount: number;
                currency: string;
              };
              francoFlatFeeAmount?: null | {
                amount: number;
                currency: string;
              };
            };
          }[];
        };
        issue?: null | {
          casesVisibleToBrand: string[];
          casesAllowedToBeSentToBrand: string[];
          current: null | {
            status: string;
            escalatedToCsByBrand: boolean;
            escalatedToCsToAdjustQuantityByBrand: boolean;
            escalatedToCsOnReship: boolean;
            autoEscalatedToCs: boolean;
            autoEscalatedToCsOnReship: boolean;
            sendToBrandEnabled: boolean;
            escalatedNewClaimToCs: null | boolean;
            reason: string;
            shippedDate: string;
            autoEscalateDate: string;
            trackingLink: null | string;
            trackingNumber: null | string;
            shippingProvider: null | string;
            reshippedDate: null | string;
            products: {
              id: number;
              name: string;
              sku: string;
              description: string;
              quantity: number;
              files: {
                url: string;
              }[];
            }[];
            packagingFiles: {
              url: string;
            }[];
            parcelReservationFiles: {
              url: string;
            }[];
            parcelContentFiles: {
              url: string;
            }[];
            options: {
              label: string;
              text: string;
            }[];
          };
        };
        retailer: {
          id: null | number;
          name: string;
          store_url: null | string;
          /** @format email */
          email: string;
          phone_number: string;
          city: string;
          postal_code?: string;
          address_line?: string;
          company_name?: string;
          business: {
            vat_number: null | string;
            tax_number: null | string;
            user_first_name?: null | string;
            user_last_name?: null | string;
            country: {
              iso_code: string;
            };
          };
        };
        rejection: null | {
          brandRejectType: null | string;
        };
        cancellation?: null | {
          retailerCanOpenCancellationRequest: boolean;
        };
        meta: null | {
          showManualInvoiceDownloadWarning?: boolean;
          casesVisibleToBrand?: string[];
          casesAllowedToBeSentToBrand?: string[];
        };
      };
  relationships?: {
    orderItems?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    orderShipping?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

export interface AnkorstoreInternalMasterOrderShipping {
  shippingMethod: null | AnkorstoreInternalMasterOrderShippingShippingMethodEnum;
  isAddingTrackingInformationPostponed: null | boolean;
  stockOrigin: null | AnkorstoreInternalMasterOrderShippingStockOriginEnum;
}

export interface AnkorstoreInternalOrderShippingResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    shippingMethod: null | AnkorstoreInternalOrderShippingResourceShippingMethodEnum;
    isAddingTrackingInformationPostponed: null | boolean;
    stockOrigin: null | AnkorstoreInternalOrderShippingResourceStockOriginEnum;
  };
}

export interface AnkorstoreInternalOrderItem {
  internalId: null | number;
  unitQuantity: number;
  batchQuantity: number;
  unitPrice: null | {
    amount: number;
    currency: string;
  };
  totalPrice: null | {
    amount: number;
    currency: string;
  };
}

export interface AnkorstoreInternalOrderItemResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    internalId: null | number;
    unitQuantity: number;
    batchQuantity: number;
    unitPrice: null | {
      amount: number;
      currency: string;
    };
    totalPrice: null | {
      amount: number;
      currency: string;
    };
  };
  relationships?: {
    /** Resource identification present in Resource Objects and Resource Identifier Objects. */
    orderedProduct?: {
      /**
       * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
       * @format uuid
       */
      id: string;
      /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
      type: string;
      /** Non-standard meta-information that can not be represented as an attribute or relationship. */
      meta?: Record<string, any>;
    };
  };
}

export interface AnkorstoreInternalOrderIssueResource {
  type?: 'order-issue';
  id?: string;
  attributes?: {
    status: string;
    escalatedToCsByBrand: boolean;
    escalatedToCsToAdjustQuantityByBrand: boolean;
    escalatedToCsOnReship: boolean;
    autoEscalatedToCs: boolean;
    autoEscalatedToCsOnReship: boolean;
    sendToBrandEnabled: boolean;
    escalatedNewClaimToCs: null | boolean;
    reason: string;
    shippedDate: string;
    autoEscalateDate: string;
    trackingLink: null | string;
    trackingNumber: null | string;
    shippingProvider: null | string;
    reshippedDate: null | string;
    products: {
      id: number;
      name: string;
      sku: string;
      description: string;
      quantity: number;
      files: {
        url: string;
      }[];
    }[];
    packagingFiles: {
      url: string;
    }[];
    parcelReservationFiles: {
      url: string;
    }[];
    parcelContentFiles: {
      url: string;
    }[];
    options: {
      label: string;
      text: string;
    }[];
  };
}

export interface AnkorstoreInternalSplitOrderRequest {
  data?: {
    attributes?: {
      /** @format date-time */
      availabilityDate: string;
      splitOffItems: {
        /** @format uuid */
        productVariantId: string;
        quantity: number;
      }[];
    };
  };
}

export interface AnkorstoreInternalOrderedProduct {
  /** @format uuid */
  fulfillableId: null | string;
  sku: string;
  name: string;
  pageUrl: string;
  /** Harmonized System Code - product classification for customs purposes. */
  hsCode?: null | string;
  images: string[];
  options: {
    name: string;
    value: null | string;
  }[];
}

export interface AnkorstoreInternalOrderedProductResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** @format uuid */
    fulfillableId: null | string;
    sku: string;
    name: string;
    pageUrl: string;
    /** Harmonized System Code - product classification for customs purposes. */
    hsCode?: null | string;
    images: string[];
    options: {
      name: string;
      value: null | string;
    }[];
  };
}

export interface AnkorstoreInternalPreorderRetailer {
  ibanLast4: null | string;
}

export interface AnkorstoreInternalPreorderRetailerResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    ibanLast4: null | string;
  };
}

export interface AnkorstoreInternalPreordersCart {
  itemCount: number;
  totalBaseAmount: {
    amount: number;
    currency: string;
  };
  totalAmountVat: {
    amount: number;
    currency: string;
  };
  totalAmountWithVat: {
    amount: number;
    currency: string;
  };
  grandTotalAmountWithVat: {
    amount: number;
    currency: string;
  };
}

export interface AnkorstoreInternalPreordersCartResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    itemCount: number;
    totalBaseAmount: {
      amount: number;
      currency: string;
    };
    totalAmountVat: {
      amount: number;
      currency: string;
    };
    totalAmountWithVat: {
      amount: number;
      currency: string;
    };
    grandTotalAmountWithVat: {
      amount: number;
      currency: string;
    };
  };
}

export interface AnkorstoreInternalPreorder {
  isSelected: boolean;
  isShippingRestrictedByEori: boolean;
  itemCount: number;
  status: AnkorstoreInternalPreorderStatusEnum;
  /** @format date-time */
  submittedAt: string | null;
  totalBaseAmount: {
    amount: number;
    currency: string;
  };
  totalAmountVat?: {
    amount: number;
    currency: string;
  };
  totalAmountWithVat?: {
    amount: number;
    currency: string;
  };
  totalAmountBeforeDiscount?: {
    amount: number;
    currency: string;
  };
  grandTotalAmountWithVat: {
    amount: number;
    currency: string;
  };
  offerDiscounts?: {
    name: string;
    type: string;
    amount: {
      amount: number;
      currency: string;
    };
  }[];
  preorderMinimumAmount?: {
    amount: number;
    currency: string;
  };
  shippingContributionAmount?: {
    amount: number;
    currency: string;
  };
  hasDiscounts?: boolean;
  hasMultiDiscounts?: boolean;
  globalDiscountPercentage?: number;
  paymentTerms?: AnkorstoreInternalPreorderPaymentTermsEnum;
  metadata?: {
    isDiscovery: boolean;
    actualShippingFeeAmount?: {
      amount: number;
      currency: string;
    };
    shippingFeeAmountVat?: {
      amount: number;
      currency: string;
    };
    francoAmount?: null | number;
    discountedShippingAmount?: {
      amount: number;
      currency: string;
    };
    amountLeftForFreeShipping?: {
      amount: number;
      currency: string;
    };
    isEligibleForDiscoveryFreeShipping?: boolean;
    isBrandEligibleForAkPlusFreeShipping?: boolean;
    offerName?: null | string;
  };
}

export interface AnkorstoreInternalPreorderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    isSelected: boolean;
    isShippingRestrictedByEori: boolean;
    itemCount: number;
    status: AnkorstoreInternalPreorderResourceStatusEnum;
    /** @format date-time */
    submittedAt: string | null;
    totalBaseAmount: {
      amount: number;
      currency: string;
    };
    totalAmountVat?: {
      amount: number;
      currency: string;
    };
    totalAmountWithVat?: {
      amount: number;
      currency: string;
    };
    totalAmountBeforeDiscount?: {
      amount: number;
      currency: string;
    };
    grandTotalAmountWithVat: {
      amount: number;
      currency: string;
    };
    offerDiscounts?: {
      name: string;
      type: string;
      amount: {
        amount: number;
        currency: string;
      };
    }[];
    preorderMinimumAmount?: {
      amount: number;
      currency: string;
    };
    shippingContributionAmount?: {
      amount: number;
      currency: string;
    };
    hasDiscounts?: boolean;
    hasMultiDiscounts?: boolean;
    globalDiscountPercentage?: number;
    paymentTerms?: AnkorstoreInternalPreorderResourcePaymentTermsEnum;
    metadata?: {
      isDiscovery: boolean;
      actualShippingFeeAmount?: {
        amount: number;
        currency: string;
      };
      shippingFeeAmountVat?: {
        amount: number;
        currency: string;
      };
      francoAmount?: null | number;
      discountedShippingAmount?: {
        amount: number;
        currency: string;
      };
      amountLeftForFreeShipping?: {
        amount: number;
        currency: string;
      };
      isEligibleForDiscoveryFreeShipping?: boolean;
      isBrandEligibleForAkPlusFreeShipping?: boolean;
      offerName?: null | string;
    };
  };
  relationships?: {
    preorderItems?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    brand?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    retailer?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

export interface AnkorstoreInternalPreorderBrand {
  internalId: number;
  name: string;
  countryIsoCode: string;
  link: string;
  logoImagePath: string;
  isEnabled: boolean;
  canShipToRetailerCountry: boolean;
}

export interface AnkorstoreInternalPreorderBrandResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    internalId: number;
    name: string;
    countryIsoCode: string;
    link: string;
    logoImagePath: string;
    isEnabled: boolean;
    canShipToRetailerCountry: boolean;
  };
}

export interface AnkorstoreInternalPreorderItem {
  /** @format uuid */
  productVariantId: string;
  quantity: number;
  multipliedQuantity: number;
  /** @format date-time */
  availableAt: string;
  canBeBought?: boolean;
  unitPrice: {
    amount: number;
    currency: string;
  };
  baseAmount: {
    amount: number;
    currency: string;
  };
  amountBeforeDiscount?: {
    amount: number;
    currency: string;
  };
}

export interface AnkorstoreInternalPreorderItemResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** @format uuid */
    productVariantId: string;
    quantity: number;
    multipliedQuantity: number;
    /** @format date-time */
    availableAt: string;
    canBeBought?: boolean;
    unitPrice: {
      amount: number;
      currency: string;
    };
    baseAmount: {
      amount: number;
      currency: string;
    };
    amountBeforeDiscount?: {
      amount: number;
      currency: string;
    };
  };
  relationships?: {
    productVariant?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    order?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

export interface AnkorstoreInternalPreorderItemProductVariant {
  internalId: number;
  name: string;
  sku: string;
  path: string;
  imagePath: string;
  unitMultiplier: number;
  options: {
    name: string;
    value: string;
  }[];
  stock: {
    /**
     * Product-scoped stock status, derived from the currently available
     * stock, `isAlwaysInStock` and `inventoryPolicy`.
     *
     * - `out_of_stock`: there is no stock available to order, i.e.
     *
     *
     *   stock is tracked (`isAlwaysInStock=false`), the
     *   `inventoryPolicy` is `deny`, and the available quantity is
     *   <= 0.
     * - `low_in_stock`: there is little stock left to order, i.e. stock
     *
     *
     *   is tracked (`isAlwaysInStock=false`) and stock is low
     *   (available quantity <= 10, or available quantity < 10% of the
     *   on-hand quantity).
     * - `in_stock`: there is plenty of stock to order (every other
     *
     *
     *   case).
     */
    status: string;
    /**
     * Whether stock is tracked at all for this product variant.
     *
     * - `true`: stock is not tracked — a retailer can order as much of
     *   this variant as they want, with no restriction at all.
     * - `false`: stock is tracked — whether a retailer can order the
     *   variant depends on the available stock quantity and the
     *   `inventoryPolicy`.
     */
    isAlwaysInStock: boolean;
    /**
     * Whether a retailer can order a product variant for which stock is not
     * available.
     *
     * - `deny` (default): no. A retailer cannot order a quantity larger than
     *
     *
     *   the currently available stock quantity, so the variant cannot be
     *   ordered when it is out of stock, or when the desired quantity exceeds
     *   the available quantity.
     * - `continue`: yes. The retailer can order any quantity, even when stock
     *
     *
     *   is insufficient (desired quantity > available quantity > 0) or the
     *   variant is out of stock (available quantity <= 0).
     *
     * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
     * @default "deny"
     */
    inventoryPolicy: AnkorstoreInternalPreorderItemProductVariantInventoryPolicyEnum;
    availableQuantity?: number;
  };
}

export interface AnkorstoreInternalPreorderItemProductVariantResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    internalId: number;
    name: string;
    sku: string;
    path: string;
    imagePath: string;
    unitMultiplier: number;
    options: {
      name: string;
      value: string;
    }[];
    stock: {
      /**
       * Product-scoped stock status, derived from the currently available
       * stock, `isAlwaysInStock` and `inventoryPolicy`.
       *
       * - `out_of_stock`: there is no stock available to order, i.e.
       *
       *
       *   stock is tracked (`isAlwaysInStock=false`), the
       *   `inventoryPolicy` is `deny`, and the available quantity is
       *   <= 0.
       * - `low_in_stock`: there is little stock left to order, i.e. stock
       *
       *
       *   is tracked (`isAlwaysInStock=false`) and stock is low
       *   (available quantity <= 10, or available quantity < 10% of the
       *   on-hand quantity).
       * - `in_stock`: there is plenty of stock to order (every other
       *
       *
       *   case).
       */
      status: string;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of
       *
       *
       *   this variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy: AnkorstoreInternalPreorderItemProductVariantResourceInventoryPolicyEnum;
      availableQuantity?: number;
    };
  };
}

export interface AnkorstoreInternalUpdatePreorderSelection {
  selectedPreorderIds: string[];
}

export interface AnkorstoreInternalUpdatePreordersCart {
  data?: {
    attributes?: {
      items?: (
        | {
            /** @format uuid */
            productVariantId: string;
            quantity: number;
          }
        | {
            /** @format uuid */
            preorderItemId: string;
            quantity: number;
          }
      )[];
    };
  };
}

export interface AnkorstoreInternalPreorderPaymentTerm {
  name: AnkorstoreInternalPreorderPaymentTermNameEnum;
}

export interface AnkorstoreInternalPreorderPaymentTermResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    name: AnkorstoreInternalPreorderPaymentTermResourceNameEnum;
  };
}

export interface AnkorstoreInternalOrderRetailerResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    id: null | number;
    name: string;
    store_url: null | string;
    /** @format email */
    email: string;
    phone_number: string;
    city: string;
    postal_code?: string;
    address_line?: string;
    company_name?: string;
    business: {
      vat_number: null | string;
      tax_number: null | string;
      user_first_name?: null | string;
      user_last_name?: null | string;
      country: {
        iso_code: string;
      };
    };
  };
}

export interface AnkorstoreInternalPreorderOrder {
  master_order_uuid?: string;
  payment_status?: AnkorstoreInternalPreorderOrderPaymentStatusEnum;
  /** @format date-time */
  payment_capture_end_date?: string;
}

export interface AnkorstoreInternalPreorderOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    master_order_uuid?: string;
    payment_status?: AnkorstoreInternalPreorderOrderResourcePaymentStatusEnum;
    /** @format date-time */
    payment_capture_end_date?: string;
  };
}

export interface AnkorstoreInternalExternalOrder {
  /** @format uuid */
  masterOrderUuid: string;
}

export interface AnkorstoreInternalExternalOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format uuid */
    masterOrderUuid: string;
  };
}

export interface AnkorstoreInternalPspAmount {
  /**
   * Amount in cents
   * @example 150000
   */
  value: number;
  /**
   * ISO 4217 currency code
   * @example "EUR"
   */
  currency: string;
}

export interface AnkorstoreInternalPspMandate {
  /** Last 4 digits of the IBAN associated with the active SDD mandate (null when no active mandate) */
  ibanLast4: null | string;
  /** Date the mandate was signed (ISO 8601 date format, null when no active mandate) */
  signatureDate: null | string;
  /**
   * Company name associated with the mandate
   * @example "Acme Corp"
   */
  companyName: string;
}

export interface AnkorstoreInternalPspRetailerAccountAttributes {
  /**
   * Current state of the retailer PSP account
   * @example "ACTIVE_WITH_MANDATE"
   */
  state: AnkorstoreInternalPspRetailerAccountAttributesStateEnum;
  availableAmount: {
    /**
     * Amount in cents
     * @example 150000
     */
    value: number;
    /**
     * ISO 4217 currency code
     * @example "EUR"
     */
    currency: string;
  };
  totalAmount: {
    /**
     * Amount in cents
     * @example 150000
     */
    value: number;
    /**
     * ISO 4217 currency code
     * @example "EUR"
     */
    currency: string;
  };
  unpaidAmount: {
    /**
     * Amount in cents
     * @example 150000
     */
    value: number;
    /**
     * ISO 4217 currency code
     * @example "EUR"
     */
    currency: string;
  };
  mandate: {
    /** Last 4 digits of the IBAN associated with the active SDD mandate (null when no active mandate) */
    ibanLast4: null | string;
    /** Date the mandate was signed (ISO 8601 date format, null when no active mandate) */
    signatureDate: null | string;
    /**
     * Company name associated with the mandate
     * @example "Acme Corp"
     */
    companyName: string;
  };
  /**
   * ISO 3166-1 alpha-2 country code of the retailer
   * @example "FR"
   */
  countryCode: string;
  /** URL to the KYC onboarding page for the PSP (null when KYC is already completed or not applicable) */
  kycLink?: null | string;
  /** Email address of the debtor (null when not available) */
  email?: null | string;
  /** Type of the business identifier (null when not available) */
  identifierType?: null | string;
  /** Value of the business identifier (null when not available) */
  identifierValue?: null | string;
  /** Identifier of the retailer account within the PSP system (null for AKS) */
  pspId?: null | string;
}

/**
 * PspRetailerAccountResource
 * A retailer account with a Payment Service Provider
 */
export interface AnkorstoreInternalPspRetailerAccountResource {
  /**
   * [resource object type](https://jsonapi.org/format/#document-resource-object-identification)
   * @example "retailer-psp-accounts"
   */
  type: string;
  /**
   * PSP identifier (e.g. "aks", "aria")
   * @example "aks"
   */
  id: string;
  attributes: {
    /**
     * Current state of the retailer PSP account
     * @example "ACTIVE_WITH_MANDATE"
     */
    state: AnkorstoreInternalPspRetailerAccountResourceStateEnum;
    availableAmount: {
      /**
       * Amount in cents
       * @example 150000
       */
      value: number;
      /**
       * ISO 4217 currency code
       * @example "EUR"
       */
      currency: string;
    };
    totalAmount: {
      /**
       * Amount in cents
       * @example 150000
       */
      value: number;
      /**
       * ISO 4217 currency code
       * @example "EUR"
       */
      currency: string;
    };
    unpaidAmount: {
      /**
       * Amount in cents
       * @example 150000
       */
      value: number;
      /**
       * ISO 4217 currency code
       * @example "EUR"
       */
      currency: string;
    };
    mandate: {
      /** Last 4 digits of the IBAN associated with the active SDD mandate (null when no active mandate) */
      ibanLast4: null | string;
      /** Date the mandate was signed (ISO 8601 date format, null when no active mandate) */
      signatureDate: null | string;
      /**
       * Company name associated with the mandate
       * @example "Acme Corp"
       */
      companyName: string;
    };
    /**
     * ISO 3166-1 alpha-2 country code of the retailer
     * @example "FR"
     */
    countryCode: string;
    /** URL to the KYC onboarding page for the PSP (null when KYC is already completed or not applicable) */
    kycLink?: null | string;
    /** Email address of the debtor (null when not available) */
    email?: null | string;
    /** Type of the business identifier (null when not available) */
    identifierType?: null | string;
    /** Value of the business identifier (null when not available) */
    identifierValue?: null | string;
    /** Identifier of the retailer account within the PSP system (null for AKS) */
    pspId?: null | string;
  };
}

export interface AnkorstoreInternalRetailerAvailableCredit {
  /** @example 15000 */
  amount?: number;
  /** @example "EUR" */
  currency?: string;
}

/**
 * RetailerAvailableCreditResource
 * Retailer available credit resource
 */
export interface AnkorstoreInternalRetailerAvailableCreditResource {
  /**
   * [resource object type](https://jsonapi.org/format/#document-resource-object-identification)
   * @example "retailer-available-credit"
   */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** @example 15000 */
    amount?: number;
    /** @example "EUR" */
    currency?: string;
  };
}

export interface AnkorstoreInternalRetailerAksFinancing {
  payment_methods?: {
    /**
     * Last 4 digits of the IBAN. null if not set up.
     * @example "1234"
     */
    iban_last4?: string | null;
    /**
     * ISO 8601 date when the mandate was signed.
     * @format date-time
     * @example "2024-01-15T10:00:00+00:00"
     */
    signed_at?: string | null;
    /**
     * Company name associated with the mandate.
     * @example "Acme Corp"
     */
    company_name?: string | null;
    /**
     * Whether the mandate is currently active. null if not set up.
     * @example true
     */
    has_active_mandate?: boolean | null;
  };
  credit_limit?: {
    available_amount?: {
      /**
       * @format float
       * @example 1000
       */
      value?: number;
      /** @example "EUR" */
      currency?: string;
    };
  } | null;
}

/**
 * RetailerAksFinancingResource
 * Retailer AKS financing resource
 */
export interface AnkorstoreInternalRetailerAksFinancingResource {
  /** @example "retailer-aks-financing" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    payment_methods?: {
      /**
       * Last 4 digits of the IBAN. null if not set up.
       * @example "1234"
       */
      iban_last4?: string | null;
      /**
       * ISO 8601 date when the mandate was signed.
       * @format date-time
       * @example "2024-01-15T10:00:00+00:00"
       */
      signed_at?: string | null;
      /**
       * Company name associated with the mandate.
       * @example "Acme Corp"
       */
      company_name?: string | null;
      /**
       * Whether the mandate is currently active. null if not set up.
       * @example true
       */
      has_active_mandate?: boolean | null;
    };
    credit_limit?: {
      available_amount?: {
        /**
         * @format float
         * @example 1000
         */
        value?: number;
        /** @example "EUR" */
        currency?: string;
      };
    } | null;
  };
}

/** PaymentResource */
export interface AnkorstoreInternalSchemasPaymentResource {
  type: 'purchase-payments';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    psp: AnkorstoreInternalSchemasPaymentResourcePspEnum;
    paymentMethod: AnkorstoreInternalSchemasPaymentResourcePaymentMethodEnum;
    pspData: {
      /** Stripe PaymentIntent ID for `sepa_credit_transfer` payment method, or Stripe SetupIntent ID for of `sepa_direct_debit` payment method. */
      pspId?: string;
      clientSecret?: string;
      /** Indicates whether there is an active mandate for the `sepa_direct_debit` payment method. */
      hasActiveMandate?: boolean;
    };
  };
}

export interface AnkorstoreInternalAmountObject {
  /** Amount in cents. */
  amount: number;
  /**
   * ISO 4217 currency code.
   * @example "EUR"
   */
  currencyCode: string;
}

/**
 * Payment methods provisioned by AnkorPay to let the retailer settle an outstanding
 * payment. A method key is present only when that method has been **provisioned**.
 *
 * Absence does NOT mean the method is permanently unavailable, and must never be
 * presented to the retailer as such. A method can be absent because it is not offered
 * for the payment's currency (SEPA credit transfer is provisioned for EUR only), or
 * because provisioning has not run yet, or because it failed and will be retried.
 * Branch on key presence to decide what to render, and use the operation's `currency`
 * if you need to explain *why* a method is missing.
 *
 * The amount charged by these methods is fixed when the recovery is provisioned. It
 * normally equals `remainingAmount` — both derive from the same reconciliation delta —
 * but can lag it if the outstanding balance moves afterwards.
 *
 * BIC and beneficiary name are deliberately not carried here: AnkorPay does not store
 * them, and they are fixed values owned by the client.
 */
export interface AnkorstoreInternalRecoveryPaymentMethodsObject {
  /** Stripe Payment Link for settling the payment by card. */
  card?: {
    /**
     * Stripe-hosted payment page, always `https` on a Stripe host. Treat as a
     * bearer capability: anyone holding the URL can pay it, so do not log it or
     * place it in a shareable surface.
     * @format uri
     * @example "https://buy.stripe.com/xxxxxxxxxxxx"
     */
    paymentLinkUrl: string;
  };
  /** SEPA credit transfer instructions. Provisioned for EUR payments only. */
  sepaCreditTransfer?: {
    /** Virtual IBAN to transfer to. */
    iban: string;
    /**
     * Transfer reference, unique per recovery. Stripe reconciles the incoming
     * transfer by this value, so it must be shown to the retailer verbatim and
     * never substituted, truncated, or reformatted.
     */
    reference: string;
  };
}

/** OperationResource */
export interface AnkorstoreInternalOperationResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format date-time */
    submittedAt: string;
    paymentTerms?: AnkorstoreInternalOperationResourcePaymentTermsEnum | null;
    paymentMethodType?: AnkorstoreInternalOperationResourcePaymentMethodTypeEnum | null;
    /**
     * ISO 4217 currency code.
     * @example "EUR"
     */
    currency: string;
    retailerGrandTotalAmountWithVat: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    };
    /** @format date-time */
    dueAt?: string | null;
    /**
     * Human-readable payment reference minted by AnkorPay, `PAY-YYMM-XXXXXX` (fixed 15
     * characters): a constant `PAY` prefix, the 2-digit year and month of the payment,
     * and a 6-character Crockford Base32 identifier (no `I`, `L`, `O` or `U`). Unique
     * across all payments, and the handle to display for both checkout- and order-level
     * operations.
     *
     * Treat it as an opaque string: do not parse the date segment or derive anything
     * from it. Null when AnkorPay has no reference for the payment, and for operations
     * not backed by an AnkorPay payment — fall back to `label` in that case.
     * @pattern ^PAY-[0-9]{4}-[0-9A-HJKMNP-TV-Z]{6}$
     * @example "PAY-2608-EA67G5"
     */
    reference: string | null;
    /**
     * Display label for the operation (`#<checkout/order id>`). Interim fallback for
     * operations with no `reference`; prefer `reference` as the payment handle.
     */
    label: string;
    fundedBy?: AnkorstoreInternalOperationResourceFundedByEnum | null;
    paymentStatus?: AnkorstoreInternalOperationResourcePaymentStatusEnum | null;
    /**
     * Granular buyer-facing payment status from AnkorPay. Provides the full 11-value status
     * used in the drawer, compared to the coarser 5-value `paymentStatus`.
     * Values:
     *
     *
     *   - `on_reception` — payment due once the order is received
     *   - `upcoming_debit` — deferred payment awaiting charge (due date in the future)
     *   - `delayed` — deferred payment where due date has passed but charge not yet initiated
     *   - `payment_in_progress` — charge is being processed
     *   - `paid_successfully` — payment confirmed and settled
     *   - `payment_recovered_successfully` — failed payment recovered via recovery plan
     *   - `payment_unsuccessful` — charge failed with no recovery plan
     *   - `partial_recovery_failed` — recovery in progress, some attempts failed
     *   - `payment_recovered_failed` — all recovery attempts failed
     *   - `cancelled` — payment cancelled, no refund
     *   - `cancelled_refunded` — payment cancelled with refund issued
     */
    paymentInnerStatus?: AnkorstoreInternalOperationResourcePaymentInnerStatusEnum | null;
    /** Amount refunded in cents. Only present when `paymentInnerStatus` is `cancelled_refunded`. */
    refundedAmount?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Remaining amount still owed by the buyer in cents.
     * Only present when `paymentInnerStatus` is `partial_recovery_failed` or `payment_recovered_failed`.
     */
    remainingAmount?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Date when the payment was successfully recovered.
     * Only present when `paymentInnerStatus` is `payment_recovered_successfully`.
     */
    recoveryDate?: string | null;
    /**
     * How the retailer can settle this payment when it is outstanding. Present on
     * both the show and list endpoints when the payment is `ankorstore`-funded, not
     * yet paid or cancelled, and carries an active `ankorstore`-source recovery
     * whose payment methods have been provisioned.
     *
     * `null` when:
     * - The payment is funded by a third party (e.g. Aria).
     * - The payment has already been paid (`paidAt` is set) or cancelled (`cancelledAt` is set).
     * - There is no active recovery, or the recovery source is not `ankorstore`.
     * - The recovery's payment methods have not yet been provisioned (provisioning
     *
     *
     *   is asynchronous: a recovery is opened before its payment link exists, so
     *   this stays `null` for approximately one to three days after recovery starts).
     */
    recoveryPaymentMethods?: {
      /** Stripe Payment Link for settling the payment by card. */
      card?: {
        /**
         * Stripe-hosted payment page, always `https` on a Stripe host. Treat as a
         * bearer capability: anyone holding the URL can pay it, so do not log it or
         * place it in a shareable surface.
         * @format uri
         * @example "https://buy.stripe.com/xxxxxxxxxxxx"
         */
        paymentLinkUrl: string;
      };
      /** SEPA credit transfer instructions. Provisioned for EUR payments only. */
      sepaCreditTransfer?: {
        /** Virtual IBAN to transfer to. */
        iban: string;
        /**
         * Transfer reference, unique per recovery. Stripe reconciles the incoming
         * transfer by this value, so it must be shown to the retailer verbatim and
         * never substituted, truncated, or reformatted.
         */
        reference: string;
      };
    } | null;
    /**
     * The UUID of the entity the AnkorPay operation was raised against. Which entity that is
     * depends on `externalType`: a checkout UUID when `externalType` is `checkout`, an order
     * UUID when it is `order`.
     * Only present for operations sourced from AnkorPay.
     */
    externalId?: string | null;
    /**
     * The kind of entity `externalId` refers to, and therefore what the operation pays for:
     *
     *
     *   - `checkout` — the operation covers the whole checkout. `orders` holds every order of
     *     that checkout, and checkout-scoped fee/discount lines appear at the operation root.
     *   - `order` — the operation covers a single order. `orders` holds exactly one entry, and
     *     the operation root carries no `billingItems` or `invoices`: the funded order owns
     *     its entire breakdown.
     *
     * Only present for operations sourced from AnkorPay. The set of types is expected to grow
     * (e.g. brand service invoices), so treat an unrecognised value as unsupported rather than
     * falling back to `checkout`.
     */
    externalType?: AnkorstoreInternalOperationResourceExternalTypeEnum | null;
    /**
     * Date when the payment was cancelled. Always present; `null` until the
     * operation is cancelled.
     */
    cancelledAt: string | null;
    /**
     * Date when the payment was successfully collected (debited). Always present;
     * `null` until the operation is paid.
     */
    paidAt: string | null;
    /**
     * Net total including VAT of the operation-level fee/discount billing items (fees positive,
     * discounts negative), computed on the backend. Includes pre-2025 orders' shipping lines and
     * excludes 2025-business-model orders' shipping (exposed as dedicated order amounts). 0 when
     * there are none; null on the listing endpoint, where it is not computed.
     */
    totalBillingItemsAmountWithVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Relative URL to download this operation's invoices as a zip, resolved on the backend from the
     * operation's backing entity so the client never constructs it or branches on `externalType`:
     * a checkout-backed operation points at the whole-checkout download, an order-backed one at that
     * single order's download. Null when there is no downloadable backing entity (absent/unknown
     * `externalType` or `externalId`).
     */
    invoicesDownloadUrl?: string | null;
  };
  relationships: {
    /**
     * The orders this operation pays for: every order of the checkout when `externalType` is
     * `checkout`, and exactly one entry — the funded order — when it is `order`.
     */
    orders?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    /**
     * Checkout-level billing items targeted at the retailer (e.g. service fees). Only present
     * when requested via `include=billingItems`, and always empty when `externalType` is
     * `order` — an order-level operation carries its breakdown on the funded order instead.
     */
    billingItems?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    /** Checkout-level invoices (e.g. proforma). Only present when requested via `include=invoices`. */
    invoices?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

export interface AnkorstoreInternalOperationOrderResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Order status. */
    status?: string | null;
    /** Human-readable status detail. */
    statusDetailsTitle?: string | null;
    /** Display label for the order. */
    label: string;
    /** Products total excluding VAT. Sourced from Order::retailer_total_amount. */
    totalAmount?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * VAT portion of the products total, exposed so the client can display the products
     * subtotal and VAT separately. Sourced from Order::retailer_total_amount_vat.
     */
    totalAmountVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Products total including VAT, excluding shipping
     * (products ex-VAT = totalAmountWithVat - totalAmountVat).
     * Sourced from Order::retailer_total_amount_with_vat.
     */
    totalAmountWithVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Products total including VAT plus shipping. Only present for orders created under the
     * 2025 business model, where shipping is part of the brand↔retailer order invoice; null
     * for pre-2025-business-model orders (where shipping is retailer↔Ankorstore and stays in
     * the fees & discounts section). Lets the client render the order subtotal including or
     * excluding shipping per business model without a discriminator flag.
     */
    totalAmountWithVatIncludingShipping?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Shipping fee excluding VAT. Present only for orders created under the 2025 business model,
     * where shipping belongs to the brand↔retailer order invoice and is exposed as a dedicated
     * amount rather than a fee/discount line; null for pre-2025-business-model orders, where
     * shipping is a billing-item line at the operation level instead. Sourced from the order's
     * retailer_shipping_fees billing items.
     */
    totalShippingFees?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /** VAT portion of the shipping fee. Same 2025-business-model-only rule as totalShippingFees. */
    totalShippingFeesVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Net total including VAT of this order's fee/discount billing items (fees positive, discounts
     * negative). Null when the order carries no such lines. Excludes shipping for 2025-business-model
     * orders (exposed via totalShippingFees) and any line surfaced at the operation level instead.
     */
    totalBillingItemsAmountWithVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * Net amount the retailer pays for this order (order total incl. VAT plus its billing items).
     * Sourced from Order::retailer_net_amount.
     */
    netAmount?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /**
     * UUID of the master order this sub-order belongs to.
     * @format uuid
     */
    masterOrderUuid?: string | null;
  };
  relationships?: {
    brand?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    billingItems?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    invoices?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

export interface AnkorstoreInternalOperationBrandResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Brand name. */
    name: string;
    images: {
      squaredPath: string | null;
      roundedPath: string | null;
      largePath: string | null;
    };
  };
}

export interface AnkorstoreInternalOperationBillingItemResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    amount?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    amountVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    amountWithVat?: {
      /** Amount in cents. */
      amount: number;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currencyCode: string;
    } | null;
    /** Human-readable label for the billing item. */
    label?: string | null;
    /** Human-readable VAT label for the billing item. */
    vatLabel?: string | null;
    /** Whether VAT should be displayed for this billing item. */
    displayVat?: boolean | null;
    /**
     * Identifier of the offer programme this line belongs to (e.g. `ankorstore_plus`), or null
     * when the line is not an offer benefit. Lets the client badge PLUS benefits (shipping fee
     * waived, deferred payment fee waived, …) without parsing the localized label.
     */
    offerName?: string | null;
  };
}

export interface AnkorstoreInternalOperationOrderInvoiceResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Invoice number, used as identifier. */
  id: string;
  attributes: {
    /** Invoice type. */
    type: AnkorstoreInternalOperationOrderInvoiceResourceTypeEnum;
    /** Human-readable label for the invoice. */
    title: string;
    /** Download path for the invoice PDF, null if not yet generated. */
    link: string | null;
  };
}

export interface AnkorstoreInternalOperationCheckoutInvoiceResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Invoice number, used as identifier. */
  id: string;
  attributes: {
    /** Human-readable label for the invoice. */
    title: string;
    /** Download path for the invoice PDF, null if not yet generated. */
    link: string | null;
  };
}

export enum AnkorstoreInternalInvoiceStatus {
  ProForma = 'pro_forma',
  Paid = 'paid',
  PaymentFailed = 'payment failed',
  PaymentPending = 'payment pending',
  PaymentProcessing = 'payment_processing',
  Disputed = 'disputed',
}

export interface AnkorstoreInternalServiceInvoice {
  /**
   * The invoice number
   * @pattern ^AKS-\d{6}-\d{9}$
   */
  invoiceNumber?: string | null;
  /** Total amount for the item, excluding VAT (in EUR & in minor units) */
  totalAmount?: number;
  /** Total amount of VAT for the item (in EUR & in minor units) */
  totalVat?: number;
  /** Total amount for the item, including VAT (in EUR & in minor units) */
  totalAmountWithVat?: number;
  /**
   * The date that invoiced this service invoice
   * @format datetime
   */
  invoicedAt?: string;
  status?: AnkorstoreInternalServiceInvoiceStatusEnum;
  /**
   * The period for which the invoice is issued
   * @pattern ^(\d{2}-)?(\d{2}-)?\d{4}$
   */
  invoicePeriod?: string;
  /** Service type of the invoice */
  serviceType?: AnkorstoreInternalServiceInvoiceServiceTypeEnum;
  /**
   * PDF contents, base64 encoded
   * @format byte
   */
  content?: string;
}

export interface AnkorstoreInternalServiceInvoiceResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * The invoice number
     * @pattern ^AKS-\d{6}-\d{9}$
     */
    invoiceNumber?: string | null;
    /** Total amount for the item, excluding VAT (in EUR & in minor units) */
    totalAmount?: number;
    /** Total amount of VAT for the item (in EUR & in minor units) */
    totalVat?: number;
    /** Total amount for the item, including VAT (in EUR & in minor units) */
    totalAmountWithVat?: number;
    /**
     * The date that invoiced this service invoice
     * @format datetime
     */
    invoicedAt?: string;
    status?: AnkorstoreInternalServiceInvoiceResourceStatusEnum;
    /**
     * The period for which the invoice is issued
     * @pattern ^(\d{2}-)?(\d{2}-)?\d{4}$
     */
    invoicePeriod?: string;
    /** Service type of the invoice */
    serviceType?: AnkorstoreInternalServiceInvoiceResourceServiceTypeEnum;
    /**
     * PDF contents, base64 encoded
     * @format byte
     */
    content?: string;
  };
}

/**
 * InvoiceExportResource
 * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"invoice-export","attributes":{"invoiced_at_from":"2023-01-01T00:00:00.000000Z","invoiced_at_to":"2023-12-31T23:59:59.000000Z","finished_at":"2024-01-05T10:37:27.000000Z","expires_at":"2024-01-06T10:37:27.000000Z","download_links":["https://ankorlocal.com/api/internal/v1/invoice-exports/1eeabb66-b239-6f70-b2d5-0242ac12000b/zip-file/25387/download"]}}
 */
export interface AnkorstoreInternalInvoiceExportResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Datetime from which invoices are taken
     * @format datetime
     */
    invoiced_at_from: string;
    /**
     * Datetime to which invoices are taken
     * @format datetime
     */
    invoiced_at_to: string;
    /**
     * Datetime when export is finished
     * @format datetime
     */
    finished_at: string;
    /**
     * Datetime when export expires
     * @format datetime
     */
    expires_at: string;
    /** Download urls of parts of invoice export */
    download_links: string[];
  };
}

export interface AnkorstoreInternalPaymentServiceProviderCustomer {
  /** Ankstore customer ID e.g. brand_id, retailer_id etc. */
  aksCustomerId: number;
  /** Ankstore customer type e.g. Brand, Retailer etc. */
  aksCustomerType: AnkorstoreInternalPaymentServiceProviderCustomerAksCustomerTypeEnum;
  /** Customer ID from payment service provider */
  customerId: string;
  /** Intent Setup ID for future payments from payment service provider */
  setupIntentId?: string | null;
  paymentServiceProvider: string;
  email?: string;
  description?: string;
  name?: string;
  mandateType: AnkorstoreInternalPaymentServiceProviderCustomerMandateTypeEnum;
  mandateStatus?: AnkorstoreInternalPaymentServiceProviderCustomerMandateStatusEnum;
}

export interface AnkorstoreInternalPaymentServiceProviderCustomerResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Ankstore customer ID e.g. brand_id, retailer_id etc. */
    aksCustomerId: number;
    /** Ankstore customer type e.g. Brand, Retailer etc. */
    aksCustomerType: AnkorstoreInternalPaymentServiceProviderCustomerResourceAksCustomerTypeEnum;
    /** Customer ID from payment service provider */
    customerId: string;
    /** Intent Setup ID for future payments from payment service provider */
    setupIntentId?: string | null;
    paymentServiceProvider: string;
    email?: string;
    description?: string;
    name?: string;
    mandateType: AnkorstoreInternalPaymentServiceProviderCustomerResourceMandateTypeEnum;
    mandateStatus?: AnkorstoreInternalPaymentServiceProviderCustomerResourceMandateStatusEnum;
  };
}

export interface AnkorstoreInternalSetupIntent {
  /** Setup Intent client secret */
  clientSecret?: string;
  /** Last 4 characters of Setup Intent Sepa Debit iban */
  ibanLast4?: string;
}

export interface AnkorstoreInternalSetupIntentResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** @pattern [A-Z_0-9a-z]+ */
  id: string;
  attributes: {
    /** Setup Intent client secret */
    clientSecret?: string;
    /** Last 4 characters of Setup Intent Sepa Debit iban */
    ibanLast4?: string;
  };
}

export interface AnkorstoreInternalCardSetupIntent {
  /** Card Setup Intent client secret */
  clientSecret: string;
  /** Card details associated with the Setup Intent */
  cardDetails: {
    /** Card brand e.g. Visa, MasterCard etc. */
    brand?: string;
    /** Last 4 digits of the card number */
    last4?: string;
    /** Card expiry month */
    expMonth?: string;
    /** Card expiry year */
    expYear?: string;
  } | null;
}

export interface AnkorstoreInternalCardSetupIntentResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** @pattern [A-Z_0-9a-z]+ */
  id: string;
  attributes: {
    /** Card Setup Intent client secret */
    clientSecret: string;
    /** Card details associated with the Setup Intent */
    cardDetails: {
      /** Card brand e.g. Visa, MasterCard etc. */
      brand?: string;
      /** Last 4 digits of the card number */
      last4?: string;
      /** Card expiry month */
      expMonth?: string;
      /** Card expiry year */
      expYear?: string;
    } | null;
  };
}

export interface AnkorstoreInternalRetailerBrand {
  /** Brand name */
  name: string;
  /** Set of brand image links, in different formats */
  images: {
    /** @format uri */
    rounded?: string | null;
    /** @format uri */
    squared?: string | null;
    /** @format uri */
    large?: string | null;
  };
}

export interface AnkorstoreInternalRetailerBrandResource {
  type: 'retailer-brands';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Brand name */
    name: string;
    /** Set of brand image links, in different formats */
    images: {
      /** @format uri */
      rounded?: string | null;
      /** @format uri */
      squared?: string | null;
      /** @format uri */
      large?: string | null;
    };
  };
}

/** [OK](https://jsonapi.org/format/#fetching-resources-responses-200) */
export interface AnkorstoreInternalProductSpreadsheetMappingResponseContent {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    self?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      uuid?: string;
      name?: number;
      user_id?: number;
      is_custom?: boolean;
      configuration?: {
        identifier?: string;
        field?: string | number | null;
        missingValue?: string | null;
        emptyValue?: string | null;
        behavior?: string | null;
      }[];
    };
    links?: {
      self?: string;
    };
  };
}

/**
 * [OK](https://jsonapi.org/format/#fetching-resources-responses-200)
 * @example {"jsonapi":{"version":"1.0"},"links":{"self":"http://www.ankorlocal.com:8000/api/internal/v1/integrations/1ed3fd06-050a-6a00-8009-0242ac120003"},"data":{"type":"integrations","id":"1ed3fd06-050a-6a00-8009-0242ac120003","attributes":{"id":9,"brand_id":22408,"type":"rutter","platform":null,"status":"integrated","platform_product_id":"7636912570603","external_product_id":"198d8bbc-cdb7-469c-a4f8-472e0d1841ca","internal_product_id":null,"internal_state":{"images":[],"name":"Juicy Orange","description":"Such a wonderful orange, you should buy it 1","unit_multiplier":2,"currency":"EUR","discount_rate":0,"retail_price":{"amount":20,"currency":"EUR"},"wholesale_price":{"amount":10,"currency":"EUR"},"original_wholesale_price":{"amount":10,"currency":"EUR"},"vat_rate":21,"categories":[{"id":1269,"name":"Gourmet","parent_id":1262}],"properties":[],"tags":[{"name":"tags_fresh_product"}],"made_in":null,"hs_code":null,"variants":[{"id":null,"sku":"orng-1","ian":"1234567891234","price":{"currency":"EUR","retail_price":{"amount":20,"currency":"EUR"},"wholesale_price":{"amount":10,"currency":"EUR"},"original_wholesale_price":{"amount":10,"currency":"EUR"},"discount_rate":0},"stock":{"id":null,"stock_quantity":16,"is_always_in_stock":false,"reserved_quantity":0,"available_quantity":16},"shape_properties":[{"id":null,"weight":0.1,"weight_unit":"kg","length":0.1,"width":0.1,"height":0.1,"length_unit":"cm","capacity":0.1,"capacity_unit":"l"}],"options":[{"id":3,"name":"other","value":"Default Title"}],"name":null,"created_at":null,"images":[{"filename":"https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081","order":1}]}]},"issues":[],"internal_state_updated_at":"2022-09-30T14:27:32.793045Z","integrated_at":null,"created_at":"2022-08-05T13:32:31.713000Z","updated_at":"2022-09-30T14:27:32.811189Z"},"links":{"self":"http://www.ankorlocal.com:8000/api/internal/v1/integrations/1ed3fd06-050a-6a00-8009-0242ac120003"}}}
 */
export interface AnkorstoreInternalProductIntegrationResponseContent {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    self?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      id?: number;
      brand_id?: number;
      type?: string;
      platform?: null;
      status?: string;
      platform_product_id?: string;
      external_product_id?: string;
      internal_product_id?: null;
      internal_state?: {
        images?: object[];
        name?: string;
        description?: string;
        unit_multiplier?: number;
        currency?: string;
        discount_rate?: number;
        retail_price?: {
          amount?: number;
          currency?: string;
        };
        wholesale_price?: {
          amount?: number;
          currency?: string;
        };
        original_wholesale_price?: {
          amount?: number;
          currency?: string;
        };
        vat_rate?: number;
        categories?: {
          id?: number;
          name?: string;
          parent_id?: number;
        }[];
        properties?: object[];
        tags?: {
          name?: string;
        }[];
        made_in?: null;
        hs_code?: null;
        variants?: {
          id?: null;
          sku?: string;
          ian?: string;
          price?: {
            currency?: string;
            retail_price?: {
              amount?: number;
              currency?: string;
            };
            wholesale_price?: {
              amount?: number;
              currency?: string;
            };
            original_wholesale_price?: {
              amount?: number;
              currency?: string;
            };
            discount_rate?: number;
          };
          stock?: {
            id?: null;
            stock_quantity?: number;
            /**
             * Whether stock is tracked at all for
             * this product variant.
             *
             * - `true`: stock is not tracked — a
             *   retailer can order as much of this
             *   variant as they want, with no
             *   restriction at all.
             * - `false`: stock is tracked — whether
             *   a retailer can order the variant
             *   depends on the available stock
             *   quantity and the `inventory_policy`.
             */
            is_always_in_stock?: boolean;
            /**
             * Whether a retailer can order a product
             * variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer
             *   cannot order a quantity larger than
             *   the currently available stock
             *   quantity, so the variant cannot be
             *   ordered when it is out of stock, or
             *   when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can
             *   order any quantity, even when stock
             *   is insufficient (desired quantity >
             *   available quantity > 0) or the
             *   variant is out of stock (available
             *   quantity <= 0).
             *
             * Only meaningful when stock is tracked
             * (`is_always_in_stock = false`).
             * @default "deny"
             */
            inventory_policy?: AnkorstoreInternalProductIntegrationResponseContentInventoryPolicyEnum;
            reserved_quantity?: number;
            available_quantity?: number;
          };
          shape_properties?: {
            id?: number | null;
            /** @format float */
            weight?: number;
            weight_unit?: string;
            /** @format float */
            length?: number;
            /** @format float */
            width?: number;
            /** @format float */
            height?: number;
            length_unit?: string;
            /** @format float */
            capacity?: number;
            capacity_unit?: string;
          }[];
          options?: {
            id?: number;
            name?: string;
            value?: string;
          }[];
          name?: null;
          created_at?: null;
          images?: {
            filename?: string;
            order?: number;
          }[];
        }[];
      };
      issues?: object[];
      internal_state_updated_at?: string;
      integrated_at?: null;
      created_at?: string;
      updated_at?: string;
    };
    links?: {
      self?: string;
    };
  };
}

/** CatalogIntegrationBrandConfig */
export interface AnkorstoreInternalCatalogIntegrationBrandConfig {
  images_google_folder_url?: string;
  empty_xlsx_download_link?: string;
  generated_google_spreadsheet?: {
    instructions_sheet_url?: string;
    data_sheet_url?: string;
  };
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  updated_at?: string;
}

export interface AnkorstoreInternalCatalogIntegrationBrandConfigResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  /** CatalogIntegrationBrandConfig */
  attributes?: {
    images_google_folder_url?: string;
    empty_xlsx_download_link?: string;
    generated_google_spreadsheet?: {
      instructions_sheet_url?: string;
      data_sheet_url?: string;
    };
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    updated_at?: string;
  };
}

/** ProductIntegrationBatchItem */
export interface AnkorstoreInternalProductIntegrationBatch {
  fetched_count?: number;
  imported_count?: number;
  integrated_count?: number;
  failed_count?: number;
  created_count?: number;
  updated_count?: number;
  type?: string;
  import_type?: AnkorstoreInternalProductIntegrationBatchImportTypeEnum;
  workflow?: AnkorstoreInternalProductIntegrationBatchWorkflowEnum;
  status?: string;
  user_id?: number;
  pimimport_job_id?: string;
}

export interface AnkorstoreInternalProductIntegrationBatchResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  /** ProductIntegrationBatchItem */
  attributes?: {
    fetched_count?: number;
    imported_count?: number;
    integrated_count?: number;
    failed_count?: number;
    created_count?: number;
    updated_count?: number;
    type?: string;
    import_type?: AnkorstoreInternalProductIntegrationBatchResourceImportTypeEnum;
    workflow?: AnkorstoreInternalProductIntegrationBatchResourceWorkflowEnum;
    status?: string;
    user_id?: number;
    pimimport_job_id?: string;
  };
}

export enum AnkorstoreInternalTemplate {
  ProductsXlsx = 'products.xlsx',
}

export interface AnkorstoreInternalExport {
  /**
   * Unique identifier of the Catalog Export
   * @format uuid
   */
  id?: string;
  /** Type of the Catalog Export */
  type?: 'catalog-export';
  attributes?: {
    /** Status of the Catalog Export */
    status?: AnkorstoreInternalExportStatusEnum;
    template?: AnkorstoreInternalExportTemplateEnum;
    /**
     * URL to download the Catalog Export, this property is only available when the status is completed
     * @format uri
     */
    downloadUrl?: string;
    /** Name of the file */
    filename?: string;
    /**
     * Date and time when the Catalog Export was created
     * @format date-time
     */
    createdAt?: string;
    /**
     * Date and time when the Catalog Export started
     * @format date-time
     */
    startedAt?: string;
    /**
     * Date and time when the Catalog Export completed
     * @format date-time
     */
    completedAt?: string;
  };
}

export interface AnkorstoreInternalTestimonial {
  body?: string;
  authorName?: string;
  authorShopName?: string;
  authorImage?: string;
  country?: string;
}

/** TestimonialResource */
export interface AnkorstoreInternalTestimonialResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    body?: string;
    authorName?: string;
    authorShopName?: string;
    authorImage?: string;
    country?: string;
  };
}

/**
 * CategoryResource
 * @example {"type":"categories","id":"1ed550e3-6ab2-6fb0-8041-0242ac130006","attributes":{"name":"Furniture"},"relationships":{"parent":{"data":{"type":"categories","id":"1ed550e3-505e-6254-803d-0242ac130006"}}}}
 */
export interface AnkorstoreInternalCategoryResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    name: string;
  };
  relationships?: {
    parent: {
      data: {
        type: 'categories';
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
      };
    };
  };
}

export interface AnkorstoreInternalServiceInvoiceItem {
  /**
   * Brand UUID. Required unless the authenticated user is a brand to use instead
   * @format uuid
   */
  brandUuid?: string;
  /** Invoiced item details. May contain linebreaks and/or markdown for formatting */
  description: string;
  /** Service Type used to distinguish what this item is for. */
  serviceType: AnkorstoreInternalServiceInvoiceItemServiceTypeEnum;
  /** Category used for item grouping and sub-totals. May contain linebreaks and/or markdown for formatting */
  category?: string;
  /**
   * Number of units invoiced per item
   * @format float
   */
  quantity: number;
  /**
   * Percentage of VAT to be applied
   * @format float
   */
  vatRate: number;
  /** Amount for one billable unit (in EUR & minor units) */
  unitAmount: number;
  /** Total amount for the item, excluding VAT (in EUR & in minor units) */
  totalAmount?: number;
  /** Total amount of VAT for the item (in EUR & in minor units) */
  totalVat?: number;
  /** Total amount for the item, including VAT (in EUR & in minor units) */
  totalAmountWithVat?: number;
  /**
   * The date that the service charge applies to
   * @format datetime
   */
  incurredAt?: string;
  /**
   * Metadata associated with the item. Keys in use:
   * - merge_key: string to merge multiple items into a single line shown in the invoice
   * - parity_factor: string to define a service items' scope if this is not already
   *
   *
   *                   uniquely defined by the description + category
   * - summary_title: string for a summary entry, for which this should be shown as a sub-item
   * - summary_key: string on which to group items for the summary entry
   * - summary_order: an explicit order (int) at which to show the summary entry, from low to high
   * - item_category: category of the item in order to identify and apply specific processes by catagory (discount per category for instance)
   */
  metadata?: string[];
}

/**
 * BulkOperationResult
 * Single operation result in the list of results in the bulk operation response
 */
export interface AnkorstoreInternalBulkOperationResult {
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: object;
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/**
 * ProductTypeResource
 * A resource that describes a product type
 */
export interface AnkorstoreInternalProductTypeResource {
  /**
   * [The type of resource](https://jsonapi.org/format/#document-resource-object-identification)
   * @default "product-type"
   */
  type: string;
  /**
   * A unique identifier for the product type.
   * @format int64
   */
  id: string;
  attributes: {
    /** A human-readable label for the product type */
    label?: string;
    /** Whether a product can be assigned to this product type or not */
    assignable?: boolean;
    /** Whether this type of product can be sold on the website or not */
    prohibited?: boolean;
  };
  relationships?: {
    /** The product attribute schema */
    schema?: {
      /** Links to the endpoints that describe the attribute schema. */
      links?: {
        /** @format uri-reference */
        related?: string;
      };
    };
  };
}

/**
 * AttributeResource
 * A resource that describes a product attribute
 */
export interface AnkorstoreInternalAttributeResource {
  /**
   * [The type of resource](https://jsonapi.org/format/#document-resource-object-identification)
   * @default "product-attribute"
   */
  type: string;
  /** A globally-unique identifier for the attribute. */
  id: string;
  attributes: {
    /** Describes the type of the attribute */
    attributeType?: AnkorstoreInternalAttributeResourceAttributeTypeEnum;
    /** A human-readable label for the product attribute */
    label?: string;
    inputTip?: string | null;
    inputHint?: string | null;
    /** Describes the requirement level for the attribute */
    requirement?: AnkorstoreInternalAttributeResourceRequirementEnum;
    options?: {
      value?: string;
      label?: string;
    }[];
  };
}

export interface AnkorstoreInternalTreeResponseItem {
  type?: string;
  id?: number;
  attributes?: {
    name?: string;
    isSelectable?: boolean;
    children?: any[];
  };
}

/** LabelCreation */
export interface AnkorstoreInternalLabelCreation {
  /**
   * Our order reference.
   * @pattern ^O_[A-Z0-9]+_[0-9]+$
   */
  fulfillmentOrderReference: string;
  /**
   * The container reference that uniquely identify the box on which the label is sticked
   * @pattern ^O_[A-Z0-9]+_[0-9]+-[0-9]+$
   */
  containerReference: string;
  /** The fulfillment center internal shipment reference */
  shipmentReference?: string;
  /** Format: AKS_{GEOGRAPHICAL-CLUSTER}_{LAST-MILE-CARRIER} */
  service: AnkorstoreInternalLabelCreationServiceEnum;
  /**
   * cm
   * @exclusiveMin 0
   */
  width: number;
  /**
   * cm
   * @exclusiveMin 0
   */
  height: number;
  /**
   * cm
   * @exclusiveMin 0
   */
  length: number;
  /**
   * g
   * @exclusiveMin 0
   */
  weight: number;
}

/** Label */
export interface AnkorstoreInternalLabel {
  format: AnkorstoreInternalLabelFormatEnum;
  encoding: AnkorstoreInternalLabelEncodingEnum;
  data: string;
  containerReference: string;
}

export interface AnkorstoreInternalLabelResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** Label */
  attributes: {
    format: AnkorstoreInternalLabelResourceFormatEnum;
    encoding: AnkorstoreInternalLabelResourceEncodingEnum;
    data: string;
    containerReference: string;
  };
}

/** HistoricalParcelDimension */
export interface AnkorstoreInternalHistoricalParcelDimension {
  width: number;
  height: number;
  length: number;
}

export interface AnkorstoreInternalHistoricalParcelDimensionResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** HistoricalParcelDimension */
  attributes: {
    width: number;
    height: number;
    length: number;
  };
}

/** Quote */
export interface AnkorstoreInternalQuote {
  /** Order master uuid linked to the quote */
  masterOrderUuid?: string;
  /** The provider of the quote, generally a carrier (ups, dhl_express ...) */
  provider?: string;
  /** Estimation of the cost for the brand */
  shippingCost?: {
    /** The amount of the shipping cost */
    amount?: number;
    /** The currency of the shipping cost */
    currency?: string;
  };
}

export interface AnkorstoreInternalQuoteResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** Quote */
  attributes: {
    /** Order master uuid linked to the quote */
    masterOrderUuid?: string;
    /** The provider of the quote, generally a carrier (ups, dhl_express ...) */
    provider?: string;
    /** Estimation of the cost for the brand */
    shippingCost?: {
      /** The amount of the shipping cost */
      amount?: number;
      /** The currency of the shipping cost */
      currency?: string;
    };
  };
  meta?: {
    /** The validation/business rule errors for the carrier */
    validationError?: {
      /** An application-specific error code, expressed as a string value. */
      code?: string;
      /** A human-readable explanation specific to this occurrence of the problem. */
      detail?: string;
      /** The HTTP status code applicable to this problem, expressed as a string value. */
      status?: string;
      /** Optional object pointing towards the problematic field */
      source?: {
        /** The field key */
        pointer?: string;
      };
      /** The HTTP status code description applicable to this problem */
      title?: string;
      /** Meta-information about the rules that failed and the limit */
      meta?: {
        rule?: string;
        options?: string[];
        [key: string]: any;
      };
    }[];
    [key: string]: any;
  };
  relationships?: {
    shippingService?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/** ShippingService */
export interface AnkorstoreInternalShippingService {
  /** The carrier code of the service */
  carrierCode?: string;
  /** The carrier service code */
  serviceCode?: string;
  /** The commercial name of the service */
  serviceCommercialName?: string;
  /** The collection method for the carrier service */
  collectionMethod?: AnkorstoreInternalShippingServiceCollectionMethodEnum[];
  /** Price of the service */
  servicePrice?: {
    /** The amount of the service price */
    amount?: number;
    /** The currency of the service price */
    currency?: string;
    /**
     * List of surcharges applied to the service price.
     * @minItems 1
     */
    surcharges?: {
      /** Shipment segment to which the surcharge applies. */
      scope: AnkorstoreInternalShippingServiceScopeEnum;
      /** Business code identifying the surcharge type. */
      code: AnkorstoreInternalShippingServiceCodeEnum;
      /** Surcharge amount expressed in minor units (e.g. cents). */
      amount: number;
    }[];
  };
  /** Delivery estimation information for the service if provided by carrier */
  timeInTransit?: {
    /**
     * Estimation of delivery date by the carrier
     * @format date
     */
    estimatedDeliveryDate?: null | string;
    /**
     * Pickup date considered for the estimation
     * @format date
     */
    pickupDate?: null | string;
    /** Number of business days the shipment is in transit */
    businessDaysInTransit?: null | number;
  };
}

export interface AnkorstoreInternalShippingServiceResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** ShippingService */
  attributes: {
    /** The carrier code of the service */
    carrierCode?: string;
    /** The carrier service code */
    serviceCode?: string;
    /** The commercial name of the service */
    serviceCommercialName?: string;
    /** The collection method for the carrier service */
    collectionMethod?: AnkorstoreInternalShippingServiceResourceCollectionMethodEnum[];
    /** Price of the service */
    servicePrice?: {
      /** The amount of the service price */
      amount?: number;
      /** The currency of the service price */
      currency?: string;
      /**
       * List of surcharges applied to the service price.
       * @minItems 1
       */
      surcharges?: {
        /** Shipment segment to which the surcharge applies. */
        scope: AnkorstoreInternalShippingServiceResourceScopeEnum;
        /** Business code identifying the surcharge type. */
        code: AnkorstoreInternalShippingServiceResourceCodeEnum;
        /** Surcharge amount expressed in minor units (e.g. cents). */
        amount: number;
      }[];
    };
    /** Delivery estimation information for the service if provided by carrier */
    timeInTransit?: {
      /**
       * Estimation of delivery date by the carrier
       * @format date
       */
      estimatedDeliveryDate?: null | string;
      /**
       * Pickup date considered for the estimation
       * @format date
       */
      pickupDate?: null | string;
      /** Number of business days the shipment is in transit */
      businessDaysInTransit?: null | number;
    };
  };
}

export interface AnkorstoreInternalNavigationNode {
  /**
   * A globally-unique identifier for the navigation element
   * @format uuid
   */
  id: string;
  type: string;
  attributes?: object;
  meta?: {
    /**
     * Depth of the navigation element in the hierarchy (starting at 0)
     * @min 0
     */
    depth: number;
    /**
     * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
     * @min 0
     */
    position: number;
    [key: string]: any;
  };
}

/** NavigationLink */
export interface AnkorstoreInternalNavigationLink {
  /** The label of the link */
  label: string;
  /**
   * The URL to which the link points to
   * @format uri-reference
   */
  url?: string;
  /** Where to open the linked URL */
  target?: AnkorstoreInternalNavigationLinkTargetEnum;
  /** Whether or not the URL is external to the website */
  external?: boolean;
  /**
   * Exclude the link from the navigation menu
   * @default false
   */
  exclude?: boolean;
  /** The tracking event to be sent when the link is clicked */
  'tracking-event'?: string;
}

/** NavigationItem */
export type AnkorstoreInternalNavigationItem = {
  /**
   * A globally-unique identifier for the navigation element
   * @format uuid
   */
  id: string;
  type: string;
  attributes?: object;
  meta?: {
    /**
     * Depth of the navigation element in the hierarchy (starting at 0)
     * @min 0
     */
    depth: number;
    /**
     * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
     * @min 0
     */
    position: number;
    [key: string]: any;
  };
} & {
  type?: 'nav-item';
  attributes?: {
    /** The label of the link */
    label: string;
    /**
     * The URL to which the link points to
     * @format uri-reference
     */
    url?: string;
    /** Where to open the linked URL */
    target?: AnkorstoreInternalNavigationItemTargetEnum;
    /** Whether or not the URL is external to the website */
    external?: boolean;
    /**
     * Exclude the link from the navigation menu
     * @default false
     */
    exclude?: boolean;
    /** The tracking event to be sent when the link is clicked */
    'tracking-event'?: string;
  } & {
    /** Secondary navigation links */
    related?: {
      /** NavigationLink */
      self?: {
        /** The label of the link */
        label: string;
        /**
         * The URL to which the link points to
         * @format uri-reference
         */
        url?: string;
        /** Where to open the linked URL */
        target?: AnkorstoreInternalNavigationItemTargetEnum1;
        /** Whether or not the URL is external to the website */
        external?: boolean;
        /**
         * Exclude the link from the navigation menu
         * @default false
         */
        exclude?: boolean;
        /** The tracking event to be sent when the link is clicked */
        'tracking-event'?: string;
      };
      /** NavigationLink */
      'newest-brands'?: {
        /** The label of the link */
        label: string;
        /**
         * The URL to which the link points to
         * @format uri-reference
         */
        url?: string;
        /** Where to open the linked URL */
        target?: AnkorstoreInternalNavigationItemTargetEnum2;
        /** Whether or not the URL is external to the website */
        external?: boolean;
        /**
         * Exclude the link from the navigation menu
         * @default false
         */
        exclude?: boolean;
        /** The tracking event to be sent when the link is clicked */
        'tracking-event'?: string;
      };
      /** NavigationLink */
      'newest-products'?: {
        /** The label of the link */
        label: string;
        /**
         * The URL to which the link points to
         * @format uri-reference
         */
        url?: string;
        /** Where to open the linked URL */
        target?: AnkorstoreInternalNavigationItemTargetEnum3;
        /** Whether or not the URL is external to the website */
        external?: boolean;
        /**
         * Exclude the link from the navigation menu
         * @default false
         */
        exclude?: boolean;
        /** The tracking event to be sent when the link is clicked */
        'tracking-event'?: string;
      };
      [key: string]: any;
    };
  };
};

/** NavigationItemGroup */
export type AnkorstoreInternalNavigationItemGroup = {
  /**
   * A globally-unique identifier for the navigation element
   * @format uuid
   */
  id: string;
  type: string;
  attributes?: object;
  meta?: {
    /**
     * Depth of the navigation element in the hierarchy (starting at 0)
     * @min 0
     */
    depth: number;
    /**
     * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
     * @min 0
     */
    position: number;
    [key: string]: any;
  };
} & {
  type?: 'nav-item-group';
  attributes?: {
    /** Title of the menu item group */
    title?: string;
    /** The list of menu items in the group */
    items?: ({
      /**
       * A globally-unique identifier for the navigation element
       * @format uuid
       */
      id: string;
      type: string;
      attributes?: object;
      meta?: {
        /**
         * Depth of the navigation element in the hierarchy (starting at 0)
         * @min 0
         */
        depth: number;
        /**
         * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
         * @min 0
         */
        position: number;
        [key: string]: any;
      };
    } & {
      type?: 'nav-item';
      attributes?: {
        /** The label of the link */
        label: string;
        /**
         * The URL to which the link points to
         * @format uri-reference
         */
        url?: string;
        /** Where to open the linked URL */
        target?: AnkorstoreInternalNavigationItemGroupTargetEnum;
        /** Whether or not the URL is external to the website */
        external?: boolean;
        /**
         * Exclude the link from the navigation menu
         * @default false
         */
        exclude?: boolean;
        /** The tracking event to be sent when the link is clicked */
        'tracking-event'?: string;
      } & {
        /** Secondary navigation links */
        related?: {
          /** NavigationLink */
          self?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationItemGroupTargetEnum1;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          };
          /** NavigationLink */
          'newest-brands'?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationItemGroupTargetEnum2;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          };
          /** NavigationLink */
          'newest-products'?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationItemGroupTargetEnum3;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          };
          [key: string]: any;
        };
      };
    })[];
  };
};

export type AnkorstoreInternalNavigationElement =
  | ({
      /**
       * A globally-unique identifier for the navigation element
       * @format uuid
       */
      id: string;
      type: string;
      attributes?: object;
      meta?: {
        /**
         * Depth of the navigation element in the hierarchy (starting at 0)
         * @min 0
         */
        depth: number;
        /**
         * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
         * @min 0
         */
        position: number;
        [key: string]: any;
      };
    } & {
      type?: 'nav-item';
      attributes?: {
        /** The label of the link */
        label: string;
        /**
         * The URL to which the link points to
         * @format uri-reference
         */
        url?: string;
        /** Where to open the linked URL */
        target?: AnkorstoreInternalNavigationElementTargetEnum;
        /** Whether or not the URL is external to the website */
        external?: boolean;
        /**
         * Exclude the link from the navigation menu
         * @default false
         */
        exclude?: boolean;
        /** The tracking event to be sent when the link is clicked */
        'tracking-event'?: string;
      } & {
        /** Secondary navigation links */
        related?: {
          /** NavigationLink */
          self?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationElementTargetEnum1;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          };
          /** NavigationLink */
          'newest-brands'?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationElementTargetEnum2;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          };
          /** NavigationLink */
          'newest-products'?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationElementTargetEnum3;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          };
          [key: string]: any;
        };
      };
    })
  | ({
      /**
       * A globally-unique identifier for the navigation element
       * @format uuid
       */
      id: string;
      type: string;
      attributes?: object;
      meta?: {
        /**
         * Depth of the navigation element in the hierarchy (starting at 0)
         * @min 0
         */
        depth: number;
        /**
         * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
         * @min 0
         */
        position: number;
        [key: string]: any;
      };
    } & {
      type?: 'nav-item-group';
      attributes?: {
        /** Title of the menu item group */
        title?: string;
        /** The list of menu items in the group */
        items?: ({
          /**
           * A globally-unique identifier for the navigation element
           * @format uuid
           */
          id: string;
          type: string;
          attributes?: object;
          meta?: {
            /**
             * Depth of the navigation element in the hierarchy (starting at 0)
             * @min 0
             */
            depth: number;
            /**
             * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
             * @min 0
             */
            position: number;
            [key: string]: any;
          };
        } & {
          type?: 'nav-item';
          attributes?: {
            /** The label of the link */
            label: string;
            /**
             * The URL to which the link points to
             * @format uri-reference
             */
            url?: string;
            /** Where to open the linked URL */
            target?: AnkorstoreInternalNavigationElementTargetEnum4;
            /** Whether or not the URL is external to the website */
            external?: boolean;
            /**
             * Exclude the link from the navigation menu
             * @default false
             */
            exclude?: boolean;
            /** The tracking event to be sent when the link is clicked */
            'tracking-event'?: string;
          } & {
            /** Secondary navigation links */
            related?: {
              /** NavigationLink */
              self?: {
                /** The label of the link */
                label: string;
                /**
                 * The URL to which the link points to
                 * @format uri-reference
                 */
                url?: string;
                /** Where to open the linked URL */
                target?: AnkorstoreInternalNavigationElementTargetEnum5;
                /** Whether or not the URL is external to the website */
                external?: boolean;
                /**
                 * Exclude the link from the navigation menu
                 * @default false
                 */
                exclude?: boolean;
                /** The tracking event to be sent when the link is clicked */
                'tracking-event'?: string;
              };
              /** NavigationLink */
              'newest-brands'?: {
                /** The label of the link */
                label: string;
                /**
                 * The URL to which the link points to
                 * @format uri-reference
                 */
                url?: string;
                /** Where to open the linked URL */
                target?: AnkorstoreInternalNavigationElementTargetEnum6;
                /** Whether or not the URL is external to the website */
                external?: boolean;
                /**
                 * Exclude the link from the navigation menu
                 * @default false
                 */
                exclude?: boolean;
                /** The tracking event to be sent when the link is clicked */
                'tracking-event'?: string;
              };
              /** NavigationLink */
              'newest-products'?: {
                /** The label of the link */
                label: string;
                /**
                 * The URL to which the link points to
                 * @format uri-reference
                 */
                url?: string;
                /** Where to open the linked URL */
                target?: AnkorstoreInternalNavigationElementTargetEnum7;
                /** Whether or not the URL is external to the website */
                external?: boolean;
                /**
                 * Exclude the link from the navigation menu
                 * @default false
                 */
                exclude?: boolean;
                /** The tracking event to be sent when the link is clicked */
                'tracking-event'?: string;
              };
              [key: string]: any;
            };
          };
        })[];
      };
    });

/**
 * SearchQuery
 * The search query.
 */
export interface AnkorstoreInternalSearchQuery {
  /**
   * A traditional textual search query. All words of the query are interpreted
   * as prefixes (for example “John Mc” will match “John Mccamey” and “Johnathan Mccamey”).
   * If the query is empty, the search will match every record in the index.
   * @default ""
   */
  term?: string;
}

/**
 * SearchParams
 * Search parameters
 */
export interface AnkorstoreInternalSearchParams {
  type: AnkorstoreInternalSearchParamsTypeEnum;
  attributes: {
    /**
     * SearchQuery
     * The search query.
     */
    query?: {
      /**
       * A traditional textual search query. All words of the query are interpreted
       * as prefixes (for example “John Mc” will match “John Mccamey” and “Johnathan Mccamey”).
       * If the query is empty, the search will match every record in the index.
       * @default ""
       */
      term?: string;
    };
    /** List of attributes that you want to use for faceting. */
    facets?: string[];
    /**
     * Refines search results by selecting documents matching the given set of filters.
     * All of the filters must match. This functions as a list of `AND` conditions.
     */
    filters?: (
      | {
          /**
           * The type of filter.
           *
           * This filter returns results that contain a specific attribute value.<br/>
           * Available on **text**, **number** or **date** attributes and supports arrays.
           */
          type: AnkorstoreInternalSearchParamsTypeEnum1;
          /** The name of the attribute upon which to apply the filter. */
          name: string;
          /**
           * The negation operator. When set to `true` it selects all results
           * that do not satisfy the filter condition.
           * @default false
           */
          not?: boolean;
          /**
           * The value upon which to filter.
           *
           * The value must be an exact match. When operating on strings, the filter
           * is case-sensitive (i.e. *“French”* will not match on *“french”*).
           */
          value: string | number | (string | number)[];
        }
      | {
          /**
           * The type of filter.
           *
           * This filter returns results over a range of dates or numbers.<br/>
           * Available on **number** or **date** attributes.
           */
          type: AnkorstoreInternalSearchParamsTypeEnum2;
          /** The name of the attribute upon which to apply the filter. */
          name: string;
          /**
           * Inclusive lower bound of the range.<br/>
           * Required if `max` or `exclusiveMax` is not given.
           */
          min?: number | string;
          /**
           * Inclusive upper bound of the range.<br/>
           * Required if `min` or `exclusiveMin` is not given.
           */
          max?: number | string;
          /**
           * Exclusive lower bound of the range.<br/>
           * Required if `max` or `exclusiveMax` is not given.
           */
          exclusiveMin?: number | string;
          /**
           * Exclusive upper bound of the range.<br/>
           * Required if `min` or `exclusiveMin` is not given.
           */
          exclusiveMax?: number | string;
        }
      | {
          /** The type of filter. */
          type: AnkorstoreInternalSearchParamsTypeEnum3;
          /** The name of the attribute upon which to apply the filter. */
          name: string;
          /** The value upon which to filter. */
          value: boolean;
        }
    )[];
    /**
     * Sorts search results at query time according to the specified attributes and indicated
     * order. Each attribute in the list must be specified as an object property followed by
     * the preferred sorting order: either ascending (`asc`) or descending (`desc`).
     *
     * For example:
     * ```json
     * "sort": {
     *
     *
     *   "retailer.shopName": "asc",
     *   "contact.email": "asc"
     * }
     * ```
     * @example {"price":"asc","author":"desc"}
     */
    sort?: Record<string, AnkorstoreInternalSearchParamsSortEnum>;
    /** Pagination parameters. */
    page?: {
      /**
       * Number of search results to return.
       * @min 1
       */
      size?: number;
      /**
       * Index of the search result page to return.
       * @min 1
       */
      current?: number;
    };
  };
}

/** ValueFacet */
export interface AnkorstoreInternalSearchValueFacet {
  /**
   * Type of facet.
   *
   * A value facet provides the counts of each value for an attribute.
   * This type of facet is only available on **text**, **number** and **date** attributes.
   */
  type: AnkorstoreInternalSearchValueFacetTypeEnum;
  data: {
    /** A human-readable name for the value. */
    name?: string;
    /** The value of the attribute. */
    value: string | number;
    /**
     * The number of results for this value of the attribute.
     * @min 1
     */
    count: number;
  }[];
}

/** RangeFacet */
export interface AnkorstoreInternalSearchRangeFacet {
  /**
   * Type of facet.
   *
   * A range facet returns counts of documents within the provided ranges.
   * This type of facet is only available on **number** and **date** attributes.
   */
  type: AnkorstoreInternalSearchRangeFacetTypeEnum;
  data: {
    /** Name given to the range. */
    name?: string;
    /**
     * Number of results within the range.
     * @min 1
     */
    count: number;
    /**
     * Inclusive lower bound of the range.
     * @format date-time
     */
    from?: number | string;
    /**
     * Exclusive upper bound of the range.
     * @format date-time
     */
    to?: number | string;
  }[];
}

/** StatsFacet */
export interface AnkorstoreInternalSearchStatsFacet {
  /**
   * Type of facet.
   *
   * Stats (also called *aggregation* or *analytic*) facets compute stats over
   * numeric values extracted from the aggregated results. This type of facet
   * is only available on **number** attributes.
   */
  type: AnkorstoreInternalSearchStatsFacetTypeEnum;
  /** The lowest numerical value across all results. */
  min: number;
  /** The highest numerical value across all results. */
  max: number;
}

export type AnkorstoreInternalSearchFacet =
  | {
      /**
       * Type of facet.
       *
       * A value facet provides the counts of each value for an attribute.
       * This type of facet is only available on **text**, **number** and **date** attributes.
       */
      type: AnkorstoreInternalSearchFacetTypeEnum;
      data: {
        /** A human-readable name for the value. */
        name?: string;
        /** The value of the attribute. */
        value: string | number;
        /**
         * The number of results for this value of the attribute.
         * @min 1
         */
        count: number;
      }[];
    }
  | {
      /**
       * Type of facet.
       *
       * A range facet returns counts of documents within the provided ranges.
       * This type of facet is only available on **number** and **date** attributes.
       */
      type: AnkorstoreInternalSearchFacetTypeEnum1;
      data: {
        /** Name given to the range. */
        name?: string;
        /**
         * Number of results within the range.
         * @min 1
         */
        count: number;
        /**
         * Inclusive lower bound of the range.
         * @format date-time
         */
        from?: number | string;
        /**
         * Exclusive upper bound of the range.
         * @format date-time
         */
        to?: number | string;
      }[];
    }
  | {
      /**
       * Type of facet.
       *
       * Stats (also called *aggregation* or *analytic*) facets compute stats over
       * numeric values extracted from the aggregated results. This type of facet
       * is only available on **number** attributes.
       */
      type: AnkorstoreInternalSearchFacetTypeEnum2;
      /** The lowest numerical value across all results. */
      min: number;
      /** The highest numerical value across all results. */
      max: number;
    };

/** SearchResponse */
export interface AnkorstoreInternalSearchResponse {
  /** Array of results matching the search. */
  data: any[];
  meta: {
    page?: {
      /**
       * Number of results per page.
       * @min 1
       */
      size?: number;
      /**
       * Index of the current search result page.
       * @min 1
       */
      current?: number;
      /**
       * Total number of search result pages.
       * @min 0
       */
      totalPages?: number;
      /**
       * Total number of results.
       * @min 0
       */
      totalResults?: number;
    };
    /**
     * Contains the number of matching contacts distributed among
     * the values of a given facet. Each facet is represented as
     * an object.
     */
    facets?: Record<
      string,
      | {
          /**
           * Type of facet.
           *
           * A value facet provides the counts of each value for an attribute.
           * This type of facet is only available on **text**, **number** and **date** attributes.
           */
          type: AnkorstoreInternalSearchResponseTypeEnum;
          data: {
            /** A human-readable name for the value. */
            name?: string;
            /** The value of the attribute. */
            value: string | number;
            /**
             * The number of results for this value of the attribute.
             * @min 1
             */
            count: number;
          }[];
        }
      | {
          /**
           * Type of facet.
           *
           * A range facet returns counts of documents within the provided ranges.
           * This type of facet is only available on **number** and **date** attributes.
           */
          type: AnkorstoreInternalSearchResponseTypeEnum1;
          data: {
            /** Name given to the range. */
            name?: string;
            /**
             * Number of results within the range.
             * @min 1
             */
            count: number;
            /**
             * Inclusive lower bound of the range.
             * @format date-time
             */
            from?: number | string;
            /**
             * Exclusive upper bound of the range.
             * @format date-time
             */
            to?: number | string;
          }[];
        }
      | {
          /**
           * Type of facet.
           *
           * Stats (also called *aggregation* or *analytic*) facets compute stats over
           * numeric values extracted from the aggregated results. This type of facet
           * is only available on **number** attributes.
           */
          type: AnkorstoreInternalSearchResponseTypeEnum2;
          /** The lowest numerical value across all results. */
          min: number;
          /** The highest numerical value across all results. */
          max: number;
        }
    >;
  };
}

export interface AnkorstoreInternalContactDocument {
  /**
   * A globally-unique identifier for the contact.
   * @format uuid
   * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
   */
  id: string;
  type: AnkorstoreInternalContactDocumentTypeEnum;
  attributes: {
    /** Relationship details */
    relation: {
      /**
       * The date and time when the contact was added to the brand's network.
       * @format date-time
       */
      addedAt: string;
      /**
       * The date and time when the contact was invited to the brand's network (i.e.
       * when a referral invitation was sent to the contact's email address).
       * @format date-time
       */
      invitedAt?: null | string;
      /**
       * The date and time when the contact became affiliated with the brand.
       * Affiliation is confirmed when a retailer places a first order with the brand.
       * @format date-time
       */
      affiliatedAt?: null | string;
      /** Status of the relationship with this contact. */
      status: AnkorstoreInternalContactDocumentStatusEnum;
      /** Origin of the contact. */
      origin: AnkorstoreInternalContactDocumentOriginEnum;
    };
    /** Contact details */
    contact: {
      /** The contact's first name. */
      firstname?: string;
      /** The contact's last name. */
      lastname?: string;
      /**
       * The contact's primary email address.
       * @format email
       */
      email?: string;
      /** The contact's primary phone number. */
      phone?: string;
      /**
       * The contact's preferred language for communications
       * (represented as a 2-letter language code conforming to
       * [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag)).
       */
      language?: string;
      /** The contact's city. */
      city?: string;
      /** The contact's zip code. */
      zip?: string;
      /** The contact's country code. */
      country?: string;
    };
    /** Retailer details */
    retailer?: {
      /**
       * The globally-unique identifier of the retailer.
       * @format uuid
       */
      uuid?: string;
      /** The shop name. */
      name?: string;
      /**
       * The type of shop.
       * @example "pet_store"
       */
      shopType?: null | string;
      /**
       * The date and time when the retailer signed up for an account.
       * @format date-time
       */
      createdAt?: string;
      /** Contact details */
      contact?: {
        /** The retailer's first name. */
        firstname?: string;
        /** The retailer's last name. */
        lastname?: string;
        /**
         * The retailer's primary email address.
         * @format email
         */
        email?: string;
        /** The retailer's primary phone number. */
        phone?: string;
        /** The retailer's city. */
        city?: string;
        /** The retailer's zip code. */
        zip?: string;
        /** The retailer's country code. */
        country?: string;
      };
      /** Status of the Ankorstore+ subscription. */
      aksStatus?: {
        /** Whether this retailer has an active subscription to Ankorstore+ */
        active?: boolean;
        /** Whether this retailer is eligible for the Ankorstore+ offer. */
        eligible?: boolean;
      };
    };
    /** Commercial terms for this contact */
    commercialTerms?: {
      /**
       * The service fee invoiced for this contact's purchases.
       * @format float
       * @min 0
       */
      serviceFees?: number;
      /**
       * The personalised discount for this contact.
       * @format float
       * @min 0
       */
      brandDiscount?: number;
      /**
       * The discount the contact benefits from as part of the repeat offer.
       * @format float
       * @min 0
       */
      repeatOffer?: number;
      /** Whether a personalised brand discount is active for this contact. */
      hasBrandDiscount?: boolean;
      /** Whether a repeat offer is currently active for this contact. */
      hasRepeatOffer?: boolean;
      /**
       * The date and time until which the repeat offer remains unlocked.
       * @format date-time
       */
      repeatOfferUnlockedUntil?: null | string;
      /**
       * The remaining amount the contact must spend to unlock the repeat offer.
       * @format float
       * @min 0
       */
      amountToUnlockRepeatOffer?: null | number;
      /**
       * The date and time until which free shipping with the brand applies.
       * @format date-time
       */
      freeShippingForBrandUntil?: null | string;
      /** The tiered discount currently assigned to this contact, if any. */
      tieredDiscount?: {
        /** The identifier of the tiered discount. */
        id?: string;
        /** The name of the tiered discount. */
        name?: string;
        /**
         * The discount percentage granted by the tiered discount.
         * @format float
         * @min 0
         */
        percentage?: number;
      };
    };
    /** Order activity */
    ordering?: {
      /**
       * The date and time when last order was placed.
       * @format date-time
       */
      lastOrderedAt?: null | string;
      /**
       * The total amount of the last placed order.
       * @example {"currency":"EUR","amount":142}
       */
      lastOrderedAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * The total number of completed orders for this contact.
       * @min 0
       */
      totalCompletedOrders?: number;
      /**
       * The total amount of completed orders for this contact.
       * @example {"currency":"EUR","amount":142}
       */
      totalSpent?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** Whether this contact is eligible for the referral offer. */
      liftEligible?: boolean;
      /**
       * The date and time when the first order was placed.
       * @format date-time
       */
      firstOrderedAt?: null | string;
      /**
       * The predicted date and time of the contact's next order.
       * @format date-time
       */
      expectedNextOrderAt?: null | string;
      /**
       * The date and time when the contact became disengaged.
       * @format date-time
       */
      disengagedAt?: null | string;
      /** The contact's ordering activity signal. */
      activitySignal?: AnkorstoreInternalContactDocumentActivitySignalEnum;
    };
    /** Prepared order activity */
    preparedOrders?: {
      /**
       * Total number of prepared orders for this contact.
       * @min 0
       */
      number: number;
    };
    /** Shopping activity */
    cart?: {
      /**
       * Order total for the shopping cart of this retailer.
       * @example {"currency":"EUR","amount":142}
       */
      amountInCart: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * The date and time when the shopping cart was last updated.
       * @format date-time
       */
      cartUpdatedAt: string;
    };
    /** Communications with this contact */
    communication?: {
      /** Direct in-app messaging */
      messaging?: {
        /**
         * The date and time when the last message was sent.
         * @format date-time
         */
        lastContactedAt?: string;
        /** Who's the sender of the last sent message. */
        lastMessageBy?: AnkorstoreInternalContactDocumentLastMessageByEnum;
      };
      /** Emailing activity */
      emailing?: {
        /**
         * Indicates the level of consent this contact has given
         * to receive email marketing campaigns.
         *
         * - **Subscribed** — A subscribed contact, or subscriber,
         * is someone who has opted in to receive marketing messages.
         *
         * - **Unsubscribed** — An unsubscribed contact is someone who
         * previously received marketing messages but has opted out.
         *
         * - **Suppressed** — A suppressed contact is someone who is
         * on the suppression list and thus is excluded from receiving
         * marketing messages. Contacts may be added to the suppression
         * list for various reasons, including if they have complained
         * about receiving emails (they marked emails as spam)
         * or if their email address bounced or is invalid.
         */
        subscriptionStatus?: AnkorstoreInternalContactDocumentSubscriptionStatusEnum;
        /**
         * The date and time when the last email was sent.
         * @format date-time
         */
        lastContactedAt?: string;
        /** Whether the brand sent an email to the contact on the same calendar day. */
        contactedRecently?: boolean;
      };
    };
    /** The name of the QR campaign the contact originated from, if any. */
    qrCampaignName?: null | string;
    /** The identifier of the QR campaign source the contact originated from, if any. */
    qrCampaignSourceId?: null | string;
  };
}

/** MultiSearchParams */
export type AnkorstoreInternalMultiSearchParams = {
  type: AnkorstoreInternalMultiSearchParamsTypeEnum;
  attributes: {
    /**
     * SearchQuery
     * The search query.
     */
    query?: {
      /**
       * A traditional textual search query. All words of the query are interpreted
       * as prefixes (for example “John Mc” will match “John Mccamey” and “Johnathan Mccamey”).
       * If the query is empty, the search will match every record in the index.
       * @default ""
       */
      term?: string;
    };
    /** List of attributes that you want to use for faceting. */
    facets?: string[];
    /**
     * Refines search results by selecting documents matching the given set of filters.
     * All of the filters must match. This functions as a list of `AND` conditions.
     */
    filters?: (
      | {
          /**
           * The type of filter.
           *
           * This filter returns results that contain a specific attribute value.<br/>
           * Available on **text**, **number** or **date** attributes and supports arrays.
           */
          type: AnkorstoreInternalMultiSearchParamsTypeEnum1;
          /** The name of the attribute upon which to apply the filter. */
          name: string;
          /**
           * The negation operator. When set to `true` it selects all results
           * that do not satisfy the filter condition.
           * @default false
           */
          not?: boolean;
          /**
           * The value upon which to filter.
           *
           * The value must be an exact match. When operating on strings, the filter
           * is case-sensitive (i.e. *“French”* will not match on *“french”*).
           */
          value: string | number | (string | number)[];
        }
      | {
          /**
           * The type of filter.
           *
           * This filter returns results over a range of dates or numbers.<br/>
           * Available on **number** or **date** attributes.
           */
          type: AnkorstoreInternalMultiSearchParamsTypeEnum2;
          /** The name of the attribute upon which to apply the filter. */
          name: string;
          /**
           * Inclusive lower bound of the range.<br/>
           * Required if `max` or `exclusiveMax` is not given.
           */
          min?: number | string;
          /**
           * Inclusive upper bound of the range.<br/>
           * Required if `min` or `exclusiveMin` is not given.
           */
          max?: number | string;
          /**
           * Exclusive lower bound of the range.<br/>
           * Required if `max` or `exclusiveMax` is not given.
           */
          exclusiveMin?: number | string;
          /**
           * Exclusive upper bound of the range.<br/>
           * Required if `min` or `exclusiveMin` is not given.
           */
          exclusiveMax?: number | string;
        }
      | {
          /** The type of filter. */
          type: AnkorstoreInternalMultiSearchParamsTypeEnum3;
          /** The name of the attribute upon which to apply the filter. */
          name: string;
          /** The value upon which to filter. */
          value: boolean;
        }
    )[];
    /**
     * Sorts search results at query time according to the specified attributes and indicated
     * order. Each attribute in the list must be specified as an object property followed by
     * the preferred sorting order: either ascending (`asc`) or descending (`desc`).
     *
     * For example:
     * ```json
     * "sort": {
     *
     *
     *   "retailer.shopName": "asc",
     *   "contact.email": "asc"
     * }
     * ```
     * @example {"price":"asc","author":"desc"}
     */
    sort?: Record<string, AnkorstoreInternalMultiSearchParamsSortEnum>;
    /** Pagination parameters. */
    page?: {
      /**
       * Number of search results to return.
       * @min 1
       */
      size?: number;
      /**
       * Index of the search result page to return.
       * @min 1
       */
      current?: number;
    };
  };
}[];

/** WidgetValue */
export type AnkorstoreInternalWidgetValue = {
  value: string;
  label: string;
  icon?: string;
}[];

/** RangeWidget */
export interface AnkorstoreInternalSearchRangeWidget {
  type: AnkorstoreInternalSearchRangeWidgetTypeEnum;
  attributes: {
    /**
     * The `Range` widget allows a user to select a numeric range
     * using a minimum and maximum input.
     */
    type?: AnkorstoreInternalSearchRangeWidgetTypeEnum1;
    /** The name of the attribute upon which to apply the filter. */
    attributeName?: string;
    minLabel?: string;
    maxLabel?: string;
    separatorLabel?: string;
    icon?: string;
    /** WidgetValue */
    values?: {
      value: string;
      label: string;
      icon?: string;
    }[];
  };
}

/** ToggleWidget */
export interface AnkorstoreInternalSearchToggleWidget {
  type: AnkorstoreInternalSearchToggleWidgetTypeEnum;
  attributes: {
    /**
     * The `Toggle` widget provides an on/off filtering feature
     * based on an attribute value.
     */
    type?: AnkorstoreInternalSearchToggleWidgetTypeEnum1;
    /** The name of the attribute upon which to apply the filter. */
    attributeName?: string;
    label?: string;
    icon?: string;
    /** WidgetValue */
    values?: {
      value: string;
      label: string;
      icon?: string;
    }[];
  };
}

/** DropdownWidget */
export interface AnkorstoreInternalSearchDropdownWidget {
  type: AnkorstoreInternalSearchDropdownWidgetTypeEnum;
  attributes: {
    /**
     * The `Dropdown` widget allows a user to select values upon which
     * to filter inside a dropdown element.
     */
    type?: AnkorstoreInternalSearchDropdownWidgetTypeEnum1;
    /** The name of the attribute upon which to apply the filter. */
    attributeName?: string;
    /**
     * Allow the multiple selection.
     * @default true
     */
    multiple?: boolean;
    label?: string;
    icon?: string;
    placeholder?: string;
    /** WidgetValue */
    values?: {
      value: string;
      label: string;
      icon?: string;
    }[];
  };
}

/** ListWidget */
export interface AnkorstoreInternalSearchListWidget {
  type: AnkorstoreInternalSearchListWidgetTypeEnum;
  attributes: {
    /**
     * The `List` widget displays a menu that lets users choose one
     * or multiple values for a specific attribute.
     */
    type?: AnkorstoreInternalSearchListWidgetTypeEnum1;
    /** The name of the attribute upon which to apply the filter. */
    attributeName?: string;
    /**
     * Allow the multiple selection.
     * @default true
     */
    multiple?: boolean;
    label?: string;
    icon?: string;
    /** WidgetValue */
    values?: {
      value: string;
      label: string;
      icon?: string;
    }[];
  };
}

/** WidgetValue */
export type AnkorstoreInternalDateRangeWidgetValue = {
  from?: string;
  to?: string;
  label: string;
  icon?: string;
}[];

/** DateRangeWidget */
export interface AnkorstoreInternalSearchDateRangeWidget {
  type: AnkorstoreInternalSearchDateRangeWidgetTypeEnum;
  attributes: {
    /**
     * The `DateRange` widget allows a user to select a date range
     * using a start and end date input.
     */
    type?: AnkorstoreInternalSearchDateRangeWidgetTypeEnum1;
    /** The name of the attribute upon which to apply the filter. */
    attributeName?: string;
    /** WidgetValue */
    values?: {
      from?: string;
      to?: string;
      label: string;
      icon?: string;
    }[];
  };
}

/** FilterWidget */
export type AnkorstoreInternalSearchFilterWidget =
  | {
      type: AnkorstoreInternalSearchFilterWidgetTypeEnum;
      attributes: {
        /**
         * The `Range` widget allows a user to select a numeric range
         * using a minimum and maximum input.
         */
        type?: AnkorstoreInternalSearchFilterWidgetTypeEnum1;
        /** The name of the attribute upon which to apply the filter. */
        attributeName?: string;
        minLabel?: string;
        maxLabel?: string;
        separatorLabel?: string;
        icon?: string;
        /** WidgetValue */
        values?: {
          value: string;
          label: string;
          icon?: string;
        }[];
      };
    }
  | {
      type: AnkorstoreInternalSearchFilterWidgetTypeEnum2;
      attributes: {
        /**
         * The `Toggle` widget provides an on/off filtering feature
         * based on an attribute value.
         */
        type?: AnkorstoreInternalSearchFilterWidgetTypeEnum3;
        /** The name of the attribute upon which to apply the filter. */
        attributeName?: string;
        label?: string;
        icon?: string;
        /** WidgetValue */
        values?: {
          value: string;
          label: string;
          icon?: string;
        }[];
      };
    }
  | {
      type: AnkorstoreInternalSearchFilterWidgetTypeEnum4;
      attributes: {
        /**
         * The `Dropdown` widget allows a user to select values upon which
         * to filter inside a dropdown element.
         */
        type?: AnkorstoreInternalSearchFilterWidgetTypeEnum5;
        /** The name of the attribute upon which to apply the filter. */
        attributeName?: string;
        /**
         * Allow the multiple selection.
         * @default true
         */
        multiple?: boolean;
        label?: string;
        icon?: string;
        placeholder?: string;
        /** WidgetValue */
        values?: {
          value: string;
          label: string;
          icon?: string;
        }[];
      };
    }
  | {
      type: AnkorstoreInternalSearchFilterWidgetTypeEnum6;
      attributes: {
        /**
         * The `List` widget displays a menu that lets users choose one
         * or multiple values for a specific attribute.
         */
        type?: AnkorstoreInternalSearchFilterWidgetTypeEnum7;
        /** The name of the attribute upon which to apply the filter. */
        attributeName?: string;
        /**
         * Allow the multiple selection.
         * @default true
         */
        multiple?: boolean;
        label?: string;
        icon?: string;
        /** WidgetValue */
        values?: {
          value: string;
          label: string;
          icon?: string;
        }[];
      };
    }
  | {
      type: AnkorstoreInternalSearchFilterWidgetTypeEnum8;
      attributes: {
        /**
         * The `DateRange` widget allows a user to select a date range
         * using a start and end date input.
         */
        type?: AnkorstoreInternalSearchFilterWidgetTypeEnum9;
        /** The name of the attribute upon which to apply the filter. */
        attributeName?: string;
        /** WidgetValue */
        values?: {
          from?: string;
          to?: string;
          label: string;
          icon?: string;
        }[];
      };
    };

/** PromocodeDiscoveryRelationshipResource */
export interface AnkorstoreInternalPromocodeDiscoveryRelationshipResource {
  type?: 'promocode-discovery-relationships';
  id?: string;
  attributes?: {
    brand_id: number;
    brand_link: string;
    brand_name: string;
    brand_logo: string;
    brand_image: string;
    brand_product_count: string;
    already_used: boolean;
  };
}

/** PromocodeFirstCheckoutResource */
export interface AnkorstoreInternalPromocodeFirstCheckoutResource {
  type?: 'promocode-first-checkout';
  id?: string;
  attributes?: {
    brand_id: number;
    brand_link: string;
    brand_name: string;
    brand_logo: string;
    brand_image: string;
    brand_product_count: string;
  };
}

export interface AnkorstoreInternalBrandOfferResource {
  id: string;
  /** @example "brand/offers" */
  type: string;
  attributes: {
    /**
     * The brand UUID this offer applies to
     * @format uuid
     */
    brandUuid?: string;
    /** The offer type */
    type?: AnkorstoreInternalBrandOfferResourceTypeEnum;
    /** The offer name */
    name?: string;
    /** The discount percentage, if applicable */
    percentage?: number | null;
  };
}

/** ConnectedHomepageConfigurationComponent */
export interface AnkorstoreInternalConnectedHomepageConfigurationComponent {
  name: string;
  parameters?: object[];
}

/** ConnectedHomepageConfigurationResource */
export interface AnkorstoreInternalConnectedHomepageConfigurationResource {
  type: 'connected-homepage-configuration';
  id: string;
  attributes: {
    segment_slug: AnkorstoreInternalConnectedHomepageConfigurationResourceSegmentSlugEnum;
    components: {
      name: string;
      parameters?: object[];
    }[];
  };
}

/** LoyaltyOfferBrandListUnlockedResource */
export interface AnkorstoreInternalConnectedHomepageRecommendationResource {
  type?: 'connected-homepage-recommendations';
  id?: string;
  attributes?: {
    brand_id: number;
    brand_link: string;
    brand_name: string;
    brand_logo: string;
    brand_images: {
      src?: string;
    }[];
    brand_is_new: boolean;
    brand_discount: number;
  };
}

export enum AnkorstoreInternalCollectionCardType {
  Product = 'product',
  Brand = 'brand',
}

export interface AnkorstoreInternalFooterAttributes {
  branding?: {
    title?: string;
    elements?: {
      url?: string;
      link?: string;
      alt?: string;
      title?: string;
    }[];
  };
  links?: {
    title?: string;
    elements?: {
      title?: string;
      url?: string;
    }[];
  }[];
  payments?: {
    svg?: string;
  }[];
  legals?: {
    title?: string;
    url?: string;
    javascript?: string;
  }[];
  socials?: {
    link?: string;
    icon?: string;
    svg?: string;
  }[];
  copyright?: string;
}

/** LoyaltyOfferBrandListResource */
export interface AnkorstoreInternalLoyaltyOfferBrandListResource {
  type: 'brand-list';
  id: string;
  attributes: {
    brand_id: number;
    brand_link: string;
    brand_name: string;
    brand_logo: string;
    brand_images: {
      src: string;
    }[];
    repeat_offer: {
      status: AnkorstoreInternalLoyaltyOfferBrandListResourceStatusEnum;
      current: {
        /** @format datetime */
        start_date: string | null;
        /** @format datetime */
        end_date: string;
        percentage: number;
        unlocked: boolean;
      };
      next?: {
        /** @format datetime */
        start_date: string;
        /** @format datetime */
        end_date: string;
        percentage: number;
        unlocked: boolean;
      };
      progress_bar: {
        title: string | null;
        amount_to_unlock: string;
        amount_spent: string;
        progress: number;
        subtitle: string;
        eligible_for_next: boolean;
      };
    };
  };
}

/** LoyaltyOfferBrandDiscountResource */
export interface AnkorstoreInternalLoyaltyOfferBrandDiscountResource {
  type?: 'brand-discount';
  id?: string;
  attributes?: {
    brand_id: number;
    discount: number;
    /** @format date-time */
    start_date: string;
    /** @format date-time */
    created_at: string;
  };
}

export enum AnkorstoreInternalFacetContext {
  Default = 'default',
  Brand = 'brand',
  CategoryBrands = 'category_brands',
  CategoryProducts = 'category_products',
  CollectionBrands = 'collection_brands',
  CollectionProducts = 'collection_products',
  NewBrands = 'new_brands',
  NewProducts = 'new_products',
  PreorderBrands = 'preorder_brands',
  PreorderProducts = 'preorder_products',
  Search = 'search',
  Wholesale = 'wholesale',
}

export interface AnkorstoreInternalCatalogFacetResource {
  slug?: string;
  name?: string;
  type?: 'catalog_facet';
  catalog_facet?: {
    message?: string;
    tracking_name?: string;
    is_quick_filter?: boolean;
    searchable?: boolean;
    placeholder?: string;
    facet_type?: string;
    badge_type?: string | null;
    is_open?: boolean;
  };
  /** Custom value-label mapping */
  choices?: Record<string, any>;
}

export interface AnkorstoreInternalAttributeDefinitionResource {
  slug?: string;
  name?: string;
  description?: string;
  type?: string;
  unit?: string | null;
  isMultiValued?: boolean;
  isFilterable?: boolean;
  hasChoices?: boolean;
  /** Custom value-label mapping */
  choices?: Record<string, any>;
  /** Children attributes are not documented to prevent circular reference */
  attributes?: object[];
}

/**
 * HeaderPillsAttributes
 * Attributes for header pills. All properties are conditionally included
 * and only present when their value is not null.
 */
export interface AnkorstoreInternalHeaderPillsAttributes {
  /**
   * Indicates whether the retailer has opted into Ankorstore Plus.
   * - `true`: Retailer is opted-in to Ankorstore Plus
   * - `false`: Retailer is not opted-in to Ankorstore Plus
   * Only present when the status is available for this retailer.
   */
  ankorstore_plus_opt_in?: boolean | null;
  /**
   * Pill
   * Promocode pill information for the retailer, only present when available.
   */
  pill?: {
    /**
     * The pill display title
     * @example "10% off your first order"
     */
    title: string;
    /**
     * The pill description text
     * @example "Use this code at checkout"
     */
    description: string;
    /**
     * The type of action associated with the pill
     * @example "copy"
     */
    action_type: string;
    /**
     * The label for the pill action button
     * @example "Copy code"
     */
    action_label: string;
    /**
     * The feedback message shown after the action is performed
     * @example "Code copied!"
     */
    feedback: string;
  };
  /**
   * CreditLimit
   * Credit limit information for the retailer, only present when available.
   */
  credit_limit?: {
    /**
     * The credit limit amount in the lowest denomination of the currency (cents)
     * @example 200000
     */
    amount: number;
    /**
     * ISO 3-letter currency code
     * @example "EUR"
     */
    currency: string;
    /**
     * Name of the payment service provider (PSP) offering the credit limit
     * @example "Aria"
     */
    pspName: string;
    /**
     * The status of the credit limit information
     * @example "ok"
     */
    status: AnkorstoreInternalHeaderPillsAttributesStatusEnum;
    /**
     * Amount required to unfreeze the credit limit, in the lowest denomination of the currency (cents). Null when the credit limit is not frozen.
     * @example 5000
     */
    unpaidTotalAmount: number | null;
    /**
     * Currency code of the unpaid total amount (ISO 4217). Null when the credit limit is not frozen.
     * @example "EUR"
     */
    unpaidTotalCurrency: string | null;
    /**
     * List of reasons why the credit limit was refused. Null when the credit limit is not refused. Possible values include `LEGAL_INFORMATION_PROTECTED`, `DEBTOR_NOT_FOUND`, `DEBTOR_CLOSED`, `DEBTOR_NOT_FOUND_OR_CLOSED`, `KYC_PENDING`, `KYC_IN_REVIEW`.
     * @example null
     */
    refusalReasons: any[] | null;
    /**
     * Number of credit providers with available credit for this retailer. When greater than 1, the pill shows the highest available amount with a multi-provider tooltip.
     * @example 1
     */
    activeProviderCount?: number;
  };
}

/**
 * HeaderPillsResource
 * Header pills resource containing promotional information for the retailer
 */
export interface AnkorstoreInternalHeaderPillsResource {
  /** Resource type identifier */
  type: 'header-pills';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /**
   * HeaderPillsAttributes
   * Attributes for header pills. All properties are conditionally included
   * and only present when their value is not null.
   */
  attributes: {
    /**
     * Indicates whether the retailer has opted into Ankorstore Plus.
     * - `true`: Retailer is opted-in to Ankorstore Plus
     * - `false`: Retailer is not opted-in to Ankorstore Plus
     * Only present when the status is available for this retailer.
     */
    ankorstore_plus_opt_in?: boolean | null;
    /**
     * Pill
     * Promocode pill information for the retailer, only present when available.
     */
    pill?: {
      /**
       * The pill display title
       * @example "10% off your first order"
       */
      title: string;
      /**
       * The pill description text
       * @example "Use this code at checkout"
       */
      description: string;
      /**
       * The type of action associated with the pill
       * @example "copy"
       */
      action_type: string;
      /**
       * The label for the pill action button
       * @example "Copy code"
       */
      action_label: string;
      /**
       * The feedback message shown after the action is performed
       * @example "Code copied!"
       */
      feedback: string;
    };
    /**
     * CreditLimit
     * Credit limit information for the retailer, only present when available.
     */
    credit_limit?: {
      /**
       * The credit limit amount in the lowest denomination of the currency (cents)
       * @example 200000
       */
      amount: number;
      /**
       * ISO 3-letter currency code
       * @example "EUR"
       */
      currency: string;
      /**
       * Name of the payment service provider (PSP) offering the credit limit
       * @example "Aria"
       */
      pspName: string;
      /**
       * The status of the credit limit information
       * @example "ok"
       */
      status: AnkorstoreInternalHeaderPillsResourceStatusEnum;
      /**
       * Amount required to unfreeze the credit limit, in the lowest denomination of the currency (cents). Null when the credit limit is not frozen.
       * @example 5000
       */
      unpaidTotalAmount: number | null;
      /**
       * Currency code of the unpaid total amount (ISO 4217). Null when the credit limit is not frozen.
       * @example "EUR"
       */
      unpaidTotalCurrency: string | null;
      /**
       * List of reasons why the credit limit was refused. Null when the credit limit is not refused. Possible values include `LEGAL_INFORMATION_PROTECTED`, `DEBTOR_NOT_FOUND`, `DEBTOR_CLOSED`, `DEBTOR_NOT_FOUND_OR_CLOSED`, `KYC_PENDING`, `KYC_IN_REVIEW`.
       * @example null
       */
      refusalReasons: any[] | null;
      /**
       * Number of credit providers with available credit for this retailer. When greater than 1, the pill shows the highest available amount with a multi-provider tooltip.
       * @example 1
       */
      activeProviderCount?: number;
    };
  };
}

/** MinimumOrderValueSettingsResource */
export interface AnkorstoreInternalMinimumOrderValueSettingsResource {
  type: 'minimum-order-value-settings';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    type: string;
    amount: number;
    currency: string;
  };
}

/** Price report field values, validated server-side against the issue schema. */
export interface AnkorstoreInternalPriceReportFields {
  /**
   * An object used to detail pricing information for various Resources.
   * @example {"currency":"EUR","amount":142}
   */
  price?: {
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** Lowest denomination of the currency this amount belongs to. */
    amount: number;
  };
  /**
   * Where the price was found. One or more sources, each with a type and optional detail.
   * @minItems 1
   */
  source: {
    /** The kind of source. */
    type: AnkorstoreInternalPriceReportFieldsTypeEnum;
    /** Optional free-text detail about this source. */
    detail?: string;
  }[];
  /** Whether the reported price is a promotional price. */
  promotion?: AnkorstoreInternalPriceReportFieldsPromotionEnum;
}

export interface AnkorstoreInternalIssueResource {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  type: AnkorstoreInternalIssueResourceTypeEnum;
  attributes: {
    type?: AnkorstoreInternalIssueResourceTypeEnum1;
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    closedAt?: string | null;
    closedBy?: string | null;
    status?: string;
    resolution?: string;
    resolvedByBrand?: boolean | null;
    /** Price report field values, validated server-side against the issue schema. */
    fields?: {
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      price?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Where the price was found. One or more sources, each with a type and optional detail.
       * @minItems 1
       */
      source: {
        /** The kind of source. */
        type: AnkorstoreInternalIssueResourceTypeEnum2;
        /** Optional free-text detail about this source. */
        detail?: string;
      }[];
      /** Whether the reported price is a promotional price. */
      promotion?: AnkorstoreInternalIssueResourcePromotionEnum;
    };
  };
}

export interface AnkorstoreInternalSchemasOrderItem {
  state: AnkorstoreInternalSchemasOrderItemStateEnum;
  brand_name: string;
  url: string;
  /** Present only when state is active */
  status?: AnkorstoreInternalSchemasOrderItemStatusEnum;
}

export interface AnkorstoreInternalOrdersCard {
  /** List of relevant order items (at most 1 item) */
  items: {
    state: AnkorstoreInternalOrdersCardStateEnum;
    brand_name: string;
    url: string;
    /** Present only when state is active */
    status?: AnkorstoreInternalOrdersCardStatusEnum;
  }[];
  /** Global order state when no items are returned. null when items contains an entry. */
  state: AnkorstoreInternalOrdersCardStateEnum1;
}

export interface AnkorstoreInternalPaymentCard {
  state: AnkorstoreInternalPaymentCardStateEnum;
  /** Amount in cents. Present for upcoming_debit and incoming_credit states. */
  amount_cents?: number;
  /** ISO 4217 currency code. Present for upcoming_debit and incoming_credit states. */
  currency?: string;
  /**
   * Due date (YYYY-MM-DD). Present for upcoming_debit and incoming_credit states.
   * @format date
   */
  due_at?: string;
}

export interface AnkorstoreInternalYourBrandsCard {
  state: AnkorstoreInternalYourBrandsCardStateEnum;
  /** Number of new products from followed brands. Present when state is news. */
  new_products_count?: number;
  /** Number of restock recommendations. Present when state is news or no_brands. */
  restock_count?: number;
}

export interface AnkorstoreInternalDontMissCard {
  /** Discount percentage to highlight */
  discount_percent: number;
  variant: AnkorstoreInternalDontMissCardVariantEnum;
}

export interface AnkorstoreInternalRetailerDashboard {
  /** True if the retailer registered within the last 15 days */
  is_onboarding: boolean;
  /** Orders card data. Null during onboarding or when not applicable. */
  orders: {
    /** List of relevant order items (at most 1 item) */
    items: {
      state: AnkorstoreInternalRetailerDashboardStateEnum;
      brand_name: string;
      url: string;
      /** Present only when state is active */
      status?: AnkorstoreInternalRetailerDashboardStatusEnum;
    }[];
    /** Global order state when no items are returned. null when items contains an entry. */
    state: AnkorstoreInternalRetailerDashboardStateEnum1;
  } | null;
  /** Payment & credit card data. Null during onboarding, on API errors, or when no relevant payment data exists. */
  payment: {
    state: AnkorstoreInternalRetailerDashboardStateEnum2;
    /** Amount in cents. Present for upcoming_debit and incoming_credit states. */
    amount_cents?: number;
    /** ISO 4217 currency code. Present for upcoming_debit and incoming_credit states. */
    currency?: string;
    /**
     * Due date (YYYY-MM-DD). Present for upcoming_debit and incoming_credit states.
     * @format date
     */
    due_at?: string;
  } | null;
  /** Your brands card data. Always present (even during onboarding). */
  your_brands: {
    state: AnkorstoreInternalRetailerDashboardStateEnum3;
    /** Number of new products from followed brands. Present when state is news. */
    new_products_count?: number;
    /** Number of restock recommendations. Present when state is news or no_brands. */
    restock_count?: number;
  } | null;
  /** Don't miss card data. Currently always null. */
  dont_miss: {
    /** Discount percentage to highlight */
    discount_percent: number;
    variant: AnkorstoreInternalRetailerDashboardVariantEnum;
  } | null;
}

/** Present in the top level `meta` of every webhook payload; describes the fired event. */
export interface AnkorstoreWebhookEventMeta {
  event?: {
    /**
     * Unique identifier of this webhook delivery.
     * @format uuid
     */
    id?: string;
    /**
     * Application the webhook subscription belongs to.
     * @format uuid
     */
    applicationId?: string;
    /** The event that fired this webhook. */
    type?: string;
    /** Unix timestamp (seconds) of when the event fired. */
    timestamp?: number;
  };
}

export interface AnkorstoreFailure {
  /** @uniqueItems true */
  errors: {
    /** An application-specific error code, expressed as a string value. */
    code?: string;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string;
    /** The HTTP status code applicable to this problem, expressed as a string value. */
    status?: string;
    /** The HTTP status code description applicable to this problem */
    title?: string;
    /** Optional object pointing towards the problematic field */
    source?: {
      /** The field key */
      pointer?: string;
    };
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Non-standard meta-information that can not be represented as an attribute or relationship. */
export type AnkorstoreMeta = Record<string, any>;

/** References to other resource objects in a to-one (`relationship`). Relationships can be specified by including a member in a resource's links object. */
export interface AnkorstoreRelationshipToOne {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/**
 * An array of objects each containing `type` and `id` members for to-many relationships.
 * @uniqueItems true
 */
export type AnkorstoreRelationshipToMany = {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}[];

/** Resource identification present in Resource Objects and Resource Identifier Objects. */
export interface AnkorstoreLinkage {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/** An object describing the server's implementation */
export interface AnkorstoreJsonapi {
  version?: string;
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

export interface AnkorstoreError {
  /** An application-specific error code, expressed as a string value. */
  code?: string;
  /** A human-readable explanation specific to this occurrence of the problem. */
  detail?: string;
  /** The HTTP status code applicable to this problem, expressed as a string value. */
  status?: string;
  /** The HTTP status code description applicable to this problem */
  title?: string;
  /** Optional object pointing towards the problematic field */
  source?: {
    /** The field key */
    pointer?: string;
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/**
 * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
 * @format uuid
 */
export type AnkorstoreId = string;

/** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
export type AnkorstoreType = string;

/** Lowest denomination of the currency this amount belongs to. */
export type AnkorstoreMoney = number;

/**
 * ISO 3-Letter Currency Code
 * @example "EUR"
 */
export type AnkorstoreCurrency = string;

/** The unit of mass */
export enum AnkorstoreMassUnit {
  G = 'g',
}

/** The unit of distance */
export enum AnkorstoreDistanceUnit {
  Cm = 'cm',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreInventoryPolicy {
  Deny = 'deny',
  Continue = 'continue',
}

/** Meta with Pagination Details */
export interface AnkorstorePaginationMeta {
  /** Cursor pagination details */
  page: {
    from: string | null;
    to: string | null;
    hasMore?: boolean;
    perPage: number;
  };
  [key: string]: any;
}

/** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
export interface AnkorstorePaginationLinks {
  /** @format url */
  first?: string;
  /** @format url */
  next?: string;
  /** @format url */
  prev?: string;
}

export interface AnkorstoreCurrencyRate {
  /** @pattern ^[A-Z]{3}$ */
  fromCurrency?: string;
  /** @pattern ^[A-Z]{3}$ */
  toCurrency?: string;
  /** @format date */
  date?: string;
  rate?: number;
}

/**
 * Order Resource
 * The resource object for Order
 */
export interface AnkorstoreOrder {
  /** @default "orders" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: {
    /**
     * The identifier of the linked master order
     * @format uuid
     */
    masterOrderId?: string;
    /** @example "ankor_confirmed" */
    status?: AnkorstoreOrderStatusEnum;
    /** The order reference used on shipping labels, communication etc */
    reference?: number;
    /** The currency the brand is paid in */
    brandCurrency?: string;
    /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
    brandNetAmount?: number;
    /** The total of all order items not including VAT */
    brandTotalAmount?: number;
    /** The total VAT of all order items */
    brandTotalAmountVat?: number;
    /** The total of all order items including VAT */
    brandTotalAmountWithVat?: number;
    /** The chosen shipping method after going through the shipping process */
    shippingMethod?: AnkorstoreOrderShippingMethodEnum;
    /**
     * Order Resource -> Shipping Overview
     * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
     */
    shippingOverview?: {
      /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
      availableShippingMethods: AnkorstoreOrderAvailableShippingMethodsEnum[];
      /** The address the order needs to be shipped to */
      shipToAddress: {
        /** The first and last name of the recipient */
        name?: null | string;
        /** The organisational name of the recipient */
        organisationName?: null | string;
        street: null | string;
        city: null | string;
        postalCode: null | string;
        countryCode?: null | string;
      };
      /** The minimum and maximum expected shipping dates */
      expectedShippingDates: {
        /** @format datetime */
        minimum: string;
        /** @format datetime */
        maximum: string;
        /** @format datetime */
        updatedMaximum?: null | string;
      };
      /** The company providing the shipping service */
      provider?: AnkorstoreOrderProviderEnum;
      /** Tracking details of the order */
      tracking?: {
        number?: string;
        /**
         * A URL to view the tracking status
         * @format url
         */
        link?: string;
      };
      /**
       * The quote is the price of the parcel(s) shipping.
       * If this object is null then no quote has been generated.
       */
      latestQuote?: {
        /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
        id: string;
        /**
         * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
         * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
         */
        provider: AnkorstoreOrderProviderEnum1;
        /** The provider of the rate for `rateAmount`. */
        rateProvider?: AnkorstoreOrderRateProviderEnum;
        /** Amount calculated for the parcels provided. */
        rateAmount?: {
          /** Lowest denomination of the currency this amount belongs to. */
          amount?: number;
          currency?: string;
        };
        /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
        shippingCostsOverview?: {
          /** Lowest denomination of the currency this amount belongs to. */
          amount?: number;
          currency?: string;
          /**
           * Type of shipping costs:
           * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
           * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
           */
          type?: AnkorstoreOrderTypeEnum;
        };
      };
      /** @uniqueItems true */
      parcels?: {
        /** @max 274 */
        length: number;
        /** @max 274 */
        width: number;
        /** @max 274 */
        height: number;
        /** The unit of distance */
        distanceUnit: AnkorstoreOrderDistanceUnitEnum;
        /**
         * @min 1
         * @max 30000
         */
        weight: number;
        /** The unit of mass */
        massUnit: AnkorstoreOrderMassUnitEnum;
        /** The tracking per parcel */
        trackedPackage: {
          /**
           * The URL to download the shipping label
           * @format url
           */
          labelUrl: null | string;
          /** @format datetime */
          eta: null | string;
          trackingNumber?: string;
          trackingLink: string;
          currentStatus: {
            /** The current status of the order/parcel */
            status?: AnkorstoreOrderStatusEnum1;
            /** Human readable version of status */
            statusDetails?: string | null;
            /**
             * Last time the status was updated
             * @format datetime
             */
            updatedAt?: string;
            /** Last known location */
            location?: {
              city?: null | string;
              state?: null | string;
              zip?: null | string;
              country?: null | string;
            };
          };
        };
      }[];
      transaction?: {
        /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
        pickup: {
          /**
           * The date of the pickup
           * @format datetime
           */
          pickupDate: string;
          /** Opening time of pickup Eg: 10:00:00 */
          readyTime: string;
          /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
          closeTime: string;
          /** The reference number for this pickup */
          externalReferenceId: string;
        };
        /** The tracking details for the overall shipment */
        tracking: {
          /**
           * The estimated time of arrival for the order
           * @format datetime
           */
          eta?: null | string;
          /** The tracking number of the order */
          trackingNumber?: string;
          /**
           * The tracking link for the order
           * @format url
           */
          trackingLink?: string;
          currentStatus?: {
            /** The current status of the order/parcel */
            status?: AnkorstoreOrderStatusEnum2;
            /** Human readable version of status */
            statusDetails?: string | null;
            /**
             * Last time the status was updated
             * @format datetime
             */
            updatedAt?: string;
            /** Last known location */
            location?: {
              city?: null | string;
              state?: null | string;
              zip?: null | string;
              country?: null | string;
            };
          };
        };
      };
    };
    /** The reason the brand has given for rejecting the order */
    brandRejectReason?: null | string;
    /** The reason the retailer rejected the reception of the order */
    retailerRejectReason?: null | string;
    /** The reason the retailer has given for a cancellation request */
    retailerCancellationRequestReason?: null | string;
    /** The billing address name */
    billingName?: null | string;
    /** The billing address organisation name */
    billingOrganisationName?: null | string;
    /** The billing address street name */
    billingStreet?: null | string;
    /** The billing address postal code */
    billingPostalCode?: null | string;
    /** The billing address city */
    billingCity?: null | string;
    /** The billing address country code - ISO format */
    billingCountryCode?: null | string;
    /**
     * The timestamp of when the order was submitted (order is placed)
     * @format datetime
     */
    submittedAt?: string;
    /**
     * The timestamp of when the order was shipped
     * @format datetime
     */
    shippedAt?: null | string;
    /**
     * The timestamp of when the brand was paid
     * @format datetime
     */
    brandPaidAt?: null | string;
    /**
     * (deprecated) The timestamp of when the order was created (before retailer payment)
     * @format datetime
     */
    createdAt?: string;
    /**
     * The timestamp of when the order was updated (does not include other resources)
     * @format datetime
     */
    updatedAt?: string;
  };
  relationships?: {
    /** Related Retailer Resource */
    retailer?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      } & {
        type?: 'retailers';
      };
    };
    /** Related Billing Item Resources */
    billingItems?: {
      /** @uniqueItems true */
      data?: ({
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      } & {
        type?: 'billing-items';
      })[];
    };
    /** Related Order Item Resources */
    orderItems?: {
      /** @uniqueItems true */
      data?: ({
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      } & {
        type?: 'order-items';
      })[];
    };
    /** Schema: Order Item -> Product Option Resource */
    'orderItems-productOption'?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    /** Schema: Order Item -> Product Option Resource -> Product */
    'orderItems-productOption-product'?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    /** Schema: Order Item -> Product Variant Resource */
    'orderItems-productVariant'?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    /** Schema: Order Item -> Product Variant Resource -> Product */
    'orderItems-productVariant-product'?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/** Order Item Resource */
export interface AnkorstoreOrderItem {
  /** @default "order-items" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: {
    /** The currency of the amounts for the brand */
    brandCurrency?: string;
    /** The ordered quantity of the product */
    quantity?: number;
    /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
    multipliedQuantity?: number;
    /**
     * The VAT percentage rate of the order item (0-100)
     * @format float
     */
    vatRate?: number;
    /** The amount due to the brand for this item */
    brandAmount?: number;
    /** The VAT amount due to the brand for this item */
    brandAmountVat?: number;
    /** The amount + VAT due to the brand for this item */
    brandAmountWithVat?: number;
    /** The cost of a single unit of this item */
    brandUnitPrice?: number;
    /**
     * The timestamp this order item was created
     * @format datetime
     */
    createdAt?: string;
    /**
     * The timestamp this order item was updated
     * @format datetime
     */
    updatedAt?: string;
  };
  relationships?: {
    /** Reference: Product Option Resource */
    productOptions?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/** Billing Item Resource */
export interface AnkorstoreBillingItem {
  /** @default "billing-items" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: {
    /**
     * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
     *
     * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
     *
     * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
     *
     * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
     *
     * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
     *
     * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
     *
     * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
     *
     * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
     *
     * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
     */
    type?: AnkorstoreBillingItemTypeEnum;
    /** The currency of the billing item */
    currency?: string;
    /**
     * The VAT percentage rate of the billing item, (from 0 - 100).
     * @format float
     */
    vatRate?: number;
    /**
     * If the currency is not in EUR, this is the conversion rate used
     * @format float
     */
    currencyRate?: number;
    /** The amount for the billing item */
    amount?: number;
    /** The VAT amount for the billing item */
    amountVat?: number;
    /** The amount including VAT for the billing item */
    amountWithVat?: number;
    /**
     * The timestamp when the billing item was created
     * @format datetime
     */
    createdAt?: string;
    /**
     * The timestamp when the billing item was updated
     * @format datetime
     */
    updatedAt?: string;
  };
}

/**
 * Product Variant Resource
 * Variant details for a given product. Unique products will have one single variant.
 */
export interface AnkorstoreProductVariant {
  /** @default "product-variants" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: {
    /** The name of the product variant */
    name?: string;
    /** The SKU of the product variant */
    sku?: string;
    /** The IAN (EAN) of the product variant, can be null */
    ian?: null | string;
    /**
     * Timestamp of when this product variant was created
     * @format datetime
     */
    createdAt?: string;
    /**
     * Timestamp of when this product variant was updated
     * @format datetime
     */
    updatedAt?: string;
    /** Timestamp of when this product variant was archived */
    archivedAt?: null | string;
    /** The suggested retail price of the product */
    retailPrice?: number;
    /** The wholesale price after the discount rate is applied */
    wholesalePrice?: number;
    /** The original wholesale price set by the brand */
    originalWholesalePrice?: number;
    /** Number of units that are available to order */
    availableQuantity?: null | number;
    /** Number of units in stock that are reserved */
    reservedQuantity?: number;
    /** Total number of units in stock (available + reserved) */
    stockQuantity?: null | number;
    /**
     * Whether stock is tracked at all for this product variant.
     *
     * - `true`: stock is not tracked — a retailer can order as much of
     *   this variant as they want, with no restriction at all.
     * - `false`: stock is tracked — whether a retailer can order the
     *   variant depends on the available stock quantity and the
     *   `inventoryPolicy`.
     */
    isAlwaysInStock?: boolean;
    /**
     * Whether a retailer can order a product variant for which stock is not
     * available.
     *
     * - `deny` (default): no. A retailer cannot order a quantity larger than
     *
     *
     *   the currently available stock quantity, so the variant cannot be
     *   ordered when it is out of stock, or when the desired quantity exceeds
     *   the available quantity.
     * - `continue`: yes. The retailer can order any quantity, even when stock
     *
     *
     *   is insufficient (desired quantity > available quantity > 0) or the
     *   variant is out of stock (available quantity <= 0).
     *
     * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
     * @default "deny"
     */
    inventoryPolicy?: AnkorstoreProductVariantInventoryPolicyEnum;
    /**
     * Resource ID used for interacting with the fulfillment service
     * @format uuid
     */
    fulfillableId?: null | string;
    /**
     * Shipping date(in future) of a preorder product e.g. 2028-12-01
     * @format date
     */
    availableAt?: string | null;
    /** List of variant images ordered by display priority */
    images?: {
      /** Display order of the image (lower is higher priority) */
      order?: number;
      /** URL of the variant image */
      url?: string;
    }[];
  };
  relationships?: {
    /** Reference: Product Resource */
    product?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/**
 * Product Option Resource
 * A unique option for a product
 */
export interface AnkorstoreProductOption {
  /** @default "product-options" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: {
    /** The name of the option */
    name?: string;
    /** The SKU of the option */
    sku?: string;
    /** The IAN (EAN) of the option, can be null */
    ian?: null | string;
    /** Whether the product is in stock or not */
    outOfStock?: boolean;
    /**
     * Timestamp of when this option was created
     * @format datetime
     */
    createdAt?: string;
    /**
     * Timestamp of when this option was updated
     * @format datetime
     */
    updatedAt?: string;
    /** Timestamp of when this option was archived */
    archivedAt?: null | string;
  };
  relationships?: {
    /** Reference: Product Resource */
    product?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

/**
 * Product Resource
 * The resource object for Product
 */
export interface AnkorstoreProduct {
  /** @default "products" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes?: {
    /** The name of the product */
    name?: string;
    /** The description of the product */
    description?: string;
    /** The language of the title and description */
    language?: string;
    /** The human readable dimensions of the product */
    dimensions?: string;
    /** The weight of the product itself */
    netWeight?: string;
    /** eg. Capacity in weight eg 100g */
    capacity?: string;
    /** The position of the product in the brands catalog, lower the higher it is */
    position?: number;
    /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
    unitMultiplier?: number;
    /**
     * The VAT rate of the product
     * @format float
     */
    vatRate?: number;
    /**
     * The percentage discount if a brand is offering one (0 - 1)
     * @format float
     */
    discountRate?: number;
    /**
     * Product Type ID
     * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
     * @format integer
     */
    productTypeId?: number;
    /** Whether the product is active or not */
    active?: boolean;
    /** Whether the product is out of stock or not */
    outOfStock?: boolean;
    /** Whether the product is archived or not */
    archived?: boolean;
    /** The suggested retail price of the product */
    retailPrice?: number;
    /** The wholesale price after the discount rate is applied */
    wholesalePrice?: number;
    /** The original wholesale price set by the brand */
    originalWholesalePrice?: number;
    /**
     * The timestamp when the product was created
     * @format datetime
     */
    createdAt?: string;
    /**
     * The timestamp when the product was indexed
     * @format datetime
     */
    indexedAt?: null | string;
    /**
     * The timestamp when the product was updated
     * @format datetime
     */
    updatedAt?: string;
    /** List of product images ordered by display priority */
    images?: {
      /** Display order of the image (lower is higher priority) */
      order?: number;
      /** URL of the product image */
      url?: string;
    }[];
    /** List of tags associated with the product */
    tags?: string[];
  };
  relationships?: {
    /** Reference: Product Option Resource */
    productOption?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    /** Reference: Product Variant Resource */
    productVariant?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/**
 * Retailer Resource
 * @example {"type":"retailers","id":"092b63ce-c5b9-1eca-b05f-0242ac170007","attributes":{"companyName":null,"storeName":"TEST RETAILER","storeUrl":null,"email":"retailer@example.com","firstName":"John","lastName":"Smith","taxNumber":"12345678","vatNumber":"FR123456789","eoriNumber":null,"phoneNumberE164":"+3345656456456","businessIdentifier":"3454353455","createdAt":"2020-06-19T11:59:30.000000Z","updatedAt":"2020-06-21T15:27:39.000000Z"}}
 */
export interface AnkorstoreRetailer {
  /** @default "retailers" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** The registered company of the retailer */
    companyName?: string | null;
    /** The name of the store */
    storeName?: string;
    /**
     * The store's website
     * @format url
     */
    storeUrl?: string | null;
    /**
     * Contact email for the retailer
     * @format email
     */
    email?: string;
    /** Retailer's first name */
    firstName?: string;
    /** Retailer's last name */
    lastName?: string;
    /** Retailer's tax number */
    taxNumber?: string;
    /** Retailer's VAT number */
    vatNumber?: string;
    /** Retailer's EORI number */
    eoriNumber?: string | null;
    /** Retailer's phone number (E164 format) */
    phoneNumberE164?: string;
    /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
    businessIdentifier?: string;
    /**
     * The timestamp when the retailer was created
     * @format datetime
     */
    createdAt?: string;
    /**
     * The timestamp when the retailer was updated
     * @format datetime
     */
    updatedAt?: string;
  };
  relationships?: {
    /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
    orders?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/** ShippingSettingsResource */
export interface AnkorstoreShippingSettingsResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    publicAddress: {
      street: string;
      postalCode: string;
      city: string;
      countryCode: string;
    };
    shippingAddress: {
      street: string;
      postalCode: string;
      city: string;
      countryCode: string;
    };
    billingAddress: {
      street: string;
      postalCode: string;
      city: string;
      countryCode: string;
    };
    eoriNumber: string;
    lucidNumber: string;
    averageLeadTime: string;
    /** List of country iso codes */
    whitelistCountries: string[];
  };
}

export interface AnkorstoreCurrencyRateResource {
  /** @default "currency-rates" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @pattern ^[A-Z]{3}$ */
    fromCurrency?: string;
    /** @pattern ^[A-Z]{3}$ */
    toCurrency?: string;
    /** @format date */
    date?: string;
    rate?: number;
  };
}

export interface AnkorstoreUserConfig {
  currency?: string;
  country?: string;
  browserId?: string;
}

export interface AnkorstoreUserConfigResource {
  /** @default "user-configs" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    currency?: string;
    country?: string;
    browserId?: string;
  };
}

/** Product Collection */
export interface AnkorstoreProductCollection {
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  /**
   * List of Product resource objects
   * @uniqueItems true
   */
  data: {
    /** @default "products" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product */
      name?: string;
      /** The description of the product */
      description?: string;
      /** The language of the title and description */
      language?: string;
      /** The human readable dimensions of the product */
      dimensions?: string;
      /** The weight of the product itself */
      netWeight?: string;
      /** eg. Capacity in weight eg 100g */
      capacity?: string;
      /** The position of the product in the brands catalog, lower the higher it is */
      position?: number;
      /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
      unitMultiplier?: number;
      /**
       * The VAT rate of the product
       * @format float
       */
      vatRate?: number;
      /**
       * The percentage discount if a brand is offering one (0 - 1)
       * @format float
       */
      discountRate?: number;
      /**
       * Product Type ID
       * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
       * @format integer
       */
      productTypeId?: number;
      /** Whether the product is active or not */
      active?: boolean;
      /** Whether the product is out of stock or not */
      outOfStock?: boolean;
      /** Whether the product is archived or not */
      archived?: boolean;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /**
       * The timestamp when the product was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp when the product was indexed
       * @format datetime
       */
      indexedAt?: null | string;
      /**
       * The timestamp when the product was updated
       * @format datetime
       */
      updatedAt?: string;
      /** List of product images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the product image */
        url?: string;
      }[];
      /** List of tags associated with the product */
      tags?: string[];
    };
    relationships?: {
      /** Reference: Product Option Resource */
      productOption?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /** Reference: Product Variant Resource */
      productVariant?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  }[];
}

/** Product Get */
export interface AnkorstoreProductGet {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Product Resource
   * The resource object for Product
   */
  data: {
    /** @default "products" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product */
      name?: string;
      /** The description of the product */
      description?: string;
      /** The language of the title and description */
      language?: string;
      /** The human readable dimensions of the product */
      dimensions?: string;
      /** The weight of the product itself */
      netWeight?: string;
      /** eg. Capacity in weight eg 100g */
      capacity?: string;
      /** The position of the product in the brands catalog, lower the higher it is */
      position?: number;
      /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
      unitMultiplier?: number;
      /**
       * The VAT rate of the product
       * @format float
       */
      vatRate?: number;
      /**
       * The percentage discount if a brand is offering one (0 - 1)
       * @format float
       */
      discountRate?: number;
      /**
       * Product Type ID
       * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
       * @format integer
       */
      productTypeId?: number;
      /** Whether the product is active or not */
      active?: boolean;
      /** Whether the product is out of stock or not */
      outOfStock?: boolean;
      /** Whether the product is archived or not */
      archived?: boolean;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /**
       * The timestamp when the product was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp when the product was indexed
       * @format datetime
       */
      indexedAt?: null | string;
      /**
       * The timestamp when the product was updated
       * @format datetime
       */
      updatedAt?: string;
      /** List of product images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the product image */
        url?: string;
      }[];
      /** List of tags associated with the product */
      tags?: string[];
    };
    relationships?: {
      /** Reference: Product Option Resource */
      productOption?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /** Reference: Product Variant Resource */
      productVariant?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: any[] | null;
}

/** Product Variant Collection */
export interface AnkorstoreProductVariantCollection {
  /**
   * List of Product Variant resource objects
   * @uniqueItems true
   */
  data: {
    /** @default "product-variants" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product variant */
      name?: string;
      /** The SKU of the product variant */
      sku?: string;
      /** The IAN (EAN) of the product variant, can be null */
      ian?: null | string;
      /**
       * Timestamp of when this product variant was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * Timestamp of when this product variant was updated
       * @format datetime
       */
      updatedAt?: string;
      /** Timestamp of when this product variant was archived */
      archivedAt?: null | string;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /** Number of units that are available to order */
      availableQuantity?: null | number;
      /** Number of units in stock that are reserved */
      reservedQuantity?: number;
      /** Total number of units in stock (available + reserved) */
      stockQuantity?: null | number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of
       *
       *
       *   this variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock?: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy?: AnkorstoreProductVariantCollectionInventoryPolicyEnum;
      /**
       * Resource ID used for interacting with the fulfillment service
       * @format uuid
       */
      fulfillableId?: null | string;
      /**
       * Shipping date(in future) of a preorder product e.g. 2028-12-01
       * @format date
       */
      availableAt?: string | null;
      /** List of variant images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the variant image */
        url?: string;
      }[];
    };
    relationships?: {
      /** Reference: Product Resource */
      product?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * ProductVariantStockUpdateSetStockQuantity
 * A request schema to update product variant stock value by setting explicit stock quantity.
 */
export interface AnkorstoreProductVariantStockUpdateSetStockQuantity {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** @default "product-variants" */
  type: string;
  attributes: {
    /**
     * Total number of units in stock (available + reserved)
     * @min 0
     * @example 100
     */
    stockQuantity: number;
    /**
     * Whether a retailer can order this variant for which stock is not
     * available. `deny` (default) rejects any quantity larger than the
     * available stock quantity; `continue` lets the retailer order any
     * quantity, even when stock is insufficient or the variant is out
     * of stock. Only valid alongside a tracked stock update (this
     * schema). Omit to preserve the variant's current policy.
     * @default "deny"
     */
    inventoryPolicy?: AnkorstoreProductVariantStockUpdateSetStockQuantityInventoryPolicyEnum;
  };
}

/**
 * ProductVariantStockUpdateSetIsAlwaysInStockRequest
 * A request schema to update product variant stock value by setting option "always in stock" to true. It will also reset any possibly previously existed explicit stock quantities.
 */
export interface AnkorstoreProductVariantStockUpdateSetIsAlwaysInStock {
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** @default "product-variants" */
  type: string;
  attributes: {
    /**
     * Whether stock is tracked at all for this product variant.
     *
     * - `true`: stock is not tracked — a retailer can order as much of
     *   this variant as they want, with no restriction at all.
     * - `false`: stock is tracked — whether a retailer can order the
     *   variant depends on the available stock quantity and the
     *   `inventoryPolicy`.
     */
    isAlwaysInStock: boolean;
    /**
     * Whether a retailer can order this variant for which stock is not
     * available. Only `deny` is accepted in combination with
     * `isAlwaysInStock=true`: an always-in-stock variant has no stock
     * tracking, so the policy is irrelevant and `continue` cannot be
     * set. Use the `stockQuantity` form of this endpoint to set
     * `continue`.
     * @default "deny"
     */
    inventoryPolicy?: AnkorstoreProductVariantStockUpdateSetIsAlwaysInStockInventoryPolicyEnum;
  };
}

/**
 * OperationSource
 * Source of the operation
 */
export enum AnkorstoreOperationSource {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum AnkorstoreOperationStatus {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum AnkorstoreOperationType {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

/**
 * updateFields
 * List of fields or group of fields that will be updated on provided products
 */
export type AnkorstoreUpdateFields = AnkorstoreUpdateFieldsEnum[];

/**
 * Operation
 * An operation resource
 */
export interface AnkorstoreOperation {
  /**
   * A globally-unique identifier for the operation
   * @format uuid
   */
  id: string;
  /** Resource type. */
  type: AnkorstoreOperationTypeEnum;
  /** The operation attributes. */
  attributes?: {
    /**
     * OperationSource
     * Source of the operation
     */
    source?: AnkorstoreOperationSourceEnum;
    /** OperationStatus */
    status?: AnkorstoreOperationStatusEnum;
    /**
     * OperationType
     * Operation type
     */
    operationType?: AnkorstoreOperationOperationTypeEnum;
    /**
     * updateFields
     * List of fields or group of fields that will be updated on provided products
     */
    updateFields?: AnkorstoreOperationUpdateFieldsEnum[];
    /**
     * Date and time when operation was created
     * @format date-time
     */
    createdAt?: string;
    /**
     * Date and time when operation processing started
     * @format date-time
     */
    startedAt?: null | string;
    /**
     * Date and time when operation was completed
     * @format date-time
     */
    completedAt?: null | string;
    /**
     * a URL where the user will be notified after the operation is complete
     * @format uri
     */
    callbackUrl?: null | string;
    /** Total number of products in the batch */
    totalProductsCount?: number;
    /** Number of products successfully processed */
    processedProductsCount?: number;
    /** Number of products which processing failed */
    failedProductsCount?: number;
  };
}

/** CallbackEvent */
export interface AnkorstoreCallbackEvent {
  /**
   * The name of the event that occurred
   * @example "completed"
   */
  event: string;
  /**
   * The event category represented as a unique identifier of the event type. The topic is defined as a concatenation of the resource and event names `{$.data.type}.{$.event}`. You might use this topic as a partition key to distribute the callback events you receive to separate queues or pools of workers to process the callbacks asynchronously.
   * @example "catalog-integration-operation.completed"
   */
  topic: string;
  /**
   * The date and time when event occurred
   * @format date-time
   */
  occurredAt: string;
  /**
   * Operation
   * the JSON:API resource describing the state of the entity which triggered the callback
   */
  data?: {
    /**
     * A globally-unique identifier for the operation
     * @format uuid
     */
    id: string;
    /** Resource type. */
    type: AnkorstoreCallbackEventTypeEnum;
    /** The operation attributes. */
    attributes?: {
      /**
       * OperationSource
       * Source of the operation
       */
      source?: AnkorstoreCallbackEventSourceEnum;
      /** OperationStatus */
      status?: AnkorstoreCallbackEventStatusEnum;
      /**
       * OperationType
       * Operation type
       */
      operationType?: AnkorstoreCallbackEventOperationTypeEnum;
      /**
       * updateFields
       * List of fields or group of fields that will be updated on provided products
       */
      updateFields?: AnkorstoreCallbackEventUpdateFieldsEnum[];
      /**
       * Date and time when operation was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when operation processing started
       * @format date-time
       */
      startedAt?: null | string;
      /**
       * Date and time when operation was completed
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * a URL where the user will be notified after the operation is complete
       * @format uri
       */
      callbackUrl?: null | string;
      /** Total number of products in the batch */
      totalProductsCount?: number;
      /** Number of products successfully processed */
      processedProductsCount?: number;
      /** Number of products which processing failed */
      failedProductsCount?: number;
    };
  };
}

/** Image */
export interface AnkorstoreOperationProductImageSchema {
  /**
   * Order number for the image to be shown
   * > Product Images:
   *     > 1 belongs to main image
   *     > Additional ones need to use 2 onwards
   *
   * > Variant Images:
   *     > Will inherit from parent product if not provided
   *     > Will be shown in the provided order
   */
  order?: number;
  /** URL of the image */
  url?: string;
}

/** Shape properties of the item */
export interface AnkorstoreOperationProductShapeSchema {
  /** Item dimensions */
  dimensions?: {
    /** Unit of the measure */
    unit_code?: string;
    /**
     * Width
     * @format float
     */
    width?: number;
    /**
     * height
     * @format float
     */
    height?: number;
    /**
     * length
     * @format float
     */
    length?: number;
  };
  /** Item capacity */
  capacity?: {
    /** Unit of the measure */
    unit_code?: string;
    /**
     * Number of units of capacity
     * @format float
     */
    amount?: number;
  };
  /** Item weight */
  weight?: {
    /** Unit of the measure */
    unit_code?: string;
    /**
     * Number of units of weight
     * @format float
     */
    amount?: number;
  };
}

/**
 * Specific options related to a variant
 * > Should not be provided in the case of having only one variant > Combination of values should be unique in the case of multiple variants
 */
export interface AnkorstoreOperationProductVariantOptionSchema {
  /** Name of the property */
  name?: AnkorstoreOperationProductVariantOptionSchemaNameEnum;
  /** Value for the option name */
  value?: string;
}

/** Variant of the product */
export interface AnkorstoreOperationProductVariantSchema {
  /**
   * IAN code
   * > Must be exactly 13 chars long
   */
  ian?: string;
  /** SKU code */
  sku?: string;
  /** Stock available, 0 means out of stock */
  stock_quantity?: number;
  /**
   * Whether stock is tracked at all for this product variant.
   *
   * - `true`: stock is not tracked — a retailer can order as much of this
   *
   *
   *   variant as they want, with no restriction at all, and the stock
   *   value is ignored.
   * - `false`: stock is tracked — whether a retailer can order the
   *
   *
   *   variant depends on the available stock quantity and the
   *   `inventory_policy`.
   */
  is_always_in_stock?: boolean;
  /**
   * Whether a retailer can order a product variant for which stock is not
   * available.
   *
   * - `deny` (default): no. A retailer cannot order a quantity larger
   *
   *
   *   than the currently available stock quantity, so the variant cannot
   *   be ordered when it is out of stock, or when the desired quantity
   *   exceeds the available quantity.
   * - `continue`: yes. The retailer can order any quantity, even when
   *
   *
   *   stock is insufficient (desired quantity > available quantity > 0)
   *   or the variant is out of stock (available quantity <= 0).
   *
   * Only meaningful when stock is tracked (`is_always_in_stock = false`).
   * Omit to inherit the variant's current policy (or `deny` for new
   * variants).
   * @default "deny"
   */
  inventory_policy?: AnkorstoreOperationProductVariantSchemaInventoryPolicyEnum;
  /** ID for the variant from external source */
  external_id?: string;
  /**
   * Discount rate applied
   * > Must be between 0 and 100 > Will be inherited from parent Product if not provided
   * @format float
   */
  discount_rate?: number;
  /**
   * Retail price
   * > Will be inherited from parent Product if not provided
   * @format float
   */
  retail_price?: number;
  /**
   * Wholesale price
   * > Will be inherited from parent Product if not provided
   * @format float
   */
  wholesale_price?: number;
  /** Shape properties of the item */
  shape_properties?: {
    /** Item dimensions */
    dimensions?: {
      /** Unit of the measure */
      unit_code?: string;
      /**
       * Width
       * @format float
       */
      width?: number;
      /**
       * height
       * @format float
       */
      height?: number;
      /**
       * length
       * @format float
       */
      length?: number;
    };
    /** Item capacity */
    capacity?: {
      /** Unit of the measure */
      unit_code?: string;
      /**
       * Number of units of capacity
       * @format float
       */
      amount?: number;
    };
    /** Item weight */
    weight?: {
      /** Unit of the measure */
      unit_code?: string;
      /**
       * Number of units of weight
       * @format float
       */
      amount?: number;
    };
  };
  /** Options specific to the variant */
  options?: {
    /** Name of the property */
    name?: AnkorstoreOperationProductVariantSchemaNameEnum;
    /** Value for the option name */
    value?: string;
  }[];
  /** Images related to specific variant. Will be shown after the ones inherited from parent product in the provided order. */
  images?: {
    /**
     * Order number for the image to be shown
     * > Product Images:
     *     > 1 belongs to main image
     *     > Additional ones need to use 2 onwards
     *
     * > Variant Images:
     *     > Will inherit from parent product if not provided
     *     > Will be shown in the provided order
     */
    order?: number;
    /** URL of the image */
    url?: string;
  }[];
}

export interface AnkorstoreOperationProductSchema {
  /** User-defined unique identifier of the product */
  id: string;
  /**
   * Type of resource
   * @default "catalog-integration-product"
   */
  type: string;
  /**
   * The product attributes. In case of a deletion operation, no attribute is expected. The only required information is the unique product identifier to delete (see following example).
   * ```json
   *
   *
   *  {
   *     "id": "<User-defined Identifier>",
   *     "type": "catalog-integration-product"
   *  }
   * ```
   */
  attributes?: {
    /** ID from external source */
    external_id?: string;
    /** Product name */
    name?: string;
    /** List of product tags */
    tags?: any[];
    /**
     * URL of the image that will be used as main one for the product
     * > It will have the number 1 order
     */
    main_image?: string;
    /** List of additional images for the product (Variants will inherit them) */
    images?: {
      /**
       * Order number for the image to be shown
       * > Product Images:
       *     > 1 belongs to main image
       *     > Additional ones need to use 2 onwards
       *
       * > Variant Images:
       *     > Will inherit from parent product if not provided
       *     > Will be shown in the provided order
       */
      order?: number;
      /** URL of the image */
      url?: string;
    }[];
    /** HS code */
    hs_code?: string;
    /** Currency used in pricing */
    currency?: AnkorstoreOperationProductSchemaCurrencyEnum;
    /**
     * VAT rate
     * @format float
     */
    vat_rate?: number;
    /**
     * Product description
     * > Must be at least 30 chars long
     */
    description?: string;
    /**
     * Discount rate applied
     * > Must be between 0 and 100
     * @format float
     */
    discount_rate?: number;
    /**
     * The minimum quantity in which a product is sold. When adding the product on the cart, cart price is computed by multiplying wholesale price * unit_multiplier
     * > Must be at least 1
     * @format integer
     */
    unit_multiplier?: number;
    /**
     * Wholesale price
     * @format float
     */
    wholesale_price?: number;
    /**
     * Retail price
     * @format float
     */
    retail_price?: number;
    /** Country code in Alpha-2 format */
    made_in_country?: string;
    /**
     * @min 1
     * @max 32767
     */
    shelf_life_days?: number;
    storage_temperature?: AnkorstoreOperationProductSchemaStorageTemperatureEnum;
    /** Shape properties of the item */
    shape_properties?: {
      /** Item dimensions */
      dimensions?: {
        /** Unit of the measure */
        unit_code?: string;
        /**
         * Width
         * @format float
         */
        width?: number;
        /**
         * height
         * @format float
         */
        height?: number;
        /**
         * length
         * @format float
         */
        length?: number;
      };
      /** Item capacity */
      capacity?: {
        /** Unit of the measure */
        unit_code?: string;
        /**
         * Number of units of capacity
         * @format float
         */
        amount?: number;
      };
      /** Item weight */
      weight?: {
        /** Unit of the measure */
        unit_code?: string;
        /**
         * Number of units of weight
         * @format float
         */
        amount?: number;
      };
    };
    /**
     * Variant of the product
     * > Every product must have at least one variant > In the case of multiple variants, unique options should be provided for each of them
     */
    variants?: {
      /**
       * IAN code
       * > Must be exactly 13 chars long
       */
      ian?: string;
      /** SKU code */
      sku?: string;
      /** Stock available, 0 means out of stock */
      stock_quantity?: number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of this
       *
       *
       *   variant as they want, with no restriction at all, and the stock
       *   value is ignored.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventory_policy`.
       */
      is_always_in_stock?: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger
       *
       *
       *   than the currently available stock quantity, so the variant cannot
       *   be ordered when it is out of stock, or when the desired quantity
       *   exceeds the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when
       *
       *
       *   stock is insufficient (desired quantity > available quantity > 0)
       *   or the variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`is_always_in_stock = false`).
       * Omit to inherit the variant's current policy (or `deny` for new
       * variants).
       * @default "deny"
       */
      inventory_policy?: AnkorstoreOperationProductSchemaInventoryPolicyEnum;
      /** ID for the variant from external source */
      external_id?: string;
      /**
       * Discount rate applied
       * > Must be between 0 and 100 > Will be inherited from parent Product if not provided
       * @format float
       */
      discount_rate?: number;
      /**
       * Retail price
       * > Will be inherited from parent Product if not provided
       * @format float
       */
      retail_price?: number;
      /**
       * Wholesale price
       * > Will be inherited from parent Product if not provided
       * @format float
       */
      wholesale_price?: number;
      /** Shape properties of the item */
      shape_properties?: {
        /** Item dimensions */
        dimensions?: {
          /** Unit of the measure */
          unit_code?: string;
          /**
           * Width
           * @format float
           */
          width?: number;
          /**
           * height
           * @format float
           */
          height?: number;
          /**
           * length
           * @format float
           */
          length?: number;
        };
        /** Item capacity */
        capacity?: {
          /** Unit of the measure */
          unit_code?: string;
          /**
           * Number of units of capacity
           * @format float
           */
          amount?: number;
        };
        /** Item weight */
        weight?: {
          /** Unit of the measure */
          unit_code?: string;
          /**
           * Number of units of weight
           * @format float
           */
          amount?: number;
        };
      };
      /** Options specific to the variant */
      options?: {
        /** Name of the property */
        name?: AnkorstoreOperationProductSchemaNameEnum;
        /** Value for the option name */
        value?: string;
      }[];
      /** Images related to specific variant. Will be shown after the ones inherited from parent product in the provided order. */
      images?: {
        /**
         * Order number for the image to be shown
         * > Product Images:
         *     > 1 belongs to main image
         *     > Additional ones need to use 2 onwards
         *
         * > Variant Images:
         *     > Will inherit from parent product if not provided
         *     > Will be shown in the provided order
         */
        order?: number;
        /** URL of the image */
        url?: string;
      }[];
    }[];
  };
}

export interface AnkorstoreOperationIssue {
  /** Property name */
  field?: string;
  /** Reason of the validation failure */
  reason?: AnkorstoreOperationIssueReasonEnum;
  /** Details related to the validation failure */
  message?: string;
}

/** OperationResult */
export interface AnkorstoreOperationResult {
  /**
   * A globally-unique identifier for the result
   * @format uuid
   */
  id: string;
  /**
   * Type of resource object
   * @default "catalog-integration-result"
   */
  type: string;
  attributes?: {
    /** User-defined unique identifier of the product. May become "undefined" if the error concerns to the entire operation */
    externalProductId: string;
    /** The operation execution result for this product */
    status: AnkorstoreOperationResultStatusEnum;
    /** The reason for the failure if the operation processing failed */
    failureReason?: string | null;
    /** List of related issues found when processing - Only validation issues are exposed */
    issues?: {
      /** Property name */
      field?: string;
      /** Reason of the validation failure */
      reason?: AnkorstoreOperationResultReasonEnum;
      /** Details related to the validation failure */
      message?: string;
    }[];
  };
}

/**
 * Product Integration Resource list
 * Product Integration Resource list
 */
export interface AnkorstoreOperationReportSchema {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /**
     * A globally-unique identifier for the result
     * @format uuid
     */
    id: string;
    /**
     * Type of resource object
     * @default "catalog-integration-result"
     */
    type: string;
    attributes?: {
      /** User-defined unique identifier of the product. May become "undefined" if the error concerns to the entire operation */
      externalProductId: string;
      /** The operation execution result for this product */
      status: AnkorstoreOperationReportSchemaStatusEnum;
      /** The reason for the failure if the operation processing failed */
      failureReason?: string | null;
      /** List of related issues found when processing - Only validation issues are exposed */
      issues?: {
        /** Property name */
        field?: string;
        /** Reason of the validation failure */
        reason?: AnkorstoreOperationReportSchemaReasonEnum;
        /** Details related to the validation failure */
        message?: string;
      }[];
    };
  }[];
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
}

export interface AnkorstoreErrorReport {
  /**
   * Identifier of the PIM import job whose failed items are reported.
   * @format uuid
   */
  pimImportJobId: string;
  /**
   * Owning brand UUID.
   * @format uuid
   */
  brandUuid: string;
  /** Lifecycle status of the error report. */
  status: AnkorstoreErrorReportStatusEnum;
  /** Name the file will be served as. */
  filename: string;
  /** Reason of failure, set only when the status is `failed`. */
  failureReason?: null | string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startedAt?: null | string;
  /** @format date-time */
  completedAt?: null | string;
  /**
   * Moment after which the file is no longer downloadable. Reports are retained for 30 days after completion.
   * @format date-time
   */
  expiresAt?: null | string;
  /**
   * Present when the report is completed and not expired.
   * @format uri
   */
  downloadUrl?: null | string;
}

export interface AnkorstoreErrorReportResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Identifier of the PIM import job whose failed items are reported.
     * @format uuid
     */
    pimImportJobId: string;
    /**
     * Owning brand UUID.
     * @format uuid
     */
    brandUuid: string;
    /** Lifecycle status of the error report. */
    status: AnkorstoreErrorReportResourceStatusEnum;
    /** Name the file will be served as. */
    filename: string;
    /** Reason of failure, set only when the status is `failed`. */
    failureReason?: null | string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    startedAt?: null | string;
    /** @format date-time */
    completedAt?: null | string;
    /**
     * Moment after which the file is no longer downloadable. Reports are retained for 30 days after completion.
     * @format date-time
     */
    expiresAt?: null | string;
    /**
     * Present when the report is completed and not expired.
     * @format uri
     */
    downloadUrl?: null | string;
  };
}

export interface AnkorstoreExternalIntegration {
  platform: AnkorstoreExternalIntegrationPlatformEnum;
  status: AnkorstoreExternalIntegrationStatusEnum;
}

export interface AnkorstoreExternalIntegrationResource {
  /** @default "external-integrations" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    platform: AnkorstoreExternalIntegrationResourcePlatformEnum;
    status: AnkorstoreExternalIntegrationResourceStatusEnum;
  };
}

export interface AnkorstoreBrandResource {
  /** @format uuid */
  id: string;
  /** @default "brands" */
  type: string;
  attributes: {
    /** Brand name */
    name: string;
    automationMode: AnkorstoreBrandResourceAutomationModeEnum;
    /** Location that is used as authoritative for marketplace stock */
    marketplaceStockLocation: AnkorstoreBrandResourceMarketplaceStockLocationEnum;
    /** Set of brand image links, in different formats. */
    images: {
      squared?: string | null;
      rounded?: string | null;
      large?: string | null;
    };
    /** Relative path to the brand storefront page (slug-based). Null when the runtime route is not registered. */
    link: string | null;
  };
}

/** BrandContactResource */
export interface AnkorstoreBrandContactResource {
  type: 'brand-contacts';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format email */
    email: string;
    /** @minItems 1 */
    purposes: AnkorstoreBrandContactResourcePurposesEnum[];
  };
}

export interface AnkorstorePayoutMoney {
  /** Amount in the lowest denomination of the currency */
  amount: number;
  /**
   * ISO 3-letter currency code
   * @example "EUR"
   */
  currency: string;
}

export interface AnkorstoreInvoice {
  title?: string;
  number?: string | null;
  path?: string | null;
  isGenerated?: boolean;
}

export interface AnkorstoreTransferSource {
  /** @format uuid */
  uuid: string;
  /** Order reference (only present for order_payment transfers) */
  reference?: string;
  /**
   * Master order UUID (only present for order_payment transfers)
   * @format uuid
   */
  masterOrderUuid?: string;
  /** Retailer store name (only present for order_payment transfers) */
  customerStoreName?: string;
  /** Order type (only present for order_payment transfers) */
  type?: AnkorstoreTransferSourceTypeEnum;
  /** Related invoices (only present for order_payment transfers) */
  invoices?: {
    title?: string;
    number?: string | null;
    path?: string | null;
    isGenerated?: boolean;
  }[];
}

export interface AnkorstoreTransfer {
  /** @format uuid */
  uuid?: string;
  amount?: {
    /** Amount in the lowest denomination of the currency */
    amount: number;
    /**
     * ISO 3-letter currency code
     * @example "EUR"
     */
    currency: string;
  };
  /** Payment service provider transfer identifier */
  pspId?: string | null;
  type?: AnkorstoreTransferTypeEnum;
  source?: {
    /** @format uuid */
    uuid: string;
    /** Order reference (only present for order_payment transfers) */
    reference?: string;
    /**
     * Master order UUID (only present for order_payment transfers)
     * @format uuid
     */
    masterOrderUuid?: string;
    /** Retailer store name (only present for order_payment transfers) */
    customerStoreName?: string;
    /** Order type (only present for order_payment transfers) */
    type?: AnkorstoreTransferTypeEnum1;
    /** Related invoices (only present for order_payment transfers) */
    invoices?: {
      title?: string;
      number?: string | null;
      path?: string | null;
      isGenerated?: boolean;
    }[];
  };
}

export interface AnkorstorePayoutAttributes {
  amount?: {
    /** Amount in the lowest denomination of the currency */
    amount: number;
    /**
     * ISO 3-letter currency code
     * @example "EUR"
     */
    currency: string;
  };
  status?: AnkorstorePayoutAttributesStatusEnum;
  /** Payment service provider payout identifier (e.g. Stripe payout ID) */
  pspId?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  arrivedAt?: string | null;
  transfers?: {
    /** @format uuid */
    uuid?: string;
    amount?: {
      /** Amount in the lowest denomination of the currency */
      amount: number;
      /**
       * ISO 3-letter currency code
       * @example "EUR"
       */
      currency: string;
    };
    /** Payment service provider transfer identifier */
    pspId?: string | null;
    type?: AnkorstorePayoutAttributesTypeEnum;
    source?: {
      /** @format uuid */
      uuid: string;
      /** Order reference (only present for order_payment transfers) */
      reference?: string;
      /**
       * Master order UUID (only present for order_payment transfers)
       * @format uuid
       */
      masterOrderUuid?: string;
      /** Retailer store name (only present for order_payment transfers) */
      customerStoreName?: string;
      /** Order type (only present for order_payment transfers) */
      type?: AnkorstorePayoutAttributesTypeEnum1;
      /** Related invoices (only present for order_payment transfers) */
      invoices?: {
        title?: string;
        number?: string | null;
        path?: string | null;
        isGenerated?: boolean;
      }[];
    };
  }[];
}

export interface AnkorstorePayout {
  /** @format uuid */
  id: string;
  type: AnkorstorePayoutTypeEnum;
  attributes: {
    amount?: {
      /** Amount in the lowest denomination of the currency */
      amount: number;
      /**
       * ISO 3-letter currency code
       * @example "EUR"
       */
      currency: string;
    };
    status?: AnkorstorePayoutStatusEnum;
    /** Payment service provider payout identifier (e.g. Stripe payout ID) */
    pspId?: string | null;
    /** @format date-time */
    createdAt?: string | null;
    /** @format date-time */
    arrivedAt?: string | null;
    transfers?: {
      /** @format uuid */
      uuid?: string;
      amount?: {
        /** Amount in the lowest denomination of the currency */
        amount: number;
        /**
         * ISO 3-letter currency code
         * @example "EUR"
         */
        currency: string;
      };
      /** Payment service provider transfer identifier */
      pspId?: string | null;
      type?: AnkorstorePayoutTypeEnum1;
      source?: {
        /** @format uuid */
        uuid: string;
        /** Order reference (only present for order_payment transfers) */
        reference?: string;
        /**
         * Master order UUID (only present for order_payment transfers)
         * @format uuid
         */
        masterOrderUuid?: string;
        /** Retailer store name (only present for order_payment transfers) */
        customerStoreName?: string;
        /** Order type (only present for order_payment transfers) */
        type?: AnkorstorePayoutTypeEnum2;
        /** Related invoices (only present for order_payment transfers) */
        invoices?: {
          title?: string;
          number?: string | null;
          path?: string | null;
          isGenerated?: boolean;
        }[];
      };
    }[];
  };
}

export interface AnkorstorePayoutCollection {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    type: AnkorstorePayoutCollectionTypeEnum;
    attributes: {
      amount?: {
        /** Amount in the lowest denomination of the currency */
        amount: number;
        /**
         * ISO 3-letter currency code
         * @example "EUR"
         */
        currency: string;
      };
      status?: AnkorstorePayoutCollectionStatusEnum;
      /** Payment service provider payout identifier (e.g. Stripe payout ID) */
      pspId?: string | null;
      /** @format date-time */
      createdAt?: string | null;
      /** @format date-time */
      arrivedAt?: string | null;
      transfers?: {
        /** @format uuid */
        uuid?: string;
        amount?: {
          /** Amount in the lowest denomination of the currency */
          amount: number;
          /**
           * ISO 3-letter currency code
           * @example "EUR"
           */
          currency: string;
        };
        /** Payment service provider transfer identifier */
        pspId?: string | null;
        type?: AnkorstorePayoutCollectionTypeEnum1;
        source?: {
          /** @format uuid */
          uuid: string;
          /** Order reference (only present for order_payment transfers) */
          reference?: string;
          /**
           * Master order UUID (only present for order_payment transfers)
           * @format uuid
           */
          masterOrderUuid?: string;
          /** Retailer store name (only present for order_payment transfers) */
          customerStoreName?: string;
          /** Order type (only present for order_payment transfers) */
          type?: AnkorstorePayoutCollectionTypeEnum2;
          /** Related invoices (only present for order_payment transfers) */
          invoices?: {
            title?: string;
            number?: string | null;
            path?: string | null;
            isGenerated?: boolean;
          }[];
        };
      }[];
    };
  }[];
  meta: {
    page: {
      currentPage?: number;
      from?: number;
      lastPage?: number;
      perPage?: number;
      to?: number;
      total?: number;
      [key: string]: any;
    };
    [key: string]: any;
  };
}

/**
 * Promo Code Index Meta
 * Pagination details, plus the suffix every one of your codes carries.
 */
export interface AnkorstorePromoCodeIndexMeta {
  /** Cursor pagination details */
  page: {
    /** The id of the first code on this page. */
    from: string | null;
    /** The id of the last code on this page — the cursor for `page[after]`. */
    to: string | null;
    hasMore?: boolean;
    perPage: number;
  };
  /**
   * Your brand's suffix, appended to every code you create. Use it to show what a name will become — `AUTUMN26` with a suffix of `K4T2M` is redeemed as `AUTUMN26-K4T2M`. Assigned the first time you list your codes, and the same from then on.
   * @example "K4T2M"
   */
  promoCodeSuffix: string;
  [key: string]: any;
}

/**
 * Percentage Benefit
 * A percentage off the order total, including VAT. Currency-agnostic.
 */
export interface AnkorstorePromoCodePercentageBenefit {
  type: 'percentage';
  /**
   * Whole percent off.
   * @min 1
   * @max 100
   * @example 15
   */
  percentage: number;
}

/**
 * Promo Code Amounts
 * The same amount in each of the three retailer currencies, in the lowest denomination of each. Converted when the code is created, so a brand can quote the figure a retailer will see at checkout whatever the rate does afterwards.
 */
export interface AnkorstorePromoCodeAmounts {
  /** Lowest denomination of the currency this amount belongs to. */
  EUR?: number;
  /** Lowest denomination of the currency this amount belongs to. */
  GBP?: number;
  /** Lowest denomination of the currency this amount belongs to. */
  SEK?: number;
}

/**
 * Fixed Benefit
 * A fixed amount off, returned in all three retailer currencies.
 */
export interface AnkorstorePromoCodeFixedBenefit {
  type: 'fixed';
  /**
   * Promo Code Amounts
   * The same amount in each of the three retailer currencies, in the lowest denomination of each. Converted when the code is created, so a brand can quote the figure a retailer will see at checkout whatever the rate does afterwards.
   */
  amounts: {
    /** Lowest denomination of the currency this amount belongs to. */
    EUR?: number;
    /** Lowest denomination of the currency this amount belongs to. */
    GBP?: number;
    /** Lowest denomination of the currency this amount belongs to. */
    SEK?: number;
  };
}

/**
 * Promo Code Benefit
 * What the code takes off — either a percentage or a fixed amount, never both.
 */
export type AnkorstorePromoCodeBenefit =
  | ({
      type: 'percentage';
    } & AnkorstorePromoCodePercentageBenefit)
  | ({
      type: 'fixed';
    } & AnkorstorePromoCodeFixedBenefit);

/**
 * Promo Code Resource
 * The resource object for a promo code owned by your brand.
 */
export interface AnkorstorePromoCode {
  /** @default "promo-codes" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /**
     * The part of the code you chose. Set on creation and never changes.
     * @example "AUTUMN26"
     */
    name?: string;
    /**
     * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
     * @example "AUTUMN26-K4T2M"
     */
    code?: string;
    /**
     * Promo Code Benefit
     * What the code takes off — either a percentage or a fixed amount, never both.
     */
    benefit?:
      | ({
          type: 'percentage';
        } & AnkorstorePromoCodePercentageBenefit)
      | ({
          type: 'fixed';
        } & AnkorstorePromoCodeFixedBenefit);
    /** The order value a retailer must reach for the code to apply. Null if there is none. */
    minimumOrder?: {
      /** Lowest denomination of the currency this amount belongs to. */
      EUR?: number;
      /** Lowest denomination of the currency this amount belongs to. */
      GBP?: number;
      /** Lowest denomination of the currency this amount belongs to. */
      SEK?: number;
    } | null;
    /**
     * When the code stops working. Null if it never expires.
     * @format date-time
     * @example "2026-12-31T23:59:59.000000Z"
     */
    validUntil?: string | null;
    /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
    status?: AnkorstorePromoCodeStatusEnum;
    /** @format date-time */
    createdAt?: string;
  };
}

/** Promo Code Index */
export interface AnkorstorePromoCodeIndex {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Promo Code Index Meta
   * Pagination details, plus the suffix every one of your codes carries.
   */
  meta?: {
    /** Cursor pagination details */
    page: {
      /** The id of the first code on this page. */
      from: string | null;
      /** The id of the last code on this page — the cursor for `page[after]`. */
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    /**
     * Your brand's suffix, appended to every code you create. Use it to show what a name will become — `AUTUMN26` with a suffix of `K4T2M` is redeemed as `AUTUMN26-K4T2M`. Assigned the first time you list your codes, and the same from then on.
     * @example "K4T2M"
     */
    promoCodeSuffix: string;
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  data?: {
    /** @default "promo-codes" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /**
       * The part of the code you chose. Set on creation and never changes.
       * @example "AUTUMN26"
       */
      name?: string;
      /**
       * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
       * @example "AUTUMN26-K4T2M"
       */
      code?: string;
      /**
       * Promo Code Benefit
       * What the code takes off — either a percentage or a fixed amount, never both.
       */
      benefit?:
        | ({
            type: 'percentage';
          } & AnkorstorePromoCodePercentageBenefit)
        | ({
            type: 'fixed';
          } & AnkorstorePromoCodeFixedBenefit);
      /** The order value a retailer must reach for the code to apply. Null if there is none. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        EUR?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        GBP?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        SEK?: number;
      } | null;
      /**
       * When the code stops working. Null if it never expires.
       * @format date-time
       * @example "2026-12-31T23:59:59.000000Z"
       */
      validUntil?: string | null;
      /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
      status?: AnkorstorePromoCodeIndexStatusEnum;
      /** @format date-time */
      createdAt?: string;
    };
  }[];
}

/**
 * Promo Code Money Input
 * One amount in one currency. Writes take a single currency; the server converts it to the other two and reads return all three.
 */
export interface AnkorstorePromoCodeMoneyInput {
  /** Lowest denomination of the currency this amount belongs to. */
  value: number;
  currency: AnkorstorePromoCodeMoneyInputCurrencyEnum;
}

/**
 * Promo Code Benefit Input
 * Either a percentage or a fixed amount. Sending both is rejected.
 */
export type AnkorstorePromoCodeBenefitInput =
  | {
      type: 'percentage';
      /**
       * Whole percent off.
       * @min 1
       * @max 100
       * @example 15
       */
      percentage: number;
    }
  | {
      type: 'fixed';
      /**
       * Promo Code Money Input
       * One amount in one currency. Writes take a single currency; the server converts it to the other two and reads return all three.
       */
      amount: {
        /** Lowest denomination of the currency this amount belongs to. */
        value: number;
        currency: AnkorstorePromoCodeBenefitInputCurrencyEnum;
      };
    };

/** Promo Code Store */
export interface AnkorstorePromoCodeStore {
  data: {
    /** @default "promo-codes" */
    type: string;
    attributes: {
      /**
       * Letters and digits only, up to 26 characters. Your brand's suffix is appended to make the code, and the finished code is at most 32 characters.
       * @example "WELCOME10"
       */
      name: string;
      /**
       * Promo Code Benefit Input
       * Either a percentage or a fixed amount. Sending both is rejected.
       */
      benefit:
        | {
            type: 'percentage';
            /**
             * Whole percent off.
             * @min 1
             * @max 100
             * @example 15
             */
            percentage: number;
          }
        | {
            type: 'fixed';
            /**
             * Promo Code Money Input
             * One amount in one currency. Writes take a single currency; the server converts it to the other two and reads return all three.
             */
            amount: {
              /** Lowest denomination of the currency this amount belongs to. */
              value: number;
              currency: AnkorstorePromoCodeStoreCurrencyEnum;
            };
          };
      /** One amount in one currency. Writes take a single currency; the server converts it to the other two and reads return all three. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        value: number;
        currency: AnkorstorePromoCodeStoreCurrencyEnum1;
      } | null;
      /**
       * Must be in the future. Null for a code that never expires.
       * @format date-time
       */
      validUntil?: string | null;
    };
  };
}

/** Promo Code Get */
export interface AnkorstorePromoCodeGet {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Promo Code Resource
   * The resource object for a promo code owned by your brand.
   */
  data?: {
    /** @default "promo-codes" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /**
       * The part of the code you chose. Set on creation and never changes.
       * @example "AUTUMN26"
       */
      name?: string;
      /**
       * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
       * @example "AUTUMN26-K4T2M"
       */
      code?: string;
      /**
       * Promo Code Benefit
       * What the code takes off — either a percentage or a fixed amount, never both.
       */
      benefit?:
        | ({
            type: 'percentage';
          } & AnkorstorePromoCodePercentageBenefit)
        | ({
            type: 'fixed';
          } & AnkorstorePromoCodeFixedBenefit);
      /** The order value a retailer must reach for the code to apply. Null if there is none. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        EUR?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        GBP?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        SEK?: number;
      } | null;
      /**
       * When the code stops working. Null if it never expires.
       * @format date-time
       * @example "2026-12-31T23:59:59.000000Z"
       */
      validUntil?: string | null;
      /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
      status?: AnkorstorePromoCodeGetStatusEnum;
      /** @format date-time */
      createdAt?: string;
    };
  };
}

/**
 * Promo Code Update
 * Only the benefit, the minimum order and the expiry date can change. `name` and `code` are fixed once created, because retailers may already be holding the code.
 */
export interface AnkorstorePromoCodeUpdate {
  data: {
    /** @default "promo-codes" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * Promo Code Benefit Input
       * Either a percentage or a fixed amount. Sending both is rejected.
       */
      benefit?:
        | {
            type: 'percentage';
            /**
             * Whole percent off.
             * @min 1
             * @max 100
             * @example 15
             */
            percentage: number;
          }
        | {
            type: 'fixed';
            /**
             * Promo Code Money Input
             * One amount in one currency. Writes take a single currency; the server converts it to the other two and reads return all three.
             */
            amount: {
              /** Lowest denomination of the currency this amount belongs to. */
              value: number;
              currency: AnkorstorePromoCodeUpdateCurrencyEnum;
            };
          };
      /** One amount in one currency. Writes take a single currency; the server converts it to the other two and reads return all three. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        value: number;
        currency: AnkorstorePromoCodeUpdateCurrencyEnum1;
      } | null;
      /**
       * Not held to a future date here: setting it to the current instant is how a code is ended early.
       * @format date-time
       */
      validUntil?: string | null;
    };
  };
}

export interface AnkorstoreBillingExport {
  type: AnkorstoreBillingExportTypeEnum;
  /** @format uuid */
  brandUuid: string;
  filename: string;
  status: AnkorstoreBillingExportStatusEnum;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  finishedAt?: null | string;
  /** @format url */
  downloadLink?: null | string;
}

export interface AnkorstoreBillingExportResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    type: AnkorstoreBillingExportResourceTypeEnum;
    /** @format uuid */
    brandUuid: string;
    filename: string;
    status: AnkorstoreBillingExportResourceStatusEnum;
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
    /** @format date-time */
    expiresAt: string;
    /** @format date-time */
    finishedAt?: null | string;
    /** @format url */
    downloadLink?: null | string;
  };
}

/** Master Order */
export interface AnkorstoreMasterOrder {
  /** @default "master-orders" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  relationships?: {
    internalOrder?: {
      data: {
        /** @default "internal-orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
      };
    };
    externalOrder?: {
      data: {
        /** @default "external-orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
      };
    };
    shipment?: {
      data: {
        /** @default "shipments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
      };
    };
  };
}

/** @example "ankor_confirmed" */
export enum AnkorstoreOrderWorkflowStatus {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

export interface AnkorstoreShippingLabelCurrentStatus {
  /** The current status of the order/parcel */
  status?: AnkorstoreShippingLabelCurrentStatusStatusEnum;
  /** Human readable version of status */
  statusDetails?: string | null;
  /**
   * Last time the status was updated
   * @format datetime
   */
  updatedAt?: string;
  /** Last known location */
  location?: {
    city?: null | string;
    state?: null | string;
    zip?: null | string;
    country?: null | string;
  };
}

/** Shipping Label Parcel */
export interface AnkorstoreShippingLabelParcelWithTrackedPackage {
  /** @max 274 */
  length: number;
  /** @max 274 */
  width: number;
  /** @max 274 */
  height: number;
  /** The unit of distance */
  distanceUnit: AnkorstoreShippingLabelParcelWithTrackedPackageDistanceUnitEnum;
  /**
   * @min 1
   * @max 30000
   */
  weight: number;
  /** The unit of mass */
  massUnit: AnkorstoreShippingLabelParcelWithTrackedPackageMassUnitEnum;
  /** The tracking per parcel */
  trackedPackage: {
    /**
     * The URL to download the shipping label
     * @format url
     */
    labelUrl: null | string;
    /** @format datetime */
    eta: null | string;
    trackingNumber?: string;
    trackingLink: string;
    currentStatus: {
      /** The current status of the order/parcel */
      status?: AnkorstoreShippingLabelParcelWithTrackedPackageStatusEnum;
      /** Human readable version of status */
      statusDetails?: string | null;
      /**
       * Last time the status was updated
       * @format datetime
       */
      updatedAt?: string;
      /** Last known location */
      location?: {
        city?: null | string;
        state?: null | string;
        zip?: null | string;
        country?: null | string;
      };
    };
  };
}

/**
 * Order Resource -> Shipping Overview
 * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
 */
export interface AnkorstoreOrderShippingOverview {
  /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
  availableShippingMethods: AnkorstoreOrderShippingOverviewAvailableShippingMethodsEnum[];
  /** The address the order needs to be shipped to */
  shipToAddress: {
    /** The first and last name of the recipient */
    name?: null | string;
    /** The organisational name of the recipient */
    organisationName?: null | string;
    street: null | string;
    city: null | string;
    postalCode: null | string;
    countryCode?: null | string;
  };
  /** The minimum and maximum expected shipping dates */
  expectedShippingDates: {
    /** @format datetime */
    minimum: string;
    /** @format datetime */
    maximum: string;
    /** @format datetime */
    updatedMaximum?: null | string;
  };
  /** The company providing the shipping service */
  provider?: AnkorstoreOrderShippingOverviewProviderEnum;
  /** Tracking details of the order */
  tracking?: {
    number?: string;
    /**
     * A URL to view the tracking status
     * @format url
     */
    link?: string;
  };
  /**
   * The quote is the price of the parcel(s) shipping.
   * If this object is null then no quote has been generated.
   */
  latestQuote?: {
    /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
    id: string;
    /**
     * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
     * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
     */
    provider: AnkorstoreOrderShippingOverviewProviderEnum1;
    /** The provider of the rate for `rateAmount`. */
    rateProvider?: AnkorstoreOrderShippingOverviewRateProviderEnum;
    /** Amount calculated for the parcels provided. */
    rateAmount?: {
      /** Lowest denomination of the currency this amount belongs to. */
      amount?: number;
      currency?: string;
    };
    /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
    shippingCostsOverview?: {
      /** Lowest denomination of the currency this amount belongs to. */
      amount?: number;
      currency?: string;
      /**
       * Type of shipping costs:
       * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
       * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
       */
      type?: AnkorstoreOrderShippingOverviewTypeEnum;
    };
  };
  /** @uniqueItems true */
  parcels?: {
    /** @max 274 */
    length: number;
    /** @max 274 */
    width: number;
    /** @max 274 */
    height: number;
    /** The unit of distance */
    distanceUnit: AnkorstoreOrderShippingOverviewDistanceUnitEnum;
    /**
     * @min 1
     * @max 30000
     */
    weight: number;
    /** The unit of mass */
    massUnit: AnkorstoreOrderShippingOverviewMassUnitEnum;
    /** The tracking per parcel */
    trackedPackage: {
      /**
       * The URL to download the shipping label
       * @format url
       */
      labelUrl: null | string;
      /** @format datetime */
      eta: null | string;
      trackingNumber?: string;
      trackingLink: string;
      currentStatus: {
        /** The current status of the order/parcel */
        status?: AnkorstoreOrderShippingOverviewStatusEnum;
        /** Human readable version of status */
        statusDetails?: string | null;
        /**
         * Last time the status was updated
         * @format datetime
         */
        updatedAt?: string;
        /** Last known location */
        location?: {
          city?: null | string;
          state?: null | string;
          zip?: null | string;
          country?: null | string;
        };
      };
    };
  }[];
  transaction?: {
    /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
    pickup: {
      /**
       * The date of the pickup
       * @format datetime
       */
      pickupDate: string;
      /** Opening time of pickup Eg: 10:00:00 */
      readyTime: string;
      /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
      closeTime: string;
      /** The reference number for this pickup */
      externalReferenceId: string;
    };
    /** The tracking details for the overall shipment */
    tracking: {
      /**
       * The estimated time of arrival for the order
       * @format datetime
       */
      eta?: null | string;
      /** The tracking number of the order */
      trackingNumber?: string;
      /**
       * The tracking link for the order
       * @format url
       */
      trackingLink?: string;
      currentStatus?: {
        /** The current status of the order/parcel */
        status?: AnkorstoreOrderShippingOverviewStatusEnum1;
        /** Human readable version of status */
        statusDetails?: string | null;
        /**
         * Last time the status was updated
         * @format datetime
         */
        updatedAt?: string;
        /** Last known location */
        location?: {
          city?: null | string;
          state?: null | string;
          zip?: null | string;
          country?: null | string;
        };
      };
    };
  };
}

/**
 * External Order Resource
 * The resource object for External Order
 */
export interface AnkorstoreExternalOrder {
  /** @default "external-orders" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** Status of the order. */
    status: string;
    /** Custom reference of the order. */
    customReference?: null | string;
    /** Shipping address of the recipient. */
    shippingAddress: {
      /** First name of the person, receiving the order */
      firstName: string;
      /** Last name of the person, receiving the order */
      lastName: string;
      /**
       * Email of the person, receiving the order
       * @format email
       */
      email: string;
      /** Phone number of the person, receiving the order. */
      phoneNumber: string;
      /** Name of the company. */
      company: null | string;
      /** Street address of the destination place. */
      street: string;
      /** Name of the destination city. */
      city: string;
      /** Postal code of the destination place. */
      postalCode: string;
      /** ISO 3166-1 country code. */
      countryCode: string;
    };
  };
  relationships?: {
    orderItems?: {
      data: {
        /** @default "external-order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
      }[];
    };
  };
}

/**
 * External Order Item Resource
 * The resource object for External Order Item
 */
export interface AnkorstoreExternalOrderItem {
  /** @default "external-order-items" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** @format uuid */
    productVariantUuid: string;
    batchQuantity: number;
    unitQuantity: number;
  };
}

/** Order shipment */
export interface AnkorstoreShipment {
  /** @default "shipments" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** @format date-time */
    shippedAt: null | string;
    trackingNumber: null | string;
    shippingCarrier: null | string;
    trackingUrl: null | string;
  };
}

/** Master Order List */
export interface AnkorstoreMasterOrderList {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  data?: {
    /** @default "master-orders" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    relationships?: {
      internalOrder?: {
        data: {
          /** @default "internal-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      externalOrder?: {
        data: {
          /** @default "external-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      shipment?: {
        data: {
          /** @default "shipments" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
    };
  }[];
  /** One of the included resources */
  included?: (
    | {
        /** @default "orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The identifier of the linked master order
           * @format uuid
           */
          masterOrderId?: string;
          /** @example "ankor_confirmed" */
          status?: AnkorstoreMasterOrderListStatusEnum;
          /** The order reference used on shipping labels, communication etc */
          reference?: number;
          /** The currency the brand is paid in */
          brandCurrency?: string;
          /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
          brandNetAmount?: number;
          /** The total of all order items not including VAT */
          brandTotalAmount?: number;
          /** The total VAT of all order items */
          brandTotalAmountVat?: number;
          /** The total of all order items including VAT */
          brandTotalAmountWithVat?: number;
          /** The chosen shipping method after going through the shipping process */
          shippingMethod?: AnkorstoreMasterOrderListShippingMethodEnum;
          /**
           * Order Resource -> Shipping Overview
           * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
           */
          shippingOverview?: {
            /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
            availableShippingMethods: AnkorstoreMasterOrderListAvailableShippingMethodsEnum[];
            /** The address the order needs to be shipped to */
            shipToAddress: {
              /** The first and last name of the recipient */
              name?: null | string;
              /** The organisational name of the recipient */
              organisationName?: null | string;
              street: null | string;
              city: null | string;
              postalCode: null | string;
              countryCode?: null | string;
            };
            /** The minimum and maximum expected shipping dates */
            expectedShippingDates: {
              /** @format datetime */
              minimum: string;
              /** @format datetime */
              maximum: string;
              /** @format datetime */
              updatedMaximum?: null | string;
            };
            /** The company providing the shipping service */
            provider?: AnkorstoreMasterOrderListProviderEnum;
            /** Tracking details of the order */
            tracking?: {
              number?: string;
              /**
               * A URL to view the tracking status
               * @format url
               */
              link?: string;
            };
            /**
             * The quote is the price of the parcel(s) shipping.
             * If this object is null then no quote has been generated.
             */
            latestQuote?: {
              /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
              id: string;
              /**
               * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
               * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
               */
              provider: AnkorstoreMasterOrderListProviderEnum1;
              /** The provider of the rate for `rateAmount`. */
              rateProvider?: AnkorstoreMasterOrderListRateProviderEnum;
              /** Amount calculated for the parcels provided. */
              rateAmount?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
              };
              /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
              shippingCostsOverview?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
                /**
                 * Type of shipping costs:
                 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
                 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
                 */
                type?: AnkorstoreMasterOrderListTypeEnum;
              };
            };
            /** @uniqueItems true */
            parcels?: {
              /** @max 274 */
              length: number;
              /** @max 274 */
              width: number;
              /** @max 274 */
              height: number;
              /** The unit of distance */
              distanceUnit: AnkorstoreMasterOrderListDistanceUnitEnum;
              /**
               * @min 1
               * @max 30000
               */
              weight: number;
              /** The unit of mass */
              massUnit: AnkorstoreMasterOrderListMassUnitEnum;
              /** The tracking per parcel */
              trackedPackage: {
                /**
                 * The URL to download the shipping label
                 * @format url
                 */
                labelUrl: null | string;
                /** @format datetime */
                eta: null | string;
                trackingNumber?: string;
                trackingLink: string;
                currentStatus: {
                  /** The current status of the order/parcel */
                  status?: AnkorstoreMasterOrderListStatusEnum1;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            }[];
            transaction?: {
              /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
              pickup: {
                /**
                 * The date of the pickup
                 * @format datetime
                 */
                pickupDate: string;
                /** Opening time of pickup Eg: 10:00:00 */
                readyTime: string;
                /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
                closeTime: string;
                /** The reference number for this pickup */
                externalReferenceId: string;
              };
              /** The tracking details for the overall shipment */
              tracking: {
                /**
                 * The estimated time of arrival for the order
                 * @format datetime
                 */
                eta?: null | string;
                /** The tracking number of the order */
                trackingNumber?: string;
                /**
                 * The tracking link for the order
                 * @format url
                 */
                trackingLink?: string;
                currentStatus?: {
                  /** The current status of the order/parcel */
                  status?: AnkorstoreMasterOrderListStatusEnum2;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            };
          };
          /** The reason the brand has given for rejecting the order */
          brandRejectReason?: null | string;
          /** The reason the retailer rejected the reception of the order */
          retailerRejectReason?: null | string;
          /** The reason the retailer has given for a cancellation request */
          retailerCancellationRequestReason?: null | string;
          /** The billing address name */
          billingName?: null | string;
          /** The billing address organisation name */
          billingOrganisationName?: null | string;
          /** The billing address street name */
          billingStreet?: null | string;
          /** The billing address postal code */
          billingPostalCode?: null | string;
          /** The billing address city */
          billingCity?: null | string;
          /** The billing address country code - ISO format */
          billingCountryCode?: null | string;
          /**
           * The timestamp of when the order was submitted (order is placed)
           * @format datetime
           */
          submittedAt?: string;
          /**
           * The timestamp of when the order was shipped
           * @format datetime
           */
          shippedAt?: null | string;
          /**
           * The timestamp of when the brand was paid
           * @format datetime
           */
          brandPaidAt?: null | string;
          /**
           * (deprecated) The timestamp of when the order was created (before retailer payment)
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp of when the order was updated (does not include other resources)
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Related Retailer Resource */
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'retailers';
            };
          };
          /** Related Billing Item Resources */
          billingItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'billing-items';
            })[];
          };
          /** Related Order Item Resources */
          orderItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'order-items';
            })[];
          };
          /** Schema: Order Item -> Product Option Resource */
          'orderItems-productOption'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Option Resource -> Product */
          'orderItems-productOption-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource */
          'orderItems-productVariant'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource -> Product */
          'orderItems-productVariant-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "external-orders" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Status of the order. */
          status: string;
          /** Custom reference of the order. */
          customReference?: null | string;
          /** Shipping address of the recipient. */
          shippingAddress: {
            /** First name of the person, receiving the order */
            firstName: string;
            /** Last name of the person, receiving the order */
            lastName: string;
            /**
             * Email of the person, receiving the order
             * @format email
             */
            email: string;
            /** Phone number of the person, receiving the order. */
            phoneNumber: string;
            /** Name of the company. */
            company: null | string;
            /** Street address of the destination place. */
            street: string;
            /** Name of the destination city. */
            city: string;
            /** Postal code of the destination place. */
            postalCode: string;
            /** ISO 3166-1 country code. */
            countryCode: string;
          };
        };
        relationships?: {
          orderItems?: {
            data: {
              /** @default "external-order-items" */
              type: string;
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
            }[];
          };
        };
      }
    | {
        /** @default "external-order-items" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantUuid: string;
          batchQuantity: number;
          unitQuantity: number;
        };
      }
    | {
        /** @default "shipments" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format date-time */
          shippedAt: null | string;
          trackingNumber: null | string;
          shippingCarrier: null | string;
          trackingUrl: null | string;
        };
      }
  )[];
}

/** Master Order Get */
export interface AnkorstoreMasterOrderGet {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Master Order */
  data?: {
    /** @default "master-orders" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    relationships?: {
      internalOrder?: {
        data: {
          /** @default "internal-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      externalOrder?: {
        data: {
          /** @default "external-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      shipment?: {
        data: {
          /** @default "shipments" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
    };
  };
  /** One of the included resources */
  included?: (
    | {
        /** @default "orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The identifier of the linked master order
           * @format uuid
           */
          masterOrderId?: string;
          /** @example "ankor_confirmed" */
          status?: AnkorstoreMasterOrderGetStatusEnum;
          /** The order reference used on shipping labels, communication etc */
          reference?: number;
          /** The currency the brand is paid in */
          brandCurrency?: string;
          /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
          brandNetAmount?: number;
          /** The total of all order items not including VAT */
          brandTotalAmount?: number;
          /** The total VAT of all order items */
          brandTotalAmountVat?: number;
          /** The total of all order items including VAT */
          brandTotalAmountWithVat?: number;
          /** The chosen shipping method after going through the shipping process */
          shippingMethod?: AnkorstoreMasterOrderGetShippingMethodEnum;
          /**
           * Order Resource -> Shipping Overview
           * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
           */
          shippingOverview?: {
            /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
            availableShippingMethods: AnkorstoreMasterOrderGetAvailableShippingMethodsEnum[];
            /** The address the order needs to be shipped to */
            shipToAddress: {
              /** The first and last name of the recipient */
              name?: null | string;
              /** The organisational name of the recipient */
              organisationName?: null | string;
              street: null | string;
              city: null | string;
              postalCode: null | string;
              countryCode?: null | string;
            };
            /** The minimum and maximum expected shipping dates */
            expectedShippingDates: {
              /** @format datetime */
              minimum: string;
              /** @format datetime */
              maximum: string;
              /** @format datetime */
              updatedMaximum?: null | string;
            };
            /** The company providing the shipping service */
            provider?: AnkorstoreMasterOrderGetProviderEnum;
            /** Tracking details of the order */
            tracking?: {
              number?: string;
              /**
               * A URL to view the tracking status
               * @format url
               */
              link?: string;
            };
            /**
             * The quote is the price of the parcel(s) shipping.
             * If this object is null then no quote has been generated.
             */
            latestQuote?: {
              /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
              id: string;
              /**
               * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
               * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
               */
              provider: AnkorstoreMasterOrderGetProviderEnum1;
              /** The provider of the rate for `rateAmount`. */
              rateProvider?: AnkorstoreMasterOrderGetRateProviderEnum;
              /** Amount calculated for the parcels provided. */
              rateAmount?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
              };
              /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
              shippingCostsOverview?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
                /**
                 * Type of shipping costs:
                 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
                 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
                 */
                type?: AnkorstoreMasterOrderGetTypeEnum;
              };
            };
            /** @uniqueItems true */
            parcels?: {
              /** @max 274 */
              length: number;
              /** @max 274 */
              width: number;
              /** @max 274 */
              height: number;
              /** The unit of distance */
              distanceUnit: AnkorstoreMasterOrderGetDistanceUnitEnum;
              /**
               * @min 1
               * @max 30000
               */
              weight: number;
              /** The unit of mass */
              massUnit: AnkorstoreMasterOrderGetMassUnitEnum;
              /** The tracking per parcel */
              trackedPackage: {
                /**
                 * The URL to download the shipping label
                 * @format url
                 */
                labelUrl: null | string;
                /** @format datetime */
                eta: null | string;
                trackingNumber?: string;
                trackingLink: string;
                currentStatus: {
                  /** The current status of the order/parcel */
                  status?: AnkorstoreMasterOrderGetStatusEnum1;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            }[];
            transaction?: {
              /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
              pickup: {
                /**
                 * The date of the pickup
                 * @format datetime
                 */
                pickupDate: string;
                /** Opening time of pickup Eg: 10:00:00 */
                readyTime: string;
                /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
                closeTime: string;
                /** The reference number for this pickup */
                externalReferenceId: string;
              };
              /** The tracking details for the overall shipment */
              tracking: {
                /**
                 * The estimated time of arrival for the order
                 * @format datetime
                 */
                eta?: null | string;
                /** The tracking number of the order */
                trackingNumber?: string;
                /**
                 * The tracking link for the order
                 * @format url
                 */
                trackingLink?: string;
                currentStatus?: {
                  /** The current status of the order/parcel */
                  status?: AnkorstoreMasterOrderGetStatusEnum2;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            };
          };
          /** The reason the brand has given for rejecting the order */
          brandRejectReason?: null | string;
          /** The reason the retailer rejected the reception of the order */
          retailerRejectReason?: null | string;
          /** The reason the retailer has given for a cancellation request */
          retailerCancellationRequestReason?: null | string;
          /** The billing address name */
          billingName?: null | string;
          /** The billing address organisation name */
          billingOrganisationName?: null | string;
          /** The billing address street name */
          billingStreet?: null | string;
          /** The billing address postal code */
          billingPostalCode?: null | string;
          /** The billing address city */
          billingCity?: null | string;
          /** The billing address country code - ISO format */
          billingCountryCode?: null | string;
          /**
           * The timestamp of when the order was submitted (order is placed)
           * @format datetime
           */
          submittedAt?: string;
          /**
           * The timestamp of when the order was shipped
           * @format datetime
           */
          shippedAt?: null | string;
          /**
           * The timestamp of when the brand was paid
           * @format datetime
           */
          brandPaidAt?: null | string;
          /**
           * (deprecated) The timestamp of when the order was created (before retailer payment)
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp of when the order was updated (does not include other resources)
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Related Retailer Resource */
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'retailers';
            };
          };
          /** Related Billing Item Resources */
          billingItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'billing-items';
            })[];
          };
          /** Related Order Item Resources */
          orderItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'order-items';
            })[];
          };
          /** Schema: Order Item -> Product Option Resource */
          'orderItems-productOption'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Option Resource -> Product */
          'orderItems-productOption-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource */
          'orderItems-productVariant'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource -> Product */
          'orderItems-productVariant-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "external-orders" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Status of the order. */
          status: string;
          /** Custom reference of the order. */
          customReference?: null | string;
          /** Shipping address of the recipient. */
          shippingAddress: {
            /** First name of the person, receiving the order */
            firstName: string;
            /** Last name of the person, receiving the order */
            lastName: string;
            /**
             * Email of the person, receiving the order
             * @format email
             */
            email: string;
            /** Phone number of the person, receiving the order. */
            phoneNumber: string;
            /** Name of the company. */
            company: null | string;
            /** Street address of the destination place. */
            street: string;
            /** Name of the destination city. */
            city: string;
            /** Postal code of the destination place. */
            postalCode: string;
            /** ISO 3166-1 country code. */
            countryCode: string;
          };
        };
        relationships?: {
          orderItems?: {
            data: {
              /** @default "external-order-items" */
              type: string;
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
            }[];
          };
        };
      }
    | {
        /** @default "external-order-items" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantUuid: string;
          batchQuantity: number;
          unitQuantity: number;
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
  )[];
}

export enum AnkorstoreFulfillmentOrderStatus {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

export interface AnkorstoreFulfillmentOrderItem {
  /** @format uuid */
  fulfillmentItemId: string;
  /** quantity in batches */
  quantity: number;
  lotNumber?: null | string;
  /** @format date-time */
  expiryDate?: null | string;
}

export interface AnkorstoreFulfillmentOrderShippedItem {
  /** @format uuid */
  fulfillableId: string;
  batchQuantity: number;
  unitQuantity: number;
  lotNumber?: null | string;
  /** @format date-time */
  expiryDate?: null | string;
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreRecipientType {
  Consumer = 'consumer',
  Business = 'business',
}

export interface AnkorstoreDeliverySchedule {
  /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
  timeSlots:
    | {
        /**
         * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
         * @example "09:30"
         */
        startTime: string;
        /**
         * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
         * @example "12:30"
         */
        endTime: string;
      }[]
    | null;
  /**
   * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
   * @minItems 1
   * @uniqueItems true
   * @example [1,2,3]
   */
  openDays: number[];
}

export interface AnkorstorePackingInstruction {
  /**
   * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
   * @minItems 1
   */
  services: AnkorstorePackingInstructionServicesEnum[];
  /** Instruction text for packing the order. */
  instruction?: string;
}

export interface AnkorstoreInstructions {
  externalReference?: string | null;
  deliverySchedule?: {
    /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
    timeSlots:
      | {
          /**
           * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "09:30"
           */
          startTime: string;
          /**
           * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
           * @example "12:30"
           */
          endTime: string;
        }[]
      | null;
    /**
     * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
     * @minItems 1
     * @uniqueItems true
     * @example [1,2,3]
     */
    openDays: number[];
  } | null;
  packingInstruction?: {
    /**
     * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
     * @minItems 1
     */
    services: AnkorstoreInstructionsServicesEnum[];
    /** Instruction text for packing the order. */
    instruction?: string;
  } | null;
}

export interface AnkorstoreFulfillmentOrder {
  /**
   * Unique human readable reference for the fulfillment order, used for communication with the warehouse
   * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
   */
  reference?: string;
  status?: AnkorstoreFulfillmentOrderStatusEnum;
  /** @format date-time */
  createdAt?: string;
  items: {
    /** @format uuid */
    fulfillmentItemId: string;
    /** quantity in batches */
    quantity: number;
    lotNumber?: null | string;
    /** @format date-time */
    expiryDate?: null | string;
  }[];
  shippedItems?: {
    /** @format uuid */
    fulfillableId: string;
    batchQuantity: number;
    unitQuantity: number;
    lotNumber?: null | string;
    /** @format date-time */
    expiryDate?: null | string;
  }[];
  /**
   * The type of recipient for a fulfillment order
   * @default "business"
   */
  recipientType?: AnkorstoreFulfillmentOrderRecipientTypeEnum;
  externalReference?: string | null;
  /**
   * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
   * @deprecated
   */
  instructionText?: string | null;
  instructions?: {
    externalReference?: string | null;
    deliverySchedule?: {
      /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
      timeSlots:
        | {
            /**
             * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "09:30"
             */
            startTime: string;
            /**
             * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
             * @example "12:30"
             */
            endTime: string;
          }[]
        | null;
      /**
       * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
       * @minItems 1
       * @uniqueItems true
       * @example [1,2,3]
       */
      openDays: number[];
    } | null;
    packingInstruction?: {
      /**
       * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
       * @minItems 1
       */
      services: AnkorstoreFulfillmentOrderServicesEnum[];
      /** Instruction text for packing the order. */
      instruction?: string;
    } | null;
  } | null;
}

export interface AnkorstoreFulfillmentOrderResource {
  /** @default "fulfillment-orders" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Unique human readable reference for the fulfillment order, used for communication with the warehouse
     * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
     */
    reference?: string;
    status?: AnkorstoreFulfillmentOrderResourceStatusEnum;
    /** @format date-time */
    createdAt?: string;
    items: {
      /** @format uuid */
      fulfillmentItemId: string;
      /** quantity in batches */
      quantity: number;
      lotNumber?: null | string;
      /** @format date-time */
      expiryDate?: null | string;
    }[];
    shippedItems?: {
      /** @format uuid */
      fulfillableId: string;
      batchQuantity: number;
      unitQuantity: number;
      lotNumber?: null | string;
      /** @format date-time */
      expiryDate?: null | string;
    }[];
    /**
     * The type of recipient for a fulfillment order
     * @default "business"
     */
    recipientType?: AnkorstoreFulfillmentOrderResourceRecipientTypeEnum;
    externalReference?: string | null;
    /**
     * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
     * @deprecated
     */
    instructionText?: string | null;
    instructions?: {
      externalReference?: string | null;
      deliverySchedule?: {
        /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
        timeSlots:
          | {
              /**
               * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "09:30"
               */
              startTime: string;
              /**
               * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "12:30"
               */
              endTime: string;
            }[]
          | null;
        /**
         * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
         * @minItems 1
         * @uniqueItems true
         * @example [1,2,3]
         */
        openDays: number[];
      } | null;
      packingInstruction?: {
        /**
         * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
         * @minItems 1
         */
        services: AnkorstoreFulfillmentOrderResourceServicesEnum[];
        /** Instruction text for packing the order. */
        instruction?: string;
      } | null;
    } | null;
  };
  links?: {
    order?: string;
  };
  relationships?: {
    statusUpdates?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/** Fulfillment order status update */
export interface AnkorstoreFulfillmentOrderStatusUpdate {
  status?: AnkorstoreFulfillmentOrderStatusUpdateStatusEnum;
  /** @format date-time */
  receivedAt?: string;
}

export interface AnkorstoreFulfillmentOrderStatusUpdateResource {
  /** @default "fulfillment-order-status-updates" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  /** Fulfillment order status update */
  attributes?: {
    status?: AnkorstoreFulfillmentOrderStatusUpdateResourceStatusEnum;
    /** @format date-time */
    receivedAt?: string;
  };
}

export interface AnkorstoreShipmentTrackingResource {
  /** @default "shipment-trackings" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    carrier: null | string;
    serviceCode?: null | string;
    trackingNumber: string;
    trackingLink: null | string;
    status: null | string;
  };
  /** Only presented if asked explicitly in the request */
  relationships?: {
    shipmentParcel?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
    shipmentQuote?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    /** Only presented if asked explicitly in the request with ?include=shippedItems */
    shippedItems?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

export interface AnkorstoreTrackedPackageResource {
  /** @default "tracked-packages" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /** Height of the package (cm) */
    height?: null | number;
    /** Width of the package (cm) */
    width?: null | number;
    /** Length of the package (cm) */
    length?: null | number;
    /** Weight of the package (g) */
    weight?: null | number;
    /** Tracking number of the package */
    trackingNumber: string;
    /** Tracking link of the package */
    trackingLink: string;
    /** Status of the package */
    status: string;
    /** Serial Shipping Container Code (SSCC) for traceability */
    serialShippingContainerCode?: null | string;
    /** Label of the package */
    label?: {
      /** Content of the label */
      content?: string;
      /** Content type of the label (gif, pdf) */
      contentType?: string;
    };
  };
}

export interface AnkorstoreShippedItemResource {
  /** @default "shipping-shipment-shipped-item" */
  type?: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id?: string;
  attributes?: {
    /**
     * The UUID of the parcel (tracked package) this item belongs to
     * @format uuid
     */
    parcelId: string;
    /**
     * The UUID of the product variant
     * @format uuid
     */
    productVariantId: string;
    /**
     * Number of batches (e.g. boxes) shipped
     * @min 1
     */
    batchQuantity: number;
    /**
     * Number of individual units shipped
     * @min 1
     */
    unitQuantity: number;
    /** Lot or batch number for traceability */
    lotNumber?: null | string;
    /**
     * Expiry date of the items (YYYY-MM-DD)
     * @format date
     */
    expiryDate?: null | string;
  };
}

/** Quote resource */
export interface AnkorstoreQuoteResource {
  /** The unique identifier for the quote as an uuid */
  quoteUuid?: string;
  /** The carrier code for the quote */
  carrierCode?: string;
  /** The service code for the quote */
  serviceCode?: string;
  /** The commercial name of the service */
  serviceCommercialName?: string;
  /** The collection method for the quote */
  collectionMethod?: AnkorstoreQuoteResourceCollectionMethodEnum[];
  shippingCost?: {
    /** The amount of the shipping cost */
    amount?: number;
    /** The currency of the shipping cost */
    currency?: string;
  };
  /** Delivery estimation information if provided by carrier */
  timeInTransit?: {
    /**
     * Estimation of delivery date by the carrier
     * @format date
     */
    estimatedDeliveryDate?: null | string;
    /**
     * Pickup date considered for the estimation
     * @format date
     */
    pickupDate?: null | string;
    /** Number of business days the shipment is in transit */
    businessDaysInTransit?: null | number;
  };
}

export interface AnkorstoreUpdateOrderItemsRequest {
  data?: {
    type?: string;
    attributes: {
      /** @minItems 1 */
      items: {
        /**
         * UUID of an existing order item to update/remove.
         * @format uuid
         */
        orderItemUuid?: string | null;
        /**
         * UUID of a product variant to add as a new line (used when `orderItemUuid` is omitted).
         * @format uuid
         */
        productVariantUuid?: string | null;
        /**
         * Target unit quantity for the line (0 removes the line). Stored directly as `multiplied_quantity`. Does not need to be evenly divisible by the product's `unit_multiplier`. When evenly divisible, batch quantity = `unitQuantity / unit_multiplier`; when not evenly divisible, packs are broken and batch quantity = `1` (one custom batch).
         * @min 0
         */
        unitQuantity: number;
        /**
         * Wholesale price for item.
         * @min 0
         */
        unitPrice?: number | null;
      }[];
    };
  };
}

/** Order Collection */
export interface AnkorstoreOrderCollection {
  /**
   * List of Order resource objects
   * @uniqueItems true
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: AnkorstoreOrderCollectionStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: AnkorstoreOrderCollectionShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: AnkorstoreOrderCollectionAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: AnkorstoreOrderCollectionProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: AnkorstoreOrderCollectionProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: AnkorstoreOrderCollectionRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: AnkorstoreOrderCollectionTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: AnkorstoreOrderCollectionDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: AnkorstoreOrderCollectionMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: AnkorstoreOrderCollectionStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: AnkorstoreOrderCollectionStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: AnkorstoreOrderCollectionTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: AnkorstoreOrderCollectionInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Order Get */
export interface AnkorstoreOrderGet {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: AnkorstoreOrderGetStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: AnkorstoreOrderGetShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: AnkorstoreOrderGetAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: AnkorstoreOrderGetProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: AnkorstoreOrderGetProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: AnkorstoreOrderGetRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: AnkorstoreOrderGetTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: AnkorstoreOrderGetDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: AnkorstoreOrderGetMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: AnkorstoreOrderGetStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: AnkorstoreOrderGetStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: AnkorstoreOrderGetTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: AnkorstoreOrderGetInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface AnkorstoreSchemasPackingInstruction {
  /**
   * List of services to be performed on the order. Either `PALLETISE`, `DOCS`, `CUSTOM_BUILD` or `SSCC`
   * @minItems 1
   */
  services: AnkorstoreSchemasPackingInstructionServicesEnum[];
  /** Instruction text for packing the order. */
  instruction?: string;
}

export interface AnkorstoreDeliveryAppointment {
  /** Is an appointment requested? */
  requested: boolean;
  /** Instruction text for booking an appointment. */
  instruction?: string;
}

export interface AnkorstoreCustomerPaymentMethodObject {
  type: string;
  email?: string | null;
  name?: string | null;
  /** @example "1234" */
  last4?: string | null;
}

export interface AnkorstoreCountryObject {
  isoCode: string;
  name: string;
  callingCode: number;
}

export interface AnkorstoreAddressObject {
  name: string;
  street: string;
  postalCode: string;
  city: string;
  country: {
    isoCode: string;
    name: string;
    callingCode: number;
  };
}

/** CustomerResource */
export interface AnkorstoreCustomerResource {
  type: 'order-pay-customer';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    storeName: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    paymentMethods?: {
      type: string;
      email?: string | null;
      name?: string | null;
      /** @example "1234" */
      last4?: string | null;
    }[];
    company: {
      phoneNumber: string;
      phoneCountry: {
        isoCode: string;
        name: string;
        callingCode: number;
      };
      taxNumber: string | null;
      vatNumber: string | null;
      vatExemption: boolean;
    };
    billingAddress?: {
      name: string;
      street: string;
      postalCode: string;
      city: string;
      country: {
        isoCode: string;
        name: string;
        callingCode: number;
      };
    };
    shippingAddress?: {
      name: string;
      street: string;
      postalCode: string;
      city: string;
      country: {
        isoCode: string;
        name: string;
        callingCode: number;
      };
    };
  };
  relationships?: {
    paymentMethods?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data: {
        id: string;
        /** @default "order-pay-customer-payment-methods" */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

export interface AnkorstoreCustomerPaymentMethodResource {
  type: 'order-pay-customer-payment-method';
  id: string;
  attributes: {
    type: string;
    email: string | null;
    name: string | null;
    /** @example "1234" */
    last4: string | null;
  };
}

/** The type of item. */
export enum AnkorstoreOrderPayCustomItemType {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

/** @example "fulfillment" */
export enum AnkorstoreOrderPayShippingMethod {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

export interface AnkorstoreSchema {
  data: {
    type: 'order-pay-orders';
    attributes: {
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** List of items with their corresponding quantities and unit amounts. */
      items?: {
        /**
         * Product variant UUID.
         * @format uuid
         */
        productVariantUuid: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 2
         */
        quantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /**
           * Order item unit net amount in brand's currency.
           * @example 1000
           */
          brandUnitPrice: number;
          /**
           * Order item discount rate, in percents.
           * @default 0
           * @example 10
           */
          discountRate?: number;
          /**
           * Order item discount amount, in Currency.
           * @default 0
           * @example 100
           */
          discountAmount?: number;
        };
        /** Minimum remaining shelf life in days. When specified, the fulfillment center will ensure items have at least this many days of shelf life remaining. */
        minimumRemainingShelfLife?: number | null;
        /**
         * Order discount rate, in percents.
         * @default 0
         * @example 10
         */
        discountRate?: number;
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type: AnkorstoreSchemaTypeEnum;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount: number;
      }[];
      /** Total amounts of the order. */
      amounts?: {
        /**
         * Order net shipping fees amount, in retailer's currency. <div class="warning"> The `shippingFeesAmount` property is deprecated and will be removed in a future version of the API. To represent shipping fees, please use a custom item in the `customItems` array. This approach provides greater flexibility and aligns with the standardized item structure in the API. </div>
         * @deprecated
         * @default 0
         * @example 500
         */
        shippingFeesAmount?: number | null;
      };
      /** @example "fulfillment" */
      shippingMethod?: AnkorstoreSchemaShippingMethodEnum;
      /** Allow you to specify opening times for the customer. */
      deliverySchedule?: {
        /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
        timeSlots:
          | {
              /**
               * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "09:30"
               */
              startTime: string;
              /**
               * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "12:30"
               */
              endTime: string;
            }[]
          | null;
        /**
         * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
         * @minItems 1
         * @uniqueItems true
         * @example [1,2,3]
         */
        openDays: number[];
      };
      /** Allow you to specify specific instructions for packing. */
      packingInstruction?: {
        /**
         * List of services to be performed on the order. Either `PALLETISE`, `DOCS`, `CUSTOM_BUILD` or `SSCC`
         * @minItems 1
         */
        services: AnkorstoreSchemaServicesEnum[];
        /** Instruction text for packing the order. */
        instruction?: string;
      } | null;
      /** Allow you to specify the need of booking an appointment before delivery */
      deliveryAppointment?: {
        /** Is an appointment requested? */
        requested: boolean;
        /** Instruction text for booking an appointment. */
        instruction?: string;
      } | null;
    };
  };
}

/** An invoice item representing a custom charge. */
export interface AnkorstoreOrderPayCustomItem {
  /** The type of item. */
  type?: AnkorstoreOrderPayCustomItemTypeEnum;
  /**
   * The VAT rate applied to this item (expressed as a percentage).
   * @min 0
   * @max 100
   * @example 12.5
   */
  vatRate?: number;
  /**
   * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
   * @min 0
   */
  amount?: number;
  /**
   * The total amount of VAT to collect for this item, in cents.
   * @min 0
   */
  amountVat?: number;
  /**
   * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
   * @min 0
   */
  amountWithVat?: number;
}

/** OrderResource */
export interface AnkorstoreOrderResource {
  /** @default "order-pay-orders" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  relationships?: any;
  attributes?: {
    /**
     * @format date-time
     * @example "2024-07-01T13:00:50.000000Z"
     */
    createdAt: string;
    /**
     * @format uuid
     * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
     */
    customerUuid: string;
    /** @example 20 */
    discountRate: number;
    /** List of items with their corresponding quantities and unit amounts. */
    items: {
      /**
       * Product variant UUID.
       * @format uuid
       * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
       */
      productVariantUuid: string;
      /**
       * Product variant name.
       * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
       */
      productVariantName: string;
      /**
       * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
       * @example 7
       */
      quantity: number;
      /**
       * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
       * @example 7
       */
      multipliedQuantity: number;
      /** Total amounts of the order item. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 1700 */
        brandUnitPriceBeforeDiscount: number;
        /** @example "€17.00" */
        brandUnitPriceBeforeDiscountFormatted: string;
        /** @example 1360 */
        brandUnitPrice: number;
        /** @example "€13.60" */
        brandUnitPriceFormatted: string;
        /** @example 11900 */
        brandAmountBeforeDiscount: number;
        /** @example "€119.00" */
        brandAmountBeforeDiscountFormatted: string;
        /** @example 2380 */
        brandDiscountAmount: number;
        /** @example "€23.80" */
        brandDiscountAmountFormatted: string;
        /** @example 9520 */
        brandAmount: number;
        /** @example "€95.20" */
        brandAmountFormatted: string;
        /** @example 1809 */
        brandAmountVat: number;
        /** @example "€18.09" */
        brandAmountVatFormatted: string;
        /** @example 11329 */
        brandAmountWithVat: number;
        /** @example "€113.29" */
        brandAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 1700 */
        customerUnitPriceBeforeDiscount: number;
        /** @example "€17.00" */
        customerUnitPriceBeforeDiscountFormatted: string;
        /** @example 1360 */
        customerUnitPrice: number;
        /** @example "€13.60" */
        customerUnitPriceFormatted: string;
        /** @example 11900 */
        customerAmountBeforeDiscount: number;
        /** @example "€119.00" */
        customerAmountBeforeDiscountFormatted: string;
        /** @example 2380 */
        customerDiscountAmount: number;
        /** @example "€23.80" */
        customerDiscountAmountFormatted: string;
        /** @example 9520 */
        customerAmount: number;
        /** @example "€95.20" */
        customerAmountFormatted: string;
        /** @example 1809 */
        customerAmountVat: number;
        /** @example "€18.09" */
        customerAmountVatFormatted: string;
        /** @example 11329 */
        customerAmountWithVat: number;
        /** @example "€113.29" */
        customerAmountWithVatFormatted: string;
        /** @example 19 */
        vatRate: number;
        /** @example 20 */
        discountRate: number;
        /** @example 100 */
        discountAmount: number;
        /** @example "€1.00" */
        discountAmountFormatted: string;
      };
    }[];
    /**
     * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
     * @minItems 0
     */
    customItems?: {
      /** The type of item. */
      type?: AnkorstoreOrderResourceTypeEnum;
      /**
       * The VAT rate applied to this item (expressed as a percentage).
       * @min 0
       * @max 100
       * @example 12.5
       */
      vatRate?: number;
      /**
       * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
       * @min 0
       */
      amount?: number;
      /**
       * The total amount of VAT to collect for this item, in cents.
       * @min 0
       */
      amountVat?: number;
      /**
       * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
       * @min 0
       */
      amountWithVat?: number;
    }[];
    status?: AnkorstoreOrderResourceStatusEnum;
    /** @example "EACN9214515" */
    masterOrderReference?: string | null;
    /**
     * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
     * @maxLength 64
     */
    customReference?: string | null;
    /** Total amounts of the order. */
    amounts: {
      /** @example "EUR" */
      brandCurrency: string;
      /** @example 1 */
      brandCurrencyRate: number;
      /** @example 54620 */
      brandTotalAmountBeforeDiscount: number;
      /** @example "€546.20" */
      brandTotalAmountBeforeDiscountFormatted: string;
      /** @example 0 */
      brandTotalDiscountAmount: number;
      /** @example "€0.00" */
      brandTotalDiscountAmountFormatted: string;
      /** @example 54620 */
      brandTotalAmount: number;
      /** @example "€546.20" */
      brandTotalAmountFormatted: string;
      /** @example 12633 */
      brandTotalAmountVat: number;
      /** @example "€126.33" */
      brandTotalAmountVatFormatted: string;
      /** @example 67253 */
      brandTotalAmountWithVat: number;
      /** @example "€672.53" */
      brandTotalAmountWithVatFormatted: string;
      /** @example "EUR" */
      customerCurrency: string;
      /** @example 1 */
      customerCurrencyRate: number;
      /** @example 54620 */
      customerTotalAmountBeforeDiscount: number;
      /** @example "€546.20" */
      customerTotalAmountBeforeDiscountFormatted: string;
      /** @example 54620 */
      customerTotalDiscountAmount: number;
      /** @example "€0.00" */
      customerTotalDiscountAmountFormatted: string;
      /** @example 54620 */
      customerTotalAmount: number;
      /** @example "€546.20" */
      customerTotalAmountFormatted: string;
      /** @example 12633 */
      customerTotalAmountVat: number;
      /** @example "€126.33" */
      customerTotalAmountVatFormatted: string;
      /** @example 67253 */
      customerTotalAmountWithVat: number;
      /** @example "€672.53" */
      customerTotalAmountWithVatFormatted: string;
      /** @example 220 */
      shippingFeesAmount: number;
      /** @example "€2.20" */
      shippingFeesAmountFormatted: string;
      /** @example 44 */
      shippingFeesAmountVat: number;
      /** @example "€0.44" */
      shippingFeesAmountVatFormatted: string;
      /** @example 264 */
      shippingFeesAmountWithVat: number;
      /** @example "€2.64" */
      shippingFeesAmountWithVatFormatted: string;
      /** @example 54840 */
      customerGrandTotalAmount: number;
      /** @example "€548.40" */
      customerGrandTotalAmountFormatted: string;
      /** @example 12677 */
      customerGrandTotalAmountVat: number;
      /** @example "€126.77" */
      customerGrandTotalAmountVatFormatted: string;
      /** @example 67517 */
      customerGrandTotalAmountWithVat: number;
      /** @example "€675.17" */
      customerGrandTotalAmountWithVatFormatted: string;
    };
    shipping: {
      /** @example "fulfillment" */
      shippingMethod: AnkorstoreOrderResourceShippingMethodEnum;
      shippingAddress: {
        /** @example "FR" */
        countryCode: string;
        /** @example "92100" */
        postalCode: string;
        /** @example "Boulogne-Billancourt" */
        city: string;
        /** @example "105, rue de Sevres" */
        street: string;
        addressLine?: string | null;
      };
      contactPerson: {
        /** @example "etienne.guillou@roy.com" */
        email: string;
        /** @example "Etienne" */
        firstName: string;
        /** @example "Guillou" */
        lastName: string;
        company?: string | null;
        phoneNumber?: string | null;
      };
    };
    tracking?: {
      /** @example "1Z999AA10123456784" */
      trackingNumber: string;
      /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
      trackingLink?: string;
      /** @example "shipped" */
      status: string;
      /** @example false */
      isDelivered: boolean;
    };
  };
}

/**
 * PaymentResource
 * The resource of a payment object
 */
export interface AnkorstorePaymentResource {
  /** @default "order-pay-payments" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * External order uuid
     * @format uuid
     */
    orderUuid: string;
    /**
     * OrderPay customer uuid (external)
     * @format uuid
     */
    customerUuid: string;
    /**
     * Brand uuid
     * @format uuid
     */
    brandUuid: string;
    /**
     * Creation date of the payment
     * @format date-time
     */
    createdAt: string;
    /** The payment service provider selected for the payment */
    psp: AnkorstorePaymentResourcePspEnum;
    /** Status of the payment */
    status: AnkorstorePaymentResourceStatusEnum;
    amount: number;
    /**
     * ISO 3-Letter Currency Code
     * @example "EUR"
     */
    currency: string;
    /** @format float */
    currencyRate: number;
    /** The payment method selected for the payment */
    paymentMethod: AnkorstorePaymentResourcePaymentMethodEnum;
    fundedBy?: string | null;
    paymentTerms?: string | null;
  };
  relationships?: {
    transactions?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/**
 * TransactionResource
 * The resource of a transaction object
 */
export interface AnkorstoreTransactionResource {
  /** @default "order-pay-transactions" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * Creation date of the transaction
     * @format date-time
     */
    createdAt: string;
    /** The payment service provider transaction id */
    pspId: string;
    amount: number;
    currency: string;
    type: string;
    status: string;
    pspData?: {
      client_secret?: string;
      iban?: {
        bic?: string;
        iban?: string;
        country?: string;
        reference?: string;
      };
    };
  };
}

/** OrderSchema */
export interface AnkorstoreOrderSchema {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** @default "order-pay-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type?: AnkorstoreOrderSchemaTypeEnum;
        /**
         * The VAT rate applied to this item (expressed as a percentage).
         * @min 0
         * @max 100
         * @example 12.5
         */
        vatRate?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount?: number;
        /**
         * The total amount of VAT to collect for this item, in cents.
         * @min 0
         */
        amountVat?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
         * @min 0
         */
        amountWithVat?: number;
      }[];
      status?: AnkorstoreOrderSchemaStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: AnkorstoreOrderSchemaShippingMethodEnum;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** @default "order-pay-payments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: AnkorstoreOrderSchemaPspEnum;
          /** Status of the payment */
          status: AnkorstoreOrderSchemaStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: AnkorstoreOrderSchemaPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-pay-transactions" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

export interface AnkorstoreListShippingQuotesResponse {
  data: {
    /** The unique identifier for the quote as an uuid */
    quoteUuid?: string;
    /** The carrier code for the quote */
    carrierCode?: string;
    /** The service code for the quote */
    serviceCode?: string;
    /** The commercial name of the service */
    serviceCommercialName?: string;
    /** The collection method for the quote */
    collectionMethod?: AnkorstoreListShippingQuotesResponseCollectionMethodEnum[];
    shippingCost?: {
      /** The amount of the shipping cost */
      amount?: number;
      /** The currency of the shipping cost */
      currency?: string;
    };
    /** Delivery estimation information if provided by carrier */
    timeInTransit?: {
      /**
       * Estimation of delivery date by the carrier
       * @format date
       */
      estimatedDeliveryDate?: null | string;
      /**
       * Pickup date considered for the estimation
       * @format date
       */
      pickupDate?: null | string;
      /** Number of business days the shipment is in transit */
      businessDaysInTransit?: null | number;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface AnkorstoreConfirmShippingQuoteResponse {
  data?: {
    id?: string;
    uuid?: string;
    orderUuid?: string;
    provider?: string;
    currency?: string;
    /** Shipping cost subtracted from total amount for ankorstore quote - Available only for ankorstore quote */
    shippingCost?: string;
    /** Refund done to the brand for custom quote - Available only for custom quote */
    refund?: string;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface AnkorstoreFulfillmentBundleItem {
  /** @format uuid */
  fulfillmentItemId?: string;
  /** The number of items in the bundle */
  quantity?: number;
}

export interface AnkorstoreFulfillmentBundle {
  /** @format uuid */
  productVariantId?: string;
  items?: {
    /** @format uuid */
    fulfillmentItemId?: string;
    /** The number of items in the bundle */
    quantity?: number;
  }[];
}

export interface AnkorstoreFulfillmentBundleResource {
  /** @default "fulfillment-bundle" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format uuid */
    productVariantId?: string;
    items?: {
      /** @format uuid */
      fulfillmentItemId?: string;
      /** The number of items in the bundle */
      quantity?: number;
    }[];
  };
}

/** A fulfillable entity, which can be either an item or a bundle (set of items) */
export interface AnkorstoreFulfillmentFulfillable {
  /** @format uuid */
  fulfillableId: string;
  /** quantity in batches */
  batchQuantity: number;
  /** quantity in units */
  unitQuantity: number;
}

export interface AnkorstoreFulfillmentFulfillableResource {
  /** @default "fulfillment-fulfillables" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /** A fulfillable entity, which can be either an item or a bundle (set of items) */
  attributes: {
    /** @format uuid */
    fulfillableId: string;
    /** quantity in batches */
    batchQuantity: number;
    /** quantity in units */
    unitQuantity: number;
  };
  relationships?: {
    item?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      } | null;
    };
    lots?: {
      /** An array of objects each containing `type` and `id` members for to-many relationships. */
      data?:
        | {
            /**
             * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
             * @format uuid
             */
            id: string;
            /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
            type: string;
            /** Non-standard meta-information that can not be represented as an attribute or relationship. */
            meta?: Record<string, any>;
          }[]
        | null;
    };
  };
}

export interface AnkorstoreFulfillmentLot {
  /** @format uuid */
  fulfillmentItemId: string;
  availableQuantity: number;
  /**
   * Optional expiry date of the lot
   * @format date-time
   */
  expiryDate?: string | null;
  /**
   * If the lot can expire, last point in time when this lot can be used to fulfill an order
   * @format date-time
   */
  sellByDate?: string | null;
  lotNumber: string;
}

export interface AnkorstoreFulfillmentLotResource {
  /** @default "fulfillment-lots" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format uuid */
    fulfillmentItemId: string;
    availableQuantity: number;
    /**
     * Optional expiry date of the lot
     * @format date-time
     */
    expiryDate?: string | null;
    /**
     * If the lot can expire, last point in time when this lot can be used to fulfill an order
     * @format date-time
     */
    sellByDate?: string | null;
    lotNumber: string;
  };
  relationships?: object;
}

/**
 * FulfillmentItem
 * Fulfillment item as exposed on the public API. Stock information (availableQuantity, stockStatus) is not included — use the stock API instead.
 */
export interface AnkorstoreFulfillmentItem {
  /** @format uuid */
  productVariantId: string;
  barcode: string;
  unitsPerBatch: number;
  /** @format float */
  unitCostMargin: number;
  /** @format float */
  unitCost: number;
  sku: string;
  productName: string;
  categoryName: string;
  classificationCode?: string | null;
  expiryTracked?: boolean;
  shelfLife?: number | null;
  lotTracked?: boolean;
  isFragile?: boolean | null;
  isOrganic?: boolean | null;
  needRepack?: boolean | null;
  needRelabel?: boolean | null;
  alcoholCode?: number | null;
  /** @format float */
  alcoholPercentage?: number | null;
  /** @format float */
  volumeOfLiquidPerPack?: number | null;
  icpeCode?: number | null;
  packingRules?: object | null;
  status?: AnkorstoreFulfillmentItemStatusEnum;
  expectedStockForDays?: number | null;
  referenceId?: string;
}

export interface AnkorstoreFulfillmentItemResource {
  /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  /**
   * FulfillmentItem
   * Fulfillment item as exposed on the public API. Stock information (availableQuantity, stockStatus) is not included — use the stock API instead.
   */
  attributes: {
    /** @format uuid */
    productVariantId: string;
    barcode: string;
    unitsPerBatch: number;
    /** @format float */
    unitCostMargin: number;
    /** @format float */
    unitCost: number;
    sku: string;
    productName: string;
    categoryName: string;
    classificationCode?: string | null;
    expiryTracked?: boolean;
    shelfLife?: number | null;
    lotTracked?: boolean;
    isFragile?: boolean | null;
    isOrganic?: boolean | null;
    needRepack?: boolean | null;
    needRelabel?: boolean | null;
    alcoholCode?: number | null;
    /** @format float */
    alcoholPercentage?: number | null;
    /** @format float */
    volumeOfLiquidPerPack?: number | null;
    icpeCode?: number | null;
    packingRules?: object | null;
    status?: AnkorstoreFulfillmentItemResourceStatusEnum;
    expectedStockForDays?: number | null;
    referenceId?: string;
  };
}

/**
 * FulfillmentItemInput
 * Input schema for creating a fulfillment item on the public API
 */
export interface AnkorstoreFulfillmentItemInput {
  /**
   * The product variant UUID. Must belong to the authenticated brand.
   * @format uuid
   */
  productVariantId: string;
  /** @pattern ^\d{13,14}$ */
  barcode: string;
  /** @min 1 */
  unitsPerBatch: number;
  /**
   * @format float
   * @min 1
   */
  unitCost: number;
  /**
   * @format float
   * @min 0
   */
  unitCostMargin: number;
  sku: string;
  productName: string;
  categoryName: string;
  classificationCode?: string;
  /** @default false */
  expiryTracked?: boolean;
  shelfLife?: number | null;
  /** @default false */
  lotTracked?: boolean;
  /** @default false */
  isFragile?: boolean | null;
  /** @default false */
  isOrganic?: boolean | null;
  /** @default false */
  needRepack?: boolean | null;
  /** @default false */
  needRelabel?: boolean | null;
  /**
   * @min 1
   * @max 11
   */
  alcoholCode?: number | null;
  /**
   * @format float
   * @min 0
   * @max 100
   */
  alcoholPercentage?: number | null;
  /**
   * @format float
   * @min 0
   * @max 100
   */
  volumeOfLiquidPerPack?: number | null;
  /**
   * @min 1000
   * @max 4999
   */
  icpeCode?: number;
}

export interface AnkorstoreFulfillmentParcelSpecification {
  /**
   * Parcel length in centimeters
   * @min 0
   */
  length: number;
  /**
   * Parcel width in centimeters
   * @min 0
   */
  width: number;
  /**
   * Parcel height in centimeters
   * @min 0
   */
  height: number;
  /**
   * Parcel weight in grams
   * @min 0
   */
  weight: number;
  /** Type of package, used to route to the parcel or pallet pricing grid. When omitted, it is estimated from the parcel dimensions. */
  packageType?: AnkorstoreFulfillmentParcelSpecificationPackageTypeEnum;
}

export interface AnkorstoreFulfillmentOrderCostsSpecification {
  type: AnkorstoreFulfillmentOrderCostsSpecificationTypeEnum;
  attributes: {
    /**
     * A 2-letter ISO-3166 country code of the destination country.
     * @example "GB"
     */
    shipToCountry: string;
    /**
     * Postal code of the destination, used for remote-area surcharge and FR/MC region resolution.
     * @example "75001"
     */
    shipToPostalCode: string;
    parcels: {
      /**
       * Parcel length in centimeters
       * @min 0
       */
      length: number;
      /**
       * Parcel width in centimeters
       * @min 0
       */
      width: number;
      /**
       * Parcel height in centimeters
       * @min 0
       */
      height: number;
      /**
       * Parcel weight in grams
       * @min 0
       */
      weight: number;
      /** Type of package, used to route to the parcel or pallet pricing grid. When omitted, it is estimated from the parcel dimensions. */
      packageType?: AnkorstoreFulfillmentOrderCostsSpecificationPackageTypeEnum;
    }[];
    /** @min 0 */
    pickingQuantity: number;
  };
}

export enum AnkorstoreFulfillmentOrderInvoiceItemCategory {
  Shipping = 'shipping',
  OrderPickLt4U = 'order pick lt 4u',
  OrderPickLt40U = 'order pick lt 40u',
  OrderPickGt40U = 'order pick gt 40u',
  UnitPickLt4U = 'unit pick lt 4u',
  UnitPickLt40U = 'unit pick lt 40u',
  UnitPickGt40U = 'unit pick gt 40u',
}

export interface AnkorstoreFulfillmentOrderCost {
  category?: AnkorstoreFulfillmentOrderCostCategoryEnum;
  /** @min 0 */
  quantity?: number;
  /** @min 0 */
  unitAmount?: number;
  /** @min 0 */
  totalAmount?: number;
  /**
   * @format double
   * @min 0
   * @max 100
   * @example 20
   */
  vatRate?: number;
  /** @min 0 */
  totalAmountWithVat?: number;
}

export interface AnkorstoreFulfillmentOrderCostResource {
  /** @default "fulfillment-order-costs" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    category?: AnkorstoreFulfillmentOrderCostResourceCategoryEnum;
    /** @min 0 */
    quantity?: number;
    /** @min 0 */
    unitAmount?: number;
    /** @min 0 */
    totalAmount?: number;
    /**
     * @format double
     * @min 0
     * @max 100
     * @example 20
     */
    vatRate?: number;
    /** @min 0 */
    totalAmountWithVat?: number;
  };
}

/** ReplenishmentItem */
export interface AnkorstoreReplenishmentItem {
  /** @format uuid */
  fulfillmentItemId: string;
  quantity: number;
  status?: AnkorstoreReplenishmentItemStatusEnum;
}

/** Replenishment */
export interface AnkorstoreReplenishmentBase {
  /**
   * deprecated, use fulfillmentBrandId instead
   * @deprecated
   */
  brandId?: number;
  /** @format uuid */
  fulfillmentBrandId?: string;
  /** @format uuid */
  warehouseId?: string;
  shippingCarrierName: string;
  shipmentType: AnkorstoreReplenishmentBaseShipmentTypeEnum;
  items: {
    /** @format uuid */
    fulfillmentItemId: string;
    quantity: number;
    status?: AnkorstoreReplenishmentBaseStatusEnum;
  }[];
}

/** ReplenishmentReceipt */
export interface AnkorstoreReplenishmentReceipt {
  receiptId?: string;
  /** @format date-time */
  receivedAt?: string;
  items?: {
    /** @format uuid */
    fulfillmentItemId: string;
    quantity: number;
    status?: AnkorstoreReplenishmentReceiptStatusEnum;
  }[];
}

export type AnkorstoreReplenishment = {
  /**
   * deprecated, use fulfillmentBrandId instead
   * @deprecated
   */
  brandId?: number;
  /** @format uuid */
  fulfillmentBrandId?: string;
  /** @format uuid */
  warehouseId?: string;
  shippingCarrierName: string;
  shipmentType: AnkorstoreReplenishmentShipmentTypeEnum;
  items: {
    /** @format uuid */
    fulfillmentItemId: string;
    quantity: number;
    status?: AnkorstoreReplenishmentStatusEnum;
  }[];
} & {
  reference?: string;
  status?: AnkorstoreReplenishmentStatusEnum1;
  /** @format date-time */
  receivedAt?: string | null;
  /** @format date-time */
  deliveredAt?: string | null;
  /** @format date-time */
  confirmedAt?: string | null;
  /** @format date-time */
  submittedAt?: string | null;
  /** @format date-time */
  createdAt?: string;
  receipts?: {
    receiptId?: string;
    /** @format date-time */
    receivedAt?: string;
    items?: {
      /** @format uuid */
      fulfillmentItemId: string;
      quantity: number;
      status?: AnkorstoreReplenishmentStatusEnum2;
    }[];
  }[];
};

export interface AnkorstoreReplenishmentResource {
  /** @default "replenishments" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * deprecated, use fulfillmentBrandId instead
     * @deprecated
     */
    brandId?: number;
    /** @format uuid */
    fulfillmentBrandId?: string;
    /** @format uuid */
    warehouseId?: string;
    shippingCarrierName: string;
    shipmentType: AnkorstoreReplenishmentResourceShipmentTypeEnum;
    items: {
      /** @format uuid */
      fulfillmentItemId: string;
      quantity: number;
      status?: AnkorstoreReplenishmentResourceStatusEnum;
    }[];
  } & {
    reference?: string;
    status?: AnkorstoreReplenishmentResourceStatusEnum1;
    /** @format date-time */
    receivedAt?: string | null;
    /** @format date-time */
    deliveredAt?: string | null;
    /** @format date-time */
    confirmedAt?: string | null;
    /** @format date-time */
    submittedAt?: string | null;
    /** @format date-time */
    createdAt?: string;
    receipts?: {
      receiptId?: string;
      /** @format date-time */
      receivedAt?: string;
      items?: {
        /** @format uuid */
        fulfillmentItemId: string;
        quantity: number;
        status?: AnkorstoreReplenishmentResourceStatusEnum2;
      }[];
    }[];
  };
  relationships?: {
    fulfillmentBrand?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
    warehouse?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  };
}

export type AnkorstoreReplenishmentInput = {
  /**
   * deprecated, use fulfillmentBrandId instead
   * @deprecated
   */
  brandId?: number;
  /** @format uuid */
  fulfillmentBrandId?: string;
  /** @format uuid */
  warehouseId?: string;
  shippingCarrierName: string;
  shipmentType: AnkorstoreReplenishmentInputShipmentTypeEnum;
  items: {
    /** @format uuid */
    fulfillmentItemId: string;
    quantity: number;
    status?: AnkorstoreReplenishmentInputStatusEnum;
  }[];
} & {
  /** @format uuid */
  id?: string;
};

export interface AnkorstoreUpdateReplenishmentRequest {
  shippingCarrierName?: string;
  shipmentType?: AnkorstoreUpdateReplenishmentRequestShipmentTypeEnum;
  status?: AnkorstoreUpdateReplenishmentRequestStatusEnum;
  items?: {
    /** @format uuid */
    fulfillmentItemId: string;
    quantity: number;
    status?: AnkorstoreUpdateReplenishmentRequestStatusEnum1;
  }[];
}

/** FrancoResource */
export interface AnkorstoreFrancoResource {
  type: 'franco';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** @format uuid */
    brandId: string;
    amount: number;
    fee: number;
    maxFee: number;
    currency: string;
  };
}

/** FrancoSettingsOptionValue */
export interface AnkorstoreFrancoSettingsOptionValue {
  amount: number;
  currency: string;
  isSpecialDeal: boolean;
  isDefault: boolean;
}

/** FrancoSettingsResource */
export interface AnkorstoreFrancoSettingsResource {
  type: 'franco-settings';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    corridor: string;
    amount: number;
    currency: string;
    fee: number;
  };
  meta: {
    amountOptions: {
      amount: number;
      currency: string;
      isSpecialDeal: boolean;
      isDefault: boolean;
    }[];
    feeOptions: {
      amount: number;
      currency: string;
      isSpecialDeal: boolean;
      isDefault: boolean;
    }[];
    defaultMaxFeeAmount: number;
    [key: string]: any;
  };
}

export interface AnkorstoreBrandRetailer {
  automaticOrderValidationMode?: boolean | null;
}

export interface AnkorstoreBrandRetailerResource {
  /** @default "brand-retailers" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    automaticOrderValidationMode?: boolean | null;
  };
}

export interface AnkorstorePlatformConfig {
  cdn?: string;
  stripePublicKey?: string;
}

export interface AnkorstorePlatformConfigResource {
  /** @default "platform-configs" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    cdn?: string;
    stripePublicKey?: string;
  };
}

/**
 * ApplicationResource
 * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"application","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":null}}
 */
export interface AnkorstoreApplicationResource {
  type: 'application';
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /** Application given name */
    name: string;
    /**
     * Email of the developer to contact
     * @format email
     * @example "developer@application.com"
     */
    developerEmail: string;
    /** Client ID generated for this application */
    clientId: string;
    /** Secret to be used for access token issuance. Can be invoked only once on application creation */
    clientSecret: null;
  };
  /** Only presented if asked explicitly in the request */
  relationships?: {
    webhookSubscriptions?: {
      /**
       * An array of objects each containing `type` and `id` members for to-many relationships.
       * @uniqueItems true
       */
      data?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }[];
    };
  };
}

/**
 * ApplicationWebhookSubscriptionResource
 * Application webhook subscription resource
 */
export interface AnkorstoreApplicationWebhookSubscriptionResource {
  /** @default "webhook-subscriptions" */
  type: string;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  id: string;
  attributes: {
    /**
     * URL of the service where webhook request will be sent when one of the events from the list occurs
     * @format uri
     * @example "https://my.app/webhook/listener"
     */
    webhookUrl: string;
    /**
     * List of subscribed event types:
     * - `order.brand_created` — A new order has been created and is pending brand confirmation
     * - `order.brand_accepted` — The brand has accepted the order
     * - `order.brand_rejected` — The brand has rejected the order
     * - `order.shipping_labels_generated` — Shipping labels have been generated for the order
     * - `order.shipped` — The order has been shipped
     * - `order.shipment_received` — The retailer has confirmed receipt of the order
     * - `order.shipment_refused` — The retailer has refused the shipment
     * - `order.brand_paid` — Payment has been transferred to the brand
     * - `order.cancelled` — The order has been cancelled
     * @uniqueItems true
     */
    events: AnkorstoreApplicationWebhookSubscriptionResourceEventsEnum[];
    signingSecret: string;
  };
}

/**
 * BulkOperationResult
 * Single operation result in the list of results in the bulk operation response
 */
export interface AnkorstoreBulkOperationResult {
  data: {
    /** @default "product-variants" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: object;
  };
}

/** Type of wrapped order */
export enum AnkorstoreInternalMasterOrderTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstoreInternalMasterOrderMasterStatusEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalMasterOrderTypeEnum1 {
  PublicApp = 'publicApp',
}

export enum AnkorstoreInternalMasterOrderPlatformNameEnum {
  WOO_COMMERCE = 'WOO_COMMERCE',
  SHOPIFY = 'SHOPIFY',
}

export enum AnkorstoreInternalMasterOrderNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreInternalMasterOrderCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum AnkorstoreInternalMasterOrderDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalMasterOrderLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum AnkorstoreInternalMasterOrderDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum AnkorstoreInternalMasterOrderServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalMasterOrderBusinessModelEnum {
  Value2024 = '2024',
  Value2025 = '2025',
}

/**
 * Whether a retailer can order the variant backing this
 * option for which stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum AnkorstoreInternalProductCardResourceInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which
 * stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum AnkorstoreInternalProductCardResourceInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order the variant backing this
 * option for which stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum AnkorstoreInternalProductCardAttributesInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which
 * stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum AnkorstoreInternalProductCardAttributesInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

export enum AnkorstoreInternalCollectionCardResourceCollectionTypeEnum {
  Product = 'product',
  Brand = 'brand',
}

export enum AnkorstoreInternalCollectionCardAttributesCollectionTypeEnum {
  Product = 'product',
  Brand = 'brand',
}

export enum AnkorstoreInternalBrandDiscoveryBrandResourceFeedbackEnum {
  Liked = 'liked',
  Disliked = 'disliked',
  Skipped = 'skipped',
}

export enum AnkorstoreInternalOnboardingResourceTypeEnum {
  Onboarding = 'onboarding',
}

export enum AnkorstoreInternalOnboardingResourceStatusEnum {
  Completed = 'completed',
  InProgress = 'in_progress',
}

export enum AnkorstoreInternalFrancoSettingsSummaryTypeEnum {
  FrancoSettingsSummary = 'franco-settings-summary',
}

export enum AnkorstoreInternalBrandContactResourcePurposesEnum {
  Finance = 'finance',
}

export enum AnkorstoreInternalVideoResourceTypeEnum {
  Videos = 'videos',
}

/** The context in which the video is displayed */
export enum AnkorstoreInternalVideoResourceDisplayContextEnum {
  Hero = 'hero',
  Story = 'story',
  Gallery = 'gallery',
}

/** @example "accepted" */
export enum AnkorstoreInternalUserAgreementStatusEnum {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum AnkorstoreInternalBrandRetailerTypeEnum {
  Custom = 'custom',
  BrandCustom = 'brand_custom',
  LiftOrder = 'lift_order',
  Network = 'network',
  SpecialOperation = 'special_operation',
  BrandCustomNetwork = 'brand_custom_network',
  Widget = 'widget',
}

export enum AnkorstoreInternalBrandRetailerResourceTypeEnum {
  Custom = 'custom',
  BrandCustom = 'brand_custom',
  LiftOrder = 'lift_order',
  Network = 'network',
  SpecialOperation = 'special_operation',
  BrandCustomNetwork = 'brand_custom_network',
  Widget = 'widget',
}

/**
 * Pillar this criterion belongs to
 * @example "seo"
 */
export enum AnkorstoreInternalCriterionResultPillarIdEnum {
  Seo = 'seo',
  Categorization = 'categorization',
  Differentiation = 'differentiation',
}

export enum AnkorstoreInternalBrandReactivationResourceStatusEnum {
  NotRequested = 'not_requested',
  Pending = 'pending',
  Approved = 'approved',
  Completed = 'completed',
  Rejected = 'rejected',
}

export enum AnkorstoreInternalBrandReactivationResourcePreviousStatusEnum {
  NotRequested = 'not_requested',
  Pending = 'pending',
  Approved = 'approved',
  Completed = 'completed',
  Rejected = 'rejected',
}

export enum AnkorstoreInternalShippingFeeResourceTypeEnum {
  RetailerShippingFees = 'retailer_shipping_fees',
}

export enum AnkorstoreInternalTaxResourceTypeEnum {
  FeesVat = 'fees_vat',
  GoodsVat = 'goods_vat',
  RecargoDeEquivalencia = 'recargo_de_equivalencia',
}

export enum AnkorstoreInternalDiscountResourceTypeEnum {
  Promocode = 'promocode',
  OfferDiscount = 'offer_discount',
  EventDiscount = 'event_discount',
  PaymentMethodDiscount = 'payment_method_discount',
  Wallet = 'wallet',
}

export enum AnkorstoreInternalCartSummaryResourceTypeEnum {
  RetailerShippingFees = 'retailer_shipping_fees',
}

export enum AnkorstoreInternalCartSummaryResourceTypeEnum1 {
  FeesVat = 'fees_vat',
  GoodsVat = 'goods_vat',
  RecargoDeEquivalencia = 'recargo_de_equivalencia',
}

export enum AnkorstoreInternalCartSummaryResourceTypeEnum2 {
  Promocode = 'promocode',
  OfferDiscount = 'offer_discount',
  EventDiscount = 'event_discount',
  PaymentMethodDiscount = 'payment_method_discount',
  Wallet = 'wallet',
}

/** Type of the Purchasing List */
export enum AnkorstoreInternalPurchasingListResourceTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasingListItemLongDistanceFeeTypeEnum {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasingListItemHeavyBulkFeeTypeEnum {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasingListShippingFeeTypeEnum {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum AnkorstoreInternalPurchasingListShippingFeeOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

export enum AnkorstoreInternalPurchasableAggregateResourceGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasableAggregateResourceTypeEnum {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasableAggregateResourceTypeEnum1 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasableAggregateResourceTypeEnum2 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum AnkorstoreInternalPurchasableAggregateResourceOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Type of the discount */
export enum AnkorstoreInternalPurchasableItemDiscountTypeEnum {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/** Type of the discount */
export enum AnkorstoreInternalPurchasableItemPricingTypeEnum {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum AnkorstoreInternalPurchasableItemStockStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreInternalPurchasableItemStockInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum AnkorstoreInternalPurchasableItemResourceAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum AnkorstoreInternalPurchasableItemResourceTypeEnum {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum AnkorstoreInternalPurchasableItemResourceStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreInternalPurchasableItemResourceInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasableItemResourceTypeEnum1 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasableItemResourceTypeEnum2 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum AnkorstoreInternalPurchasableItemResourceTypeEnum3 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum AnkorstoreInternalPurchasableItemResourceOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum AnkorstoreInternalPurchasableItemResourceStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

/**
 * The cart lifecycle state.
 * @example "draft"
 */
export enum AnkorstoreInternalPreparedOrderStateEnum {
  Draft = 'draft',
  Submitted = 'submitted',
  Confirmed = 'confirmed',
  Paid = 'paid',
}

/**
 * Why the product could not be re-added.
 * - `unavailable`: the variant no longer exists or is no longer sold by the brand.
 */
export enum AnkorstoreInternalUnavailableItemReasonEnum {
  Unavailable = 'unavailable',
}

/**
 * The cart lifecycle state.
 * @example "draft"
 */
export enum AnkorstoreInternalPreparedOrderResourceStateEnum {
  Draft = 'draft',
  Submitted = 'submitted',
  Confirmed = 'confirmed',
  Paid = 'paid',
}

/**
 * Why the product could not be re-added.
 * - `unavailable`: the variant no longer exists or is no longer sold by the brand.
 */
export enum AnkorstoreInternalPreparedOrderResourceReasonEnum {
  Unavailable = 'unavailable',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalSearchValueFilterTypeEnum {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalSearchRangeFilterTypeEnum {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalSearchBooleanFilterTypeEnum {
  Boolean = 'boolean',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalSearchFilterTypeEnum {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalSearchFilterTypeEnum1 {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalSearchFilterTypeEnum2 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum AnkorstoreInternalCampaignMessageTypeEnum {
  Email = 'email',
}

/** The type of message. */
export enum AnkorstoreInternalCampaignMessageEmailTypeEnum {
  Email = 'email',
}

export enum AnkorstoreInternalCampaignResourceTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum AnkorstoreInternalCampaignResourceTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum AnkorstoreInternalCampaignResourceStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum AnkorstoreInternalCampaignResourceTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalCampaignResourceTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalCampaignResourceTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalCampaignResourceTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum AnkorstoreInternalCampaignResourceTypeEnum5 {
  Email = 'email',
}

export enum AnkorstoreInternalCampaignCollectionDocumentTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum AnkorstoreInternalCampaignCollectionDocumentTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum AnkorstoreInternalCampaignCollectionDocumentStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum AnkorstoreInternalCampaignCollectionDocumentTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalCampaignCollectionDocumentTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalCampaignCollectionDocumentTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalCampaignCollectionDocumentTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum AnkorstoreInternalCampaignCollectionDocumentTypeEnum5 {
  Email = 'email',
}

export enum AnkorstoreInternalCampaignDocumentTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum AnkorstoreInternalCampaignDocumentTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum AnkorstoreInternalCampaignDocumentStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum AnkorstoreInternalCampaignDocumentTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalCampaignDocumentTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalCampaignDocumentTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalCampaignDocumentTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum AnkorstoreInternalCampaignDocumentTypeEnum5 {
  Email = 'email',
}

export enum AnkorstoreInternalCampaignDeliveryResourceTypeEnum {
  CampaignDelivery = 'campaign-delivery',
}

/** The current status of the delivery. */
export enum AnkorstoreInternalCampaignDeliveryResourceStatusEnum {
  Queued = 'queued',
  Undeliverable = 'undeliverable',
  Attempted = 'attempted',
  Failed = 'failed',
  Sent = 'sent',
  Delivered = 'delivered',
  Bounced = 'bounced',
  Suppressed = 'suppressed',
}

export enum AnkorstoreInternalCampaignDeliveryCollectionDocumentTypeEnum {
  CampaignDelivery = 'campaign-delivery',
}

/** The current status of the delivery. */
export enum AnkorstoreInternalCampaignDeliveryCollectionDocumentStatusEnum {
  Queued = 'queued',
  Undeliverable = 'undeliverable',
  Attempted = 'attempted',
  Failed = 'failed',
  Sent = 'sent',
  Delivered = 'delivered',
  Bounced = 'bounced',
  Suppressed = 'suppressed',
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum AnkorstoreInternalRutterConfigurationCatalogSynchronizationWorkflowEnum {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum AnkorstoreInternalRutterConfigurationShopifyCatalogPriceStrategyEnum {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum AnkorstoreInternalRutterIntegrationCatalogSynchronizationWorkflowEnum {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum AnkorstoreInternalRutterIntegrationShopifyCatalogPriceStrategyEnum {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

export enum AnkorstoreInternalPlatformVerificationErrorCodeEnum {
  INVALID_URL_FORMAT = 'INVALID_URL_FORMAT',
  SITE_DOES_NOT_EXIST = 'SITE_DOES_NOT_EXIST',
  PLATFORM_MISMATCH = 'PLATFORM_MISMATCH',
  TARGET_RESPONDED_WITH_ERROR = 'TARGET_RESPONDED_WITH_ERROR',
  UNABLE_TO_CONNECT = 'UNABLE_TO_CONNECT',
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',
}

export enum AnkorstoreInternalFulfillableProductVariantFulfillableTypeEnum {
  Item = 'item',
  Bundle = 'bundle',
}

export enum AnkorstoreInternalProductVariantFulfillmentItemFulfillableTypeEnum {
  Item = 'item',
  Bundle = 'bundle',
}

export enum AnkorstoreInternalProductVariantFulfillmentItemClassificationCodeEnum {
  AerosolsInflammables = 'Aérosols inflammables',
  BoissonAlcoolisees = 'Boisson alcoolisées',
  CerealesGrainsProduitsAlimentaires = 'Céréales, grains, produits alimentaires',
  ContenantPilesOuBatteriesLithium = 'Contenant Piles ou batteries lithium',
  Corrosifs = 'Corrosifs',
  GazInflammables = 'Gaz inflammables',
  LiquidesInflammables = 'Liquides inflammables',
  MateriauxComburants = 'Matériaux comburants',
  Plastique = 'Plastique',
  ProduitsBois = 'Produits bois',
  ProduitsExplosifs = 'Produits explosifs',
  ProduitsGazeuxSousPression = 'Produits gazeux sous pression',
  ProduitsToxiquesToxicite = 'Produits toxiques / Toxicité',
  SolidesInflammables = 'Solides inflammables',
  AutresCombustibles = 'Autres combustibles',
  AutresDangereux = 'Autres dangereux',
}

export enum AnkorstoreInternalProductVariantFulfillmentItemStatusEnum {
  Created = 'created',
  Pending = 'pending',
  Synced = 'synced',
}

export enum AnkorstoreInternalProductVariantFulfillmentItemStockStatusEnum {
  InStock = 'in_stock',
  SoonOutOfStock = 'soon_out_of_stock',
  OutOfStock = 'out_of_stock',
  NeverReplenished = 'never_replenished',
}

export enum AnkorstoreInternalProductVariantFulfillmentBundleFulfillableTypeEnum {
  Item = 'item',
  Bundle = 'bundle',
}

export enum AnkorstoreInternalFulfillableProductVariantResourceFulfillableTypeEnum {
  Item = 'item',
  Bundle = 'bundle',
}

export enum AnkorstoreInternalFulfillableProductVariantResourceClassificationCodeEnum {
  AerosolsInflammables = 'Aérosols inflammables',
  BoissonAlcoolisees = 'Boisson alcoolisées',
  CerealesGrainsProduitsAlimentaires = 'Céréales, grains, produits alimentaires',
  ContenantPilesOuBatteriesLithium = 'Contenant Piles ou batteries lithium',
  Corrosifs = 'Corrosifs',
  GazInflammables = 'Gaz inflammables',
  LiquidesInflammables = 'Liquides inflammables',
  MateriauxComburants = 'Matériaux comburants',
  Plastique = 'Plastique',
  ProduitsBois = 'Produits bois',
  ProduitsExplosifs = 'Produits explosifs',
  ProduitsGazeuxSousPression = 'Produits gazeux sous pression',
  ProduitsToxiquesToxicite = 'Produits toxiques / Toxicité',
  SolidesInflammables = 'Solides inflammables',
  AutresCombustibles = 'Autres combustibles',
  AutresDangereux = 'Autres dangereux',
}

export enum AnkorstoreInternalFulfillableProductVariantResourceStatusEnum {
  Created = 'created',
  Pending = 'pending',
  Synced = 'synced',
}

export enum AnkorstoreInternalFulfillableProductVariantResourceStockStatusEnum {
  InStock = 'in_stock',
  SoonOutOfStock = 'soon_out_of_stock',
  OutOfStock = 'out_of_stock',
  NeverReplenished = 'never_replenished',
}

export enum AnkorstoreInternalFulfillableProductVariantResourceFulfillableTypeEnum1 {
  Item = 'item',
  Bundle = 'bundle',
}

export enum AnkorstoreInternalPackingInstructionServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalInstructionsServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalFulfillmentOrderAttributesServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderAttributesRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderJsonApiRequestTypeEnum {
  FulfillmentOrders = 'fulfillment-orders',
}

export enum AnkorstoreInternalFulfillmentOrderJsonApiRequestServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderJsonApiRequestRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderFlatRequestServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderFlatRequestRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderRequestTypeEnum {
  FulfillmentOrders = 'fulfillment-orders',
}

export enum AnkorstoreInternalFulfillmentOrderRequestServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderRequestRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderRequestServicesEnum1 {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderRequestRecipientTypeEnum1 {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderResourceStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreInternalFulfillmentOrderResourceRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalFulfillmentOrderStatusUpdateStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalFulfillmentOrderStatusUpdateResourceStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalFulfillmentBrandBillingCategoryEnum {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum AnkorstoreInternalFulfillmentBrandParcelCarrierEnum {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum AnkorstoreInternalFulfillmentBrandPalletCarrierEnum {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export enum AnkorstoreInternalFulfillmentBrandResourceBillingCategoryEnum {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum AnkorstoreInternalFulfillmentBrandResourceParcelCarrierEnum {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum AnkorstoreInternalFulfillmentBrandResourcePalletCarrierEnum {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export enum AnkorstoreInternalFulfillmentBrandStoreRequestBillingCategoryEnum {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum AnkorstoreInternalFulfillmentBrandStoreRequestParcelCarrierEnum {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum AnkorstoreInternalFulfillmentBrandStoreRequestPalletCarrierEnum {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export enum AnkorstoreInternalExternalIntegrationPlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum AnkorstoreInternalExternalIntegrationStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum AnkorstoreInternalExternalIntegrationResourcePlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum AnkorstoreInternalExternalIntegrationResourceStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

/** Unit of time. */
export enum AnkorstoreInternalDurationUnitEnum {
  Day = 'day',
  Month = 'month',
}

export enum AnkorstoreInternalOrderPayAccountResourceStatusEnum {
  Active = 'active',
  Trialling = 'trialling',
  Churned = 'churned',
}

/** The current status of the subscription. */
export enum AnkorstoreInternalOrderPayAccountResourceStatusEnum1 {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

/** Unit of time. */
export enum AnkorstoreInternalOrderPayAccountResourceUnitEnum {
  Day = 'day',
  Month = 'month',
}

/** Unit of time. */
export enum AnkorstoreInternalOrderPayAccountResourceUnitEnum1 {
  Day = 'day',
  Month = 'month',
}

/** The status expected for the subscription. */
export enum AnkorstoreInternalUpdateOrderPayAccountResourceStatusEnum {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

/** The payment service provider selected for the payment */
export enum AnkorstoreInternalPaymentResourcePspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum AnkorstoreInternalPaymentResourceStatusEnum {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum AnkorstoreInternalPaymentResourcePaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export enum AnkorstoreInternalOrderResourceStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalOrderSchemaStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The payment service provider selected for the payment */
export enum AnkorstoreInternalOrderSchemaPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum AnkorstoreInternalOrderSchemaStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum AnkorstoreInternalOrderSchemaPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export enum AnkorstoreInternalSchemasPackingInstructionServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalExternalCustomerTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalExternalCustomerServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalExternalCustomerResourceTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalExternalCustomerResourceServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalCreateExternalCustomerRequestTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalCreateExternalCustomerRequestServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalUpdateExternalCustomerRequestTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreInternalUpdateExternalCustomerRequestServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalParcelDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalOrderShipmentEstimationCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum AnkorstoreInternalOrderShipmentEstimationDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalBrandOrderShipmentLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum AnkorstoreInternalBrandOrderShipmentDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalBrandOrderShippingNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreInternalBrandOrderShippingCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum AnkorstoreInternalBrandOrderShippingDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalBrandOrderShippingLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum AnkorstoreInternalBrandOrderShippingDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum AnkorstoreInternalBrandOrderRetailerServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/** Type of wrapped order */
export enum AnkorstoreInternalBrandMasterOrderTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstoreInternalBrandMasterOrderMasterStatusEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalBrandMasterOrderTypeEnum1 {
  PublicApp = 'publicApp',
}

export enum AnkorstoreInternalBrandMasterOrderPlatformNameEnum {
  WOO_COMMERCE = 'WOO_COMMERCE',
  SHOPIFY = 'SHOPIFY',
}

export enum AnkorstoreInternalBrandMasterOrderNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreInternalBrandMasterOrderCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum AnkorstoreInternalBrandMasterOrderDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalBrandMasterOrderLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum AnkorstoreInternalBrandMasterOrderDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum AnkorstoreInternalBrandMasterOrderServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalBrandMasterOrderBusinessModelEnum {
  Value2024 = '2024',
  Value2025 = '2025',
}

export enum AnkorstoreInternalRetailerOrderShipmentDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalRetailerOrderShippingDistanceUnitEnum {
  Cm = 'cm',
}

/** Type of wrapped order */
export enum AnkorstoreInternalRetailerMasterOrderTypeEnum {
  Internal = 'internal',
}

export enum AnkorstoreInternalRetailerMasterOrderDistanceUnitEnum {
  Cm = 'cm',
}

/** Type of wrapped order */
export enum AnkorstoreInternalMasterOrderResourceTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstoreInternalMasterOrderResourceMasterStatusEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalMasterOrderResourceTypeEnum1 {
  PublicApp = 'publicApp',
}

export enum AnkorstoreInternalMasterOrderResourcePlatformNameEnum {
  WOO_COMMERCE = 'WOO_COMMERCE',
  SHOPIFY = 'SHOPIFY',
}

export enum AnkorstoreInternalMasterOrderResourceNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreInternalMasterOrderResourceCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum AnkorstoreInternalMasterOrderResourceDistanceUnitEnum {
  Cm = 'cm',
}

export enum AnkorstoreInternalMasterOrderResourceLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum AnkorstoreInternalMasterOrderResourceDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum AnkorstoreInternalMasterOrderResourceServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInternalMasterOrderResourceBusinessModelEnum {
  Value2024 = '2024',
  Value2025 = '2025',
}

/** Type of wrapped order */
export enum AnkorstoreInternalMasterOrderResourceTypeEnum2 {
  Internal = 'internal',
}

export enum AnkorstoreInternalMasterOrderResourceDistanceUnitEnum2 {
  Cm = 'cm',
}

export enum AnkorstoreInternalMasterOrderShippingShippingMethodEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreInternalMasterOrderShippingStockOriginEnum {
  DirectShipping = 'directShipping',
  FulfillmentCenter = 'fulfillmentCenter',
}

export enum AnkorstoreInternalOrderShippingResourceShippingMethodEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreInternalOrderShippingResourceStockOriginEnum {
  DirectShipping = 'directShipping',
  FulfillmentCenter = 'fulfillmentCenter',
}

export enum AnkorstoreInternalPreorderStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalPreorderPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

export enum AnkorstoreInternalPreorderResourceStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum AnkorstoreInternalPreorderResourcePaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreInternalPreorderItemProductVariantInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreInternalPreorderItemProductVariantResourceInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum AnkorstoreInternalPreorderPaymentTermNameEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

export enum AnkorstoreInternalPreorderPaymentTermResourceNameEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

export enum AnkorstoreInternalPreorderOrderPaymentStatusEnum {
  Pending = 'pending',
  Captured = 'captured',
  Failed = 'failed',
}

export enum AnkorstoreInternalPreorderOrderResourcePaymentStatusEnum {
  Pending = 'pending',
  Captured = 'captured',
  Failed = 'failed',
}

/**
 * Current state of the retailer PSP account
 * @example "ACTIVE_WITH_MANDATE"
 */
export enum AnkorstoreInternalPspRetailerAccountAttributesStateEnum {
  ACTIVE_WITH_MANDATE = 'ACTIVE_WITH_MANDATE',
  ACTIVE_NO_MANDATE = 'ACTIVE_NO_MANDATE',
  APPLY = 'APPLY',
  KYC_PENDING = 'KYC_PENDING',
  KYC_IN_REVIEW = 'KYC_IN_REVIEW',
  LEGAL_INFORMATION_PROTECTED = 'LEGAL_INFORMATION_PROTECTED',
  PROCESSING = 'PROCESSING',
  FROZEN = 'FROZEN',
  REFUSED_BI_UPDATE = 'REFUSED_BI_UPDATE',
  REFUSED_GENERIC = 'REFUSED_GENERIC',
}

/**
 * Current state of the retailer PSP account
 * @example "ACTIVE_WITH_MANDATE"
 */
export enum AnkorstoreInternalPspRetailerAccountResourceStateEnum {
  ACTIVE_WITH_MANDATE = 'ACTIVE_WITH_MANDATE',
  ACTIVE_NO_MANDATE = 'ACTIVE_NO_MANDATE',
  APPLY = 'APPLY',
  KYC_PENDING = 'KYC_PENDING',
  KYC_IN_REVIEW = 'KYC_IN_REVIEW',
  LEGAL_INFORMATION_PROTECTED = 'LEGAL_INFORMATION_PROTECTED',
  PROCESSING = 'PROCESSING',
  FROZEN = 'FROZEN',
  REFUSED_BI_UPDATE = 'REFUSED_BI_UPDATE',
  REFUSED_GENERIC = 'REFUSED_GENERIC',
}

export enum AnkorstoreInternalSchemasPaymentResourcePspEnum {
  Stripe = 'stripe',
}

export enum AnkorstoreInternalSchemasPaymentResourcePaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
}

export enum AnkorstoreInternalOperationResourcePaymentTermsEnum {
  Net30 = 'net-30',
  Net60 = 'net-60',
  Net90 = 'net-90',
  Reception10 = 'reception-10',
  UponAvailability = 'upon-availability',
  Installments3 = 'installments-3',
}

export enum AnkorstoreInternalOperationResourcePaymentMethodTypeEnum {
  BankTransfer = 'bank_transfer',
  Bancontact = 'bancontact',
  Card = 'card',
  Ideal = 'ideal',
  Invoice = 'invoice',
  Paypal = 'paypal',
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
}

export enum AnkorstoreInternalOperationResourceFundedByEnum {
  Alma = 'alma',
  AlmaAnkorstore = 'alma-ankorstore',
  Ankorstore = 'ankorstore',
  Finexkap = 'finexkap',
  Hokodo = 'hokodo',
  Aria = 'aria',
  Pledg = 'pledg',
}

export enum AnkorstoreInternalOperationResourcePaymentStatusEnum {
  Failed = 'failed',
  InProgress = 'in_progress',
  Paid = 'paid',
  PastDue = 'past_due',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Delayed = 'delayed',
}

export enum AnkorstoreInternalOperationResourcePaymentInnerStatusEnum {
  OnReception = 'on_reception',
  UpcomingDebit = 'upcoming_debit',
  Delayed = 'delayed',
  PaymentInProgress = 'payment_in_progress',
  PaidSuccessfully = 'paid_successfully',
  PaymentRecoveredSuccessfully = 'payment_recovered_successfully',
  PaymentUnsuccessful = 'payment_unsuccessful',
  PartialRecoveryFailed = 'partial_recovery_failed',
  PaymentRecoveredFailed = 'payment_recovered_failed',
  Cancelled = 'cancelled',
  CancelledRefunded = 'cancelled_refunded',
}

export enum AnkorstoreInternalOperationResourceExternalTypeEnum {
  Checkout = 'checkout',
  Order = 'order',
}

/** Invoice type. */
export enum AnkorstoreInternalOperationOrderInvoiceResourceTypeEnum {
  Invoice = 'invoice',
  CreditMemo = 'credit_memo',
  Proforma = 'proforma',
  PurchaseOrder = 'purchase_order',
}

export enum AnkorstoreInternalServiceInvoiceStatusEnum {
  ProForma = 'pro_forma',
  Paid = 'paid',
  PaymentFailed = 'payment failed',
  PaymentPending = 'payment pending',
  PaymentProcessing = 'payment_processing',
  Disputed = 'disputed',
}

/** Service type of the invoice */
export enum AnkorstoreInternalServiceInvoiceServiceTypeEnum {
  Fulfillment = 'fulfillment',
  Ads = 'ads',
  Orderpay = 'orderpay',
}

export enum AnkorstoreInternalServiceInvoiceResourceStatusEnum {
  ProForma = 'pro_forma',
  Paid = 'paid',
  PaymentFailed = 'payment failed',
  PaymentPending = 'payment pending',
  PaymentProcessing = 'payment_processing',
  Disputed = 'disputed',
}

/** Service type of the invoice */
export enum AnkorstoreInternalServiceInvoiceResourceServiceTypeEnum {
  Fulfillment = 'fulfillment',
  Ads = 'ads',
  Orderpay = 'orderpay',
}

/** Ankstore customer type e.g. Brand, Retailer etc. */
export enum AnkorstoreInternalPaymentServiceProviderCustomerAksCustomerTypeEnum {
  Brand = 'brand',
  Retailer = 'retailer',
}

export enum AnkorstoreInternalPaymentServiceProviderCustomerMandateTypeEnum {
  MultiUse = 'multi_use',
  SingleUse = 'single_use',
  Card = 'card',
}

export enum AnkorstoreInternalPaymentServiceProviderCustomerMandateStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
}

/** Ankstore customer type e.g. Brand, Retailer etc. */
export enum AnkorstoreInternalPaymentServiceProviderCustomerResourceAksCustomerTypeEnum {
  Brand = 'brand',
  Retailer = 'retailer',
}

export enum AnkorstoreInternalPaymentServiceProviderCustomerResourceMandateTypeEnum {
  MultiUse = 'multi_use',
  SingleUse = 'single_use',
  Card = 'card',
}

export enum AnkorstoreInternalPaymentServiceProviderCustomerResourceMandateStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
}

/**
 * Whether a retailer can order a product
 * variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer
 *   cannot order a quantity larger than
 *   the currently available stock
 *   quantity, so the variant cannot be
 *   ordered when it is out of stock, or
 *   when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can
 *   order any quantity, even when stock
 *   is insufficient (desired quantity >
 *   available quantity > 0) or the
 *   variant is out of stock (available
 *   quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum AnkorstoreInternalProductIntegrationResponseContentInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum AnkorstoreInternalProductIntegrationBatchImportTypeEnum {
  Add = 'add',
  Replace = 'replace',
}

export enum AnkorstoreInternalProductIntegrationBatchWorkflowEnum {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
  Activate = 'activate',
}

export enum AnkorstoreInternalProductIntegrationBatchResourceImportTypeEnum {
  Add = 'add',
  Replace = 'replace',
}

export enum AnkorstoreInternalProductIntegrationBatchResourceWorkflowEnum {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
  Activate = 'activate',
}

/** Status of the Catalog Export */
export enum AnkorstoreInternalExportStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export enum AnkorstoreInternalExportTemplateEnum {
  ProductsXlsx = 'products.xlsx',
}

/** Service Type used to distinguish what this item is for. */
export enum AnkorstoreInternalServiceInvoiceItemServiceTypeEnum {
  Fulfillment = 'fulfillment',
  Ads = 'ads',
  Orderpay = 'orderpay',
}

/** Describes the type of the attribute */
export enum AnkorstoreInternalAttributeResourceAttributeTypeEnum {
  SingleSelect = 'single-select',
  MultiSelect = 'multi-select',
}

/** Describes the requirement level for the attribute */
export enum AnkorstoreInternalAttributeResourceRequirementEnum {
  Mandatory = 'mandatory',
  Recommended = 'recommended',
  Optional = 'optional',
}

/** Format: AKS_{GEOGRAPHICAL-CLUSTER}_{LAST-MILE-CARRIER} */
export enum AnkorstoreInternalLabelCreationServiceEnum {
  AKS_PAR_COG = 'AKS_PAR_COG',
  AKS_PAR_AKS = 'AKS_PAR_AKS',
}

export enum AnkorstoreInternalLabelFormatEnum {
  ZPL = 'ZPL',
}

export enum AnkorstoreInternalLabelEncodingEnum {
  Base64 = 'base64',
}

export enum AnkorstoreInternalLabelResourceFormatEnum {
  ZPL = 'ZPL',
}

export enum AnkorstoreInternalLabelResourceEncodingEnum {
  Base64 = 'base64',
}

export enum AnkorstoreInternalShippingServiceCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

/** Shipment segment to which the surcharge applies. */
export enum AnkorstoreInternalShippingServiceScopeEnum {
  Origin = 'origin',
  Destination = 'destination',
}

/** Business code identifying the surcharge type. */
export enum AnkorstoreInternalShippingServiceCodeEnum {
  EXTENDED_AREA = 'EXTENDED_AREA',
  REMOTE_AREA = 'REMOTE_AREA',
}

export enum AnkorstoreInternalShippingServiceResourceCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

/** Shipment segment to which the surcharge applies. */
export enum AnkorstoreInternalShippingServiceResourceScopeEnum {
  Origin = 'origin',
  Destination = 'destination',
}

/** Business code identifying the surcharge type. */
export enum AnkorstoreInternalShippingServiceResourceCodeEnum {
  EXTENDED_AREA = 'EXTENDED_AREA',
  REMOTE_AREA = 'REMOTE_AREA',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationLinkTargetEnum {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemTargetEnum {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemTargetEnum1 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemTargetEnum2 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemTargetEnum3 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemGroupTargetEnum {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemGroupTargetEnum1 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemGroupTargetEnum2 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationItemGroupTargetEnum3 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum1 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum2 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum3 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum4 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum5 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum6 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum AnkorstoreInternalNavigationElementTargetEnum7 {
  Self = 'self',
  Blank = 'blank',
}

export enum AnkorstoreInternalSearchParamsTypeEnum {
  SearchParams = 'search-params',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalSearchParamsTypeEnum1 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalSearchParamsTypeEnum2 {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalSearchParamsTypeEnum3 {
  Boolean = 'boolean',
}

export enum AnkorstoreInternalSearchParamsSortEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/**
 * Type of facet.
 *
 * A value facet provides the counts of each value for an attribute.
 * This type of facet is only available on **text**, **number** and **date** attributes.
 */
export enum AnkorstoreInternalSearchValueFacetTypeEnum {
  Value = 'value',
}

/**
 * Type of facet.
 *
 * A range facet returns counts of documents within the provided ranges.
 * This type of facet is only available on **number** and **date** attributes.
 */
export enum AnkorstoreInternalSearchRangeFacetTypeEnum {
  Range = 'range',
}

/**
 * Type of facet.
 *
 * Stats (also called *aggregation* or *analytic*) facets compute stats over
 * numeric values extracted from the aggregated results. This type of facet
 * is only available on **number** attributes.
 */
export enum AnkorstoreInternalSearchStatsFacetTypeEnum {
  Stats = 'stats',
}

/**
 * Type of facet.
 *
 * A value facet provides the counts of each value for an attribute.
 * This type of facet is only available on **text**, **number** and **date** attributes.
 */
export enum AnkorstoreInternalSearchFacetTypeEnum {
  Value = 'value',
}

/**
 * Type of facet.
 *
 * A range facet returns counts of documents within the provided ranges.
 * This type of facet is only available on **number** and **date** attributes.
 */
export enum AnkorstoreInternalSearchFacetTypeEnum1 {
  Range = 'range',
}

/**
 * Type of facet.
 *
 * Stats (also called *aggregation* or *analytic*) facets compute stats over
 * numeric values extracted from the aggregated results. This type of facet
 * is only available on **number** attributes.
 */
export enum AnkorstoreInternalSearchFacetTypeEnum2 {
  Stats = 'stats',
}

/**
 * Type of facet.
 *
 * A value facet provides the counts of each value for an attribute.
 * This type of facet is only available on **text**, **number** and **date** attributes.
 */
export enum AnkorstoreInternalSearchResponseTypeEnum {
  Value = 'value',
}

/**
 * Type of facet.
 *
 * A range facet returns counts of documents within the provided ranges.
 * This type of facet is only available on **number** and **date** attributes.
 */
export enum AnkorstoreInternalSearchResponseTypeEnum1 {
  Range = 'range',
}

/**
 * Type of facet.
 *
 * Stats (also called *aggregation* or *analytic*) facets compute stats over
 * numeric values extracted from the aggregated results. This type of facet
 * is only available on **number** attributes.
 */
export enum AnkorstoreInternalSearchResponseTypeEnum2 {
  Stats = 'stats',
}

export enum AnkorstoreInternalContactDocumentTypeEnum {
  ContactDocument = 'contact-document',
}

/** Status of the relationship with this contact. */
export enum AnkorstoreInternalContactDocumentStatusEnum {
  Prospect = 'prospect',
  Customer = 'customer',
}

/** Origin of the contact. */
export enum AnkorstoreInternalContactDocumentOriginEnum {
  Ankorstore = 'ankorstore',
  Imported = 'imported',
}

/** The contact's ordering activity signal. */
export enum AnkorstoreInternalContactDocumentActivitySignalEnum {
  High = 'high',
  Low = 'low',
  Inactive = 'inactive',
}

/** Who's the sender of the last sent message. */
export enum AnkorstoreInternalContactDocumentLastMessageByEnum {
  Retailer = 'retailer',
  Brand = 'brand',
}

/**
 * Indicates the level of consent this contact has given
 * to receive email marketing campaigns.
 *
 * - **Subscribed** — A subscribed contact, or subscriber,
 * is someone who has opted in to receive marketing messages.
 *
 * - **Unsubscribed** — An unsubscribed contact is someone who
 * previously received marketing messages but has opted out.
 *
 * - **Suppressed** — A suppressed contact is someone who is
 * on the suppression list and thus is excluded from receiving
 * marketing messages. Contacts may be added to the suppression
 * list for various reasons, including if they have complained
 * about receiving emails (they marked emails as spam)
 * or if their email address bounced or is invalid.
 */
export enum AnkorstoreInternalContactDocumentSubscriptionStatusEnum {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
  Suppressed = 'suppressed',
}

export enum AnkorstoreInternalMultiSearchParamsTypeEnum {
  SearchParams = 'search-params',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum AnkorstoreInternalMultiSearchParamsTypeEnum1 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum AnkorstoreInternalMultiSearchParamsTypeEnum2 {
  Range = 'range',
}

/** The type of filter. */
export enum AnkorstoreInternalMultiSearchParamsTypeEnum3 {
  Boolean = 'boolean',
}

export enum AnkorstoreInternalMultiSearchParamsSortEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export enum AnkorstoreInternalSearchRangeWidgetTypeEnum {
  Widget = 'widget',
}

/**
 * The `Range` widget allows a user to select a numeric range
 * using a minimum and maximum input.
 */
export enum AnkorstoreInternalSearchRangeWidgetTypeEnum1 {
  RangeWidget = 'range-widget',
}

export enum AnkorstoreInternalSearchToggleWidgetTypeEnum {
  Widget = 'widget',
}

/**
 * The `Toggle` widget provides an on/off filtering feature
 * based on an attribute value.
 */
export enum AnkorstoreInternalSearchToggleWidgetTypeEnum1 {
  ToggleWidget = 'toggle-widget',
}

export enum AnkorstoreInternalSearchDropdownWidgetTypeEnum {
  Widget = 'widget',
}

/**
 * The `Dropdown` widget allows a user to select values upon which
 * to filter inside a dropdown element.
 */
export enum AnkorstoreInternalSearchDropdownWidgetTypeEnum1 {
  DropdownWidget = 'dropdown-widget',
}

export enum AnkorstoreInternalSearchListWidgetTypeEnum {
  Widget = 'widget',
}

/**
 * The `List` widget displays a menu that lets users choose one
 * or multiple values for a specific attribute.
 */
export enum AnkorstoreInternalSearchListWidgetTypeEnum1 {
  ListWidget = 'list-widget',
}

export enum AnkorstoreInternalSearchDateRangeWidgetTypeEnum {
  Widget = 'widget',
}

/**
 * The `DateRange` widget allows a user to select a date range
 * using a start and end date input.
 */
export enum AnkorstoreInternalSearchDateRangeWidgetTypeEnum1 {
  DateRangeWidget = 'date-range-widget',
}

export enum AnkorstoreInternalSearchFilterWidgetTypeEnum {
  Widget = 'widget',
}

/**
 * The `Range` widget allows a user to select a numeric range
 * using a minimum and maximum input.
 */
export enum AnkorstoreInternalSearchFilterWidgetTypeEnum1 {
  RangeWidget = 'range-widget',
}

export enum AnkorstoreInternalSearchFilterWidgetTypeEnum2 {
  Widget = 'widget',
}

/**
 * The `Toggle` widget provides an on/off filtering feature
 * based on an attribute value.
 */
export enum AnkorstoreInternalSearchFilterWidgetTypeEnum3 {
  ToggleWidget = 'toggle-widget',
}

export enum AnkorstoreInternalSearchFilterWidgetTypeEnum4 {
  Widget = 'widget',
}

/**
 * The `Dropdown` widget allows a user to select values upon which
 * to filter inside a dropdown element.
 */
export enum AnkorstoreInternalSearchFilterWidgetTypeEnum5 {
  DropdownWidget = 'dropdown-widget',
}

export enum AnkorstoreInternalSearchFilterWidgetTypeEnum6 {
  Widget = 'widget',
}

/**
 * The `List` widget displays a menu that lets users choose one
 * or multiple values for a specific attribute.
 */
export enum AnkorstoreInternalSearchFilterWidgetTypeEnum7 {
  ListWidget = 'list-widget',
}

export enum AnkorstoreInternalSearchFilterWidgetTypeEnum8 {
  Widget = 'widget',
}

/**
 * The `DateRange` widget allows a user to select a date range
 * using a start and end date input.
 */
export enum AnkorstoreInternalSearchFilterWidgetTypeEnum9 {
  DateRangeWidget = 'date-range-widget',
}

/** The offer type */
export enum AnkorstoreInternalBrandOfferResourceTypeEnum {
  Discount = 'discount',
  Promocode = 'promocode',
}

export enum AnkorstoreInternalConnectedHomepageConfigurationResourceSegmentSlugEnum {
  AksplusEligibleNonMembers = 'aksplus-eligible-non-members',
  AksplusEligibleMembers = 'aksplus-eligible-members',
  NewRetailers = 'new-retailers',
  Default = 'default',
}

export enum AnkorstoreInternalLoyaltyOfferBrandListResourceStatusEnum {
  Unlocked = 'unlocked',
  Locked = 'locked',
  Unlocking = 'unlocking',
  NotStarted = 'not-started',
}

/**
 * The status of the credit limit information
 * @example "ok"
 */
export enum AnkorstoreInternalHeaderPillsAttributesStatusEnum {
  Ok = 'ok',
  Incomplete = 'incomplete',
  Frozen = 'frozen',
  Refused = 'refused',
}

/**
 * The status of the credit limit information
 * @example "ok"
 */
export enum AnkorstoreInternalHeaderPillsResourceStatusEnum {
  Ok = 'ok',
  Incomplete = 'incomplete',
  Frozen = 'frozen',
  Refused = 'refused',
}

/** The kind of source. */
export enum AnkorstoreInternalPriceReportFieldsTypeEnum {
  Direct = 'direct',
  OtherMarketplace = 'other_marketplace',
  BrandWebsite = 'brand_website',
  Tradeshow = 'tradeshow',
  Other = 'other',
}

/** Whether the reported price is a promotional price. */
export enum AnkorstoreInternalPriceReportFieldsPromotionEnum {
  Yes = 'yes',
  No = 'no',
}

export enum AnkorstoreInternalIssueResourceTypeEnum {
  PricingIssues = 'pricing-issues',
}

export enum AnkorstoreInternalIssueResourceTypeEnum1 {
  PublicPriceReport = 'public_price_report',
  PrivatePriceReport = 'private_price_report',
}

/** The kind of source. */
export enum AnkorstoreInternalIssueResourceTypeEnum2 {
  Direct = 'direct',
  OtherMarketplace = 'other_marketplace',
  BrandWebsite = 'brand_website',
  Tradeshow = 'tradeshow',
  Other = 'other',
}

/** Whether the reported price is a promotional price. */
export enum AnkorstoreInternalIssueResourcePromotionEnum {
  Yes = 'yes',
  No = 'no',
}

export enum AnkorstoreInternalSchemasOrderItemStateEnum {
  Confirmable = 'confirmable',
  Active = 'active',
}

/** Present only when state is active */
export enum AnkorstoreInternalSchemasOrderItemStatusEnum {
  AwaitingBrandConfirmation = 'awaiting_brand_confirmation',
  Validated = 'validated',
  InPreparation = 'in_preparation',
  Shipped = 'shipped',
}

export enum AnkorstoreInternalOrdersCardStateEnum {
  Confirmable = 'confirmable',
  Active = 'active',
}

/** Present only when state is active */
export enum AnkorstoreInternalOrdersCardStatusEnum {
  AwaitingBrandConfirmation = 'awaiting_brand_confirmation',
  Validated = 'validated',
  InPreparation = 'in_preparation',
  Shipped = 'shipped',
}

/** Global order state when no items are returned. null when items contains an entry. */
export enum AnkorstoreInternalOrdersCardStateEnum1 {
  NeverOrdered = 'never_ordered',
  Idle = 'idle',
}

export enum AnkorstoreInternalPaymentCardStateEnum {
  Failed = 'failed',
  UpcomingDebit = 'upcoming_debit',
  IncomingCredit = 'incoming_credit',
  BnplNudge = 'bnpl_nudge',
}

export enum AnkorstoreInternalYourBrandsCardStateEnum {
  FollowAsk = 'follow_ask',
  News = 'news',
  NoBrands = 'no_brands',
}

export enum AnkorstoreInternalDontMissCardVariantEnum {
  Onboarding = 'onboarding',
  Campaign = 'campaign',
}

export enum AnkorstoreInternalRetailerDashboardStateEnum {
  Confirmable = 'confirmable',
  Active = 'active',
}

/** Present only when state is active */
export enum AnkorstoreInternalRetailerDashboardStatusEnum {
  AwaitingBrandConfirmation = 'awaiting_brand_confirmation',
  Validated = 'validated',
  InPreparation = 'in_preparation',
  Shipped = 'shipped',
}

/** Global order state when no items are returned. null when items contains an entry. */
export enum AnkorstoreInternalRetailerDashboardStateEnum1 {
  NeverOrdered = 'never_ordered',
  Idle = 'idle',
}

export enum AnkorstoreInternalRetailerDashboardStateEnum2 {
  Failed = 'failed',
  UpcomingDebit = 'upcoming_debit',
  IncomingCredit = 'incoming_credit',
  BnplNudge = 'bnpl_nudge',
}

export enum AnkorstoreInternalRetailerDashboardStateEnum3 {
  FollowAsk = 'follow_ask',
  News = 'news',
  NoBrands = 'no_brands',
}

export enum AnkorstoreInternalRetailerDashboardVariantEnum {
  Onboarding = 'onboarding',
  Campaign = 'campaign',
}

/** @example "ankor_confirmed" */
export enum AnkorstoreOrderStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum AnkorstoreOrderShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum AnkorstoreOrderAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum AnkorstoreOrderProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum AnkorstoreOrderProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum AnkorstoreOrderRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum AnkorstoreOrderTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum AnkorstoreOrderDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreOrderMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum AnkorstoreBillingItemTypeEnum {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreProductVariantInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreProductVariantCollectionInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order this variant for which stock is not
 * available. `deny` (default) rejects any quantity larger than the
 * available stock quantity; `continue` lets the retailer order any
 * quantity, even when stock is insufficient or the variant is out
 * of stock. Only valid alongside a tracked stock update (this
 * schema). Omit to preserve the variant's current policy.
 * @default "deny"
 */
export enum AnkorstoreProductVariantStockUpdateSetStockQuantityInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order this variant for which stock is not
 * available. Only `deny` is accepted in combination with
 * `isAlwaysInStock=true`: an always-in-stock variant has no stock
 * tracking, so the policy is irrelevant and `continue` cannot be
 * set. Use the `stockQuantity` form of this endpoint to set
 * `continue`.
 * @default "deny"
 */
export enum AnkorstoreProductVariantStockUpdateSetIsAlwaysInStockInventoryPolicyEnum {
  Deny = 'deny',
}

export enum AnkorstoreUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

/** Resource type. */
export enum AnkorstoreOperationTypeEnum {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum AnkorstoreOperationSourceEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum AnkorstoreOperationStatusEnum {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum AnkorstoreOperationOperationTypeEnum {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum AnkorstoreOperationUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

/** Resource type. */
export enum AnkorstoreCallbackEventTypeEnum {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum AnkorstoreCallbackEventSourceEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum AnkorstoreCallbackEventStatusEnum {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum AnkorstoreCallbackEventOperationTypeEnum {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum AnkorstoreCallbackEventUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

/** Name of the property */
export enum AnkorstoreOperationProductVariantOptionSchemaNameEnum {
  Color = 'color',
  Size = 'size',
  Material = 'material',
  Style = 'style',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger
 *
 *
 *   than the currently available stock quantity, so the variant cannot
 *   be ordered when it is out of stock, or when the desired quantity
 *   exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when
 *
 *
 *   stock is insufficient (desired quantity > available quantity > 0)
 *   or the variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`is_always_in_stock = false`).
 * Omit to inherit the variant's current policy (or `deny` for new
 * variants).
 * @default "deny"
 */
export enum AnkorstoreOperationProductVariantSchemaInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Name of the property */
export enum AnkorstoreOperationProductVariantSchemaNameEnum {
  Color = 'color',
  Size = 'size',
  Material = 'material',
  Style = 'style',
}

/** Currency used in pricing */
export enum AnkorstoreOperationProductSchemaCurrencyEnum {
  GBP = 'GBP',
  EUR = 'EUR',
  SEK = 'SEK',
}

export enum AnkorstoreOperationProductSchemaStorageTemperatureEnum {
  Controlled = 'controlled',
  Fresh = 'fresh',
  Frozen = 'frozen',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger
 *
 *
 *   than the currently available stock quantity, so the variant cannot
 *   be ordered when it is out of stock, or when the desired quantity
 *   exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when
 *
 *
 *   stock is insufficient (desired quantity > available quantity > 0)
 *   or the variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`is_always_in_stock = false`).
 * Omit to inherit the variant's current policy (or `deny` for new
 * variants).
 * @default "deny"
 */
export enum AnkorstoreOperationProductSchemaInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Name of the property */
export enum AnkorstoreOperationProductSchemaNameEnum {
  Color = 'color',
  Size = 'size',
  Material = 'material',
  Style = 'style',
}

/** Reason of the validation failure */
export enum AnkorstoreOperationIssueReasonEnum {
  RequiredField = 'required_field',
  InvalidField = 'invalid_field',
  InvalidImage = 'invalid_image',
  InternalError = 'internal_error',
}

/** The operation execution result for this product */
export enum AnkorstoreOperationResultStatusEnum {
  Success = 'success',
  Failure = 'failure',
}

/** Reason of the validation failure */
export enum AnkorstoreOperationResultReasonEnum {
  RequiredField = 'required_field',
  InvalidField = 'invalid_field',
  InvalidImage = 'invalid_image',
  InternalError = 'internal_error',
}

/** The operation execution result for this product */
export enum AnkorstoreOperationReportSchemaStatusEnum {
  Success = 'success',
  Failure = 'failure',
}

/** Reason of the validation failure */
export enum AnkorstoreOperationReportSchemaReasonEnum {
  RequiredField = 'required_field',
  InvalidField = 'invalid_field',
  InvalidImage = 'invalid_image',
  InternalError = 'internal_error',
}

/** Lifecycle status of the error report. */
export enum AnkorstoreErrorReportStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

/** Lifecycle status of the error report. */
export enum AnkorstoreErrorReportResourceStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export enum AnkorstoreExternalIntegrationPlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum AnkorstoreExternalIntegrationStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum AnkorstoreExternalIntegrationResourcePlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum AnkorstoreExternalIntegrationResourceStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum AnkorstoreBrandResourceAutomationModeEnum {
  AutomaticBrandControl = 'automatic-brand_control',
  AutomaticConfirmAndRequestFulfillment = 'automatic-confirm-and-request-fulfillment',
}

/** Location that is used as authoritative for marketplace stock */
export enum AnkorstoreBrandResourceMarketplaceStockLocationEnum {
  Brand = 'brand',
  Warehouse = 'warehouse',
}

export enum AnkorstoreBrandContactResourcePurposesEnum {
  Finance = 'finance',
}

/** Order type (only present for order_payment transfers) */
export enum AnkorstoreTransferSourceTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstoreTransferTypeEnum {
  OrderPayment = 'order_payment',
  Refund = 'refund',
}

/** Order type (only present for order_payment transfers) */
export enum AnkorstoreTransferTypeEnum1 {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstorePayoutAttributesStatusEnum {
  Pending = 'pending',
  Paid = 'paid',
  Failed = 'failed',
  Canceled = 'canceled',
  InTransit = 'in_transit',
  TransferToCome = 'transfer_to_come',
}

export enum AnkorstorePayoutAttributesTypeEnum {
  OrderPayment = 'order_payment',
  Refund = 'refund',
}

/** Order type (only present for order_payment transfers) */
export enum AnkorstorePayoutAttributesTypeEnum1 {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstorePayoutTypeEnum {
  Payouts = 'payouts',
}

export enum AnkorstorePayoutStatusEnum {
  Pending = 'pending',
  Paid = 'paid',
  Failed = 'failed',
  Canceled = 'canceled',
  InTransit = 'in_transit',
  TransferToCome = 'transfer_to_come',
}

export enum AnkorstorePayoutTypeEnum1 {
  OrderPayment = 'order_payment',
  Refund = 'refund',
}

/** Order type (only present for order_payment transfers) */
export enum AnkorstorePayoutTypeEnum2 {
  Internal = 'internal',
  External = 'external',
}

export enum AnkorstorePayoutCollectionTypeEnum {
  Payouts = 'payouts',
}

export enum AnkorstorePayoutCollectionStatusEnum {
  Pending = 'pending',
  Paid = 'paid',
  Failed = 'failed',
  Canceled = 'canceled',
  InTransit = 'in_transit',
  TransferToCome = 'transfer_to_come',
}

export enum AnkorstorePayoutCollectionTypeEnum1 {
  OrderPayment = 'order_payment',
  Refund = 'refund',
}

/** Order type (only present for order_payment transfers) */
export enum AnkorstorePayoutCollectionTypeEnum2 {
  Internal = 'internal',
  External = 'external',
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum AnkorstorePromoCodeStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum AnkorstorePromoCodeIndexStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

export enum AnkorstorePromoCodeMoneyInputCurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum AnkorstorePromoCodeBenefitInputCurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum AnkorstorePromoCodeStoreCurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum AnkorstorePromoCodeStoreCurrencyEnum1 {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum AnkorstorePromoCodeGetStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

export enum AnkorstorePromoCodeUpdateCurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum AnkorstorePromoCodeUpdateCurrencyEnum1 {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum AnkorstoreBillingExportTypeEnum {
  Invoicing = 'invoicing',
  Accounting = 'accounting',
}

export enum AnkorstoreBillingExportStatusEnum {
  Created = 'created',
  InProcess = 'in_process',
  Completed = 'completed',
  PartiallyCompleted = 'partially_completed',
  Failed = 'failed',
}

export enum AnkorstoreBillingExportResourceTypeEnum {
  Invoicing = 'invoicing',
  Accounting = 'accounting',
}

export enum AnkorstoreBillingExportResourceStatusEnum {
  Created = 'created',
  InProcess = 'in_process',
  Completed = 'completed',
  PartiallyCompleted = 'partially_completed',
  Failed = 'failed',
}

/** The current status of the order/parcel */
export enum AnkorstoreShippingLabelCurrentStatusStatusEnum {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The unit of distance */
export enum AnkorstoreShippingLabelParcelWithTrackedPackageDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreShippingLabelParcelWithTrackedPackageMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreShippingLabelParcelWithTrackedPackageStatusEnum {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export enum AnkorstoreOrderShippingOverviewAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum AnkorstoreOrderShippingOverviewProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum AnkorstoreOrderShippingOverviewProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum AnkorstoreOrderShippingOverviewRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum AnkorstoreOrderShippingOverviewTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum AnkorstoreOrderShippingOverviewDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreOrderShippingOverviewMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderShippingOverviewStatusEnum {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderShippingOverviewStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** @example "ankor_confirmed" */
export enum AnkorstoreMasterOrderListStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum AnkorstoreMasterOrderListShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum AnkorstoreMasterOrderListAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum AnkorstoreMasterOrderListProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum AnkorstoreMasterOrderListProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum AnkorstoreMasterOrderListRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum AnkorstoreMasterOrderListTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum AnkorstoreMasterOrderListDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreMasterOrderListMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreMasterOrderListStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum AnkorstoreMasterOrderListStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** @example "ankor_confirmed" */
export enum AnkorstoreMasterOrderGetStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum AnkorstoreMasterOrderGetShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum AnkorstoreMasterOrderGetAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum AnkorstoreMasterOrderGetProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum AnkorstoreMasterOrderGetProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum AnkorstoreMasterOrderGetRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum AnkorstoreMasterOrderGetTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum AnkorstoreMasterOrderGetDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreMasterOrderGetMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreMasterOrderGetStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum AnkorstoreMasterOrderGetStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export enum AnkorstorePackingInstructionServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreInstructionsServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreFulfillmentOrderStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreFulfillmentOrderRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreFulfillmentOrderServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreFulfillmentOrderResourceStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum AnkorstoreFulfillmentOrderResourceRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum AnkorstoreFulfillmentOrderResourceServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum AnkorstoreFulfillmentOrderStatusUpdateStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

export enum AnkorstoreFulfillmentOrderStatusUpdateResourceStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

export enum AnkorstoreQuoteResourceCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

/** @example "ankor_confirmed" */
export enum AnkorstoreOrderCollectionStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum AnkorstoreOrderCollectionShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum AnkorstoreOrderCollectionAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum AnkorstoreOrderCollectionProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum AnkorstoreOrderCollectionProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum AnkorstoreOrderCollectionRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum AnkorstoreOrderCollectionTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum AnkorstoreOrderCollectionDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreOrderCollectionMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderCollectionStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderCollectionStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum AnkorstoreOrderCollectionTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreOrderCollectionInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** @example "ankor_confirmed" */
export enum AnkorstoreOrderGetStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum AnkorstoreOrderGetShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum AnkorstoreOrderGetAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum AnkorstoreOrderGetProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum AnkorstoreOrderGetProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum AnkorstoreOrderGetRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum AnkorstoreOrderGetTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum AnkorstoreOrderGetDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum AnkorstoreOrderGetMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderGetStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum AnkorstoreOrderGetStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum AnkorstoreOrderGetTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum AnkorstoreOrderGetInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum AnkorstoreSchemasPackingInstructionServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
  SSCC = 'SSCC',
}

/** The type of item. */
export enum AnkorstoreSchemaTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

/** @example "fulfillment" */
export enum AnkorstoreSchemaShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

export enum AnkorstoreSchemaServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
  SSCC = 'SSCC',
}

/** The type of item. */
export enum AnkorstoreOrderPayCustomItemTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

/** The type of item. */
export enum AnkorstoreOrderResourceTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum AnkorstoreOrderResourceStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum AnkorstoreOrderResourceShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum AnkorstorePaymentResourcePspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum AnkorstorePaymentResourceStatusEnum {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum AnkorstorePaymentResourcePaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

/** The type of item. */
export enum AnkorstoreOrderSchemaTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum AnkorstoreOrderSchemaStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum AnkorstoreOrderSchemaShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum AnkorstoreOrderSchemaPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum AnkorstoreOrderSchemaStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum AnkorstoreOrderSchemaPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export enum AnkorstoreListShippingQuotesResponseCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum AnkorstoreFulfillmentItemStatusEnum {
  Created = 'created',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
  Synced = 'synced',
}

export enum AnkorstoreFulfillmentItemResourceStatusEnum {
  Created = 'created',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
  Synced = 'synced',
}

/** Type of package, used to route to the parcel or pallet pricing grid. When omitted, it is estimated from the parcel dimensions. */
export enum AnkorstoreFulfillmentParcelSpecificationPackageTypeEnum {
  Parcel = 'parcel',
  Pallet = 'pallet',
}

export enum AnkorstoreFulfillmentOrderCostsSpecificationTypeEnum {
  FulfillmentOrderCostsSpecification = 'fulfillment-order-costs-specification',
}

/** Type of package, used to route to the parcel or pallet pricing grid. When omitted, it is estimated from the parcel dimensions. */
export enum AnkorstoreFulfillmentOrderCostsSpecificationPackageTypeEnum {
  Parcel = 'parcel',
  Pallet = 'pallet',
}

export enum AnkorstoreFulfillmentOrderCostCategoryEnum {
  Shipping = 'shipping',
  OrderPickLt4U = 'order pick lt 4u',
  OrderPickLt40U = 'order pick lt 40u',
  OrderPickGt40U = 'order pick gt 40u',
  UnitPickLt4U = 'unit pick lt 4u',
  UnitPickLt40U = 'unit pick lt 40u',
  UnitPickGt40U = 'unit pick gt 40u',
}

export enum AnkorstoreFulfillmentOrderCostResourceCategoryEnum {
  Shipping = 'shipping',
  OrderPickLt4U = 'order pick lt 4u',
  OrderPickLt40U = 'order pick lt 40u',
  OrderPickGt40U = 'order pick gt 40u',
  UnitPickLt4U = 'unit pick lt 4u',
  UnitPickLt40U = 'unit pick lt 40u',
  UnitPickGt40U = 'unit pick gt 40u',
}

export enum AnkorstoreReplenishmentItemStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentBaseShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum AnkorstoreReplenishmentBaseStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentReceiptStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum AnkorstoreReplenishmentStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentStatusEnum1 {
  Created = 'created',
  Sent = 'sent',
  Received = 'received',
  Confirmed = 'confirmed',
  Delivered = 'delivered',
}

export enum AnkorstoreReplenishmentStatusEnum2 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentResourceShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum AnkorstoreReplenishmentResourceStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentResourceStatusEnum1 {
  Created = 'created',
  Sent = 'sent',
  Received = 'received',
  Confirmed = 'confirmed',
  Delivered = 'delivered',
}

export enum AnkorstoreReplenishmentResourceStatusEnum2 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreReplenishmentInputShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum AnkorstoreReplenishmentInputStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreUpdateReplenishmentRequestShipmentTypeEnum {
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum AnkorstoreUpdateReplenishmentRequestStatusEnum {
  Sent = 'sent',
}

export enum AnkorstoreUpdateReplenishmentRequestStatusEnum1 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum AnkorstoreApplicationWebhookSubscriptionResourceEventsEnum {
  OrderBrandCreated = 'order.brand_created',
  OrderBrandAccepted = 'order.brand_accepted',
  OrderBrandRejected = 'order.brand_rejected',
  OrderShippingLabelsGenerated = 'order.shipping_labels_generated',
  OrderShipped = 'order.shipped',
  OrderShipmentReceived = 'order.shipment_received',
  OrderShipmentRefused = 'order.shipment_refused',
  OrderBrandPaid = 'order.brand_paid',
  OrderCancelled = 'order.cancelled',
}

export enum GetBrandDiscoverySelectionFeedbackEnum {
  Liked = 'liked',
  Disliked = 'disliked',
  Skipped = 'skipped',
}

export interface GetBrandDiscoverySelectionData {
  data: {
    type: 'brand-discovery-selection';
    /** @format uuid */
    id: string;
    attributes: {
      /** @format date */
      week: string;
      /** @format date */
      next_selection_date: string;
      status: {
        completed: boolean;
        counts: {
          liked: number;
          disliked: number;
          skipped: number;
        };
      };
    };
    relationships: {
      brands: {
        data: {
          type: 'brand';
          /** @format uuid */
          id: string;
        }[];
      };
    };
  };
  included: (
    | {
        type: 'brand';
        /** @format uuid */
        id: string;
        attributes: {
          brand_id: number;
          feedback: GetBrandDiscoverySelectionFeedbackEnum;
          name: string;
          link: string;
          /** @format uri */
          logo_url: string;
          story: string;
          display_address: {
            city: string;
            country: string;
            region: string;
            postal_code: string;
          };
          made_in: string[];
          minimum?: {
            /** Amount in cents */
            amount: number;
            /** @example "EUR" */
            currency: string;
          } | null;
          estimated_delivery: {
            minDays?: number | null;
            maxDays?: number | null;
          };
          instagram_username?: string | null;
          product_count: number;
          has_product_collection: boolean;
        };
        relationships: {
          products: {
            data: {
              type: 'product';
              /** @format uuid */
              id: string;
            }[];
          };
        };
      }
    | {
        type: 'product';
        /** @format uuid */
        id: string;
        attributes: {
          title: string;
          link: string;
          /** @format uri */
          image: string;
          wholesale_price: {
            /** Amount in cents */
            amount: number;
            /** @example "EUR" */
            currency: string;
          };
          discount_rate: number;
        };
      }
  )[];
}

/** The retailer's feedback for this brand */
export enum SubmitBrandDiscoveryFeedbackStatusEnum {
  Liked = 'liked',
  Disliked = 'disliked',
  Skipped = 'skipped',
}

export type SubmitBrandDiscoveryFeedbackData = any;

export interface ListApplicationsInternalData {
  /**
   * ApplicationResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"applications","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"}}
   */
  data: {
    type: 'applications';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Custom application name (should be unique within user applications) */
      name: string;
      /**
       * Email of the developer to contact in context of any issues with this application
       * @format email
       * @example "developer@application.com"
       */
      developerEmail: string;
      /** Client ID to be used for access token issuance */
      clientId: string;
      /** Secret to be used for access token issuance. Can be invoked only once, when application is created or credentials re-generated. */
      clientSecret: string | null;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      webhookSubscriptions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`. */
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /** @uniqueItems true */
      events: string[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"applications","id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"},"relationships":{"webhookSubscriptions":{"data":[{"id":"efbfbdef-bfbd-1eef-bfbd-efbfbdefbfbd","type":"webhook-subscription"}]}}},"included":[{"id":"efbfbdef-bfbd-1eef-bfbd-efbfbdefbfbd","type":"webhook-subscription","attributes":{"webhookUrl":"https://my-app.com/webhook-listener","signingSecret":"some-secret","events":["orders.brand_created","orders.brand_accepted","orders.brand_rejected","orders.shipped"]}}]} */
export interface CreateApplicationData {
  /**
   * ApplicationResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"applications","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"}}
   */
  data: {
    type: 'applications';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Custom application name (should be unique within user applications) */
      name: string;
      /**
       * Email of the developer to contact in context of any issues with this application
       * @format email
       * @example "developer@application.com"
       */
      developerEmail: string;
      /** Client ID to be used for access token issuance */
      clientId: string;
      /** Secret to be used for access token issuance. Can be invoked only once, when application is created or credentials re-generated. */
      clientSecret: string | null;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      webhookSubscriptions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`. */
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /** @uniqueItems true */
      events: string[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"applications","id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"},"relationships":{"webhookSubscriptions":{"data":[{"id":"efbfbdef-bfbd-1eef-bfbd-efbfbdefbfbd","type":"webhook-subscription"}]}}},"included":[{"id":"efbfbdef-bfbd-1eef-bfbd-efbfbdefbfbd","type":"webhook-subscription","attributes":{"webhookUrl":"https://my-app.com/webhook-listener","signingSecret":"some-secret","events":["orders.brand_created","orders.brand_accepted","orders.brand_rejected","orders.shipped"]}}]} */
export interface UpdateApplicationData {
  /**
   * ApplicationResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"applications","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"}}
   */
  data: {
    type: 'applications';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Custom application name (should be unique within user applications) */
      name: string;
      /**
       * Email of the developer to contact in context of any issues with this application
       * @format email
       * @example "developer@application.com"
       */
      developerEmail: string;
      /** Client ID to be used for access token issuance */
      clientId: string;
      /** Secret to be used for access token issuance. Can be invoked only once, when application is created or credentials re-generated. */
      clientSecret: string | null;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      webhookSubscriptions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`. */
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /** @uniqueItems true */
      events: string[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export type DeleteApplicationData = any;

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"applications","id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"},"relationships":{"webhookSubscriptions":{"data":[{"id":"efbfbdef-bfbd-1eef-bfbd-efbfbdefbfbd","type":"webhook-subscription"}]}}},"included":[{"id":"efbfbdef-bfbd-1eef-bfbd-efbfbdefbfbd","type":"webhook-subscription","attributes":{"webhookUrl":"https://my-app.com/webhook-listener","signingSecret":"some-secret","events":["orders.brand_created","orders.brand_accepted","orders.brand_rejected","orders.shipped"]}}]} */
export interface RegenerateCredentialsData {
  /**
   * ApplicationResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"applications","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":"v8s98g9s895h8929834"}}
   */
  data: {
    type: 'applications';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Custom application name (should be unique within user applications) */
      name: string;
      /**
       * Email of the developer to contact in context of any issues with this application
       * @format email
       * @example "developer@application.com"
       */
      developerEmail: string;
      /** Client ID to be used for access token issuance */
      clientId: string;
      /** Secret to be used for access token issuance. Can be invoked only once, when application is created or credentials re-generated. */
      clientSecret: string | null;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      webhookSubscriptions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`. */
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /** @uniqueItems true */
      events: string[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetApiInternalV1BrandsBrandIdTypeEnum {
  Onboarding = 'onboarding',
}

export enum GetApiInternalV1BrandsBrandIdTypeEnum1 {
  FrancoSettingsSummary = 'franco-settings-summary',
}

export enum GetApiInternalV1BrandsBrandIdTypeEnum2 {
  BrandContacts = 'brand-contacts',
}

export enum GetApiInternalV1BrandsBrandIdTypeEnum3 {
  Onboarding = 'onboarding',
}

export enum GetApiInternalV1BrandsBrandIdStatusEnum {
  Completed = 'completed',
  InProgress = 'in_progress',
}

export enum GetApiInternalV1BrandsBrandIdTypeEnum4 {
  FrancoSettingsSummary = 'franco-settings-summary',
}

export enum GetApiInternalV1BrandsBrandIdPurposesEnum {
  Finance = 'finance',
}

export interface GetApiInternalV1BrandsBrandIdParams {
  /** Brand's attributes separated by comma */
  'fields[brands]'?: string;
  /**
   * A comma-separated list of resources to include (e.g: onboarding,brand-contacts)
   * @pattern ^(users|onboarding|franco-settings-summary|brand-contacts)(,(users|onboarding|franco-settings-summary|brand-contacts))*$
   */
  include?: string;
  /** @format uuid */
  brandId: string;
}

export interface GetApiInternalV1BrandsBrandIdData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    type: string;
    attributes: {
      name?: string;
      status?: string;
      isOnHoliday?: boolean;
      /** @format date */
      holidayStartDate?: string;
      /** @format date */
      holidayEndDate?: string;
      /** VAT configuration enforced when ingesting the brand's products. When the brand is VAT-exempt, validation is bypassed (any rate passes) and allowedRates is null. */
      vatConfiguration?: {
        /** When true, VAT validation is bypassed entirely; any rate (or none) is accepted. */
        exempt: boolean;
        /** VAT rates (percentages) a product may carry and still pass ingestion validation. Null when the brand is VAT-exempt. */
        allowedRates: any[] | null;
      };
    };
    relationships?: {
      onboarding?: {
        data: {
          /** @format uuid */
          id: string;
          type: GetApiInternalV1BrandsBrandIdTypeEnum;
        };
      };
      'franco-settings-summary'?: {
        data: {
          /** @format uuid */
          id: string;
          type: GetApiInternalV1BrandsBrandIdTypeEnum1;
        };
      };
      'brand-contacts'?: {
        data: {
          /** @format uuid */
          id: string;
          type: GetApiInternalV1BrandsBrandIdTypeEnum2;
        }[];
      };
    };
  };
  included?: (
    | {
        type: GetApiInternalV1BrandsBrandIdTypeEnum3;
        /** @format uuid */
        id: string;
        attributes: {
          status: GetApiInternalV1BrandsBrandIdStatusEnum;
          steps: {
            name?: string;
            progress?: number;
            isComplete?: boolean;
          }[];
          /** @format date */
          createdAt: string;
          /** @format date */
          completedAt: string | null;
        };
      }
    | {
        type: GetApiInternalV1BrandsBrandIdTypeEnum4;
        /** @format uuid */
        id: string;
        attributes: {
          hasFrancoSettings: boolean;
        };
      }
    | {
        type: 'brand-contacts';
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** @format email */
          email: string;
          /** @minItems 1 */
          purposes: GetApiInternalV1BrandsBrandIdPurposesEnum[];
        };
      }
  )[];
}

export enum PatchApiInternalV1BrandsBrandIdTypeEnum {
  Onboarding = 'onboarding',
}

export enum PatchApiInternalV1BrandsBrandIdTypeEnum1 {
  FrancoSettingsSummary = 'franco-settings-summary',
}

export enum PatchApiInternalV1BrandsBrandIdTypeEnum2 {
  BrandContacts = 'brand-contacts',
}

export enum PatchApiInternalV1BrandsBrandIdTypeEnum3 {
  Onboarding = 'onboarding',
}

export enum PatchApiInternalV1BrandsBrandIdStatusEnum {
  Completed = 'completed',
  InProgress = 'in_progress',
}

export enum PatchApiInternalV1BrandsBrandIdTypeEnum4 {
  FrancoSettingsSummary = 'franco-settings-summary',
}

export enum PatchApiInternalV1BrandsBrandIdPurposesEnum {
  Finance = 'finance',
}

export enum PatchApiInternalV1BrandsBrandIdStatusEnum1 {
  Online = 'online',
  Offline = 'offline',
  ComingSoon = 'coming_soon',
}

export interface PatchApiInternalV1BrandsBrandIdData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    type: string;
    attributes: {
      name?: string;
      status?: string;
      isOnHoliday?: boolean;
      /** @format date */
      holidayStartDate?: string;
      /** @format date */
      holidayEndDate?: string;
      /** VAT configuration enforced when ingesting the brand's products. When the brand is VAT-exempt, validation is bypassed (any rate passes) and allowedRates is null. */
      vatConfiguration?: {
        /** When true, VAT validation is bypassed entirely; any rate (or none) is accepted. */
        exempt: boolean;
        /** VAT rates (percentages) a product may carry and still pass ingestion validation. Null when the brand is VAT-exempt. */
        allowedRates: any[] | null;
      };
    };
    relationships?: {
      onboarding?: {
        data: {
          /** @format uuid */
          id: string;
          type: PatchApiInternalV1BrandsBrandIdTypeEnum;
        };
      };
      'franco-settings-summary'?: {
        data: {
          /** @format uuid */
          id: string;
          type: PatchApiInternalV1BrandsBrandIdTypeEnum1;
        };
      };
      'brand-contacts'?: {
        data: {
          /** @format uuid */
          id: string;
          type: PatchApiInternalV1BrandsBrandIdTypeEnum2;
        }[];
      };
    };
  };
  included?: (
    | {
        type: PatchApiInternalV1BrandsBrandIdTypeEnum3;
        /** @format uuid */
        id: string;
        attributes: {
          status: PatchApiInternalV1BrandsBrandIdStatusEnum;
          steps: {
            name?: string;
            progress?: number;
            isComplete?: boolean;
          }[];
          /** @format date */
          createdAt: string;
          /** @format date */
          completedAt: string | null;
        };
      }
    | {
        type: PatchApiInternalV1BrandsBrandIdTypeEnum4;
        /** @format uuid */
        id: string;
        attributes: {
          hasFrancoSettings: boolean;
        };
      }
    | {
        type: 'brand-contacts';
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** @format email */
          email: string;
          /** @minItems 1 */
          purposes: PatchApiInternalV1BrandsBrandIdPurposesEnum[];
        };
      }
  )[];
}

export interface GetBrandsCompanyData {
  /** CompanyResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      founded_in_year: number;
      company_name: string;
      company_invoice_description: string;
      legal_form?: string;
      city_of_registration?: string;
      tax_number: string | null;
      vat_exemption: boolean;
      vat_number: string | null;
      sole_trader_number: string | null;
      above_intracomm_threshold: boolean;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum UpdateBrandsCompanyTypeEnum {
  Company = 'company',
}

export interface UpdateBrandsCompanyData {
  /** CompanyResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      founded_in_year: number;
      company_name: string;
      company_invoice_description: string;
      legal_form?: string;
      city_of_registration?: string;
      tax_number: string | null;
      vat_exemption: boolean;
      vat_number: string | null;
      sole_trader_number: string | null;
      above_intracomm_threshold: boolean;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetBrandMediaParams {
  /**
   * Filter by original filename.
   * @example "filename"
   */
  'filter[query]'?: string;
  /**
   * The number of resources to return.
   * @max 50
   * @example 50
   */
  'page[limit]'?: number;
  /**
   * The offset of the first resource to return.
   * @example 0
   */
  'page[offset]'?: number;
}

export interface GetBrandMediaData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      originalFilename: string;
      /** @format url */
      url: string;
      /** @format date-time */
      createdAt: string;
    };
  }[];
  meta: {
    /** Offset-based pagination details. */
    page: {
      /** The number of the current page. */
      currentPage?: number;
      /** The number of the last page. */
      lastPage?: number;
      /** The number of resources on a page. */
      perPage?: number;
      /** The total number of resources. */
      total?: number;
      /** The ordinal number of the first resource on the current page. */
      from?: number;
      /** The ordinal number of the last resource on the current page. */
      to?: number;
    };
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** The links to resource pages. A link might be omitted to indicate that it is unavailable. */
  links: {
    /**
     * The link to the first page of resources.
     * @format url
     */
    first?: string;
    /**
     * The link to the previous page of resources.
     * @format url
     */
    prev?: string;
    /**
     * The link to the next page of resources.
     * @format url
     */
    next?: string;
    /**
     * The link to the last page of resources.
     * @format url
     */
    last?: string;
  };
}

export enum UploadMediaTypeEnum {
  MediaUploadResult = 'media-upload-result',
}

/** Error message if the upload failed */
export enum UploadMediaErrorEnum {
  AlreadyExists = 'already_exists',
  GenericError = 'generic_error',
}

export interface UploadMediaData {
  data?: {
    /** File name */
    id?: string;
    type?: UploadMediaTypeEnum;
    attributes?: {
      media?: {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          originalFilename: string;
          /** @format url */
          url: string;
          /** @format date-time */
          createdAt: string;
        };
      };
      /** Error message if the upload failed */
      error?: UploadMediaErrorEnum;
    };
  }[];
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
  };
}

export enum GetVideosTypeEnum {
  Videos = 'videos',
}

/** The context in which the video is displayed */
export enum GetVideosDisplayContextEnum {
  Hero = 'hero',
  Story = 'story',
  Gallery = 'gallery',
}

export interface GetVideosParams {
  /**
   * Filter by brand UUID. If not provided, defaults to the logged-in brand.
   * @format uuid
   */
  'filter[brandUuid]'?: string;
  /** Filter by display context. */
  'filter[displayContext]'?: FilterDisplayContextEnum;
  /** Filter by video filename. */
  'filter[query]'?: string;
  /**
   * The number of resources to return.
   * @max 50
   * @default 5
   */
  'page[limit]'?: number;
  /**
   * The offset of the first resource to return.
   * @default 0
   */
  'page[offset]'?: number;
}

/** Filter by display context. */
export enum FilterDisplayContextEnum {
  Hero = 'hero',
  Story = 'story',
}

export interface GetVideosData {
  data: {
    type: GetVideosTypeEnum;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** The context in which the video is displayed */
      displayContext: GetVideosDisplayContextEnum;
      /** The sort order of the video */
      sortOrder?: string;
      /**
       * The YouTube video URL
       * @format url
       */
      videoUrl: string;
      /** The original filename or title of the video */
      videoFilename?: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
    };
  }[];
  meta: {
    /** Offset-based pagination details. */
    page: {
      /** The number of the current page. */
      currentPage?: number;
      /** The number of the last page. */
      lastPage?: number;
      /** The number of resources on a page. */
      perPage?: number;
      /** The total number of resources. */
      total?: number;
      /** The ordinal number of the first resource on the current page. */
      from?: number;
      /** The ordinal number of the last resource on the current page. */
      to?: number;
    };
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** The links to resource pages. A link might be omitted to indicate that it is unavailable. */
  links: {
    /**
     * The link to the first page of resources.
     * @format url
     */
    first?: string;
    /**
     * The link to the previous page of resources.
     * @format url
     */
    prev?: string;
    /**
     * The link to the next page of resources.
     * @format url
     */
    next?: string;
    /**
     * The link to the last page of resources.
     * @format url
     */
    last?: string;
  };
}

/** Filter by display context. */
export enum GetVideosParams1FilterDisplayContextEnum {
  Hero = 'hero',
  Story = 'story',
}

export enum UploadVideoTypeEnum {
  Videos = 'videos',
}

/**
 * The context in which the video will be displayed.
 * @default "hero"
 */
export enum UploadVideoDisplayContextEnum {
  Hero = 'hero',
  Story = 'story',
  Gallery = 'gallery',
}

export interface UploadVideoData {
  data: {
    type: UploadVideoTypeEnum;
    /**
     * The UUID of the created video
     * @format uuid
     */
    id: string;
  };
}

export type DeleteVideoData = any;

/** @example "accepted" */
export enum AgreementsUpsertUserAgreementStatusStatusEnum {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

/** Target status for the user agreement */
export enum AgreementsUpsertUserAgreementStatusStatusEnum1 {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export interface AgreementsUpsertUserAgreementStatusData {
  /** JSON:API resource representing a user agreement and its status for a user */
  data: {
    /**
     * @default "user-agreements"
     * @example "user-agreements"
     */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @example "terms-and-conditions-bm-25" */
      agreementId: string;
      /** @example "accepted" */
      status: AgreementsUpsertUserAgreementStatusStatusEnum;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "accepted" */
export enum AgreementsGetUserAgreementStatusEnum {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export interface AgreementsGetUserAgreementData {
  /** JSON:API resource representing a user agreement and its status for a user */
  data: {
    /**
     * @default "user-agreements"
     * @example "user-agreements"
     */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @example "terms-and-conditions-bm-25" */
      agreementId: string;
      /** @example "accepted" */
      status: AgreementsGetUserAgreementStatusEnum;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface ListBrandTieredDiscountsParams {
  /**
   * List only assigned or unassigned tiered discounts
   * @example true
   */
  'filter[assigned]'?: boolean;
  /**
   * List only global or not global tiered discounts
   * @example true
   */
  'filter[global]'?: boolean;
}

export interface ListBrandTieredDiscountsData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: 'tiered-discount';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     * @example "00000000-0000-0000-0000-000000000000"
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandUuid?: string;
      /** @example false */
      isGlobal: boolean;
      /** @example "Volume Discount" */
      name: string;
      /**
       * The highest percentage value among all tiers
       * @example 10
       */
      maxPercentage: number;
      /** @example [{"percentage":5,"minimumOrderValue":{"currency":"EUR","amount":10000}},{"percentage":10,"minimumOrderValue":{"currency":"EUR","amount":20000}}] */
      tiers: {
        /**
         * @min 1
         * @max 70
         * @example 5
         */
        percentage: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":10000}
         */
        minimumOrderValue: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        } | null;
      }[];
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface CreateTieredDiscountData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: 'tiered-discount';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     * @example "00000000-0000-0000-0000-000000000000"
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandUuid?: string;
      /** @example false */
      isGlobal: boolean;
      /** @example "Volume Discount" */
      name: string;
      /**
       * The highest percentage value among all tiers
       * @example 10
       */
      maxPercentage: number;
      /** @example [{"percentage":5,"minimumOrderValue":{"currency":"EUR","amount":10000}},{"percentage":10,"minimumOrderValue":{"currency":"EUR","amount":20000}}] */
      tiers: {
        /**
         * @min 1
         * @max 70
         * @example 5
         */
        percentage: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":10000}
         */
        minimumOrderValue: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        } | null;
      }[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface UpdateTieredDiscountData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: 'tiered-discount';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     * @example "00000000-0000-0000-0000-000000000000"
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandUuid?: string;
      /** @example false */
      isGlobal: boolean;
      /** @example "Volume Discount" */
      name: string;
      /**
       * The highest percentage value among all tiers
       * @example 10
       */
      maxPercentage: number;
      /** @example [{"percentage":5,"minimumOrderValue":{"currency":"EUR","amount":10000}},{"percentage":10,"minimumOrderValue":{"currency":"EUR","amount":20000}}] */
      tiers: {
        /**
         * @min 1
         * @max 70
         * @example 5
         */
        percentage: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":10000}
         */
        minimumOrderValue: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        } | null;
      }[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface DeleteTieredDiscountData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

export interface AssignTieredDiscountToContactsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

export interface UnassignTieredDiscountFromContactsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

export interface ListRetailerTieredDiscountsData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: 'tiered-discount';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     * @example "00000000-0000-0000-0000-000000000000"
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandUuid?: string;
      /** @example false */
      isGlobal: boolean;
      /** @example "Volume Discount" */
      name: string;
      /**
       * The highest percentage value among all tiers
       * @example 10
       */
      maxPercentage: number;
      /** @example [{"percentage":5,"minimumOrderValue":{"currency":"EUR","amount":10000}},{"percentage":10,"minimumOrderValue":{"currency":"EUR","amount":20000}}] */
      tiers: {
        /**
         * @min 1
         * @max 70
         * @example 5
         */
        percentage: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":10000}
         */
        minimumOrderValue: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        } | null;
      }[];
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetBrandSegmentsData {
  data: {
    /** @example "brand-segments" */
    type: string;
    /** @example "brand-segments" */
    id: string;
    attributes: {
      /** Brands in network with no orders */
      network_prospects: {
        /** Internal brand ID */
        brand_id?: number | null;
        /**
         * Brand UUID
         * @format uuid
         */
        brand_uuid: string;
        /** Brand display name */
        brand_name: string;
        /** URL path to brand page */
        brand_link?: string | null;
        /** URL to brand logo image */
        brand_logo?: string | null;
        /** Brand images with source URLs */
        brand_images: {
          /** URL to brand image */
          src: string;
        }[];
        /** Whether the brand is new to the platform */
        brand_is_new: boolean;
        /** Total number of products from this brand */
        brand_total_products_count: number;
        /** Whether the brand has new products */
        brand_has_new_products: boolean;
        /** Brand story/description */
        story?: string | null;
        /** Brand's country code (ISO 3166-1 alpha-2) */
        country_code?: string | null;
        /**
         * Date of last order from this brand (YYYY-MM-DD)
         * @format date
         */
        last_order_on?: string | null;
        /** Whether the retailer is a new one for the brand */
        is_first_order?: boolean;
        /** Total number of completed orders from this brand */
        total_orders: number;
        /** Total amount spent with this brand (in minor units) */
        total_spent_amount: number;
        /** Currency of total spent amount (ISO 4217) */
        total_spent_currency: string;
        /**
         * When the discount was last updated (ISO 8601)
         * @format date-time
         */
        discount_updated_at: string;
      }[];
      /** Brands in network with order history */
      network_customers: {
        /** Internal brand ID */
        brand_id?: number | null;
        /**
         * Brand UUID
         * @format uuid
         */
        brand_uuid: string;
        /** Brand display name */
        brand_name: string;
        /** URL path to brand page */
        brand_link?: string | null;
        /** URL to brand logo image */
        brand_logo?: string | null;
        /** Brand images with source URLs */
        brand_images: {
          /** URL to brand image */
          src: string;
        }[];
        /** Whether the brand is new to the platform */
        brand_is_new: boolean;
        /** Total number of products from this brand */
        brand_total_products_count: number;
        /** Whether the brand has new products */
        brand_has_new_products: boolean;
        /** Brand story/description */
        story?: string | null;
        /** Brand's country code (ISO 3166-1 alpha-2) */
        country_code?: string | null;
        /**
         * Date of last order from this brand (YYYY-MM-DD)
         * @format date
         */
        last_order_on?: string | null;
        /** Whether the retailer is a new one for the brand */
        is_first_order?: boolean;
        /** Total number of completed orders from this brand */
        total_orders: number;
        /** Total amount spent with this brand (in minor units) */
        total_spent_amount: number;
        /** Currency of total spent amount (ISO 4217) */
        total_spent_currency: string;
        /**
         * When the discount was last updated (ISO 8601)
         * @format date-time
         */
        discount_updated_at: string;
      }[];
      /** Brands with global discounts not in network */
      global_discovery: {
        /** Internal brand ID */
        brand_id?: number | null;
        /**
         * Brand UUID
         * @format uuid
         */
        brand_uuid: string;
        /** Brand display name */
        brand_name: string;
        /** URL path to brand page */
        brand_link?: string | null;
        /** URL to brand logo image */
        brand_logo?: string | null;
        /** Brand images with source URLs */
        brand_images: {
          /** URL to brand image */
          src: string;
        }[];
        /** Whether the brand is new to the platform */
        brand_is_new: boolean;
        /** Total number of products from this brand */
        brand_total_products_count: number;
        /** Whether the brand has new products */
        brand_has_new_products: boolean;
        /** Brand story/description */
        story?: string | null;
        /** Brand's country code (ISO 3166-1 alpha-2) */
        country_code?: string | null;
        /**
         * Date of last order from this brand (YYYY-MM-DD)
         * @format date
         */
        last_order_on?: string | null;
        /** Whether the retailer is a new one for the brand */
        is_first_order?: boolean;
        /** Total number of completed orders from this brand */
        total_orders: number;
        /** Total amount spent with this brand (in minor units) */
        total_spent_amount: number;
        /** Currency of total spent amount (ISO 4217) */
        total_spent_currency: string;
        /**
         * When the discount was last updated (ISO 8601)
         * @format date-time
         */
        discount_updated_at: string;
      }[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetBrandRetailerTypeEnum {
  Custom = 'custom',
  BrandCustom = 'brand_custom',
  LiftOrder = 'lift_order',
  Network = 'network',
  SpecialOperation = 'special_operation',
  BrandCustomNetwork = 'brand_custom_network',
  Widget = 'widget',
}

export interface GetBrandRetailerData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      automaticOrderValidationMode?: boolean | null;
      repeatFeesPercentage?: number | null;
      firstFeesPercentage?: number | null;
      type?: GetBrandRetailerTypeEnum;
      /** @format date-time */
      expiresAt?: string | null;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum UpdateBrandRetailerTypeEnum {
  Custom = 'custom',
  BrandCustom = 'brand_custom',
  LiftOrder = 'lift_order',
  Network = 'network',
  SpecialOperation = 'special_operation',
  BrandCustomNetwork = 'brand_custom_network',
  Widget = 'widget',
}

export interface UpdateBrandRetailerData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      automaticOrderValidationMode?: boolean | null;
      repeatFeesPercentage?: number | null;
      firstFeesPercentage?: number | null;
      type?: UpdateBrandRetailerTypeEnum;
      /** @format date-time */
      expiresAt?: string | null;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetBrandMarketingCardsData {
  data: {
    type: 'marketing-cards';
    id: 'campaign-performance';
    attributes: {
      /**
       * Total number of orders created after campaigns
       * @min 0
       */
      totalOrders: number;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetApiInternalV1BrandsProductScoresTypeEnum {
  ProductScores = 'product-scores',
}

/**
 * Quality band this product's totalPoints falls into. Derived from totalPoints rather than stored, and uses the same vocabulary as the aggregate endpoint's tierBreakdown.
 * @example "critical"
 */
export enum GetApiInternalV1BrandsProductScoresTierEnum {
  Excellent = 'excellent',
  Good = 'good',
  NeedsWork = 'needs_work',
  Critical = 'critical',
}

/**
 * Pillar this criterion belongs to
 * @example "seo"
 */
export enum GetApiInternalV1BrandsProductScoresPillarIdEnum {
  Seo = 'seo',
  Categorization = 'categorization',
  Differentiation = 'differentiation',
}

/**
 * "pending" while a recompute is in flight for this product (the attributes above still reflect the last completed score); "ready" once it reflects the current state.
 * @example "ready"
 */
export enum GetApiInternalV1BrandsProductScoresStatusEnum {
  Pending = 'pending',
  Ready = 'ready',
}

export interface GetApiInternalV1BrandsProductScoresParams {
  /**
   * UUID of a single product to fetch the score for
   * @format uuid
   * @example "b3f1e8a2-9c4d-4f7a-8e21-6d5c0a1b2e3f"
   */
  'filter[product_id]'?: string;
  /**
   * Keep only products in this tier or any tier below it — `good` returns everything that is not `excellent`. Since `excellent` is the top tier it bounds nothing, so passing it is valid and returns every product. Combines with `filter[product_id]` using AND, so naming a product whose score sits above the threshold returns an empty list. An unrecognised value is rejected with 422.
   * @example "good"
   */
  'filter[max_tier]'?: FilterMaxTierEnum;
  /**
   * The number of resources to return.
   * @example 50
   */
  'page[limit]'?: number;
  /**
   * The offset of the first resource to return.
   * @example 0
   */
  'page[offset]'?: number;
  /**
   * JSON:API sparse fieldset. A comma-separated list of attribute names restricts each resource to just those attributes. Pass an empty value to get only `type`/`id` — e.g. a caller that only wants the list of product uuids, without paying for the full score payload. Omitting the parameter entirely returns every attribute, unchanged from today.
   * @example "totalPoints,tier"
   */
  'fields[product-scores]'?: string;
}

/**
 * Keep only products in this tier or any tier below it — `good` returns everything that is not `excellent`. Since `excellent` is the top tier it bounds nothing, so passing it is valid and returns every product. Combines with `filter[product_id]` using AND, so naming a product whose score sits above the threshold returns an empty list. An unrecognised value is rejected with 422.
 * @example "good"
 */
export enum FilterMaxTierEnum {
  Excellent = 'excellent',
  Good = 'good',
  NeedsWork = 'needs_work',
  Critical = 'critical',
}

export interface GetApiInternalV1BrandsProductScoresData {
  jsonapi: {
    version?: string;
  };
  meta: {
    /** Offset-based pagination details. */
    page: {
      /** The number of the current page. */
      currentPage?: number;
      /** The number of the last page. */
      lastPage?: number;
      /** The number of resources on a page. */
      perPage?: number;
      /** The total number of resources. */
      total?: number;
      /** The ordinal number of the first resource on the current page. */
      from?: number;
      /** The ordinal number of the last resource on the current page. */
      to?: number;
    };
    [key: string]: any;
  };
  data: {
    type: GetApiInternalV1BrandsProductScoresTypeEnum;
    /**
     * Product UUID
     * @format uuid
     */
    id: string;
    /** Absent when `fields[product-scores]` is passed with an empty value (sparse fieldset requesting no attributes). Otherwise never partially null, even while `status` is `pending`: a product that has never been scored (only a placeholder row exists) is excluded from this endpoint entirely rather than returned with empty fields, and a product re-entering `pending` for a rescore keeps every field at its last completed value until the new score lands. `status` is the only field that reflects "in flight" — everything else is always a complete, previously-computed score. */
    attributes?: {
      /**
       * Sum of all pillar scores
       * @example 6
       */
      totalPoints: number;
      /**
       * Sum of all pillar maximums
       * @example 57
       */
      totalMax: number;
      /**
       * Quality band this product's totalPoints falls into. Derived from totalPoints rather than stored, and uses the same vocabulary as the aggregate endpoint's tierBreakdown.
       * @example "critical"
       */
      tier: GetApiInternalV1BrandsProductScoresTierEnum;
      /**
       * @format date-time
       * @example "2026-07-24T10:00:00Z"
       */
      scoredAt: string;
      /** Per-pillar score breakdown */
      scores: {
        seo: {
          /**
           * Points awarded for this pillar
           * @example 3
           */
          score: number;
          /**
           * Maximum points available for this pillar
           * @example 22
           */
          max: number;
          /**
           * Product content the judge used to derive this pillar score
           * @example "Title: 'pillow'. Description: 'This is an organ but also a pillow.'"
           */
          evidence: string;
        };
        categorization: {
          /**
           * Points awarded for this pillar
           * @example 3
           */
          score: number;
          /**
           * Maximum points available for this pillar
           * @example 22
           */
          max: number;
          /**
           * Product content the judge used to derive this pillar score
           * @example "Title: 'pillow'. Description: 'This is an organ but also a pillow.'"
           */
          evidence: string;
        };
        differentiation: {
          /**
           * Points awarded for this pillar
           * @example 3
           */
          score: number;
          /**
           * Maximum points available for this pillar
           * @example 22
           */
          max: number;
          /**
           * Product content the judge used to derive this pillar score
           * @example "Title: 'pillow'. Description: 'This is an organ but also a pillow.'"
           */
          evidence: string;
        };
      };
      /** Per-criterion scoring */
      criterionResults: {
        /**
         * Unique identifier for the scoring criterion
         * @example "title_structure"
         */
        criterionId: string;
        /**
         * Pillar this criterion belongs to
         * @example "seo"
         */
        pillarId: GetApiInternalV1BrandsProductScoresPillarIdEnum;
        /** @example 2 */
        pointsAwarded: number;
        /** @example 8 */
        maxPoints: number;
      }[];
      /** LLM-suggested title/description rewrite, when the judge proposes one. A null rewrittenTitle/rewrittenDescription IS the "left unchanged" signal for that field — there is no separate changed-fields list. */
      rewrite?: {
        /**
         * Suggested replacement title, or null if the title was not rewritten
         * @example "Colomba Easter Cake - Dark Chocolate & Red Orange, 1kg"
         */
        rewrittenTitle: string | null;
        /** Suggested replacement description, or null if the description was not rewritten */
        rewrittenDescription: string | null;
      };
      /** Brand-facing improvement summary per listing field. */
      feedback?: {
        /**
         * What to improve in the title, or null when the title has nothing worth reporting
         * @example "State the scent and the net weight in the title."
         */
        feedbackTitle: string | null;
        /** What to improve in the description, or null when the description has nothing worth reporting */
        feedbackDescription: string | null;
      };
      /**
       * Hash over all scored inputs as returned by the Data API. Can be used as a cache key to detect whether inputs have changed since last scoring.
       * @example "sha256:9f2c4a7e1b8d6035c2a1f0e9d7b6c5a4938271605f4e3d2c1b0a9f8e7d6c5b4a"
       */
      contentHash?: string | null;
      /**
       * "pending" while a recompute is in flight for this product (the attributes above still reflect the last completed score); "ready" once it reflects the current state.
       * @example "ready"
       */
      status: GetApiInternalV1BrandsProductScoresStatusEnum;
    };
  }[];
}

/**
 * Keep only products in this tier or any tier below it — `good` returns everything that is not `excellent`. Since `excellent` is the top tier it bounds nothing, so passing it is valid and returns every product. Combines with `filter[product_id]` using AND, so naming a product whose score sits above the threshold returns an empty list. An unrecognised value is rejected with 422.
 * @example "good"
 */
export enum GetApiInternalV1BrandsProductScoresParams1FilterMaxTierEnum {
  Excellent = 'excellent',
  Good = 'good',
  NeedsWork = 'needs_work',
  Critical = 'critical',
}

export enum GetApiInternalV1BrandsProductScoresAggregateTypeEnum {
  BrandProductScores = 'brand-product-scores',
}

export interface GetApiInternalV1BrandsProductScoresAggregateData {
  jsonapi: {
    version?: string;
  };
  data: {
    type: GetApiInternalV1BrandsProductScoresAggregateTypeEnum;
    /** Brand ID */
    id: string;
    attributes: {
      /**
       * Aggregate score from 0 to 100
       * @format float
       * @example 52.5
       */
      score: number;
      /**
       * Number of products the aggregate was computed from
       * @example 4
       */
      productCount: number;
      /**
       * @format date-time
       * @example "2026-08-06T10:00:00Z"
       */
      computedAt: string;
      /** Number of products in each tier, always includes all four keys */
      tierBreakdown: {
        /** @example 1 */
        excellent: number;
        /** @example 1 */
        good: number;
        /** @example 1 */
        needs_work: number;
        /** @example 1 */
        critical: number;
      };
      /**
       * True while at least one of the brand's products has a recompute in flight. The score/tierBreakdown above still reflect the last completed computation and may not include it yet.
       * @example false
       */
      pending: boolean;
    };
  };
}

export enum BrandsActionStatusStatusEnum {
  NotRequested = 'not_requested',
  Pending = 'pending',
  Approved = 'approved',
  Completed = 'completed',
  Rejected = 'rejected',
}

export enum BrandsActionStatusPreviousStatusEnum {
  NotRequested = 'not_requested',
  Pending = 'pending',
  Approved = 'approved',
  Completed = 'completed',
  Rejected = 'rejected',
}

export interface BrandsActionStatusData {
  data: {
    type: 'reactivations';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandUuid: string;
      status: BrandsActionStatusStatusEnum;
      previousStatus: BrandsActionStatusPreviousStatusEnum;
      /** @format date-time */
      createdAt: string;
    };
    meta?: {
      /**
       * Current status of the brand (online|offline|onboarding)
       * @example "online"
       */
      brandStatus?: string;
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum BrandsActionTransitionStatusEnum {
  NotRequested = 'not_requested',
  Pending = 'pending',
  Approved = 'approved',
  Completed = 'completed',
  Rejected = 'rejected',
}

export enum BrandsActionTransitionPreviousStatusEnum {
  NotRequested = 'not_requested',
  Pending = 'pending',
  Approved = 'approved',
  Completed = 'completed',
  Rejected = 'rejected',
}

export enum BrandsActionTransitionTypeEnum {
  RequestReactivation = 'request-reactivation',
  DismissBanner = 'dismiss-banner',
}

export interface BrandsActionTransitionData {
  data: {
    type: 'reactivations';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandUuid: string;
      status: BrandsActionTransitionStatusEnum;
      previousStatus: BrandsActionTransitionPreviousStatusEnum;
      /** @format date-time */
      createdAt: string;
    };
    meta?: {
      /**
       * Current status of the brand (online|offline|onboarding)
       * @example "online"
       */
      brandStatus?: string;
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetCartItemCounterData {
  /**
   * ItemCounterResource
   * Item Counter resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      main: number;
      savedForLater: number;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetCheckoutValidationsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * CheckoutValidationsResource
   * Checkout validations resource
   */
  data?: {
    /**
     * [resource object type](https://jsonapi.org/format/#document-resource-object-identification)
     * @example "checkout-validations"
     */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /** @example true */
      shouldShowTaxNumberQuestion?: boolean;
      /** @example "HRA10526" */
      taxNumber?: string | null;
      /** @example false */
      shouldShowVatNumberQuestion?: boolean;
      /** @example "DE279778283" */
      vatNumber?: string | null;
      /** @example true */
      shouldShowVatExemptionCheckbox?: boolean;
      /** @example false */
      vatExemption?: boolean;
      /** @example true */
      shouldDisableNoNumberOption?: boolean;
      /** @example false */
      isSoleTrader?: boolean;
      /** @example true */
      shouldShowCompanySelect?: boolean;
      /** @example false */
      shouldShowCompanyRegistrationForm?: boolean;
      /** @example false */
      shouldShowCompanyRegistrationBusinessNameInput?: boolean;
      /** @example null */
      eoriNumber?: string | null;
      /** @example false */
      shouldShowEoriNumberQuestion?: boolean;
      /** @example null */
      isPayingRecargo?: boolean | null;
      /** @example false */
      shouldShowRecargoQuestion?: boolean;
    };
  };
}

export enum GetCartSummaryTypeEnum {
  RetailerShippingFees = 'retailer_shipping_fees',
}

export enum GetCartSummaryTypeEnum1 {
  FeesVat = 'fees_vat',
  GoodsVat = 'goods_vat',
  RecargoDeEquivalencia = 'recargo_de_equivalencia',
}

export enum GetCartSummaryTypeEnum2 {
  Promocode = 'promocode',
  OfferDiscount = 'offer_discount',
  EventDiscount = 'event_discount',
  PaymentMethodDiscount = 'payment_method_discount',
  Wallet = 'wallet',
}

/** Type of the Purchasing List */
export enum GetCartSummaryTypeEnum3 {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

export enum GetCartSummaryGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum GetCartSummaryTypeEnum4 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetCartSummaryTypeEnum5 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetCartSummaryTypeEnum6 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetCartSummaryOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface GetCartSummaryData {
  /**
   * CartSummaryResource
   * Cart Summary resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      summary: {
        /**
         * sum of product taxes (vat) + sum of individual fees (and their respective vat) + sum of global taxes (recargo, ...)
         * @example {"currency":"EUR","amount":142}
         */
        feesAndTaxesTotal?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * sum of discounts (promocode, offers, ...)
         * @example {"currency":"EUR","amount":142}
         */
        discountsTotal?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * everything considered, taxes included
         * @example {"currency":"EUR","amount":142}
         */
        grandTotal?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
      };
      fees: ({
        type: string;
        label?: string;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amount: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
      } & {
        type?: GetCartSummaryTypeEnum;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amountLeftForFreeShipping?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        metadata?: {
          offerName?: string;
          isShippingFree?: boolean;
          isEligibleForDiscoveryFreeShipping?: boolean;
          brandNonEligibleForAkPlusFreeShipping?: boolean;
          francoAmount?: number;
          francoFeeAmount?: number;
          francoMaxFeeAmount?: number;
        };
      })[];
      taxes: {
        type: GetCartSummaryTypeEnum1;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amount: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
      }[];
      discounts: {
        type: GetCartSummaryTypeEnum2;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amount: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        metadata?: {
          label: string;
        };
      }[];
    };
    meta: {
      isFirstPurchase: boolean;
      isShippable: boolean;
      [key: string]: any;
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        id: string;
        attributes: {
          /** Type of the Purchasing List */
          type?: GetCartSummaryTypeEnum3;
          /** Custom name of Purchasing List */
          name?: string | null;
          /**
           * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          totalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          selectionTotalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
          totalItemCount?: number;
        };
        relationships?: {
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          itemAggregates?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        links?: {
          self: string;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: GetCartSummaryGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: GetCartSummaryTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetCartSummaryTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetCartSummaryTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetCartSummaryOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          code: string;
          message?: string | null;
          status?: string | null;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          amount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * When the code stops working. Null if it never expires.
           * @format datetime
           */
          expiresAt: string | null;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrder: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          minimumCheckout?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          name: string;
          organisationName: string;
          city: string;
          postalCode: string;
          street: string;
          /**
           * CountryObject
           * Country object
           */
          country: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Type of the Purchasing List */
export enum GetAllCartsTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum GetAllCartsAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum GetAllCartsTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum GetAllCartsStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetAllCartsInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum GetAllCartsTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetAllCartsTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetAllCartsTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetAllCartsOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum GetAllCartsStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum GetAllCartsGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum GetAllCartsTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetAllCartsTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetAllCartsTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetAllCartsOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface GetAllCartsData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Optional note from the brand to the retailer (max 800 characters) */
      note?: string | null;
    };
    relationships?: {
      list?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        id: string;
        attributes: {
          /** Type of the Purchasing List */
          type?: GetAllCartsTypeEnum;
          /** Custom name of Purchasing List */
          name?: string | null;
          /**
           * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          totalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          selectionTotalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
          totalItemCount?: number;
        };
        relationships?: {
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          itemAggregates?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        links?: {
          self: string;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: GetAllCartsAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: GetAllCartsTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: GetAllCartsStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: GetAllCartsInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: GetAllCartsTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetAllCartsTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetAllCartsTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetAllCartsOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: GetAllCartsStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: GetAllCartsGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: GetAllCartsTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetAllCartsTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetAllCartsTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetAllCartsOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

/** Type of the Purchasing List */
export enum GetOneCartTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum GetOneCartAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum GetOneCartTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum GetOneCartStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetOneCartInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum GetOneCartTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetOneCartTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetOneCartTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetOneCartOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum GetOneCartStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum GetOneCartGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum GetOneCartTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetOneCartTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetOneCartTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetOneCartOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface GetOneCartParams {
  /**
   * JSON:API sparse fieldsets for purchasable-aggregates resources.
   * Comma-separated list of fields (attributes AND relationships) to include in the response.
   *
   * Available attributes: totalAmountBeforeDiscount, totalAmountAfterDiscount, selected, hasMultiDiscounts, globalDiscountPercentage, globalDiscountType, itemCount, hasReachedBrandMinimumOrderValue, applicableFees, canShipToRetailerCountry, isPreparedOrder, everyProductOutOfStock, unavailableItemsCount, hasFreshProducts, hasInsufficientStockItems, hasNeedsFreshInputProducts, estimatedDelivery, repeatOffer
   * Available relationships: brand, items
   *
   * IMPORTANT: When using sparse fieldsets, you MUST include the relationships (brand, items) if you want them in the response.
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees (shipping fees, etc.), improving response time.
   * @example "totalAmountAfterDiscount,itemCount,applicableFees,brand,items"
   */
  'fields[purchasable-aggregates]'?: string;
  /**
   * JSON:API sparse fieldsets for purchasable-items resources.
   * Comma-separated list of attributes to include in the response.
   *
   * Available fields: name, path, options, imagePath, availability, unitMultiplier, availableAt, pricing, stock, applicableFees, storageTemperature, needsFreshInput
   *
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees for individual items.
   * @example "pricing,availability"
   */
  'fields[purchasable-items]'?: string;
  /**
   * Cart ID
   * @format uuid
   */
  id: string;
}

export interface GetOneCartData {
  /**
   * CartResource
   * Cart resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Optional note from the brand to the retailer (max 800 characters) */
      note?: string | null;
    };
    relationships?: {
      list?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        id: string;
        attributes: {
          /** Type of the Purchasing List */
          type?: GetOneCartTypeEnum;
          /** Custom name of Purchasing List */
          name?: string | null;
          /**
           * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          totalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          selectionTotalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
          totalItemCount?: number;
        };
        relationships?: {
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          itemAggregates?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        links?: {
          self: string;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: GetOneCartAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: GetOneCartTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: GetOneCartStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: GetOneCartInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: GetOneCartTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetOneCartTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetOneCartTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetOneCartOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: GetOneCartStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: GetOneCartGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: GetOneCartTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetOneCartTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetOneCartTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetOneCartOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

export enum GetCartExpandBrandGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum GetCartExpandBrandTypeEnum {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetCartExpandBrandTypeEnum1 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetCartExpandBrandTypeEnum2 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetCartExpandBrandOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum GetCartExpandBrandAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum GetCartExpandBrandTypeEnum3 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum GetCartExpandBrandStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetCartExpandBrandInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum GetCartExpandBrandTypeEnum4 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetCartExpandBrandTypeEnum5 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetCartExpandBrandTypeEnum6 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetCartExpandBrandOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum GetCartExpandBrandStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export interface GetCartExpandBrandParams {
  /**
   * Comma-separated list of relationships to include. Expected value: brand,items,items.purchasableItem
   * @example "brand,items,items.purchasableItem"
   */
  include?: string;
  /**
   * UUID of the brand to expand from the cart
   * @format uuid
   */
  brandUuid: string;
}

export interface GetCartExpandBrandData {
  /**
   * PurchasableAggregateResource
   * Aggregate (grouped by brand) of Purchasing List items
   */
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
       * @example {"currency":"EUR","amount":142}
       */
      totalAmountBeforeDiscount: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
       * @example {"currency":"EUR","amount":142}
       */
      totalAmountAfterDiscount: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** Whether the aggregate is part of the selection or not */
      selected: boolean;
      /** Whether the aggregate contains items with differents discounts */
      hasMultiDiscounts: boolean;
      /**
       * Resulting global discount percentage applied on the total amount of the aggregate
       * @format float
       */
      globalDiscountPercentage: number;
      /** Type of the global discount applied on the aggregate, null when no global discount applies */
      globalDiscountType: GetCartExpandBrandGlobalDiscountTypeEnum | null;
      /** Repeat offer information, absent when no repeat offer applies to this aggregate */
      repeatOffer?: {
        /**
         * Total amount to spend in order to unlock AKS+ repeat offer
         * @example {"currency":"EUR","amount":142}
         */
        amountLeftToReachThreshold: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * Discount the brand will give to retailer for the AKS+ repeat offer
         * @format float
         */
        percentage: number;
        activeDiscount: {
          /**
           * Percentage of the current active discount
           * @format float
           */
          percentage: number;
          /** EndDate of the current active discount */
          endDate: string;
        } | null;
      };
      /** Total number of items contained in the aggregate */
      itemCount: number;
      /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
      hasReachedBrandMinimumOrderValue: boolean;
      /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
      applicableFees: (
        | {
            /** Type of the fee */
            type?: GetCartExpandBrandTypeEnum;
            /**
             * Amount of the fee
             * @example {"currency":"EUR","amount":142}
             */
            amount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Country where the fee is applied
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            shippingCountryIsoCode?: string;
          }
        | {
            /** Type of the fee */
            type?: GetCartExpandBrandTypeEnum1;
            /**
             * Amount of the fee
             * @example {"currency":"EUR","amount":142}
             */
            amount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
          }
        | {
            /** Type of the fee */
            type: GetCartExpandBrandTypeEnum2;
            /**
             * Amount of the fee
             * @example {"currency":"EUR","amount":142}
             */
            amount: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Amount left to reach the free shipping
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftForFreeShipping: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            } | null;
            metadata: {
              /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
              offerName?: GetCartExpandBrandOfferNameEnum;
              brandNonEligibleForAkPlusFreeShipping: boolean;
              isDiscovery: boolean;
              isEligibleForDiscoveryFreeShipping: boolean;
              /** Minimum order amount to qualify for free shipping (cents) */
              francoAmount?: number | null;
              /** Shipping fee amount when below franco threshold (cents) */
              francoFeeAmount?: number | null;
              /** Maximum shipping fee amount (cents) */
              francoMaxFeeAmount?: number | null;
            };
          }
      )[];
      /** Whether the brand can ship to the retailer country */
      canShipToRetailerCountry: boolean;
      /** Whether the items in this brand aggregate belong to a prepared order */
      isPreparedOrder: boolean;
      /** Whether all products in this brand aggregate are out of stock */
      everyProductOutOfStock: boolean;
      /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
      unavailableItemsCount: number;
      /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
      hasFreshProducts: boolean;
      /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
      hasInsufficientStockItems: boolean;
      /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
      hasNeedsFreshInputProducts: boolean;
      /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
      estimatedDelivery: {
        /** Minimum estimated delivery days for this brand aggregate */
        minDays: number | null;
        /** Maximum estimated delivery days for this brand aggregate */
        maxDays: number | null;
      };
    };
    relationships?: {
      brand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      items?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: GetCartExpandBrandAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: GetCartExpandBrandTypeEnum3;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: GetCartExpandBrandStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: GetCartExpandBrandInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: GetCartExpandBrandTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetCartExpandBrandTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetCartExpandBrandTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetCartExpandBrandOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: GetCartExpandBrandStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
  )[];
}

/** Type of the Purchasing List */
export enum GetAllPurchasingListsTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum GetAllPurchasingListsAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum GetAllPurchasingListsTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum GetAllPurchasingListsStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetAllPurchasingListsInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum GetAllPurchasingListsTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetAllPurchasingListsTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetAllPurchasingListsTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetAllPurchasingListsOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum GetAllPurchasingListsStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum GetAllPurchasingListsGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum GetAllPurchasingListsTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetAllPurchasingListsTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetAllPurchasingListsTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetAllPurchasingListsOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface GetAllPurchasingListsParams {
  /** Filter by purchasing list type */
  'filter[type]'?: FilterTypeEnum;
  /**
   * JSON:API sparse fieldsets for purchasable-aggregates resources.
   * Comma-separated list of fields (attributes AND relationships) to include in the response.
   *
   * Available attributes: totalAmountBeforeDiscount, totalAmountAfterDiscount, selected, hasMultiDiscounts, globalDiscountPercentage, globalDiscountType, itemCount, hasReachedBrandMinimumOrderValue, applicableFees, canShipToRetailerCountry, isPreparedOrder, everyProductOutOfStock, unavailableItemsCount, hasFreshProducts, hasInsufficientStockItems, hasNeedsFreshInputProducts, estimatedDelivery, repeatOffer
   * Available relationships: brand, items
   *
   * IMPORTANT: When using sparse fieldsets, you MUST include the relationships (brand, items) if you want them in the response.
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees (shipping fees, etc.), improving response time.
   * @example "totalAmountAfterDiscount,itemCount,applicableFees,brand,items"
   */
  'fields[purchasable-aggregates]'?: string;
  /**
   * JSON:API sparse fieldsets for purchasable-items resources.
   * Comma-separated list of attributes to include in the response.
   *
   * Available fields: name, path, options, imagePath, availability, unitMultiplier, availableAt, pricing, stock, applicableFees, storageTemperature, needsFreshInput
   *
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees for individual items.
   * @example "pricing,availability"
   */
  'fields[purchasable-items]'?: string;
}

/** Filter by purchasing list type */
export enum FilterTypeEnum {
  Cart = 'cart',
  SavedForLater = 'saved_for_later',
}

export interface GetAllPurchasingListsData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    id: string;
    attributes: {
      /** Type of the Purchasing List */
      type?: GetAllPurchasingListsTypeEnum;
      /** Custom name of Purchasing List */
      name?: string | null;
      /**
       * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      selectionTotalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
      totalItemCount?: number;
    };
    relationships?: {
      items?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      itemAggregates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
    links?: {
      self: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: GetAllPurchasingListsAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: GetAllPurchasingListsTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: GetAllPurchasingListsStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: GetAllPurchasingListsInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: GetAllPurchasingListsTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetAllPurchasingListsTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetAllPurchasingListsTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetAllPurchasingListsOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: GetAllPurchasingListsStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: GetAllPurchasingListsGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: GetAllPurchasingListsTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetAllPurchasingListsTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetAllPurchasingListsTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetAllPurchasingListsOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

/** Filter by purchasing list type */
export enum GetAllPurchasingListsParams1FilterTypeEnum {
  Cart = 'cart',
  SavedForLater = 'saved_for_later',
}

/** Type of the Purchasing List */
export enum GetPurchasingListTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum GetPurchasingListAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum GetPurchasingListTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum GetPurchasingListStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetPurchasingListInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum GetPurchasingListTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetPurchasingListTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetPurchasingListTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetPurchasingListOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum GetPurchasingListStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum GetPurchasingListGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum GetPurchasingListTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum GetPurchasingListTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum GetPurchasingListTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetPurchasingListOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface GetPurchasingListParams {
  /**
   * JSON:API sparse fieldsets for purchasable-aggregates resources.
   * Comma-separated list of fields (attributes AND relationships) to include in the response.
   *
   * Available attributes: totalAmountBeforeDiscount, totalAmountAfterDiscount, selected, hasMultiDiscounts, globalDiscountPercentage, globalDiscountType, itemCount, hasReachedBrandMinimumOrderValue, applicableFees, canShipToRetailerCountry, isPreparedOrder, everyProductOutOfStock, unavailableItemsCount, hasFreshProducts, hasInsufficientStockItems, hasNeedsFreshInputProducts, estimatedDelivery, repeatOffer
   * Available relationships: brand, items
   *
   * IMPORTANT: When using sparse fieldsets, you MUST include the relationships (brand, items) if you want them in the response.
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees (shipping fees, etc.), improving response time.
   * @example "totalAmountAfterDiscount,itemCount,applicableFees,brand,items"
   */
  'fields[purchasable-aggregates]'?: string;
  /**
   * JSON:API sparse fieldsets for purchasable-items resources.
   * Comma-separated list of attributes to include in the response.
   *
   * Available fields: name, path, options, imagePath, availability, unitMultiplier, availableAt, pricing, stock, applicableFees, storageTemperature, needsFreshInput
   *
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees for individual items.
   * @example "pricing,availability"
   */
  'fields[purchasable-items]'?: string;
  /** Purchasing List ID */
  purchasingList: string;
}

export interface GetPurchasingListData {
  /**
   * PurchasingListResource
   * Purchasing List resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    id: string;
    attributes: {
      /** Type of the Purchasing List */
      type?: GetPurchasingListTypeEnum;
      /** Custom name of Purchasing List */
      name?: string | null;
      /**
       * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      selectionTotalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
      totalItemCount?: number;
    };
    relationships?: {
      items?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      itemAggregates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
    links?: {
      self: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: GetPurchasingListAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: GetPurchasingListTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: GetPurchasingListStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: GetPurchasingListInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: GetPurchasingListTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetPurchasingListTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetPurchasingListTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetPurchasingListOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: GetPurchasingListStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: GetPurchasingListGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: GetPurchasingListTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: GetPurchasingListTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: GetPurchasingListTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: GetPurchasingListOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

/** Type of the Purchasing List */
export enum PurchasingListActionContentUpdateTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum PurchasingListActionContentUpdateAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum PurchasingListActionContentUpdateTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum PurchasingListActionContentUpdateStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum PurchasingListActionContentUpdateInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum PurchasingListActionContentUpdateTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum PurchasingListActionContentUpdateTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum PurchasingListActionContentUpdateTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum PurchasingListActionContentUpdateOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum PurchasingListActionContentUpdateStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum PurchasingListActionContentUpdateGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum PurchasingListActionContentUpdateTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum PurchasingListActionContentUpdateTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum PurchasingListActionContentUpdateTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum PurchasingListActionContentUpdateOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface PurchasingListActionContentUpdateParams {
  /**
   * JSON:API sparse fieldsets for purchasable-aggregates resources.
   * Comma-separated list of fields (attributes AND relationships) to include in the response.
   *
   * Available attributes: totalAmountBeforeDiscount, totalAmountAfterDiscount, selected, hasMultiDiscounts, globalDiscountPercentage, globalDiscountType, itemCount, hasReachedBrandMinimumOrderValue, applicableFees, canShipToRetailerCountry, isPreparedOrder, everyProductOutOfStock, unavailableItemsCount, hasFreshProducts, hasInsufficientStockItems, hasNeedsFreshInputProducts, estimatedDelivery, repeatOffer
   * Available relationships: brand, items
   *
   * IMPORTANT: When using sparse fieldsets, you MUST include the relationships (brand, items) if you want them in the response.
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees (shipping fees, etc.), improving response time.
   * @example "totalAmountAfterDiscount,itemCount,applicableFees,brand,items"
   */
  'fields[purchasable-aggregates]'?: string;
  /**
   * JSON:API sparse fieldsets for purchasable-items resources.
   * Comma-separated list of attributes to include in the response.
   *
   * Available fields: name, path, options, imagePath, availability, unitMultiplier, availableAt, pricing, stock, applicableFees, storageTemperature, needsFreshInput
   *
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees for individual items.
   * @example "pricing,availability"
   */
  'fields[purchasable-items]'?: string;
  /** Purchasing List ID */
  purchasingList: string;
}

export interface PurchasingListActionContentUpdateData {
  /**
   * PurchasingListResource
   * Purchasing List resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    id: string;
    attributes: {
      /** Type of the Purchasing List */
      type?: PurchasingListActionContentUpdateTypeEnum;
      /** Custom name of Purchasing List */
      name?: string | null;
      /**
       * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      selectionTotalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
      totalItemCount?: number;
    };
    relationships?: {
      items?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      itemAggregates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
    links?: {
      self: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: PurchasingListActionContentUpdateAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: PurchasingListActionContentUpdateTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: PurchasingListActionContentUpdateStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: PurchasingListActionContentUpdateInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: PurchasingListActionContentUpdateTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: PurchasingListActionContentUpdateTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: PurchasingListActionContentUpdateTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: PurchasingListActionContentUpdateOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: PurchasingListActionContentUpdateStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: PurchasingListActionContentUpdateGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: PurchasingListActionContentUpdateTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: PurchasingListActionContentUpdateTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: PurchasingListActionContentUpdateTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: PurchasingListActionContentUpdateOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

/** Type of the Purchasing List */
export enum PurchasingListActionSelectionUpdateTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum PurchasingListActionSelectionUpdateAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum PurchasingListActionSelectionUpdateTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum PurchasingListActionSelectionUpdateStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum PurchasingListActionSelectionUpdateInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum PurchasingListActionSelectionUpdateTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum PurchasingListActionSelectionUpdateTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum PurchasingListActionSelectionUpdateTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum PurchasingListActionSelectionUpdateOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum PurchasingListActionSelectionUpdateStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum PurchasingListActionSelectionUpdateGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum PurchasingListActionSelectionUpdateTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum PurchasingListActionSelectionUpdateTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum PurchasingListActionSelectionUpdateTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum PurchasingListActionSelectionUpdateOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface PurchasingListActionSelectionUpdateParams {
  /**
   * JSON:API sparse fieldsets for purchasable-aggregates resources.
   * Comma-separated list of fields (attributes AND relationships) to include in the response.
   *
   * Available attributes: totalAmountBeforeDiscount, totalAmountAfterDiscount, selected, hasMultiDiscounts, globalDiscountPercentage, globalDiscountType, itemCount, hasReachedBrandMinimumOrderValue, applicableFees, canShipToRetailerCountry, isPreparedOrder, everyProductOutOfStock, unavailableItemsCount, hasFreshProducts, hasInsufficientStockItems, hasNeedsFreshInputProducts, estimatedDelivery, repeatOffer
   * Available relationships: brand, items
   *
   * IMPORTANT: When using sparse fieldsets, you MUST include the relationships (brand, items) if you want them in the response.
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees (shipping fees, etc.), improving response time.
   * @example "totalAmountAfterDiscount,itemCount,applicableFees,brand,items"
   */
  'fields[purchasable-aggregates]'?: string;
  /**
   * JSON:API sparse fieldsets for purchasable-items resources.
   * Comma-separated list of attributes to include in the response.
   *
   * Available fields: name, path, options, imagePath, availability, unitMultiplier, availableAt, pricing, stock, applicableFees, storageTemperature, needsFreshInput
   *
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees for individual items.
   * @example "pricing,availability"
   */
  'fields[purchasable-items]'?: string;
  /** Purchasing List ID */
  purchasingList: string;
}

export interface PurchasingListActionSelectionUpdateData {
  /**
   * PurchasingListResource
   * Purchasing List resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    id: string;
    attributes: {
      /** Type of the Purchasing List */
      type?: PurchasingListActionSelectionUpdateTypeEnum;
      /** Custom name of Purchasing List */
      name?: string | null;
      /**
       * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
       * @example {"currency":"EUR","amount":142}
       */
      selectionTotalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
      totalItemCount?: number;
    };
    relationships?: {
      items?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      itemAggregates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
    links?: {
      self: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: PurchasingListActionSelectionUpdateAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: PurchasingListActionSelectionUpdateTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: PurchasingListActionSelectionUpdateStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: PurchasingListActionSelectionUpdateInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: PurchasingListActionSelectionUpdateTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: PurchasingListActionSelectionUpdateTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: PurchasingListActionSelectionUpdateTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: PurchasingListActionSelectionUpdateOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: PurchasingListActionSelectionUpdateStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: PurchasingListActionSelectionUpdateGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: PurchasingListActionSelectionUpdateTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: PurchasingListActionSelectionUpdateTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: PurchasingListActionSelectionUpdateTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: PurchasingListActionSelectionUpdateOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

/** Type of the Purchasing List */
export enum PurchasingListActionCrossListOperationTypeEnum {
  SavedForLater = 'saved_for_later',
  Cart = 'cart',
}

/**
 * Whether the product variant can be ordered with the quantity
 * currently in the cart.
 *
 * - `available`: it can be ordered with the current cart quantity.
 * - `available_for_preorder`: same, for a pre-order cart.
 *
 *
 *   Deprecated and no longer relevant.
 * - `out_of_stock`: it cannot be ordered with the current cart
 *
 *
 *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
 *   `inventoryPolicy` is `deny`, and the available quantity is
 *   lower than or equal to the cart quantity.
 * - `variant_disabled`: the variant is disabled (archived).
 * - `product_disabled`: the product is disabled (offline, ...).
 * - `brand_disabled`: the brand is disabled (offline, coming soon,
 *
 *
 *   ...).
 * - `country_blacklisted`: the retailer's shipping country is not
 *
 *
 *   allowed by the brand's settings.
 * - `brand_in_holiday`: the brand is in holiday mode.
 */
export enum PurchasingListActionCrossListOperationAvailabilityEnum {
  Available = 'available',
  AvailableForPreorder = 'available_for_preorder',
  VariantDisabled = 'variant_disabled',
  ProductDisabled = 'product_disabled',
  BrandDisabled = 'brand_disabled',
  CountryBlacklisted = 'country_blacklisted',
  BrandInHoliday = 'brand_in_holiday',
  OutOfStock = 'out_of_stock',
}

/** Type of the discount */
export enum PurchasingListActionCrossListOperationTypeEnum1 {
  ProductDiscount = 'product_discount',
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
}

/**
 * Product-scoped stock status, derived from the currently available
 * stock, `isAlwaysInStock` and `inventoryPolicy`.
 *
 * - `out_of_stock`: there is no stock available to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
 *   and the available quantity is <= 0.
 * - `low_in_stock`: there is little stock left to order, i.e. stock is
 *
 *
 *   tracked (`isAlwaysInStock=false`) and stock is low (available
 *   quantity <= 10, or available quantity < 10% of the on-hand
 *   quantity).
 * - `in_stock`: there is plenty of stock to order (every other case).
 */
export enum PurchasingListActionCrossListOperationStatusEnum {
  InStock = 'in_stock',
  LowInStock = 'low_in_stock',
  OutOfStock = 'out_of_stock',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum PurchasingListActionCrossListOperationInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Type of the fee */
export enum PurchasingListActionCrossListOperationTypeEnum2 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum PurchasingListActionCrossListOperationTypeEnum3 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum PurchasingListActionCrossListOperationTypeEnum4 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum PurchasingListActionCrossListOperationOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

/** Storage temperature requirement of the product, if set by the brand */
export enum PurchasingListActionCrossListOperationStorageTemperatureEnum {
  None = 'none',
  Frozen = 'frozen',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  Fresh = 'fresh',
  Controlled = 'controlled',
}

export enum PurchasingListActionCrossListOperationGlobalDiscountTypeEnum {
  BrandDiscount = 'brand_discount',
  EventSpecialDiscount = 'event_special_discount',
  LoyaltyDiscount = 'loyalty_discount',
}

/** Type of the fee */
export enum PurchasingListActionCrossListOperationTypeEnum5 {
  LongDistanceFees = 'long_distance_fees',
}

/** Type of the fee */
export enum PurchasingListActionCrossListOperationTypeEnum6 {
  HeavyBulkFees = 'heavy_bulk_fees',
}

/** Type of the fee */
export enum PurchasingListActionCrossListOperationTypeEnum7 {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum PurchasingListActionCrossListOperationOfferNameEnum1 {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface PurchasingListActionCrossListOperationParams {
  /**
   * JSON:API sparse fieldsets for purchasable-aggregates resources.
   * Comma-separated list of fields (attributes AND relationships) to include in the response.
   *
   * Available attributes: totalAmountBeforeDiscount, totalAmountAfterDiscount, selected, hasMultiDiscounts, globalDiscountPercentage, globalDiscountType, itemCount, hasReachedBrandMinimumOrderValue, applicableFees, canShipToRetailerCountry, isPreparedOrder, everyProductOutOfStock, unavailableItemsCount, hasFreshProducts, hasInsufficientStockItems, hasNeedsFreshInputProducts, estimatedDelivery, repeatOffer
   * Available relationships: brand, items
   *
   * IMPORTANT: When using sparse fieldsets, you MUST include the relationships (brand, items) if you want them in the response.
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees (shipping fees, etc.), improving response time.
   * @example "totalAmountAfterDiscount,itemCount,applicableFees,brand,items"
   */
  'fields[purchasable-aggregates]'?: string;
  /**
   * JSON:API sparse fieldsets for purchasable-items resources.
   * Comma-separated list of attributes to include in the response.
   *
   * Available fields: name, path, options, imagePath, availability, unitMultiplier, availableAt, pricing, stock, applicableFees, storageTemperature, needsFreshInput
   *
   * Note: Omitting applicableFees from this list will defer the computation of applicable fees for individual items.
   * @example "pricing,availability"
   */
  'fields[purchasable-items]'?: string;
}

export interface PurchasingListActionCrossListOperationData {
  /**
   * PurchasingListCrossListOperationResultResource
   * Cross list operation resource
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: object;
    relationships?: {
      sourceList?: {
        /**
         * Linkage
         * Resource identification present in Resource Objects and Resource Identifier Objects.
         */
        data: {
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      destinationList?: {
        /**
         * Linkage
         * Resource identification present in Resource Objects and Resource Identifier Objects.
         */
        data: {
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        id: string;
        attributes: {
          /** Type of the Purchasing List */
          type?: PurchasingListActionCrossListOperationTypeEnum;
          /** Custom name of Purchasing List */
          name?: string | null;
          /**
           * Total amount (excl. taxes) of the Purchasing List (sum of the amounts of all the items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          totalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the selected set if items in the Purchasing List (sum of the amounts of all the selected items contained in the list, respecting the chosen quantity). Inactive (or non-buyable) items are excluded, same for product aggregates (brands) which doesn't reach the minimum order value threshold.
           * @example {"currency":"EUR","amount":142}
           */
          selectionTotalAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Total number of items units contained in the Purchasing List (respecting the chosen quantity) */
          totalItemCount?: number;
        };
        relationships?: {
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          itemAggregates?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        links?: {
          self: string;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * ID of the linked Purchasable Item (product variant)
           * @format uuid
           */
          purchasableItemID?: string;
          /** @format uuid */
          productID?: string;
          /** Quantity of units of the item (ex: 2 packs of 6 bottles of wine: quantity = 2) */
          quantity?: number;
          /** Total quantity of individual units of the item (ex: 2 packs of 6 bottles of wine: quantity = 12) */
          multipliedQuantity?: number;
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, before any discount
           * @example {"currency":"EUR","amount":142}
           */
          amountBeforeDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Amount (excl. taxes) of the item, respecting the chosen quantity, discount being eventually applied
           * @example {"currency":"EUR","amount":142}
           */
          amountAfterDiscount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
        };
        relationships?: {
          purchasableItem?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the item */
          name?: string;
          /** Path of the item */
          path?: string;
          /** Options of the item */
          options?: {
            /** Type of the option assigned to this item (ex: size) */
            type?: string;
            /** Name of the option assigned to this item, translated in user's language (ex: size, taille, ...) */
            name?: string;
            /** Value of the option assigned to this item (ex: 42 FR) */
            value?: string;
          }[];
          /** Path to the main image of the item */
          imagePath?: string | null;
          /**
           * Whether the product variant can be ordered with the quantity
           * currently in the cart.
           *
           * - `available`: it can be ordered with the current cart quantity.
           * - `available_for_preorder`: same, for a pre-order cart.
           *
           *
           *   Deprecated and no longer relevant.
           * - `out_of_stock`: it cannot be ordered with the current cart
           *
           *
           *   quantity, i.e. stock is tracked (`isAlwaysInStock=false`), the
           *   `inventoryPolicy` is `deny`, and the available quantity is
           *   lower than or equal to the cart quantity.
           * - `variant_disabled`: the variant is disabled (archived).
           * - `product_disabled`: the product is disabled (offline, ...).
           * - `brand_disabled`: the brand is disabled (offline, coming soon,
           *
           *
           *   ...).
           * - `country_blacklisted`: the retailer's shipping country is not
           *
           *
           *   allowed by the brand's settings.
           * - `brand_in_holiday`: the brand is in holiday mode.
           */
          availability?: PurchasingListActionCrossListOperationAvailabilityEnum;
          /** Number of individual units contained in a single item unit (ex: 6 bottles of wine in a pack) */
          unitMultiplier?: number;
          /**
           * Shipping date(in future) of a preorder product e.g. 2024-12-01
           * @format date
           */
          availableAt?: string | null;
          /**
           * PurchasableItemPricing
           * Pricing details of the Purchasable Item
           */
          pricing?: {
            /** Optional discount applied on the Purchasable Item */
            discount?: null | {
              /** Type of the discount */
              type?: PurchasingListActionCrossListOperationTypeEnum1;
              /**
               * Value (percentage) of the discount
               * @format float
               */
              percentage?: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, before any discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceBeforeDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Unit price (excl. taxes) of the Purchasable Item, after (eventual) discount
             * @example {"currency":"EUR","amount":142}
             */
            unitPriceAfterDiscount?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /** If product discount is higher than brand global discount */
            isUpperThanGlobalBrandDiscount?: boolean;
          };
          /**
           * PurchasableItemStock
           * Stock details of the Purchasable Item
           */
          stock?: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`), the `inventoryPolicy` is `deny`,
             *   and the available quantity is <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock is
             *
             *
             *   tracked (`isAlwaysInStock=false`) and stock is low (available
             *   quantity <= 10, or available quantity < 10% of the on-hand
             *   quantity).
             * - `in_stock`: there is plenty of stock to order (every other case).
             */
            status: PurchasingListActionCrossListOperationStatusEnum;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of this
             *
             *
             *   variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: PurchasingListActionCrossListOperationInventoryPolicyEnum;
            /** Available quantity of the item in the stock (non-present if the product is always in stock) */
            availableQuantity?: number;
          };
          /** Optional extra fees applied on the Purchasable Item */
          applicableFees?: (
            | {
                /** Type of the fee */
                type?: PurchasingListActionCrossListOperationTypeEnum2;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: PurchasingListActionCrossListOperationTypeEnum3;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: PurchasingListActionCrossListOperationTypeEnum4;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: PurchasingListActionCrossListOperationOfferNameEnum;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Storage temperature requirement of the product, if set by the brand */
          storageTemperature?: PurchasingListActionCrossListOperationStorageTemperatureEnum;
          /** Whether this product needs fresh input (temperature-controlled shipping) */
          needsFreshInput?: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), before any discount
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountBeforeDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * Total amount (excl. taxes) of the aggregate (sum of the amounts of all the items contained in it, respecting the chosen quantity), after discount applied
           * @example {"currency":"EUR","amount":142}
           */
          totalAmountAfterDiscount: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether the aggregate is part of the selection or not */
          selected: boolean;
          /** Whether the aggregate contains items with differents discounts */
          hasMultiDiscounts: boolean;
          /**
           * Resulting global discount percentage applied on the total amount of the aggregate
           * @format float
           */
          globalDiscountPercentage: number;
          /** Type of the global discount applied on the aggregate, null when no global discount applies */
          globalDiscountType: PurchasingListActionCrossListOperationGlobalDiscountTypeEnum | null;
          /** Repeat offer information, absent when no repeat offer applies to this aggregate */
          repeatOffer?: {
            /**
             * Total amount to spend in order to unlock AKS+ repeat offer
             * @example {"currency":"EUR","amount":142}
             */
            amountLeftToReachThreshold: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            /**
             * Discount the brand will give to retailer for the AKS+ repeat offer
             * @format float
             */
            percentage: number;
            activeDiscount: {
              /**
               * Percentage of the current active discount
               * @format float
               */
              percentage: number;
              /** EndDate of the current active discount */
              endDate: string;
            } | null;
          };
          /** Total number of items contained in the aggregate */
          itemCount: number;
          /** Whether the global total amount of the aggregate has reached the minimum order value (for the brand) */
          hasReachedBrandMinimumOrderValue: boolean;
          /** Aggregate of the optional extra fees applied on some of the Purchasable Items contained in the list */
          applicableFees: (
            | {
                /** Type of the fee */
                type?: PurchasingListActionCrossListOperationTypeEnum5;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Country where the fee is applied
                 * @pattern ^[A-Z]{2}$
                 * @example "FR"
                 */
                shippingCountryIsoCode?: string;
              }
            | {
                /** Type of the fee */
                type?: PurchasingListActionCrossListOperationTypeEnum6;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount?: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
              }
            | {
                /** Type of the fee */
                type: PurchasingListActionCrossListOperationTypeEnum7;
                /**
                 * Amount of the fee
                 * @example {"currency":"EUR","amount":142}
                 */
                amount: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                };
                /**
                 * Amount left to reach the free shipping
                 * @example {"currency":"EUR","amount":142}
                 */
                amountLeftForFreeShipping: {
                  /**
                   * ISO 3-Letter Currency Code
                   * @example "EUR"
                   */
                  currency: string;
                  /** Lowest denomination of the currency this amount belongs to. */
                  amount: number;
                } | null;
                metadata: {
                  /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
                  offerName?: PurchasingListActionCrossListOperationOfferNameEnum1;
                  brandNonEligibleForAkPlusFreeShipping: boolean;
                  isDiscovery: boolean;
                  isEligibleForDiscoveryFreeShipping: boolean;
                  /** Minimum order amount to qualify for free shipping (cents) */
                  francoAmount?: number | null;
                  /** Shipping fee amount when below franco threshold (cents) */
                  francoFeeAmount?: number | null;
                  /** Maximum shipping fee amount (cents) */
                  francoMaxFeeAmount?: number | null;
                };
              }
          )[];
          /** Whether the brand can ship to the retailer country */
          canShipToRetailerCountry: boolean;
          /** Whether the items in this brand aggregate belong to a prepared order */
          isPreparedOrder: boolean;
          /** Whether all products in this brand aggregate are out of stock */
          everyProductOutOfStock: boolean;
          /** Count of items that are out_of_stock, product_disabled, or variant_disabled */
          unavailableItemsCount: number;
          /** Whether this aggregate contains at least one fresh product (storageTemperature !== null) */
          hasFreshProducts: boolean;
          /** Whether any item in this brand aggregate has insufficient stock (availableQuantity > 0 but limited) */
          hasInsufficientStockItems: boolean;
          /** Whether this aggregate contains at least one product that needs fresh input (needsFreshInput === true) */
          hasNeedsFreshInputProducts: boolean;
          /** Estimated delivery date range (max EDD across all products in the cart for this brand) */
          estimatedDelivery: {
            /** Minimum estimated delivery days for this brand aggregate */
            minDays: number | null;
            /** Maximum estimated delivery days for this brand aggregate */
            maxDays: number | null;
          };
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          items?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Name of the brand */
          name?: string;
          /** Path to the logo image of the brand */
          logoImagePath?: string;
          /**
           * Minimum amount (excl. taxes) threshold to reach in order to be able to place an order for this brand
           * @example {"currency":"EUR","amount":142}
           */
          minimumOrderValue?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * CountryObject
           * Country object
           */
          country?: {
            /**
             * [Short and unique alphanumeric codes to represent the relevant country](https://en.wikipedia.org/wiki/ISO_3166-2)
             * @pattern ^[A-Z]{2}$
             * @example "FR"
             */
            isoCode: string;
            name: string;
          };
          /** Whether the brand is enabled (i.e. has been accepted) or not */
          isEnabled?: boolean;
          /**
           * PurchasableAggregateBrandHolidayMode
           * Brand's holiday mode information
           */
          holidayMode?: {
            /** Whether the brand is currently on holiday mode */
            isEnabled: boolean;
            /**
             * End date of the holiday mode
             * @format date
             */
            endDate: string | null;
          };
        };
      }
  )[];
}

/** Type of the fee */
export enum GetBrandCartApplicableFeesTypeEnum {
  RetailerShippingFees = 'retailer_shipping_fees',
}

/** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
export enum GetBrandCartApplicableFeesOfferNameEnum {
  AnkorstorePlus = 'ankorstore_plus',
}

export interface GetBrandCartApplicableFeesData {
  applicableFees: {
    /** Type of the fee */
    type: GetBrandCartApplicableFeesTypeEnum;
    /**
     * Amount of the fee
     * @example {"currency":"EUR","amount":142}
     */
    amount: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * Amount left to reach the free shipping
     * @example {"currency":"EUR","amount":142}
     */
    amountLeftForFreeShipping: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    } | null;
    metadata: {
      /** Offer program name applied on this fee, present only when the retailer is enrolled in that offer */
      offerName?: GetBrandCartApplicableFeesOfferNameEnum;
      brandNonEligibleForAkPlusFreeShipping: boolean;
      isDiscovery: boolean;
      isEligibleForDiscoveryFreeShipping: boolean;
      /** Minimum order amount to qualify for free shipping (cents) */
      francoAmount?: number | null;
      /** Shipping fee amount when below franco threshold (cents) */
      francoFeeAmount?: number | null;
      /** Maximum shipping fee amount (cents) */
      francoMaxFeeAmount?: number | null;
    };
  }[];
}

/**
 * The cart lifecycle state.
 * @example "draft"
 */
export enum DuplicatePreparedOrderCartStateEnum {
  Draft = 'draft',
  Submitted = 'submitted',
  Confirmed = 'confirmed',
  Paid = 'paid',
}

/**
 * Why the product could not be re-added.
 * - `unavailable`: the variant no longer exists or is no longer sold by the brand.
 */
export enum DuplicatePreparedOrderCartReasonEnum {
  Unavailable = 'unavailable',
}

export interface DuplicatePreparedOrderCartData {
  /** PreparedOrderResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /**
     * PreparedOrder
     * A brand's prepared-order cart.
     */
    attributes: {
      /**
       * The cart lifecycle state.
       * @example "draft"
       */
      state?: DuplicatePreparedOrderCartStateEnum;
      /** Public preview URL, present once the cart is submitted or confirmed. */
      permalink?: string | null;
      /** The retailer the cart is prepared for, or `null` when unassigned. */
      customer?: object | null;
      items?: {
        id?: number;
        type?: 'order_item';
        /** PreparedOrderItemProduct */
        product?: {
          id?: number;
          type?: 'product';
          /** @format date-time */
          createdAt?: string;
          name?: string;
          images?: string[];
          link?: string | null;
          unitMultiplier?: number;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          originalWholesalePrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          wholesalePrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          retailPrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          discountEventPrice?: object | null;
          discountType?: string | null;
          discountRate?: number;
        };
        /** PreparedOrderItemProductVariant */
        variant?: {
          id?: number | null;
          sku?: string;
          ian?: string | null;
          /** @format date-time */
          createdAt?: string;
          name?: string;
          unitMultiplier?: number;
          price?: {
            currency?: string;
            /**
             * An object used to detail pricing information for various Resources.
             * @example {"currency":"EUR","amount":142}
             */
            retailPrice?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            wholesalePrice?: object | null;
            /**
             * An object used to detail pricing information for various Resources.
             * @example {"currency":"EUR","amount":142}
             */
            originalWholesalePrice?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
          };
          /** @format date-time */
          availableAt?: string | null;
          outOfStock?: boolean;
        };
        /** The number of packs. */
        quantity?: number;
        /** The number of units (packs multiplied by the pack size). */
        multipliedQuantity?: number;
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        unitPriceBeforeDiscount?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        unitPrice?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amountBeforeDiscount?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amount?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amountVat?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        amountWithVat?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
      }[];
      billingItems?: Record<string, any>[];
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmountBeforeDiscount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmount?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmountVat?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /**
       * An object used to detail pricing information for various Resources.
       * @example {"currency":"EUR","amount":142}
       */
      totalAmountWithVat?: {
        /**
         * ISO 3-Letter Currency Code
         * @example "EUR"
         */
        currency: string;
        /** Lowest denomination of the currency this amount belongs to. */
        amount: number;
      };
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      /** @format date-time */
      submittedAt?: string | null;
      /** @format date-time */
      paidAt?: string | null;
    };
    meta?: {
      /** Source products that could not be re-added to the duplicate. */
      unavailableItems?: {
        /**
         * Why the product could not be re-added.
         * - `unavailable`: the variant no longer exists or is no longer sold by the brand.
         */
        reason: DuplicatePreparedOrderCartReasonEnum;
        /** PreparedOrderItemProduct */
        product: {
          id?: number;
          type?: 'product';
          /** @format date-time */
          createdAt?: string;
          name?: string;
          images?: string[];
          link?: string | null;
          unitMultiplier?: number;
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          originalWholesalePrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          wholesalePrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * An object used to detail pricing information for various Resources.
           * @example {"currency":"EUR","amount":142}
           */
          retailPrice?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          discountEventPrice?: object | null;
          discountType?: string | null;
          discountRate?: number;
        };
        /** PreparedOrderItemProductVariant */
        variant: {
          id?: number | null;
          sku?: string;
          ian?: string | null;
          /** @format date-time */
          createdAt?: string;
          name?: string;
          unitMultiplier?: number;
          price?: {
            currency?: string;
            /**
             * An object used to detail pricing information for various Resources.
             * @example {"currency":"EUR","amount":142}
             */
            retailPrice?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
            wholesalePrice?: object | null;
            /**
             * An object used to detail pricing information for various Resources.
             * @example {"currency":"EUR","amount":142}
             */
            originalWholesalePrice?: {
              /**
               * ISO 3-Letter Currency Code
               * @example "EUR"
               */
              currency: string;
              /** Lowest denomination of the currency this amount belongs to. */
              amount: number;
            };
          };
          /** @format date-time */
          availableAt?: string | null;
          outOfStock?: boolean;
        };
      }[];
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum CreateCampaignTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum CreateCampaignTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum CreateCampaignStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum CreateCampaignTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum CreateCampaignTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum CreateCampaignTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum CreateCampaignTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum CreateCampaignTypeEnum5 {
  Email = 'email',
}

export enum CreateCampaignTypeEnum6 {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum CreateCampaignTypeEnum7 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum CreateCampaignStatusEnum1 {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum CreateCampaignTemplateVersionEnum1 {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum CreateCampaignTypeEnum8 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum CreateCampaignTypeEnum9 {
  Range = 'range',
}

/** The type of filter. */
export enum CreateCampaignTypeEnum10 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum CreateCampaignTypeEnum11 {
  Email = 'email',
}

export interface CreateCampaignParams {
  /**
   * Start the campaign after saving it.
   * @default false
   */
  start_campaign?: boolean;
}

export interface CreateCampaignData {
  /** A campaign resource */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: CreateCampaignTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: CreateCampaignTypeEnum1;
      /** The current status of the campaign. */
      status?: CreateCampaignStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: CreateCampaignTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: CreateCampaignTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: CreateCampaignTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: CreateCampaignTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: CreateCampaignTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetCampaignsTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum GetCampaignsTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum GetCampaignsStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum GetCampaignsTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum GetCampaignsTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum GetCampaignsTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum GetCampaignsTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum GetCampaignsTypeEnum5 {
  Email = 'email',
}

export interface GetCampaignsData {
  /** A collection of campaign resources. */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: GetCampaignsTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: GetCampaignsTypeEnum1;
      /** The current status of the campaign. */
      status?: GetCampaignsStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: GetCampaignsTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: GetCampaignsTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: GetCampaignsTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: GetCampaignsTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: GetCampaignsTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetCampaignTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum GetCampaignTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum GetCampaignStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum GetCampaignTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum GetCampaignTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum GetCampaignTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum GetCampaignTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum GetCampaignTypeEnum5 {
  Email = 'email',
}

export interface GetCampaignData {
  /** A campaign resource */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: GetCampaignTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: GetCampaignTypeEnum1;
      /** The current status of the campaign. */
      status?: GetCampaignStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: GetCampaignTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: GetCampaignTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: GetCampaignTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: GetCampaignTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: GetCampaignTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum UpdateCampaignTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum UpdateCampaignTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum UpdateCampaignStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum UpdateCampaignTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum UpdateCampaignTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum UpdateCampaignTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum UpdateCampaignTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum UpdateCampaignTypeEnum5 {
  Email = 'email',
}

export enum UpdateCampaignTypeEnum6 {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum UpdateCampaignTypeEnum7 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum UpdateCampaignStatusEnum1 {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum UpdateCampaignTemplateVersionEnum1 {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum UpdateCampaignTypeEnum8 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum UpdateCampaignTypeEnum9 {
  Range = 'range',
}

/** The type of filter. */
export enum UpdateCampaignTypeEnum10 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum UpdateCampaignTypeEnum11 {
  Email = 'email',
}

export interface UpdateCampaignParams {
  /**
   * Start the campaign after saving it.
   * @default false
   */
  start_campaign?: boolean;
  /**
   * The globally-unique identifier of the campaign
   * @format uuid
   */
  campaignId: string;
}

export interface UpdateCampaignData {
  /** A campaign resource */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: UpdateCampaignTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: UpdateCampaignTypeEnum1;
      /** The current status of the campaign. */
      status?: UpdateCampaignStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: UpdateCampaignTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: UpdateCampaignTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: UpdateCampaignTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: UpdateCampaignTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: UpdateCampaignTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export type DeleteCampaignData = any;

export enum GetCampaignDeliveriesTypeEnum {
  CampaignDelivery = 'campaign-delivery',
}

/** The current status of the delivery. */
export enum GetCampaignDeliveriesStatusEnum {
  Queued = 'queued',
  Undeliverable = 'undeliverable',
  Attempted = 'attempted',
  Failed = 'failed',
  Sent = 'sent',
  Delivered = 'delivered',
  Bounced = 'bounced',
  Suppressed = 'suppressed',
}

export interface GetCampaignDeliveriesData {
  /** A collection of campaign delivery resources. */
  data: {
    /**
     * A globally-unique identifier for the delivery.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: GetCampaignDeliveriesTypeEnum;
    attributes: {
      /** The current status of the delivery. */
      status?: GetCampaignDeliveriesStatusEnum;
      /**
       * The recipient's email address.
       * @format email
       */
      email?: string;
      /**
       * The recipient's language represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
       * @example "en"
       */
      language?: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum ScheduleCampaignTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum ScheduleCampaignTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum ScheduleCampaignStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum ScheduleCampaignTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum ScheduleCampaignTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum ScheduleCampaignTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum ScheduleCampaignTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum ScheduleCampaignTypeEnum5 {
  Email = 'email',
}

export enum ScheduleCampaignTypeEnum6 {
  Campaign = 'campaign',
}

export interface ScheduleCampaignData {
  /** A campaign resource */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: ScheduleCampaignTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: ScheduleCampaignTypeEnum1;
      /** The current status of the campaign. */
      status?: ScheduleCampaignStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: ScheduleCampaignTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: ScheduleCampaignTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: ScheduleCampaignTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: ScheduleCampaignTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: ScheduleCampaignTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum CancelScheduleCampaignTypeEnum {
  Campaign = 'campaign',
}

/** The type of campaign. */
export enum CancelScheduleCampaignTypeEnum1 {
  Regular = 'regular',
  Referral = 'referral',
}

/** The current status of the campaign. */
export enum CancelScheduleCampaignStatusEnum {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}

/** The template version that this campaign uses. */
export enum CancelScheduleCampaignTemplateVersionEnum {
  Value1 = '1',
  Value2 = '2',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum CancelScheduleCampaignTypeEnum2 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum CancelScheduleCampaignTypeEnum3 {
  Range = 'range',
}

/** The type of filter. */
export enum CancelScheduleCampaignTypeEnum4 {
  Boolean = 'boolean',
}

/** The type of message. */
export enum CancelScheduleCampaignTypeEnum5 {
  Email = 'email',
}

export interface CancelScheduleCampaignData {
  /** A campaign resource */
  data: {
    /**
     * A globally-unique identifier for the campaign.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id?: string;
    type: CancelScheduleCampaignTypeEnum;
    attributes: {
      /** Readable name of the campaign. */
      name?: string;
      /** The type of campaign. */
      type?: CancelScheduleCampaignTypeEnum1;
      /** The current status of the campaign. */
      status?: CancelScheduleCampaignStatusEnum;
      /**
       * The UTC datetime at which the campaign is scheduled to be dispatched, formatted as ISO 8601 (RFC 3339). `null` when the campaign is not scheduled.
       * @format date-time
       */
      scheduledAt?: null | string;
      /** The template version that this campaign uses. */
      templateVersion?: CancelScheduleCampaignTemplateVersionEnum;
      /** The target audience for this campaign. */
      audience?: {
        /** Defines the target audience by selecting contacts matching the given set of filters. All of the filters must match. This functions as a list of `AND` conditions. */
        filters?: (
          | {
              /**
               * The type of filter.
               *
               * This filter returns results that contain a specific attribute value.<br/>
               * Available on **text**, **number** or **date** attributes and supports arrays.
               */
              type: CancelScheduleCampaignTypeEnum2;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * The negation operator. When set to `true` it selects all results
               * that do not satisfy the filter condition.
               * @default false
               */
              not?: boolean;
              /**
               * The value upon which to filter.
               *
               * The value must be an exact match. When operating on strings, the filter
               * is case-sensitive (i.e. *“French”* will not match on *“french”*).
               */
              value: string | number | (string | number)[];
            }
          | {
              /**
               * The type of filter.
               *
               * This filter returns results over a range of dates or numbers.<br/>
               * Available on **number** or **date** attributes.
               */
              type: CancelScheduleCampaignTypeEnum3;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /**
               * Inclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              min?: number | string;
              /**
               * Inclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              max?: number | string;
              /**
               * Exclusive lower bound of the range.<br/>
               * Required if `max` or `exclusiveMax` is not given.
               */
              exclusiveMin?: number | string;
              /**
               * Exclusive upper bound of the range.<br/>
               * Required if `min` or `exclusiveMin` is not given.
               */
              exclusiveMax?: number | string;
            }
          | {
              /** The type of filter. */
              type: CancelScheduleCampaignTypeEnum4;
              /** The name of the attribute upon which to apply the filter. */
              name: string;
              /** The value upon which to filter. */
              value: boolean;
            }
        )[];
      };
      /** Content of the campaign. */
      content?: {
        /**
         * The default language for this campaign.
         * @example "en"
         */
        defaultLanguage?: string;
        /** The campaign messages. */
        messages?: ({
          /** The type of message. */
          type: CancelScheduleCampaignTypeEnum5;
          /**
           * The language for this message represented as a 2-letter code conforming to [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag).
           * @example "en"
           */
          language?: string;
        } & {
          /** The name to display as the sender name for the email. */
          from?: string;
          /** The subject of this email message. */
          subject?: string;
          /** The HTML body for this email message. */
          body?: string;
          /** The HTML footer for this email message, used on version 1 templates. */
          footer?: null | string;
          /** The label of the call-to-action button, used on version 1 templates. */
          ctaText?: null | string;
        })[];
      };
    };
    meta?: {
      /**
       * The date when this campaign was created.
       * @format date-time
       */
      createdAt?: string;
      /**
       * The date when this campaign was verified.
       * @format date-time
       */
      verifiedAt?: null | string;
      /**
       * The date when this campaign was completed.
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * The number of languages this campaign targets.
       * @min 0
       */
      languageCount?: number;
      /** The report summary. */
      report?: {
        /**
         * The total number of recipients for this campaign.
         * @min 0
         */
        recipientCount?: number;
        /**
         * The total number of successful deliveries.
         * @min 0
         */
        totalDelivered?: number;
        /**
         * The number of unique opens.
         * @min 0
         */
        opens?: number;
        /**
         * The number of unique clicks.
         * @min 0
         */
        clicks?: number;
        /**
         * The number of unique opens divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        openRate?: number;
        /**
         * The number of unique clicks divided by the total number of successful deliveries.
         * @format float
         * @min 0
         * @max 100
         */
        clickRate?: number;
      };
      [key: string]: any;
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetCampaignTemplatesData {
  /** A collection of campaign resources. */
  data: {
    /** The unique identifier for the template */
    id?: string;
    /** The localized name of the template */
    name?: string;
    /** A localized description of the template */
    description?: string;
    /** A collection of template contents */
    contents?: {
      /** The iso-2 language code of the content */
      language: string;
      /** The type of the content */
      type: string;
    }[];
    /** A collection of allowed segment types */
    allowedSegments?: string[];
    /** A collection of segments for which this template is the default one */
    defaultForSegments?: string[];
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetCampaignTemplateData {
  /** A campaign template resource */
  data: {
    /** The unique identifier for the template */
    id?: string;
    /** The localized name of the template */
    name?: string;
    /** A localized description of the template */
    description?: string;
    /** A collection of template contents */
    contents?: {
      /** The iso-2 language code of the content */
      language: string;
      /** The type of the content */
      type: string;
    }[];
    /** A collection of allowed segment types */
    allowedSegments?: string[];
    /** A collection of segments for which this template is the default one */
    defaultForSegments?: string[];
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum ListRutterIntegrationsCatalogSynchronizationWorkflowEnum {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum ListRutterIntegrationsShopifyCatalogPriceStrategyEnum {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

export interface ListRutterIntegrationsData {
  data: {
    /**
     * @default "rutter-integrations"
     * @example "rutter-integrations"
     */
    type: string;
    /** In the current implementation this ID matches the ID of the target brand. In the future most probably will be replaced with Rutter ingeration entity identifier. */
    id: string;
    attributes: {
      /**
       * Access token received from Rutter API
       * @example "937c5af4-d0a4-46b5-820d-300e75d982a5"
       */
      accessToken: string;
      /**
       * Target platform name
       * @example "SHOPIFY"
       */
      platformName: string;
      /**
       * Rutter Order Tags
       * List of order tags to be added to each new order synchronized to external Rutter platform
       * @maxItems 5
       * @uniqueItems true
       */
      orderTags?: string[];
      /** Configuration parameters for the integration */
      configuration?: null | {
        /** Initial financial status for all order synced to Shopify */
        order_default_financial_status?: string;
        /** Inventory policy for new orders created on Shopify. */
        inventory_policy?: string;
        /** To enable/disable synchronization of Shopify inventory to Ankorstore. */
        inventory_synchronization?: boolean;
        /** To initiate full catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization?: boolean;
        /** To enable/disable continuous catalog synchronization (prices) from Shopify to Ankorstore. */
        catalog_continuous_synchronization?: boolean;
        /** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization_workflow?: ListRutterIntegrationsCatalogSynchronizationWorkflowEnum;
        /** Strategy to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_strategy?: ListRutterIntegrationsShopifyCatalogPriceStrategyEnum;
        /** Multiplier (as float) to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_multiplier?: number;
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum CreateRutterIntegrationCatalogSynchronizationWorkflowEnum {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum CreateRutterIntegrationShopifyCatalogPriceStrategyEnum {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum CreateRutterIntegrationCatalogSynchronizationWorkflowEnum1 {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum CreateRutterIntegrationShopifyCatalogPriceStrategyEnum1 {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

export interface CreateRutterIntegrationData {
  data: {
    /**
     * @default "rutter-integrations"
     * @example "rutter-integrations"
     */
    type: string;
    /** In the current implementation this ID matches the ID of the target brand. In the future most probably will be replaced with Rutter ingeration entity identifier. */
    id: string;
    attributes: {
      /**
       * Access token received from Rutter API
       * @example "937c5af4-d0a4-46b5-820d-300e75d982a5"
       */
      accessToken: string;
      /**
       * Target platform name
       * @example "SHOPIFY"
       */
      platformName: string;
      /**
       * Rutter Order Tags
       * List of order tags to be added to each new order synchronized to external Rutter platform
       * @maxItems 5
       * @uniqueItems true
       */
      orderTags?: string[];
      /** Configuration parameters for the integration */
      configuration?: null | {
        /** Initial financial status for all order synced to Shopify */
        order_default_financial_status?: string;
        /** Inventory policy for new orders created on Shopify. */
        inventory_policy?: string;
        /** To enable/disable synchronization of Shopify inventory to Ankorstore. */
        inventory_synchronization?: boolean;
        /** To initiate full catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization?: boolean;
        /** To enable/disable continuous catalog synchronization (prices) from Shopify to Ankorstore. */
        catalog_continuous_synchronization?: boolean;
        /** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization_workflow?: CreateRutterIntegrationCatalogSynchronizationWorkflowEnum;
        /** Strategy to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_strategy?: CreateRutterIntegrationShopifyCatalogPriceStrategyEnum;
        /** Multiplier (as float) to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_multiplier?: number;
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export type DeleteRutterIntegrationData = any;

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum UpdateRutterIntegrationCatalogSynchronizationWorkflowEnum {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum UpdateRutterIntegrationShopifyCatalogPriceStrategyEnum {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum UpdateRutterIntegrationCatalogSynchronizationWorkflowEnum1 {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum UpdateRutterIntegrationShopifyCatalogPriceStrategyEnum1 {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

export interface UpdateRutterIntegrationData {
  data: {
    /**
     * @default "rutter-integrations"
     * @example "rutter-integrations"
     */
    type: string;
    /** In the current implementation this ID matches the ID of the target brand. In the future most probably will be replaced with Rutter ingeration entity identifier. */
    id: string;
    attributes: {
      /**
       * Access token received from Rutter API
       * @example "937c5af4-d0a4-46b5-820d-300e75d982a5"
       */
      accessToken: string;
      /**
       * Target platform name
       * @example "SHOPIFY"
       */
      platformName: string;
      /**
       * Rutter Order Tags
       * List of order tags to be added to each new order synchronized to external Rutter platform
       * @maxItems 5
       * @uniqueItems true
       */
      orderTags?: string[];
      /** Configuration parameters for the integration */
      configuration?: null | {
        /** Initial financial status for all order synced to Shopify */
        order_default_financial_status?: string;
        /** Inventory policy for new orders created on Shopify. */
        inventory_policy?: string;
        /** To enable/disable synchronization of Shopify inventory to Ankorstore. */
        inventory_synchronization?: boolean;
        /** To initiate full catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization?: boolean;
        /** To enable/disable continuous catalog synchronization (prices) from Shopify to Ankorstore. */
        catalog_continuous_synchronization?: boolean;
        /** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization_workflow?: UpdateRutterIntegrationCatalogSynchronizationWorkflowEnum;
        /** Strategy to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_strategy?: UpdateRutterIntegrationShopifyCatalogPriceStrategyEnum;
        /** Multiplier (as float) to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_multiplier?: number;
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
export enum RutterIntegrationStoreShopifyCatalogSynchronizationWorkflowEnum {
  Import = 'import',
  Update = 'update',
}

/** Strategy to use for price synchronization from Shopify to Ankorstore. */
export enum RutterIntegrationStoreShopifyShopifyCatalogPriceStrategyEnum {
  Retail = 'retail',
  Wholesale = 'wholesale',
}

export interface RutterIntegrationStoreShopifyData {
  data: {
    /**
     * @default "rutter-integrations"
     * @example "rutter-integrations"
     */
    type: string;
    /** In the current implementation this ID matches the ID of the target brand. In the future most probably will be replaced with Rutter ingeration entity identifier. */
    id: string;
    attributes: {
      /**
       * Access token received from Rutter API
       * @example "937c5af4-d0a4-46b5-820d-300e75d982a5"
       */
      accessToken: string;
      /**
       * Target platform name
       * @example "SHOPIFY"
       */
      platformName: string;
      /**
       * Rutter Order Tags
       * List of order tags to be added to each new order synchronized to external Rutter platform
       * @maxItems 5
       * @uniqueItems true
       */
      orderTags?: string[];
      /** Configuration parameters for the integration */
      configuration?: null | {
        /** Initial financial status for all order synced to Shopify */
        order_default_financial_status?: string;
        /** Inventory policy for new orders created on Shopify. */
        inventory_policy?: string;
        /** To enable/disable synchronization of Shopify inventory to Ankorstore. */
        inventory_synchronization?: boolean;
        /** To initiate full catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization?: boolean;
        /** To enable/disable continuous catalog synchronization (prices) from Shopify to Ankorstore. */
        catalog_continuous_synchronization?: boolean;
        /** Product integration workflow to use for catalog synchronization from Shopify to Ankorstore. */
        catalog_synchronization_workflow?: RutterIntegrationStoreShopifyCatalogSynchronizationWorkflowEnum;
        /** Strategy to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_strategy?: RutterIntegrationStoreShopifyShopifyCatalogPriceStrategyEnum;
        /** Multiplier (as float) to use for price synchronization from Shopify to Ankorstore. */
        shopify_catalog_price_multiplier?: number;
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum PlatformVerificationsCodeEnum {
  INVALID_URL_FORMAT = 'INVALID_URL_FORMAT',
  SITE_DOES_NOT_EXIST = 'SITE_DOES_NOT_EXIST',
  PLATFORM_MISMATCH = 'PLATFORM_MISMATCH',
  TARGET_RESPONDED_WITH_ERROR = 'TARGET_RESPONDED_WITH_ERROR',
  UNABLE_TO_CONNECT = 'UNABLE_TO_CONNECT',
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',
}

export interface PlatformVerificationsData {
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      platformUrl: string;
      authenticationUrl: string | null;
    };
  };
}

export type GetApiMobileV1SearchBrandsIdProductsData = any;

export interface GetApiMobileV1SearchProductsParams {
  /** The search query. */
  query: string;
  /**
   * The total number of pages in the search response.
   * @min 1
   * @max 100
   * @default 20
   */
  hitsPerPage?: number;
  /**
   * The current page of results (zero-indexed).
   * @min 0
   * @max 9223372036854776000
   */
  page?: number;
}

/** @example {"paging":{"page":0,"pages":500,"items_per_page":2,"total":1405},"data":[{"id":112233,"name":"PlateTastics","images":["/products/images/112233-asdfa2ac92fa6.jpg","/products/images/112233-4123asdbaxcvxeb.jpg"],"retail_price":{"currency":"EUR","amount":160},"wholesale_price":{"currency":"EUR","amount":78},"location":"France","brand":{"id":123,"name":"We Sell Everything","images":["/brands/rounded/123-47d64faujbbla9.jpg"]}},{"id":332211,"name":"Super plates","images":["/products/images/332211-3fsfsdfasfc9ddb5.jpg","/products/images/332211-42241basdfsadfa.jpg"],"retail_price":{"currency":"EUR","amount":300},"wholesale_price":{"currency":"EUR","amount":142},"location":"United Kingdom","brand":{"id":321,"name":"Plate Kings","images":["/brands/rounded/321-4balsdfjbla12.jpg"]}}]} */
export interface GetApiMobileV1SearchProductsData {
  paging: {
    page: number;
    pages: number;
    items_per_page: number;
    total: number;
  };
  data: {
    id: number;
    name: string;
    images: string[];
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    retail_price: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /**
     * An object used to detail pricing information for various Resources.
     * @example {"currency":"EUR","amount":142}
     */
    wholesale_price: {
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** Lowest denomination of the currency this amount belongs to. */
      amount: number;
    };
    /** @example "France" */
    location: string;
    brand: {
      id: number;
      name: string;
      images: string[];
    };
    /**
     * The base URL for product images
     * @example "https://img.ankorstore.com"
     */
    image_base_url: string;
  }[];
}

export enum ProductsListFulfillableFulfillableTypeEnum {
  Item = 'item',
  Bundle = 'bundle',
}

export enum ProductsListFulfillableClassificationCodeEnum {
  AerosolsInflammables = 'Aérosols inflammables',
  BoissonAlcoolisees = 'Boisson alcoolisées',
  CerealesGrainsProduitsAlimentaires = 'Céréales, grains, produits alimentaires',
  ContenantPilesOuBatteriesLithium = 'Contenant Piles ou batteries lithium',
  Corrosifs = 'Corrosifs',
  GazInflammables = 'Gaz inflammables',
  LiquidesInflammables = 'Liquides inflammables',
  MateriauxComburants = 'Matériaux comburants',
  Plastique = 'Plastique',
  ProduitsBois = 'Produits bois',
  ProduitsExplosifs = 'Produits explosifs',
  ProduitsGazeuxSousPression = 'Produits gazeux sous pression',
  ProduitsToxiquesToxicite = 'Produits toxiques / Toxicité',
  SolidesInflammables = 'Solides inflammables',
  AutresCombustibles = 'Autres combustibles',
  AutresDangereux = 'Autres dangereux',
}

export enum ProductsListFulfillableStatusEnum {
  Created = 'created',
  Pending = 'pending',
  Synced = 'synced',
}

export enum ProductsListFulfillableStockStatusEnum {
  InStock = 'in_stock',
  SoonOutOfStock = 'soon_out_of_stock',
  OutOfStock = 'out_of_stock',
  NeverReplenished = 'never_replenished',
}

export enum ProductsListFulfillableFulfillableTypeEnum1 {
  Item = 'item',
  Bundle = 'bundle',
}

export interface ProductsListFulfillableParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /** Request the subset with a given fulfillmentItem status */
  'filter[fulfillmentItemStatus]'?: FilterFulfillmentItemStatusEnum;
  /** Exclude product variant which are mapped to a bundle */
  'filter[bundles]'?: boolean;
  /** Search for matches within the SKU, referenceId, barcode and the product name, including translations */
  searchTerm?: string;
  /** Specify what attribute(s) to sort by */
  sort?: SortEnum;
}

/** Request the subset with a given fulfillmentItem status */
export enum FilterFulfillmentItemStatusEnum {
  Synced = 'synced',
  Pending = 'pending',
}

/** Specify what attribute(s) to sort by */
export enum SortEnum {
  ExpectZeroStockAt = 'expectZeroStockAt',
  ValueExpectZeroStockAt = '-expectZeroStockAt',
  StockStatus = 'stockStatus',
  ValueStockStatus = '-stockStatus',
  AvailableQuantityUnits = 'availableQuantityUnits',
  ValueAvailableQuantityUnits = '-availableQuantityUnits',
  ProductArchived = 'productArchived',
  ValueProductArchived = '-productArchived',
}

export interface ProductsListFulfillableData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes:
      | ({
          /** @format uuid */
          fulfillableId?: string;
          fulfillableType?: ProductsListFulfillableFulfillableTypeEnum;
          /** Available batch quantity in the warehouse */
          availableQuantity?: number;
          /** Whether the product is archived in the catalog */
          productArchived?: boolean;
          /** Images from the catalog (as relative path) */
          productImages?: string[];
          /** Name of the product in the catalog */
          productName?: string;
          /** Stock Keeping Unit */
          sku?: string;
        } & {
          /**
           * Unique barcode (EAN13 or ITF14)
           * @pattern ^\d{13,14}$
           */
          barcode?: string;
          /** Number of units in a batch. This indicates the lowest denominator of items that can be fulfilled */
          unitsPerBatch?: number;
          /**
           * Margin (as a percentage) between the cost price and wholesale price. Used for insurance purposes
           * @format float
           * @min 0
           * @max 100
           */
          unitCostMargin?: number;
          /** Name of the product shared with warehouse systems */
          warehouseProductName?: string;
          /** Name of the category shared with warehouse systems */
          warehouseCategoryName?: string;
          classificationCode?: ProductsListFulfillableClassificationCodeEnum;
          /**
           * Whether the item in the warehouse is tracked for expiry
           * @default false
           */
          expiryTracked?: boolean | null;
          /** Shelf life of the item in days */
          shelfLife?: number | null;
          /**
           * Whether the item in the warehouse is tracked by lot
           * @default false
           */
          lotTracked?: boolean | null;
          /**
           * Whether the item is considered fragile
           * @default false
           */
          isFragile?: boolean | null;
          /**
           * Whether the item is considered organic
           * @default false
           */
          isOrganic?: boolean | null;
          /**
           * Whether the item needs to be repacked before shipping
           * @default false
           */
          needRepack?: boolean | null;
          /**
           * Whether the item needs to be relabeled before shipping
           * @default false
           */
          needRelabel?: boolean | null;
          /**
           * Code for alcohol classification, as used in the warehouse
           * @min 1
           * @max 11
           */
          alcoholCode?: number | null;
          /**
           * Percentage of alcohol in the item
           * @format float
           * @min 0
           * @max 100
           */
          alcoholPercentage?: number | null;
          /**
           * Volume of liquid per pack in liter
           * @format float
           * @min 0
           * @max 100
           */
          volumeOfLiquidPerPack?: number | null;
          /**
           * Installation Classified for the Protection of the Environment, as used in the warehouse
           * @min 1000
           * @max 4999
           */
          icpeCode?: number | null;
          status?: ProductsListFulfillableStatusEnum;
          /** How many days stock is expected to last, based on historical data.  Null if insufficient data available to create an estimate */
          expectedStockForDays?: number | null;
          stockStatus?: ProductsListFulfillableStockStatusEnum;
          /** Reference for the fulfillment item, used in the warehouse */
          referenceId?: string;
        })
      | ({
          /** @format uuid */
          fulfillableId?: string;
          fulfillableType?: ProductsListFulfillableFulfillableTypeEnum1;
          /** Available batch quantity in the warehouse */
          availableQuantity?: number;
          /** Whether the product is archived in the catalog */
          productArchived?: boolean;
          /** Images from the catalog (as relative path) */
          productImages?: string[];
          /** Name of the product in the catalog */
          productName?: string;
          /** Stock Keeping Unit */
          sku?: string;
        } & {
          bundleItems?: {
            /** @format uuid */
            fulfillmentItemId?: string;
            /** number of batches of this item included in the bundle */
            quantity?: number;
          }[];
        });
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
}

/** Request the subset with a given fulfillmentItem status */
export enum ProductsListFulfillableParams1FilterFulfillmentItemStatusEnum {
  Synced = 'synced',
  Pending = 'pending',
}

/** Specify what attribute(s) to sort by */
export enum ProductsListFulfillableParams1SortEnum {
  ExpectZeroStockAt = 'expectZeroStockAt',
  ValueExpectZeroStockAt = '-expectZeroStockAt',
  StockStatus = 'stockStatus',
  ValueStockStatus = '-stockStatus',
  AvailableQuantityUnits = 'availableQuantityUnits',
  ValueAvailableQuantityUnits = '-availableQuantityUnits',
  ProductArchived = 'productArchived',
  ValueProductArchived = '-productArchived',
}

export enum FulfillmentCreateOrderStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum FulfillmentCreateOrderRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum FulfillmentCreateOrderStatusEnum1 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

export enum FulfillmentCreateOrderStatusEnum2 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum FulfillmentCreateOrderRecipientTypeEnum1 {
  Consumer = 'consumer',
  Business = 'business',
}

export enum FulfillmentCreateOrderStatusEnum3 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
}

export enum FulfillmentCreateOrderDetailEnum {
  NotAFulfillmentBrand = 'not_a_fulfillment_brand',
  UnavailableItems = 'unavailable_items',
  AlreadyBeingFulfilled = 'already_being_fulfilled',
  NotAvailableForInternationalOrders = 'not_available_for_international_orders',
  MissingHsCodeForInternationalOrder = 'missing_hs_code_for_international_order',
  UnresolvableProductVariantUuids = 'unresolvable_product_variant_uuids',
}

export enum FulfillmentCreateOrderTypeEnum {
  FulfillmentOrders = 'fulfillment-orders',
}

export enum FulfillmentCreateOrderServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum FulfillmentCreateOrderRecipientTypeEnum2 {
  Consumer = 'consumer',
  Business = 'business',
}

export enum FulfillmentCreateOrderServicesEnum1 {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum FulfillmentCreateOrderRecipientTypeEnum3 {
  Consumer = 'consumer',
  Business = 'business',
}

export interface FulfillmentCreateOrderParams {
  /** Validate the request without creating the order */
  validateOrder?: boolean;
}

export interface FulfillmentCreateOrderData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Unique human readable reference for the fulfillment order, used for communication with the warehouse
       * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
       */
      reference?: string;
      /** @format uuid */
      masterOrderUuid: string;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /**
       * [Deprecated] This concept no longer exists. Please refer to the related master order if you need to distinguish between internal and external orders
       * @deprecated
       */
      isDirect?: boolean;
      /** Is shipping fee charged for order, default to true */
      shippingCharged?: boolean;
      status?: FulfillmentCreateOrderStatusEnum;
      /** @format date-time */
      createdAt?: string;
      /** Shipping address for the recipient. Required for order creation */
      shippingAddress?: {
        /** @minLength 1 */
        firstName?: string;
        /** @minLength 1 */
        lastName?: string;
        company?: string;
        /** @minLength 1 */
        phone?: string;
        email?: string;
        /** @minLength 1 */
        street?: string;
        /** @minLength 1 */
        city?: string;
        postalCode?: string;
        /** @pattern ^[A-Z]{2}$ */
        country?: string;
      } | null;
      /** Optional billing address for the recipient */
      billingAddress?: {
        /** @minLength 1 */
        firstName?: string;
        /** @minLength 1 */
        lastName?: string;
        company?: string;
        /** @minLength 1 */
        phone?: string;
        email?: string;
        /** @minLength 1 */
        street?: string;
        /** @minLength 1 */
        city?: string;
        postalCode?: string;
        /** @pattern ^[A-Z]{2}$ */
        country?: string;
      } | null;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        /** quantity in batches */
        quantity: number;
      }[];
      /**
       * The type of recipient for a fulfillment order
       * @default "business"
       */
      recipientType?: FulfillmentCreateOrderRecipientTypeEnum;
    };
    links?: {
      order?: string;
    };
    relationships?: {
      statusUpdates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      shipments?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        /** Shipment tracking info. Will be null until this information is available */
        attributes?: {
          trackingNumber?: string;
          trackingLink?: string | null;
          /** Shipping provider identifier */
          provider?: string;
          /** Shipping provider display name */
          providerName?: string;
          /** Parcel or pallet width (in MM) */
          width?: number;
          /** Parcel or pallet length (in MM) */
          length?: number;
          /** Parcel or pallet height (in MM) */
          height?: number;
          /** Parcel or pallet weight (in GR) */
          weight?: number;
          /** @format date-time */
          createdAt?: string;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        /** Fulfillment order status update */
        attributes?: {
          status?: FulfillmentCreateOrderStatusEnum1;
          /** @format date-time */
          receivedAt?: string;
        };
      }
  )[];
}

export interface FulfillmentListWarehousesData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** FulfillmentItem */
    attributes: {
      code: string;
      name: string;
      addresseLine1?: string;
      addresseLine2?: string;
      postalCode: string;
      city: string;
      /** @pattern ^[A-Z]{2}$ */
      countryCode: string;
      email: string;
      phone: string;
      /** @format uuid */
      astralLocationId: string | null;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface FulfillmentGetWarehouseData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** FulfillmentItem */
    attributes: {
      code: string;
      name: string;
      addresseLine1?: string;
      addresseLine2?: string;
      postalCode: string;
      city: string;
      /** @pattern ^[A-Z]{2}$ */
      countryCode: string;
      email: string;
      phone: string;
      /** @format uuid */
      astralLocationId: string | null;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentGetBrandBillingCategoryEnum {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum FulfillmentGetBrandParcelCarrierEnum {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum FulfillmentGetBrandPalletCarrierEnum {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export interface FulfillmentGetBrandData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      warehouseId: string;
      billingCategory: FulfillmentGetBrandBillingCategoryEnum;
      reference: string;
      parcelCarrier?: FulfillmentGetBrandParcelCarrierEnum;
      palletCarrier?: FulfillmentGetBrandPalletCarrierEnum;
      maxParcelShipmentWeight?: number | null;
    };
    relationships?: {
      warehouse?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** FulfillmentItem */
    attributes: {
      code: string;
      name: string;
      addresseLine1?: string;
      addresseLine2?: string;
      postalCode: string;
      city: string;
      /** @pattern ^[A-Z]{2}$ */
      countryCode: string;
      email: string;
      phone: string;
      /** @format uuid */
      astralLocationId: string | null;
    };
  }[];
}

export enum FulfillmentCreateBrandBillingCategoryEnum {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum FulfillmentCreateBrandParcelCarrierEnum {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum FulfillmentCreateBrandPalletCarrierEnum {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export enum FulfillmentCreateBrandBillingCategoryEnum1 {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum FulfillmentCreateBrandParcelCarrierEnum1 {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum FulfillmentCreateBrandPalletCarrierEnum1 {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export enum FulfillmentCreateBrandBillingCategoryEnum2 {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum FulfillmentCreateBrandParcelCarrierEnum2 {
  DPD_CLA = 'DPD_CLA',
  DPD_PRE = 'DPD_PRE',
  UPSB2B = 'UPS_B2B',
  UPSB2C = 'UPS_B2C',
}

export enum FulfillmentCreateBrandPalletCarrierEnum2 {
  KNC01C = 'KNC01_C',
  KNC02C = 'KNC02_C',
  DE_MES = 'DE_MES',
  DE_MEI = 'DE_MEI',
}

export interface FulfillmentCreateBrandData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      warehouseId: string;
      billingCategory: FulfillmentCreateBrandBillingCategoryEnum;
      reference: string;
      parcelCarrier?: FulfillmentCreateBrandParcelCarrierEnum;
      palletCarrier?: FulfillmentCreateBrandPalletCarrierEnum;
      maxParcelShipmentWeight?: number | null;
    };
    relationships?: {
      warehouse?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** FulfillmentItem */
    attributes: {
      code: string;
      name: string;
      addresseLine1?: string;
      addresseLine2?: string;
      postalCode: string;
      city: string;
      /** @pattern ^[A-Z]{2}$ */
      countryCode: string;
      email: string;
      phone: string;
      /** @format uuid */
      astralLocationId: string | null;
    };
  }[];
}

export enum IntegrationListExternalIntegrationsPlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum IntegrationListExternalIntegrationsStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export interface IntegrationListExternalIntegrationsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      platform: IntegrationListExternalIntegrationsPlatformEnum;
      status: IntegrationListExternalIntegrationsStatusEnum;
    };
  }[];
}

export enum CreateOrderPayAccountStatusEnum {
  Active = 'active',
  Trialling = 'trialling',
  Churned = 'churned',
}

/** The current status of the subscription. */
export enum CreateOrderPayAccountStatusEnum1 {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

/** Unit of time. */
export enum CreateOrderPayAccountUnitEnum {
  Day = 'day',
  Month = 'month',
}

/** Unit of time. */
export enum CreateOrderPayAccountUnitEnum1 {
  Day = 'day',
  Month = 'month',
}

export enum CreateOrderPayAccountStatusEnum2 {
  Active = 'active',
  Trialling = 'trialling',
  Churned = 'churned',
}

/** The current status of the subscription. */
export enum CreateOrderPayAccountStatusEnum3 {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

/** Unit of time. */
export enum CreateOrderPayAccountUnitEnum2 {
  Day = 'day',
  Month = 'month',
}

/** Unit of time. */
export enum CreateOrderPayAccountUnitEnum3 {
  Day = 'day',
  Month = 'month',
}

export interface CreateOrderPayAccountData {
  /** OrderPayAccountResource */
  data: {
    type: 'order-pay-account';
    /**
     * A globally-unique identifier for the account.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id: string;
    attributes: {
      status?: CreateOrderPayAccountStatusEnum;
      /**
       * Date when the account was created.
       * @format date-time
       */
      createdAt?: string;
      /** The user's acceptance of the terms and conditions. */
      termsAcceptance?: {
        /**
         * The version of the terms and conditions. Defaults to the latest version.
         * @example "2025.04"
         */
        termsVersion?: string;
        /**
         * Date when the user accepted the terms and conditions.
         * @format date-time
         */
        acceptedAt?: string;
      } | null;
      subscription?: {
        /** The current status of the subscription. */
        status?: CreateOrderPayAccountStatusEnum1;
        /**
         * Date when the subscription started or `null` if it hasn't started yet.
         * @format date-time
         */
        startedAt?: null | string;
        /**
         * Date when the subscription has ended or `null` if it's active.
         * @format date-time
         */
        expiresAt?: null | string;
        /** The recurring frequency with which the subscription is charged. */
        billingCycle?: {
          /**
           * Amount of time.
           * @min 0
           */
          amount?: number;
          /** Unit of time. */
          unit?: CreateOrderPayAccountUnitEnum;
        };
        /** The trial period or `null` if there is no trial for this subscription. */
        trialPeriod?: {
          /** The duration of the trial period if any. */
          duration?: {
            /**
             * Amount of time.
             * @min 0
             */
            amount?: number;
            /** Unit of time. */
            unit?: CreateOrderPayAccountUnitEnum1;
          };
          /**
           * Date when the trial period has started.
           * @format date-time
           */
          startedAt?: null | string;
          /**
           * Date when the trial period has expired.
           * @format date-time
           */
          expiresAt?: null | string;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetOrderPayAccountStatusEnum {
  Active = 'active',
  Trialling = 'trialling',
  Churned = 'churned',
}

/** The current status of the subscription. */
export enum GetOrderPayAccountStatusEnum1 {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

/** Unit of time. */
export enum GetOrderPayAccountUnitEnum {
  Day = 'day',
  Month = 'month',
}

/** Unit of time. */
export enum GetOrderPayAccountUnitEnum1 {
  Day = 'day',
  Month = 'month',
}

export interface GetOrderPayAccountData {
  /** OrderPayAccountResource */
  data: {
    type: 'order-pay-account';
    /**
     * A globally-unique identifier for the account.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id: string;
    attributes: {
      status?: GetOrderPayAccountStatusEnum;
      /**
       * Date when the account was created.
       * @format date-time
       */
      createdAt?: string;
      /** The user's acceptance of the terms and conditions. */
      termsAcceptance?: {
        /**
         * The version of the terms and conditions. Defaults to the latest version.
         * @example "2025.04"
         */
        termsVersion?: string;
        /**
         * Date when the user accepted the terms and conditions.
         * @format date-time
         */
        acceptedAt?: string;
      } | null;
      subscription?: {
        /** The current status of the subscription. */
        status?: GetOrderPayAccountStatusEnum1;
        /**
         * Date when the subscription started or `null` if it hasn't started yet.
         * @format date-time
         */
        startedAt?: null | string;
        /**
         * Date when the subscription has ended or `null` if it's active.
         * @format date-time
         */
        expiresAt?: null | string;
        /** The recurring frequency with which the subscription is charged. */
        billingCycle?: {
          /**
           * Amount of time.
           * @min 0
           */
          amount?: number;
          /** Unit of time. */
          unit?: GetOrderPayAccountUnitEnum;
        };
        /** The trial period or `null` if there is no trial for this subscription. */
        trialPeriod?: {
          /** The duration of the trial period if any. */
          duration?: {
            /**
             * Amount of time.
             * @min 0
             */
            amount?: number;
            /** Unit of time. */
            unit?: GetOrderPayAccountUnitEnum1;
          };
          /**
           * Date when the trial period has started.
           * @format date-time
           */
          startedAt?: null | string;
          /**
           * Date when the trial period has expired.
           * @format date-time
           */
          expiresAt?: null | string;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum PatchOrderPayAccountStatusEnum {
  Active = 'active',
  Trialling = 'trialling',
  Churned = 'churned',
}

/** The current status of the subscription. */
export enum PatchOrderPayAccountStatusEnum1 {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

/** Unit of time. */
export enum PatchOrderPayAccountUnitEnum {
  Day = 'day',
  Month = 'month',
}

/** Unit of time. */
export enum PatchOrderPayAccountUnitEnum1 {
  Day = 'day',
  Month = 'month',
}

/** The status expected for the subscription. */
export enum PatchOrderPayAccountStatusEnum2 {
  Pending = 'pending',
  Active = 'active',
  Cancelled = 'cancelled',
}

export interface PatchOrderPayAccountData {
  /** OrderPayAccountResource */
  data: {
    type: 'order-pay-account';
    /**
     * A globally-unique identifier for the account.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id: string;
    attributes: {
      status?: PatchOrderPayAccountStatusEnum;
      /**
       * Date when the account was created.
       * @format date-time
       */
      createdAt?: string;
      /** The user's acceptance of the terms and conditions. */
      termsAcceptance?: {
        /**
         * The version of the terms and conditions. Defaults to the latest version.
         * @example "2025.04"
         */
        termsVersion?: string;
        /**
         * Date when the user accepted the terms and conditions.
         * @format date-time
         */
        acceptedAt?: string;
      } | null;
      subscription?: {
        /** The current status of the subscription. */
        status?: PatchOrderPayAccountStatusEnum1;
        /**
         * Date when the subscription started or `null` if it hasn't started yet.
         * @format date-time
         */
        startedAt?: null | string;
        /**
         * Date when the subscription has ended or `null` if it's active.
         * @format date-time
         */
        expiresAt?: null | string;
        /** The recurring frequency with which the subscription is charged. */
        billingCycle?: {
          /**
           * Amount of time.
           * @min 0
           */
          amount?: number;
          /** Unit of time. */
          unit?: PatchOrderPayAccountUnitEnum;
        };
        /** The trial period or `null` if there is no trial for this subscription. */
        trialPeriod?: {
          /** The duration of the trial period if any. */
          duration?: {
            /**
             * Amount of time.
             * @min 0
             */
            amount?: number;
            /** Unit of time. */
            unit?: PatchOrderPayAccountUnitEnum1;
          };
          /**
           * Date when the trial period has started.
           * @format date-time
           */
          startedAt?: null | string;
          /**
           * Date when the trial period has expired.
           * @format date-time
           */
          expiresAt?: null | string;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** The payment service provider selected for the payment */
export enum CreateOrderPayPaymentPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum CreateOrderPayPaymentStatusEnum {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum CreateOrderPayPaymentPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export enum CreateOrderPayPaymentPspEnum1 {
  Stripe = 'stripe',
}

export enum CreateOrderPayPaymentPaymentMethodEnum1 {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export interface CreateOrderPayPaymentData {
  /**
   * PaymentResource
   * The resource of a payment object
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * External order uuid
       * @format uuid
       */
      orderUuid: string;
      /**
       * OrderPay customer uuid (external)
       * @format uuid
       */
      customerUuid: string;
      /**
       * Brand uuid
       * @format uuid
       */
      brandUuid: string;
      /**
       * Creation date of the payment
       * @format date-time
       */
      createdAt: string;
      /** The payment service provider selected for the payment */
      psp: CreateOrderPayPaymentPspEnum;
      /** Status of the payment */
      status: CreateOrderPayPaymentStatusEnum;
      amount: number;
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** @format float */
      currencyRate: number;
      /** The payment method selected for the payment */
      paymentMethod: CreateOrderPayPaymentPaymentMethodEnum;
      fundedBy?: string | null;
      paymentTerms?: string | null;
    };
    relationships?: {
      transactions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Creation date of the transaction
       * @format date-time
       */
      createdAt: string;
      /** The payment service provider transaction id */
      pspId: string;
      amount: number;
      currency: string;
      type: string;
      status: string;
      pspData?: {
        client_secret?: string;
        iban?: {
          bic?: string;
          iban?: string;
          country?: string;
          reference?: string;
        };
      };
    };
  }[];
}

/** The payment service provider selected for the payment */
export enum ConfirmOrderPayPaymentPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum ConfirmOrderPayPaymentStatusEnum {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum ConfirmOrderPayPaymentPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export interface ConfirmOrderPayPaymentData {
  /**
   * PaymentResource
   * The resource of a payment object
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * External order uuid
       * @format uuid
       */
      orderUuid: string;
      /**
       * OrderPay customer uuid (external)
       * @format uuid
       */
      customerUuid: string;
      /**
       * Brand uuid
       * @format uuid
       */
      brandUuid: string;
      /**
       * Creation date of the payment
       * @format date-time
       */
      createdAt: string;
      /** The payment service provider selected for the payment */
      psp: ConfirmOrderPayPaymentPspEnum;
      /** Status of the payment */
      status: ConfirmOrderPayPaymentStatusEnum;
      amount: number;
      /**
       * ISO 3-Letter Currency Code
       * @example "EUR"
       */
      currency: string;
      /** @format float */
      currencyRate: number;
      /** The payment method selected for the payment */
      paymentMethod: ConfirmOrderPayPaymentPaymentMethodEnum;
      fundedBy?: string | null;
      paymentTerms?: string | null;
    };
    relationships?: {
      transactions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Creation date of the transaction
       * @format date-time
       */
      createdAt: string;
      /** The payment service provider transaction id */
      pspId: string;
      amount: number;
      currency: string;
      type: string;
      status: string;
      pspData?: {
        client_secret?: string;
        iban?: {
          bic?: string;
          iban?: string;
          country?: string;
          reference?: string;
        };
      };
    };
  }[];
}

export enum UpdateOrderPayItemsQuantitiesByBrandStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The payment service provider selected for the payment */
export enum UpdateOrderPayItemsQuantitiesByBrandPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum UpdateOrderPayItemsQuantitiesByBrandStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum UpdateOrderPayItemsQuantitiesByBrandPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

/** OrderSchema */
export interface UpdateOrderPayItemsQuantitiesByBrandData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      brand: {
        /**
         * @format uuid
         * @example "1ef2e44a-b396-6b56-80d5-c66dfcccaea9"
         */
        brandUuid: string;
        /**
         * Brand name.
         * @example "Chevalier"
         */
        name: string;
        /**
         * Brand rounded logo image path.
         * @example "/brands/rounded/rounded.jpg"
         */
        imageRoundedPath: string;
      };
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      status?: UpdateOrderPayItemsQuantitiesByBrandStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: string;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: UpdateOrderPayItemsQuantitiesByBrandPspEnum;
          /** Status of the payment */
          status: UpdateOrderPayItemsQuantitiesByBrandStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: UpdateOrderPayItemsQuantitiesByBrandPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

export enum OrderingListExternalCustomersTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingListExternalCustomersServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export interface OrderingListExternalCustomersParams {
  /**
   * Search string to filter the list of external customers. The search string
   * is matched against the external customer's first and last name, email address and business name.
   */
  'search-term'?: string;
}

export interface OrderingListExternalCustomersData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      firstName: string;
      lastName: string;
      street: string;
      additionalAddress: null | string;
      postalCode: string;
      city: string;
      countryCode: string;
      businessName: null | string;
      email: string;
      phoneNumber: string;
      type?: OrderingListExternalCustomersTypeEnum;
      deliverySchedule?: {
        /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
        timeSlots:
          | {
              /**
               * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "09:30"
               */
              startTime: string;
              /**
               * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "12:30"
               */
              endTime: string;
            }[]
          | null;
        /**
         * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
         * @minItems 1
         * @uniqueItems true
         * @example [1,2,3]
         */
        openDays: number[];
      } | null;
      packingInstruction?: {
        /**
         * List of packing instruction services
         * @minItems 1
         */
        services: OrderingListExternalCustomersServicesEnum[];
        /**
         * Additional packing instruction (can be empty)
         * @example "Instruction text"
         */
        instruction: string;
      } | null;
      deliveryAppointment?: {
        /**
         * Whether a delivery appointment is requested for this customer.
         * @example true
         */
        requested: boolean;
        /**
         * Additional instruction for the delivery appointment (can be empty)
         * @maxLength 1000
         * @example "Please call before delivery"
         */
        instruction: string;
      } | null;
      /** Whether the customer receives deliveries directly at the loading dock. */
      pickupAtDock: boolean;
    };
  }[];
}

export enum OrderingCreateExternalCustomerTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingCreateExternalCustomerServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum OrderingCreateExternalCustomerTypeEnum1 {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingCreateExternalCustomerServicesEnum1 {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export interface OrderingCreateExternalCustomerData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      firstName: string;
      lastName: string;
      street: string;
      additionalAddress: null | string;
      postalCode: string;
      city: string;
      countryCode: string;
      businessName: null | string;
      email: string;
      phoneNumber: string;
      type?: OrderingCreateExternalCustomerTypeEnum;
      deliverySchedule?: {
        /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
        timeSlots:
          | {
              /**
               * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "09:30"
               */
              startTime: string;
              /**
               * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "12:30"
               */
              endTime: string;
            }[]
          | null;
        /**
         * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
         * @minItems 1
         * @uniqueItems true
         * @example [1,2,3]
         */
        openDays: number[];
      } | null;
      packingInstruction?: {
        /**
         * List of packing instruction services
         * @minItems 1
         */
        services: OrderingCreateExternalCustomerServicesEnum[];
        /**
         * Additional packing instruction (can be empty)
         * @example "Instruction text"
         */
        instruction: string;
      } | null;
      deliveryAppointment?: {
        /**
         * Whether a delivery appointment is requested for this customer.
         * @example true
         */
        requested: boolean;
        /**
         * Additional instruction for the delivery appointment (can be empty)
         * @maxLength 1000
         * @example "Please call before delivery"
         */
        instruction: string;
      } | null;
      /** Whether the customer receives deliveries directly at the loading dock. */
      pickupAtDock: boolean;
    };
  };
}

export enum OrderingViewExternalCustomerTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingViewExternalCustomerServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export interface OrderingViewExternalCustomerData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      firstName: string;
      lastName: string;
      street: string;
      additionalAddress: null | string;
      postalCode: string;
      city: string;
      countryCode: string;
      businessName: null | string;
      email: string;
      phoneNumber: string;
      type?: OrderingViewExternalCustomerTypeEnum;
      deliverySchedule?: {
        /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
        timeSlots:
          | {
              /**
               * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "09:30"
               */
              startTime: string;
              /**
               * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "12:30"
               */
              endTime: string;
            }[]
          | null;
        /**
         * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
         * @minItems 1
         * @uniqueItems true
         * @example [1,2,3]
         */
        openDays: number[];
      } | null;
      packingInstruction?: {
        /**
         * List of packing instruction services
         * @minItems 1
         */
        services: OrderingViewExternalCustomerServicesEnum[];
        /**
         * Additional packing instruction (can be empty)
         * @example "Instruction text"
         */
        instruction: string;
      } | null;
      deliveryAppointment?: {
        /**
         * Whether a delivery appointment is requested for this customer.
         * @example true
         */
        requested: boolean;
        /**
         * Additional instruction for the delivery appointment (can be empty)
         * @maxLength 1000
         * @example "Please call before delivery"
         */
        instruction: string;
      } | null;
      /** Whether the customer receives deliveries directly at the loading dock. */
      pickupAtDock: boolean;
    };
  };
}

export enum OrderingUpdateExternalCustomerTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingUpdateExternalCustomerServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum OrderingUpdateExternalCustomerTypeEnum1 {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingUpdateExternalCustomerServicesEnum1 {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export interface OrderingUpdateExternalCustomerData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      firstName: string;
      lastName: string;
      street: string;
      additionalAddress: null | string;
      postalCode: string;
      city: string;
      countryCode: string;
      businessName: null | string;
      email: string;
      phoneNumber: string;
      type?: OrderingUpdateExternalCustomerTypeEnum;
      deliverySchedule?: {
        /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
        timeSlots:
          | {
              /**
               * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "09:30"
               */
              startTime: string;
              /**
               * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
               * @example "12:30"
               */
              endTime: string;
            }[]
          | null;
        /**
         * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
         * @minItems 1
         * @uniqueItems true
         * @example [1,2,3]
         */
        openDays: number[];
      } | null;
      packingInstruction?: {
        /**
         * List of packing instruction services
         * @minItems 1
         */
        services: OrderingUpdateExternalCustomerServicesEnum[];
        /**
         * Additional packing instruction (can be empty)
         * @example "Instruction text"
         */
        instruction: string;
      } | null;
      deliveryAppointment?: {
        /**
         * Whether a delivery appointment is requested for this customer.
         * @example true
         */
        requested: boolean;
        /**
         * Additional instruction for the delivery appointment (can be empty)
         * @maxLength 1000
         * @example "Please call before delivery"
         */
        instruction: string;
      } | null;
      /** Whether the customer receives deliveries directly at the loading dock. */
      pickupAtDock: boolean;
    };
  };
}

export interface OrderingDeleteExternalCustomerData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

/** Type of wrapped order */
export enum OrderingListOrdersTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum OrderingListOrdersMasterStatusEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingListOrdersTypeEnum1 {
  PublicApp = 'publicApp',
}

export enum OrderingListOrdersPlatformNameEnum {
  WOO_COMMERCE = 'WOO_COMMERCE',
  SHOPIFY = 'SHOPIFY',
}

export enum OrderingListOrdersNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum OrderingListOrdersCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum OrderingListOrdersDistanceUnitEnum {
  Cm = 'cm',
}

export enum OrderingListOrdersLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum OrderingListOrdersDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum OrderingListOrdersServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum OrderingListOrdersBusinessModelEnum {
  Value2024 = '2024',
  Value2025 = '2025',
}

/** Type of wrapped order */
export enum OrderingListOrdersTypeEnum2 {
  Internal = 'internal',
}

export enum OrderingListOrdersDistanceUnitEnum2 {
  Cm = 'cm',
}

export enum OrderingListOrdersShippingMethodEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum OrderingListOrdersStockOriginEnum {
  DirectShipping = 'directShipping',
  FulfillmentCenter = 'fulfillmentCenter',
}

export interface OrderingListOrdersParams {
  /** Choose only specific attributes from order payload */
  'fields[orders]'?: string;
  /** Choose only specific attributes from order payload */
  'fields[order-shipping]'?: string;
  /** Include related resources in the response */
  include?: IncludeEnum;
  'page[limit]'?: number;
  'page[offset]'?: number;
  /** Request masters orders for a specific priority category */
  'filter[priority_key]'?: FilterPriorityKeyEnum;
  /** Request master orders for a specific status category */
  'filter[status_key]'?: FilterStatusKeyEnum;
  /** Request master orders based on free text search e.g. product, brand, retailer etc. */
  'filter[search_term]'?: string;
  /** Request master orders for a specific brand cancellation reason */
  'filter[brand_cancellation_key]'?: FilterBrandCancellationKeyEnum;
  /** Request master orders of a specific type */
  'filter[order_type]'?: FilterOrderTypeEnum;
  /** Request external orders of a specific type. Can be used only if the `filter[order_type]` is set to `external`. */
  'filter[external_order_type]'?: FilterExternalOrderTypeEnum;
  /** Request master orders for a specific wrapped order statuses */
  'filter[wrapped_order_status]'?: FilterWrappedOrderStatusEnum[];
  /** Request master orders by their UUIDs */
  'filter[uuid]'?: string[];
  /**
   * Specify attribute(s) to sort by
   * @default "-date_created"
   */
  sort?: SortEnum1;
}

/** Include related resources in the response */
export enum IncludeEnum {
  OrderItems = 'orderItems',
  OrderShipping = 'orderShipping',
}

/** Request masters orders for a specific priority category */
export enum FilterPriorityKeyEnum {
  OnTime = 'on_time',
  Overdue = 'overdue',
  CloseDeadline = 'close_deadline',
}

/** Request master orders for a specific status category */
export enum FilterStatusKeyEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
  PendingValidation = 'pending_validation',
  ReceptionRefused = 'reception_refused',
}

/** Request master orders for a specific brand cancellation reason */
export enum FilterBrandCancellationKeyEnum {
  PRODUCT_OUT_OF_STOCK = 'PRODUCT_OUT_OF_STOCK',
  BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION = 'BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION',
  BRAND_CANNOT_DELIVER_TO_THE_AREA = 'BRAND_CANNOT_DELIVER_TO_THE_AREA',
  RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER = 'RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER',
  BRAND_SHIPPING_FEES_VIA_CUSTOM = 'BRAND_SHIPPING_FEES_VIA_CUSTOM',
  OTHER = 'OTHER',
  REJECTED_VIA_EXTERNAL_INTEGRATION = 'REJECTED_VIA_EXTERNAL_INTEGRATION',
  BRAND_SHIPPING_FEES_VIA_ANKORSTORE = 'BRAND_SHIPPING_FEES_VIA_ANKORSTORE',
  PAYMENT_ISSUES_WITH_RETAILER = 'PAYMENT_ISSUES_WITH_RETAILER',
  PREPARATION_TIME_TOO_HIGH = 'PREPARATION_TIME_TOO_HIGH',
  BUYER_NOT_A_RETAILER = 'BUYER_NOT_A_RETAILER',
  PURCHASE_NOT_FOR_RESALE = 'PURCHASE_NOT_FOR_RESALE',
  RETAILER_NOT_GOOD_FIT_FOR_BRAND = 'RETAILER_NOT_GOOD_FIT_FOR_BRAND',
  RETAILER_VAT_NUMBER_MISSING = 'RETAILER_VAT_NUMBER_MISSING',
  ORDER_ITEMS_PRICES_INCORRECT = 'ORDER_ITEMS_PRICES_INCORRECT',
  BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA = 'BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA',
}

/** Request master orders of a specific type */
export enum FilterOrderTypeEnum {
  Internal = 'internal',
  External = 'external',
}

/** Request external orders of a specific type. Can be used only if the `filter[order_type]` is set to `external`. */
export enum FilterExternalOrderTypeEnum {
  Nafo = 'nafo',
  OrderPay = 'order_pay',
}

export enum FilterWrappedOrderStatusEnum {
  Created = 'created',
  AwaitingFulfillment = 'awaiting_fulfillment',
  Shipped = 'shipped',
  Arrived = 'arrived',
  Cancelled = 'cancelled',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
}

/**
 * Specify attribute(s) to sort by
 * @default "-date_created"
 */
export enum SortEnum1 {
  DateCreated = 'date_created',
  ValueDateCreated = '-date_created',
  Status = 'status',
  ValueStatus = '-status',
}

export interface OrderingListOrdersData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes:
      | {
          /** Type of wrapped order */
          type: OrderingListOrdersTypeEnum;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          preorderCreatedAt?: null | string;
          /** @pattern ^[EI][A-NP-Z]{3}[1-9]{7}$ */
          reference?: string;
          customReference?: null | string;
          masterStatus?: OrderingListOrdersMasterStatusEnum;
          status: {
            name: string;
            shortTitle?: string;
            title: null | string;
            details: null | string;
            subStatus?: {
              shortTitle?: string;
            };
          };
          /** The `amounts` property of the `ExternalOrder`, if set. */
          amounts?: {
            /** @example "EUR" */
            brandCurrency: string;
            /** @example 1 */
            brandCurrencyRate: number;
            /** @example "€546.20" */
            brandTotalAmount: string;
            /** @example "€126.33" */
            brandTotalAmountVat: string;
            /** @example "€672.53" */
            brandTotalAmountWithVat: string;
            /** @example "EUR" */
            customerCurrency: string;
            /** @example 1 */
            customerCurrencyRate: number;
            /** @example "€546.20" */
            customerTotalAmount: string;
            /** @example "€126.33" */
            customerTotalAmountVat: string;
            /** @example "€672.53" */
            customerTotalAmountWithVat: string;
            /** @example "€2.20" */
            shippingFeesAmount: string;
            /** @example "€0.44" */
            shippingFeesAmountVat: string;
            /** @example "€2.64" */
            shippingFeesAmountWithVat: string;
            /** @example "€548.40" */
            customerGrandTotalAmount: string;
            /** @example "€126.77" */
            customerGrandTotalAmountVat: string;
            /** @example "€675.17" */
            customerGrandTotalAmountWithVat: string;
          };
          /** The `metadata` property of the `ExternalOrder`, if set. */
          metadata?: {
            /** @example "fulfillment" */
            shippingMethod: string;
            address: {
              /** @example "FR" */
              countryCode: string;
              /** @example "75116" */
              postalCode: string;
              /** @example "Paris" */
              city: string;
              /** @example "av Kleber" */
              addressLine: string;
              /** @example null */
              company: string | null;
            };
            contactPerson: {
              /** @example "John" */
              firstName: string;
              /** @example "Smith" */
              lastName: string;
              /** @example "foo@bar.com" */
              email: string;
              /** @example null */
              phone: string | null;
            };
          };
          internalId: null | number;
          /** @format uuid */
          internalUuid?: string | null;
          /** @format uuid */
          externalOrderUuid?: string | null;
          isDiscovery?: null | boolean;
          isDiscoveryForRetailer?: null | boolean;
          isBelongingToReferral?: null | boolean;
          totals: null | {
            totalAmount: {
              amount: number;
              currency: string;
            };
            totalVatAmount: {
              amount: number;
              currency: string;
            };
            totalAmountWithVat: {
              amount: number;
              currency: string;
            };
            netAmount: {
              amount: number;
              currency: string;
            };
          };
          brand: {
            id: string | number;
            name: string;
            /** @format url */
            link: string;
            display_address: {
              city: string;
            };
          };
          user?: {
            /** @format uuid */
            uuid: string;
            /** @example "John" */
            firstName: string;
            /** @example "Smith" */
            lastName: string;
            /**
             * @format email
             * @example "john@smith.com"
             */
            email: string;
          };
          updates: null | {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
          taxes:
            | null
            | {
                name: string;
                amount: {
                  amount: number;
                  currency: string;
                };
              }[];
          priorityTag?: null | {
            name: string;
          };
          vat: null | {
            isShifted: boolean;
            applicationDetails: null | {
              message: string;
              link: null | {
                href: string;
                text: string;
              };
            };
          };
          deadlines?: null | {
            /** @format date-time */
            toShip: null | string;
            /** @format date-time */
            toAccept: null | string;
            /** @format date-time */
            toActOnIssue: null | string;
          };
          synchronizations?:
            | null
            | {
                type?: OrderingListOrdersTypeEnum1;
                platformName?: OrderingListOrdersPlatformNameEnum;
                error?: null | string;
              }[];
          invoices?:
            | null
            | {
                isGenerated: boolean;
                title: string;
                number: null | string;
                path: null | string;
              }[];
          shipping: null | {
            shippingProvider: null | string;
            isInternational?: boolean;
            hasShippingLabelGenerationError?: boolean;
            hasRevertedShippingLabels?: boolean;
            fees?: null | {
              refundAmount: null | {
                amount: number;
                currency: string;
              };
            };
            /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
            billedWeightFee?: {
              amount: number;
              currency: string;
            };
            shippingAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            availableShippingMethods?:
              | null
              | {
                  name: OrderingListOrdersNameEnum;
                  canBeUsed: boolean;
                  errors: object[] | object;
                }[];
            shipmentEstimation?: null | {
              collectionMethods: OrderingListOrdersCollectionMethodsEnum[];
              rateProvider: null | string;
              rateAmount: null | {
                amount: number;
                currency: string;
              };
              estimatedParcels: {
                weight: null | number;
                height: null | number;
                length: null | number;
                width: null | number;
                distanceUnit?: OrderingListOrdersDistanceUnitEnum;
              }[];
            };
            shipment: null | {
              /** @format date-time */
              shippedAt: null | string;
              labelPrintingFormat: OrderingListOrdersLabelPrintingFormatEnum;
              trackedPackages: {
                /** @format url */
                labelUrl?: null | string;
                parcel?: {
                  weight: null | number;
                  height: null | number;
                  length: null | number;
                  width: null | number;
                  distanceUnit?: OrderingListOrdersDistanceUnitEnum1;
                };
              }[];
              shipFromAddress: {
                address: {
                  countryCode: null | string;
                  postalCode: null | string;
                  city: null | string;
                  addressLine: null | string;
                };
                company: null | string;
                contactPerson: {
                  firstName: null | string;
                  lastName: null | string;
                  fullName: null | string;
                  phoneNumber: null | string;
                  /** @format email */
                  email: null | string;
                };
              };
              pickup: null | {
                /** @format date-time */
                date: string;
                readyTime: string;
                closeTime: string;
              };
              labelRevertReasons: {
                actionType: string;
                actionReason: string;
              }[];
            };
          };
          tracking: null | {
            trackingNumber: null | string;
            trackingLink: null | string;
            status: null | string;
          };
          billing: null | {
            billingItems: {
              id: number;
              type: string;
              label: string;
              displayVat: boolean;
              isVatShifted: boolean;
              amount: null | {
                amount: number;
                currency: string;
              };
              amountVat: null | {
                amount: number;
                currency: string;
              };
              amountWithVat: null | {
                amount: number;
                currency: string;
              };
              /** Amount of the billing item in percents */
              percentage: null | number;
              /** Whether the billing item was created as part of a special deal */
              isSpecialDeal: boolean;
              francoSetting?: null | {
                francoAmount?: null | {
                  amount: number;
                  currency: string;
                };
                francoFlatFeeAmount?: null | {
                  amount: number;
                  currency: string;
                };
              };
            }[];
          };
          issue?: null | {
            casesVisibleToBrand: string[];
            casesAllowedToBeSentToBrand: string[];
            current: null | {
              status: string;
              escalatedToCsByBrand: boolean;
              escalatedToCsToAdjustQuantityByBrand: boolean;
              escalatedToCsOnReship: boolean;
              autoEscalatedToCs: boolean;
              autoEscalatedToCsOnReship: boolean;
              sendToBrandEnabled: boolean;
              escalatedNewClaimToCs: null | boolean;
              reason: string;
              shippedDate: string;
              autoEscalateDate: string;
              trackingLink: null | string;
              trackingNumber: null | string;
              shippingProvider: null | string;
              reshippedDate: null | string;
              products: {
                id: number;
                name: string;
                sku: string;
                description: string;
                quantity: number;
                files: {
                  url: string;
                }[];
              }[];
              packagingFiles: {
                url: string;
              }[];
              parcelReservationFiles: {
                url: string;
              }[];
              parcelContentFiles: {
                url: string;
              }[];
              options: {
                label: string;
                text: string;
              }[];
            };
          };
          retailer: null | {
            id: null | number;
            /** @format uuid */
            uuid?: string | null;
            name: string;
            /** @format email */
            email: string;
            phone_number: string;
            city: string;
            business: {
              user_first_name?: string;
              user_last_name?: string;
              vat_number: null | string;
              tax_number: null | string;
              country: {
                iso_code: string;
              };
            };
            /** The opening times of the customer for delivery. */
            deliverySchedule?: {
              /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
              timeSlots:
                | {
                    /**
                     * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "09:30"
                     */
                    startTime: string;
                    /**
                     * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "12:30"
                     */
                    endTime: string;
                  }[]
                | null;
              /**
               * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
               * @minItems 1
               * @uniqueItems true
               * @example [1,2,3]
               */
              openDays: number[];
            } | null;
            /** The packing instruction of the customer. */
            packingInstruction?: {
              /**
               * List of packing instruction services
               * @minItems 1
               */
              services: OrderingListOrdersServicesEnum[];
              /**
               * Additional packing instruction (can be empty)
               * @example "Instruction text"
               */
              instruction: string;
            } | null;
            deliveryAppointment?: {
              /**
               * Whether a delivery appointment is requested for this customer.
               * @example true
               */
              requested: boolean;
              /**
               * Additional instruction for the delivery appointment (can be empty)
               * @maxLength 1000
               * @example "Please call before delivery"
               */
              instruction: string;
            } | null;
          };
          rejection: null | {
            brandRejectType: null | string;
            availableBrandRejectReasons?: {
              rejectType: string;
              rejectTypeLabel: string;
            }[];
            isRetailerCancellationRequestOpened?: boolean;
          };
          meta: null | {
            showAlcoholWarning?: boolean;
            showManualInvoiceDownloadWarning?: boolean;
            casesVisibleToBrand?: string[];
            casesAllowedToBeSentToBrand?: string[];
            isSplitAllowed?: boolean;
            businessModel?: OrderingListOrdersBusinessModelEnum;
          };
        }
      | {
          /** Type of wrapped order */
          type: OrderingListOrdersTypeEnum2;
          /** @format date-time */
          createdAt: string;
          orderItemCount?: number;
          internalId: null | number;
          checkoutId?: null | number;
          /**
           * The AnkorPay payment operation UUID associated with this order's checkout. Null if no payment operation is found.
           * @format uuid
           */
          externalPaymentUuid?: null | string;
          status: {
            name: string;
            shortTitle?: string;
            title: null | string;
            details: null | string;
            subStatus?: {
              shortTitle?: string;
            };
            /** @format datetime */
            transitionedAt?: null | string;
          };
          totals: null | {
            totalAmount: {
              amount: number;
              currency: string;
            };
            totalVatAmount: {
              amount: number;
              currency: string;
            };
            totalAmountWithVat: {
              amount: number;
              currency: string;
            };
            netAmount: {
              amount: number;
              currency: string;
            };
            retailerTotalAmountBeforeDiscount?: {
              amount: number;
              currency: string;
            };
          };
          brand: {
            id: number;
            name: string;
            /** @format url */
            link: string;
            display_address: {
              city: string;
            };
            images?: {
              rounded: null | string;
            };
          };
          updates: null | {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
          events?: {
            type: string;
            updates: {
              oldTotalAmount: {
                amount: number;
                currency: string;
              };
              oldTotalAmountVat: {
                amount: number;
                currency: string;
              };
              oldTotalAmountWithVat: {
                amount: number;
                currency: string;
              };
              oldRecargoAmount: null | {
                amount: number;
                currency: string;
              };
              itemUpdates: {
                itemId: string;
                productName: string;
                sku: string;
                productImage: string | null;
                productUrl: string;
                oldQuantity: number;
                newQuantity: number;
                oldMultipliedQuantity: number;
                newMultipliedQuantity: number;
                unitPrice: {
                  amount: number;
                  currency: string;
                };
                oldAmount: {
                  amount: number;
                  currency: string;
                };
                newAmount: {
                  amount: number;
                  currency: string;
                };
              }[];
            };
          }[];
          taxes:
            | null
            | {
                name: string;
                amount: {
                  amount: number;
                  currency: string;
                };
              }[];
          shipping: {
            shippingProvider: null | string;
            /** @format date-time */
            shippedAt: null | string;
            shippingMethod: null | string;
            shippingAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            shipment: null | {
              trackedPackages: {
                /** @format url */
                labelUrl?: null | string;
                parcel?: {
                  weight: null | number;
                  height: null | number;
                  length: null | number;
                  width: null | number;
                  distanceUnit?: OrderingListOrdersDistanceUnitEnum2;
                };
              }[];
            };
          };
          tracking: null | {
            trackingNumber: null | string;
            trackingLink: null | string;
            status: null | string;
          };
          billing: null | {
            billingItems: {
              id: number;
              type: string;
              label: string;
              displayVat: boolean;
              isVatShifted: boolean;
              amount: null | {
                amount: number;
                currency: string;
              };
              amountVat: null | {
                amount: number;
                currency: string;
              };
              amountWithVat: null | {
                amount: number;
                currency: string;
              };
              /** Amount of the billing item in percents */
              percentage: null | number;
              /** Whether the billing item was created as part of a special deal */
              isSpecialDeal: boolean;
              francoSetting?: null | {
                francoAmount?: null | {
                  amount: number;
                  currency: string;
                };
                francoFlatFeeAmount?: null | {
                  amount: number;
                  currency: string;
                };
              };
            }[];
          };
          issue?: null | {
            casesVisibleToBrand: string[];
            casesAllowedToBeSentToBrand: string[];
            current: null | {
              status: string;
              escalatedToCsByBrand: boolean;
              escalatedToCsToAdjustQuantityByBrand: boolean;
              escalatedToCsOnReship: boolean;
              autoEscalatedToCs: boolean;
              autoEscalatedToCsOnReship: boolean;
              sendToBrandEnabled: boolean;
              escalatedNewClaimToCs: null | boolean;
              reason: string;
              shippedDate: string;
              autoEscalateDate: string;
              trackingLink: null | string;
              trackingNumber: null | string;
              shippingProvider: null | string;
              reshippedDate: null | string;
              products: {
                id: number;
                name: string;
                sku: string;
                description: string;
                quantity: number;
                files: {
                  url: string;
                }[];
              }[];
              packagingFiles: {
                url: string;
              }[];
              parcelReservationFiles: {
                url: string;
              }[];
              parcelContentFiles: {
                url: string;
              }[];
              options: {
                label: string;
                text: string;
              }[];
            };
          };
          retailer: {
            id: null | number;
            name: string;
            store_url: null | string;
            /** @format email */
            email: string;
            phone_number: string;
            city: string;
            postal_code?: string;
            address_line?: string;
            company_name?: string;
            business: {
              vat_number: null | string;
              tax_number: null | string;
              user_first_name?: null | string;
              user_last_name?: null | string;
              country: {
                iso_code: string;
              };
            };
          };
          rejection: null | {
            brandRejectType: null | string;
          };
          cancellation?: null | {
            retailerCanOpenCancellationRequest: boolean;
          };
          meta: null | {
            showManualInvoiceDownloadWarning?: boolean;
            casesVisibleToBrand?: string[];
            casesAllowedToBeSentToBrand?: string[];
          };
        };
    relationships?: {
      orderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      orderShipping?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          shippingMethod: null | OrderingListOrdersShippingMethodEnum;
          isAddingTrackingInformationPostponed: null | boolean;
          stockOrigin: null | OrderingListOrdersStockOriginEnum;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: null | number;
          unitQuantity: number;
          batchQuantity: number;
          unitPrice: null | {
            amount: number;
            currency: string;
          };
          totalPrice: null | {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          /** Resource identification present in Resource Objects and Resource Identifier Objects. */
          orderedProduct?: {
            /**
             * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
             * @format uuid
             */
            id: string;
            /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
            type: string;
            /** Non-standard meta-information that can not be represented as an attribute or relationship. */
            meta?: Record<string, any>;
          };
        };
      }
    | {
        type?: 'order-issue';
        id?: string;
        attributes?: {
          status: string;
          escalatedToCsByBrand: boolean;
          escalatedToCsToAdjustQuantityByBrand: boolean;
          escalatedToCsOnReship: boolean;
          autoEscalatedToCs: boolean;
          autoEscalatedToCsOnReship: boolean;
          sendToBrandEnabled: boolean;
          escalatedNewClaimToCs: null | boolean;
          reason: string;
          shippedDate: string;
          autoEscalateDate: string;
          trackingLink: null | string;
          trackingNumber: null | string;
          shippingProvider: null | string;
          reshippedDate: null | string;
          products: {
            id: number;
            name: string;
            sku: string;
            description: string;
            quantity: number;
            files: {
              url: string;
            }[];
          }[];
          packagingFiles: {
            url: string;
          }[];
          parcelReservationFiles: {
            url: string;
          }[];
          parcelContentFiles: {
            url: string;
          }[];
          options: {
            label: string;
            text: string;
          }[];
        };
      }
  )[];
  meta: {
    count_by_status_key?: {
      /** @min 1 */
      created?: number | null;
      /** @min 1 */
      prepared?: number | null;
      /** @min 1 */
      shipped?: number | null;
      /** @min 1 */
      delivered?: number | null;
      /** @min 1 */
      completed?: number | null;
      /** @min 1 */
      cancelled?: number | null;
    };
    count_by_type_of_order?: {
      /** @min 1 */
      internal?: number | null;
      /** @min 1 */
      external?: number | null;
    };
    [key: string]: any;
  };
}

/** Include related resources in the response */
export enum OrderingListOrdersParams1IncludeEnum {
  OrderItems = 'orderItems',
  OrderShipping = 'orderShipping',
}

/** Request masters orders for a specific priority category */
export enum OrderingListOrdersParams1FilterPriorityKeyEnum {
  OnTime = 'on_time',
  Overdue = 'overdue',
  CloseDeadline = 'close_deadline',
}

/** Request master orders for a specific status category */
export enum OrderingListOrdersParams1FilterStatusKeyEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
  PendingValidation = 'pending_validation',
  ReceptionRefused = 'reception_refused',
}

/** Request master orders for a specific brand cancellation reason */
export enum OrderingListOrdersParams1FilterBrandCancellationKeyEnum {
  PRODUCT_OUT_OF_STOCK = 'PRODUCT_OUT_OF_STOCK',
  BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION = 'BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION',
  BRAND_CANNOT_DELIVER_TO_THE_AREA = 'BRAND_CANNOT_DELIVER_TO_THE_AREA',
  RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER = 'RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER',
  BRAND_SHIPPING_FEES_VIA_CUSTOM = 'BRAND_SHIPPING_FEES_VIA_CUSTOM',
  OTHER = 'OTHER',
  REJECTED_VIA_EXTERNAL_INTEGRATION = 'REJECTED_VIA_EXTERNAL_INTEGRATION',
  BRAND_SHIPPING_FEES_VIA_ANKORSTORE = 'BRAND_SHIPPING_FEES_VIA_ANKORSTORE',
  PAYMENT_ISSUES_WITH_RETAILER = 'PAYMENT_ISSUES_WITH_RETAILER',
  PREPARATION_TIME_TOO_HIGH = 'PREPARATION_TIME_TOO_HIGH',
  BUYER_NOT_A_RETAILER = 'BUYER_NOT_A_RETAILER',
  PURCHASE_NOT_FOR_RESALE = 'PURCHASE_NOT_FOR_RESALE',
  RETAILER_NOT_GOOD_FIT_FOR_BRAND = 'RETAILER_NOT_GOOD_FIT_FOR_BRAND',
  RETAILER_VAT_NUMBER_MISSING = 'RETAILER_VAT_NUMBER_MISSING',
  ORDER_ITEMS_PRICES_INCORRECT = 'ORDER_ITEMS_PRICES_INCORRECT',
  BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA = 'BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA',
}

/** Request master orders of a specific type */
export enum OrderingListOrdersParams1FilterOrderTypeEnum {
  Internal = 'internal',
  External = 'external',
}

/** Request external orders of a specific type. Can be used only if the `filter[order_type]` is set to `external`. */
export enum OrderingListOrdersParams1FilterExternalOrderTypeEnum {
  Nafo = 'nafo',
  OrderPay = 'order_pay',
}

export enum OrderingListOrdersParams1FilterWrappedOrderStatusEnum {
  Created = 'created',
  AwaitingFulfillment = 'awaiting_fulfillment',
  Shipped = 'shipped',
  Arrived = 'arrived',
  Cancelled = 'cancelled',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
}

/**
 * Specify attribute(s) to sort by
 * @default "-date_created"
 */
export enum OrderingListOrdersParams1SortEnum {
  DateCreated = 'date_created',
  ValueDateCreated = '-date_created',
  Status = 'status',
  ValueStatus = '-status',
}

/** Type of wrapped order */
export enum OrderingShowOrderTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum OrderingShowOrderMasterStatusEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingShowOrderTypeEnum1 {
  PublicApp = 'publicApp',
}

export enum OrderingShowOrderPlatformNameEnum {
  WOO_COMMERCE = 'WOO_COMMERCE',
  SHOPIFY = 'SHOPIFY',
}

export enum OrderingShowOrderNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum OrderingShowOrderCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum OrderingShowOrderDistanceUnitEnum {
  Cm = 'cm',
}

export enum OrderingShowOrderLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum OrderingShowOrderDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum OrderingShowOrderServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum OrderingShowOrderBusinessModelEnum {
  Value2024 = '2024',
  Value2025 = '2025',
}

/** Type of wrapped order */
export enum OrderingShowOrderTypeEnum2 {
  Internal = 'internal',
}

export enum OrderingShowOrderDistanceUnitEnum2 {
  Cm = 'cm',
}

export enum OrderingShowOrderShippingMethodEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum OrderingShowOrderStockOriginEnum {
  DirectShipping = 'directShipping',
  FulfillmentCenter = 'fulfillmentCenter',
}

export interface OrderingShowOrderParams {
  /** Include related resources in the response */
  include?: IncludeEnum1;
  /** Choose only specific attributes from order payload */
  'fields[orders]'?: string;
  /** Choose only specific attributes from order payload */
  'fields[order-shipping]'?: string;
  /**
   * UUID of the requested resource
   * @format uuid
   */
  id: string;
}

/** Include related resources in the response */
export enum IncludeEnum1 {
  OrderItems = 'orderItems',
  OrderShipping = 'orderShipping',
}

export interface OrderingShowOrderData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes:
      | {
          /** Type of wrapped order */
          type: OrderingShowOrderTypeEnum;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          preorderCreatedAt?: null | string;
          /** @pattern ^[EI][A-NP-Z]{3}[1-9]{7}$ */
          reference?: string;
          customReference?: null | string;
          masterStatus?: OrderingShowOrderMasterStatusEnum;
          status: {
            name: string;
            shortTitle?: string;
            title: null | string;
            details: null | string;
            subStatus?: {
              shortTitle?: string;
            };
          };
          /** The `amounts` property of the `ExternalOrder`, if set. */
          amounts?: {
            /** @example "EUR" */
            brandCurrency: string;
            /** @example 1 */
            brandCurrencyRate: number;
            /** @example "€546.20" */
            brandTotalAmount: string;
            /** @example "€126.33" */
            brandTotalAmountVat: string;
            /** @example "€672.53" */
            brandTotalAmountWithVat: string;
            /** @example "EUR" */
            customerCurrency: string;
            /** @example 1 */
            customerCurrencyRate: number;
            /** @example "€546.20" */
            customerTotalAmount: string;
            /** @example "€126.33" */
            customerTotalAmountVat: string;
            /** @example "€672.53" */
            customerTotalAmountWithVat: string;
            /** @example "€2.20" */
            shippingFeesAmount: string;
            /** @example "€0.44" */
            shippingFeesAmountVat: string;
            /** @example "€2.64" */
            shippingFeesAmountWithVat: string;
            /** @example "€548.40" */
            customerGrandTotalAmount: string;
            /** @example "€126.77" */
            customerGrandTotalAmountVat: string;
            /** @example "€675.17" */
            customerGrandTotalAmountWithVat: string;
          };
          /** The `metadata` property of the `ExternalOrder`, if set. */
          metadata?: {
            /** @example "fulfillment" */
            shippingMethod: string;
            address: {
              /** @example "FR" */
              countryCode: string;
              /** @example "75116" */
              postalCode: string;
              /** @example "Paris" */
              city: string;
              /** @example "av Kleber" */
              addressLine: string;
              /** @example null */
              company: string | null;
            };
            contactPerson: {
              /** @example "John" */
              firstName: string;
              /** @example "Smith" */
              lastName: string;
              /** @example "foo@bar.com" */
              email: string;
              /** @example null */
              phone: string | null;
            };
          };
          internalId: null | number;
          /** @format uuid */
          internalUuid?: string | null;
          /** @format uuid */
          externalOrderUuid?: string | null;
          isDiscovery?: null | boolean;
          isDiscoveryForRetailer?: null | boolean;
          isBelongingToReferral?: null | boolean;
          totals: null | {
            totalAmount: {
              amount: number;
              currency: string;
            };
            totalVatAmount: {
              amount: number;
              currency: string;
            };
            totalAmountWithVat: {
              amount: number;
              currency: string;
            };
            netAmount: {
              amount: number;
              currency: string;
            };
          };
          brand: {
            id: string | number;
            name: string;
            /** @format url */
            link: string;
            display_address: {
              city: string;
            };
          };
          user?: {
            /** @format uuid */
            uuid: string;
            /** @example "John" */
            firstName: string;
            /** @example "Smith" */
            lastName: string;
            /**
             * @format email
             * @example "john@smith.com"
             */
            email: string;
          };
          updates: null | {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
          taxes:
            | null
            | {
                name: string;
                amount: {
                  amount: number;
                  currency: string;
                };
              }[];
          priorityTag?: null | {
            name: string;
          };
          vat: null | {
            isShifted: boolean;
            applicationDetails: null | {
              message: string;
              link: null | {
                href: string;
                text: string;
              };
            };
          };
          deadlines?: null | {
            /** @format date-time */
            toShip: null | string;
            /** @format date-time */
            toAccept: null | string;
            /** @format date-time */
            toActOnIssue: null | string;
          };
          synchronizations?:
            | null
            | {
                type?: OrderingShowOrderTypeEnum1;
                platformName?: OrderingShowOrderPlatformNameEnum;
                error?: null | string;
              }[];
          invoices?:
            | null
            | {
                isGenerated: boolean;
                title: string;
                number: null | string;
                path: null | string;
              }[];
          shipping: null | {
            shippingProvider: null | string;
            isInternational?: boolean;
            hasShippingLabelGenerationError?: boolean;
            hasRevertedShippingLabels?: boolean;
            fees?: null | {
              refundAmount: null | {
                amount: number;
                currency: string;
              };
            };
            /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
            billedWeightFee?: {
              amount: number;
              currency: string;
            };
            shippingAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            availableShippingMethods?:
              | null
              | {
                  name: OrderingShowOrderNameEnum;
                  canBeUsed: boolean;
                  errors: object[] | object;
                }[];
            shipmentEstimation?: null | {
              collectionMethods: OrderingShowOrderCollectionMethodsEnum[];
              rateProvider: null | string;
              rateAmount: null | {
                amount: number;
                currency: string;
              };
              estimatedParcels: {
                weight: null | number;
                height: null | number;
                length: null | number;
                width: null | number;
                distanceUnit?: OrderingShowOrderDistanceUnitEnum;
              }[];
            };
            shipment: null | {
              /** @format date-time */
              shippedAt: null | string;
              labelPrintingFormat: OrderingShowOrderLabelPrintingFormatEnum;
              trackedPackages: {
                /** @format url */
                labelUrl?: null | string;
                parcel?: {
                  weight: null | number;
                  height: null | number;
                  length: null | number;
                  width: null | number;
                  distanceUnit?: OrderingShowOrderDistanceUnitEnum1;
                };
              }[];
              shipFromAddress: {
                address: {
                  countryCode: null | string;
                  postalCode: null | string;
                  city: null | string;
                  addressLine: null | string;
                };
                company: null | string;
                contactPerson: {
                  firstName: null | string;
                  lastName: null | string;
                  fullName: null | string;
                  phoneNumber: null | string;
                  /** @format email */
                  email: null | string;
                };
              };
              pickup: null | {
                /** @format date-time */
                date: string;
                readyTime: string;
                closeTime: string;
              };
              labelRevertReasons: {
                actionType: string;
                actionReason: string;
              }[];
            };
          };
          tracking: null | {
            trackingNumber: null | string;
            trackingLink: null | string;
            status: null | string;
          };
          billing: null | {
            billingItems: {
              id: number;
              type: string;
              label: string;
              displayVat: boolean;
              isVatShifted: boolean;
              amount: null | {
                amount: number;
                currency: string;
              };
              amountVat: null | {
                amount: number;
                currency: string;
              };
              amountWithVat: null | {
                amount: number;
                currency: string;
              };
              /** Amount of the billing item in percents */
              percentage: null | number;
              /** Whether the billing item was created as part of a special deal */
              isSpecialDeal: boolean;
              francoSetting?: null | {
                francoAmount?: null | {
                  amount: number;
                  currency: string;
                };
                francoFlatFeeAmount?: null | {
                  amount: number;
                  currency: string;
                };
              };
            }[];
          };
          issue?: null | {
            casesVisibleToBrand: string[];
            casesAllowedToBeSentToBrand: string[];
            current: null | {
              status: string;
              escalatedToCsByBrand: boolean;
              escalatedToCsToAdjustQuantityByBrand: boolean;
              escalatedToCsOnReship: boolean;
              autoEscalatedToCs: boolean;
              autoEscalatedToCsOnReship: boolean;
              sendToBrandEnabled: boolean;
              escalatedNewClaimToCs: null | boolean;
              reason: string;
              shippedDate: string;
              autoEscalateDate: string;
              trackingLink: null | string;
              trackingNumber: null | string;
              shippingProvider: null | string;
              reshippedDate: null | string;
              products: {
                id: number;
                name: string;
                sku: string;
                description: string;
                quantity: number;
                files: {
                  url: string;
                }[];
              }[];
              packagingFiles: {
                url: string;
              }[];
              parcelReservationFiles: {
                url: string;
              }[];
              parcelContentFiles: {
                url: string;
              }[];
              options: {
                label: string;
                text: string;
              }[];
            };
          };
          retailer: null | {
            id: null | number;
            /** @format uuid */
            uuid?: string | null;
            name: string;
            /** @format email */
            email: string;
            phone_number: string;
            city: string;
            business: {
              user_first_name?: string;
              user_last_name?: string;
              vat_number: null | string;
              tax_number: null | string;
              country: {
                iso_code: string;
              };
            };
            /** The opening times of the customer for delivery. */
            deliverySchedule?: {
              /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
              timeSlots:
                | {
                    /**
                     * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "09:30"
                     */
                    startTime: string;
                    /**
                     * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "12:30"
                     */
                    endTime: string;
                  }[]
                | null;
              /**
               * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
               * @minItems 1
               * @uniqueItems true
               * @example [1,2,3]
               */
              openDays: number[];
            } | null;
            /** The packing instruction of the customer. */
            packingInstruction?: {
              /**
               * List of packing instruction services
               * @minItems 1
               */
              services: OrderingShowOrderServicesEnum[];
              /**
               * Additional packing instruction (can be empty)
               * @example "Instruction text"
               */
              instruction: string;
            } | null;
            deliveryAppointment?: {
              /**
               * Whether a delivery appointment is requested for this customer.
               * @example true
               */
              requested: boolean;
              /**
               * Additional instruction for the delivery appointment (can be empty)
               * @maxLength 1000
               * @example "Please call before delivery"
               */
              instruction: string;
            } | null;
          };
          rejection: null | {
            brandRejectType: null | string;
            availableBrandRejectReasons?: {
              rejectType: string;
              rejectTypeLabel: string;
            }[];
            isRetailerCancellationRequestOpened?: boolean;
          };
          meta: null | {
            showAlcoholWarning?: boolean;
            showManualInvoiceDownloadWarning?: boolean;
            casesVisibleToBrand?: string[];
            casesAllowedToBeSentToBrand?: string[];
            isSplitAllowed?: boolean;
            businessModel?: OrderingShowOrderBusinessModelEnum;
          };
        }
      | {
          /** Type of wrapped order */
          type: OrderingShowOrderTypeEnum2;
          /** @format date-time */
          createdAt: string;
          orderItemCount?: number;
          internalId: null | number;
          checkoutId?: null | number;
          /**
           * The AnkorPay payment operation UUID associated with this order's checkout. Null if no payment operation is found.
           * @format uuid
           */
          externalPaymentUuid?: null | string;
          status: {
            name: string;
            shortTitle?: string;
            title: null | string;
            details: null | string;
            subStatus?: {
              shortTitle?: string;
            };
            /** @format datetime */
            transitionedAt?: null | string;
          };
          totals: null | {
            totalAmount: {
              amount: number;
              currency: string;
            };
            totalVatAmount: {
              amount: number;
              currency: string;
            };
            totalAmountWithVat: {
              amount: number;
              currency: string;
            };
            netAmount: {
              amount: number;
              currency: string;
            };
            retailerTotalAmountBeforeDiscount?: {
              amount: number;
              currency: string;
            };
          };
          brand: {
            id: number;
            name: string;
            /** @format url */
            link: string;
            display_address: {
              city: string;
            };
            images?: {
              rounded: null | string;
            };
          };
          updates: null | {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
          events?: {
            type: string;
            updates: {
              oldTotalAmount: {
                amount: number;
                currency: string;
              };
              oldTotalAmountVat: {
                amount: number;
                currency: string;
              };
              oldTotalAmountWithVat: {
                amount: number;
                currency: string;
              };
              oldRecargoAmount: null | {
                amount: number;
                currency: string;
              };
              itemUpdates: {
                itemId: string;
                productName: string;
                sku: string;
                productImage: string | null;
                productUrl: string;
                oldQuantity: number;
                newQuantity: number;
                oldMultipliedQuantity: number;
                newMultipliedQuantity: number;
                unitPrice: {
                  amount: number;
                  currency: string;
                };
                oldAmount: {
                  amount: number;
                  currency: string;
                };
                newAmount: {
                  amount: number;
                  currency: string;
                };
              }[];
            };
          }[];
          taxes:
            | null
            | {
                name: string;
                amount: {
                  amount: number;
                  currency: string;
                };
              }[];
          shipping: {
            shippingProvider: null | string;
            /** @format date-time */
            shippedAt: null | string;
            shippingMethod: null | string;
            shippingAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            shipment: null | {
              trackedPackages: {
                /** @format url */
                labelUrl?: null | string;
                parcel?: {
                  weight: null | number;
                  height: null | number;
                  length: null | number;
                  width: null | number;
                  distanceUnit?: OrderingShowOrderDistanceUnitEnum2;
                };
              }[];
            };
          };
          tracking: null | {
            trackingNumber: null | string;
            trackingLink: null | string;
            status: null | string;
          };
          billing: null | {
            billingItems: {
              id: number;
              type: string;
              label: string;
              displayVat: boolean;
              isVatShifted: boolean;
              amount: null | {
                amount: number;
                currency: string;
              };
              amountVat: null | {
                amount: number;
                currency: string;
              };
              amountWithVat: null | {
                amount: number;
                currency: string;
              };
              /** Amount of the billing item in percents */
              percentage: null | number;
              /** Whether the billing item was created as part of a special deal */
              isSpecialDeal: boolean;
              francoSetting?: null | {
                francoAmount?: null | {
                  amount: number;
                  currency: string;
                };
                francoFlatFeeAmount?: null | {
                  amount: number;
                  currency: string;
                };
              };
            }[];
          };
          issue?: null | {
            casesVisibleToBrand: string[];
            casesAllowedToBeSentToBrand: string[];
            current: null | {
              status: string;
              escalatedToCsByBrand: boolean;
              escalatedToCsToAdjustQuantityByBrand: boolean;
              escalatedToCsOnReship: boolean;
              autoEscalatedToCs: boolean;
              autoEscalatedToCsOnReship: boolean;
              sendToBrandEnabled: boolean;
              escalatedNewClaimToCs: null | boolean;
              reason: string;
              shippedDate: string;
              autoEscalateDate: string;
              trackingLink: null | string;
              trackingNumber: null | string;
              shippingProvider: null | string;
              reshippedDate: null | string;
              products: {
                id: number;
                name: string;
                sku: string;
                description: string;
                quantity: number;
                files: {
                  url: string;
                }[];
              }[];
              packagingFiles: {
                url: string;
              }[];
              parcelReservationFiles: {
                url: string;
              }[];
              parcelContentFiles: {
                url: string;
              }[];
              options: {
                label: string;
                text: string;
              }[];
            };
          };
          retailer: {
            id: null | number;
            name: string;
            store_url: null | string;
            /** @format email */
            email: string;
            phone_number: string;
            city: string;
            postal_code?: string;
            address_line?: string;
            company_name?: string;
            business: {
              vat_number: null | string;
              tax_number: null | string;
              user_first_name?: null | string;
              user_last_name?: null | string;
              country: {
                iso_code: string;
              };
            };
          };
          rejection: null | {
            brandRejectType: null | string;
          };
          cancellation?: null | {
            retailerCanOpenCancellationRequest: boolean;
          };
          meta: null | {
            showManualInvoiceDownloadWarning?: boolean;
            casesVisibleToBrand?: string[];
            casesAllowedToBeSentToBrand?: string[];
          };
        };
    relationships?: {
      orderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      orderShipping?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          shippingMethod: null | OrderingShowOrderShippingMethodEnum;
          isAddingTrackingInformationPostponed: null | boolean;
          stockOrigin: null | OrderingShowOrderStockOriginEnum;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: null | number;
          unitQuantity: number;
          batchQuantity: number;
          unitPrice: null | {
            amount: number;
            currency: string;
          };
          totalPrice: null | {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          /** Resource identification present in Resource Objects and Resource Identifier Objects. */
          orderedProduct?: {
            /**
             * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
             * @format uuid
             */
            id: string;
            /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
            type: string;
            /** Non-standard meta-information that can not be represented as an attribute or relationship. */
            meta?: Record<string, any>;
          };
        };
      }
    | {
        type?: 'order-issue';
        id?: string;
        attributes?: {
          status: string;
          escalatedToCsByBrand: boolean;
          escalatedToCsToAdjustQuantityByBrand: boolean;
          escalatedToCsOnReship: boolean;
          autoEscalatedToCs: boolean;
          autoEscalatedToCsOnReship: boolean;
          sendToBrandEnabled: boolean;
          escalatedNewClaimToCs: null | boolean;
          reason: string;
          shippedDate: string;
          autoEscalateDate: string;
          trackingLink: null | string;
          trackingNumber: null | string;
          shippingProvider: null | string;
          reshippedDate: null | string;
          products: {
            id: number;
            name: string;
            sku: string;
            description: string;
            quantity: number;
            files: {
              url: string;
            }[];
          }[];
          packagingFiles: {
            url: string;
          }[];
          parcelReservationFiles: {
            url: string;
          }[];
          parcelContentFiles: {
            url: string;
          }[];
          options: {
            label: string;
            text: string;
          }[];
        };
      }
  )[];
}

/** Include related resources in the response */
export enum OrderingShowOrderParams1IncludeEnum {
  OrderItems = 'orderItems',
  OrderShipping = 'orderShipping',
}

export interface GetMasterOrderUuidByInternalIdData {
  data: {
    masterOrderUuid?: string;
  };
}

export interface OrderingExportOrdersParams {
  /** Year for which orders to be exported */
  export_year?: number;
  /** Month for which orders to be exported */
  export_month?: number;
  /** Export format i.e. csv, xlsx */
  export_format?: ExportFormatEnum;
  status_key?: StatusKeyEnum;
}

/** Export format i.e. csv, xlsx */
export enum ExportFormatEnum {
  Csv = 'csv',
  Xlsx = 'xlsx',
}

export enum StatusKeyEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
  PendingValidation = 'pending_validation',
  ReceptionRefused = 'reception_refused',
}

/**
 * The contents of a CSV file.
 * @format binary
 */
export type OrderingExportOrdersData = File;

/** Export format i.e. csv, xlsx */
export enum OrderingExportOrdersParams1ExportFormatEnum {
  Csv = 'csv',
  Xlsx = 'xlsx',
}

export enum OrderingExportOrdersParams1StatusKeyEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
  PendingValidation = 'pending_validation',
  ReceptionRefused = 'reception_refused',
}

/** Type of wrapped order */
export enum OrderingSplitOrderTypeEnum {
  Internal = 'internal',
  External = 'external',
}

export enum OrderingSplitOrderMasterStatusEnum {
  Created = 'created',
  Prepared = 'prepared',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingSplitOrderTypeEnum1 {
  PublicApp = 'publicApp',
}

export enum OrderingSplitOrderPlatformNameEnum {
  WOO_COMMERCE = 'WOO_COMMERCE',
  SHOPIFY = 'SHOPIFY',
}

export enum OrderingSplitOrderNameEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum OrderingSplitOrderCollectionMethodsEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum OrderingSplitOrderDistanceUnitEnum {
  Cm = 'cm',
}

export enum OrderingSplitOrderLabelPrintingFormatEnum {
  Default = 'default',
  FullPage = 'full_page',
}

export enum OrderingSplitOrderDistanceUnitEnum1 {
  Cm = 'cm',
}

export enum OrderingSplitOrderServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum OrderingSplitOrderBusinessModelEnum {
  Value2024 = '2024',
  Value2025 = '2025',
}

/** Type of wrapped order */
export enum OrderingSplitOrderTypeEnum2 {
  Internal = 'internal',
}

export enum OrderingSplitOrderDistanceUnitEnum2 {
  Cm = 'cm',
}

export enum OrderingSplitOrderShippingMethodEnum {
  Custom = 'custom',
  Ankorstore = 'ankorstore',
  Fulfillment = 'fulfillment',
}

export enum OrderingSplitOrderStockOriginEnum {
  DirectShipping = 'directShipping',
  FulfillmentCenter = 'fulfillmentCenter',
}

export interface OrderingSplitOrderData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes:
      | {
          /** Type of wrapped order */
          type: OrderingSplitOrderTypeEnum;
          /** @format date-time */
          createdAt: string;
          /** @format date-time */
          preorderCreatedAt?: null | string;
          /** @pattern ^[EI][A-NP-Z]{3}[1-9]{7}$ */
          reference?: string;
          customReference?: null | string;
          masterStatus?: OrderingSplitOrderMasterStatusEnum;
          status: {
            name: string;
            shortTitle?: string;
            title: null | string;
            details: null | string;
            subStatus?: {
              shortTitle?: string;
            };
          };
          /** The `amounts` property of the `ExternalOrder`, if set. */
          amounts?: {
            /** @example "EUR" */
            brandCurrency: string;
            /** @example 1 */
            brandCurrencyRate: number;
            /** @example "€546.20" */
            brandTotalAmount: string;
            /** @example "€126.33" */
            brandTotalAmountVat: string;
            /** @example "€672.53" */
            brandTotalAmountWithVat: string;
            /** @example "EUR" */
            customerCurrency: string;
            /** @example 1 */
            customerCurrencyRate: number;
            /** @example "€546.20" */
            customerTotalAmount: string;
            /** @example "€126.33" */
            customerTotalAmountVat: string;
            /** @example "€672.53" */
            customerTotalAmountWithVat: string;
            /** @example "€2.20" */
            shippingFeesAmount: string;
            /** @example "€0.44" */
            shippingFeesAmountVat: string;
            /** @example "€2.64" */
            shippingFeesAmountWithVat: string;
            /** @example "€548.40" */
            customerGrandTotalAmount: string;
            /** @example "€126.77" */
            customerGrandTotalAmountVat: string;
            /** @example "€675.17" */
            customerGrandTotalAmountWithVat: string;
          };
          /** The `metadata` property of the `ExternalOrder`, if set. */
          metadata?: {
            /** @example "fulfillment" */
            shippingMethod: string;
            address: {
              /** @example "FR" */
              countryCode: string;
              /** @example "75116" */
              postalCode: string;
              /** @example "Paris" */
              city: string;
              /** @example "av Kleber" */
              addressLine: string;
              /** @example null */
              company: string | null;
            };
            contactPerson: {
              /** @example "John" */
              firstName: string;
              /** @example "Smith" */
              lastName: string;
              /** @example "foo@bar.com" */
              email: string;
              /** @example null */
              phone: string | null;
            };
          };
          internalId: null | number;
          /** @format uuid */
          internalUuid?: string | null;
          /** @format uuid */
          externalOrderUuid?: string | null;
          isDiscovery?: null | boolean;
          isDiscoveryForRetailer?: null | boolean;
          isBelongingToReferral?: null | boolean;
          totals: null | {
            totalAmount: {
              amount: number;
              currency: string;
            };
            totalVatAmount: {
              amount: number;
              currency: string;
            };
            totalAmountWithVat: {
              amount: number;
              currency: string;
            };
            netAmount: {
              amount: number;
              currency: string;
            };
          };
          brand: {
            id: string | number;
            name: string;
            /** @format url */
            link: string;
            display_address: {
              city: string;
            };
          };
          user?: {
            /** @format uuid */
            uuid: string;
            /** @example "John" */
            firstName: string;
            /** @example "Smith" */
            lastName: string;
            /**
             * @format email
             * @example "john@smith.com"
             */
            email: string;
          };
          updates: null | {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
          taxes:
            | null
            | {
                name: string;
                amount: {
                  amount: number;
                  currency: string;
                };
              }[];
          priorityTag?: null | {
            name: string;
          };
          vat: null | {
            isShifted: boolean;
            applicationDetails: null | {
              message: string;
              link: null | {
                href: string;
                text: string;
              };
            };
          };
          deadlines?: null | {
            /** @format date-time */
            toShip: null | string;
            /** @format date-time */
            toAccept: null | string;
            /** @format date-time */
            toActOnIssue: null | string;
          };
          synchronizations?:
            | null
            | {
                type?: OrderingSplitOrderTypeEnum1;
                platformName?: OrderingSplitOrderPlatformNameEnum;
                error?: null | string;
              }[];
          invoices?:
            | null
            | {
                isGenerated: boolean;
                title: string;
                number: null | string;
                path: null | string;
              }[];
          shipping: null | {
            shippingProvider: null | string;
            isInternational?: boolean;
            hasShippingLabelGenerationError?: boolean;
            hasRevertedShippingLabels?: boolean;
            fees?: null | {
              refundAmount: null | {
                amount: number;
                currency: string;
              };
            };
            /** Final brand shipping fee once the carrier-billed weight is known. Absent when only an estimation is available — callers should then fall back to shipmentEstimation.rateAmount. */
            billedWeightFee?: {
              amount: number;
              currency: string;
            };
            shippingAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            availableShippingMethods?:
              | null
              | {
                  name: OrderingSplitOrderNameEnum;
                  canBeUsed: boolean;
                  errors: object[] | object;
                }[];
            shipmentEstimation?: null | {
              collectionMethods: OrderingSplitOrderCollectionMethodsEnum[];
              rateProvider: null | string;
              rateAmount: null | {
                amount: number;
                currency: string;
              };
              estimatedParcels: {
                weight: null | number;
                height: null | number;
                length: null | number;
                width: null | number;
                distanceUnit?: OrderingSplitOrderDistanceUnitEnum;
              }[];
            };
            shipment: null | {
              /** @format date-time */
              shippedAt: null | string;
              labelPrintingFormat: OrderingSplitOrderLabelPrintingFormatEnum;
              trackedPackages: {
                /** @format url */
                labelUrl?: null | string;
                parcel?: {
                  weight: null | number;
                  height: null | number;
                  length: null | number;
                  width: null | number;
                  distanceUnit?: OrderingSplitOrderDistanceUnitEnum1;
                };
              }[];
              shipFromAddress: {
                address: {
                  countryCode: null | string;
                  postalCode: null | string;
                  city: null | string;
                  addressLine: null | string;
                };
                company: null | string;
                contactPerson: {
                  firstName: null | string;
                  lastName: null | string;
                  fullName: null | string;
                  phoneNumber: null | string;
                  /** @format email */
                  email: null | string;
                };
              };
              pickup: null | {
                /** @format date-time */
                date: string;
                readyTime: string;
                closeTime: string;
              };
              labelRevertReasons: {
                actionType: string;
                actionReason: string;
              }[];
            };
          };
          tracking: null | {
            trackingNumber: null | string;
            trackingLink: null | string;
            status: null | string;
          };
          billing: null | {
            billingItems: {
              id: number;
              type: string;
              label: string;
              displayVat: boolean;
              isVatShifted: boolean;
              amount: null | {
                amount: number;
                currency: string;
              };
              amountVat: null | {
                amount: number;
                currency: string;
              };
              amountWithVat: null | {
                amount: number;
                currency: string;
              };
              /** Amount of the billing item in percents */
              percentage: null | number;
              /** Whether the billing item was created as part of a special deal */
              isSpecialDeal: boolean;
              francoSetting?: null | {
                francoAmount?: null | {
                  amount: number;
                  currency: string;
                };
                francoFlatFeeAmount?: null | {
                  amount: number;
                  currency: string;
                };
              };
            }[];
          };
          issue?: null | {
            casesVisibleToBrand: string[];
            casesAllowedToBeSentToBrand: string[];
            current: null | {
              status: string;
              escalatedToCsByBrand: boolean;
              escalatedToCsToAdjustQuantityByBrand: boolean;
              escalatedToCsOnReship: boolean;
              autoEscalatedToCs: boolean;
              autoEscalatedToCsOnReship: boolean;
              sendToBrandEnabled: boolean;
              escalatedNewClaimToCs: null | boolean;
              reason: string;
              shippedDate: string;
              autoEscalateDate: string;
              trackingLink: null | string;
              trackingNumber: null | string;
              shippingProvider: null | string;
              reshippedDate: null | string;
              products: {
                id: number;
                name: string;
                sku: string;
                description: string;
                quantity: number;
                files: {
                  url: string;
                }[];
              }[];
              packagingFiles: {
                url: string;
              }[];
              parcelReservationFiles: {
                url: string;
              }[];
              parcelContentFiles: {
                url: string;
              }[];
              options: {
                label: string;
                text: string;
              }[];
            };
          };
          retailer: null | {
            id: null | number;
            /** @format uuid */
            uuid?: string | null;
            name: string;
            /** @format email */
            email: string;
            phone_number: string;
            city: string;
            business: {
              user_first_name?: string;
              user_last_name?: string;
              vat_number: null | string;
              tax_number: null | string;
              country: {
                iso_code: string;
              };
            };
            /** The opening times of the customer for delivery. */
            deliverySchedule?: {
              /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
              timeSlots:
                | {
                    /**
                     * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "09:30"
                     */
                    startTime: string;
                    /**
                     * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                     * @example "12:30"
                     */
                    endTime: string;
                  }[]
                | null;
              /**
               * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
               * @minItems 1
               * @uniqueItems true
               * @example [1,2,3]
               */
              openDays: number[];
            } | null;
            /** The packing instruction of the customer. */
            packingInstruction?: {
              /**
               * List of packing instruction services
               * @minItems 1
               */
              services: OrderingSplitOrderServicesEnum[];
              /**
               * Additional packing instruction (can be empty)
               * @example "Instruction text"
               */
              instruction: string;
            } | null;
            deliveryAppointment?: {
              /**
               * Whether a delivery appointment is requested for this customer.
               * @example true
               */
              requested: boolean;
              /**
               * Additional instruction for the delivery appointment (can be empty)
               * @maxLength 1000
               * @example "Please call before delivery"
               */
              instruction: string;
            } | null;
          };
          rejection: null | {
            brandRejectType: null | string;
            availableBrandRejectReasons?: {
              rejectType: string;
              rejectTypeLabel: string;
            }[];
            isRetailerCancellationRequestOpened?: boolean;
          };
          meta: null | {
            showAlcoholWarning?: boolean;
            showManualInvoiceDownloadWarning?: boolean;
            casesVisibleToBrand?: string[];
            casesAllowedToBeSentToBrand?: string[];
            isSplitAllowed?: boolean;
            businessModel?: OrderingSplitOrderBusinessModelEnum;
          };
        }
      | {
          /** Type of wrapped order */
          type: OrderingSplitOrderTypeEnum2;
          /** @format date-time */
          createdAt: string;
          orderItemCount?: number;
          internalId: null | number;
          checkoutId?: null | number;
          /**
           * The AnkorPay payment operation UUID associated with this order's checkout. Null if no payment operation is found.
           * @format uuid
           */
          externalPaymentUuid?: null | string;
          status: {
            name: string;
            shortTitle?: string;
            title: null | string;
            details: null | string;
            subStatus?: {
              shortTitle?: string;
            };
            /** @format datetime */
            transitionedAt?: null | string;
          };
          totals: null | {
            totalAmount: {
              amount: number;
              currency: string;
            };
            totalVatAmount: {
              amount: number;
              currency: string;
            };
            totalAmountWithVat: {
              amount: number;
              currency: string;
            };
            netAmount: {
              amount: number;
              currency: string;
            };
            retailerTotalAmountBeforeDiscount?: {
              amount: number;
              currency: string;
            };
          };
          brand: {
            id: number;
            name: string;
            /** @format url */
            link: string;
            display_address: {
              city: string;
            };
            images?: {
              rounded: null | string;
            };
          };
          updates: null | {
            oldTotalAmount: {
              amount: number;
              currency: string;
            };
            oldTotalAmountVat: {
              amount: number;
              currency: string;
            };
            oldTotalAmountWithVat: {
              amount: number;
              currency: string;
            };
            oldRecargoAmount: null | {
              amount: number;
              currency: string;
            };
            itemUpdates: {
              itemId: string;
              productName: string;
              sku: string;
              productImage: string | null;
              productUrl: string;
              oldQuantity: number;
              newQuantity: number;
              oldMultipliedQuantity: number;
              newMultipliedQuantity: number;
              unitPrice: {
                amount: number;
                currency: string;
              };
              oldAmount: {
                amount: number;
                currency: string;
              };
              newAmount: {
                amount: number;
                currency: string;
              };
            }[];
          };
          events?: {
            type: string;
            updates: {
              oldTotalAmount: {
                amount: number;
                currency: string;
              };
              oldTotalAmountVat: {
                amount: number;
                currency: string;
              };
              oldTotalAmountWithVat: {
                amount: number;
                currency: string;
              };
              oldRecargoAmount: null | {
                amount: number;
                currency: string;
              };
              itemUpdates: {
                itemId: string;
                productName: string;
                sku: string;
                productImage: string | null;
                productUrl: string;
                oldQuantity: number;
                newQuantity: number;
                oldMultipliedQuantity: number;
                newMultipliedQuantity: number;
                unitPrice: {
                  amount: number;
                  currency: string;
                };
                oldAmount: {
                  amount: number;
                  currency: string;
                };
                newAmount: {
                  amount: number;
                  currency: string;
                };
              }[];
            };
          }[];
          taxes:
            | null
            | {
                name: string;
                amount: {
                  amount: number;
                  currency: string;
                };
              }[];
          shipping: {
            shippingProvider: null | string;
            /** @format date-time */
            shippedAt: null | string;
            shippingMethod: null | string;
            shippingAddress: {
              address: {
                countryCode: null | string;
                postalCode: null | string;
                city: null | string;
                addressLine: null | string;
              };
              company: null | string;
              contactPerson: {
                firstName: null | string;
                lastName: null | string;
                fullName: null | string;
                phoneNumber: null | string;
                /** @format email */
                email: null | string;
              };
            };
            shipment: null | {
              trackedPackages: {
                /** @format url */
                labelUrl?: null | string;
                parcel?: {
                  weight: null | number;
                  height: null | number;
                  length: null | number;
                  width: null | number;
                  distanceUnit?: OrderingSplitOrderDistanceUnitEnum2;
                };
              }[];
            };
          };
          tracking: null | {
            trackingNumber: null | string;
            trackingLink: null | string;
            status: null | string;
          };
          billing: null | {
            billingItems: {
              id: number;
              type: string;
              label: string;
              displayVat: boolean;
              isVatShifted: boolean;
              amount: null | {
                amount: number;
                currency: string;
              };
              amountVat: null | {
                amount: number;
                currency: string;
              };
              amountWithVat: null | {
                amount: number;
                currency: string;
              };
              /** Amount of the billing item in percents */
              percentage: null | number;
              /** Whether the billing item was created as part of a special deal */
              isSpecialDeal: boolean;
              francoSetting?: null | {
                francoAmount?: null | {
                  amount: number;
                  currency: string;
                };
                francoFlatFeeAmount?: null | {
                  amount: number;
                  currency: string;
                };
              };
            }[];
          };
          issue?: null | {
            casesVisibleToBrand: string[];
            casesAllowedToBeSentToBrand: string[];
            current: null | {
              status: string;
              escalatedToCsByBrand: boolean;
              escalatedToCsToAdjustQuantityByBrand: boolean;
              escalatedToCsOnReship: boolean;
              autoEscalatedToCs: boolean;
              autoEscalatedToCsOnReship: boolean;
              sendToBrandEnabled: boolean;
              escalatedNewClaimToCs: null | boolean;
              reason: string;
              shippedDate: string;
              autoEscalateDate: string;
              trackingLink: null | string;
              trackingNumber: null | string;
              shippingProvider: null | string;
              reshippedDate: null | string;
              products: {
                id: number;
                name: string;
                sku: string;
                description: string;
                quantity: number;
                files: {
                  url: string;
                }[];
              }[];
              packagingFiles: {
                url: string;
              }[];
              parcelReservationFiles: {
                url: string;
              }[];
              parcelContentFiles: {
                url: string;
              }[];
              options: {
                label: string;
                text: string;
              }[];
            };
          };
          retailer: {
            id: null | number;
            name: string;
            store_url: null | string;
            /** @format email */
            email: string;
            phone_number: string;
            city: string;
            postal_code?: string;
            address_line?: string;
            company_name?: string;
            business: {
              vat_number: null | string;
              tax_number: null | string;
              user_first_name?: null | string;
              user_last_name?: null | string;
              country: {
                iso_code: string;
              };
            };
          };
          rejection: null | {
            brandRejectType: null | string;
          };
          cancellation?: null | {
            retailerCanOpenCancellationRequest: boolean;
          };
          meta: null | {
            showManualInvoiceDownloadWarning?: boolean;
            casesVisibleToBrand?: string[];
            casesAllowedToBeSentToBrand?: string[];
          };
        };
    relationships?: {
      orderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      orderShipping?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          shippingMethod: null | OrderingSplitOrderShippingMethodEnum;
          isAddingTrackingInformationPostponed: null | boolean;
          stockOrigin: null | OrderingSplitOrderStockOriginEnum;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: null | number;
          unitQuantity: number;
          batchQuantity: number;
          unitPrice: null | {
            amount: number;
            currency: string;
          };
          totalPrice: null | {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          /** Resource identification present in Resource Objects and Resource Identifier Objects. */
          orderedProduct?: {
            /**
             * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
             * @format uuid
             */
            id: string;
            /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
            type: string;
            /** Non-standard meta-information that can not be represented as an attribute or relationship. */
            meta?: Record<string, any>;
          };
        };
      }
    | {
        type?: 'order-issue';
        id?: string;
        attributes?: {
          status: string;
          escalatedToCsByBrand: boolean;
          escalatedToCsToAdjustQuantityByBrand: boolean;
          escalatedToCsOnReship: boolean;
          autoEscalatedToCs: boolean;
          autoEscalatedToCsOnReship: boolean;
          sendToBrandEnabled: boolean;
          escalatedNewClaimToCs: null | boolean;
          reason: string;
          shippedDate: string;
          autoEscalateDate: string;
          trackingLink: null | string;
          trackingNumber: null | string;
          shippingProvider: null | string;
          reshippedDate: null | string;
          products: {
            id: number;
            name: string;
            sku: string;
            description: string;
            quantity: number;
            files: {
              url: string;
            }[];
          }[];
          packagingFiles: {
            url: string;
          }[];
          parcelReservationFiles: {
            url: string;
          }[];
          parcelContentFiles: {
            url: string;
          }[];
          options: {
            label: string;
            text: string;
          }[];
        };
      }
  )[];
}

export interface OrderingListOrderItemsParams {
  /** Include related resources in the response */
  include?: IncludeEnum2;
  /**
   * UUID of the requested resource
   * @format uuid
   */
  id: string;
}

/** Include related resources in the response */
export enum IncludeEnum2 {
  OrderedProduct = 'orderedProduct',
}

export interface OrderingListOrderItemsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      internalId: null | number;
      unitQuantity: number;
      batchQuantity: number;
      unitPrice: null | {
        amount: number;
        currency: string;
      };
      totalPrice: null | {
        amount: number;
        currency: string;
      };
    };
    relationships?: {
      /** Resource identification present in Resource Objects and Resource Identifier Objects. */
      orderedProduct?: {
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      };
    };
  }[];
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /** @format uuid */
      fulfillableId: null | string;
      sku: string;
      name: string;
      pageUrl: string;
      /** Harmonized System Code - product classification for customs purposes. */
      hsCode?: null | string;
      images: string[];
      options: {
        name: string;
        value: null | string;
      }[];
    };
  }[];
}

/** Include related resources in the response */
export enum OrderingListOrderItemsParams1IncludeEnum {
  OrderedProduct = 'orderedProduct',
}

export interface OrderingGetPreorderRetailerData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      ibanLast4: null | string;
    };
  }[];
}

export enum OrderingGetPreordersCartStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingGetPreordersCartPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingGetPreordersCartInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface OrderingGetPreordersCartParams {
  /** Include related resources in the response */
  include?: IncludeEnum3;
}

/** Include related resources in the response */
export enum IncludeEnum3 {
  Preorders = 'preorders',
  PreordersPreorderItems = 'preorders.preorderItems',
  PreordersPreorderItemsProductVariant = 'preorders.preorderItems.productVariant',
  PreordersBrand = 'preorders.brand',
}

export interface OrderingGetPreordersCartData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      itemCount: number;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          isSelected: boolean;
          isShippingRestrictedByEori: boolean;
          itemCount: number;
          status: OrderingGetPreordersCartStatusEnum;
          /** @format date-time */
          submittedAt: string | null;
          totalBaseAmount: {
            amount: number;
            currency: string;
          };
          totalAmountVat?: {
            amount: number;
            currency: string;
          };
          totalAmountWithVat?: {
            amount: number;
            currency: string;
          };
          totalAmountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
          grandTotalAmountWithVat: {
            amount: number;
            currency: string;
          };
          offerDiscounts?: {
            name: string;
            type: string;
            amount: {
              amount: number;
              currency: string;
            };
          }[];
          preorderMinimumAmount?: {
            amount: number;
            currency: string;
          };
          shippingContributionAmount?: {
            amount: number;
            currency: string;
          };
          hasDiscounts?: boolean;
          hasMultiDiscounts?: boolean;
          globalDiscountPercentage?: number;
          paymentTerms?: OrderingGetPreordersCartPaymentTermsEnum;
          metadata?: {
            isDiscovery: boolean;
            actualShippingFeeAmount?: {
              amount: number;
              currency: string;
            };
            shippingFeeAmountVat?: {
              amount: number;
              currency: string;
            };
            francoAmount?: null | number;
            discountedShippingAmount?: {
              amount: number;
              currency: string;
            };
            amountLeftForFreeShipping?: {
              amount: number;
              currency: string;
            };
            isEligibleForDiscoveryFreeShipping?: boolean;
            isBrandEligibleForAkPlusFreeShipping?: boolean;
            offerName?: null | string;
          };
        };
        relationships?: {
          preorderItems?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingGetPreordersCartInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
  )[];
}

/** Include related resources in the response */
export enum OrderingGetPreordersCartParams1IncludeEnum {
  Preorders = 'preorders',
  PreordersPreorderItems = 'preorders.preorderItems',
  PreordersPreorderItemsProductVariant = 'preorders.preorderItems.productVariant',
  PreordersBrand = 'preorders.brand',
}

export enum OrderingUpdatePreorderSelectionStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingUpdatePreorderSelectionPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingUpdatePreorderSelectionInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface OrderingUpdatePreorderSelectionData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      itemCount: number;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          isSelected: boolean;
          isShippingRestrictedByEori: boolean;
          itemCount: number;
          status: OrderingUpdatePreorderSelectionStatusEnum;
          /** @format date-time */
          submittedAt: string | null;
          totalBaseAmount: {
            amount: number;
            currency: string;
          };
          totalAmountVat?: {
            amount: number;
            currency: string;
          };
          totalAmountWithVat?: {
            amount: number;
            currency: string;
          };
          totalAmountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
          grandTotalAmountWithVat: {
            amount: number;
            currency: string;
          };
          offerDiscounts?: {
            name: string;
            type: string;
            amount: {
              amount: number;
              currency: string;
            };
          }[];
          preorderMinimumAmount?: {
            amount: number;
            currency: string;
          };
          shippingContributionAmount?: {
            amount: number;
            currency: string;
          };
          hasDiscounts?: boolean;
          hasMultiDiscounts?: boolean;
          globalDiscountPercentage?: number;
          paymentTerms?: OrderingUpdatePreorderSelectionPaymentTermsEnum;
          metadata?: {
            isDiscovery: boolean;
            actualShippingFeeAmount?: {
              amount: number;
              currency: string;
            };
            shippingFeeAmountVat?: {
              amount: number;
              currency: string;
            };
            francoAmount?: null | number;
            discountedShippingAmount?: {
              amount: number;
              currency: string;
            };
            amountLeftForFreeShipping?: {
              amount: number;
              currency: string;
            };
            isEligibleForDiscoveryFreeShipping?: boolean;
            isBrandEligibleForAkPlusFreeShipping?: boolean;
            offerName?: null | string;
          };
        };
        relationships?: {
          preorderItems?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingUpdatePreorderSelectionInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
  )[];
}

export enum OrderingUpdatePreordersCartStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingUpdatePreordersCartPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingUpdatePreordersCartInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface OrderingUpdatePreordersCartData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      itemCount: number;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          isSelected: boolean;
          isShippingRestrictedByEori: boolean;
          itemCount: number;
          status: OrderingUpdatePreordersCartStatusEnum;
          /** @format date-time */
          submittedAt: string | null;
          totalBaseAmount: {
            amount: number;
            currency: string;
          };
          totalAmountVat?: {
            amount: number;
            currency: string;
          };
          totalAmountWithVat?: {
            amount: number;
            currency: string;
          };
          totalAmountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
          grandTotalAmountWithVat: {
            amount: number;
            currency: string;
          };
          offerDiscounts?: {
            name: string;
            type: string;
            amount: {
              amount: number;
              currency: string;
            };
          }[];
          preorderMinimumAmount?: {
            amount: number;
            currency: string;
          };
          shippingContributionAmount?: {
            amount: number;
            currency: string;
          };
          hasDiscounts?: boolean;
          hasMultiDiscounts?: boolean;
          globalDiscountPercentage?: number;
          paymentTerms?: OrderingUpdatePreordersCartPaymentTermsEnum;
          metadata?: {
            isDiscovery: boolean;
            actualShippingFeeAmount?: {
              amount: number;
              currency: string;
            };
            shippingFeeAmountVat?: {
              amount: number;
              currency: string;
            };
            francoAmount?: null | number;
            discountedShippingAmount?: {
              amount: number;
              currency: string;
            };
            amountLeftForFreeShipping?: {
              amount: number;
              currency: string;
            };
            isEligibleForDiscoveryFreeShipping?: boolean;
            isBrandEligibleForAkPlusFreeShipping?: boolean;
            offerName?: null | string;
          };
        };
        relationships?: {
          preorderItems?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingUpdatePreordersCartInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
  )[];
}

export enum OrderingGetPreordersPaymentTermsNameEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

export interface OrderingGetPreordersPaymentTermsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      name: OrderingGetPreordersPaymentTermsNameEnum;
    };
  }[];
}

export interface OrderingCheckoutPreordersCartData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

export enum OrderingListPreordersStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingListPreordersPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingListPreordersInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum OrderingListPreordersPaymentStatusEnum {
  Pending = 'pending',
  Captured = 'captured',
  Failed = 'failed',
}

export interface OrderingListPreordersParams {
  /** Include related resources in the response */
  include?: string;
  'page[limit]'?: number;
  'page[offset]'?: number;
  /**
   * Filter preorders by included product variant UUIDs, separated by comma
   * @example "123e4567-e89b-12d3-a456-426614174000,123e4567-e89b-12d3-a456-426614174001"
   */
  'filter[productVariantUuid]'?: string;
  /**
   * Filter preorders by statuses, separated by comma
   * @example "requested,waiting_availability"
   */
  'filter[status]'?: string;
}

export interface OrderingListPreordersData {
  meta: {
    page: {
      currentPage?: number;
      from?: number;
      lastPage?: number;
      perPage?: number;
      to?: number;
      total?: number;
    };
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    first?: string;
    last?: string;
    [key: string]: any;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      isSelected: boolean;
      isShippingRestrictedByEori: boolean;
      itemCount: number;
      status: OrderingListPreordersStatusEnum;
      /** @format date-time */
      submittedAt: string | null;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat?: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat?: {
        amount: number;
        currency: string;
      };
      totalAmountBeforeDiscount?: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
      offerDiscounts?: {
        name: string;
        type: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
      preorderMinimumAmount?: {
        amount: number;
        currency: string;
      };
      shippingContributionAmount?: {
        amount: number;
        currency: string;
      };
      hasDiscounts?: boolean;
      hasMultiDiscounts?: boolean;
      globalDiscountPercentage?: number;
      paymentTerms?: OrderingListPreordersPaymentTermsEnum;
      metadata?: {
        isDiscovery: boolean;
        actualShippingFeeAmount?: {
          amount: number;
          currency: string;
        };
        shippingFeeAmountVat?: {
          amount: number;
          currency: string;
        };
        francoAmount?: null | number;
        discountedShippingAmount?: {
          amount: number;
          currency: string;
        };
        amountLeftForFreeShipping?: {
          amount: number;
          currency: string;
        };
        isEligibleForDiscoveryFreeShipping?: boolean;
        isBrandEligibleForAkPlusFreeShipping?: boolean;
        offerName?: null | string;
      };
    };
    relationships?: {
      preorderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      brand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          id: null | number;
          name: string;
          store_url: null | string;
          /** @format email */
          email: string;
          phone_number: string;
          city: string;
          postal_code?: string;
          address_line?: string;
          company_name?: string;
          business: {
            vat_number: null | string;
            tax_number: null | string;
            user_first_name?: null | string;
            user_last_name?: null | string;
            country: {
              iso_code: string;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingListPreordersInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          master_order_uuid?: string;
          payment_status?: OrderingListPreordersPaymentStatusEnum;
          /** @format date-time */
          payment_capture_end_date?: string;
        };
      }
  )[];
}

export enum OrderingShowPreorderStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingShowPreorderPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingShowPreorderInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum OrderingShowPreorderPaymentStatusEnum {
  Pending = 'pending',
  Captured = 'captured',
  Failed = 'failed',
}

export interface OrderingShowPreorderParams {
  /** Include related resources in the response */
  include?: IncludeEnum4;
  /**
   * UUID of the requested resource
   * @format uuid
   */
  id: string;
}

/** Include related resources in the response */
export enum IncludeEnum4 {
  PreorderItems = 'preorderItems',
  PreorderItemsProductVariant = 'preorderItems.productVariant',
  PreorderItemsOrder = 'preorderItems.order',
  Brand = 'brand',
  Retailer = 'retailer',
}

export interface OrderingShowPreorderData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      isSelected: boolean;
      isShippingRestrictedByEori: boolean;
      itemCount: number;
      status: OrderingShowPreorderStatusEnum;
      /** @format date-time */
      submittedAt: string | null;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat?: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat?: {
        amount: number;
        currency: string;
      };
      totalAmountBeforeDiscount?: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
      offerDiscounts?: {
        name: string;
        type: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
      preorderMinimumAmount?: {
        amount: number;
        currency: string;
      };
      shippingContributionAmount?: {
        amount: number;
        currency: string;
      };
      hasDiscounts?: boolean;
      hasMultiDiscounts?: boolean;
      globalDiscountPercentage?: number;
      paymentTerms?: OrderingShowPreorderPaymentTermsEnum;
      metadata?: {
        isDiscovery: boolean;
        actualShippingFeeAmount?: {
          amount: number;
          currency: string;
        };
        shippingFeeAmountVat?: {
          amount: number;
          currency: string;
        };
        francoAmount?: null | number;
        discountedShippingAmount?: {
          amount: number;
          currency: string;
        };
        amountLeftForFreeShipping?: {
          amount: number;
          currency: string;
        };
        isEligibleForDiscoveryFreeShipping?: boolean;
        isBrandEligibleForAkPlusFreeShipping?: boolean;
        offerName?: null | string;
      };
    };
    relationships?: {
      preorderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      brand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          id: null | number;
          name: string;
          store_url: null | string;
          /** @format email */
          email: string;
          phone_number: string;
          city: string;
          postal_code?: string;
          address_line?: string;
          company_name?: string;
          business: {
            vat_number: null | string;
            tax_number: null | string;
            user_first_name?: null | string;
            user_last_name?: null | string;
            country: {
              iso_code: string;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingShowPreorderInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          master_order_uuid?: string;
          payment_status?: OrderingShowPreorderPaymentStatusEnum;
          /** @format date-time */
          payment_capture_end_date?: string;
        };
      }
  )[];
}

/** Include related resources in the response */
export enum OrderingShowPreorderParams1IncludeEnum {
  PreorderItems = 'preorderItems',
  PreorderItemsProductVariant = 'preorderItems.productVariant',
  PreorderItemsOrder = 'preorderItems.order',
  Brand = 'brand',
  Retailer = 'retailer',
}

export enum OrderingAcceptPreorderByBrandStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingAcceptPreorderByBrandPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingAcceptPreorderByBrandInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum OrderingAcceptPreorderByBrandPaymentStatusEnum {
  Pending = 'pending',
  Captured = 'captured',
  Failed = 'failed',
}

export interface OrderingAcceptPreorderByBrandData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      isSelected: boolean;
      isShippingRestrictedByEori: boolean;
      itemCount: number;
      status: OrderingAcceptPreorderByBrandStatusEnum;
      /** @format date-time */
      submittedAt: string | null;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat?: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat?: {
        amount: number;
        currency: string;
      };
      totalAmountBeforeDiscount?: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
      offerDiscounts?: {
        name: string;
        type: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
      preorderMinimumAmount?: {
        amount: number;
        currency: string;
      };
      shippingContributionAmount?: {
        amount: number;
        currency: string;
      };
      hasDiscounts?: boolean;
      hasMultiDiscounts?: boolean;
      globalDiscountPercentage?: number;
      paymentTerms?: OrderingAcceptPreorderByBrandPaymentTermsEnum;
      metadata?: {
        isDiscovery: boolean;
        actualShippingFeeAmount?: {
          amount: number;
          currency: string;
        };
        shippingFeeAmountVat?: {
          amount: number;
          currency: string;
        };
        francoAmount?: null | number;
        discountedShippingAmount?: {
          amount: number;
          currency: string;
        };
        amountLeftForFreeShipping?: {
          amount: number;
          currency: string;
        };
        isEligibleForDiscoveryFreeShipping?: boolean;
        isBrandEligibleForAkPlusFreeShipping?: boolean;
        offerName?: null | string;
      };
    };
    relationships?: {
      preorderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      brand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          id: null | number;
          name: string;
          store_url: null | string;
          /** @format email */
          email: string;
          phone_number: string;
          city: string;
          postal_code?: string;
          address_line?: string;
          company_name?: string;
          business: {
            vat_number: null | string;
            tax_number: null | string;
            user_first_name?: null | string;
            user_last_name?: null | string;
            country: {
              iso_code: string;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingAcceptPreorderByBrandInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          master_order_uuid?: string;
          payment_status?: OrderingAcceptPreorderByBrandPaymentStatusEnum;
          /** @format date-time */
          payment_capture_end_date?: string;
        };
      }
  )[];
}

export enum OrderingRejectPreorderByBrandStatusEnum {
  Created = 'created',
  Requested = 'requested',
  WaitingAvailability = 'waiting_availability',
  PartiallyAvailable = 'partially_available',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderingRejectPreorderByBrandPaymentTermsEnum {
  UponAvailability = 'upon-availability',
  UponAvailabilityNet30 = 'upon-availability-net-30',
  UponAvailabilityNet60 = 'upon-availability-net-60',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum OrderingRejectPreorderByBrandInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export enum OrderingRejectPreorderByBrandPaymentStatusEnum {
  Pending = 'pending',
  Captured = 'captured',
  Failed = 'failed',
}

export interface OrderingRejectPreorderByBrandData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      isSelected: boolean;
      isShippingRestrictedByEori: boolean;
      itemCount: number;
      status: OrderingRejectPreorderByBrandStatusEnum;
      /** @format date-time */
      submittedAt: string | null;
      totalBaseAmount: {
        amount: number;
        currency: string;
      };
      totalAmountVat?: {
        amount: number;
        currency: string;
      };
      totalAmountWithVat?: {
        amount: number;
        currency: string;
      };
      totalAmountBeforeDiscount?: {
        amount: number;
        currency: string;
      };
      grandTotalAmountWithVat: {
        amount: number;
        currency: string;
      };
      offerDiscounts?: {
        name: string;
        type: string;
        amount: {
          amount: number;
          currency: string;
        };
      }[];
      preorderMinimumAmount?: {
        amount: number;
        currency: string;
      };
      shippingContributionAmount?: {
        amount: number;
        currency: string;
      };
      hasDiscounts?: boolean;
      hasMultiDiscounts?: boolean;
      globalDiscountPercentage?: number;
      paymentTerms?: OrderingRejectPreorderByBrandPaymentTermsEnum;
      metadata?: {
        isDiscovery: boolean;
        actualShippingFeeAmount?: {
          amount: number;
          currency: string;
        };
        shippingFeeAmountVat?: {
          amount: number;
          currency: string;
        };
        francoAmount?: null | number;
        discountedShippingAmount?: {
          amount: number;
          currency: string;
        };
        amountLeftForFreeShipping?: {
          amount: number;
          currency: string;
        };
        isEligibleForDiscoveryFreeShipping?: boolean;
        isBrandEligibleForAkPlusFreeShipping?: boolean;
        offerName?: null | string;
      };
    };
    relationships?: {
      preorderItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      brand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          countryIsoCode: string;
          link: string;
          logoImagePath: string;
          isEnabled: boolean;
          canShipToRetailerCountry: boolean;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          id: null | number;
          name: string;
          store_url: null | string;
          /** @format email */
          email: string;
          phone_number: string;
          city: string;
          postal_code?: string;
          address_line?: string;
          company_name?: string;
          business: {
            vat_number: null | string;
            tax_number: null | string;
            user_first_name?: null | string;
            user_last_name?: null | string;
            country: {
              iso_code: string;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantId: string;
          quantity: number;
          multipliedQuantity: number;
          /** @format date-time */
          availableAt: string;
          canBeBought?: boolean;
          unitPrice: {
            amount: number;
            currency: string;
          };
          baseAmount: {
            amount: number;
            currency: string;
          };
          amountBeforeDiscount?: {
            amount: number;
            currency: string;
          };
        };
        relationships?: {
          productVariant?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          order?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          internalId: number;
          name: string;
          sku: string;
          path: string;
          imagePath: string;
          unitMultiplier: number;
          options: {
            name: string;
            value: string;
          }[];
          stock: {
            /**
             * Product-scoped stock status, derived from the currently available
             * stock, `isAlwaysInStock` and `inventoryPolicy`.
             *
             * - `out_of_stock`: there is no stock available to order, i.e.
             *
             *
             *   stock is tracked (`isAlwaysInStock=false`), the
             *   `inventoryPolicy` is `deny`, and the available quantity is
             *   <= 0.
             * - `low_in_stock`: there is little stock left to order, i.e. stock
             *
             *
             *   is tracked (`isAlwaysInStock=false`) and stock is low
             *   (available quantity <= 10, or available quantity < 10% of the
             *   on-hand quantity).
             * - `in_stock`: there is plenty of stock to order (every other
             *
             *
             *   case).
             */
            status: string;
            /**
             * Whether stock is tracked at all for this product variant.
             *
             * - `true`: stock is not tracked — a retailer can order as much of
             *
             *
             *   this variant as they want, with no restriction at all.
             * - `false`: stock is tracked — whether a retailer can order the
             *
             *
             *   variant depends on the available stock quantity and the
             *   `inventoryPolicy`.
             */
            isAlwaysInStock: boolean;
            /**
             * Whether a retailer can order a product variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer cannot order a quantity larger than
             *
             *
             *   the currently available stock quantity, so the variant cannot be
             *   ordered when it is out of stock, or when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can order any quantity, even when stock
             *
             *
             *   is insufficient (desired quantity > available quantity > 0) or the
             *   variant is out of stock (available quantity <= 0).
             *
             * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
             * @default "deny"
             */
            inventoryPolicy: OrderingRejectPreorderByBrandInventoryPolicyEnum;
            availableQuantity?: number;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          master_order_uuid?: string;
          payment_status?: OrderingRejectPreorderByBrandPaymentStatusEnum;
          /** @format date-time */
          payment_capture_end_date?: string;
        };
      }
  )[];
}

export interface OrderingShipExternalOrderWithCustomMethodData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      masterOrderUuid: string;
    };
  };
}

export interface OrderingConfirmReceptionExternalOrderData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      masterOrderUuid: string;
    };
  };
}

/**
 * Current state of the retailer PSP account
 * @example "ACTIVE_WITH_MANDATE"
 */
export enum PaymentListPspsStateEnum {
  ACTIVE_WITH_MANDATE = 'ACTIVE_WITH_MANDATE',
  ACTIVE_NO_MANDATE = 'ACTIVE_NO_MANDATE',
  APPLY = 'APPLY',
  KYC_PENDING = 'KYC_PENDING',
  KYC_IN_REVIEW = 'KYC_IN_REVIEW',
  LEGAL_INFORMATION_PROTECTED = 'LEGAL_INFORMATION_PROTECTED',
  PROCESSING = 'PROCESSING',
  FROZEN = 'FROZEN',
  REFUSED_BI_UPDATE = 'REFUSED_BI_UPDATE',
  REFUSED_GENERIC = 'REFUSED_GENERIC',
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"retailer-psp-accounts","id":"aks","attributes":{"state":"ACTIVE_WITH_MANDATE","availableAmount":{"value":150000,"currency":"EUR"},"totalAmount":{"value":200000,"currency":"EUR"},"unpaidAmount":{"value":0,"currency":"EUR"},"mandate":{"ibanLast4":"1234","signatureDate":"2024-01-15","companyName":"Acme Corp"},"countryCode":"FR","kycLink":null,"email":"debtoremail@gmail.com","identifierType":"SIREN","identifierValue":"445330103","pspId":null}},{"type":"retailer-psp-accounts","id":"aria","attributes":{"state":"ACTIVE_NO_MANDATE","availableAmount":{"value":50000,"currency":"EUR"},"totalAmount":{"value":100000,"currency":"EUR"},"unpaidAmount":{"value":25000,"currency":"EUR"},"mandate":{"ibanLast4":null,"signatureDate":null,"companyName":"Acme Corp"},"countryCode":"FR","kycLink":"https://kyc.example.com/onboarding","email":"debtoremail@gmail.com","identifierType":"SIREN","identifierValue":"445330103","pspId":"aria-psp-id-123"}}]} */
export interface PaymentListPspsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** List of retailer PSP account resources, or null when the retailer has no access to payment terms */
  data?:
    | null
    | {
        /**
         * [resource object type](https://jsonapi.org/format/#document-resource-object-identification)
         * @example "retailer-psp-accounts"
         */
        type: string;
        /**
         * PSP identifier (e.g. "aks", "aria")
         * @example "aks"
         */
        id: string;
        attributes: {
          /**
           * Current state of the retailer PSP account
           * @example "ACTIVE_WITH_MANDATE"
           */
          state: PaymentListPspsStateEnum;
          availableAmount: {
            /**
             * Amount in cents
             * @example 150000
             */
            value: number;
            /**
             * ISO 4217 currency code
             * @example "EUR"
             */
            currency: string;
          };
          totalAmount: {
            /**
             * Amount in cents
             * @example 150000
             */
            value: number;
            /**
             * ISO 4217 currency code
             * @example "EUR"
             */
            currency: string;
          };
          unpaidAmount: {
            /**
             * Amount in cents
             * @example 150000
             */
            value: number;
            /**
             * ISO 4217 currency code
             * @example "EUR"
             */
            currency: string;
          };
          mandate: {
            /** Last 4 digits of the IBAN associated with the active SDD mandate (null when no active mandate) */
            ibanLast4: null | string;
            /** Date the mandate was signed (ISO 8601 date format, null when no active mandate) */
            signatureDate: null | string;
            /**
             * Company name associated with the mandate
             * @example "Acme Corp"
             */
            companyName: string;
          };
          /**
           * ISO 3166-1 alpha-2 country code of the retailer
           * @example "FR"
           */
          countryCode: string;
          /** URL to the KYC onboarding page for the PSP (null when KYC is already completed or not applicable) */
          kycLink?: null | string;
          /** Email address of the debtor (null when not available) */
          email?: null | string;
          /** Type of the business identifier (null when not available) */
          identifierType?: null | string;
          /** Value of the business identifier (null when not available) */
          identifierValue?: null | string;
          /** Identifier of the retailer account within the PSP system (null for AKS) */
          pspId?: null | string;
        };
      }[];
}

export interface PaymentConfirmBusinessIdentifierData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

export interface PaymentConfirmLegalInformationData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: null;
}

export interface PaymentViewRetailerAvailableCreditData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * RetailerAvailableCreditResource
   * Retailer available credit resource
   */
  data?: {
    /**
     * [resource object type](https://jsonapi.org/format/#document-resource-object-identification)
     * @example "retailer-available-credit"
     */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /** @example 15000 */
      amount?: number;
      /** @example "EUR" */
      currency?: string;
    };
  };
}

export interface PaymentViewRetailerAksFinancingData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * RetailerAksFinancingResource
   * Retailer AKS financing resource
   */
  data?: {
    /** @example "retailer-aks-financing" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      payment_methods?: {
        /**
         * Last 4 digits of the IBAN. null if not set up.
         * @example "1234"
         */
        iban_last4?: string | null;
        /**
         * ISO 8601 date when the mandate was signed.
         * @format date-time
         * @example "2024-01-15T10:00:00+00:00"
         */
        signed_at?: string | null;
        /**
         * Company name associated with the mandate.
         * @example "Acme Corp"
         */
        company_name?: string | null;
        /**
         * Whether the mandate is currently active. null if not set up.
         * @example true
         */
        has_active_mandate?: boolean | null;
      };
      credit_limit?: {
        available_amount?: {
          /**
           * @format float
           * @example 1000
           */
          value?: number;
          /** @example "EUR" */
          currency?: string;
        };
      } | null;
    };
  };
}

export interface PaymentCreateRetailerAksFinancingSepaSetupIntentData {
  data?: {
    /** @example "sepa-setup-intents" */
    type?: string;
    /**
     * Stripe SetupIntent ID
     * @example "seti_1234"
     */
    id?: string;
    attributes?: {
      /**
       * Stripe client secret for confirming the setup intent
       * @example "seti_1234_secret_5678"
       */
      client_secret?: string;
    };
  };
}

export interface PaymentConfirmRetailerAksFinancingSepaSetupData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * RetailerAksFinancingResource
   * Retailer AKS financing resource
   */
  data?: {
    /** @example "retailer-aks-financing" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      payment_methods?: {
        /**
         * Last 4 digits of the IBAN. null if not set up.
         * @example "1234"
         */
        iban_last4?: string | null;
        /**
         * ISO 8601 date when the mandate was signed.
         * @format date-time
         * @example "2024-01-15T10:00:00+00:00"
         */
        signed_at?: string | null;
        /**
         * Company name associated with the mandate.
         * @example "Acme Corp"
         */
        company_name?: string | null;
        /**
         * Whether the mandate is currently active. null if not set up.
         * @example true
         */
        has_active_mandate?: boolean | null;
      };
      credit_limit?: {
        available_amount?: {
          /**
           * @format float
           * @example 1000
           */
          value?: number;
          /** @example "EUR" */
          currency?: string;
        };
      } | null;
    };
  };
}

export enum CreatePurchasePaymentPspEnum {
  Stripe = 'stripe',
}

export enum CreatePurchasePaymentPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
}

export enum CreatePurchasePaymentPurchasableEntityTypeEnum {
  Checkout = 'checkout',
  Preorder = 'preorder',
}

export enum CreatePurchasePaymentPspEnum1 {
  Stripe = 'stripe',
}

/** Using `sepa_credit_transfer` will always create a new PaymentIntent in Stripe, while `sepa_direct_debit` will create a new SetupIntent in Stripe only if `withNewPaymentMethod` is set to `true`. */
export enum CreatePurchasePaymentPaymentMethodEnum1 {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
}

export interface CreatePurchasePaymentData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** PaymentResource */
  data: {
    type: 'purchase-payments';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      psp: CreatePurchasePaymentPspEnum;
      paymentMethod: CreatePurchasePaymentPaymentMethodEnum;
      pspData: {
        /** Stripe PaymentIntent ID for `sepa_credit_transfer` payment method, or Stripe SetupIntent ID for of `sepa_direct_debit` payment method. */
        pspId?: string;
        clientSecret?: string;
        /** Indicates whether there is an active mandate for the `sepa_direct_debit` payment method. */
        hasActiveMandate?: boolean;
      };
    };
  };
}

export enum ListPurchaseOperationsPaymentTermsEnum {
  Net30 = 'net-30',
  Net60 = 'net-60',
  Net90 = 'net-90',
  Reception10 = 'reception-10',
  UponAvailability = 'upon-availability',
  Installments3 = 'installments-3',
}

export enum ListPurchaseOperationsPaymentMethodTypeEnum {
  BankTransfer = 'bank_transfer',
  Bancontact = 'bancontact',
  Card = 'card',
  Ideal = 'ideal',
  Invoice = 'invoice',
  Paypal = 'paypal',
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
}

export enum ListPurchaseOperationsFundedByEnum {
  Alma = 'alma',
  AlmaAnkorstore = 'alma-ankorstore',
  Ankorstore = 'ankorstore',
  Finexkap = 'finexkap',
  Hokodo = 'hokodo',
  Aria = 'aria',
  Pledg = 'pledg',
}

export enum ListPurchaseOperationsPaymentStatusEnum {
  Failed = 'failed',
  InProgress = 'in_progress',
  Paid = 'paid',
  PastDue = 'past_due',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Delayed = 'delayed',
}

export enum ListPurchaseOperationsPaymentInnerStatusEnum {
  OnReception = 'on_reception',
  UpcomingDebit = 'upcoming_debit',
  Delayed = 'delayed',
  PaymentInProgress = 'payment_in_progress',
  PaidSuccessfully = 'paid_successfully',
  PaymentRecoveredSuccessfully = 'payment_recovered_successfully',
  PaymentUnsuccessful = 'payment_unsuccessful',
  PartialRecoveryFailed = 'partial_recovery_failed',
  PaymentRecoveredFailed = 'payment_recovered_failed',
  Cancelled = 'cancelled',
  CancelledRefunded = 'cancelled_refunded',
}

export enum ListPurchaseOperationsExternalTypeEnum {
  Checkout = 'checkout',
  Order = 'order',
}

/** Invoice type. */
export enum ListPurchaseOperationsTypeEnum {
  Invoice = 'invoice',
  CreditMemo = 'credit_memo',
  Proforma = 'proforma',
  PurchaseOrder = 'purchase_order',
}

export interface ListPurchaseOperationsParams {
  /** Include related resources in the response. */
  include?: string;
  /**
   * Sort operations by one or more fields, comma-separated (JSON:API convention).
   * Prefix a field name with `-` for descending order. Defaults to `-submittedAt`.
   * Supported fields: `submittedAt`, `dueAt`, `amount`.
   * Examples: `dueAt`, `-submittedAt`, `dueAt,-submittedAt`.
   * @pattern ^-?(submittedAt|dueAt|amount)(,-?(submittedAt|dueAt|amount))*$
   */
  sort?: string;
  /**
   * Filter operations by payment method. Each value maps to an underlying `paymentMethodType`/`fundedBy` combination.
   * Supported values:
   *
   *
   *   - `aria` — SEPA debit funded by Aria
   *   - `ankorstore` — SEPA debit funded by Ankorstore
   *   - `card` — Card payment
   *   - `paypal` — PayPal payment
   *   - `sepa_credit_transfer` — SEPA Credit Transfer payment
   */
  'filter[paymentMethod]'?: FilterPaymentMethodEnum;
  /**
   * Filter operations by brand UUID.
   * @format uuid
   */
  'filter[brand]'?: string;
  /**
   * Filter operations by payment status. Each value maps to one or more underlying AnkorPay buyer statuses.
   * `past_due` and `delayed` additionally restrict results to operations whose due date is on or before today.
   * Supported values:
   *
   *
   *   - `failed` — payment unsuccessful, partial or full recovery failed
   *   - `in_progress` — payment in progress
   *   - `paid` — paid successfully or recovered successfully
   *   - `pending` — upcoming debit
   *   - `cancelled` — cancelled or cancelled and refunded
   *   - `past_due` — upcoming debit whose due date is on or before today
   *   - `delayed` — upcoming debit whose due date is on or before today
   *   - `frozen_related` — payment unsuccessful/recovery failed, or upcoming debit whose due date is on or before today
   */
  'filter[payment_status]'?: FilterPaymentStatusEnum;
  /**
   * Filter operations with due date >= this date.
   * Format: ISO 8601 date or datetime (e.g. 2026-01-01 or 2026-01-01T00:00:00Z)
   * @format date
   */
  'filter[due_at_from]'?: string;
  /**
   * Filter operations with due date <= this date.
   * Format: ISO 8601 date or datetime (e.g. 2026-01-31 or 2026-01-31T23:59:59Z)
   * @format date
   */
  'filter[due_at_to]'?: string;
  /**
   * Filter operations by their human-readable payment reference (`PAY-YYMM-XXXXXX`), as
   * displayed on the payment. The match is exact, so at most one operation is returned.
   *
   * The value is normalised before matching: surrounding whitespace is trimmed, the input
   * is upper-cased, and the letters the Crockford Base32 alphabet leaves out are folded
   * onto the digits they are mistaken for (`I`/`L` → `1`, `O` → `0`). A value that is not
   * a well-formed reference after normalisation is rejected with a `400`.
   */
  'filter[reference]'?: string;
  /**
   * Page number to fetch (1-based). Defaults to 1. Use the `next` link in the response to advance pages.
   * @min 1
   * @default 1
   */
  'page[number]'?: number;
  /**
   * Maximum number of items to return per page. Defaults to 30.
   * @min 1
   * @default 30
   */
  'page[limit]'?: number;
}

/**
 * Filter operations by payment method. Each value maps to an underlying `paymentMethodType`/`fundedBy` combination.
 * Supported values:
 *
 *
 *   - `aria` — SEPA debit funded by Aria
 *   - `ankorstore` — SEPA debit funded by Ankorstore
 *   - `card` — Card payment
 *   - `paypal` — PayPal payment
 *   - `sepa_credit_transfer` — SEPA Credit Transfer payment
 */
export enum FilterPaymentMethodEnum {
  Aria = 'aria',
  Ankorstore = 'ankorstore',
  Card = 'card',
  Paypal = 'paypal',
  SepaCreditTransfer = 'sepa_credit_transfer',
}

/**
 * Filter operations by payment status. Each value maps to one or more underlying AnkorPay buyer statuses.
 * `past_due` and `delayed` additionally restrict results to operations whose due date is on or before today.
 * Supported values:
 *
 *
 *   - `failed` — payment unsuccessful, partial or full recovery failed
 *   - `in_progress` — payment in progress
 *   - `paid` — paid successfully or recovered successfully
 *   - `pending` — upcoming debit
 *   - `cancelled` — cancelled or cancelled and refunded
 *   - `past_due` — upcoming debit whose due date is on or before today
 *   - `delayed` — upcoming debit whose due date is on or before today
 *   - `frozen_related` — payment unsuccessful/recovery failed, or upcoming debit whose due date is on or before today
 */
export enum FilterPaymentStatusEnum {
  Failed = 'failed',
  InProgress = 'in_progress',
  Paid = 'paid',
  Pending = 'pending',
  Cancelled = 'cancelled',
  PastDue = 'past_due',
  Delayed = 'delayed',
  FrozenRelated = 'frozen_related',
}

export interface ListPurchaseOperationsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
  links?: {
    /** URL to fetch the previous page (decrements `page[number]` by 1). Null when on the first page. */
    prev?: string | null;
    /** URL to fetch the next page (increments `page[number]` by 1). Null when on the last page. */
    next?: string | null;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format date-time */
      submittedAt: string;
      paymentTerms?: ListPurchaseOperationsPaymentTermsEnum | null;
      paymentMethodType?: ListPurchaseOperationsPaymentMethodTypeEnum | null;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currency: string;
      retailerGrandTotalAmountWithVat: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      };
      /** @format date-time */
      dueAt?: string | null;
      /**
       * Human-readable payment reference minted by AnkorPay, `PAY-YYMM-XXXXXX` (fixed 15
       * characters): a constant `PAY` prefix, the 2-digit year and month of the payment,
       * and a 6-character Crockford Base32 identifier (no `I`, `L`, `O` or `U`). Unique
       * across all payments, and the handle to display for both checkout- and order-level
       * operations.
       *
       * Treat it as an opaque string: do not parse the date segment or derive anything
       * from it. Null when AnkorPay has no reference for the payment, and for operations
       * not backed by an AnkorPay payment — fall back to `label` in that case.
       * @pattern ^PAY-[0-9]{4}-[0-9A-HJKMNP-TV-Z]{6}$
       * @example "PAY-2608-EA67G5"
       */
      reference: string | null;
      /**
       * Display label for the operation (`#<checkout/order id>`). Interim fallback for
       * operations with no `reference`; prefer `reference` as the payment handle.
       */
      label: string;
      fundedBy?: ListPurchaseOperationsFundedByEnum | null;
      paymentStatus?: ListPurchaseOperationsPaymentStatusEnum | null;
      /**
       * Granular buyer-facing payment status from AnkorPay. Provides the full 11-value status
       * used in the drawer, compared to the coarser 5-value `paymentStatus`.
       * Values:
       *
       *
       *   - `on_reception` — payment due once the order is received
       *   - `upcoming_debit` — deferred payment awaiting charge (due date in the future)
       *   - `delayed` — deferred payment where due date has passed but charge not yet initiated
       *   - `payment_in_progress` — charge is being processed
       *   - `paid_successfully` — payment confirmed and settled
       *   - `payment_recovered_successfully` — failed payment recovered via recovery plan
       *   - `payment_unsuccessful` — charge failed with no recovery plan
       *   - `partial_recovery_failed` — recovery in progress, some attempts failed
       *   - `payment_recovered_failed` — all recovery attempts failed
       *   - `cancelled` — payment cancelled, no refund
       *   - `cancelled_refunded` — payment cancelled with refund issued
       */
      paymentInnerStatus?: ListPurchaseOperationsPaymentInnerStatusEnum | null;
      /** Amount refunded in cents. Only present when `paymentInnerStatus` is `cancelled_refunded`. */
      refundedAmount?: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      } | null;
      /**
       * Remaining amount still owed by the buyer in cents.
       * Only present when `paymentInnerStatus` is `partial_recovery_failed` or `payment_recovered_failed`.
       */
      remainingAmount?: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      } | null;
      /**
       * Date when the payment was successfully recovered.
       * Only present when `paymentInnerStatus` is `payment_recovered_successfully`.
       */
      recoveryDate?: string | null;
      /**
       * How the retailer can settle this payment when it is outstanding. Present on
       * both the show and list endpoints when the payment is `ankorstore`-funded, not
       * yet paid or cancelled, and carries an active `ankorstore`-source recovery
       * whose payment methods have been provisioned.
       *
       * `null` when:
       * - The payment is funded by a third party (e.g. Aria).
       * - The payment has already been paid (`paidAt` is set) or cancelled (`cancelledAt` is set).
       * - There is no active recovery, or the recovery source is not `ankorstore`.
       * - The recovery's payment methods have not yet been provisioned (provisioning
       *
       *
       *   is asynchronous: a recovery is opened before its payment link exists, so
       *   this stays `null` for approximately one to three days after recovery starts).
       */
      recoveryPaymentMethods?: {
        /** Stripe Payment Link for settling the payment by card. */
        card?: {
          /**
           * Stripe-hosted payment page, always `https` on a Stripe host. Treat as a
           * bearer capability: anyone holding the URL can pay it, so do not log it or
           * place it in a shareable surface.
           * @format uri
           * @example "https://buy.stripe.com/xxxxxxxxxxxx"
           */
          paymentLinkUrl: string;
        };
        /** SEPA credit transfer instructions. Provisioned for EUR payments only. */
        sepaCreditTransfer?: {
          /** Virtual IBAN to transfer to. */
          iban: string;
          /**
           * Transfer reference, unique per recovery. Stripe reconciles the incoming
           * transfer by this value, so it must be shown to the retailer verbatim and
           * never substituted, truncated, or reformatted.
           */
          reference: string;
        };
      } | null;
      /**
       * The UUID of the entity the AnkorPay operation was raised against. Which entity that is
       * depends on `externalType`: a checkout UUID when `externalType` is `checkout`, an order
       * UUID when it is `order`.
       * Only present for operations sourced from AnkorPay.
       */
      externalId?: string | null;
      /**
       * The kind of entity `externalId` refers to, and therefore what the operation pays for:
       *
       *
       *   - `checkout` — the operation covers the whole checkout. `orders` holds every order of
       *     that checkout, and checkout-scoped fee/discount lines appear at the operation root.
       *   - `order` — the operation covers a single order. `orders` holds exactly one entry, and
       *     the operation root carries no `billingItems` or `invoices`: the funded order owns
       *     its entire breakdown.
       *
       * Only present for operations sourced from AnkorPay. The set of types is expected to grow
       * (e.g. brand service invoices), so treat an unrecognised value as unsupported rather than
       * falling back to `checkout`.
       */
      externalType?: ListPurchaseOperationsExternalTypeEnum | null;
      /**
       * Date when the payment was cancelled. Always present; `null` until the
       * operation is cancelled.
       */
      cancelledAt: string | null;
      /**
       * Date when the payment was successfully collected (debited). Always present;
       * `null` until the operation is paid.
       */
      paidAt: string | null;
      /**
       * Net total including VAT of the operation-level fee/discount billing items (fees positive,
       * discounts negative), computed on the backend. Includes pre-2025 orders' shipping lines and
       * excludes 2025-business-model orders' shipping (exposed as dedicated order amounts). 0 when
       * there are none; null on the listing endpoint, where it is not computed.
       */
      totalBillingItemsAmountWithVat?: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      } | null;
      /**
       * Relative URL to download this operation's invoices as a zip, resolved on the backend from the
       * operation's backing entity so the client never constructs it or branches on `externalType`:
       * a checkout-backed operation points at the whole-checkout download, an order-backed one at that
       * single order's download. Null when there is no downloadable backing entity (absent/unknown
       * `externalType` or `externalId`).
       */
      invoicesDownloadUrl?: string | null;
    };
    relationships: {
      /**
       * The orders this operation pays for: every order of the checkout when `externalType` is
       * `checkout`, and exactly one entry — the funded order — when it is `order`.
       */
      orders?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /**
       * Checkout-level billing items targeted at the retailer (e.g. service fees). Only present
       * when requested via `include=billingItems`, and always empty when `externalType` is
       * `order` — an order-level operation carries its breakdown on the funded order instead.
       */
      billingItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /** Checkout-level invoices (e.g. proforma). Only present when requested via `include=invoices`. */
      invoices?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  }[];
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Order status. */
          status?: string | null;
          /** Human-readable status detail. */
          statusDetailsTitle?: string | null;
          /** Display label for the order. */
          label: string;
          /** Products total excluding VAT. Sourced from Order::retailer_total_amount. */
          totalAmount?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * VAT portion of the products total, exposed so the client can display the products
           * subtotal and VAT separately. Sourced from Order::retailer_total_amount_vat.
           */
          totalAmountVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Products total including VAT, excluding shipping
           * (products ex-VAT = totalAmountWithVat - totalAmountVat).
           * Sourced from Order::retailer_total_amount_with_vat.
           */
          totalAmountWithVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Products total including VAT plus shipping. Only present for orders created under the
           * 2025 business model, where shipping is part of the brand↔retailer order invoice; null
           * for pre-2025-business-model orders (where shipping is retailer↔Ankorstore and stays in
           * the fees & discounts section). Lets the client render the order subtotal including or
           * excluding shipping per business model without a discriminator flag.
           */
          totalAmountWithVatIncludingShipping?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Shipping fee excluding VAT. Present only for orders created under the 2025 business model,
           * where shipping belongs to the brand↔retailer order invoice and is exposed as a dedicated
           * amount rather than a fee/discount line; null for pre-2025-business-model orders, where
           * shipping is a billing-item line at the operation level instead. Sourced from the order's
           * retailer_shipping_fees billing items.
           */
          totalShippingFees?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /** VAT portion of the shipping fee. Same 2025-business-model-only rule as totalShippingFees. */
          totalShippingFeesVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Net total including VAT of this order's fee/discount billing items (fees positive, discounts
           * negative). Null when the order carries no such lines. Excludes shipping for 2025-business-model
           * orders (exposed via totalShippingFees) and any line surfaced at the operation level instead.
           */
          totalBillingItemsAmountWithVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Net amount the retailer pays for this order (order total incl. VAT plus its billing items).
           * Sourced from Order::retailer_net_amount.
           */
          netAmount?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * UUID of the master order this sub-order belongs to.
           * @format uuid
           */
          masterOrderUuid?: string | null;
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          billingItems?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          invoices?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Brand name. */
          name: string;
          images: {
            squaredPath: string | null;
            roundedPath: string | null;
            largePath: string | null;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          amount?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          amountVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          amountWithVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /** Human-readable label for the billing item. */
          label?: string | null;
          /** Human-readable VAT label for the billing item. */
          vatLabel?: string | null;
          /** Whether VAT should be displayed for this billing item. */
          displayVat?: boolean | null;
          /**
           * Identifier of the offer programme this line belongs to (e.g. `ankorstore_plus`), or null
           * when the line is not an offer benefit. Lets the client badge PLUS benefits (shipping fee
           * waived, deferred payment fee waived, …) without parsing the localized label.
           */
          offerName?: string | null;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Invoice number, used as identifier. */
        id: string;
        attributes: {
          /** Invoice type. */
          type: ListPurchaseOperationsTypeEnum;
          /** Human-readable label for the invoice. */
          title: string;
          /** Download path for the invoice PDF, null if not yet generated. */
          link: string | null;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Invoice number, used as identifier. */
        id: string;
        attributes: {
          /** Human-readable label for the invoice. */
          title: string;
          /** Download path for the invoice PDF, null if not yet generated. */
          link: string | null;
        };
      }
  )[];
}

/**
 * Filter operations by payment method. Each value maps to an underlying `paymentMethodType`/`fundedBy` combination.
 * Supported values:
 *
 *
 *   - `aria` — SEPA debit funded by Aria
 *   - `ankorstore` — SEPA debit funded by Ankorstore
 *   - `card` — Card payment
 *   - `paypal` — PayPal payment
 *   - `sepa_credit_transfer` — SEPA Credit Transfer payment
 */
export enum ListPurchaseOperationsParams1FilterPaymentMethodEnum {
  Aria = 'aria',
  Ankorstore = 'ankorstore',
  Card = 'card',
  Paypal = 'paypal',
  SepaCreditTransfer = 'sepa_credit_transfer',
}

/**
 * Filter operations by payment status. Each value maps to one or more underlying AnkorPay buyer statuses.
 * `past_due` and `delayed` additionally restrict results to operations whose due date is on or before today.
 * Supported values:
 *
 *
 *   - `failed` — payment unsuccessful, partial or full recovery failed
 *   - `in_progress` — payment in progress
 *   - `paid` — paid successfully or recovered successfully
 *   - `pending` — upcoming debit
 *   - `cancelled` — cancelled or cancelled and refunded
 *   - `past_due` — upcoming debit whose due date is on or before today
 *   - `delayed` — upcoming debit whose due date is on or before today
 *   - `frozen_related` — payment unsuccessful/recovery failed, or upcoming debit whose due date is on or before today
 */
export enum ListPurchaseOperationsParams1FilterPaymentStatusEnum {
  Failed = 'failed',
  InProgress = 'in_progress',
  Paid = 'paid',
  Pending = 'pending',
  Cancelled = 'cancelled',
  PastDue = 'past_due',
  Delayed = 'delayed',
  FrozenRelated = 'frozen_related',
}

export enum ShowPurchaseOperationPaymentTermsEnum {
  Net30 = 'net-30',
  Net60 = 'net-60',
  Net90 = 'net-90',
  Reception10 = 'reception-10',
  UponAvailability = 'upon-availability',
  Installments3 = 'installments-3',
}

export enum ShowPurchaseOperationPaymentMethodTypeEnum {
  BankTransfer = 'bank_transfer',
  Bancontact = 'bancontact',
  Card = 'card',
  Ideal = 'ideal',
  Invoice = 'invoice',
  Paypal = 'paypal',
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDebit = 'sepa_debit',
}

export enum ShowPurchaseOperationFundedByEnum {
  Alma = 'alma',
  AlmaAnkorstore = 'alma-ankorstore',
  Ankorstore = 'ankorstore',
  Finexkap = 'finexkap',
  Hokodo = 'hokodo',
  Aria = 'aria',
  Pledg = 'pledg',
}

export enum ShowPurchaseOperationPaymentStatusEnum {
  Failed = 'failed',
  InProgress = 'in_progress',
  Paid = 'paid',
  PastDue = 'past_due',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Delayed = 'delayed',
}

export enum ShowPurchaseOperationPaymentInnerStatusEnum {
  OnReception = 'on_reception',
  UpcomingDebit = 'upcoming_debit',
  Delayed = 'delayed',
  PaymentInProgress = 'payment_in_progress',
  PaidSuccessfully = 'paid_successfully',
  PaymentRecoveredSuccessfully = 'payment_recovered_successfully',
  PaymentUnsuccessful = 'payment_unsuccessful',
  PartialRecoveryFailed = 'partial_recovery_failed',
  PaymentRecoveredFailed = 'payment_recovered_failed',
  Cancelled = 'cancelled',
  CancelledRefunded = 'cancelled_refunded',
}

export enum ShowPurchaseOperationExternalTypeEnum {
  Checkout = 'checkout',
  Order = 'order',
}

/** Invoice type. */
export enum ShowPurchaseOperationTypeEnum {
  Invoice = 'invoice',
  CreditMemo = 'credit_memo',
  Proforma = 'proforma',
  PurchaseOrder = 'purchase_order',
}

export interface ShowPurchaseOperationParams {
  /** Include related resources in the response. */
  include?: string;
  /**
   * UUID of the payment operation.
   * @format uuid
   */
  paymentOperation: string;
}

export interface ShowPurchaseOperationData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta?: Record<string, any>;
  /** OperationResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format date-time */
      submittedAt: string;
      paymentTerms?: ShowPurchaseOperationPaymentTermsEnum | null;
      paymentMethodType?: ShowPurchaseOperationPaymentMethodTypeEnum | null;
      /**
       * ISO 4217 currency code.
       * @example "EUR"
       */
      currency: string;
      retailerGrandTotalAmountWithVat: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      };
      /** @format date-time */
      dueAt?: string | null;
      /**
       * Human-readable payment reference minted by AnkorPay, `PAY-YYMM-XXXXXX` (fixed 15
       * characters): a constant `PAY` prefix, the 2-digit year and month of the payment,
       * and a 6-character Crockford Base32 identifier (no `I`, `L`, `O` or `U`). Unique
       * across all payments, and the handle to display for both checkout- and order-level
       * operations.
       *
       * Treat it as an opaque string: do not parse the date segment or derive anything
       * from it. Null when AnkorPay has no reference for the payment, and for operations
       * not backed by an AnkorPay payment — fall back to `label` in that case.
       * @pattern ^PAY-[0-9]{4}-[0-9A-HJKMNP-TV-Z]{6}$
       * @example "PAY-2608-EA67G5"
       */
      reference: string | null;
      /**
       * Display label for the operation (`#<checkout/order id>`). Interim fallback for
       * operations with no `reference`; prefer `reference` as the payment handle.
       */
      label: string;
      fundedBy?: ShowPurchaseOperationFundedByEnum | null;
      paymentStatus?: ShowPurchaseOperationPaymentStatusEnum | null;
      /**
       * Granular buyer-facing payment status from AnkorPay. Provides the full 11-value status
       * used in the drawer, compared to the coarser 5-value `paymentStatus`.
       * Values:
       *
       *
       *   - `on_reception` — payment due once the order is received
       *   - `upcoming_debit` — deferred payment awaiting charge (due date in the future)
       *   - `delayed` — deferred payment where due date has passed but charge not yet initiated
       *   - `payment_in_progress` — charge is being processed
       *   - `paid_successfully` — payment confirmed and settled
       *   - `payment_recovered_successfully` — failed payment recovered via recovery plan
       *   - `payment_unsuccessful` — charge failed with no recovery plan
       *   - `partial_recovery_failed` — recovery in progress, some attempts failed
       *   - `payment_recovered_failed` — all recovery attempts failed
       *   - `cancelled` — payment cancelled, no refund
       *   - `cancelled_refunded` — payment cancelled with refund issued
       */
      paymentInnerStatus?: ShowPurchaseOperationPaymentInnerStatusEnum | null;
      /** Amount refunded in cents. Only present when `paymentInnerStatus` is `cancelled_refunded`. */
      refundedAmount?: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      } | null;
      /**
       * Remaining amount still owed by the buyer in cents.
       * Only present when `paymentInnerStatus` is `partial_recovery_failed` or `payment_recovered_failed`.
       */
      remainingAmount?: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      } | null;
      /**
       * Date when the payment was successfully recovered.
       * Only present when `paymentInnerStatus` is `payment_recovered_successfully`.
       */
      recoveryDate?: string | null;
      /**
       * How the retailer can settle this payment when it is outstanding. Present on
       * both the show and list endpoints when the payment is `ankorstore`-funded, not
       * yet paid or cancelled, and carries an active `ankorstore`-source recovery
       * whose payment methods have been provisioned.
       *
       * `null` when:
       * - The payment is funded by a third party (e.g. Aria).
       * - The payment has already been paid (`paidAt` is set) or cancelled (`cancelledAt` is set).
       * - There is no active recovery, or the recovery source is not `ankorstore`.
       * - The recovery's payment methods have not yet been provisioned (provisioning
       *
       *
       *   is asynchronous: a recovery is opened before its payment link exists, so
       *   this stays `null` for approximately one to three days after recovery starts).
       */
      recoveryPaymentMethods?: {
        /** Stripe Payment Link for settling the payment by card. */
        card?: {
          /**
           * Stripe-hosted payment page, always `https` on a Stripe host. Treat as a
           * bearer capability: anyone holding the URL can pay it, so do not log it or
           * place it in a shareable surface.
           * @format uri
           * @example "https://buy.stripe.com/xxxxxxxxxxxx"
           */
          paymentLinkUrl: string;
        };
        /** SEPA credit transfer instructions. Provisioned for EUR payments only. */
        sepaCreditTransfer?: {
          /** Virtual IBAN to transfer to. */
          iban: string;
          /**
           * Transfer reference, unique per recovery. Stripe reconciles the incoming
           * transfer by this value, so it must be shown to the retailer verbatim and
           * never substituted, truncated, or reformatted.
           */
          reference: string;
        };
      } | null;
      /**
       * The UUID of the entity the AnkorPay operation was raised against. Which entity that is
       * depends on `externalType`: a checkout UUID when `externalType` is `checkout`, an order
       * UUID when it is `order`.
       * Only present for operations sourced from AnkorPay.
       */
      externalId?: string | null;
      /**
       * The kind of entity `externalId` refers to, and therefore what the operation pays for:
       *
       *
       *   - `checkout` — the operation covers the whole checkout. `orders` holds every order of
       *     that checkout, and checkout-scoped fee/discount lines appear at the operation root.
       *   - `order` — the operation covers a single order. `orders` holds exactly one entry, and
       *     the operation root carries no `billingItems` or `invoices`: the funded order owns
       *     its entire breakdown.
       *
       * Only present for operations sourced from AnkorPay. The set of types is expected to grow
       * (e.g. brand service invoices), so treat an unrecognised value as unsupported rather than
       * falling back to `checkout`.
       */
      externalType?: ShowPurchaseOperationExternalTypeEnum | null;
      /**
       * Date when the payment was cancelled. Always present; `null` until the
       * operation is cancelled.
       */
      cancelledAt: string | null;
      /**
       * Date when the payment was successfully collected (debited). Always present;
       * `null` until the operation is paid.
       */
      paidAt: string | null;
      /**
       * Net total including VAT of the operation-level fee/discount billing items (fees positive,
       * discounts negative), computed on the backend. Includes pre-2025 orders' shipping lines and
       * excludes 2025-business-model orders' shipping (exposed as dedicated order amounts). 0 when
       * there are none; null on the listing endpoint, where it is not computed.
       */
      totalBillingItemsAmountWithVat?: {
        /** Amount in cents. */
        amount: number;
        /**
         * ISO 4217 currency code.
         * @example "EUR"
         */
        currencyCode: string;
      } | null;
      /**
       * Relative URL to download this operation's invoices as a zip, resolved on the backend from the
       * operation's backing entity so the client never constructs it or branches on `externalType`:
       * a checkout-backed operation points at the whole-checkout download, an order-backed one at that
       * single order's download. Null when there is no downloadable backing entity (absent/unknown
       * `externalType` or `externalId`).
       */
      invoicesDownloadUrl?: string | null;
    };
    relationships: {
      /**
       * The orders this operation pays for: every order of the checkout when `externalType` is
       * `checkout`, and exactly one entry — the funded order — when it is `order`.
       */
      orders?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /**
       * Checkout-level billing items targeted at the retailer (e.g. service fees). Only present
       * when requested via `include=billingItems`, and always empty when `externalType` is
       * `order` — an order-level operation carries its breakdown on the funded order instead.
       */
      billingItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /** Checkout-level invoices (e.g. proforma). Only present when requested via `include=invoices`. */
      invoices?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  included?: (
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Order status. */
          status?: string | null;
          /** Human-readable status detail. */
          statusDetailsTitle?: string | null;
          /** Display label for the order. */
          label: string;
          /** Products total excluding VAT. Sourced from Order::retailer_total_amount. */
          totalAmount?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * VAT portion of the products total, exposed so the client can display the products
           * subtotal and VAT separately. Sourced from Order::retailer_total_amount_vat.
           */
          totalAmountVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Products total including VAT, excluding shipping
           * (products ex-VAT = totalAmountWithVat - totalAmountVat).
           * Sourced from Order::retailer_total_amount_with_vat.
           */
          totalAmountWithVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Products total including VAT plus shipping. Only present for orders created under the
           * 2025 business model, where shipping is part of the brand↔retailer order invoice; null
           * for pre-2025-business-model orders (where shipping is retailer↔Ankorstore and stays in
           * the fees & discounts section). Lets the client render the order subtotal including or
           * excluding shipping per business model without a discriminator flag.
           */
          totalAmountWithVatIncludingShipping?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Shipping fee excluding VAT. Present only for orders created under the 2025 business model,
           * where shipping belongs to the brand↔retailer order invoice and is exposed as a dedicated
           * amount rather than a fee/discount line; null for pre-2025-business-model orders, where
           * shipping is a billing-item line at the operation level instead. Sourced from the order's
           * retailer_shipping_fees billing items.
           */
          totalShippingFees?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /** VAT portion of the shipping fee. Same 2025-business-model-only rule as totalShippingFees. */
          totalShippingFeesVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Net total including VAT of this order's fee/discount billing items (fees positive, discounts
           * negative). Null when the order carries no such lines. Excludes shipping for 2025-business-model
           * orders (exposed via totalShippingFees) and any line surfaced at the operation level instead.
           */
          totalBillingItemsAmountWithVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * Net amount the retailer pays for this order (order total incl. VAT plus its billing items).
           * Sourced from Order::retailer_net_amount.
           */
          netAmount?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /**
           * UUID of the master order this sub-order belongs to.
           * @format uuid
           */
          masterOrderUuid?: string | null;
        };
        relationships?: {
          brand?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          billingItems?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          invoices?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** Brand name. */
          name: string;
          images: {
            squaredPath: string | null;
            roundedPath: string | null;
            largePath: string | null;
          };
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          amount?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          amountVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          amountWithVat?: {
            /** Amount in cents. */
            amount: number;
            /**
             * ISO 4217 currency code.
             * @example "EUR"
             */
            currencyCode: string;
          } | null;
          /** Human-readable label for the billing item. */
          label?: string | null;
          /** Human-readable VAT label for the billing item. */
          vatLabel?: string | null;
          /** Whether VAT should be displayed for this billing item. */
          displayVat?: boolean | null;
          /**
           * Identifier of the offer programme this line belongs to (e.g. `ankorstore_plus`), or null
           * when the line is not an offer benefit. Lets the client badge PLUS benefits (shipping fee
           * waived, deferred payment fee waived, …) without parsing the localized label.
           */
          offerName?: string | null;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Invoice number, used as identifier. */
        id: string;
        attributes: {
          /** Invoice type. */
          type: ShowPurchaseOperationTypeEnum;
          /** Human-readable label for the invoice. */
          title: string;
          /** Download path for the invoice PDF, null if not yet generated. */
          link: string | null;
        };
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /** Invoice number, used as identifier. */
        id: string;
        attributes: {
          /** Human-readable label for the invoice. */
          title: string;
          /** Download path for the invoice PDF, null if not yet generated. */
          link: string | null;
        };
      }
  )[];
}

export enum InvoicingListServiceInvoicesStatusEnum {
  ProForma = 'pro_forma',
  Paid = 'paid',
  PaymentFailed = 'payment failed',
  PaymentPending = 'payment pending',
  PaymentProcessing = 'payment_processing',
  Disputed = 'disputed',
}

/** Service type of the invoice */
export enum InvoicingListServiceInvoicesServiceTypeEnum {
  Fulfillment = 'fulfillment',
  Ads = 'ads',
  Orderpay = 'orderpay',
}

export interface InvoicingListServiceInvoicesParams {
  limit?: number;
  offset?: number;
  /**
   * Request specific statuses only
   * @minItems 1
   */
  'filter[status]'?: FilterStatusEnum[];
  /**
   * Filter invoices with invoiced_at >= this date.
   * Format: ISO 8601 date or datetime (e.g. 2026-01-01 or 2026-01-01T00:00:00Z)
   * @format date
   */
  'filter[from]'?: string;
  /**
   * Filter invoices with invoiced_at <= this date.
   * Format: ISO 8601 date or datetime (e.g. 2026-01-31 or 2026-01-31T23:59:59Z)
   * @format date
   */
  'filter[to]'?: string;
}

export enum FilterStatusEnum {
  ProForma = 'pro_forma',
  Paid = 'paid',
  PaymentFailed = 'payment failed',
  PaymentPending = 'payment pending',
  PaymentProcessing = 'payment_processing',
  Disputed = 'disputed',
}

export interface InvoicingListServiceInvoicesData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * The invoice number
       * @pattern ^AKS-\d{6}-\d{9}$
       */
      invoiceNumber?: string | null;
      /** Total amount for the item, excluding VAT (in EUR & in minor units) */
      totalAmount?: number;
      /** Total amount of VAT for the item (in EUR & in minor units) */
      totalVat?: number;
      /** Total amount for the item, including VAT (in EUR & in minor units) */
      totalAmountWithVat?: number;
      /**
       * The date that invoiced this service invoice
       * @format datetime
       */
      invoicedAt?: string;
      status?: InvoicingListServiceInvoicesStatusEnum;
      /**
       * The period for which the invoice is issued
       * @pattern ^(\d{2}-)?(\d{2}-)?\d{4}$
       */
      invoicePeriod?: string;
      /** Service type of the invoice */
      serviceType?: InvoicingListServiceInvoicesServiceTypeEnum;
      /**
       * PDF contents, base64 encoded
       * @format byte
       */
      content?: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta: {
    /** Offset-based pagination details. */
    page?: {
      /** The number of the current page. */
      currentPage?: number;
      /** The number of the last page. */
      lastPage?: number;
      /** The number of resources on a page. */
      perPage?: number;
      /** The total number of resources. */
      total?: number;
      /** The ordinal number of the first resource on the current page. */
      from?: number;
      /** The ordinal number of the last resource on the current page. */
      to?: number;
    };
    /** Filter metadata including counts per status */
    filters?: {
      /** Count of invoices per status (only statuses with count > 0 are included). Keys are snake_case versions of status values. */
      statuses?: {
        /** @min 1 */
        paid?: number;
        /** @min 1 */
        payment_pending?: number;
        /** @min 1 */
        payment_failed?: number;
        /** @min 1 */
        payment_processing?: number;
        /** @min 1 */
        pro_forma?: number;
        /** @min 1 */
        disputed?: number;
        [key: string]: any;
      };
      [key: string]: any;
    };
    [key: string]: any;
  };
}

export enum InvoicingListServiceInvoicesParams1FilterStatusEnum {
  ProForma = 'pro_forma',
  Paid = 'paid',
  PaymentFailed = 'payment failed',
  PaymentPending = 'payment pending',
  PaymentProcessing = 'payment_processing',
  Disputed = 'disputed',
}

export interface ListInvoiceExportsData {
  /**
   * InvoiceExportResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"invoice-export","attributes":{"invoiced_at_from":"2023-01-01T00:00:00.000000Z","invoiced_at_to":"2023-12-31T23:59:59.000000Z","finished_at":"2024-01-05T10:37:27.000000Z","expires_at":"2024-01-06T10:37:27.000000Z","download_links":["https://ankorlocal.com/api/internal/v1/invoice-exports/1eeabb66-b239-6f70-b2d5-0242ac12000b/zip-file/25387/download"]}}
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Datetime from which invoices are taken
       * @format datetime
       */
      invoiced_at_from: string;
      /**
       * Datetime to which invoices are taken
       * @format datetime
       */
      invoiced_at_to: string;
      /**
       * Datetime when export is finished
       * @format datetime
       */
      finished_at: string;
      /**
       * Datetime when export expires
       * @format datetime
       */
      expires_at: string;
      /** Download urls of parts of invoice export */
      download_links: string[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface TriggerInvoiceExportData {
  /**
   * InvoiceExportResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"invoice-export","attributes":{"invoiced_at_from":"2023-01-01T00:00:00.000000Z","invoiced_at_to":"2023-12-31T23:59:59.000000Z","finished_at":"2024-01-05T10:37:27.000000Z","expires_at":"2024-01-06T10:37:27.000000Z","download_links":["https://ankorlocal.com/api/internal/v1/invoice-exports/1eeabb66-b239-6f70-b2d5-0242ac12000b/zip-file/25387/download"]}}
   */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Datetime from which invoices are taken
       * @format datetime
       */
      invoiced_at_from: string;
      /**
       * Datetime to which invoices are taken
       * @format datetime
       */
      invoiced_at_to: string;
      /**
       * Datetime when export is finished
       * @format datetime
       */
      finished_at: string;
      /**
       * Datetime when export expires
       * @format datetime
       */
      expires_at: string;
      /** Download urls of parts of invoice export */
      download_links: string[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface DownloadInvoiceExportZipFileData {
  data: {
    /** @format binary */
    file?: File;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface DownloadInvoiceByCheckoutUuidData {
  data: {
    /** @format binary */
    file?: File;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface DownloadInvoiceByOrderUuidData {
  data: {
    /** @format binary */
    file?: File;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Ankstore customer type e.g. Brand, Retailer etc. */
export enum CreateInvoicingPaymentServiceProviderCustomerAksCustomerTypeEnum {
  Brand = 'brand',
  Retailer = 'retailer',
}

export enum CreateInvoicingPaymentServiceProviderCustomerMandateTypeEnum {
  MultiUse = 'multi_use',
  SingleUse = 'single_use',
  Card = 'card',
}

export enum CreateInvoicingPaymentServiceProviderCustomerMandateStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
}

export interface CreateInvoicingPaymentServiceProviderCustomerData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Ankstore customer ID e.g. brand_id, retailer_id etc. */
      aksCustomerId: number;
      /** Ankstore customer type e.g. Brand, Retailer etc. */
      aksCustomerType: CreateInvoicingPaymentServiceProviderCustomerAksCustomerTypeEnum;
      /** Customer ID from payment service provider */
      customerId: string;
      /** Intent Setup ID for future payments from payment service provider */
      setupIntentId?: string | null;
      paymentServiceProvider: string;
      email?: string;
      description?: string;
      name?: string;
      mandateType: CreateInvoicingPaymentServiceProviderCustomerMandateTypeEnum;
      mandateStatus?: CreateInvoicingPaymentServiceProviderCustomerMandateStatusEnum;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Ankstore customer type e.g. Brand, Retailer etc. */
export enum InvoicingPaymentServiceProviderCustomerAksCustomerTypeEnum {
  Brand = 'brand',
  Retailer = 'retailer',
}

export enum InvoicingPaymentServiceProviderCustomerMandateTypeEnum {
  MultiUse = 'multi_use',
  SingleUse = 'single_use',
  Card = 'card',
}

export enum InvoicingPaymentServiceProviderCustomerMandateStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
}

export interface InvoicingPaymentServiceProviderCustomerData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Ankstore customer ID e.g. brand_id, retailer_id etc. */
      aksCustomerId: number;
      /** Ankstore customer type e.g. Brand, Retailer etc. */
      aksCustomerType: InvoicingPaymentServiceProviderCustomerAksCustomerTypeEnum;
      /** Customer ID from payment service provider */
      customerId: string;
      /** Intent Setup ID for future payments from payment service provider */
      setupIntentId?: string | null;
      paymentServiceProvider: string;
      email?: string;
      description?: string;
      name?: string;
      mandateType: InvoicingPaymentServiceProviderCustomerMandateTypeEnum;
      mandateStatus?: InvoicingPaymentServiceProviderCustomerMandateStatusEnum;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Ankstore customer type e.g. Brand, Retailer etc. */
export enum UpdateInvoicingPaymentServiceProviderCustomerAksCustomerTypeEnum {
  Brand = 'brand',
  Retailer = 'retailer',
}

export enum UpdateInvoicingPaymentServiceProviderCustomerMandateTypeEnum {
  MultiUse = 'multi_use',
  SingleUse = 'single_use',
  Card = 'card',
}

export enum UpdateInvoicingPaymentServiceProviderCustomerMandateStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
}

export interface UpdateInvoicingPaymentServiceProviderCustomerData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Ankstore customer ID e.g. brand_id, retailer_id etc. */
      aksCustomerId: number;
      /** Ankstore customer type e.g. Brand, Retailer etc. */
      aksCustomerType: UpdateInvoicingPaymentServiceProviderCustomerAksCustomerTypeEnum;
      /** Customer ID from payment service provider */
      customerId: string;
      /** Intent Setup ID for future payments from payment service provider */
      setupIntentId?: string | null;
      paymentServiceProvider: string;
      email?: string;
      description?: string;
      name?: string;
      mandateType: UpdateInvoicingPaymentServiceProviderCustomerMandateTypeEnum;
      mandateStatus?: UpdateInvoicingPaymentServiceProviderCustomerMandateStatusEnum;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface PaymentServiceProviderSetupIntentData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /** @pattern [A-Z_0-9a-z]+ */
    id: string;
    attributes: {
      /** Setup Intent client secret */
      clientSecret?: string;
      /** Last 4 characters of Setup Intent Sepa Debit iban */
      ibanLast4?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface CreateInvoicingPaymentServiceSetupIntentData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /** @pattern [A-Z_0-9a-z]+ */
    id: string;
    attributes: {
      /** Setup Intent client secret */
      clientSecret?: string;
      /** Last 4 characters of Setup Intent Sepa Debit iban */
      ibanLast4?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface PaymentServiceProviderCardSetupIntentData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /** @pattern [A-Z_0-9a-z]+ */
    id: string;
    attributes: {
      /** Card Setup Intent client secret */
      clientSecret: string;
      /** Card details associated with the Setup Intent */
      cardDetails: {
        /** Card brand e.g. Visa, MasterCard etc. */
        brand?: string;
        /** Last 4 digits of the card number */
        last4?: string;
        /** Card expiry month */
        expMonth?: string;
        /** Card expiry year */
        expYear?: string;
      } | null;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface CreateInvoicingPaymentServiceCardSetupIntentData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /** @pattern [A-Z_0-9a-z]+ */
    id: string;
    attributes: {
      /** Card Setup Intent client secret */
      clientSecret: string;
      /** Card details associated with the Setup Intent */
      cardDetails: {
        /** Card brand e.g. Visa, MasterCard etc. */
        brand?: string;
        /** Last 4 digits of the card number */
        last4?: string;
        /** Card expiry month */
        expMonth?: string;
        /** Card expiry year */
        expYear?: string;
      } | null;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetRetailerBrandsParams {
  /**
   * Required. Return only brands whose name starts with the given value (prefix match).
   * @minLength 1
   */
  'filter[name]': string;
  /**
   * Maximum number of results to return. Defaults to 20, max 100.
   * @min 1
   * @max 100
   * @default 20
   */
  'page[limit]'?: number;
}

export interface GetRetailerBrandsData {
  data: {
    type: 'retailer-brands';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Brand name */
      name: string;
      /** Set of brand image links, in different formats */
      images: {
        /** @format uri */
        rounded?: string | null;
        /** @format uri */
        squared?: string | null;
        /** @format uri */
        large?: string | null;
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetApiInternalV1CandidateBrandsIdData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      email?: string;
      firstName?: string;
    };
  };
}

export interface RutterIntegrationSendTestOrderData {
  /**
   * URL of the created test order
   * @format uri
   * @example "https://my-store.com/admin/orders/12345"
   */
  orderUrl: string;
}

export interface PostApiInternalV1CatalogIntegrationProductSpreadsheetMappingData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
      configuration?: {
        identifier?: string;
        field?: string | number | null;
        missingValue?: string | null;
        emptyValue?: string | null;
        behavior?: string | null;
      }[];
    };
  };
}

export interface GetApiInternalV1CatalogIntegrationProductSpreadsheetMappingsListData {
  data: {
    /** An object describing the server's implementation */
    jsonapi?: {
      /** @example "1.0" */
      version?: string;
      /** Non-standard meta-information that can not be represented as an attribute or relationship. */
      meta?: Record<string, any>;
    };
    links?: {
      self?: string;
    };
    data?: {
      type?: string;
      id?: string;
      attributes?: {
        uuid?: string;
        name?: number;
        user_id?: number;
        is_custom?: boolean;
        configuration?: {
          identifier?: string;
          field?: string | number | null;
          missingValue?: string | null;
          emptyValue?: string | null;
          behavior?: string | null;
        }[];
      };
      links?: {
        self?: string;
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetCatalogIntegrationProductSpreadsheetMappingData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    self?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      uuid?: string;
      name?: number;
      user_id?: number;
      is_custom?: boolean;
      configuration?: {
        identifier?: string;
        field?: string | number | null;
        missingValue?: string | null;
        emptyValue?: string | null;
        behavior?: string | null;
      }[];
    };
    links?: {
      self?: string;
    };
  };
}

export interface GetMappingsForHeadersData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    self?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      uuid?: string;
      name?: number;
      user_id?: number;
      is_custom?: boolean;
      configuration?: {
        identifier?: string;
        field?: string | number | null;
        missingValue?: string | null;
        emptyValue?: string | null;
        behavior?: string | null;
      }[];
    };
    links?: {
      self?: string;
    };
  };
}

export enum PostApiInternalV1CatalogIntegrationCsvBatchesWorkflowEnum {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
}

export enum PostApiInternalV1CatalogIntegrationCsvBatchesWorkflowEnum1 {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
}

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"product-integration-batches","id":"27","attributes":{"payload":{"spreadsheet_upload_file_id":"file-upload:some-hash.csv"},"workflow":"import"}}} */
export interface PostApiInternalV1CatalogIntegrationCsvBatchesData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      payload?: {
        spreadsheet_upload_file_id?: string;
      };
      workflow?: PostApiInternalV1CatalogIntegrationCsvBatchesWorkflowEnum;
    };
  };
}

export enum PostApiInternalV1CatalogIntegrationXlsxBatchesWorkflowEnum {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
}

export enum PostApiInternalV1CatalogIntegrationXlsxBatchesWorkflowEnum1 {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
}

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"product-integration-batches","id":"27","attributes":{"payload":{"spreadsheet_upload_file_id":"file-upload:some-hash.csv"},"workflow":"import"}}} */
export interface PostApiInternalV1CatalogIntegrationXlsxBatchesData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      payload?: {
        spreadsheet_upload_file_id?: string;
      };
      workflow?: PostApiInternalV1CatalogIntegrationXlsxBatchesWorkflowEnum;
    };
  };
}

/**
 * Whether a retailer can order a product
 * variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer
 *   cannot order a quantity larger than
 *   the currently available stock
 *   quantity, so the variant cannot be
 *   ordered when it is out of stock, or
 *   when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can
 *   order any quantity, even when stock
 *   is insufficient (desired quantity >
 *   available quantity > 0) or the
 *   variant is out of stock (available
 *   quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetCatalogIntegrationIntegrationsIntegrationsInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface GetCatalogIntegrationIntegrationsIntegrationsParams {
  /**
   * Results page number.
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Number of items returned per page.
   * @min 1
   * @max 50
   * @default 50
   */
  perPage?: number;
  /**
   * Property to sort results by.
   * @default "id"
   */
  sort?: SortEnum2;
  /** Keep only results with issues (true) or without issues (false). */
  'filter[hasIssues]'?: boolean;
}

/**
 * Property to sort results by.
 * @default "id"
 */
export enum SortEnum2 {
  Id = 'id',
  Status = 'status',
  Type = 'type',
  PlatformProductId = 'platform_product_id',
  ExternalProductId = 'external_product_id',
  InternalProductId = 'internal_product_id',
  ProductUpdatedAt = 'product_updated_at',
  IntegratedAt = 'integrated_at',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at',
}

export interface GetCatalogIntegrationIntegrationsIntegrationsData {
  data: {
    /** An object describing the server's implementation */
    jsonapi?: {
      /** @example "1.0" */
      version?: string;
      /** Non-standard meta-information that can not be represented as an attribute or relationship. */
      meta?: Record<string, any>;
    };
    links?: {
      self?: string;
    };
    data?: {
      type?: string;
      id?: string;
      attributes?: {
        id?: number;
        brand_id?: number;
        type?: string;
        platform?: null;
        status?: string;
        platform_product_id?: string;
        external_product_id?: string;
        internal_product_id?: null;
        internal_state?: {
          images?: object[];
          name?: string;
          description?: string;
          unit_multiplier?: number;
          currency?: string;
          discount_rate?: number;
          retail_price?: {
            amount?: number;
            currency?: string;
          };
          wholesale_price?: {
            amount?: number;
            currency?: string;
          };
          original_wholesale_price?: {
            amount?: number;
            currency?: string;
          };
          vat_rate?: number;
          categories?: {
            id?: number;
            name?: string;
            parent_id?: number;
          }[];
          properties?: object[];
          tags?: {
            name?: string;
          }[];
          made_in?: null;
          hs_code?: null;
          variants?: {
            id?: null;
            sku?: string;
            ian?: string;
            price?: {
              currency?: string;
              retail_price?: {
                amount?: number;
                currency?: string;
              };
              wholesale_price?: {
                amount?: number;
                currency?: string;
              };
              original_wholesale_price?: {
                amount?: number;
                currency?: string;
              };
              discount_rate?: number;
            };
            stock?: {
              id?: null;
              stock_quantity?: number;
              /**
               * Whether stock is tracked at all for
               * this product variant.
               *
               * - `true`: stock is not tracked — a
               *   retailer can order as much of this
               *   variant as they want, with no
               *   restriction at all.
               * - `false`: stock is tracked — whether
               *   a retailer can order the variant
               *   depends on the available stock
               *   quantity and the `inventory_policy`.
               */
              is_always_in_stock?: boolean;
              /**
               * Whether a retailer can order a product
               * variant for which stock is not
               * available.
               *
               * - `deny` (default): no. A retailer
               *   cannot order a quantity larger than
               *   the currently available stock
               *   quantity, so the variant cannot be
               *   ordered when it is out of stock, or
               *   when the desired quantity exceeds
               *   the available quantity.
               * - `continue`: yes. The retailer can
               *   order any quantity, even when stock
               *   is insufficient (desired quantity >
               *   available quantity > 0) or the
               *   variant is out of stock (available
               *   quantity <= 0).
               *
               * Only meaningful when stock is tracked
               * (`is_always_in_stock = false`).
               * @default "deny"
               */
              inventory_policy?: GetCatalogIntegrationIntegrationsIntegrationsInventoryPolicyEnum;
              reserved_quantity?: number;
              available_quantity?: number;
            };
            shape_properties?: {
              id?: number | null;
              /** @format float */
              weight?: number;
              weight_unit?: string;
              /** @format float */
              length?: number;
              /** @format float */
              width?: number;
              /** @format float */
              height?: number;
              length_unit?: string;
              /** @format float */
              capacity?: number;
              capacity_unit?: string;
            }[];
            options?: {
              id?: number;
              name?: string;
              value?: string;
            }[];
            name?: null;
            created_at?: null;
            images?: {
              filename?: string;
              order?: number;
            }[];
          }[];
        };
        issues?: object[];
        internal_state_updated_at?: string;
        integrated_at?: null;
        created_at?: string;
        updated_at?: string;
      };
      links?: {
        self?: string;
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * Property to sort results by.
 * @default "id"
 */
export enum GetCatalogIntegrationIntegrationsIntegrationsParams1SortEnum {
  Id = 'id',
  Status = 'status',
  Type = 'type',
  PlatformProductId = 'platform_product_id',
  ExternalProductId = 'external_product_id',
  InternalProductId = 'internal_product_id',
  ProductUpdatedAt = 'product_updated_at',
  IntegratedAt = 'integrated_at',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at',
}

/**
 * Whether a retailer can order a product
 * variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer
 *   cannot order a quantity larger than
 *   the currently available stock
 *   quantity, so the variant cannot be
 *   ordered when it is out of stock, or
 *   when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can
 *   order any quantity, even when stock
 *   is insufficient (desired quantity >
 *   available quantity > 0) or the
 *   variant is out of stock (available
 *   quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetCatalogIntegrationIntegrationsIntegrationsIdInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** @example {"jsonapi":{"version":"1.0"},"links":{"self":"http://www.ankorlocal.com:8000/api/internal/v1/integrations/1ed3fd06-050a-6a00-8009-0242ac120003"},"data":{"type":"integrations","id":"1ed3fd06-050a-6a00-8009-0242ac120003","attributes":{"id":9,"brand_id":22408,"type":"rutter","platform":null,"status":"integrated","platform_product_id":"7636912570603","external_product_id":"198d8bbc-cdb7-469c-a4f8-472e0d1841ca","internal_product_id":null,"internal_state":{"images":[],"name":"Juicy Orange","description":"Such a wonderful orange, you should buy it 1","unit_multiplier":2,"currency":"EUR","discount_rate":0,"retail_price":{"amount":20,"currency":"EUR"},"wholesale_price":{"amount":10,"currency":"EUR"},"original_wholesale_price":{"amount":10,"currency":"EUR"},"vat_rate":21,"categories":[{"id":1269,"name":"Gourmet","parent_id":1262}],"properties":[],"tags":[{"name":"tags_fresh_product"}],"made_in":null,"hs_code":null,"variants":[{"id":null,"sku":"orng-1","ian":"1234567891234","price":{"currency":"EUR","retail_price":{"amount":20,"currency":"EUR"},"wholesale_price":{"amount":10,"currency":"EUR"},"original_wholesale_price":{"amount":10,"currency":"EUR"},"discount_rate":0},"stock":{"id":null,"stock_quantity":16,"is_always_in_stock":false,"reserved_quantity":0,"available_quantity":16},"shape_properties":[{"id":null,"weight":0.1,"weight_unit":"kg","length":0.1,"width":0.1,"height":0.1,"length_unit":"cm","capacity":0.1,"capacity_unit":"l"}],"options":[{"id":3,"name":"other","value":"Default Title"}],"name":null,"created_at":null,"images":[{"filename":"https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081","order":1}]}]},"issues":[],"internal_state_updated_at":"2022-09-30T14:27:32.793045Z","integrated_at":null,"created_at":"2022-08-05T13:32:31.713000Z","updated_at":"2022-09-30T14:27:32.811189Z"},"links":{"self":"http://www.ankorlocal.com:8000/api/internal/v1/integrations/1ed3fd06-050a-6a00-8009-0242ac120003"}}} */
export interface GetCatalogIntegrationIntegrationsIntegrationsIdData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    self?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      id?: number;
      brand_id?: number;
      type?: string;
      platform?: null;
      status?: string;
      platform_product_id?: string;
      external_product_id?: string;
      internal_product_id?: null;
      internal_state?: {
        images?: object[];
        name?: string;
        description?: string;
        unit_multiplier?: number;
        currency?: string;
        discount_rate?: number;
        retail_price?: {
          amount?: number;
          currency?: string;
        };
        wholesale_price?: {
          amount?: number;
          currency?: string;
        };
        original_wholesale_price?: {
          amount?: number;
          currency?: string;
        };
        vat_rate?: number;
        categories?: {
          id?: number;
          name?: string;
          parent_id?: number;
        }[];
        properties?: object[];
        tags?: {
          name?: string;
        }[];
        made_in?: null;
        hs_code?: null;
        variants?: {
          id?: null;
          sku?: string;
          ian?: string;
          price?: {
            currency?: string;
            retail_price?: {
              amount?: number;
              currency?: string;
            };
            wholesale_price?: {
              amount?: number;
              currency?: string;
            };
            original_wholesale_price?: {
              amount?: number;
              currency?: string;
            };
            discount_rate?: number;
          };
          stock?: {
            id?: null;
            stock_quantity?: number;
            /**
             * Whether stock is tracked at all for
             * this product variant.
             *
             * - `true`: stock is not tracked — a
             *   retailer can order as much of this
             *   variant as they want, with no
             *   restriction at all.
             * - `false`: stock is tracked — whether
             *   a retailer can order the variant
             *   depends on the available stock
             *   quantity and the `inventory_policy`.
             */
            is_always_in_stock?: boolean;
            /**
             * Whether a retailer can order a product
             * variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer
             *   cannot order a quantity larger than
             *   the currently available stock
             *   quantity, so the variant cannot be
             *   ordered when it is out of stock, or
             *   when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can
             *   order any quantity, even when stock
             *   is insufficient (desired quantity >
             *   available quantity > 0) or the
             *   variant is out of stock (available
             *   quantity <= 0).
             *
             * Only meaningful when stock is tracked
             * (`is_always_in_stock = false`).
             * @default "deny"
             */
            inventory_policy?: GetCatalogIntegrationIntegrationsIntegrationsIdInventoryPolicyEnum;
            reserved_quantity?: number;
            available_quantity?: number;
          };
          shape_properties?: {
            id?: number | null;
            /** @format float */
            weight?: number;
            weight_unit?: string;
            /** @format float */
            length?: number;
            /** @format float */
            width?: number;
            /** @format float */
            height?: number;
            length_unit?: string;
            /** @format float */
            capacity?: number;
            capacity_unit?: string;
          }[];
          options?: {
            id?: number;
            name?: string;
            value?: string;
          }[];
          name?: null;
          created_at?: null;
          images?: {
            filename?: string;
            order?: number;
          }[];
        }[];
      };
      issues?: object[];
      internal_state_updated_at?: string;
      integrated_at?: null;
      created_at?: string;
      updated_at?: string;
    };
    links?: {
      self?: string;
    };
  };
}

/**
 * Whether a retailer can order a product
 * variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer
 *   cannot order a quantity larger than
 *   the currently available stock
 *   quantity, so the variant cannot be
 *   ordered when it is out of stock, or
 *   when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can
 *   order any quantity, even when stock
 *   is insufficient (desired quantity >
 *   available quantity > 0) or the
 *   variant is out of stock (available
 *   quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum PatchCatalogIntegrationIntegrationsIntegrationIdInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product
 * variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer
 *   cannot order a quantity larger than
 *   the currently available stock
 *   quantity, so the variant cannot be
 *   ordered when it is out of stock, or
 *   when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can
 *   order any quantity, even when stock
 *   is insufficient (desired quantity >
 *   available quantity > 0) or the
 *   variant is out of stock (available
 *   quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum PatchCatalogIntegrationIntegrationsIntegrationIdInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

/** @example {"jsonapi":{"version":"1.0"},"links":{"self":"http://www.ankorlocal.com:8000/api/internal/v1/integrations/1ed3fd06-050a-6a00-8009-0242ac120003"},"data":{"type":"integrations","id":"1ed3fd06-050a-6a00-8009-0242ac120003","attributes":{"id":9,"brand_id":22408,"type":"rutter","platform":null,"status":"integrated","platform_product_id":"7636912570603","external_product_id":"198d8bbc-cdb7-469c-a4f8-472e0d1841ca","internal_product_id":null,"internal_state":{"images":[],"name":"Juicy Orange","description":"Such a wonderful orange, you should buy it 1","unit_multiplier":2,"currency":"EUR","discount_rate":0,"retail_price":{"amount":20,"currency":"EUR"},"wholesale_price":{"amount":10,"currency":"EUR"},"original_wholesale_price":{"amount":10,"currency":"EUR"},"vat_rate":21,"categories":[{"id":1269,"name":"Gourmet","parent_id":1262}],"properties":[],"tags":[{"name":"tags_fresh_product"}],"made_in":null,"hs_code":null,"variants":[{"id":null,"sku":"orng-1","ian":"1234567891234","price":{"currency":"EUR","retail_price":{"amount":20,"currency":"EUR"},"wholesale_price":{"amount":10,"currency":"EUR"},"original_wholesale_price":{"amount":10,"currency":"EUR"},"discount_rate":0},"stock":{"id":null,"stock_quantity":16,"is_always_in_stock":false,"reserved_quantity":0,"available_quantity":16},"shape_properties":[{"id":null,"weight":0.1,"weight_unit":"kg","length":0.1,"width":0.1,"height":0.1,"length_unit":"cm","capacity":0.1,"capacity_unit":"l"}],"options":[{"id":3,"name":"other","value":"Default Title"}],"name":null,"created_at":null,"images":[{"filename":"https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081","order":1}]}]},"issues":[],"internal_state_updated_at":"2022-09-30T14:27:32.793045Z","integrated_at":null,"created_at":"2022-08-05T13:32:31.713000Z","updated_at":"2022-09-30T14:27:32.811189Z"},"links":{"self":"http://www.ankorlocal.com:8000/api/internal/v1/integrations/1ed3fd06-050a-6a00-8009-0242ac120003"}}} */
export interface PatchCatalogIntegrationIntegrationsIntegrationIdData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    self?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      id?: number;
      brand_id?: number;
      type?: string;
      platform?: null;
      status?: string;
      platform_product_id?: string;
      external_product_id?: string;
      internal_product_id?: null;
      internal_state?: {
        images?: object[];
        name?: string;
        description?: string;
        unit_multiplier?: number;
        currency?: string;
        discount_rate?: number;
        retail_price?: {
          amount?: number;
          currency?: string;
        };
        wholesale_price?: {
          amount?: number;
          currency?: string;
        };
        original_wholesale_price?: {
          amount?: number;
          currency?: string;
        };
        vat_rate?: number;
        categories?: {
          id?: number;
          name?: string;
          parent_id?: number;
        }[];
        properties?: object[];
        tags?: {
          name?: string;
        }[];
        made_in?: null;
        hs_code?: null;
        variants?: {
          id?: null;
          sku?: string;
          ian?: string;
          price?: {
            currency?: string;
            retail_price?: {
              amount?: number;
              currency?: string;
            };
            wholesale_price?: {
              amount?: number;
              currency?: string;
            };
            original_wholesale_price?: {
              amount?: number;
              currency?: string;
            };
            discount_rate?: number;
          };
          stock?: {
            id?: null;
            stock_quantity?: number;
            /**
             * Whether stock is tracked at all for
             * this product variant.
             *
             * - `true`: stock is not tracked — a
             *   retailer can order as much of this
             *   variant as they want, with no
             *   restriction at all.
             * - `false`: stock is tracked — whether
             *   a retailer can order the variant
             *   depends on the available stock
             *   quantity and the `inventory_policy`.
             */
            is_always_in_stock?: boolean;
            /**
             * Whether a retailer can order a product
             * variant for which stock is not
             * available.
             *
             * - `deny` (default): no. A retailer
             *   cannot order a quantity larger than
             *   the currently available stock
             *   quantity, so the variant cannot be
             *   ordered when it is out of stock, or
             *   when the desired quantity exceeds
             *   the available quantity.
             * - `continue`: yes. The retailer can
             *   order any quantity, even when stock
             *   is insufficient (desired quantity >
             *   available quantity > 0) or the
             *   variant is out of stock (available
             *   quantity <= 0).
             *
             * Only meaningful when stock is tracked
             * (`is_always_in_stock = false`).
             * @default "deny"
             */
            inventory_policy?: PatchCatalogIntegrationIntegrationsIntegrationIdInventoryPolicyEnum;
            reserved_quantity?: number;
            available_quantity?: number;
          };
          shape_properties?: {
            id?: number | null;
            /** @format float */
            weight?: number;
            weight_unit?: string;
            /** @format float */
            length?: number;
            /** @format float */
            width?: number;
            /** @format float */
            height?: number;
            length_unit?: string;
            /** @format float */
            capacity?: number;
            capacity_unit?: string;
          }[];
          options?: {
            id?: number;
            name?: string;
            value?: string;
          }[];
          name?: null;
          created_at?: null;
          images?: {
            filename?: string;
            order?: number;
          }[];
        }[];
      };
      issues?: object[];
      internal_state_updated_at?: string;
      integrated_at?: null;
      created_at?: string;
      updated_at?: string;
    };
    links?: {
      self?: string;
    };
  };
}

export interface GetApiInternalV1CatalogIntegrationBrandConfigData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    /** CatalogIntegrationBrandConfig */
    attributes?: {
      images_google_folder_url?: string;
      empty_xlsx_download_link?: string;
      generated_google_spreadsheet?: {
        instructions_sheet_url?: string;
        data_sheet_url?: string;
      };
      /** @format date-time */
      created_at?: string;
      /** @format date-time */
      updated_at?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetApiInternalV1CatalogExportsExportsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      status?: string;
      spreadsheet_url?: string;
    };
  };
}

export interface GetApiInternalV1CatalogExportsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      status?: string;
      spreadsheet_url?: string;
    };
  };
}

export type PostApiInternalV1CatalogExportsData = any;

export interface GetApiInternalV1CatalogExportsUuidData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      status?: string;
      spreadsheet_url?: string;
    };
  };
}

export type PostApiInternalV1CatalogIntegrationBrandConfigsSpreadsheetData = any;

export type DeleteApiInternalV1CatalogIntegrationBrandConfigsSpreadsheetData = any;

export interface PatchApiInternalV1CatalogIntegrationsActionsUpdateAllParams {
  /** Product integration ID */
  'filter[id]'?: string[];
  /** Product integration status */
  'filter[status]'?: string[];
  /** Apply only to results with issues (true) or without issues (false). */
  'filter[hasIssues]'?: boolean;
}

export type PatchApiInternalV1CatalogIntegrationsActionsUpdateAllData = any;

export type DeleteApiInternalV1CatalogIntegrationsActionsDeleteManyData = any;

export interface GetApiInternalV1CatalogIntegrationsIntegrationsActionsStatisticsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta: {
    products_total_count: number;
    products_without_issues_total_count: number;
    [key: string]: any;
  };
}

export interface PostApiInternalV1CatalogIntegrationsIntegrationsActionsApproveAllParams {
  /** Product integration statuses */
  'filter[status]'?: string[];
  /** Apply only to results with issues (true) or without issues (false). */
  'filter[hasIssues]'?: boolean;
}

export type PostApiInternalV1CatalogIntegrationsIntegrationsActionsApproveAllData = any;

export type PostApiInternalV1CatalogIntegrationsIntegrationsActionsApproveManyData = any;

export interface DeleteApiInternalV1CatalogIntegrationsActionsPurgeParams {
  /** Product integration status */
  'filter[status]'?: string[];
  /** Apply only to results with issues (true) or without issues (false). */
  'filter[hasIssues]'?: boolean;
}

export type DeleteApiInternalV1CatalogIntegrationsActionsPurgeData = any;

export enum GetApiInternalV1CatalogIntegrationBatchesImportTypeEnum {
  Add = 'add',
  Replace = 'replace',
}

export enum GetApiInternalV1CatalogIntegrationBatchesWorkflowEnum {
  Import = 'import',
  Replace = 'replace',
  Update = 'update',
  Activate = 'activate',
}

export interface GetApiInternalV1CatalogIntegrationBatchesParams {
  /**
   * Results page number.
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Number of items returned per page.
   * @min 1
   * @max 50
   * @default 50
   */
  perPage?: number;
  /**
   * Property to sort results by.
   * @default "created_at"
   */
  sort?: string;
}

export interface GetApiInternalV1CatalogIntegrationBatchesData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    /** ProductIntegrationBatchItem */
    attributes?: {
      fetched_count?: number;
      imported_count?: number;
      integrated_count?: number;
      failed_count?: number;
      created_count?: number;
      updated_count?: number;
      type?: string;
      import_type?: GetApiInternalV1CatalogIntegrationBatchesImportTypeEnum;
      workflow?: GetApiInternalV1CatalogIntegrationBatchesWorkflowEnum;
      status?: string;
      user_id?: number;
      pimimport_job_id?: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * Spreadsheet template
 * @format binary
 */
export type GetApiInternalV1CatalogExchangeTemplatesData = File;

/** Name of the template to download */
export enum GetApiInternalV1CatalogExchangeTemplatesParamsNameEnum {
  ProductsXlsx = 'products.xlsx',
}

export enum GetApiInternalV1CatalogExchangeTemplatesParamsEnum {
  ProductsXlsx = 'products.xlsx',
}

/** Status of the Catalog Export */
export enum GetApiInternalV1CatalogExchangeExportsStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export enum GetApiInternalV1CatalogExchangeExportsTemplateEnum {
  ProductsXlsx = 'products.xlsx',
}

export interface GetApiInternalV1CatalogExchangeExportsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /**
     * Unique identifier of the Catalog Export
     * @format uuid
     */
    id?: string;
    /** Type of the Catalog Export */
    type?: 'catalog-export';
    attributes?: {
      /** Status of the Catalog Export */
      status?: GetApiInternalV1CatalogExchangeExportsStatusEnum;
      template?: GetApiInternalV1CatalogExchangeExportsTemplateEnum;
      /**
       * URL to download the Catalog Export, this property is only available when the status is completed
       * @format uri
       */
      downloadUrl?: string;
      /** Name of the file */
      filename?: string;
      /**
       * Date and time when the Catalog Export was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when the Catalog Export started
       * @format date-time
       */
      startedAt?: string;
      /**
       * Date and time when the Catalog Export completed
       * @format date-time
       */
      completedAt?: string;
    };
  }[];
}

/** Status of the Catalog Export */
export enum PostApiInternalV1CatalogExchangeExportsStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export enum PostApiInternalV1CatalogExchangeExportsTemplateEnum {
  ProductsXlsx = 'products.xlsx',
}

export enum PostApiInternalV1CatalogExchangeExportsTemplateEnum1 {
  ProductsXlsx = 'products.xlsx',
}

export interface PostApiInternalV1CatalogExchangeExportsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /**
     * Unique identifier of the Catalog Export
     * @format uuid
     */
    id?: string;
    /** Type of the Catalog Export */
    type?: 'catalog-export';
    attributes?: {
      /** Status of the Catalog Export */
      status?: PostApiInternalV1CatalogExchangeExportsStatusEnum;
      template?: PostApiInternalV1CatalogExchangeExportsTemplateEnum;
      /**
       * URL to download the Catalog Export, this property is only available when the status is completed
       * @format uri
       */
      downloadUrl?: string;
      /** Name of the file */
      filename?: string;
      /**
       * Date and time when the Catalog Export was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when the Catalog Export started
       * @format date-time
       */
      startedAt?: string;
      /**
       * Date and time when the Catalog Export completed
       * @format date-time
       */
      completedAt?: string;
    };
  };
}

/** Status of the Catalog Export */
export enum GetApiInternalV1CatalogExchangeExportsIdStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export enum GetApiInternalV1CatalogExchangeExportsIdTemplateEnum {
  ProductsXlsx = 'products.xlsx',
}

export interface GetApiInternalV1CatalogExchangeExportsIdData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /**
     * Unique identifier of the Catalog Export
     * @format uuid
     */
    id?: string;
    /** Type of the Catalog Export */
    type?: 'catalog-export';
    attributes?: {
      /** Status of the Catalog Export */
      status?: GetApiInternalV1CatalogExchangeExportsIdStatusEnum;
      template?: GetApiInternalV1CatalogExchangeExportsIdTemplateEnum;
      /**
       * URL to download the Catalog Export, this property is only available when the status is completed
       * @format uri
       */
      downloadUrl?: string;
      /** Name of the file */
      filename?: string;
      /**
       * Date and time when the Catalog Export was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when the Catalog Export started
       * @format date-time
       */
      startedAt?: string;
      /**
       * Date and time when the Catalog Export completed
       * @format date-time
       */
      completedAt?: string;
    };
  };
}

/**
 * Spreadsheet export
 * @format binary
 */
export type GetApiInternalV1CatalogExchangeExportsDownloadData = File;

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"offer-programmes","id":"1ed505e9-0137-6440-888f-0242ac12000c","attributes":{"name":"Diane Reynaud","type":"offer-programmes","start_date":"2022-10-20T00:00:00.000000Z","end_date":"2022-11-03T00:00:00.000000Z","optin":true,"free_trial_eligible":false,"content_management":{"prismic_id":"test","link":{"terms_conditions":"test_link"}}},"links":{"self":"https://ankorstore.com/api/internal/v1/offer-programmes/1ed505e9-0137-6440-888f-0242ac12000c"}},{"type":"offer-programmes","id":"1ed505eb-fd41-69d2-ad3d-0242ac12000c","attributes":{"name":"Henriette-Élise Giraud","type":"offer-programmes","start_date":"2022-10-20T00:00:00.000000Z","end_date":"2022-11-03T00:00:00.000000Z","optin":false,"free_trial_eligible":true,"content_management":{"prismic_id":"test","link":{"terms_conditions":"test_link"}}},"links":{"self":"https://ankorstore.com/api/internal/v1/offer-programmes/1ed505eb-fd41-69d2-ad3d-0242ac12000c"}},{"type":"offer-programmes","id":"1ed5063b-2ada-68cc-a370-0242ac12000c","attributes":{"name":"William Ollivier","type":"offer-programmes","start_date":"2022-10-20T00:00:00.000000Z","end_date":"2022-11-03T00:00:00.000000Z","optin":false,"free_trial_eligible":true,"content_management":{"prismic_id":"test","link":{"terms_conditions":"test_link"}}},"links":{"self":"https://ankorstore.com/api/internal/v1/offer-programmes/1ed5063b-2ada-68cc-a370-0242ac12000c"}}]} */
export interface GetApiInternvalV1OfferProgrammesEligibleData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
      type?: string;
      start_date?: string;
      end_date?: string;
      optin?: boolean;
      free_trial_eligible?: boolean;
      content_management?: {
        prismic_id?: string;
      };
      subscription?: {
        status?: string;
        price?: {
          amount?: number;
          currency?: string;
        };
        currentPeriodStart?: string;
        currentPeriodEnd?: string;
        billingDate?: string;
        subscribedAt?: string;
        canceledAt?: string;
      };
      savings?: {
        nb_net_90_checkouts?: number;
        total_amount?: {
          amount?: number;
          currency?: string;
        };
        shipping_fees?: {
          amount?: number;
          currency?: string;
        };
        discount?: {
          amount?: number;
          currency?: string;
        };
      };
    };
    links?: {
      self?: string;
    };
  }[];
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"offer-programmes","id":"1ed505e9-0137-6440-888f-0242ac12000c","attributes":{"name":"Diane Reynaud","type":"offer-programmes","start_date":"2022-10-20T00:00:00.000000Z","end_date":"2022-11-03T00:00:00.000000Z","optin":true,"content_management":{"prismic_id":"test","link":{"terms_conditions":"test_link"}}},"links":{"self":"https://ankorstore.com/api/internal/v1/offer-programmes/1ed505e9-0137-6440-888f-0242ac12000c"}}]} */
export interface GetApiInternvalV1OfferProgrammesData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
      type?: string;
      start_date?: string;
      end_date?: string;
      optin?: boolean;
      free_trial_eligible?: boolean;
      content_management?: {
        prismic_id?: string;
      };
      subscription?: {
        status?: string;
        price?: {
          amount?: number;
          currency?: string;
        };
        currentPeriodStart?: string;
        currentPeriodEnd?: string;
        billingDate?: string;
        subscribedAt?: string;
        canceledAt?: string;
      };
      savings?: {
        nb_net_90_checkouts?: number;
        total_amount?: {
          amount?: number;
          currency?: string;
        };
        shipping_fees?: {
          amount?: number;
          currency?: string;
        };
        discount?: {
          amount?: number;
          currency?: string;
        };
      };
      potential_savings?: {
        net90?: boolean;
        total_amount?: {
          amount?: number;
          currency?: string;
        };
        shipping_fees?: {
          amount?: number;
          currency?: string;
        };
        nb_brands_repeat_offer?: number;
        nb_brands_48H?: number;
      };
    };
    links?: {
      self?: string;
    };
  }[];
}

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"offer-programmes","id":"1ed505e9-0137-6440-888f-0242ac12000c","attributes":{"name":"Diane Reynaud","type":"offer-programmes","start_date":"2022-10-20T00:00:00.000000Z","end_date":"2022-11-03T00:00:00.000000Z","optin":true},"links":{"self":"https://ankorstore.com/api/internal/v1/offer-programmes/1ed505e9-0137-6440-888f-0242ac12000c"}}} */
export interface PostApiInternalV1OfferProgrammesIdOptinsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
      type?: string;
      start_date?: string;
      end_date?: string;
      optin?: boolean;
    };
    links?: {
      self?: string;
    };
  };
}

/** @example {"jsonapi":{"version":"1.0"},"data":{"type":"offer-programmes","id":"1ed505e9-0137-6440-888f-0242ac12000c","attributes":{"name":"Diane Reynaud","type":"offer-programmes","start_date":"2022-10-20T00:00:00.000000Z","end_date":"2022-11-03T00:00:00.000000Z","optin":true},"links":{"self":"https://ankorstore.com/api/internal/v1/offer-programmes/1ed505e9-0137-6440-888f-0242ac12000c"}}} */
export interface PostApiInternalV1OfferProgrammesIdOptoutsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
      type?: string;
      start_date?: string;
      end_date?: string;
      optin?: boolean;
    };
    links?: {
      self?: string;
    };
  };
}

export interface GetApiInternalV1TestimonialsParams {
  /** Filter testimonials by multiple country ids */
  'filter[countryId]'?: number[];
  /** Filter testimonials by multiple country iso codes */
  'filter[country][isoCode]'?: string[];
  /** A limit on the number of resources to be returned, i.e. the per-page amount. */
  'page[size]'?: string;
  /** A cursor for use in pagination. after is a resource ID that defines your place in the list. For instance, if you make a paged request and receive 100 resources, ending with resource with id foo, your subsequent call can include page[after]=foo in order to fetch the next page of the list. */
  'page[after]'?: string;
  sort?: SortEnum3;
}

export enum SortEnum3 {
  CreatedAt = 'createdAt',
  ValueCreatedAt = '-createdAt',
}

export interface GetApiInternalV1TestimonialsData {
  meta?: {
    page?: {
      /** Uuid of the first element */
      from?: string;
      hasMore?: boolean;
      perPage?: number;
      /** Uuid of the last element */
      to?: string;
    };
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  links?: {
    first?: string;
    prev?: string;
  };
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      body?: string;
      authorName?: string;
      authorShopName?: string;
      authorImage?: string;
      country?: string;
    };
  }[];
}

export enum GetApiInternalV1TestimonialsParams1SortEnum {
  CreatedAt = 'createdAt',
  ValueCreatedAt = '-createdAt',
}

export interface GetApiInternalV1CategoriesData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      name: string;
    };
    relationships?: {
      parent: {
        data: {
          type: 'categories';
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
    };
  }[];
}

export enum PostApiInternalV1OperationsOpEnum {
  Add = 'add',
  Update = 'update',
}

/** Service Type used to distinguish what this item is for. */
export enum PostApiInternalV1OperationsServiceTypeEnum {
  Fulfillment = 'fulfillment',
  Ads = 'ads',
  Orderpay = 'orderpay',
}

export interface PostApiInternalV1OperationsData {
  'atomic:results'?: {
    data?: {
      /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
      type: string;
      /**
       * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
       * @format uuid
       */
      id: string;
      attributes?: object;
    };
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  }[];
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"segments","id":"1ed5ed69-3b3b-675a-9c3d-0242ac12000b","attributes":{"name":"country_FR"}},{"type":"segments","id":"1ed5ed69-4694-6070-a1c3-0242ac12000b","attributes":{"name":"core_country"}},{"type":"segments","id":"1ed5ed69-4bd6-688a-85f8-0242ac12000b","attributes":{"name":"retailer"}}]} */
export interface GetApiInternalV1SegmentsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
    };
  }[];
}

export interface GetApiInternalV1BusinessEventBrandDiscountsParams {
  /** array of json encoded products ids */
  'filter[id]'?: string;
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"business-event-brand-discounts","id":"31951","attributes":{"discount":10},"links":{"self":"https://ankorstore.localhost/api/internal/v1/business-event-brand-discounts/31951"}}]} */
export interface GetApiInternalV1BusinessEventBrandDiscountsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      discount?: number;
    };
    links?: {
      self?: string;
    };
  }[];
}

export interface GetApiInternalV1ProductPricesParams {
  /** lists of product ids separated with a coma */
  'filter[id]'?: string;
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"product-prices","id":"3231389","attributes":{"originalWholesalePrice":{"currency":"EUR","amount":1010},"wholesalePrice":{"currency":"EUR","amount":1010},"retailPrice":{"currency":"EUR","amount":2000},"discountRate":0}},{"type":"product-prices","id":"3231391","attributes":{"originalWholesalePrice":{"currency":"GBP","amount":674},"wholesalePrice":{"currency":"GBP","amount":674},"retailPrice":{"currency":"GBP","amount":899},"discountRate":0}},{"type":"product-prices","id":"3231397","attributes":{"originalWholesalePrice":{"currency":"GBP","amount":419},"wholesalePrice":{"currency":"GBP","amount":419},"retailPrice":{"currency":"GBP","amount":599},"discountRate":0}}]} */
export interface GetApiInternalV1ProductPricesData {
  jsonapi?: {
    version?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      originalWholesalePrice?: {
        currency?: string;
        amount?: number;
      };
      wholesalePrice?: {
        currency?: string;
        amount?: number;
      };
      retailPrice?: {
        currency?: string;
        amount?: number;
      };
      discountRate?: number;
    };
  }[];
}

/** @example {"jsonapi":{"version":"1.0"},"links":{"self":"https://www.ankorstore.com/api/internal/v1/product-types/6343"},"data":{"type":"product-type","id":"6343","attributes":{"label":"Dresses","assignable":false,"prohibited":false},"relationships":{"schema":{"links":{"related":"https://www.ankorstore.com/api/internal/v1/product-types/6343/schema"}}}}} */
export interface GetProductTypeData {
  /**
   * ProductTypeResource
   * A resource that describes a product type
   */
  data?: {
    /**
     * [The type of resource](https://jsonapi.org/format/#document-resource-object-identification)
     * @default "product-type"
     */
    type: string;
    /**
     * A unique identifier for the product type.
     * @format int64
     */
    id: string;
    attributes: {
      /** A human-readable label for the product type */
      label?: string;
      /** Whether a product can be assigned to this product type or not */
      assignable?: boolean;
      /** Whether this type of product can be sold on the website or not */
      prohibited?: boolean;
    };
    relationships?: {
      /** The product attribute schema */
      schema?: {
        /** Links to the endpoints that describe the attribute schema. */
        links?: {
          /** @format uri-reference */
          related?: string;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Describes the type of the attribute */
export enum GetProductTypeSchemaAttributeTypeEnum {
  SingleSelect = 'single-select',
  MultiSelect = 'multi-select',
}

/** Describes the requirement level for the attribute */
export enum GetProductTypeSchemaRequirementEnum {
  Mandatory = 'mandatory',
  Recommended = 'recommended',
  Optional = 'optional',
}

/** @example {"jsonapi":{"version":"1.0"},"links":{"related":"https://www.ankorstore.com/api/internal/v1/product-types/6431/schema"},"data":[{"type":"product-attribute","id":"age_group","attributes":{"attributeType":"single-select","label":"Age Group","inputTip":"Indicate the target consumer age group for which the product has been designed.","inputHint":"Select an age group","requirement":"mandatory","options":[{"value":"adult","label":"Adult"},{"value":"baby","label":"Baby"},{"value":"kid","label":"Kid"}]}},{"type":"product-attribute","id":"target_gender","attributes":{"attributeType":"single-select","label":"Target Gender","inputTip":"Indicate the target consumer gender for which the product has been designed.","inputHint":"Select a gender","requirement":"mandatory","options":[{"value":"female","label":"Female"},{"value":"male","label":"Male"},{"value":"unisex","label":"Unisex"}]}}]} */
export interface GetProductTypeSchemaData {
  data?: {
    /**
     * [The type of resource](https://jsonapi.org/format/#document-resource-object-identification)
     * @default "product-attribute"
     */
    type: string;
    /** A globally-unique identifier for the attribute. */
    id: string;
    attributes: {
      /** Describes the type of the attribute */
      attributeType?: GetProductTypeSchemaAttributeTypeEnum;
      /** A human-readable label for the product attribute */
      label?: string;
      inputTip?: string | null;
      inputHint?: string | null;
      /** Describes the requirement level for the attribute */
      requirement?: GetProductTypeSchemaRequirementEnum;
      options?: {
        value?: string;
        label?: string;
      }[];
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"product-type-suggestion","id":"12345","attributes":{"name":"Pet Supplies","context":"","searchString":"Pet Supplies"}},{"type":"product-type-suggestion","id":"67890","attributes":{"name":"Bird Supplies","context":"Pet Supplies","searchString":"Bird Supplies Pet Supplies"}}]} */
export interface GetApiInternalV1ProductTypesAutocompleteData {
  jsonapi?: {
    version?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      name?: string;
      context?: string;
      searchString?: string;
    };
  }[];
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"category","id":"12345","attributes":{"fullPath":"Pet Supplies > Bird Supplies > Bird Cages & Stands"}},{"type":"category","id":"54321","attributes":{"fullPath":"Stationary & Hobbies > Accessories > Bird Cages & Stands"}}]} */
export interface GetApiInternalV1ProductTypesCategoriesData {
  jsonapi?: {
    version?: string;
  };
  data?: {
    type?: string;
    id?: string;
    attributes?: {
      fullPath?: string;
    };
  }[];
}

/** @example {"jsonapi":{"version":"1.0"},"data":[{"type":"product-type","id":1,"attributes":{"name":"Pet Supplies","isSelectable":true,"children":[{"type":"product-type","id":2,"attributes":{"name":"Bird Supplies","isSelectable":true}},{"type":"product-type","id":3,"attributes":{"name":"Cat Supplies","isSelectable":true}}]}}]} */
export interface GetApiInternalV1ProductTypesTreeData {
  jsonapi?: {
    version?: string;
  };
  data?: {
    type?: string;
    id?: number;
    attributes?: {
      name?: string;
      isSelectable?: boolean;
      children?: any[];
    };
  }[];
}

export enum CreateLabelFormatEnum {
  ZPL = 'ZPL',
}

export enum CreateLabelEncodingEnum {
  Base64 = 'base64',
}

export enum CreateLabelFormatEnum1 {
  ZPL = 'ZPL',
}

export enum CreateLabelEncodingEnum1 {
  Base64 = 'base64',
}

/** Format: AKS_{GEOGRAPHICAL-CLUSTER}_{LAST-MILE-CARRIER} */
export enum CreateLabelServiceEnum {
  AKS_PAR_COG = 'AKS_PAR_COG',
  AKS_PAR_AKS = 'AKS_PAR_AKS',
}

export interface CreateLabelData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** Label */
    attributes: {
      format: CreateLabelFormatEnum;
      encoding: CreateLabelEncodingEnum;
      data: string;
      containerReference: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface ListHistoricalParcelDimensionsData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** HistoricalParcelDimension */
    attributes: {
      width: number;
      height: number;
      length: number;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum ListOrderShippingQuotesCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

/** Shipment segment to which the surcharge applies. */
export enum ListOrderShippingQuotesScopeEnum {
  Origin = 'origin',
  Destination = 'destination',
}

/** Business code identifying the surcharge type. */
export enum ListOrderShippingQuotesCodeEnum {
  EXTENDED_AREA = 'EXTENDED_AREA',
  REMOTE_AREA = 'REMOTE_AREA',
}

export interface ListOrderShippingQuotesParams {
  /** Include shipping service in the payload */
  include?: IncludeEnum5;
  /**
   * Id of master order for which the quotes are requested
   * @format uuid
   */
  masterOrderUuid: string;
}

/** Include shipping service in the payload */
export enum IncludeEnum5 {
  ShippingService = 'shippingService',
}

export interface ListOrderShippingQuotesData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** Quote */
    attributes: {
      /** Order master uuid linked to the quote */
      masterOrderUuid?: string;
      /** The provider of the quote, generally a carrier (ups, dhl_express ...) */
      provider?: string;
      /** Estimation of the cost for the brand */
      shippingCost?: {
        /** The amount of the shipping cost */
        amount?: number;
        /** The currency of the shipping cost */
        currency?: string;
      };
    };
    meta?: {
      /** The validation/business rule errors for the carrier */
      validationError?: {
        /** An application-specific error code, expressed as a string value. */
        code?: string;
        /** A human-readable explanation specific to this occurrence of the problem. */
        detail?: string;
        /** The HTTP status code applicable to this problem, expressed as a string value. */
        status?: string;
        /** Optional object pointing towards the problematic field */
        source?: {
          /** The field key */
          pointer?: string;
        };
        /** The HTTP status code description applicable to this problem */
        title?: string;
        /** Meta-information about the rules that failed and the limit */
        meta?: {
          rule?: string;
          options?: string[];
          [key: string]: any;
        };
      }[];
      [key: string]: any;
    };
    relationships?: {
      shippingService?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** ShippingService */
    attributes: {
      /** The carrier code of the service */
      carrierCode?: string;
      /** The carrier service code */
      serviceCode?: string;
      /** The commercial name of the service */
      serviceCommercialName?: string;
      /** The collection method for the carrier service */
      collectionMethod?: ListOrderShippingQuotesCollectionMethodEnum[];
      /** Price of the service */
      servicePrice?: {
        /** The amount of the service price */
        amount?: number;
        /** The currency of the service price */
        currency?: string;
        /**
         * List of surcharges applied to the service price.
         * @minItems 1
         */
        surcharges?: {
          /** Shipment segment to which the surcharge applies. */
          scope: ListOrderShippingQuotesScopeEnum;
          /** Business code identifying the surcharge type. */
          code: ListOrderShippingQuotesCodeEnum;
          /** Surcharge amount expressed in minor units (e.g. cents). */
          amount: number;
        }[];
      };
      /** Delivery estimation information for the service if provided by carrier */
      timeInTransit?: {
        /**
         * Estimation of delivery date by the carrier
         * @format date
         */
        estimatedDeliveryDate?: null | string;
        /**
         * Pickup date considered for the estimation
         * @format date
         */
        pickupDate?: null | string;
        /** Number of business days the shipment is in transit */
        businessDaysInTransit?: null | number;
      };
    };
  }[];
}

/** Include shipping service in the payload */
export enum ListOrderShippingQuotesParams1IncludeEnum {
  ShippingService = 'shippingService',
}

/** @example {"loyalty":{"available_discounts":[5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"current_discount":10,"network":null}} */
export interface GetApiInternalV1LoyaltyData {
  data?: {
    current_discount?: number;
    available_discounts?: any[];
    network?: any[];
  }[];
}

export type UpdateApiInternalV1LoyaltyData = object;

export type DeleteApiInternalV1LoyaltyData = object;

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum1 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum2 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum3 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum4 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum5 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum6 {
  Self = 'self',
  Blank = 'blank',
}

/** Where to open the linked URL */
export enum GetNavMenuItemsTargetEnum7 {
  Self = 'self',
  Blank = 'blank',
}

export interface GetNavMenuItemsData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: (
    | ({
        /**
         * A globally-unique identifier for the navigation element
         * @format uuid
         */
        id: string;
        type: string;
        attributes?: object;
        meta?: {
          /**
           * Depth of the navigation element in the hierarchy (starting at 0)
           * @min 0
           */
          depth: number;
          /**
           * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
           * @min 0
           */
          position: number;
          [key: string]: any;
        };
      } & {
        type?: 'nav-item';
        attributes?: {
          /** The label of the link */
          label: string;
          /**
           * The URL to which the link points to
           * @format uri-reference
           */
          url?: string;
          /** Where to open the linked URL */
          target?: GetNavMenuItemsTargetEnum;
          /** Whether or not the URL is external to the website */
          external?: boolean;
          /**
           * Exclude the link from the navigation menu
           * @default false
           */
          exclude?: boolean;
          /** The tracking event to be sent when the link is clicked */
          'tracking-event'?: string;
        } & {
          /** Secondary navigation links */
          related?: {
            /** NavigationLink */
            self?: {
              /** The label of the link */
              label: string;
              /**
               * The URL to which the link points to
               * @format uri-reference
               */
              url?: string;
              /** Where to open the linked URL */
              target?: GetNavMenuItemsTargetEnum1;
              /** Whether or not the URL is external to the website */
              external?: boolean;
              /**
               * Exclude the link from the navigation menu
               * @default false
               */
              exclude?: boolean;
              /** The tracking event to be sent when the link is clicked */
              'tracking-event'?: string;
            };
            /** NavigationLink */
            'newest-brands'?: {
              /** The label of the link */
              label: string;
              /**
               * The URL to which the link points to
               * @format uri-reference
               */
              url?: string;
              /** Where to open the linked URL */
              target?: GetNavMenuItemsTargetEnum2;
              /** Whether or not the URL is external to the website */
              external?: boolean;
              /**
               * Exclude the link from the navigation menu
               * @default false
               */
              exclude?: boolean;
              /** The tracking event to be sent when the link is clicked */
              'tracking-event'?: string;
            };
            /** NavigationLink */
            'newest-products'?: {
              /** The label of the link */
              label: string;
              /**
               * The URL to which the link points to
               * @format uri-reference
               */
              url?: string;
              /** Where to open the linked URL */
              target?: GetNavMenuItemsTargetEnum3;
              /** Whether or not the URL is external to the website */
              external?: boolean;
              /**
               * Exclude the link from the navigation menu
               * @default false
               */
              exclude?: boolean;
              /** The tracking event to be sent when the link is clicked */
              'tracking-event'?: string;
            };
            [key: string]: any;
          };
        };
      })
    | ({
        /**
         * A globally-unique identifier for the navigation element
         * @format uuid
         */
        id: string;
        type: string;
        attributes?: object;
        meta?: {
          /**
           * Depth of the navigation element in the hierarchy (starting at 0)
           * @min 0
           */
          depth: number;
          /**
           * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
           * @min 0
           */
          position: number;
          [key: string]: any;
        };
      } & {
        type?: 'nav-item-group';
        attributes?: {
          /** Title of the menu item group */
          title?: string;
          /** The list of menu items in the group */
          items?: ({
            /**
             * A globally-unique identifier for the navigation element
             * @format uuid
             */
            id: string;
            type: string;
            attributes?: object;
            meta?: {
              /**
               * Depth of the navigation element in the hierarchy (starting at 0)
               * @min 0
               */
              depth: number;
              /**
               * A decimal value used to order elements that are on the same level in the navigation tree (starting at 0)
               * @min 0
               */
              position: number;
              [key: string]: any;
            };
          } & {
            type?: 'nav-item';
            attributes?: {
              /** The label of the link */
              label: string;
              /**
               * The URL to which the link points to
               * @format uri-reference
               */
              url?: string;
              /** Where to open the linked URL */
              target?: GetNavMenuItemsTargetEnum4;
              /** Whether or not the URL is external to the website */
              external?: boolean;
              /**
               * Exclude the link from the navigation menu
               * @default false
               */
              exclude?: boolean;
              /** The tracking event to be sent when the link is clicked */
              'tracking-event'?: string;
            } & {
              /** Secondary navigation links */
              related?: {
                /** NavigationLink */
                self?: {
                  /** The label of the link */
                  label: string;
                  /**
                   * The URL to which the link points to
                   * @format uri-reference
                   */
                  url?: string;
                  /** Where to open the linked URL */
                  target?: GetNavMenuItemsTargetEnum5;
                  /** Whether or not the URL is external to the website */
                  external?: boolean;
                  /**
                   * Exclude the link from the navigation menu
                   * @default false
                   */
                  exclude?: boolean;
                  /** The tracking event to be sent when the link is clicked */
                  'tracking-event'?: string;
                };
                /** NavigationLink */
                'newest-brands'?: {
                  /** The label of the link */
                  label: string;
                  /**
                   * The URL to which the link points to
                   * @format uri-reference
                   */
                  url?: string;
                  /** Where to open the linked URL */
                  target?: GetNavMenuItemsTargetEnum6;
                  /** Whether or not the URL is external to the website */
                  external?: boolean;
                  /**
                   * Exclude the link from the navigation menu
                   * @default false
                   */
                  exclude?: boolean;
                  /** The tracking event to be sent when the link is clicked */
                  'tracking-event'?: string;
                };
                /** NavigationLink */
                'newest-products'?: {
                  /** The label of the link */
                  label: string;
                  /**
                   * The URL to which the link points to
                   * @format uri-reference
                   */
                  url?: string;
                  /** Where to open the linked URL */
                  target?: GetNavMenuItemsTargetEnum7;
                  /** Whether or not the URL is external to the website */
                  external?: boolean;
                  /**
                   * Exclude the link from the navigation menu
                   * @default false
                   */
                  exclude?: boolean;
                  /** The tracking event to be sent when the link is clicked */
                  'tracking-event'?: string;
                };
                [key: string]: any;
              };
            };
          })[];
        };
      })
  )[];
}

/** @example {"loyalty":{"network":null}} */
export interface GetApiInternalV1LoyaltyRetailerData {
  data?: {
    network?: any[];
  }[];
}

export interface GetApiInternalV1AnkorstorePlusPerksBrandData {
  data?: {
    title?: string;
    description?: string;
    perks?: any[];
  }[];
}

export interface GetApiInternalV1AnkorstorePlusPerksProductData {
  data?: {
    title?: string;
    description?: string;
    perks?: any[];
  }[];
}

export type BrandNetworkContactDeleteData = any;

export interface BrandNetworkContactDeleteListData {
  data?: {
    deleted?: {
      /**
       * The unique identifier for the deleted contact
       * @format uuid
       */
      id?: string;
    }[];
    notFound?: {
      /**
       * Unique identifier of the resource not found when processing
       * @format uuid
       */
      id?: string;
    }[];
    error?: {
      /**
       * Unique identifier of the resource failed to process
       * @format uuid
       */
      id?: string;
    }[];
  };
}

export enum ExportContactsTypeEnum {
  ContactExport = 'contact-export',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum ExportContactsTypeEnum1 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum ExportContactsTypeEnum2 {
  Range = 'range',
}

/** The type of filter. */
export enum ExportContactsTypeEnum3 {
  Boolean = 'boolean',
}

/**
 * The content of the CSV file to download.
 * @format binary
 */
export type ExportContactsData = File;

/**
 * Type of facet.
 *
 * A value facet provides the counts of each value for an attribute.
 * This type of facet is only available on **text**, **number** and **date** attributes.
 */
export enum SearchContactsTypeEnum {
  Value = 'value',
}

/**
 * Type of facet.
 *
 * A range facet returns counts of documents within the provided ranges.
 * This type of facet is only available on **number** and **date** attributes.
 */
export enum SearchContactsTypeEnum1 {
  Range = 'range',
}

/**
 * Type of facet.
 *
 * Stats (also called *aggregation* or *analytic*) facets compute stats over
 * numeric values extracted from the aggregated results. This type of facet
 * is only available on **number** attributes.
 */
export enum SearchContactsTypeEnum2 {
  Stats = 'stats',
}

export enum SearchContactsTypeEnum3 {
  ContactDocument = 'contact-document',
}

/** Status of the relationship with this contact. */
export enum SearchContactsStatusEnum {
  Prospect = 'prospect',
  Customer = 'customer',
}

/** Origin of the contact. */
export enum SearchContactsOriginEnum {
  Ankorstore = 'ankorstore',
  Imported = 'imported',
}

/** The contact's ordering activity signal. */
export enum SearchContactsActivitySignalEnum {
  High = 'high',
  Low = 'low',
  Inactive = 'inactive',
}

/** Who's the sender of the last sent message. */
export enum SearchContactsLastMessageByEnum {
  Retailer = 'retailer',
  Brand = 'brand',
}

/**
 * Indicates the level of consent this contact has given
 * to receive email marketing campaigns.
 *
 * - **Subscribed** — A subscribed contact, or subscriber,
 * is someone who has opted in to receive marketing messages.
 *
 * - **Unsubscribed** — An unsubscribed contact is someone who
 * previously received marketing messages but has opted out.
 *
 * - **Suppressed** — A suppressed contact is someone who is
 * on the suppression list and thus is excluded from receiving
 * marketing messages. Contacts may be added to the suppression
 * list for various reasons, including if they have complained
 * about receiving emails (they marked emails as spam)
 * or if their email address bounced or is invalid.
 */
export enum SearchContactsSubscriptionStatusEnum {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
  Suppressed = 'suppressed',
}

export enum SearchContactsTypeEnum4 {
  SearchParams = 'search-params',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum SearchContactsTypeEnum5 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum SearchContactsTypeEnum6 {
  Range = 'range',
}

/** The type of filter. */
export enum SearchContactsTypeEnum7 {
  Boolean = 'boolean',
}

export enum SearchContactsSortEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export type SearchContactsData = {
  /** Array of results matching the search. */
  data: any[];
  meta: {
    page?: {
      /**
       * Number of results per page.
       * @min 1
       */
      size?: number;
      /**
       * Index of the current search result page.
       * @min 1
       */
      current?: number;
      /**
       * Total number of search result pages.
       * @min 0
       */
      totalPages?: number;
      /**
       * Total number of results.
       * @min 0
       */
      totalResults?: number;
    };
    /**
     * Contains the number of matching contacts distributed among
     * the values of a given facet. Each facet is represented as
     * an object.
     */
    facets?: Record<
      string,
      | {
          /**
           * Type of facet.
           *
           * A value facet provides the counts of each value for an attribute.
           * This type of facet is only available on **text**, **number** and **date** attributes.
           */
          type: SearchContactsTypeEnum;
          data: {
            /** A human-readable name for the value. */
            name?: string;
            /** The value of the attribute. */
            value: string | number;
            /**
             * The number of results for this value of the attribute.
             * @min 1
             */
            count: number;
          }[];
        }
      | {
          /**
           * Type of facet.
           *
           * A range facet returns counts of documents within the provided ranges.
           * This type of facet is only available on **number** and **date** attributes.
           */
          type: SearchContactsTypeEnum1;
          data: {
            /** Name given to the range. */
            name?: string;
            /**
             * Number of results within the range.
             * @min 1
             */
            count: number;
            /**
             * Inclusive lower bound of the range.
             * @format date-time
             */
            from?: number | string;
            /**
             * Exclusive upper bound of the range.
             * @format date-time
             */
            to?: number | string;
          }[];
        }
      | {
          /**
           * Type of facet.
           *
           * Stats (also called *aggregation* or *analytic*) facets compute stats over
           * numeric values extracted from the aggregated results. This type of facet
           * is only available on **number** attributes.
           */
          type: SearchContactsTypeEnum2;
          /** The lowest numerical value across all results. */
          min: number;
          /** The highest numerical value across all results. */
          max: number;
        }
    >;
  };
} & {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /**
     * A globally-unique identifier for the contact.
     * @format uuid
     * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
     */
    id: string;
    type: SearchContactsTypeEnum3;
    attributes: {
      /** Relationship details */
      relation: {
        /**
         * The date and time when the contact was added to the brand's network.
         * @format date-time
         */
        addedAt: string;
        /**
         * The date and time when the contact was invited to the brand's network (i.e.
         * when a referral invitation was sent to the contact's email address).
         * @format date-time
         */
        invitedAt?: null | string;
        /**
         * The date and time when the contact became affiliated with the brand.
         * Affiliation is confirmed when a retailer places a first order with the brand.
         * @format date-time
         */
        affiliatedAt?: null | string;
        /** Status of the relationship with this contact. */
        status: SearchContactsStatusEnum;
        /** Origin of the contact. */
        origin: SearchContactsOriginEnum;
      };
      /** Contact details */
      contact: {
        /** The contact's first name. */
        firstname?: string;
        /** The contact's last name. */
        lastname?: string;
        /**
         * The contact's primary email address.
         * @format email
         */
        email?: string;
        /** The contact's primary phone number. */
        phone?: string;
        /**
         * The contact's preferred language for communications
         * (represented as a 2-letter language code conforming to
         * [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag)).
         */
        language?: string;
        /** The contact's city. */
        city?: string;
        /** The contact's zip code. */
        zip?: string;
        /** The contact's country code. */
        country?: string;
      };
      /** Retailer details */
      retailer?: {
        /**
         * The globally-unique identifier of the retailer.
         * @format uuid
         */
        uuid?: string;
        /** The shop name. */
        name?: string;
        /**
         * The type of shop.
         * @example "pet_store"
         */
        shopType?: null | string;
        /**
         * The date and time when the retailer signed up for an account.
         * @format date-time
         */
        createdAt?: string;
        /** Contact details */
        contact?: {
          /** The retailer's first name. */
          firstname?: string;
          /** The retailer's last name. */
          lastname?: string;
          /**
           * The retailer's primary email address.
           * @format email
           */
          email?: string;
          /** The retailer's primary phone number. */
          phone?: string;
          /** The retailer's city. */
          city?: string;
          /** The retailer's zip code. */
          zip?: string;
          /** The retailer's country code. */
          country?: string;
        };
        /** Status of the Ankorstore+ subscription. */
        aksStatus?: {
          /** Whether this retailer has an active subscription to Ankorstore+ */
          active?: boolean;
          /** Whether this retailer is eligible for the Ankorstore+ offer. */
          eligible?: boolean;
        };
      };
      /** Commercial terms for this contact */
      commercialTerms?: {
        /**
         * The service fee invoiced for this contact's purchases.
         * @format float
         * @min 0
         */
        serviceFees?: number;
        /**
         * The personalised discount for this contact.
         * @format float
         * @min 0
         */
        brandDiscount?: number;
        /**
         * The discount the contact benefits from as part of the repeat offer.
         * @format float
         * @min 0
         */
        repeatOffer?: number;
        /** Whether a personalised brand discount is active for this contact. */
        hasBrandDiscount?: boolean;
        /** Whether a repeat offer is currently active for this contact. */
        hasRepeatOffer?: boolean;
        /**
         * The date and time until which the repeat offer remains unlocked.
         * @format date-time
         */
        repeatOfferUnlockedUntil?: null | string;
        /**
         * The remaining amount the contact must spend to unlock the repeat offer.
         * @format float
         * @min 0
         */
        amountToUnlockRepeatOffer?: null | number;
        /**
         * The date and time until which free shipping with the brand applies.
         * @format date-time
         */
        freeShippingForBrandUntil?: null | string;
        /** The tiered discount currently assigned to this contact, if any. */
        tieredDiscount?: {
          /** The identifier of the tiered discount. */
          id?: string;
          /** The name of the tiered discount. */
          name?: string;
          /**
           * The discount percentage granted by the tiered discount.
           * @format float
           * @min 0
           */
          percentage?: number;
        };
      };
      /** Order activity */
      ordering?: {
        /**
         * The date and time when last order was placed.
         * @format date-time
         */
        lastOrderedAt?: null | string;
        /**
         * The total amount of the last placed order.
         * @example {"currency":"EUR","amount":142}
         */
        lastOrderedAmount?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * The total number of completed orders for this contact.
         * @min 0
         */
        totalCompletedOrders?: number;
        /**
         * The total amount of completed orders for this contact.
         * @example {"currency":"EUR","amount":142}
         */
        totalSpent?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /** Whether this contact is eligible for the referral offer. */
        liftEligible?: boolean;
        /**
         * The date and time when the first order was placed.
         * @format date-time
         */
        firstOrderedAt?: null | string;
        /**
         * The predicted date and time of the contact's next order.
         * @format date-time
         */
        expectedNextOrderAt?: null | string;
        /**
         * The date and time when the contact became disengaged.
         * @format date-time
         */
        disengagedAt?: null | string;
        /** The contact's ordering activity signal. */
        activitySignal?: SearchContactsActivitySignalEnum;
      };
      /** Prepared order activity */
      preparedOrders?: {
        /**
         * Total number of prepared orders for this contact.
         * @min 0
         */
        number: number;
      };
      /** Shopping activity */
      cart?: {
        /**
         * Order total for the shopping cart of this retailer.
         * @example {"currency":"EUR","amount":142}
         */
        amountInCart: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * The date and time when the shopping cart was last updated.
         * @format date-time
         */
        cartUpdatedAt: string;
      };
      /** Communications with this contact */
      communication?: {
        /** Direct in-app messaging */
        messaging?: {
          /**
           * The date and time when the last message was sent.
           * @format date-time
           */
          lastContactedAt?: string;
          /** Who's the sender of the last sent message. */
          lastMessageBy?: SearchContactsLastMessageByEnum;
        };
        /** Emailing activity */
        emailing?: {
          /**
           * Indicates the level of consent this contact has given
           * to receive email marketing campaigns.
           *
           * - **Subscribed** — A subscribed contact, or subscriber,
           * is someone who has opted in to receive marketing messages.
           *
           * - **Unsubscribed** — An unsubscribed contact is someone who
           * previously received marketing messages but has opted out.
           *
           * - **Suppressed** — A suppressed contact is someone who is
           * on the suppression list and thus is excluded from receiving
           * marketing messages. Contacts may be added to the suppression
           * list for various reasons, including if they have complained
           * about receiving emails (they marked emails as spam)
           * or if their email address bounced or is invalid.
           */
          subscriptionStatus?: SearchContactsSubscriptionStatusEnum;
          /**
           * The date and time when the last email was sent.
           * @format date-time
           */
          lastContactedAt?: string;
          /** Whether the brand sent an email to the contact on the same calendar day. */
          contactedRecently?: boolean;
        };
      };
      /** The name of the QR campaign the contact originated from, if any. */
      qrCampaignName?: null | string;
      /** The identifier of the QR campaign source the contact originated from, if any. */
      qrCampaignSourceId?: null | string;
    };
  }[];
};

/**
 * Type of facet.
 *
 * A value facet provides the counts of each value for an attribute.
 * This type of facet is only available on **text**, **number** and **date** attributes.
 */
export enum MultipleSearchContactsTypeEnum {
  Value = 'value',
}

/**
 * Type of facet.
 *
 * A range facet returns counts of documents within the provided ranges.
 * This type of facet is only available on **number** and **date** attributes.
 */
export enum MultipleSearchContactsTypeEnum1 {
  Range = 'range',
}

/**
 * Type of facet.
 *
 * Stats (also called *aggregation* or *analytic*) facets compute stats over
 * numeric values extracted from the aggregated results. This type of facet
 * is only available on **number** attributes.
 */
export enum MultipleSearchContactsTypeEnum2 {
  Stats = 'stats',
}

export enum MultipleSearchContactsTypeEnum3 {
  ContactDocument = 'contact-document',
}

/** Status of the relationship with this contact. */
export enum MultipleSearchContactsStatusEnum {
  Prospect = 'prospect',
  Customer = 'customer',
}

/** Origin of the contact. */
export enum MultipleSearchContactsOriginEnum {
  Ankorstore = 'ankorstore',
  Imported = 'imported',
}

/** The contact's ordering activity signal. */
export enum MultipleSearchContactsActivitySignalEnum {
  High = 'high',
  Low = 'low',
  Inactive = 'inactive',
}

/** Who's the sender of the last sent message. */
export enum MultipleSearchContactsLastMessageByEnum {
  Retailer = 'retailer',
  Brand = 'brand',
}

/**
 * Indicates the level of consent this contact has given
 * to receive email marketing campaigns.
 *
 * - **Subscribed** — A subscribed contact, or subscriber,
 * is someone who has opted in to receive marketing messages.
 *
 * - **Unsubscribed** — An unsubscribed contact is someone who
 * previously received marketing messages but has opted out.
 *
 * - **Suppressed** — A suppressed contact is someone who is
 * on the suppression list and thus is excluded from receiving
 * marketing messages. Contacts may be added to the suppression
 * list for various reasons, including if they have complained
 * about receiving emails (they marked emails as spam)
 * or if their email address bounced or is invalid.
 */
export enum MultipleSearchContactsSubscriptionStatusEnum {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
  Suppressed = 'suppressed',
}

export enum MultipleSearchContactsTypeEnum4 {
  SearchParams = 'search-params',
}

/**
 * The type of filter.
 *
 * This filter returns results that contain a specific attribute value.<br/>
 * Available on **text**, **number** or **date** attributes and supports arrays.
 */
export enum MultipleSearchContactsTypeEnum5 {
  Value = 'value',
}

/**
 * The type of filter.
 *
 * This filter returns results over a range of dates or numbers.<br/>
 * Available on **number** or **date** attributes.
 */
export enum MultipleSearchContactsTypeEnum6 {
  Range = 'range',
}

/** The type of filter. */
export enum MultipleSearchContactsTypeEnum7 {
  Boolean = 'boolean',
}

export enum MultipleSearchContactsSortEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export type MultipleSearchContactsData = {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** An array of search results, in the same order as the search queries. */
  data?: ({
    /** Array of results matching the search. */
    data: any[];
    meta: {
      page?: {
        /**
         * Number of results per page.
         * @min 1
         */
        size?: number;
        /**
         * Index of the current search result page.
         * @min 1
         */
        current?: number;
        /**
         * Total number of search result pages.
         * @min 0
         */
        totalPages?: number;
        /**
         * Total number of results.
         * @min 0
         */
        totalResults?: number;
      };
      /**
       * Contains the number of matching contacts distributed among
       * the values of a given facet. Each facet is represented as
       * an object.
       */
      facets?: Record<
        string,
        | {
            /**
             * Type of facet.
             *
             * A value facet provides the counts of each value for an attribute.
             * This type of facet is only available on **text**, **number** and **date** attributes.
             */
            type: MultipleSearchContactsTypeEnum;
            data: {
              /** A human-readable name for the value. */
              name?: string;
              /** The value of the attribute. */
              value: string | number;
              /**
               * The number of results for this value of the attribute.
               * @min 1
               */
              count: number;
            }[];
          }
        | {
            /**
             * Type of facet.
             *
             * A range facet returns counts of documents within the provided ranges.
             * This type of facet is only available on **number** and **date** attributes.
             */
            type: MultipleSearchContactsTypeEnum1;
            data: {
              /** Name given to the range. */
              name?: string;
              /**
               * Number of results within the range.
               * @min 1
               */
              count: number;
              /**
               * Inclusive lower bound of the range.
               * @format date-time
               */
              from?: number | string;
              /**
               * Exclusive upper bound of the range.
               * @format date-time
               */
              to?: number | string;
            }[];
          }
        | {
            /**
             * Type of facet.
             *
             * Stats (also called *aggregation* or *analytic*) facets compute stats over
             * numeric values extracted from the aggregated results. This type of facet
             * is only available on **number** attributes.
             */
            type: MultipleSearchContactsTypeEnum2;
            /** The lowest numerical value across all results. */
            min: number;
            /** The highest numerical value across all results. */
            max: number;
          }
      >;
    };
  } & {
    data?: {
      /**
       * A globally-unique identifier for the contact.
       * @format uuid
       * @example "1ef077c4-f8a1-6bc8-9ac6-4e29ff3d1748"
       */
      id: string;
      type: MultipleSearchContactsTypeEnum3;
      attributes: {
        /** Relationship details */
        relation: {
          /**
           * The date and time when the contact was added to the brand's network.
           * @format date-time
           */
          addedAt: string;
          /**
           * The date and time when the contact was invited to the brand's network (i.e.
           * when a referral invitation was sent to the contact's email address).
           * @format date-time
           */
          invitedAt?: null | string;
          /**
           * The date and time when the contact became affiliated with the brand.
           * Affiliation is confirmed when a retailer places a first order with the brand.
           * @format date-time
           */
          affiliatedAt?: null | string;
          /** Status of the relationship with this contact. */
          status: MultipleSearchContactsStatusEnum;
          /** Origin of the contact. */
          origin: MultipleSearchContactsOriginEnum;
        };
        /** Contact details */
        contact: {
          /** The contact's first name. */
          firstname?: string;
          /** The contact's last name. */
          lastname?: string;
          /**
           * The contact's primary email address.
           * @format email
           */
          email?: string;
          /** The contact's primary phone number. */
          phone?: string;
          /**
           * The contact's preferred language for communications
           * (represented as a 2-letter language code conforming to
           * [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag)).
           */
          language?: string;
          /** The contact's city. */
          city?: string;
          /** The contact's zip code. */
          zip?: string;
          /** The contact's country code. */
          country?: string;
        };
        /** Retailer details */
        retailer?: {
          /**
           * The globally-unique identifier of the retailer.
           * @format uuid
           */
          uuid?: string;
          /** The shop name. */
          name?: string;
          /**
           * The type of shop.
           * @example "pet_store"
           */
          shopType?: null | string;
          /**
           * The date and time when the retailer signed up for an account.
           * @format date-time
           */
          createdAt?: string;
          /** Contact details */
          contact?: {
            /** The retailer's first name. */
            firstname?: string;
            /** The retailer's last name. */
            lastname?: string;
            /**
             * The retailer's primary email address.
             * @format email
             */
            email?: string;
            /** The retailer's primary phone number. */
            phone?: string;
            /** The retailer's city. */
            city?: string;
            /** The retailer's zip code. */
            zip?: string;
            /** The retailer's country code. */
            country?: string;
          };
          /** Status of the Ankorstore+ subscription. */
          aksStatus?: {
            /** Whether this retailer has an active subscription to Ankorstore+ */
            active?: boolean;
            /** Whether this retailer is eligible for the Ankorstore+ offer. */
            eligible?: boolean;
          };
        };
        /** Commercial terms for this contact */
        commercialTerms?: {
          /**
           * The service fee invoiced for this contact's purchases.
           * @format float
           * @min 0
           */
          serviceFees?: number;
          /**
           * The personalised discount for this contact.
           * @format float
           * @min 0
           */
          brandDiscount?: number;
          /**
           * The discount the contact benefits from as part of the repeat offer.
           * @format float
           * @min 0
           */
          repeatOffer?: number;
          /** Whether a personalised brand discount is active for this contact. */
          hasBrandDiscount?: boolean;
          /** Whether a repeat offer is currently active for this contact. */
          hasRepeatOffer?: boolean;
          /**
           * The date and time until which the repeat offer remains unlocked.
           * @format date-time
           */
          repeatOfferUnlockedUntil?: null | string;
          /**
           * The remaining amount the contact must spend to unlock the repeat offer.
           * @format float
           * @min 0
           */
          amountToUnlockRepeatOffer?: null | number;
          /**
           * The date and time until which free shipping with the brand applies.
           * @format date-time
           */
          freeShippingForBrandUntil?: null | string;
          /** The tiered discount currently assigned to this contact, if any. */
          tieredDiscount?: {
            /** The identifier of the tiered discount. */
            id?: string;
            /** The name of the tiered discount. */
            name?: string;
            /**
             * The discount percentage granted by the tiered discount.
             * @format float
             * @min 0
             */
            percentage?: number;
          };
        };
        /** Order activity */
        ordering?: {
          /**
           * The date and time when last order was placed.
           * @format date-time
           */
          lastOrderedAt?: null | string;
          /**
           * The total amount of the last placed order.
           * @example {"currency":"EUR","amount":142}
           */
          lastOrderedAmount?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * The total number of completed orders for this contact.
           * @min 0
           */
          totalCompletedOrders?: number;
          /**
           * The total amount of completed orders for this contact.
           * @example {"currency":"EUR","amount":142}
           */
          totalSpent?: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /** Whether this contact is eligible for the referral offer. */
          liftEligible?: boolean;
          /**
           * The date and time when the first order was placed.
           * @format date-time
           */
          firstOrderedAt?: null | string;
          /**
           * The predicted date and time of the contact's next order.
           * @format date-time
           */
          expectedNextOrderAt?: null | string;
          /**
           * The date and time when the contact became disengaged.
           * @format date-time
           */
          disengagedAt?: null | string;
          /** The contact's ordering activity signal. */
          activitySignal?: MultipleSearchContactsActivitySignalEnum;
        };
        /** Prepared order activity */
        preparedOrders?: {
          /**
           * Total number of prepared orders for this contact.
           * @min 0
           */
          number: number;
        };
        /** Shopping activity */
        cart?: {
          /**
           * Order total for the shopping cart of this retailer.
           * @example {"currency":"EUR","amount":142}
           */
          amountInCart: {
            /**
             * ISO 3-Letter Currency Code
             * @example "EUR"
             */
            currency: string;
            /** Lowest denomination of the currency this amount belongs to. */
            amount: number;
          };
          /**
           * The date and time when the shopping cart was last updated.
           * @format date-time
           */
          cartUpdatedAt: string;
        };
        /** Communications with this contact */
        communication?: {
          /** Direct in-app messaging */
          messaging?: {
            /**
             * The date and time when the last message was sent.
             * @format date-time
             */
            lastContactedAt?: string;
            /** Who's the sender of the last sent message. */
            lastMessageBy?: MultipleSearchContactsLastMessageByEnum;
          };
          /** Emailing activity */
          emailing?: {
            /**
             * Indicates the level of consent this contact has given
             * to receive email marketing campaigns.
             *
             * - **Subscribed** — A subscribed contact, or subscriber,
             * is someone who has opted in to receive marketing messages.
             *
             * - **Unsubscribed** — An unsubscribed contact is someone who
             * previously received marketing messages but has opted out.
             *
             * - **Suppressed** — A suppressed contact is someone who is
             * on the suppression list and thus is excluded from receiving
             * marketing messages. Contacts may be added to the suppression
             * list for various reasons, including if they have complained
             * about receiving emails (they marked emails as spam)
             * or if their email address bounced or is invalid.
             */
            subscriptionStatus?: MultipleSearchContactsSubscriptionStatusEnum;
            /**
             * The date and time when the last email was sent.
             * @format date-time
             */
            lastContactedAt?: string;
            /** Whether the brand sent an email to the contact on the same calendar day. */
            contactedRecently?: boolean;
          };
        };
        /** The name of the QR campaign the contact originated from, if any. */
        qrCampaignName?: null | string;
        /** The identifier of the QR campaign source the contact originated from, if any. */
        qrCampaignSourceId?: null | string;
      };
    }[];
  })[];
};

export enum GetSearchFiltersTypeEnum {
  Widget = 'widget',
}

/**
 * The `Range` widget allows a user to select a numeric range
 * using a minimum and maximum input.
 */
export enum GetSearchFiltersTypeEnum1 {
  RangeWidget = 'range-widget',
}

export enum GetSearchFiltersTypeEnum2 {
  Widget = 'widget',
}

/**
 * The `Toggle` widget provides an on/off filtering feature
 * based on an attribute value.
 */
export enum GetSearchFiltersTypeEnum3 {
  ToggleWidget = 'toggle-widget',
}

export enum GetSearchFiltersTypeEnum4 {
  Widget = 'widget',
}

/**
 * The `Dropdown` widget allows a user to select values upon which
 * to filter inside a dropdown element.
 */
export enum GetSearchFiltersTypeEnum5 {
  DropdownWidget = 'dropdown-widget',
}

export enum GetSearchFiltersTypeEnum6 {
  Widget = 'widget',
}

/**
 * The `List` widget displays a menu that lets users choose one
 * or multiple values for a specific attribute.
 */
export enum GetSearchFiltersTypeEnum7 {
  ListWidget = 'list-widget',
}

export enum GetSearchFiltersTypeEnum8 {
  Widget = 'widget',
}

/**
 * The `DateRange` widget allows a user to select a date range
 * using a start and end date input.
 */
export enum GetSearchFiltersTypeEnum9 {
  DateRangeWidget = 'date-range-widget',
}

export interface GetSearchFiltersData {
  /** List of available filters. */
  data: (
    | {
        type: GetSearchFiltersTypeEnum;
        attributes: {
          /**
           * The `Range` widget allows a user to select a numeric range
           * using a minimum and maximum input.
           */
          type?: GetSearchFiltersTypeEnum1;
          /** The name of the attribute upon which to apply the filter. */
          attributeName?: string;
          minLabel?: string;
          maxLabel?: string;
          separatorLabel?: string;
          icon?: string;
          /** WidgetValue */
          values?: {
            value: string;
            label: string;
            icon?: string;
          }[];
        };
      }
    | {
        type: GetSearchFiltersTypeEnum2;
        attributes: {
          /**
           * The `Toggle` widget provides an on/off filtering feature
           * based on an attribute value.
           */
          type?: GetSearchFiltersTypeEnum3;
          /** The name of the attribute upon which to apply the filter. */
          attributeName?: string;
          label?: string;
          icon?: string;
          /** WidgetValue */
          values?: {
            value: string;
            label: string;
            icon?: string;
          }[];
        };
      }
    | {
        type: GetSearchFiltersTypeEnum4;
        attributes: {
          /**
           * The `Dropdown` widget allows a user to select values upon which
           * to filter inside a dropdown element.
           */
          type?: GetSearchFiltersTypeEnum5;
          /** The name of the attribute upon which to apply the filter. */
          attributeName?: string;
          /**
           * Allow the multiple selection.
           * @default true
           */
          multiple?: boolean;
          label?: string;
          icon?: string;
          placeholder?: string;
          /** WidgetValue */
          values?: {
            value: string;
            label: string;
            icon?: string;
          }[];
        };
      }
    | {
        type: GetSearchFiltersTypeEnum6;
        attributes: {
          /**
           * The `List` widget displays a menu that lets users choose one
           * or multiple values for a specific attribute.
           */
          type?: GetSearchFiltersTypeEnum7;
          /** The name of the attribute upon which to apply the filter. */
          attributeName?: string;
          /**
           * Allow the multiple selection.
           * @default true
           */
          multiple?: boolean;
          label?: string;
          icon?: string;
          /** WidgetValue */
          values?: {
            value: string;
            label: string;
            icon?: string;
          }[];
        };
      }
    | {
        type: GetSearchFiltersTypeEnum8;
        attributes: {
          /**
           * The `DateRange` widget allows a user to select a date range
           * using a start and end date input.
           */
          type?: GetSearchFiltersTypeEnum9;
          /** The name of the attribute upon which to apply the filter. */
          attributeName?: string;
          /** WidgetValue */
          values?: {
            from?: string;
            to?: string;
            label: string;
            icon?: string;
          }[];
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum ApplyPersonalisedDiscountTypeEnum {
  PersonalisedDiscountBulkRequest = 'personalised-discount-bulk-request',
}

export interface ApplyPersonalisedDiscountData {
  meta?: {
    /**
     * Number of contacts who were applied the personalised discount.
     * @min 0
     */
    affectedContacts?: number;
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface ListPromocodeDiscoveryRelationshipsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta?: {
    promocode?: {
      code?: string;
      /** @format datetime */
      expired_at?: string;
      percentage?: string;
    };
    [key: string]: any;
  };
  data: {
    type?: 'promocode-discovery-relationships';
    id?: string;
    attributes?: {
      brand_id: number;
      brand_link: string;
      brand_name: string;
      brand_logo: string;
      brand_image: string;
      brand_product_count: string;
      already_used: boolean;
    };
  }[];
}

export interface DisplayDiscoveryBrandAndPromocodeForFirstCheckoutData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta?: {
    promocode?: {
      title: string;
      description: string;
      action_type: string;
      action_label: string;
      feedback: string;
    };
    [key: string]: any;
  };
  data: {
    type?: 'promocode-first-checkout';
    id?: string;
    attributes?: {
      brand_id: number;
      brand_link: string;
      brand_name: string;
      brand_logo: string;
      brand_image: string;
      brand_product_count: string;
    };
  }[];
}

export interface GetPromocodeLiftAmountAvailableData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    id: string;
    type: string;
    attributes: {
      amount?: number;
      currency?: string;
    };
  } | null;
}

/** The offer type */
export enum GetBrandOffersTypeEnum {
  Discount = 'discount',
  Promocode = 'promocode',
}

export interface GetBrandOffersParams {
  /**
   * List of brand UUIDs to retrieve offers for
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  'filter[brandUuids]'?: string[];
}

export interface GetBrandOffersData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    id: string;
    /** @example "brand/offers" */
    type: string;
    attributes: {
      /**
       * The brand UUID this offer applies to
       * @format uuid
       */
      brandUuid?: string;
      /** The offer type */
      type?: GetBrandOffersTypeEnum;
      /** The offer name */
      name?: string;
      /** The discount percentage, if applicable */
      percentage?: number | null;
    };
  }[];
}

export enum GetConnectedHomepageConfigurationSegmentSlugEnum {
  AksplusEligibleNonMembers = 'aksplus-eligible-non-members',
  AksplusEligibleMembers = 'aksplus-eligible-members',
  NewRetailers = 'new-retailers',
  Default = 'default',
}

export interface GetConnectedHomepageConfigurationData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: 'connected-homepage-configuration';
    id: string;
    attributes: {
      segment_slug: GetConnectedHomepageConfigurationSegmentSlugEnum;
      components: {
        name: string;
        parameters?: object[];
      }[];
    };
  } | null;
}

export interface GetConnectedHomepageRecommendationsParams {
  /** type */
  'type-id': number;
}

export interface GetConnectedHomepageRecommendationsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta: {
    type?: string;
    [key: string]: any;
  };
  data: {
    type?: 'connected-homepage-recommendations';
    id?: string;
    attributes?: {
      brand_id: number;
      brand_link: string;
      brand_name: string;
      brand_logo: string;
      brand_images: {
        src?: string;
      }[];
      brand_is_new: boolean;
      brand_discount: number;
    };
  }[];
}

export interface GetBrandCardListParams {
  carouselSelectionType: CarouselSelectionTypeEnum;
}

export enum CarouselSelectionTypeEnum {
  DiscoveryBrand = 'discovery-brand',
  ReorderBrand = 'reorder-brand',
}

export interface GetBrandCardListData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: string;
    id: string;
    attributes: {
      brand_id: number;
      brand_link: string;
      brand_name: string;
      brand_logo: string;
      brand_is_new: boolean;
      brand_discount: number;
      brand_images: {
        src: string;
      }[];
      brand_total_products_count?: number;
      brand_has_new_products?: boolean;
      is_first_order?: boolean;
      last_order_on?: string;
    };
  }[];
}

export enum GetBrandCardListParams1CarouselSelectionTypeEnum {
  DiscoveryBrand = 'discovery-brand',
  ReorderBrand = 'reorder-brand',
}

/**
 * Whether a retailer can order the variant backing this
 * option for which stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetProductCardListInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which
 * stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetProductCardListInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

export interface GetProductCardListParams {
  brandId: number;
  carouselSelectionType: CarouselSelectionTypeEnum1;
}

export enum CarouselSelectionTypeEnum1 {
  DiscoveryBrand = 'discovery-brand',
  ReorderBrand = 'reorder-brand',
}

export interface GetProductCardListData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: string;
    id: string;
    attributes: {
      uuid: string;
      id: number;
      retail_price: {
        currency?: string;
        amount?: number;
      };
      retail_prices: {
        EUR?: number;
        GBP?: number;
        SEK?: number;
      };
      wholesale_price: {
        currency?: string;
        amount?: number;
      };
      original_wholesale_price: {
        currency?: string;
        amount?: number;
      };
      discount_rate: number;
      discount_type: string;
      is_discounted: boolean;
      unit_multiplier: number;
      link: string;
      name: string;
      out_of_stock: boolean;
      is_new: boolean;
      brand: {
        id?: number;
        name?: string;
        brandLocation?: {
          lon?: number;
          lat?: number;
        };
        link?: string;
        minimum?: number;
        country_code?: string;
        segment?: string;
        country?: object;
        opened_countries?: string[];
        images?: {
          squared?: string;
          rounded?: string;
          large?: string;
        };
        business_events?: object;
        business_events_eligible?: number[];
        business_events_rankings?: object;
        location?: string[];
        shipping_lead_time?: string[];
        brand_tags?: string[];
        synonyms?: string[];
        aks_plus?: string[];
      };
      options: {
        id?: number;
        variation?: string | null;
        ian?: string;
        sku?: string;
        out_of_stock?: boolean;
        stock?: {
          id?: number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as
           *
           *
           *   much of this variant as they want, with no restriction
           *   at all.
           * - `false`: stock is tracked — whether a retailer can order
           *
           *
           *   the variant depends on the available stock quantity and
           *   the `inventory_policy`.
           */
          is_always_in_stock?: boolean;
          /**
           * Whether a retailer can order the variant backing this
           * option for which stock is not available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity
           *
           *
           *   larger than the currently available stock quantity, so
           *   the variant cannot be ordered when it is out of stock, or
           *   when the desired quantity exceeds the available quantity.
           * - `continue`: yes. The retailer can order any quantity,
           *
           *
           *   even when stock is insufficient (desired quantity >
           *   available quantity > 0) or the variant is out of stock
           *   (available quantity <= 0).
           *
           * Only meaningful when stock is tracked
           * (`is_always_in_stock = false`).
           * @default "deny"
           */
          inventory_policy?: GetProductCardListInventoryPolicyEnum;
          available_quantity?: number | null;
          /**
           * Product-scoped stock status, derived from the currently
           * available stock, `is_always_in_stock` and
           * `inventory_policy`.
           *
           * - `out_of_stock`: there is no stock available to order,
           *
           *
           *   i.e. stock is tracked (`is_always_in_stock=false`), the
           *   `inventory_policy` is `deny`, and the available quantity
           *   is <= 0.
           * - `low_in_stock`: there is little stock left to order, i.e.
           *
           *
           *   stock is tracked (`is_always_in_stock=false`) and stock
           *   is low (available quantity <= 10, or available quantity
           *   < 10% of the on-hand quantity).
           * - `in_stock`: there is plenty of stock to order (every
           *
           *
           *   other case).
           */
          status?: string;
        };
      }[];
      variants: {
        id?: number;
        uuid?: string;
        sku?: string;
        ian?: string;
        out_of_stock?: boolean;
        retail_prices?: {
          EUR?: number;
          GBP?: number;
          SEK?: number;
        };
        retail_price?: {
          currency?: string;
          amount?: number;
        };
        wholesale_price?: {
          currency?: string;
          amount?: number;
        };
        stock?: {
          id?: number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as
           *
           *
           *   much of this variant as they want, with no restriction
           *   at all.
           * - `false`: stock is tracked — whether a retailer can order
           *
           *
           *   the variant depends on the available stock quantity and
           *   the `inventory_policy`.
           */
          is_always_in_stock?: boolean;
          /**
           * Whether a retailer can order a product variant for which
           * stock is not available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity
           *
           *
           *   larger than the currently available stock quantity, so
           *   the variant cannot be ordered when it is out of stock, or
           *   when the desired quantity exceeds the available quantity.
           * - `continue`: yes. The retailer can order any quantity,
           *
           *
           *   even when stock is insufficient (desired quantity >
           *   available quantity > 0) or the variant is out of stock
           *   (available quantity <= 0).
           *
           * Only meaningful when stock is tracked
           * (`is_always_in_stock = false`).
           * @default "deny"
           */
          inventory_policy?: GetProductCardListInventoryPolicyEnum1;
          available_quantity?: number | null;
          /**
           * Product-scoped stock status, derived from the currently
           * available stock, `is_always_in_stock` and
           * `inventory_policy`.
           *
           * - `out_of_stock`: there is no stock available to order,
           *
           *
           *   i.e. stock is tracked (`is_always_in_stock=false`), the
           *   `inventory_policy` is `deny`, and the available quantity
           *   is <= 0.
           * - `low_in_stock`: there is little stock left to order, i.e.
           *
           *
           *   stock is tracked (`is_always_in_stock=false`) and stock
           *   is low (available quantity <= 10, or available quantity
           *   < 10% of the on-hand quantity).
           * - `in_stock`: there is plenty of stock to order (every
           *
           *
           *   other case).
           */
          status?: string;
        };
        options?: object[];
      }[];
      images: string[];
      discount_event_price?: {
        currency?: string | null;
        amount?: number | null;
      };
    };
  }[];
}

export enum GetProductCardListParams1CarouselSelectionTypeEnum {
  DiscoveryBrand = 'discovery-brand',
  ReorderBrand = 'reorder-brand',
}

export enum GetCarouselCarouselTypeEnum {
  Brands = 'brands',
  Products = 'products',
  Collections = 'collections',
}

export enum GetCarouselHighlightedCardTypeEnum {
  Brand = 'brand',
  Collection = 'collection',
}

export enum GetCarouselCollectionTypeEnum {
  Product = 'product',
  Brand = 'brand',
}

/**
 * Whether a retailer can order the variant backing this
 * option for which stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetCarouselInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which
 * stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetCarouselInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

export enum GetCarouselCollectionTypeEnum1 {
  Product = 'product',
  Brand = 'brand',
}

export interface GetCarouselParams {
  brandId?: number;
  /** Carousel uuid */
  carouselUuid: string;
}

export interface GetCarouselData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    id: string;
    type: string;
    attributes: {
      /** Human-readable identifier for tracking purposes */
      slug?: string | null;
      /** Recommendation algorithm type ID used as id_algo for tracking */
      recommendation_type_id?: number | null;
      title: string | null;
      subtitle: string | null;
      cta_label: string | null;
      cta_link: string | null;
      carousel_type: GetCarouselCarouselTypeEnum;
      display_options: {
        with_reorder_tile?: boolean | null;
        background_color?: boolean | null;
        with_aks_plus_badge?: boolean | null;
      };
      highlighted_card_type: GetCarouselHighlightedCardTypeEnum;
      highlighted_card:
        | {
            collection_uuid: string;
            collection_link: string;
            collection_name: string;
            collection_image: string;
            collection_count: number;
            collection_type: GetCarouselCollectionTypeEnum;
          }
        | {
            brand_id: number;
            brand_link: string;
            brand_name: string;
            brand_logo: string;
            brand_is_new: boolean;
            brand_discount: number;
            brand_images: {
              src: string;
            }[];
            brand_total_products_count?: number;
            brand_has_new_products?: boolean;
            is_first_order?: boolean;
            last_order_on?: string;
          }
        | null;
    };
  };
  included?: (
    | {
        type: string;
        id: string;
        attributes: {
          brand_id: number;
          brand_link: string;
          brand_name: string;
          brand_logo: string;
          brand_is_new: boolean;
          brand_discount: number;
          brand_images: {
            src: string;
          }[];
          brand_total_products_count?: number;
          brand_has_new_products?: boolean;
          is_first_order?: boolean;
          last_order_on?: string;
        };
      }
    | {
        type: string;
        id: string;
        attributes: {
          uuid: string;
          id: number;
          retail_price: {
            currency?: string;
            amount?: number;
          };
          retail_prices: {
            EUR?: number;
            GBP?: number;
            SEK?: number;
          };
          wholesale_price: {
            currency?: string;
            amount?: number;
          };
          original_wholesale_price: {
            currency?: string;
            amount?: number;
          };
          discount_rate: number;
          discount_type: string;
          is_discounted: boolean;
          unit_multiplier: number;
          link: string;
          name: string;
          out_of_stock: boolean;
          is_new: boolean;
          brand: {
            id?: number;
            name?: string;
            brandLocation?: {
              lon?: number;
              lat?: number;
            };
            link?: string;
            minimum?: number;
            country_code?: string;
            segment?: string;
            country?: object;
            opened_countries?: string[];
            images?: {
              squared?: string;
              rounded?: string;
              large?: string;
            };
            business_events?: object;
            business_events_eligible?: number[];
            business_events_rankings?: object;
            location?: string[];
            shipping_lead_time?: string[];
            brand_tags?: string[];
            synonyms?: string[];
            aks_plus?: string[];
          };
          options: {
            id?: number;
            variation?: string | null;
            ian?: string;
            sku?: string;
            out_of_stock?: boolean;
            stock?: {
              id?: number;
              /**
               * Whether stock is tracked at all for this product variant.
               *
               * - `true`: stock is not tracked — a retailer can order as
               *
               *
               *   much of this variant as they want, with no restriction
               *   at all.
               * - `false`: stock is tracked — whether a retailer can order
               *
               *
               *   the variant depends on the available stock quantity and
               *   the `inventory_policy`.
               */
              is_always_in_stock?: boolean;
              /**
               * Whether a retailer can order the variant backing this
               * option for which stock is not available.
               *
               * - `deny` (default): no. A retailer cannot order a quantity
               *
               *
               *   larger than the currently available stock quantity, so
               *   the variant cannot be ordered when it is out of stock, or
               *   when the desired quantity exceeds the available quantity.
               * - `continue`: yes. The retailer can order any quantity,
               *
               *
               *   even when stock is insufficient (desired quantity >
               *   available quantity > 0) or the variant is out of stock
               *   (available quantity <= 0).
               *
               * Only meaningful when stock is tracked
               * (`is_always_in_stock = false`).
               * @default "deny"
               */
              inventory_policy?: GetCarouselInventoryPolicyEnum;
              available_quantity?: number | null;
              /**
               * Product-scoped stock status, derived from the currently
               * available stock, `is_always_in_stock` and
               * `inventory_policy`.
               *
               * - `out_of_stock`: there is no stock available to order,
               *
               *
               *   i.e. stock is tracked (`is_always_in_stock=false`), the
               *   `inventory_policy` is `deny`, and the available quantity
               *   is <= 0.
               * - `low_in_stock`: there is little stock left to order, i.e.
               *
               *
               *   stock is tracked (`is_always_in_stock=false`) and stock
               *   is low (available quantity <= 10, or available quantity
               *   < 10% of the on-hand quantity).
               * - `in_stock`: there is plenty of stock to order (every
               *
               *
               *   other case).
               */
              status?: string;
            };
          }[];
          variants: {
            id?: number;
            uuid?: string;
            sku?: string;
            ian?: string;
            out_of_stock?: boolean;
            retail_prices?: {
              EUR?: number;
              GBP?: number;
              SEK?: number;
            };
            retail_price?: {
              currency?: string;
              amount?: number;
            };
            wholesale_price?: {
              currency?: string;
              amount?: number;
            };
            stock?: {
              id?: number;
              /**
               * Whether stock is tracked at all for this product variant.
               *
               * - `true`: stock is not tracked — a retailer can order as
               *
               *
               *   much of this variant as they want, with no restriction
               *   at all.
               * - `false`: stock is tracked — whether a retailer can order
               *
               *
               *   the variant depends on the available stock quantity and
               *   the `inventory_policy`.
               */
              is_always_in_stock?: boolean;
              /**
               * Whether a retailer can order a product variant for which
               * stock is not available.
               *
               * - `deny` (default): no. A retailer cannot order a quantity
               *
               *
               *   larger than the currently available stock quantity, so
               *   the variant cannot be ordered when it is out of stock, or
               *   when the desired quantity exceeds the available quantity.
               * - `continue`: yes. The retailer can order any quantity,
               *
               *
               *   even when stock is insufficient (desired quantity >
               *   available quantity > 0) or the variant is out of stock
               *   (available quantity <= 0).
               *
               * Only meaningful when stock is tracked
               * (`is_always_in_stock = false`).
               * @default "deny"
               */
              inventory_policy?: GetCarouselInventoryPolicyEnum1;
              available_quantity?: number | null;
              /**
               * Product-scoped stock status, derived from the currently
               * available stock, `is_always_in_stock` and
               * `inventory_policy`.
               *
               * - `out_of_stock`: there is no stock available to order,
               *
               *
               *   i.e. stock is tracked (`is_always_in_stock=false`), the
               *   `inventory_policy` is `deny`, and the available quantity
               *   is <= 0.
               * - `low_in_stock`: there is little stock left to order, i.e.
               *
               *
               *   stock is tracked (`is_always_in_stock=false`) and stock
               *   is low (available quantity <= 10, or available quantity
               *   < 10% of the on-hand quantity).
               * - `in_stock`: there is plenty of stock to order (every
               *
               *
               *   other case).
               */
              status?: string;
            };
            options?: object[];
          }[];
          images: string[];
          discount_event_price?: {
            currency?: string | null;
            amount?: number | null;
          };
        };
      }
    | {
        type: string;
        id: string;
        attributes: {
          collection_uuid: string;
          collection_link: string;
          collection_name: string;
          collection_image: string;
          collection_count: number;
          collection_type: GetCarouselCollectionTypeEnum1;
        };
      }
  )[];
}

export interface GetUnconnectedFooterData {
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    type: string;
    id: string;
    attributes: {
      branding?: {
        title?: string;
        elements?: {
          url?: string;
          link?: string;
          alt?: string;
          title?: string;
        }[];
      };
      links?: {
        title?: string;
        elements?: {
          title?: string;
          url?: string;
        }[];
      }[];
      payments?: {
        svg?: string;
      }[];
      legals?: {
        title?: string;
        url?: string;
        javascript?: string;
      }[];
      socials?: {
        link?: string;
        icon?: string;
        svg?: string;
      }[];
      copyright?: string;
    };
  };
}

export enum GetBrandListStatusEnum {
  Unlocked = 'unlocked',
  Locked = 'locked',
  Unlocking = 'unlocking',
  NotStarted = 'not-started',
}

export interface GetBrandListData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta: {
    threshold_amount: string;
    total_unlocked_brands: number;
    total_locked_brands: number;
    total_started_unlocking_brands: number;
    total_brands: number;
    locked_brands_cta_link: string | null;
    unlocked_brands_cta_link: string | null;
    started_unlocking_brands_cta_link: string | null;
    [key: string]: any;
  };
  data: {
    type: 'brand-list';
    id: string;
    attributes: {
      brand_id: number;
      brand_link: string;
      brand_name: string;
      brand_logo: string;
      brand_images: {
        src: string;
      }[];
      repeat_offer: {
        status: GetBrandListStatusEnum;
        current: {
          /** @format datetime */
          start_date: string | null;
          /** @format datetime */
          end_date: string;
          percentage: number;
          unlocked: boolean;
        };
        next?: {
          /** @format datetime */
          start_date: string;
          /** @format datetime */
          end_date: string;
          percentage: number;
          unlocked: boolean;
        };
        progress_bar: {
          title: string | null;
          amount_to_unlock: string;
          amount_spent: string;
          progress: number;
          subtitle: string;
          eligible_for_next: boolean;
        };
      };
    };
  }[];
}

export interface GetBrandDiscountData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** LoyaltyOfferBrandDiscountResource */
  data: {
    type?: 'brand-discount';
    id?: string;
    attributes?: {
      brand_id: number;
      discount: number;
      /** @format date-time */
      start_date: string;
      /** @format date-time */
      created_at: string;
    };
  };
}

export enum RenderCatalogAttributesAndFacetsContextEnum {
  Default = 'default',
  Brand = 'brand',
  CategoryBrands = 'category_brands',
  CategoryProducts = 'category_products',
  CollectionBrands = 'collection_brands',
  CollectionProducts = 'collection_products',
  NewBrands = 'new_brands',
  NewProducts = 'new_products',
  PreorderBrands = 'preorder_brands',
  PreorderProducts = 'preorder_products',
  Search = 'search',
  Wholesale = 'wholesale',
}

export interface RenderCatalogAttributesAndFacetsData {
  data: {
    slug?: string;
    name?: string;
    type?: 'catalog_facet';
    catalog_facet?: {
      message?: string;
      tracking_name?: string;
      is_quick_filter?: boolean;
      searchable?: boolean;
      placeholder?: string;
      facet_type?: string;
      badge_type?: string | null;
      is_open?: boolean;
    };
    /** Custom value-label mapping */
    choices?: Record<string, any>;
  }[];
}

export interface GetCategoryAttributesParams {
  lang?: string;
  /** Category ID */
  categoryId: number;
}

export type GetCategoryAttributesData = {
  slug?: string;
  name?: string;
  description?: string;
  type?: string;
  unit?: string | null;
  isMultiValued?: boolean;
  isFilterable?: boolean;
  hasChoices?: boolean;
  /** Custom value-label mapping */
  choices?: Record<string, any>;
  /** Children attributes are not documented to prevent circular reference */
  attributes?: object[];
}[];

export interface GetProductAttributesParams {
  lang?: string;
  /** Product ID */
  productId: number;
}

export type GetProductAttributesData = {
  slug?: string;
  name?: string;
  description?: string;
  type?: string;
  unit?: string | null;
  isMultiValued?: boolean;
  isFilterable?: boolean;
  hasChoices?: boolean;
  /** Custom value-label mapping */
  choices?: Record<string, any>;
  /** Children attributes are not documented to prevent circular reference */
  attributes?: object[];
}[];

/**
 * The status of the credit limit information
 * @example "ok"
 */
export enum GetCmsHeaderPillsStatusEnum {
  Ok = 'ok',
  Incomplete = 'incomplete',
  Frozen = 'frozen',
  Refused = 'refused',
}

export interface GetCmsHeaderPillsData {
  /**
   * HeaderPillsResource
   * Header pills resource containing promotional information for the retailer
   */
  data: {
    /** Resource type identifier */
    type: 'header-pills';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /**
     * HeaderPillsAttributes
     * Attributes for header pills. All properties are conditionally included
     * and only present when their value is not null.
     */
    attributes: {
      /**
       * Indicates whether the retailer has opted into Ankorstore Plus.
       * - `true`: Retailer is opted-in to Ankorstore Plus
       * - `false`: Retailer is not opted-in to Ankorstore Plus
       * Only present when the status is available for this retailer.
       */
      ankorstore_plus_opt_in?: boolean | null;
      /**
       * Pill
       * Promocode pill information for the retailer, only present when available.
       */
      pill?: {
        /**
         * The pill display title
         * @example "10% off your first order"
         */
        title: string;
        /**
         * The pill description text
         * @example "Use this code at checkout"
         */
        description: string;
        /**
         * The type of action associated with the pill
         * @example "copy"
         */
        action_type: string;
        /**
         * The label for the pill action button
         * @example "Copy code"
         */
        action_label: string;
        /**
         * The feedback message shown after the action is performed
         * @example "Code copied!"
         */
        feedback: string;
      };
      /**
       * CreditLimit
       * Credit limit information for the retailer, only present when available.
       */
      credit_limit?: {
        /**
         * The credit limit amount in the lowest denomination of the currency (cents)
         * @example 200000
         */
        amount: number;
        /**
         * ISO 3-letter currency code
         * @example "EUR"
         */
        currency: string;
        /**
         * Name of the payment service provider (PSP) offering the credit limit
         * @example "Aria"
         */
        pspName: string;
        /**
         * The status of the credit limit information
         * @example "ok"
         */
        status: GetCmsHeaderPillsStatusEnum;
        /**
         * Amount required to unfreeze the credit limit, in the lowest denomination of the currency (cents). Null when the credit limit is not frozen.
         * @example 5000
         */
        unpaidTotalAmount: number | null;
        /**
         * Currency code of the unpaid total amount (ISO 4217). Null when the credit limit is not frozen.
         * @example "EUR"
         */
        unpaidTotalCurrency: string | null;
        /**
         * List of reasons why the credit limit was refused. Null when the credit limit is not refused. Possible values include `LEGAL_INFORMATION_PROTECTED`, `DEBTOR_NOT_FOUND`, `DEBTOR_CLOSED`, `DEBTOR_NOT_FOUND_OR_CLOSED`, `KYC_PENDING`, `KYC_IN_REVIEW`.
         * @example null
         */
        refusalReasons: any[] | null;
        /**
         * Number of credit providers with available credit for this retailer. When greater than 1, the pill shows the highest available amount with a multi-provider tooltip.
         * @example 1
         */
        activeProviderCount?: number;
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetBannerAksPlusStatusEnum {
  Member = 'member',
  Eligible = 'eligible',
  NotEligible = 'not_eligible',
}

export enum GetBannerCarouselTypeEnum {
  Brands = 'brands',
  Products = 'products',
  Collections = 'collections',
}

/**
 * Whether a retailer can order the variant backing this
 * option for which stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetBannerInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order a product variant for which
 * stock is not available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity
 *
 *
 *   larger than the currently available stock quantity, so
 *   the variant cannot be ordered when it is out of stock, or
 *   when the desired quantity exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity,
 *
 *
 *   even when stock is insufficient (desired quantity >
 *   available quantity > 0) or the variant is out of stock
 *   (available quantity <= 0).
 *
 * Only meaningful when stock is tracked
 * (`is_always_in_stock = false`).
 * @default "deny"
 */
export enum GetBannerInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

export enum GetBannerCollectionTypeEnum {
  Product = 'product',
  Brand = 'brand',
}

export interface GetBannerParams {
  /** Banner slug */
  'banner-slug': string;
}

export interface GetBannerData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  meta?: {
    aks_plus_status: GetBannerAksPlusStatusEnum;
    [key: string]: any;
  };
  data: {
    id: string;
    type: string;
    attributes: {
      offer?: {
        /** @format date-time */
        end_date?: string;
      };
      banner?: {
        title?: string | null;
        subtitle?: string | null;
        cta_label?: string | null;
        cta_link?: string | null;
        background_image?: string | null;
        background_image_mobile?: string | null;
        foreground_image?: string | null;
        foreground_image_mobile?: string | null;
      };
      carousel_type?: GetBannerCarouselTypeEnum;
    };
    relationships?: {
      brands?: {
        data: {
          id: string;
          type: string;
        }[];
      };
    };
  };
  included?: (
    | {
        type: string;
        id: string;
        attributes: {
          brand_id: number;
          brand_link: string;
          brand_name: string;
          brand_logo: string;
          brand_is_new: boolean;
          brand_discount: number;
          brand_images: {
            src: string;
          }[];
          brand_total_products_count?: number;
          brand_has_new_products?: boolean;
          is_first_order?: boolean;
          last_order_on?: string;
        };
      }
    | {
        type: string;
        id: string;
        attributes: {
          uuid: string;
          id: number;
          retail_price: {
            currency?: string;
            amount?: number;
          };
          retail_prices: {
            EUR?: number;
            GBP?: number;
            SEK?: number;
          };
          wholesale_price: {
            currency?: string;
            amount?: number;
          };
          original_wholesale_price: {
            currency?: string;
            amount?: number;
          };
          discount_rate: number;
          discount_type: string;
          is_discounted: boolean;
          unit_multiplier: number;
          link: string;
          name: string;
          out_of_stock: boolean;
          is_new: boolean;
          brand: {
            id?: number;
            name?: string;
            brandLocation?: {
              lon?: number;
              lat?: number;
            };
            link?: string;
            minimum?: number;
            country_code?: string;
            segment?: string;
            country?: object;
            opened_countries?: string[];
            images?: {
              squared?: string;
              rounded?: string;
              large?: string;
            };
            business_events?: object;
            business_events_eligible?: number[];
            business_events_rankings?: object;
            location?: string[];
            shipping_lead_time?: string[];
            brand_tags?: string[];
            synonyms?: string[];
            aks_plus?: string[];
          };
          options: {
            id?: number;
            variation?: string | null;
            ian?: string;
            sku?: string;
            out_of_stock?: boolean;
            stock?: {
              id?: number;
              /**
               * Whether stock is tracked at all for this product variant.
               *
               * - `true`: stock is not tracked — a retailer can order as
               *
               *
               *   much of this variant as they want, with no restriction
               *   at all.
               * - `false`: stock is tracked — whether a retailer can order
               *
               *
               *   the variant depends on the available stock quantity and
               *   the `inventory_policy`.
               */
              is_always_in_stock?: boolean;
              /**
               * Whether a retailer can order the variant backing this
               * option for which stock is not available.
               *
               * - `deny` (default): no. A retailer cannot order a quantity
               *
               *
               *   larger than the currently available stock quantity, so
               *   the variant cannot be ordered when it is out of stock, or
               *   when the desired quantity exceeds the available quantity.
               * - `continue`: yes. The retailer can order any quantity,
               *
               *
               *   even when stock is insufficient (desired quantity >
               *   available quantity > 0) or the variant is out of stock
               *   (available quantity <= 0).
               *
               * Only meaningful when stock is tracked
               * (`is_always_in_stock = false`).
               * @default "deny"
               */
              inventory_policy?: GetBannerInventoryPolicyEnum;
              available_quantity?: number | null;
              /**
               * Product-scoped stock status, derived from the currently
               * available stock, `is_always_in_stock` and
               * `inventory_policy`.
               *
               * - `out_of_stock`: there is no stock available to order,
               *
               *
               *   i.e. stock is tracked (`is_always_in_stock=false`), the
               *   `inventory_policy` is `deny`, and the available quantity
               *   is <= 0.
               * - `low_in_stock`: there is little stock left to order, i.e.
               *
               *
               *   stock is tracked (`is_always_in_stock=false`) and stock
               *   is low (available quantity <= 10, or available quantity
               *   < 10% of the on-hand quantity).
               * - `in_stock`: there is plenty of stock to order (every
               *
               *
               *   other case).
               */
              status?: string;
            };
          }[];
          variants: {
            id?: number;
            uuid?: string;
            sku?: string;
            ian?: string;
            out_of_stock?: boolean;
            retail_prices?: {
              EUR?: number;
              GBP?: number;
              SEK?: number;
            };
            retail_price?: {
              currency?: string;
              amount?: number;
            };
            wholesale_price?: {
              currency?: string;
              amount?: number;
            };
            stock?: {
              id?: number;
              /**
               * Whether stock is tracked at all for this product variant.
               *
               * - `true`: stock is not tracked — a retailer can order as
               *
               *
               *   much of this variant as they want, with no restriction
               *   at all.
               * - `false`: stock is tracked — whether a retailer can order
               *
               *
               *   the variant depends on the available stock quantity and
               *   the `inventory_policy`.
               */
              is_always_in_stock?: boolean;
              /**
               * Whether a retailer can order a product variant for which
               * stock is not available.
               *
               * - `deny` (default): no. A retailer cannot order a quantity
               *
               *
               *   larger than the currently available stock quantity, so
               *   the variant cannot be ordered when it is out of stock, or
               *   when the desired quantity exceeds the available quantity.
               * - `continue`: yes. The retailer can order any quantity,
               *
               *
               *   even when stock is insufficient (desired quantity >
               *   available quantity > 0) or the variant is out of stock
               *   (available quantity <= 0).
               *
               * Only meaningful when stock is tracked
               * (`is_always_in_stock = false`).
               * @default "deny"
               */
              inventory_policy?: GetBannerInventoryPolicyEnum1;
              available_quantity?: number | null;
              /**
               * Product-scoped stock status, derived from the currently
               * available stock, `is_always_in_stock` and
               * `inventory_policy`.
               *
               * - `out_of_stock`: there is no stock available to order,
               *
               *
               *   i.e. stock is tracked (`is_always_in_stock=false`), the
               *   `inventory_policy` is `deny`, and the available quantity
               *   is <= 0.
               * - `low_in_stock`: there is little stock left to order, i.e.
               *
               *
               *   stock is tracked (`is_always_in_stock=false`) and stock
               *   is low (available quantity <= 10, or available quantity
               *   < 10% of the on-hand quantity).
               * - `in_stock`: there is plenty of stock to order (every
               *
               *
               *   other case).
               */
              status?: string;
            };
            options?: object[];
          }[];
          images: string[];
          discount_event_price?: {
            currency?: string | null;
            amount?: number | null;
          };
        };
      }
    | {
        type: string;
        id: string;
        attributes: {
          collection_uuid: string;
          collection_link: string;
          collection_name: string;
          collection_image: string;
          collection_count: number;
          collection_type: GetBannerCollectionTypeEnum;
        };
      }
  )[];
}

export enum GetToplineBannerTypeEnum {
  ToplineBanner = 'topline-banner',
}

export interface GetToplineBannerData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    type: GetToplineBannerTypeEnum;
    attributes: {
      /** Multilingual description text */
      description: {
        en?: string;
        fr?: string;
        de?: string;
        es?: string;
        it?: string;
      };
      /** Multilingual link URL */
      link_url?: {
        en?: string;
        fr?: string;
        de?: string;
        es?: string;
        it?: string;
      };
      /** Multilingual link label */
      link_label?: {
        en?: string;
        fr?: string;
        de?: string;
        es?: string;
        it?: string;
      };
      /**
       * Hex color for banner background
       * @example "#e8b1a1"
       */
      background_color: string;
      /**
       * Hex color for banner text
       * @example "#000000"
       */
      text_color: string;
    };
  };
}

export enum CmsArticlesStoreTypeEnum {
  Articles = 'articles',
}

export enum CmsArticlesStoreStatusEnum {
  Draft = 'draft',
}

export enum CmsArticlesStoreTypeEnum1 {
  Articles = 'articles',
}

export interface CmsArticlesStoreData {
  data: {
    type: CmsArticlesStoreTypeEnum;
    id: string;
    attributes: {
      slug?: string;
      status?: CmsArticlesStoreStatusEnum;
    };
  };
}

export enum CmsArticlesIndexTypeEnum {
  Articles = 'articles',
}

export enum CmsArticlesIndexStatusEnum {
  Published = 'published',
}

export interface CmsArticlesIndexParams {
  /**
   * The page of results to return.
   * @default 1
   */
  'page[number]'?: number;
  /**
   * The number of resources to return per page.
   * @default 15
   */
  'page[size]'?: number;
}

export interface CmsArticlesIndexData {
  data: {
    type: CmsArticlesIndexTypeEnum;
    /** Article UUID */
    id: string;
    attributes: {
      slug: string;
      status: CmsArticlesIndexStatusEnum;
      /**
       * Null for articles published before this field existed. Sorting is newest-published-first, so these sort last (nulls last).
       * @format date-time
       */
      publishedAt: string | null;
      /** Resolved to the current request locale, falling back to English */
      title: string;
      /** Resolved to the current request locale, falling back to English */
      body: string;
      /** Resolved to the current request locale, falling back to English */
      excerpt: string;
    };
  }[];
  meta: {
    page: {
      currentPage?: number;
      perPage?: number;
      lastPage?: number | null;
      total?: number | null;
      from?: number | null;
      to?: number | null;
    };
    [key: string]: any;
  };
}

/**
 * The contents of a CSV file.
 * @format binary
 */
export type ExportDraftsData = File;

export interface ListBrandsMinimumOrderValueSettingsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: 'minimum-order-value-settings';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      type: string;
      amount: number;
      currency: string;
    };
  }[];
}

export enum CreateBrandsMinimumOrderValueSettingsTypeEnum {
  MinimumOrderValueSettings = 'minimum-order-value-settings',
}

export enum CreateBrandsMinimumOrderValueSettingsTypeEnum1 {
  Reorder = 'reorder',
  Discovery = 'discovery',
}

export interface CreateBrandsMinimumOrderValueSettingsData {
  /** An object describing the server's implementation */
  jsonapi: {
    /** @example "1.0" */
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** MinimumOrderValueSettingsResource */
  data: {
    type: 'minimum-order-value-settings';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      type: string;
      amount: number;
      currency: string;
    };
  };
}

export enum IntegrationOnboardingDetectPlatformTypeEnum {
  PlatformDetection = 'platform-detection',
}

/** The detected platform, or `null` when no supported platform was detected. */
export enum IntegrationOnboardingDetectPlatformPlatformEnum {
  Woocommerce = 'woocommerce',
  Shopify = 'shopify',
}

export enum IntegrationOnboardingDetectPlatformTypeEnum1 {
  PlatformDetection = 'platform-detection',
}

export interface IntegrationOnboardingDetectPlatformData {
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
  };
  data: {
    type: IntegrationOnboardingDetectPlatformTypeEnum;
    /** Ephemeral identifier for this detection result. */
    id: string;
    attributes: {
      /** The detected platform, or `null` when no supported platform was detected. */
      platform: IntegrationOnboardingDetectPlatformPlatformEnum;
    };
  };
}

export enum IntegrationOnboardingStartImportTypeEnum {
  CatalogImport = 'catalog-import',
}

export enum IntegrationOnboardingStartImportPlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
}

export enum IntegrationOnboardingStartImportTypeEnum1 {
  CatalogImport = 'catalog-import',
}

/** The resolved platform to import from. */
export enum IntegrationOnboardingStartImportPlatformEnum1 {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
}

export interface IntegrationOnboardingStartImportData {
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
  };
  data: {
    type: IntegrationOnboardingStartImportTypeEnum;
    /** The import handle to poll for progress. */
    id: string;
    attributes: {
      platform: IntegrationOnboardingStartImportPlatformEnum;
      /** @example "requested" */
      status: string;
    };
  };
}

export enum IntegrationOnboardingImportStatusTypeEnum {
  CatalogImport = 'catalog-import',
}

/** The integration platform. */
export enum IntegrationOnboardingImportStatusPlatformEnum {
  Woocommerce = 'woocommerce',
  Shopify = 'shopify',
}

/** Normalized, platform-agnostic import status, so the client can render a consistent state regardless of platform. */
export enum IntegrationOnboardingImportStatusStatusEnum {
  Pending = 'pending',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export interface IntegrationOnboardingImportStatusParams {
  /**
   * Full https URL of the brand's store (the one passed to start). Optional: when omitted, the current integration is resolved server-side.
   * @format uri
   * @maxLength 2048
   */
  shopUrl?: string;
}

export interface IntegrationOnboardingImportStatusData {
  jsonapi?: {
    /** @example "1.0" */
    version?: string;
  };
  /** The `catalog-import` resource, or `null` when there is no current import to show for the brand/store. */
  data: {
    type: IntegrationOnboardingImportStatusTypeEnum;
    /** The store URL the import is being polled for. */
    id: string;
    /** The `platform` and the normalized `status`, plus the platform-specific import payload nested alongside. */
    attributes: {
      /** The integration platform. */
      platform: IntegrationOnboardingImportStatusPlatformEnum;
      /** Normalized, platform-agnostic import status, so the client can render a consistent state regardless of platform. */
      status: IntegrationOnboardingImportStatusStatusEnum;
      [key: string]: any;
    };
  } | null;
}

export enum ReportPriceIssueTypeEnum {
  PricingIssues = 'pricing-issues',
}

export enum ReportPriceIssueTypeEnum1 {
  PublicPriceReport = 'public_price_report',
  PrivatePriceReport = 'private_price_report',
}

/** The kind of source. */
export enum ReportPriceIssueTypeEnum2 {
  Direct = 'direct',
  OtherMarketplace = 'other_marketplace',
  BrandWebsite = 'brand_website',
  Tradeshow = 'tradeshow',
  Other = 'other',
}

/** Whether the reported price is a promotional price. */
export enum ReportPriceIssuePromotionEnum {
  Yes = 'yes',
  No = 'no',
}

export enum ReportPriceIssueTypeEnum3 {
  PricingIssues = 'pricing-issues',
}

/** The kind of price report. */
export enum ReportPriceIssueTypeEnum4 {
  PublicPriceReport = 'public_price_report',
  PrivatePriceReport = 'private_price_report',
}

/** The kind of source. */
export enum ReportPriceIssueTypeEnum5 {
  Direct = 'direct',
  OtherMarketplace = 'other_marketplace',
  BrandWebsite = 'brand_website',
  Tradeshow = 'tradeshow',
  Other = 'other',
}

/** Whether the reported price is a promotional price. */
export enum ReportPriceIssuePromotionEnum1 {
  Yes = 'yes',
  No = 'no',
}

export interface ReportPriceIssueData {
  data: {
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    type: ReportPriceIssueTypeEnum;
    attributes: {
      type?: ReportPriceIssueTypeEnum1;
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      closedAt?: string | null;
      closedBy?: string | null;
      status?: string;
      resolution?: string;
      resolvedByBrand?: boolean | null;
      /** Price report field values, validated server-side against the issue schema. */
      fields?: {
        /**
         * An object used to detail pricing information for various Resources.
         * @example {"currency":"EUR","amount":142}
         */
        price?: {
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** Lowest denomination of the currency this amount belongs to. */
          amount: number;
        };
        /**
         * Where the price was found. One or more sources, each with a type and optional detail.
         * @minItems 1
         */
        source: {
          /** The kind of source. */
          type: ReportPriceIssueTypeEnum2;
          /** Optional free-text detail about this source. */
          detail?: string;
        }[];
        /** Whether the reported price is a promotional price. */
        promotion?: ReportPriceIssuePromotionEnum;
      };
    };
  };
}

export enum GetRetailerDashboardStateEnum {
  Confirmable = 'confirmable',
  Active = 'active',
}

/** Present only when state is active */
export enum GetRetailerDashboardStatusEnum {
  AwaitingBrandConfirmation = 'awaiting_brand_confirmation',
  Validated = 'validated',
  InPreparation = 'in_preparation',
  Shipped = 'shipped',
}

/** Global order state when no items are returned. null when items contains an entry. */
export enum GetRetailerDashboardStateEnum1 {
  NeverOrdered = 'never_ordered',
  Idle = 'idle',
}

export enum GetRetailerDashboardStateEnum2 {
  Failed = 'failed',
  UpcomingDebit = 'upcoming_debit',
  IncomingCredit = 'incoming_credit',
  BnplNudge = 'bnpl_nudge',
}

export enum GetRetailerDashboardStateEnum3 {
  FollowAsk = 'follow_ask',
  News = 'news',
  NoBrands = 'no_brands',
}

export enum GetRetailerDashboardVariantEnum {
  Onboarding = 'onboarding',
  Campaign = 'campaign',
}

export interface GetRetailerDashboardData {
  /** True if the retailer registered within the last 15 days */
  is_onboarding: boolean;
  /** Orders card data. Null during onboarding or when not applicable. */
  orders: {
    /** List of relevant order items (at most 1 item) */
    items: {
      state: GetRetailerDashboardStateEnum;
      brand_name: string;
      url: string;
      /** Present only when state is active */
      status?: GetRetailerDashboardStatusEnum;
    }[];
    /** Global order state when no items are returned. null when items contains an entry. */
    state: GetRetailerDashboardStateEnum1;
  } | null;
  /** Payment & credit card data. Null during onboarding, on API errors, or when no relevant payment data exists. */
  payment: {
    state: GetRetailerDashboardStateEnum2;
    /** Amount in cents. Present for upcoming_debit and incoming_credit states. */
    amount_cents?: number;
    /** ISO 4217 currency code. Present for upcoming_debit and incoming_credit states. */
    currency?: string;
    /**
     * Due date (YYYY-MM-DD). Present for upcoming_debit and incoming_credit states.
     * @format date
     */
    due_at?: string;
  } | null;
  /** Your brands card data. Always present (even during onboarding). */
  your_brands: {
    state: GetRetailerDashboardStateEnum3;
    /** Number of new products from followed brands. Present when state is news. */
    new_products_count?: number;
    /** Number of restock recommendations. Present when state is news or no_brands. */
    restock_count?: number;
  } | null;
  /** Don't miss card data. Currently always null. */
  dont_miss: {
    /** Discount percentage to highlight */
    discount_percent: number;
    variant: GetRetailerDashboardVariantEnum;
  } | null;
}

export interface GetCurrenciesRatesLatestPublicData {
  data: {
    /** @default "currency-rates" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @pattern ^[A-Z]{3}$ */
      fromCurrency?: string;
      /** @pattern ^[A-Z]{3}$ */
      toCurrency?: string;
      /** @format date */
      date?: string;
      rate?: number;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "email-verifications" */
export enum CreateEmailVerificationPublicTypeEnum {
  EmailVerifications = 'email-verifications',
}

export interface CreateEmailVerificationPublicData {
  data?: {
    /** @example "email-verifications" */
    type?: string;
    /**
     * The verification token to use when verifying the code
     * @format uuid
     * @example "550e8400-e29b-41d4-a716-446655440000"
     */
    id?: string;
    attributes?: {
      /**
       * @format email
       * @example "user@example.com"
       */
      email?: string;
      /**
       * Number of minutes until the verification code expires
       * @example 10
       */
      expiresInMinutes?: number;
      /**
       * Timestamp when the email was verified (null if not yet verified)
       * @format date-time
       * @example null
       */
      verifiedAt?: string | null;
    };
  };
}

/** @example "email-verifications" */
export enum VerifyEmailCodePublicTypeEnum {
  EmailVerifications = 'email-verifications',
}

export interface VerifyEmailCodePublicData {
  data?: {
    /** @example "email-verifications" */
    type?: string;
    /**
     * @format uuid
     * @example "550e8400-e29b-41d4-a716-446655440000"
     */
    id?: string;
    attributes?: {
      /**
       * @format email
       * @example "user@example.com"
       */
      email?: string;
      /** @example 10 */
      expiresInMinutes?: number;
      /**
       * Timestamp when the email was verified
       * @format date-time
       * @example "2024-01-15T10:30:00Z"
       */
      verifiedAt?: string;
    };
  };
}

export interface GetMeConfigPublicData {
  data: {
    /** @default "user-configs" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      currency?: string;
      country?: string;
      browserId?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetUserConfigPublicData {
  data: {
    /** @default "user-configs" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      currency?: string;
      country?: string;
      browserId?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface ListProductsPublicParams {
  /** A comma-separated list of resources to include (e.g: productVariant) */
  include?: IncludeEnum6;
  /**
   * Limit the number of results returned per page. Must not exceed 50; defaults to 15 when omitted.
   * @format int64
   * @max 50
   * @default 15
   */
  'page[limit]'?: number;
  /** show items before the provided ID (uuid format) */
  'page[before]'?: string;
  /** show items after the provided ID (uuid format) */
  'page[after]'?: string;
}

/** A comma-separated list of resources to include (e.g: productVariant) */
export enum IncludeEnum6 {
  ProductOption = 'productOption',
  ProductVariant = 'productVariant',
}

/** Product Collection */
export interface ListProductsPublicData {
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  /**
   * List of Product resource objects
   * @uniqueItems true
   */
  data: {
    /** @default "products" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product */
      name?: string;
      /** The description of the product */
      description?: string;
      /** The language of the title and description */
      language?: string;
      /** The human readable dimensions of the product */
      dimensions?: string;
      /** The weight of the product itself */
      netWeight?: string;
      /** eg. Capacity in weight eg 100g */
      capacity?: string;
      /** The position of the product in the brands catalog, lower the higher it is */
      position?: number;
      /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
      unitMultiplier?: number;
      /**
       * The VAT rate of the product
       * @format float
       */
      vatRate?: number;
      /**
       * The percentage discount if a brand is offering one (0 - 1)
       * @format float
       */
      discountRate?: number;
      /**
       * Product Type ID
       * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
       * @format integer
       */
      productTypeId?: number;
      /** Whether the product is active or not */
      active?: boolean;
      /** Whether the product is out of stock or not */
      outOfStock?: boolean;
      /** Whether the product is archived or not */
      archived?: boolean;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /**
       * The timestamp when the product was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp when the product was indexed
       * @format datetime
       */
      indexedAt?: null | string;
      /**
       * The timestamp when the product was updated
       * @format datetime
       */
      updatedAt?: string;
      /** List of product images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the product image */
        url?: string;
      }[];
      /** List of tags associated with the product */
      tags?: string[];
    };
    relationships?: {
      /** Reference: Product Option Resource */
      productOption?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /** Reference: Product Variant Resource */
      productVariant?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  }[];
}

/** A comma-separated list of resources to include (e.g: productVariant) */
export enum ListProductsPublicParams1IncludeEnum {
  ProductOption = 'productOption',
  ProductVariant = 'productVariant',
}

export interface GetProductPublicParams {
  /** A comma-separated list of resources to include (e.g: productVariant) */
  include?: IncludeEnum7;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   * @default "079ba9ad-dcdb-4dda-ba0a-1174dad313c5"
   */
  product: string;
}

/** A comma-separated list of resources to include (e.g: productVariant) */
export enum IncludeEnum7 {
  ProductOption = 'productOption',
  ProductVariant = 'productVariant',
}

/** Product Get */
export interface GetProductPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Product Resource
   * The resource object for Product
   */
  data: {
    /** @default "products" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product */
      name?: string;
      /** The description of the product */
      description?: string;
      /** The language of the title and description */
      language?: string;
      /** The human readable dimensions of the product */
      dimensions?: string;
      /** The weight of the product itself */
      netWeight?: string;
      /** eg. Capacity in weight eg 100g */
      capacity?: string;
      /** The position of the product in the brands catalog, lower the higher it is */
      position?: number;
      /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
      unitMultiplier?: number;
      /**
       * The VAT rate of the product
       * @format float
       */
      vatRate?: number;
      /**
       * The percentage discount if a brand is offering one (0 - 1)
       * @format float
       */
      discountRate?: number;
      /**
       * Product Type ID
       * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
       * @format integer
       */
      productTypeId?: number;
      /** Whether the product is active or not */
      active?: boolean;
      /** Whether the product is out of stock or not */
      outOfStock?: boolean;
      /** Whether the product is archived or not */
      archived?: boolean;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /**
       * The timestamp when the product was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp when the product was indexed
       * @format datetime
       */
      indexedAt?: null | string;
      /**
       * The timestamp when the product was updated
       * @format datetime
       */
      updatedAt?: string;
      /** List of product images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the product image */
        url?: string;
      }[];
      /** List of tags associated with the product */
      tags?: string[];
    };
    relationships?: {
      /** Reference: Product Option Resource */
      productOption?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      /** Reference: Product Variant Resource */
      productVariant?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: any[] | null;
}

/** A comma-separated list of resources to include (e.g: productVariant) */
export enum GetProductPublicParams1IncludeEnum {
  ProductOption = 'productOption',
  ProductVariant = 'productVariant',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum ListProductVariantsWithStockPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface ListProductVariantsWithStockPublicParams {
  /**
   * Filter by ID(s)
   * @example ["3571bdc1-fa01-44fa-9342-d99bd1c2befa","4271bdc1-fa01-44fa-9342-d99bd1c2befa"]
   */
  'filter[id][]'?: string[];
  /**
   * Filter by product ID(s)
   * @example ["2291bdc1-bc01-44fa-9342-d95bd1c2befa","4271bdc1-fa11-54fa-9242-d99bd1c2befb"]
   */
  'filter[productId][]'?: string[];
  /**
   * Filter by SKU(s)
   * @example "MY-SKU12,MY-SKU34"
   */
  'filter[sku]'?: string;
  /**
   * Filter by IAN/EAN (exact match, comma-separated for multiple)
   * @example "1924859325863,1924859325867"
   */
  'filter[ian]'?: string;
  /** Filter by SKU or name */
  'filter[skuOrName]'?: string;
  /** Filter by archived status (`archivedAt` attribute is nullable or not) */
  'filter[archived]'?: boolean;
  /** A comma-separated list of resources to include (e.g: product) */
  include?: IncludeEnum8;
}

/** A comma-separated list of resources to include (e.g: product) */
export enum IncludeEnum8 {
  Product = 'product',
}

/** Product Variant Collection */
export interface ListProductVariantsWithStockPublicData {
  /**
   * List of Product Variant resource objects
   * @uniqueItems true
   */
  data: {
    /** @default "product-variants" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product variant */
      name?: string;
      /** The SKU of the product variant */
      sku?: string;
      /** The IAN (EAN) of the product variant, can be null */
      ian?: null | string;
      /**
       * Timestamp of when this product variant was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * Timestamp of when this product variant was updated
       * @format datetime
       */
      updatedAt?: string;
      /** Timestamp of when this product variant was archived */
      archivedAt?: null | string;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /** Number of units that are available to order */
      availableQuantity?: null | number;
      /** Number of units in stock that are reserved */
      reservedQuantity?: number;
      /** Total number of units in stock (available + reserved) */
      stockQuantity?: null | number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of
       *
       *
       *   this variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock?: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy?: ListProductVariantsWithStockPublicInventoryPolicyEnum;
      /**
       * Resource ID used for interacting with the fulfillment service
       * @format uuid
       */
      fulfillableId?: null | string;
      /**
       * Shipping date(in future) of a preorder product e.g. 2028-12-01
       * @format date
       */
      availableAt?: string | null;
      /** List of variant images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the variant image */
        url?: string;
      }[];
    };
    relationships?: {
      /** Reference: Product Resource */
      product?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: product) */
export enum ListProductVariantsWithStockPublicParams1IncludeEnum {
  Product = 'product',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetProductVariantWithStockPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface GetProductVariantWithStockPublicParams {
  /** A comma-separated list of resources to include (e.g: product) */
  include?: IncludeEnum9;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  productVariant: string;
}

/** A comma-separated list of resources to include (e.g: product) */
export enum IncludeEnum9 {
  Product = 'product',
}

export interface GetProductVariantWithStockPublicData {
  /**
   * Product Variant Resource
   * Variant details for a given product. Unique products will have one single variant.
   */
  data: {
    /** @default "product-variants" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product variant */
      name?: string;
      /** The SKU of the product variant */
      sku?: string;
      /** The IAN (EAN) of the product variant, can be null */
      ian?: null | string;
      /**
       * Timestamp of when this product variant was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * Timestamp of when this product variant was updated
       * @format datetime
       */
      updatedAt?: string;
      /** Timestamp of when this product variant was archived */
      archivedAt?: null | string;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /** Number of units that are available to order */
      availableQuantity?: null | number;
      /** Number of units in stock that are reserved */
      reservedQuantity?: number;
      /** Total number of units in stock (available + reserved) */
      stockQuantity?: null | number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of
       *
       *
       *   this variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock?: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy?: GetProductVariantWithStockPublicInventoryPolicyEnum;
      /**
       * Resource ID used for interacting with the fulfillment service
       * @format uuid
       */
      fulfillableId?: null | string;
      /**
       * Shipping date(in future) of a preorder product e.g. 2028-12-01
       * @format date
       */
      availableAt?: string | null;
      /** List of variant images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the variant image */
        url?: string;
      }[];
    };
    relationships?: {
      /** Reference: Product Resource */
      product?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: product) */
export enum GetProductVariantWithStockPublicParams1IncludeEnum {
  Product = 'product',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum UpdateProductVariantStockPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order this variant for which stock is not
 * available. `deny` (default) rejects any quantity larger than the
 * available stock quantity; `continue` lets the retailer order any
 * quantity, even when stock is insufficient or the variant is out
 * of stock. Only valid alongside a tracked stock update (this
 * schema). Omit to preserve the variant's current policy.
 * @default "deny"
 */
export enum UpdateProductVariantStockPublicInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

/**
 * Whether a retailer can order this variant for which stock is not
 * available. Only `deny` is accepted in combination with
 * `isAlwaysInStock=true`: an always-in-stock variant has no stock
 * tracking, so the policy is irrelevant and `continue` cannot be
 * set. Use the `stockQuantity` form of this endpoint to set
 * `continue`.
 * @default "deny"
 */
export enum UpdateProductVariantStockPublicInventoryPolicyEnum2 {
  Deny = 'deny',
}

export interface UpdateProductVariantStockPublicData {
  /**
   * Product Variant Resource
   * Variant details for a given product. Unique products will have one single variant.
   */
  data: {
    /** @default "product-variants" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product variant */
      name?: string;
      /** The SKU of the product variant */
      sku?: string;
      /** The IAN (EAN) of the product variant, can be null */
      ian?: null | string;
      /**
       * Timestamp of when this product variant was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * Timestamp of when this product variant was updated
       * @format datetime
       */
      updatedAt?: string;
      /** Timestamp of when this product variant was archived */
      archivedAt?: null | string;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /** Number of units that are available to order */
      availableQuantity?: null | number;
      /** Number of units in stock that are reserved */
      reservedQuantity?: number;
      /** Total number of units in stock (available + reserved) */
      stockQuantity?: null | number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of
       *
       *
       *   this variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock?: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy?: UpdateProductVariantStockPublicInventoryPolicyEnum;
      /**
       * Resource ID used for interacting with the fulfillment service
       * @format uuid
       */
      fulfillableId?: null | string;
      /**
       * Shipping date(in future) of a preorder product e.g. 2028-12-01
       * @format date
       */
      availableAt?: string | null;
      /** List of variant images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the variant image */
        url?: string;
      }[];
    };
    relationships?: {
      /** Reference: Product Resource */
      product?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum UpdateProductVariantPricesPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface UpdateProductVariantPricesPublicData {
  /**
   * Product Variant Resource
   * Variant details for a given product. Unique products will have one single variant.
   */
  data: {
    /** @default "product-variants" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /** The name of the product variant */
      name?: string;
      /** The SKU of the product variant */
      sku?: string;
      /** The IAN (EAN) of the product variant, can be null */
      ian?: null | string;
      /**
       * Timestamp of when this product variant was created
       * @format datetime
       */
      createdAt?: string;
      /**
       * Timestamp of when this product variant was updated
       * @format datetime
       */
      updatedAt?: string;
      /** Timestamp of when this product variant was archived */
      archivedAt?: null | string;
      /** The suggested retail price of the product */
      retailPrice?: number;
      /** The wholesale price after the discount rate is applied */
      wholesalePrice?: number;
      /** The original wholesale price set by the brand */
      originalWholesalePrice?: number;
      /** Number of units that are available to order */
      availableQuantity?: null | number;
      /** Number of units in stock that are reserved */
      reservedQuantity?: number;
      /** Total number of units in stock (available + reserved) */
      stockQuantity?: null | number;
      /**
       * Whether stock is tracked at all for this product variant.
       *
       * - `true`: stock is not tracked — a retailer can order as much of
       *
       *
       *   this variant as they want, with no restriction at all.
       * - `false`: stock is tracked — whether a retailer can order the
       *
       *
       *   variant depends on the available stock quantity and the
       *   `inventoryPolicy`.
       */
      isAlwaysInStock?: boolean;
      /**
       * Whether a retailer can order a product variant for which stock is not
       * available.
       *
       * - `deny` (default): no. A retailer cannot order a quantity larger than
       *
       *
       *   the currently available stock quantity, so the variant cannot be
       *   ordered when it is out of stock, or when the desired quantity exceeds
       *   the available quantity.
       * - `continue`: yes. The retailer can order any quantity, even when stock
       *
       *
       *   is insufficient (desired quantity > available quantity > 0) or the
       *   variant is out of stock (available quantity <= 0).
       *
       * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
       * @default "deny"
       */
      inventoryPolicy?: UpdateProductVariantPricesPublicInventoryPolicyEnum;
      /**
       * Resource ID used for interacting with the fulfillment service
       * @format uuid
       */
      fulfillableId?: null | string;
      /**
       * Shipping date(in future) of a preorder product e.g. 2028-12-01
       * @format date
       */
      availableAt?: string | null;
      /** List of variant images ordered by display priority */
      images?: {
        /** Display order of the image (lower is higher priority) */
        order?: number;
        /** URL of the variant image */
        url?: string;
      }[];
    };
    relationships?: {
      /** Reference: Product Resource */
      product?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface ProductVariantsDeclareFulfillmentItemPublicData {
  data?: null;
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** JSON:API resource type. */
export enum GetProductVariantPricesPublicTypeEnum {
  ProductVariantPrices = 'product-variant-prices',
}

export interface GetProductVariantPricesPublicParams {
  /**
   * One or more product variant UUIDs to price. Repeat the parameter for
   * each UUID. Minimum 1, maximum 50 per request.
   * @maxItems 50
   * @minItems 1
   * @example ["3571bdc1-fa01-44fa-9342-d99bd1c2befa","4271bdc1-fa01-44fa-9342-d99bd1c2befa"]
   */
  'filter[id][]': string[];
}

export interface GetProductVariantPricesPublicData {
  data?: {
    /** JSON:API resource type. */
    type: GetProductVariantPricesPublicTypeEnum;
    /**
     * The product variant UUID.
     * @format uuid
     */
    id: string;
    attributes: {
      /** Wholesale price before any retailer-specific discount. */
      original_wholesale_price: {
        /**
         * Amount in the currency's minor unit (e.g. cents for EUR).
         * @example 2000
         */
        amount: number;
        /**
         * ISO-4217 currency code.
         * @example "EUR"
         */
        currency: string;
      };
      /** Effective wholesale price after all applicable discounts. */
      wholesale_price: {
        /**
         * Amount in the currency's minor unit (e.g. cents for EUR).
         * @example 1800
         */
        amount: number;
        /**
         * ISO-4217 currency code.
         * @example "EUR"
         */
        currency: string;
      };
      /**
       * Highest discount percentage applied as a whole number (e.g. 10 means 10% off). 0 when no discount applies.
       * @example 10
       */
      discount_rate: number;
    };
  }[];
}

/** Resource type. */
export enum PostCatalogIntegrationOperationsPublicTypeEnum {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum PostCatalogIntegrationOperationsPublicSourceEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum PostCatalogIntegrationOperationsPublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum PostCatalogIntegrationOperationsPublicOperationTypeEnum {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum PostCatalogIntegrationOperationsPublicUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

/** The type of resource to create */
export enum PostCatalogIntegrationOperationsPublicTypeEnum1 {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum PostCatalogIntegrationOperationsPublicSourceEnum1 {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/**
 * OperationType
 * Operation type
 */
export enum PostCatalogIntegrationOperationsPublicOperationTypeEnum1 {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum PostCatalogIntegrationOperationsPublicUpdateFieldsEnum1 {
  Stock = 'stock',
  Prices = 'prices',
  Description = 'description',
  Dimensions = 'dimensions',
  Images = 'images',
  Name = 'name',
  Prices1 = 'prices',
  RetailPrice = 'retail_price',
  Stock2 = 'stock',
  Tags = 'tags',
  UnitMultiplier = 'unit_multiplier',
  VatRate = 'vat_rate',
  WholesalePrice = 'wholesale_price',
}

export interface PostCatalogIntegrationOperationsPublicData {
  /**
   * Operation
   * An operation resource
   */
  data?: {
    /**
     * A globally-unique identifier for the operation
     * @format uuid
     */
    id: string;
    /** Resource type. */
    type: PostCatalogIntegrationOperationsPublicTypeEnum;
    /** The operation attributes. */
    attributes?: {
      /**
       * OperationSource
       * Source of the operation
       */
      source?: PostCatalogIntegrationOperationsPublicSourceEnum;
      /** OperationStatus */
      status?: PostCatalogIntegrationOperationsPublicStatusEnum;
      /**
       * OperationType
       * Operation type
       */
      operationType?: PostCatalogIntegrationOperationsPublicOperationTypeEnum;
      /**
       * updateFields
       * List of fields or group of fields that will be updated on provided products
       */
      updateFields?: PostCatalogIntegrationOperationsPublicUpdateFieldsEnum[];
      /**
       * Date and time when operation was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when operation processing started
       * @format date-time
       */
      startedAt?: null | string;
      /**
       * Date and time when operation was completed
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * a URL where the user will be notified after the operation is complete
       * @format uri
       */
      callbackUrl?: null | string;
      /** Total number of products in the batch */
      totalProductsCount?: number;
      /** Number of products successfully processed */
      processedProductsCount?: number;
      /** Number of products which processing failed */
      failedProductsCount?: number;
    };
  };
}

/** Resource type. */
export enum CreateDeleteCatalogIntegrationOperationsPublicTypeEnum {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum CreateDeleteCatalogIntegrationOperationsPublicSourceEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum CreateDeleteCatalogIntegrationOperationsPublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum CreateDeleteCatalogIntegrationOperationsPublicOperationTypeEnum {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum CreateDeleteCatalogIntegrationOperationsPublicUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum CreateDeleteCatalogIntegrationOperationsPublicSourceEnum1 {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** The type of resource to create */
export enum CreateDeleteCatalogIntegrationOperationsPublicTypeEnum1 {
  CatalogIntegrationProduct = 'catalog-integration-product',
}

export interface CreateDeleteCatalogIntegrationOperationsPublicData {
  /**
   * Operation
   * An operation resource
   */
  data?: {
    /**
     * A globally-unique identifier for the operation
     * @format uuid
     */
    id: string;
    /** Resource type. */
    type: CreateDeleteCatalogIntegrationOperationsPublicTypeEnum;
    /** The operation attributes. */
    attributes?: {
      /**
       * OperationSource
       * Source of the operation
       */
      source?: CreateDeleteCatalogIntegrationOperationsPublicSourceEnum;
      /** OperationStatus */
      status?: CreateDeleteCatalogIntegrationOperationsPublicStatusEnum;
      /**
       * OperationType
       * Operation type
       */
      operationType?: CreateDeleteCatalogIntegrationOperationsPublicOperationTypeEnum;
      /**
       * updateFields
       * List of fields or group of fields that will be updated on provided products
       */
      updateFields?: CreateDeleteCatalogIntegrationOperationsPublicUpdateFieldsEnum[];
      /**
       * Date and time when operation was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when operation processing started
       * @format date-time
       */
      startedAt?: null | string;
      /**
       * Date and time when operation was completed
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * a URL where the user will be notified after the operation is complete
       * @format uri
       */
      callbackUrl?: null | string;
      /** Total number of products in the batch */
      totalProductsCount?: number;
      /** Number of products successfully processed */
      processedProductsCount?: number;
      /** Number of products which processing failed */
      failedProductsCount?: number;
    };
  };
}

/** Resource type. */
export enum GetCatalogIntegrationOperationPublicTypeEnum {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum GetCatalogIntegrationOperationPublicSourceEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum GetCatalogIntegrationOperationPublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum GetCatalogIntegrationOperationPublicOperationTypeEnum {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum GetCatalogIntegrationOperationPublicUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

export interface GetCatalogIntegrationOperationPublicData {
  /**
   * Operation
   * An operation resource
   */
  data?: {
    /**
     * A globally-unique identifier for the operation
     * @format uuid
     */
    id: string;
    /** Resource type. */
    type: GetCatalogIntegrationOperationPublicTypeEnum;
    /** The operation attributes. */
    attributes?: {
      /**
       * OperationSource
       * Source of the operation
       */
      source?: GetCatalogIntegrationOperationPublicSourceEnum;
      /** OperationStatus */
      status?: GetCatalogIntegrationOperationPublicStatusEnum;
      /**
       * OperationType
       * Operation type
       */
      operationType?: GetCatalogIntegrationOperationPublicOperationTypeEnum;
      /**
       * updateFields
       * List of fields or group of fields that will be updated on provided products
       */
      updateFields?: GetCatalogIntegrationOperationPublicUpdateFieldsEnum[];
      /**
       * Date and time when operation was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when operation processing started
       * @format date-time
       */
      startedAt?: null | string;
      /**
       * Date and time when operation was completed
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * a URL where the user will be notified after the operation is complete
       * @format uri
       */
      callbackUrl?: null | string;
      /** Total number of products in the batch */
      totalProductsCount?: number;
      /** Number of products successfully processed */
      processedProductsCount?: number;
      /** Number of products which processing failed */
      failedProductsCount?: number;
    };
  };
}

/** Resource type. */
export enum PatchCatalogIntegrationOperationPublicTypeEnum {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * OperationSource
 * Source of the operation
 */
export enum PatchCatalogIntegrationOperationPublicSourceEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Other = 'other',
}

/** OperationStatus */
export enum PatchCatalogIntegrationOperationPublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Skipped = 'skipped',
  Succeeded = 'succeeded',
  PartiallyFailed = 'partially_failed',
  Failed = 'failed',
}

/**
 * OperationType
 * Operation type
 */
export enum PatchCatalogIntegrationOperationPublicOperationTypeEnum {
  Import = 'import',
  Update = 'update',
  Delete = 'delete',
}

export enum PatchCatalogIntegrationOperationPublicUpdateFieldsEnum {
  Stock = 'stock',
  Prices = 'prices',
}

/** The type of resource to be updated */
export enum PatchCatalogIntegrationOperationPublicTypeEnum1 {
  CatalogIntegrationOperation = 'catalog-integration-operation',
}

/**
 * The operation status. Set this attribute to `started` in order to start processing the operation. Please note that an attempt to start processing an empty operation (i.e. an operation with no products attached) always leads to the operation being marked as "Skipped" and triggers the generation of an empty report.
 * Only one Operation is allowed to be started at a time. Any attempt of starting an Operation while another one is currently being processed (started, but not completed/cancelled yet) will result on a `pending` status.
 * Once an Operation processing has been completed, next `pending` one for the Brand will be executed automatically.
 */
export enum PatchCatalogIntegrationOperationPublicStatusEnum1 {
  Started = 'started',
}

export interface PatchCatalogIntegrationOperationPublicData {
  /**
   * Operation
   * An operation resource
   */
  data?: {
    /**
     * A globally-unique identifier for the operation
     * @format uuid
     */
    id: string;
    /** Resource type. */
    type: PatchCatalogIntegrationOperationPublicTypeEnum;
    /** The operation attributes. */
    attributes?: {
      /**
       * OperationSource
       * Source of the operation
       */
      source?: PatchCatalogIntegrationOperationPublicSourceEnum;
      /** OperationStatus */
      status?: PatchCatalogIntegrationOperationPublicStatusEnum;
      /**
       * OperationType
       * Operation type
       */
      operationType?: PatchCatalogIntegrationOperationPublicOperationTypeEnum;
      /**
       * updateFields
       * List of fields or group of fields that will be updated on provided products
       */
      updateFields?: PatchCatalogIntegrationOperationPublicUpdateFieldsEnum[];
      /**
       * Date and time when operation was created
       * @format date-time
       */
      createdAt?: string;
      /**
       * Date and time when operation processing started
       * @format date-time
       */
      startedAt?: null | string;
      /**
       * Date and time when operation was completed
       * @format date-time
       */
      completedAt?: null | string;
      /**
       * a URL where the user will be notified after the operation is complete
       * @format uri
       */
      callbackUrl?: null | string;
      /** Total number of products in the batch */
      totalProductsCount?: number;
      /** Number of products successfully processed */
      processedProductsCount?: number;
      /** Number of products which processing failed */
      failedProductsCount?: number;
    };
  };
}

/** Currency used in pricing */
export enum PostCatalogIntegrationOperationProductsPublicCurrencyEnum {
  GBP = 'GBP',
  EUR = 'EUR',
  SEK = 'SEK',
}

export enum PostCatalogIntegrationOperationProductsPublicStorageTemperatureEnum {
  Controlled = 'controlled',
  Fresh = 'fresh',
  Frozen = 'frozen',
  UltraFreshHighlyPerishable = 'ultra_fresh_highly_perishable',
  UltraFreshStrictChilled = 'ultra_fresh_strict_chilled',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger
 *
 *
 *   than the currently available stock quantity, so the variant cannot
 *   be ordered when it is out of stock, or when the desired quantity
 *   exceeds the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when
 *
 *
 *   stock is insufficient (desired quantity > available quantity > 0)
 *   or the variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`is_always_in_stock = false`).
 * Omit to inherit the variant's current policy (or `deny` for new
 * variants).
 * @default "deny"
 */
export enum PostCatalogIntegrationOperationProductsPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Name of the property */
export enum PostCatalogIntegrationOperationProductsPublicNameEnum {
  Color = 'color',
  Size = 'size',
  Material = 'material',
  Style = 'style',
}

export interface PostCatalogIntegrationOperationProductsPublicData {
  meta?: {
    /** The total number of products attached to the operation */
    totalProductsCount?: number;
  };
}

/** The operation execution result for this product */
export enum GetCatalogIntegrationOperationReportPublicStatusEnum {
  Success = 'success',
  Failure = 'failure',
}

/** Reason of the validation failure */
export enum GetCatalogIntegrationOperationReportPublicReasonEnum {
  RequiredField = 'required_field',
  InvalidField = 'invalid_field',
  InvalidImage = 'invalid_image',
  InternalError = 'internal_error',
}

export interface GetCatalogIntegrationOperationReportPublicParams {
  /**
   * limit the amount of results returned
   * @format int64
   */
  'page[limit]'?: number;
  /** show items before the provided ID (uuid format) */
  'page[before]'?: string;
  /** show items after the provided ID (uuid format) */
  'page[after]'?: string;
  /**
   * The unique identifier of the operation
   * @format uuid
   */
  operationId: string;
}

/**
 * Product Integration Resource list
 * Product Integration Resource list
 */
export interface GetCatalogIntegrationOperationReportPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data?: {
    /**
     * A globally-unique identifier for the result
     * @format uuid
     */
    id: string;
    /**
     * Type of resource object
     * @default "catalog-integration-result"
     */
    type: string;
    attributes?: {
      /** User-defined unique identifier of the product. May become "undefined" if the error concerns to the entire operation */
      externalProductId: string;
      /** The operation execution result for this product */
      status: GetCatalogIntegrationOperationReportPublicStatusEnum;
      /** The reason for the failure if the operation processing failed */
      failureReason?: string | null;
      /** List of related issues found when processing - Only validation issues are exposed */
      issues?: {
        /** Property name */
        field?: string;
        /** Reason of the validation failure */
        reason?: GetCatalogIntegrationOperationReportPublicReasonEnum;
        /** Details related to the validation failure */
        message?: string;
      }[];
    };
  }[];
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
}

/** Lifecycle status of the error report. */
export enum CatalogExchangeErrorReportsCreatePublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

/** Lifecycle status of the error report. */
export enum CatalogExchangeErrorReportsCreatePublicStatusEnum1 {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export enum CatalogExchangeErrorReportsCreatePublicTypeEnum {
  CatalogExchangeErrorReport = 'catalog-exchange-error-report',
}

export interface CatalogExchangeErrorReportsCreatePublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Identifier of the PIM import job whose failed items are reported.
       * @format uuid
       */
      pimImportJobId: string;
      /**
       * Owning brand UUID.
       * @format uuid
       */
      brandUuid: string;
      /** Lifecycle status of the error report. */
      status: CatalogExchangeErrorReportsCreatePublicStatusEnum;
      /** Name the file will be served as. */
      filename: string;
      /** Reason of failure, set only when the status is `failed`. */
      failureReason?: null | string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      startedAt?: null | string;
      /** @format date-time */
      completedAt?: null | string;
      /**
       * Moment after which the file is no longer downloadable. Reports are retained for 30 days after completion.
       * @format date-time
       */
      expiresAt?: null | string;
      /**
       * Present when the report is completed and not expired.
       * @format uri
       */
      downloadUrl?: null | string;
    };
  };
}

/** Lifecycle status of the error report. */
export enum CatalogExchangeErrorReportsListPublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export interface CatalogExchangeErrorReportsListPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Identifier of the PIM import job whose failed items are reported.
       * @format uuid
       */
      pimImportJobId: string;
      /**
       * Owning brand UUID.
       * @format uuid
       */
      brandUuid: string;
      /** Lifecycle status of the error report. */
      status: CatalogExchangeErrorReportsListPublicStatusEnum;
      /** Name the file will be served as. */
      filename: string;
      /** Reason of failure, set only when the status is `failed`. */
      failureReason?: null | string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      startedAt?: null | string;
      /** @format date-time */
      completedAt?: null | string;
      /**
       * Moment after which the file is no longer downloadable. Reports are retained for 30 days after completion.
       * @format date-time
       */
      expiresAt?: null | string;
      /**
       * Present when the report is completed and not expired.
       * @format uri
       */
      downloadUrl?: null | string;
    };
  }[];
}

/** Lifecycle status of the error report. */
export enum CatalogExchangeErrorReportsShowPublicStatusEnum {
  Created = 'created',
  Started = 'started',
  Completed = 'completed',
  Failed = 'failed',
}

export interface CatalogExchangeErrorReportsShowPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Identifier of the PIM import job whose failed items are reported.
       * @format uuid
       */
      pimImportJobId: string;
      /**
       * Owning brand UUID.
       * @format uuid
       */
      brandUuid: string;
      /** Lifecycle status of the error report. */
      status: CatalogExchangeErrorReportsShowPublicStatusEnum;
      /** Name the file will be served as. */
      filename: string;
      /** Reason of failure, set only when the status is `failed`. */
      failureReason?: null | string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      startedAt?: null | string;
      /** @format date-time */
      completedAt?: null | string;
      /**
       * Moment after which the file is no longer downloadable. Reports are retained for 30 days after completion.
       * @format date-time
       */
      expiresAt?: null | string;
      /**
       * Present when the report is completed and not expired.
       * @format uri
       */
      downloadUrl?: null | string;
    };
  };
}

/** @format binary */
export type CatalogExchangeErrorReportsDownloadPublicData = File;

export enum IntegrationUpdateExternalIntegrationStatusPublicPlatformEnum {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum IntegrationUpdateExternalIntegrationStatusPublicStatusEnum {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum IntegrationUpdateExternalIntegrationStatusPublicPlatformEnum1 {
  Shopify = 'shopify',
  Woocommerce = 'woocommerce',
  Prestashop = 'prestashop',
  Odoo = 'odoo',
  Sellsy = 'sellsy',
}

export enum IntegrationUpdateExternalIntegrationStatusPublicStatusEnum1 {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export interface IntegrationUpdateExternalIntegrationStatusPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @default "external-integrations" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      platform: IntegrationUpdateExternalIntegrationStatusPublicPlatformEnum;
      status: IntegrationUpdateExternalIntegrationStatusPublicStatusEnum;
    };
  };
}

export enum GetBrandsPublicAutomationModeEnum {
  AutomaticBrandControl = 'automatic-brand_control',
  AutomaticConfirmAndRequestFulfillment = 'automatic-confirm-and-request-fulfillment',
}

/** Location that is used as authoritative for marketplace stock */
export enum GetBrandsPublicMarketplaceStockLocationEnum {
  Brand = 'brand',
  Warehouse = 'warehouse',
}

export interface GetBrandsPublicParams {
  /**
   * Limit the result set to brands matching one of the supplied UUIDs. Unknown or hidden ids are silently omitted. Capped at 50 ids per request — chunk client-side beyond that.
   * @maxItems 50
   */
  'filter[id][]'?: string[];
  /**
   * Cursor (brand UUID, exclusive) to start the page from when iterating forward.
   * @format uuid
   */
  'page[from]'?: string;
  /**
   * Cursor (brand UUID, exclusive) to end the page at when iterating backward.
   * @format uuid
   */
  'page[to]'?: string;
  /**
   * Maximum number of brands returned per page.
   * @min 1
   */
  'page[limit]'?: number;
}

export interface GetBrandsPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    /** @default "brands" */
    type: string;
    attributes: {
      /** Brand name */
      name: string;
      automationMode: GetBrandsPublicAutomationModeEnum;
      /** Location that is used as authoritative for marketplace stock */
      marketplaceStockLocation: GetBrandsPublicMarketplaceStockLocationEnum;
      /** Set of brand image links, in different formats. */
      images: {
        squared?: string | null;
        rounded?: string | null;
        large?: string | null;
      };
      /** Relative path to the brand storefront page (slug-based). Null when the runtime route is not registered. */
      link: string | null;
    };
  }[];
}

export enum GetApiV1OwnBrandsPublicAutomationModeEnum {
  AutomaticBrandControl = 'automatic-brand_control',
  AutomaticConfirmAndRequestFulfillment = 'automatic-confirm-and-request-fulfillment',
}

/** Location that is used as authoritative for marketplace stock */
export enum GetApiV1OwnBrandsPublicMarketplaceStockLocationEnum {
  Brand = 'brand',
  Warehouse = 'warehouse',
}

export enum GetApiV1OwnBrandsPublicPurposesEnum {
  Finance = 'finance',
}

export interface GetApiV1OwnBrandsPublicParams {
  /**
   * A comma-separated list of resources to include (e.g: brand-contacts)
   * @pattern ^brand-contacts$
   */
  include?: string;
}

export interface GetApiV1OwnBrandsPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    /** @default "brands" */
    type: string;
    attributes: {
      /** Brand name */
      name: string;
      automationMode: GetApiV1OwnBrandsPublicAutomationModeEnum;
      /** Location that is used as authoritative for marketplace stock */
      marketplaceStockLocation: GetApiV1OwnBrandsPublicMarketplaceStockLocationEnum;
      /** Set of brand image links, in different formats. */
      images: {
        squared?: string | null;
        rounded?: string | null;
        large?: string | null;
      };
      /** Relative path to the brand storefront page (slug-based). Null when the runtime route is not registered. */
      link: string | null;
    };
  }[];
  included?: {
    type: 'brand-contacts';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format email */
      email: string;
      /** @minItems 1 */
      purposes: GetApiV1OwnBrandsPublicPurposesEnum[];
    };
  }[];
}

export enum GetApiV1BrandsPayoutsPublicTypeEnum {
  Payouts = 'payouts',
}

export enum GetApiV1BrandsPayoutsPublicStatusEnum {
  Pending = 'pending',
  Paid = 'paid',
  Failed = 'failed',
  Canceled = 'canceled',
  InTransit = 'in_transit',
  TransferToCome = 'transfer_to_come',
}

export enum GetApiV1BrandsPayoutsPublicTypeEnum1 {
  OrderPayment = 'order_payment',
  Refund = 'refund',
}

/** Order type (only present for order_payment transfers) */
export enum GetApiV1BrandsPayoutsPublicTypeEnum2 {
  Internal = 'internal',
  External = 'external',
}

export interface GetApiV1BrandsPayoutsPublicParams {
  /**
   * Number of items to skip
   * @default 0
   */
  'page[offset]'?: number;
  /**
   * Maximum number of items to return
   * @default 20
   */
  'page[limit]'?: number;
}

export interface GetApiV1BrandsPayoutsPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** @format uuid */
    id: string;
    type: GetApiV1BrandsPayoutsPublicTypeEnum;
    attributes: {
      amount?: {
        /** Amount in the lowest denomination of the currency */
        amount: number;
        /**
         * ISO 3-letter currency code
         * @example "EUR"
         */
        currency: string;
      };
      status?: GetApiV1BrandsPayoutsPublicStatusEnum;
      /** Payment service provider payout identifier (e.g. Stripe payout ID) */
      pspId?: string | null;
      /** @format date-time */
      createdAt?: string | null;
      /** @format date-time */
      arrivedAt?: string | null;
      transfers?: {
        /** @format uuid */
        uuid?: string;
        amount?: {
          /** Amount in the lowest denomination of the currency */
          amount: number;
          /**
           * ISO 3-letter currency code
           * @example "EUR"
           */
          currency: string;
        };
        /** Payment service provider transfer identifier */
        pspId?: string | null;
        type?: GetApiV1BrandsPayoutsPublicTypeEnum1;
        source?: {
          /** @format uuid */
          uuid: string;
          /** Order reference (only present for order_payment transfers) */
          reference?: string;
          /**
           * Master order UUID (only present for order_payment transfers)
           * @format uuid
           */
          masterOrderUuid?: string;
          /** Retailer store name (only present for order_payment transfers) */
          customerStoreName?: string;
          /** Order type (only present for order_payment transfers) */
          type?: GetApiV1BrandsPayoutsPublicTypeEnum2;
          /** Related invoices (only present for order_payment transfers) */
          invoices?: {
            title?: string;
            number?: string | null;
            path?: string | null;
            isGenerated?: boolean;
          }[];
        };
      }[];
    };
  }[];
  meta: {
    page: {
      currentPage?: number;
      from?: number;
      lastPage?: number;
      perPage?: number;
      to?: number;
      total?: number;
      [key: string]: any;
    };
    [key: string]: any;
  };
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum ListPromoCodesPublicStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

export interface ListPromoCodesPublicParams {
  /**
   * Order the list by one field. Prefix with `-` for descending; defaults to `-createdAt`.
   * @default "-createdAt"
   */
  sort?: SortEnum4;
  /** Return only codes that are currently active, or only those that have expired. */
  'filter[status]'?: FilterStatusEnum1;
  /**
   * limit the amount of results returned
   * @format int64
   */
  'page[limit]'?: number;
  /**
   * A cursor for use in pagination. `after` is a promo code id that defines your place in the list; the page returned is the codes that follow it in the current ordering.
   * @format uuid
   */
  'page[after]'?: string;
  /**
   * A cursor for use in pagination. `before` is a promo code id that defines your place in the list; the page returned is the codes that precede it. If both `before` and `after` are given, only `before` is used.
   * @format uuid
   */
  'page[before]'?: string;
}

/**
 * Order the list by one field. Prefix with `-` for descending; defaults to `-createdAt`.
 * @default "-createdAt"
 */
export enum SortEnum4 {
  CreatedAt = 'createdAt',
  ValueCreatedAt = '-createdAt',
  MinimumOrder = 'minimumOrder',
  ValueMinimumOrder = '-minimumOrder',
  ValidUntil = 'validUntil',
  ValueValidUntil = '-validUntil',
  Status = 'status',
  ValueStatus = '-status',
}

/** Return only codes that are currently active, or only those that have expired. */
export enum FilterStatusEnum1 {
  Active = 'active',
  Expired = 'expired',
}

/** Promo Code Index */
export interface ListPromoCodesPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Promo Code Index Meta
   * Pagination details, plus the suffix every one of your codes carries.
   */
  meta?: {
    /** Cursor pagination details */
    page: {
      /** The id of the first code on this page. */
      from: string | null;
      /** The id of the last code on this page — the cursor for `page[after]`. */
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    /**
     * Your brand's suffix, appended to every code you create. Use it to show what a name will become — `AUTUMN26` with a suffix of `K4T2M` is redeemed as `AUTUMN26-K4T2M`. Assigned the first time you list your codes, and the same from then on.
     * @example "K4T2M"
     */
    promoCodeSuffix: string;
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  data?: {
    /** @default "promo-codes" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /**
       * The part of the code you chose. Set on creation and never changes.
       * @example "AUTUMN26"
       */
      name?: string;
      /**
       * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
       * @example "AUTUMN26-K4T2M"
       */
      code?: string;
      /**
       * Promo Code Benefit
       * What the code takes off — either a percentage or a fixed amount, never both.
       */
      benefit?:
        | ({
            type: 'percentage';
          } & AnkorstorePromoCodePercentageBenefit)
        | ({
            type: 'fixed';
          } & AnkorstorePromoCodeFixedBenefit);
      /** The order value a retailer must reach for the code to apply. Null if there is none. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        EUR?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        GBP?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        SEK?: number;
      } | null;
      /**
       * When the code stops working. Null if it never expires.
       * @format date-time
       * @example "2026-12-31T23:59:59.000000Z"
       */
      validUntil?: string | null;
      /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
      status?: ListPromoCodesPublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
    };
  }[];
}

/**
 * Order the list by one field. Prefix with `-` for descending; defaults to `-createdAt`.
 * @default "-createdAt"
 */
export enum ListPromoCodesPublicParams1SortEnum {
  CreatedAt = 'createdAt',
  ValueCreatedAt = '-createdAt',
  MinimumOrder = 'minimumOrder',
  ValueMinimumOrder = '-minimumOrder',
  ValidUntil = 'validUntil',
  ValueValidUntil = '-validUntil',
  Status = 'status',
  ValueStatus = '-status',
}

/** Return only codes that are currently active, or only those that have expired. */
export enum ListPromoCodesPublicParams1FilterStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum CreatePromoCodePublicStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

export enum CreatePromoCodePublicCurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum CreatePromoCodePublicCurrencyEnum1 {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

/** Promo Code Get */
export interface CreatePromoCodePublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Promo Code Resource
   * The resource object for a promo code owned by your brand.
   */
  data?: {
    /** @default "promo-codes" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /**
       * The part of the code you chose. Set on creation and never changes.
       * @example "AUTUMN26"
       */
      name?: string;
      /**
       * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
       * @example "AUTUMN26-K4T2M"
       */
      code?: string;
      /**
       * Promo Code Benefit
       * What the code takes off — either a percentage or a fixed amount, never both.
       */
      benefit?:
        | ({
            type: 'percentage';
          } & AnkorstorePromoCodePercentageBenefit)
        | ({
            type: 'fixed';
          } & AnkorstorePromoCodeFixedBenefit);
      /** The order value a retailer must reach for the code to apply. Null if there is none. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        EUR?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        GBP?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        SEK?: number;
      } | null;
      /**
       * When the code stops working. Null if it never expires.
       * @format date-time
       * @example "2026-12-31T23:59:59.000000Z"
       */
      validUntil?: string | null;
      /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
      status?: CreatePromoCodePublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
    };
  };
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum GetPromoCodePublicStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

/** Promo Code Get */
export interface GetPromoCodePublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Promo Code Resource
   * The resource object for a promo code owned by your brand.
   */
  data?: {
    /** @default "promo-codes" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /**
       * The part of the code you chose. Set on creation and never changes.
       * @example "AUTUMN26"
       */
      name?: string;
      /**
       * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
       * @example "AUTUMN26-K4T2M"
       */
      code?: string;
      /**
       * Promo Code Benefit
       * What the code takes off — either a percentage or a fixed amount, never both.
       */
      benefit?:
        | ({
            type: 'percentage';
          } & AnkorstorePromoCodePercentageBenefit)
        | ({
            type: 'fixed';
          } & AnkorstorePromoCodeFixedBenefit);
      /** The order value a retailer must reach for the code to apply. Null if there is none. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        EUR?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        GBP?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        SEK?: number;
      } | null;
      /**
       * When the code stops working. Null if it never expires.
       * @format date-time
       * @example "2026-12-31T23:59:59.000000Z"
       */
      validUntil?: string | null;
      /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
      status?: GetPromoCodePublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
    };
  };
}

/** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
export enum UpdatePromoCodePublicStatusEnum {
  Active = 'active',
  Expired = 'expired',
}

export enum UpdatePromoCodePublicCurrencyEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

export enum UpdatePromoCodePublicCurrencyEnum1 {
  EUR = 'EUR',
  GBP = 'GBP',
  SEK = 'SEK',
}

/** Promo Code Get */
export interface UpdatePromoCodePublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /**
   * Promo Code Resource
   * The resource object for a promo code owned by your brand.
   */
  data?: {
    /** @default "promo-codes" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      /**
       * The part of the code you chose. Set on creation and never changes.
       * @example "AUTUMN26"
       */
      name?: string;
      /**
       * What a retailer types at checkout: your chosen name followed by your brand's suffix. The suffix is the same on every code you own, so your codes never clash with another brand's.
       * @example "AUTUMN26-K4T2M"
       */
      code?: string;
      /**
       * Promo Code Benefit
       * What the code takes off — either a percentage or a fixed amount, never both.
       */
      benefit?:
        | ({
            type: 'percentage';
          } & AnkorstorePromoCodePercentageBenefit)
        | ({
            type: 'fixed';
          } & AnkorstorePromoCodeFixedBenefit);
      /** The order value a retailer must reach for the code to apply. Null if there is none. */
      minimumOrder?: {
        /** Lowest denomination of the currency this amount belongs to. */
        EUR?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        GBP?: number;
        /** Lowest denomination of the currency this amount belongs to. */
        SEK?: number;
      } | null;
      /**
       * When the code stops working. Null if it never expires.
       * @format date-time
       * @example "2026-12-31T23:59:59.000000Z"
       */
      validUntil?: string | null;
      /** Derived from `validUntil`, never stored. A code is active up to and including that instant. */
      status?: UpdatePromoCodePublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
    };
  };
}

export type DeletePromoCodePublicData = any;

export enum OrderingBillingExportsCreatePublicTypeEnum {
  Invoicing = 'invoicing',
  Accounting = 'accounting',
}

export enum OrderingBillingExportsCreatePublicStatusEnum {
  Created = 'created',
  InProcess = 'in_process',
  Completed = 'completed',
  PartiallyCompleted = 'partially_completed',
  Failed = 'failed',
}

export enum OrderingBillingExportsCreatePublicTypeEnum1 {
  BillingExports = 'billing-exports',
}

export enum OrderingBillingExportsCreatePublicTypeEnum2 {
  Accounting = 'accounting',
  AccountingComplete = 'accounting_complete',
  Invoicing = 'invoicing',
}

export enum OrderingBillingExportsCreatePublicFormatsEnum {
  Csv = 'csv',
  Xlsx = 'xlsx',
  Pdf = 'pdf',
}

export interface OrderingBillingExportsCreatePublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      type: OrderingBillingExportsCreatePublicTypeEnum;
      /** @format uuid */
      brandUuid: string;
      filename: string;
      status: OrderingBillingExportsCreatePublicStatusEnum;
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      /** @format date-time */
      expiresAt: string;
      /** @format date-time */
      finishedAt?: null | string;
      /** @format url */
      downloadLink?: null | string;
    };
  };
}

export enum OrderingBillingExportsListPublicTypeEnum {
  Invoicing = 'invoicing',
  Accounting = 'accounting',
}

export enum OrderingBillingExportsListPublicStatusEnum {
  Created = 'created',
  InProcess = 'in_process',
  Completed = 'completed',
  PartiallyCompleted = 'partially_completed',
  Failed = 'failed',
}

export interface OrderingBillingExportsListPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      type: OrderingBillingExportsListPublicTypeEnum;
      /** @format uuid */
      brandUuid: string;
      filename: string;
      status: OrderingBillingExportsListPublicStatusEnum;
      /** @format date-time */
      from: string;
      /** @format date-time */
      to: string;
      /** @format date-time */
      expiresAt: string;
      /** @format date-time */
      finishedAt?: null | string;
      /** @format url */
      downloadLink?: null | string;
    };
  }[];
}

export interface OrderingBillingExportsDownloadPublicData {
  data: {
    /** @format binary */
    file?: File;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "ankor_confirmed" */
export enum ListMasterOrdersPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum ListMasterOrdersPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum ListMasterOrdersPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum ListMasterOrdersPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum ListMasterOrdersPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum ListMasterOrdersPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum ListMasterOrdersPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum ListMasterOrdersPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum ListMasterOrdersPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum ListMasterOrdersPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum ListMasterOrdersPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export interface ListMasterOrdersPublicParams {
  include?: IncludeEnum10;
  /**
   * limit the amount of results returned
   * @format int64
   */
  'page[limit]'?: number;
  /** show items before the provided ID (uuid format) */
  'page[before]'?: string;
  /** show items after the provided ID (uuid format) */
  'page[after]'?: string;
}

export enum IncludeEnum10 {
  InternalOrder = 'internalOrder',
  ExternalOrder = 'externalOrder',
  Shipment = 'shipment',
}

/** Master Order List */
export interface ListMasterOrdersPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  data?: {
    /** @default "master-orders" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    relationships?: {
      internalOrder?: {
        data: {
          /** @default "internal-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      externalOrder?: {
        data: {
          /** @default "external-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      shipment?: {
        data: {
          /** @default "shipments" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
    };
  }[];
  /** One of the included resources */
  included?: (
    | {
        /** @default "orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The identifier of the linked master order
           * @format uuid
           */
          masterOrderId?: string;
          /** @example "ankor_confirmed" */
          status?: ListMasterOrdersPublicStatusEnum;
          /** The order reference used on shipping labels, communication etc */
          reference?: number;
          /** The currency the brand is paid in */
          brandCurrency?: string;
          /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
          brandNetAmount?: number;
          /** The total of all order items not including VAT */
          brandTotalAmount?: number;
          /** The total VAT of all order items */
          brandTotalAmountVat?: number;
          /** The total of all order items including VAT */
          brandTotalAmountWithVat?: number;
          /** The chosen shipping method after going through the shipping process */
          shippingMethod?: ListMasterOrdersPublicShippingMethodEnum;
          /**
           * Order Resource -> Shipping Overview
           * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
           */
          shippingOverview?: {
            /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
            availableShippingMethods: ListMasterOrdersPublicAvailableShippingMethodsEnum[];
            /** The address the order needs to be shipped to */
            shipToAddress: {
              /** The first and last name of the recipient */
              name?: null | string;
              /** The organisational name of the recipient */
              organisationName?: null | string;
              street: null | string;
              city: null | string;
              postalCode: null | string;
              countryCode?: null | string;
            };
            /** The minimum and maximum expected shipping dates */
            expectedShippingDates: {
              /** @format datetime */
              minimum: string;
              /** @format datetime */
              maximum: string;
              /** @format datetime */
              updatedMaximum?: null | string;
            };
            /** The company providing the shipping service */
            provider?: ListMasterOrdersPublicProviderEnum;
            /** Tracking details of the order */
            tracking?: {
              number?: string;
              /**
               * A URL to view the tracking status
               * @format url
               */
              link?: string;
            };
            /**
             * The quote is the price of the parcel(s) shipping.
             * If this object is null then no quote has been generated.
             */
            latestQuote?: {
              /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
              id: string;
              /**
               * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
               * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
               */
              provider: ListMasterOrdersPublicProviderEnum1;
              /** The provider of the rate for `rateAmount`. */
              rateProvider?: ListMasterOrdersPublicRateProviderEnum;
              /** Amount calculated for the parcels provided. */
              rateAmount?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
              };
              /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
              shippingCostsOverview?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
                /**
                 * Type of shipping costs:
                 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
                 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
                 */
                type?: ListMasterOrdersPublicTypeEnum;
              };
            };
            /** @uniqueItems true */
            parcels?: {
              /** @max 274 */
              length: number;
              /** @max 274 */
              width: number;
              /** @max 274 */
              height: number;
              /** The unit of distance */
              distanceUnit: ListMasterOrdersPublicDistanceUnitEnum;
              /**
               * @min 1
               * @max 30000
               */
              weight: number;
              /** The unit of mass */
              massUnit: ListMasterOrdersPublicMassUnitEnum;
              /** The tracking per parcel */
              trackedPackage: {
                /**
                 * The URL to download the shipping label
                 * @format url
                 */
                labelUrl: null | string;
                /** @format datetime */
                eta: null | string;
                trackingNumber?: string;
                trackingLink: string;
                currentStatus: {
                  /** The current status of the order/parcel */
                  status?: ListMasterOrdersPublicStatusEnum1;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            }[];
            transaction?: {
              /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
              pickup: {
                /**
                 * The date of the pickup
                 * @format datetime
                 */
                pickupDate: string;
                /** Opening time of pickup Eg: 10:00:00 */
                readyTime: string;
                /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
                closeTime: string;
                /** The reference number for this pickup */
                externalReferenceId: string;
              };
              /** The tracking details for the overall shipment */
              tracking: {
                /**
                 * The estimated time of arrival for the order
                 * @format datetime
                 */
                eta?: null | string;
                /** The tracking number of the order */
                trackingNumber?: string;
                /**
                 * The tracking link for the order
                 * @format url
                 */
                trackingLink?: string;
                currentStatus?: {
                  /** The current status of the order/parcel */
                  status?: ListMasterOrdersPublicStatusEnum2;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            };
          };
          /** The reason the brand has given for rejecting the order */
          brandRejectReason?: null | string;
          /** The reason the retailer rejected the reception of the order */
          retailerRejectReason?: null | string;
          /** The reason the retailer has given for a cancellation request */
          retailerCancellationRequestReason?: null | string;
          /** The billing address name */
          billingName?: null | string;
          /** The billing address organisation name */
          billingOrganisationName?: null | string;
          /** The billing address street name */
          billingStreet?: null | string;
          /** The billing address postal code */
          billingPostalCode?: null | string;
          /** The billing address city */
          billingCity?: null | string;
          /** The billing address country code - ISO format */
          billingCountryCode?: null | string;
          /**
           * The timestamp of when the order was submitted (order is placed)
           * @format datetime
           */
          submittedAt?: string;
          /**
           * The timestamp of when the order was shipped
           * @format datetime
           */
          shippedAt?: null | string;
          /**
           * The timestamp of when the brand was paid
           * @format datetime
           */
          brandPaidAt?: null | string;
          /**
           * (deprecated) The timestamp of when the order was created (before retailer payment)
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp of when the order was updated (does not include other resources)
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Related Retailer Resource */
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'retailers';
            };
          };
          /** Related Billing Item Resources */
          billingItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'billing-items';
            })[];
          };
          /** Related Order Item Resources */
          orderItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'order-items';
            })[];
          };
          /** Schema: Order Item -> Product Option Resource */
          'orderItems-productOption'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Option Resource -> Product */
          'orderItems-productOption-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource */
          'orderItems-productVariant'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource -> Product */
          'orderItems-productVariant-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "external-orders" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Status of the order. */
          status: string;
          /** Custom reference of the order. */
          customReference?: null | string;
          /** Shipping address of the recipient. */
          shippingAddress: {
            /** First name of the person, receiving the order */
            firstName: string;
            /** Last name of the person, receiving the order */
            lastName: string;
            /**
             * Email of the person, receiving the order
             * @format email
             */
            email: string;
            /** Phone number of the person, receiving the order. */
            phoneNumber: string;
            /** Name of the company. */
            company: null | string;
            /** Street address of the destination place. */
            street: string;
            /** Name of the destination city. */
            city: string;
            /** Postal code of the destination place. */
            postalCode: string;
            /** ISO 3166-1 country code. */
            countryCode: string;
          };
        };
        relationships?: {
          orderItems?: {
            data: {
              /** @default "external-order-items" */
              type: string;
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
            }[];
          };
        };
      }
    | {
        /** @default "external-order-items" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantUuid: string;
          batchQuantity: number;
          unitQuantity: number;
        };
      }
    | {
        /** @default "shipments" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format date-time */
          shippedAt: null | string;
          trackingNumber: null | string;
          shippingCarrier: null | string;
          trackingUrl: null | string;
        };
      }
  )[];
}

export enum ListMasterOrdersPublicParams1IncludeEnum {
  InternalOrder = 'internalOrder',
  ExternalOrder = 'externalOrder',
  Shipment = 'shipment',
}

/** @example "ankor_confirmed" */
export enum GetMasterOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum GetMasterOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum GetMasterOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum GetMasterOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum GetMasterOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum GetMasterOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum GetMasterOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum GetMasterOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum GetMasterOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum GetMasterOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum GetMasterOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export interface GetMasterOrderPublicParams {
  include?: IncludeEnum11;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  masterOrder: string;
}

export enum IncludeEnum11 {
  InternalOrder = 'internalOrder',
  ExternalOrder = 'externalOrder',
  Shipment = 'shipment',
}

/** Master Order Get */
export interface GetMasterOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Master Order */
  data?: {
    /** @default "master-orders" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    relationships?: {
      internalOrder?: {
        data: {
          /** @default "internal-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      externalOrder?: {
        data: {
          /** @default "external-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      shipment?: {
        data: {
          /** @default "shipments" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
    };
  };
  /** One of the included resources */
  included?: (
    | {
        /** @default "orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The identifier of the linked master order
           * @format uuid
           */
          masterOrderId?: string;
          /** @example "ankor_confirmed" */
          status?: GetMasterOrderPublicStatusEnum;
          /** The order reference used on shipping labels, communication etc */
          reference?: number;
          /** The currency the brand is paid in */
          brandCurrency?: string;
          /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
          brandNetAmount?: number;
          /** The total of all order items not including VAT */
          brandTotalAmount?: number;
          /** The total VAT of all order items */
          brandTotalAmountVat?: number;
          /** The total of all order items including VAT */
          brandTotalAmountWithVat?: number;
          /** The chosen shipping method after going through the shipping process */
          shippingMethod?: GetMasterOrderPublicShippingMethodEnum;
          /**
           * Order Resource -> Shipping Overview
           * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
           */
          shippingOverview?: {
            /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
            availableShippingMethods: GetMasterOrderPublicAvailableShippingMethodsEnum[];
            /** The address the order needs to be shipped to */
            shipToAddress: {
              /** The first and last name of the recipient */
              name?: null | string;
              /** The organisational name of the recipient */
              organisationName?: null | string;
              street: null | string;
              city: null | string;
              postalCode: null | string;
              countryCode?: null | string;
            };
            /** The minimum and maximum expected shipping dates */
            expectedShippingDates: {
              /** @format datetime */
              minimum: string;
              /** @format datetime */
              maximum: string;
              /** @format datetime */
              updatedMaximum?: null | string;
            };
            /** The company providing the shipping service */
            provider?: GetMasterOrderPublicProviderEnum;
            /** Tracking details of the order */
            tracking?: {
              number?: string;
              /**
               * A URL to view the tracking status
               * @format url
               */
              link?: string;
            };
            /**
             * The quote is the price of the parcel(s) shipping.
             * If this object is null then no quote has been generated.
             */
            latestQuote?: {
              /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
              id: string;
              /**
               * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
               * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
               */
              provider: GetMasterOrderPublicProviderEnum1;
              /** The provider of the rate for `rateAmount`. */
              rateProvider?: GetMasterOrderPublicRateProviderEnum;
              /** Amount calculated for the parcels provided. */
              rateAmount?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
              };
              /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
              shippingCostsOverview?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
                /**
                 * Type of shipping costs:
                 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
                 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
                 */
                type?: GetMasterOrderPublicTypeEnum;
              };
            };
            /** @uniqueItems true */
            parcels?: {
              /** @max 274 */
              length: number;
              /** @max 274 */
              width: number;
              /** @max 274 */
              height: number;
              /** The unit of distance */
              distanceUnit: GetMasterOrderPublicDistanceUnitEnum;
              /**
               * @min 1
               * @max 30000
               */
              weight: number;
              /** The unit of mass */
              massUnit: GetMasterOrderPublicMassUnitEnum;
              /** The tracking per parcel */
              trackedPackage: {
                /**
                 * The URL to download the shipping label
                 * @format url
                 */
                labelUrl: null | string;
                /** @format datetime */
                eta: null | string;
                trackingNumber?: string;
                trackingLink: string;
                currentStatus: {
                  /** The current status of the order/parcel */
                  status?: GetMasterOrderPublicStatusEnum1;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            }[];
            transaction?: {
              /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
              pickup: {
                /**
                 * The date of the pickup
                 * @format datetime
                 */
                pickupDate: string;
                /** Opening time of pickup Eg: 10:00:00 */
                readyTime: string;
                /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
                closeTime: string;
                /** The reference number for this pickup */
                externalReferenceId: string;
              };
              /** The tracking details for the overall shipment */
              tracking: {
                /**
                 * The estimated time of arrival for the order
                 * @format datetime
                 */
                eta?: null | string;
                /** The tracking number of the order */
                trackingNumber?: string;
                /**
                 * The tracking link for the order
                 * @format url
                 */
                trackingLink?: string;
                currentStatus?: {
                  /** The current status of the order/parcel */
                  status?: GetMasterOrderPublicStatusEnum2;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            };
          };
          /** The reason the brand has given for rejecting the order */
          brandRejectReason?: null | string;
          /** The reason the retailer rejected the reception of the order */
          retailerRejectReason?: null | string;
          /** The reason the retailer has given for a cancellation request */
          retailerCancellationRequestReason?: null | string;
          /** The billing address name */
          billingName?: null | string;
          /** The billing address organisation name */
          billingOrganisationName?: null | string;
          /** The billing address street name */
          billingStreet?: null | string;
          /** The billing address postal code */
          billingPostalCode?: null | string;
          /** The billing address city */
          billingCity?: null | string;
          /** The billing address country code - ISO format */
          billingCountryCode?: null | string;
          /**
           * The timestamp of when the order was submitted (order is placed)
           * @format datetime
           */
          submittedAt?: string;
          /**
           * The timestamp of when the order was shipped
           * @format datetime
           */
          shippedAt?: null | string;
          /**
           * The timestamp of when the brand was paid
           * @format datetime
           */
          brandPaidAt?: null | string;
          /**
           * (deprecated) The timestamp of when the order was created (before retailer payment)
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp of when the order was updated (does not include other resources)
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Related Retailer Resource */
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'retailers';
            };
          };
          /** Related Billing Item Resources */
          billingItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'billing-items';
            })[];
          };
          /** Related Order Item Resources */
          orderItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'order-items';
            })[];
          };
          /** Schema: Order Item -> Product Option Resource */
          'orderItems-productOption'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Option Resource -> Product */
          'orderItems-productOption-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource */
          'orderItems-productVariant'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource -> Product */
          'orderItems-productVariant-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "external-orders" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Status of the order. */
          status: string;
          /** Custom reference of the order. */
          customReference?: null | string;
          /** Shipping address of the recipient. */
          shippingAddress: {
            /** First name of the person, receiving the order */
            firstName: string;
            /** Last name of the person, receiving the order */
            lastName: string;
            /**
             * Email of the person, receiving the order
             * @format email
             */
            email: string;
            /** Phone number of the person, receiving the order. */
            phoneNumber: string;
            /** Name of the company. */
            company: null | string;
            /** Street address of the destination place. */
            street: string;
            /** Name of the destination city. */
            city: string;
            /** Postal code of the destination place. */
            postalCode: string;
            /** ISO 3166-1 country code. */
            countryCode: string;
          };
        };
        relationships?: {
          orderItems?: {
            data: {
              /** @default "external-order-items" */
              type: string;
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
            }[];
          };
        };
      }
    | {
        /** @default "external-order-items" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantUuid: string;
          batchQuantity: number;
          unitQuantity: number;
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
  )[];
}

export enum GetMasterOrderPublicParams1IncludeEnum {
  InternalOrder = 'internalOrder',
  ExternalOrder = 'externalOrder',
  Shipment = 'shipment',
}

/** @example "ankor_confirmed" */
export enum PatchMasterOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum PatchMasterOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum PatchMasterOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum PatchMasterOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum PatchMasterOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum PatchMasterOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum PatchMasterOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum PatchMasterOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum PatchMasterOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum PatchMasterOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum PatchMasterOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export enum PatchMasterOrderPublicTypeEnum1 {
  InternalOrder = 'internal-order',
  ExternalOrder = 'external-order',
}

/** Master Order Get */
export interface PatchMasterOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Master Order */
  data?: {
    /** @default "master-orders" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    relationships?: {
      internalOrder?: {
        data: {
          /** @default "internal-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      externalOrder?: {
        data: {
          /** @default "external-orders" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
      shipment?: {
        data: {
          /** @default "shipments" */
          type: string;
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
        };
      };
    };
  };
  /** One of the included resources */
  included?: (
    | {
        /** @default "orders" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The identifier of the linked master order
           * @format uuid
           */
          masterOrderId?: string;
          /** @example "ankor_confirmed" */
          status?: PatchMasterOrderPublicStatusEnum;
          /** The order reference used on shipping labels, communication etc */
          reference?: number;
          /** The currency the brand is paid in */
          brandCurrency?: string;
          /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
          brandNetAmount?: number;
          /** The total of all order items not including VAT */
          brandTotalAmount?: number;
          /** The total VAT of all order items */
          brandTotalAmountVat?: number;
          /** The total of all order items including VAT */
          brandTotalAmountWithVat?: number;
          /** The chosen shipping method after going through the shipping process */
          shippingMethod?: PatchMasterOrderPublicShippingMethodEnum;
          /**
           * Order Resource -> Shipping Overview
           * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
           */
          shippingOverview?: {
            /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
            availableShippingMethods: PatchMasterOrderPublicAvailableShippingMethodsEnum[];
            /** The address the order needs to be shipped to */
            shipToAddress: {
              /** The first and last name of the recipient */
              name?: null | string;
              /** The organisational name of the recipient */
              organisationName?: null | string;
              street: null | string;
              city: null | string;
              postalCode: null | string;
              countryCode?: null | string;
            };
            /** The minimum and maximum expected shipping dates */
            expectedShippingDates: {
              /** @format datetime */
              minimum: string;
              /** @format datetime */
              maximum: string;
              /** @format datetime */
              updatedMaximum?: null | string;
            };
            /** The company providing the shipping service */
            provider?: PatchMasterOrderPublicProviderEnum;
            /** Tracking details of the order */
            tracking?: {
              number?: string;
              /**
               * A URL to view the tracking status
               * @format url
               */
              link?: string;
            };
            /**
             * The quote is the price of the parcel(s) shipping.
             * If this object is null then no quote has been generated.
             */
            latestQuote?: {
              /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
              id: string;
              /**
               * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
               * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
               */
              provider: PatchMasterOrderPublicProviderEnum1;
              /** The provider of the rate for `rateAmount`. */
              rateProvider?: PatchMasterOrderPublicRateProviderEnum;
              /** Amount calculated for the parcels provided. */
              rateAmount?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
              };
              /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
              shippingCostsOverview?: {
                /** Lowest denomination of the currency this amount belongs to. */
                amount?: number;
                currency?: string;
                /**
                 * Type of shipping costs:
                 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
                 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
                 */
                type?: PatchMasterOrderPublicTypeEnum;
              };
            };
            /** @uniqueItems true */
            parcels?: {
              /** @max 274 */
              length: number;
              /** @max 274 */
              width: number;
              /** @max 274 */
              height: number;
              /** The unit of distance */
              distanceUnit: PatchMasterOrderPublicDistanceUnitEnum;
              /**
               * @min 1
               * @max 30000
               */
              weight: number;
              /** The unit of mass */
              massUnit: PatchMasterOrderPublicMassUnitEnum;
              /** The tracking per parcel */
              trackedPackage: {
                /**
                 * The URL to download the shipping label
                 * @format url
                 */
                labelUrl: null | string;
                /** @format datetime */
                eta: null | string;
                trackingNumber?: string;
                trackingLink: string;
                currentStatus: {
                  /** The current status of the order/parcel */
                  status?: PatchMasterOrderPublicStatusEnum1;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            }[];
            transaction?: {
              /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
              pickup: {
                /**
                 * The date of the pickup
                 * @format datetime
                 */
                pickupDate: string;
                /** Opening time of pickup Eg: 10:00:00 */
                readyTime: string;
                /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
                closeTime: string;
                /** The reference number for this pickup */
                externalReferenceId: string;
              };
              /** The tracking details for the overall shipment */
              tracking: {
                /**
                 * The estimated time of arrival for the order
                 * @format datetime
                 */
                eta?: null | string;
                /** The tracking number of the order */
                trackingNumber?: string;
                /**
                 * The tracking link for the order
                 * @format url
                 */
                trackingLink?: string;
                currentStatus?: {
                  /** The current status of the order/parcel */
                  status?: PatchMasterOrderPublicStatusEnum2;
                  /** Human readable version of status */
                  statusDetails?: string | null;
                  /**
                   * Last time the status was updated
                   * @format datetime
                   */
                  updatedAt?: string;
                  /** Last known location */
                  location?: {
                    city?: null | string;
                    state?: null | string;
                    zip?: null | string;
                    country?: null | string;
                  };
                };
              };
            };
          };
          /** The reason the brand has given for rejecting the order */
          brandRejectReason?: null | string;
          /** The reason the retailer rejected the reception of the order */
          retailerRejectReason?: null | string;
          /** The reason the retailer has given for a cancellation request */
          retailerCancellationRequestReason?: null | string;
          /** The billing address name */
          billingName?: null | string;
          /** The billing address organisation name */
          billingOrganisationName?: null | string;
          /** The billing address street name */
          billingStreet?: null | string;
          /** The billing address postal code */
          billingPostalCode?: null | string;
          /** The billing address city */
          billingCity?: null | string;
          /** The billing address country code - ISO format */
          billingCountryCode?: null | string;
          /**
           * The timestamp of when the order was submitted (order is placed)
           * @format datetime
           */
          submittedAt?: string;
          /**
           * The timestamp of when the order was shipped
           * @format datetime
           */
          shippedAt?: null | string;
          /**
           * The timestamp of when the brand was paid
           * @format datetime
           */
          brandPaidAt?: null | string;
          /**
           * (deprecated) The timestamp of when the order was created (before retailer payment)
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp of when the order was updated (does not include other resources)
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Related Retailer Resource */
          retailer?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'retailers';
            };
          };
          /** Related Billing Item Resources */
          billingItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'billing-items';
            })[];
          };
          /** Related Order Item Resources */
          orderItems?: {
            /** @uniqueItems true */
            data?: ({
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            } & {
              type?: 'order-items';
            })[];
          };
          /** Schema: Order Item -> Product Option Resource */
          'orderItems-productOption'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Option Resource -> Product */
          'orderItems-productOption-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource */
          'orderItems-productVariant'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
          /** Schema: Order Item -> Product Variant Resource -> Product */
          'orderItems-productVariant-product'?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "external-orders" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Status of the order. */
          status: string;
          /** Custom reference of the order. */
          customReference?: null | string;
          /** Shipping address of the recipient. */
          shippingAddress: {
            /** First name of the person, receiving the order */
            firstName: string;
            /** Last name of the person, receiving the order */
            lastName: string;
            /**
             * Email of the person, receiving the order
             * @format email
             */
            email: string;
            /** Phone number of the person, receiving the order. */
            phoneNumber: string;
            /** Name of the company. */
            company: null | string;
            /** Street address of the destination place. */
            street: string;
            /** Name of the destination city. */
            city: string;
            /** Postal code of the destination place. */
            postalCode: string;
            /** ISO 3166-1 country code. */
            countryCode: string;
          };
        };
        relationships?: {
          orderItems?: {
            data: {
              /** @default "external-order-items" */
              type: string;
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
            }[];
          };
        };
      }
    | {
        /** @default "external-order-items" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** @format uuid */
          productVariantUuid: string;
          batchQuantity: number;
          unitQuantity: number;
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
  )[];
}

export interface MasterOrderCheckFulfillabilityPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface MasterOrderRequestFulfillmentPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicStatusEnum1 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

export interface OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicData {
  data: {
    /** @default "fulfillment-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Unique human readable reference for the fulfillment order, used for communication with the warehouse
       * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
       */
      reference?: string;
      status?: OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        /** quantity in batches */
        quantity: number;
        lotNumber?: null | string;
        /** @format date-time */
        expiryDate?: null | string;
      }[];
      shippedItems?: {
        /** @format uuid */
        fulfillableId: string;
        batchQuantity: number;
        unitQuantity: number;
        lotNumber?: null | string;
        /** @format date-time */
        expiryDate?: null | string;
      }[];
      /**
       * The type of recipient for a fulfillment order
       * @default "business"
       */
      recipientType?: OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicRecipientTypeEnum;
      externalReference?: string | null;
      /**
       * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
       * @deprecated
       */
      instructionText?: string | null;
      instructions?: {
        externalReference?: string | null;
        deliverySchedule?: {
          /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
          timeSlots:
            | {
                /**
                 * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "09:30"
                 */
                startTime: string;
                /**
                 * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "12:30"
                 */
                endTime: string;
              }[]
            | null;
          /**
           * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
           * @minItems 1
           * @uniqueItems true
           * @example [1,2,3]
           */
          openDays: number[];
        } | null;
        packingInstruction?: {
          /**
           * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
           * @minItems 1
           */
          services: OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicServicesEnum[];
          /** Instruction text for packing the order. */
          instruction?: string;
        } | null;
      } | null;
    };
    links?: {
      order?: string;
    };
    relationships?: {
      statusUpdates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** @default "fulfillment-order-status-updates" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    /** Fulfillment order status update */
    attributes?: {
      status?: OrderingMasterOrdersRelationshipsFulfillmentOrdersPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string;
    };
  }[];
}

export interface OrderingMasterOrdersRelationshipFulfillmentOrdersPublicData {
  /**
   * An array of objects each containing `type` and `id` members for to-many relationships.
   * @uniqueItems true
   */
  data: {
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetMasterOrderShippingShipmentPublicParams {
  include?: IncludeEnum12;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  orderId: string;
}

export enum IncludeEnum12 {
  ShipmentParcel = 'shipmentParcel',
  ShipmentQuote = 'shipmentQuote',
  ShippedItems = 'shippedItems',
}

export interface GetMasterOrderShippingShipmentPublicData {
  data: {
    /** @default "shipment-trackings" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      carrier: null | string;
      serviceCode?: null | string;
      trackingNumber: string;
      trackingLink: null | string;
      status: null | string;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      shipmentParcel?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      shipmentQuote?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Only presented if asked explicitly in the request with ?include=shippedItems */
      shippedItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** @default "tracked-packages" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Height of the package (cm) */
          height?: null | number;
          /** Width of the package (cm) */
          width?: null | number;
          /** Length of the package (cm) */
          length?: null | number;
          /** Weight of the package (g) */
          weight?: null | number;
          /** Tracking number of the package */
          trackingNumber: string;
          /** Tracking link of the package */
          trackingLink: string;
          /** Status of the package */
          status: string;
          /** Serial Shipping Container Code (SSCC) for traceability */
          serialShippingContainerCode?: null | string;
          /** Label of the package */
          label?: {
            /** Content of the label */
            content?: string;
            /** Content type of the label (gif, pdf) */
            contentType?: string;
          };
        };
      }
    | {
        /** @default "shipping-shipment-shipped-item" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /**
           * The UUID of the parcel (tracked package) this item belongs to
           * @format uuid
           */
          parcelId: string;
          /**
           * The UUID of the product variant
           * @format uuid
           */
          productVariantId: string;
          /**
           * Number of batches (e.g. boxes) shipped
           * @min 1
           */
          batchQuantity: number;
          /**
           * Number of individual units shipped
           * @min 1
           */
          unitQuantity: number;
          /** Lot or batch number for traceability */
          lotNumber?: null | string;
          /**
           * Expiry date of the items (YYYY-MM-DD)
           * @format date
           */
          expiryDate?: null | string;
        };
      }
  )[];
}

export enum GetMasterOrderShippingShipmentPublicParams1IncludeEnum {
  ShipmentParcel = 'shipmentParcel',
  ShipmentQuote = 'shipmentQuote',
  ShippedItems = 'shippedItems',
}

export enum PostMasterOrderShippingShipmentPublicCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum PostMasterOrderShippingShipmentPublicTypeEnum {
  ShippingShipment = 'shipping-shipment',
}

export enum PostMasterOrderShippingShipmentPublicStatusEnum {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export enum PostMasterOrderShippingShipmentPublicTypeEnum1 {
  ShippingShipmentParcel = 'shipping-shipment-parcel',
}

export enum PostMasterOrderShippingShipmentPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export enum PostMasterOrderShippingShipmentPublicTypeEnum2 {
  ShippingQuotes = 'shipping-quotes',
}

export interface PostMasterOrderShippingShipmentPublicParams {
  include?: IncludeEnum13;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  orderId: string;
}

export enum IncludeEnum13 {
  ShipmentParcel = 'shipmentParcel',
  ShipmentQuote = 'shipmentQuote',
  ShippedItems = 'shippedItems',
}

export interface PostMasterOrderShippingShipmentPublicData {
  data: {
    /** @default "shipment-trackings" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      carrier: null | string;
      serviceCode?: null | string;
      trackingNumber: string;
      trackingLink: null | string;
      status: null | string;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      shipmentParcel?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      shipmentQuote?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Only presented if asked explicitly in the request with ?include=shippedItems */
      shippedItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** @default "tracked-packages" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Height of the package (cm) */
          height?: null | number;
          /** Width of the package (cm) */
          width?: null | number;
          /** Length of the package (cm) */
          length?: null | number;
          /** Weight of the package (g) */
          weight?: null | number;
          /** Tracking number of the package */
          trackingNumber: string;
          /** Tracking link of the package */
          trackingLink: string;
          /** Status of the package */
          status: string;
          /** Serial Shipping Container Code (SSCC) for traceability */
          serialShippingContainerCode?: null | string;
          /** Label of the package */
          label?: {
            /** Content of the label */
            content?: string;
            /** Content type of the label (gif, pdf) */
            contentType?: string;
          };
        };
      }
    | {
        /** The unique identifier for the quote as an uuid */
        quoteUuid?: string;
        /** The carrier code for the quote */
        carrierCode?: string;
        /** The service code for the quote */
        serviceCode?: string;
        /** The commercial name of the service */
        serviceCommercialName?: string;
        /** The collection method for the quote */
        collectionMethod?: PostMasterOrderShippingShipmentPublicCollectionMethodEnum[];
        shippingCost?: {
          /** The amount of the shipping cost */
          amount?: number;
          /** The currency of the shipping cost */
          currency?: string;
        };
        /** Delivery estimation information if provided by carrier */
        timeInTransit?: {
          /**
           * Estimation of delivery date by the carrier
           * @format date
           */
          estimatedDeliveryDate?: null | string;
          /**
           * Pickup date considered for the estimation
           * @format date
           */
          pickupDate?: null | string;
          /** Number of business days the shipment is in transit */
          businessDaysInTransit?: null | number;
        };
      }
  )[];
}

export enum PostMasterOrderShippingShipmentPublicParams1IncludeEnum {
  ShipmentParcel = 'shipmentParcel',
  ShipmentQuote = 'shipmentQuote',
  ShippedItems = 'shippedItems',
}

export enum PatchMasterOrderShippingShipmentPublicCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export enum PatchMasterOrderShippingShipmentPublicTypeEnum {
  ShippingShipment = 'shipping-shipment',
}

export enum PatchMasterOrderShippingShipmentPublicStatusEnum {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export enum PatchMasterOrderShippingShipmentPublicTypeEnum1 {
  ShippingShipmentParcel = 'shipping-shipment-parcel',
}

export enum PatchMasterOrderShippingShipmentPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

export interface PatchMasterOrderShippingShipmentPublicParams {
  include?: IncludeEnum14;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  orderId: string;
}

export enum IncludeEnum14 {
  ShipmentParcel = 'shipmentParcel',
  ShipmentQuote = 'shipmentQuote',
  ShippedItems = 'shippedItems',
}

export interface PatchMasterOrderShippingShipmentPublicData {
  data: {
    /** @default "shipment-trackings" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    attributes?: {
      carrier: null | string;
      serviceCode?: null | string;
      trackingNumber: string;
      trackingLink: null | string;
      status: null | string;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      shipmentParcel?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
      shipmentQuote?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Only presented if asked explicitly in the request with ?include=shippedItems */
      shippedItems?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** @default "tracked-packages" */
        type?: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id?: string;
        attributes?: {
          /** Height of the package (cm) */
          height?: null | number;
          /** Width of the package (cm) */
          width?: null | number;
          /** Length of the package (cm) */
          length?: null | number;
          /** Weight of the package (g) */
          weight?: null | number;
          /** Tracking number of the package */
          trackingNumber: string;
          /** Tracking link of the package */
          trackingLink: string;
          /** Status of the package */
          status: string;
          /** Serial Shipping Container Code (SSCC) for traceability */
          serialShippingContainerCode?: null | string;
          /** Label of the package */
          label?: {
            /** Content of the label */
            content?: string;
            /** Content type of the label (gif, pdf) */
            contentType?: string;
          };
        };
      }
    | {
        /** The unique identifier for the quote as an uuid */
        quoteUuid?: string;
        /** The carrier code for the quote */
        carrierCode?: string;
        /** The service code for the quote */
        serviceCode?: string;
        /** The commercial name of the service */
        serviceCommercialName?: string;
        /** The collection method for the quote */
        collectionMethod?: PatchMasterOrderShippingShipmentPublicCollectionMethodEnum[];
        shippingCost?: {
          /** The amount of the shipping cost */
          amount?: number;
          /** The currency of the shipping cost */
          currency?: string;
        };
        /** Delivery estimation information if provided by carrier */
        timeInTransit?: {
          /**
           * Estimation of delivery date by the carrier
           * @format date
           */
          estimatedDeliveryDate?: null | string;
          /**
           * Pickup date considered for the estimation
           * @format date
           */
          pickupDate?: null | string;
          /** Number of business days the shipment is in transit */
          businessDaysInTransit?: null | number;
        };
      }
  )[];
}

export enum PatchMasterOrderShippingShipmentPublicParams1IncludeEnum {
  ShipmentParcel = 'shipmentParcel',
  ShipmentQuote = 'shipmentQuote',
  ShippedItems = 'shippedItems',
}

export interface OrderingUpdateOrderItemsPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "ankor_confirmed" */
export enum ListInternalOrdersPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum ListInternalOrdersPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum ListInternalOrdersPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum ListInternalOrdersPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum ListInternalOrdersPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum ListInternalOrdersPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum ListInternalOrdersPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum ListInternalOrdersPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum ListInternalOrdersPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum ListInternalOrdersPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum ListInternalOrdersPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum ListInternalOrdersPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum ListInternalOrdersPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface ListInternalOrdersPublicParams {
  /**
   * Retailer Id
   * @example "23e4567-e89b-12d3-a456-426614174000"
   */
  'filter[retailer]'?: string;
  /**
   * Order Status
   * @example "ankor_confirmed"
   */
  'filter[status]'?: FilterStatusEnum2;
  /**
   * Promo code (code or id) applied to the order
   * @example "SUMMER10"
   */
  'filter[promocode]'?: string;
  /** Whether the order has any promo code applied */
  'filter[hasPromocode]'?: boolean;
  /** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
  include?: IncludeEnum15;
  /**
   * limit the amount of results returned
   * @format int64
   */
  'page[limit]'?: number;
  /** show items before the provided ID (uuid format) */
  'page[before]'?: string;
  /** show items after the provided ID (uuid format) */
  'page[after]'?: string;
}

/**
 * Order Status
 * @example "ankor_confirmed"
 */
export enum FilterStatusEnum2 {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum IncludeEnum15 {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** Order Collection */
export interface ListInternalOrdersPublicData {
  /**
   * List of Order resource objects
   * @uniqueItems true
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: ListInternalOrdersPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: ListInternalOrdersPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: ListInternalOrdersPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: ListInternalOrdersPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: ListInternalOrdersPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: ListInternalOrdersPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: ListInternalOrdersPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: ListInternalOrdersPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: ListInternalOrdersPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: ListInternalOrdersPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: ListInternalOrdersPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: ListInternalOrdersPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: ListInternalOrdersPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** Meta with Pagination Details */
  meta?: {
    /** Cursor pagination details */
    page: {
      from: string | null;
      to: string | null;
      hasMore?: boolean;
      perPage: number;
    };
    [key: string]: any;
  };
  /** Pagination navigation links. If a link does not exist then you cannot paginate any further in that direction. */
  links?: {
    /** @format url */
    first?: string;
    /** @format url */
    next?: string;
    /** @format url */
    prev?: string;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * Order Status
 * @example "ankor_confirmed"
 */
export enum ListInternalOrdersPublicParams1FilterStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum ListInternalOrdersPublicParams1IncludeEnum {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** @example "ankor_confirmed" */
export enum GetInternalOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum GetInternalOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum GetInternalOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum GetInternalOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum GetInternalOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum GetInternalOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum GetInternalOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum GetInternalOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum GetInternalOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum GetInternalOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum GetInternalOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum GetInternalOrderPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum GetInternalOrderPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface GetInternalOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
  include?: IncludeEnum16;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  order: string;
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum IncludeEnum16 {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** Order Get */
export interface GetInternalOrderPublicData {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: GetInternalOrderPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: GetInternalOrderPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: GetInternalOrderPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: GetInternalOrderPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: GetInternalOrderPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: GetInternalOrderPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: GetInternalOrderPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: GetInternalOrderPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: GetInternalOrderPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: GetInternalOrderPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: GetInternalOrderPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: GetInternalOrderPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: GetInternalOrderPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum GetInternalOrderPublicParams1IncludeEnum {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

export enum InternalOrderIsFulfillablePublicDetailEnum {
  NotAFulfillmentBrand = 'not_a_fulfillment_brand',
  UnavailableItems = 'unavailable_items',
  AlreadyBeingFulfilled = 'already_being_fulfilled',
  NotAvailableForInternationalOrders = 'not_available_for_international_orders',
  MissingHsCodeForInternationalOrder = 'missing_hs_code_for_international_order',
  StockIsBeingTransferred = 'stock_is_being_transferred',
}

export interface InternalOrderIsFulfillablePublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "ankor_confirmed" */
export enum TransitionInternalOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum TransitionInternalOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum TransitionInternalOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum TransitionInternalOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum TransitionInternalOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum TransitionInternalOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum TransitionInternalOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum TransitionInternalOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum TransitionInternalOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum TransitionInternalOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum TransitionInternalOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum TransitionInternalOrderPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum TransitionInternalOrderPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** The transition to use */
export enum TransitionInternalOrderPublicTypeEnum2 {
  BrandValidates = 'brand-validates',
}

export enum TransitionInternalOrderPublicTypeEnum3 {
  OrderItems = 'order-items',
}

/** The transition to use */
export enum TransitionInternalOrderPublicTypeEnum4 {
  BrandRejects = 'brand-rejects',
}

/** One of the available reject reasons. */
export enum TransitionInternalOrderPublicRejectTypeEnum {
  BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA = 'BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA',
  BRAND_CANNOT_DELIVER_TO_THE_AREA = 'BRAND_CANNOT_DELIVER_TO_THE_AREA',
  BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION = 'BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION',
  BUYER_NOT_A_RETAILER = 'BUYER_NOT_A_RETAILER',
  ORDER_ITEMS_PRICES_INCORRECT = 'ORDER_ITEMS_PRICES_INCORRECT',
  PAYMENT_ISSUES_WITH_RETAILER = 'PAYMENT_ISSUES_WITH_RETAILER',
  PREPARATION_TIME_TOO_HIGH = 'PREPARATION_TIME_TOO_HIGH',
  PRODUCT_OUT_OF_STOCK = 'PRODUCT_OUT_OF_STOCK',
  PURCHASE_NOT_FOR_RESALE = 'PURCHASE_NOT_FOR_RESALE',
  RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER = 'RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER',
  RETAILER_NOT_GOOD_FIT_FOR_BRAND = 'RETAILER_NOT_GOOD_FIT_FOR_BRAND',
  RETAILER_VAT_NUMBER_MISSING = 'RETAILER_VAT_NUMBER_MISSING',
  OTHER = 'OTHER',
}

/** The transition to use */
export enum TransitionInternalOrderPublicTypeEnum5 {
  BrandResetsShippingLabelsGeneration = 'brand-resets-shipping-labels-generation',
}

/** One of the available reset reasons. */
export enum TransitionInternalOrderPublicResetTypeEnum {
  BRAND_NEED_MORE_LABELS_TO_SHIP = 'BRAND_NEED_MORE_LABELS_TO_SHIP',
  BRAND_PUT_WRONG_WEIGHT_DIMENSIONS = 'BRAND_PUT_WRONG_WEIGHT_DIMENSIONS',
  BRAND_SHIPS_WITH_DIFFERENT_CARRIER = 'BRAND_SHIPS_WITH_DIFFERENT_CARRIER',
  PROBLEM_DURING_SHIPPING_LABEL_GENERATION = 'PROBLEM_DURING_SHIPPING_LABEL_GENERATION',
  RETAILER_ASKED_DELIVERY_ADDRESS_CHANGE = 'RETAILER_ASKED_DELIVERY_ADDRESS_CHANGE',
  SHIPPING_ADDRESS_MISMATCHES_PICKUP_ADDRESS = 'SHIPPING_ADDRESS_MISMATCHES_PICKUP_ADDRESS',
  OTHER = 'OTHER',
}

/** The transition to use */
export enum TransitionInternalOrderPublicTypeEnum6 {
  BrandRequestsFulfillment = 'brand-requests-fulfillment',
}

/** The transition to use */
export enum TransitionInternalOrderPublicTypeEnum7 {
  MarkAsFulfilled = 'mark-as-fulfilled',
}

export interface TransitionInternalOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
  include?: IncludeEnum17;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  order: string;
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum IncludeEnum17 {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** Order Get */
export interface TransitionInternalOrderPublicData {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: TransitionInternalOrderPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: TransitionInternalOrderPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: TransitionInternalOrderPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: TransitionInternalOrderPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: TransitionInternalOrderPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: TransitionInternalOrderPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: TransitionInternalOrderPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: TransitionInternalOrderPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: TransitionInternalOrderPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: TransitionInternalOrderPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: TransitionInternalOrderPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: TransitionInternalOrderPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: TransitionInternalOrderPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum TransitionInternalOrderPublicParams1IncludeEnum {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/**
 * The type of recipient for this order
 * @default "business"
 */
export enum OrderingCreateNonAnkorstoreFulfillmentOrderPublicRecipientTypeEnum {
  Business = 'business',
  Consumer = 'consumer',
}

export enum OrderingCreateNonAnkorstoreFulfillmentOrderPublicServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
  SSCC = 'SSCC',
}

export interface OrderingCreateNonAnkorstoreFulfillmentOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "ankor_confirmed" */
export enum BrandAcceptOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum BrandAcceptOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum BrandAcceptOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum BrandAcceptOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum BrandAcceptOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum BrandAcceptOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum BrandAcceptOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum BrandAcceptOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum BrandAcceptOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum BrandAcceptOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum BrandAcceptOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum BrandAcceptOrderPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum BrandAcceptOrderPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface BrandAcceptOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
  include?: IncludeEnum18;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  order: string;
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum IncludeEnum18 {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** Order Get */
export interface BrandAcceptOrderPublicData {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: BrandAcceptOrderPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: BrandAcceptOrderPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: BrandAcceptOrderPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: BrandAcceptOrderPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: BrandAcceptOrderPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: BrandAcceptOrderPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: BrandAcceptOrderPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: BrandAcceptOrderPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: BrandAcceptOrderPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: BrandAcceptOrderPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: BrandAcceptOrderPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: BrandAcceptOrderPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: BrandAcceptOrderPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum BrandAcceptOrderPublicParams1IncludeEnum {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** @example "ankor_confirmed" */
export enum BrandRejectOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum BrandRejectOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum BrandRejectOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum BrandRejectOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum BrandRejectOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum BrandRejectOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum BrandRejectOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum BrandRejectOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum BrandRejectOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum BrandRejectOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum BrandRejectOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum BrandRejectOrderPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum BrandRejectOrderPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** One of the available reject reasons. If this field is omitted from the payload it will default to OTHER to ensure backwards compatibility. Please note that this field will be mandatory in the future. */
export enum BrandRejectOrderPublicRejectTypeEnum {
  BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA = 'BRAND_ALREADY_HAS_CUSTOMER_IN_THE_AREA',
  BRAND_CANNOT_DELIVER_TO_THE_AREA = 'BRAND_CANNOT_DELIVER_TO_THE_AREA',
  BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION = 'BRAND_HAS_EXCLUSIVE_DISTRIBUTOR_IN_THE_REGION',
  BUYER_NOT_A_RETAILER = 'BUYER_NOT_A_RETAILER',
  ORDER_ITEMS_PRICES_INCORRECT = 'ORDER_ITEMS_PRICES_INCORRECT',
  PAYMENT_ISSUES_WITH_RETAILER = 'PAYMENT_ISSUES_WITH_RETAILER',
  PREPARATION_TIME_TOO_HIGH = 'PREPARATION_TIME_TOO_HIGH',
  PRODUCT_OUT_OF_STOCK = 'PRODUCT_OUT_OF_STOCK',
  PURCHASE_NOT_FOR_RESALE = 'PURCHASE_NOT_FOR_RESALE',
  RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER = 'RETAILER_AGREED_TO_DO_CHANGES_TO_ORDER',
  RETAILER_NOT_GOOD_FIT_FOR_BRAND = 'RETAILER_NOT_GOOD_FIT_FOR_BRAND',
  RETAILER_VAT_NUMBER_MISSING = 'RETAILER_VAT_NUMBER_MISSING',
  OTHER = 'OTHER',
}

export interface BrandRejectOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
  include?: IncludeEnum19;
  /**
   * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
   * @format uuid
   */
  order: string;
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum IncludeEnum19 {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** Order Get */
export interface BrandRejectOrderPublicData {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: BrandRejectOrderPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: BrandRejectOrderPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: BrandRejectOrderPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: BrandRejectOrderPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: BrandRejectOrderPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: BrandRejectOrderPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: BrandRejectOrderPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: BrandRejectOrderPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: BrandRejectOrderPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: BrandRejectOrderPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: BrandRejectOrderPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: BrandRejectOrderPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: BrandRejectOrderPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum BrandRejectOrderPublicParams1IncludeEnum {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

export interface ListOrderPayCustomerPublicParams {
  'filter[storeName]'?: string;
  'filter[email]'?: string;
  /**
   * Page number, starting at 1
   * @default 1
   */
  'page[number]'?: number;
  /**
   * Maximum number of elements per page
   * @default 20
   */
  'page[size]'?: number;
  /** Comma-separated list of attributes to sort by (storeName by default) */
  sort?: SortEnum5;
  /** A comma-separated list of resources to include (e.g: paymentMethods) */
  include?: IncludeEnum20;
}

/** Comma-separated list of attributes to sort by (storeName by default) */
export enum SortEnum5 {
  Id = 'id',
  StoreName = 'storeName',
}

/** A comma-separated list of resources to include (e.g: paymentMethods) */
export enum IncludeEnum20 {
  PaymentMethods = 'paymentMethods',
}

export interface ListOrderPayCustomerPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: 'order-pay-customer';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      storeName: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      paymentMethods?: {
        type: string;
        email?: string | null;
        name?: string | null;
        /** @example "1234" */
        last4?: string | null;
      }[];
      company: {
        phoneNumber: string;
        phoneCountry: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
        taxNumber: string | null;
        vatNumber: string | null;
        vatExemption: boolean;
      };
      billingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
      shippingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
    };
    relationships?: {
      paymentMethods?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data: {
          id: string;
          /** @default "order-pay-customer-payment-methods" */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  }[];
  meta: {
    page: {
      currentPage?: number;
      from?: number;
      lastPage?: number;
      perPage?: number;
      to?: number;
      total?: number;
    };
    [key: string]: any;
  };
}

/** Comma-separated list of attributes to sort by (storeName by default) */
export enum ListOrderPayCustomerPublicParams1SortEnum {
  Id = 'id',
  StoreName = 'storeName',
}

/** A comma-separated list of resources to include (e.g: paymentMethods) */
export enum ListOrderPayCustomerPublicParams1IncludeEnum {
  PaymentMethods = 'paymentMethods',
}

export interface CreateOrderPayCustomerPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** CustomerResource */
  data: {
    type: 'order-pay-customer';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      storeName: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      paymentMethods?: {
        type: string;
        email?: string | null;
        name?: string | null;
        /** @example "1234" */
        last4?: string | null;
      }[];
      company: {
        phoneNumber: string;
        phoneCountry: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
        taxNumber: string | null;
        vatNumber: string | null;
        vatExemption: boolean;
      };
      billingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
      shippingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
    };
    relationships?: {
      paymentMethods?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data: {
          id: string;
          /** @default "order-pay-customer-payment-methods" */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  included?: {
    type: 'order-pay-customer-payment-method';
    id: string;
    attributes: {
      type: string;
      email: string | null;
      name: string | null;
      /** @example "1234" */
      last4: string | null;
    };
  }[];
}

export interface ShowOrderPayCustomerPublicParams {
  /** A comma-separated list of resources to include */
  include?: IncludeEnum21;
  /**
   * Customer ID
   * @format uuid
   */
  orderPayCustomer: string;
}

/** A comma-separated list of resources to include */
export enum IncludeEnum21 {
  PaymentMethods = 'paymentMethods',
}

export interface ShowOrderPayCustomerPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** CustomerResource */
  data: {
    type: 'order-pay-customer';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      storeName: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      paymentMethods?: {
        type: string;
        email?: string | null;
        name?: string | null;
        /** @example "1234" */
        last4?: string | null;
      }[];
      company: {
        phoneNumber: string;
        phoneCountry: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
        taxNumber: string | null;
        vatNumber: string | null;
        vatExemption: boolean;
      };
      billingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
      shippingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
    };
    relationships?: {
      paymentMethods?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data: {
          id: string;
          /** @default "order-pay-customer-payment-methods" */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  included?: {
    type: 'order-pay-customer-payment-method';
    id: string;
    attributes: {
      type: string;
      email: string | null;
      name: string | null;
      /** @example "1234" */
      last4: string | null;
    };
  }[];
}

/** A comma-separated list of resources to include */
export enum ShowOrderPayCustomerPublicParams1IncludeEnum {
  PaymentMethods = 'paymentMethods',
}

export interface UpdateOrderPayCustomerPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** CustomerResource */
  data: {
    type: 'order-pay-customer';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      storeName: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      paymentMethods?: {
        type: string;
        email?: string | null;
        name?: string | null;
        /** @example "1234" */
        last4?: string | null;
      }[];
      company: {
        phoneNumber: string;
        phoneCountry: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
        taxNumber: string | null;
        vatNumber: string | null;
        vatExemption: boolean;
      };
      billingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
      shippingAddress?: {
        name: string;
        street: string;
        postalCode: string;
        city: string;
        country: {
          isoCode: string;
          name: string;
          callingCode: number;
        };
      };
    };
    relationships?: {
      paymentMethods?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data: {
          id: string;
          /** @default "order-pay-customer-payment-methods" */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  included?: {
    type: 'order-pay-customer-payment-method';
    id: string;
    attributes: {
      type: string;
      email: string | null;
      name: string | null;
      /** @example "1234" */
      last4: string | null;
    };
  }[];
}

/** The type of item. */
export enum CreateOrderPayOrderPublicTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum CreateOrderPayOrderPublicStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum CreateOrderPayOrderPublicShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum CreateOrderPayOrderPublicPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum CreateOrderPayOrderPublicStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum CreateOrderPayOrderPublicPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

/** The type of item. */
export enum CreateOrderPayOrderPublicTypeEnum1 {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

/** @example "fulfillment" */
export enum CreateOrderPayOrderPublicShippingMethodEnum1 {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

export enum CreateOrderPayOrderPublicServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
  SSCC = 'SSCC',
}

/** OrderSchema */
export interface CreateOrderPayOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** @default "order-pay-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type?: CreateOrderPayOrderPublicTypeEnum;
        /**
         * The VAT rate applied to this item (expressed as a percentage).
         * @min 0
         * @max 100
         * @example 12.5
         */
        vatRate?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount?: number;
        /**
         * The total amount of VAT to collect for this item, in cents.
         * @min 0
         */
        amountVat?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
         * @min 0
         */
        amountWithVat?: number;
      }[];
      status?: CreateOrderPayOrderPublicStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: CreateOrderPayOrderPublicShippingMethodEnum;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** @default "order-pay-payments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: CreateOrderPayOrderPublicPspEnum;
          /** Status of the payment */
          status: CreateOrderPayOrderPublicStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: CreateOrderPayOrderPublicPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-pay-transactions" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

/** The type of item. */
export enum ShowOrderPayOrderPublicTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum ShowOrderPayOrderPublicStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum ShowOrderPayOrderPublicShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum ShowOrderPayOrderPublicPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum ShowOrderPayOrderPublicStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum ShowOrderPayOrderPublicPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

export interface ShowOrderPayOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: payment,payment.transactions) */
  include?: IncludeEnum22;
  /**
   * UUID of the requested resource
   * @format uuid
   */
  id: string;
}

/** A comma-separated list of resources to include (e.g: payment,payment.transactions) */
export enum IncludeEnum22 {
  Payment = 'payment',
  PaymentTransactions = 'payment.transactions',
}

/** OrderSchema */
export interface ShowOrderPayOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** @default "order-pay-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type?: ShowOrderPayOrderPublicTypeEnum;
        /**
         * The VAT rate applied to this item (expressed as a percentage).
         * @min 0
         * @max 100
         * @example 12.5
         */
        vatRate?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount?: number;
        /**
         * The total amount of VAT to collect for this item, in cents.
         * @min 0
         */
        amountVat?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
         * @min 0
         */
        amountWithVat?: number;
      }[];
      status?: ShowOrderPayOrderPublicStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: ShowOrderPayOrderPublicShippingMethodEnum;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** @default "order-pay-payments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: ShowOrderPayOrderPublicPspEnum;
          /** Status of the payment */
          status: ShowOrderPayOrderPublicStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: ShowOrderPayOrderPublicPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-pay-transactions" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

/** A comma-separated list of resources to include (e.g: payment,payment.transactions) */
export enum ShowOrderPayOrderPublicParams1IncludeEnum {
  Payment = 'payment',
  PaymentTransactions = 'payment.transactions',
}

/** The type of item. */
export enum UpdateOrderPayOrderPublicTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum UpdateOrderPayOrderPublicStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum UpdateOrderPayOrderPublicShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum UpdateOrderPayOrderPublicPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum UpdateOrderPayOrderPublicStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum UpdateOrderPayOrderPublicPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

/** The type of item. */
export enum UpdateOrderPayOrderPublicTypeEnum1 {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum UpdateOrderPayOrderPublicServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
  SSCC = 'SSCC',
}

/** OrderSchema */
export interface UpdateOrderPayOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** @default "order-pay-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type?: UpdateOrderPayOrderPublicTypeEnum;
        /**
         * The VAT rate applied to this item (expressed as a percentage).
         * @min 0
         * @max 100
         * @example 12.5
         */
        vatRate?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount?: number;
        /**
         * The total amount of VAT to collect for this item, in cents.
         * @min 0
         */
        amountVat?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
         * @min 0
         */
        amountWithVat?: number;
      }[];
      status?: UpdateOrderPayOrderPublicStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: UpdateOrderPayOrderPublicShippingMethodEnum;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** @default "order-pay-payments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: UpdateOrderPayOrderPublicPspEnum;
          /** Status of the payment */
          status: UpdateOrderPayOrderPublicStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: UpdateOrderPayOrderPublicPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-pay-transactions" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

/** The type of item. */
export enum CancelOrderPayOrderPublicTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum CancelOrderPayOrderPublicStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum CancelOrderPayOrderPublicShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum CancelOrderPayOrderPublicPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum CancelOrderPayOrderPublicStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum CancelOrderPayOrderPublicPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

/** OrderSchema */
export interface CancelOrderPayOrderPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** @default "order-pay-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type?: CancelOrderPayOrderPublicTypeEnum;
        /**
         * The VAT rate applied to this item (expressed as a percentage).
         * @min 0
         * @max 100
         * @example 12.5
         */
        vatRate?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount?: number;
        /**
         * The total amount of VAT to collect for this item, in cents.
         * @min 0
         */
        amountVat?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
         * @min 0
         */
        amountWithVat?: number;
      }[];
      status?: CancelOrderPayOrderPublicStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: CancelOrderPayOrderPublicShippingMethodEnum;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** @default "order-pay-payments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: CancelOrderPayOrderPublicPspEnum;
          /** Status of the payment */
          status: CancelOrderPayOrderPublicStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: CancelOrderPayOrderPublicPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-pay-transactions" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

/** The type of item. */
export enum ConfirmOrderPayOrderByBrandPublicTypeEnum {
  ShippingFees = 'shippingFees',
  ExciseDuties = 'exciseDuties',
  EcoTax = 'ecoTax',
}

export enum ConfirmOrderPayOrderByBrandPublicStatusEnum {
  Created = 'created',
  BrandConfirmed = 'brand_confirmed',
  PaymentConfirmed = 'payment_confirmed',
  WaitingShipping = 'waiting_shipping',
  Shipped = 'shipped',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** @example "fulfillment" */
export enum ConfirmOrderPayOrderByBrandPublicShippingMethodEnum {
  Custom = 'custom',
  Fulfillment = 'fulfillment',
}

/** The payment service provider selected for the payment */
export enum ConfirmOrderPayOrderByBrandPublicPspEnum {
  Stripe = 'stripe',
}

/** Status of the payment */
export enum ConfirmOrderPayOrderByBrandPublicStatusEnum1 {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

/** The payment method selected for the payment */
export enum ConfirmOrderPayOrderByBrandPublicPaymentMethodEnum {
  SepaCreditTransfer = 'sepa_credit_transfer',
  SepaDirectDebit = 'sepa_direct_debit',
  Card = 'card',
  Paypal = 'paypal',
}

/** OrderSchema */
export interface ConfirmOrderPayOrderByBrandPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** OrderResource */
  data: {
    /** @default "order-pay-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    relationships?: any;
    attributes?: {
      /**
       * @format date-time
       * @example "2024-07-01T13:00:50.000000Z"
       */
      createdAt: string;
      /**
       * @format uuid
       * @example "2cef2271-11fd-4cfc-925f-d5ea761229c6"
       */
      customerUuid: string;
      /** @example 20 */
      discountRate: number;
      /** List of items with their corresponding quantities and unit amounts. */
      items: {
        /**
         * Product variant UUID.
         * @format uuid
         * @example "1ef2e4f1-5a37-66c6-9399-c66dfcccaea9"
         */
        productVariantUuid: string;
        /**
         * Product variant name.
         * @example "Voluptas ut consequatur (1789457692, Jaune de Mars)"
         */
        productVariantName: string;
        /**
         * Quantity of bundles of the item (ex: 2 boxes of 6 bottles of wine each: `quantity = 2`)
         * @example 7
         */
        quantity: number;
        /**
         * Total quantity of individual units of the item (ex: 2 boxes of 6 bottles of wine each: `multipliedQuantity = 12`)
         * @example 7
         */
        multipliedQuantity: number;
        /** Total amounts of the order item. */
        amounts: {
          /** @example "EUR" */
          brandCurrency: string;
          /** @example 1 */
          brandCurrencyRate: number;
          /** @example 1700 */
          brandUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          brandUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          brandUnitPrice: number;
          /** @example "€13.60" */
          brandUnitPriceFormatted: string;
          /** @example 11900 */
          brandAmountBeforeDiscount: number;
          /** @example "€119.00" */
          brandAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          brandDiscountAmount: number;
          /** @example "€23.80" */
          brandDiscountAmountFormatted: string;
          /** @example 9520 */
          brandAmount: number;
          /** @example "€95.20" */
          brandAmountFormatted: string;
          /** @example 1809 */
          brandAmountVat: number;
          /** @example "€18.09" */
          brandAmountVatFormatted: string;
          /** @example 11329 */
          brandAmountWithVat: number;
          /** @example "€113.29" */
          brandAmountWithVatFormatted: string;
          /** @example "EUR" */
          customerCurrency: string;
          /** @example 1 */
          customerCurrencyRate: number;
          /** @example 1700 */
          customerUnitPriceBeforeDiscount: number;
          /** @example "€17.00" */
          customerUnitPriceBeforeDiscountFormatted: string;
          /** @example 1360 */
          customerUnitPrice: number;
          /** @example "€13.60" */
          customerUnitPriceFormatted: string;
          /** @example 11900 */
          customerAmountBeforeDiscount: number;
          /** @example "€119.00" */
          customerAmountBeforeDiscountFormatted: string;
          /** @example 2380 */
          customerDiscountAmount: number;
          /** @example "€23.80" */
          customerDiscountAmountFormatted: string;
          /** @example 9520 */
          customerAmount: number;
          /** @example "€95.20" */
          customerAmountFormatted: string;
          /** @example 1809 */
          customerAmountVat: number;
          /** @example "€18.09" */
          customerAmountVatFormatted: string;
          /** @example 11329 */
          customerAmountWithVat: number;
          /** @example "€113.29" */
          customerAmountWithVatFormatted: string;
          /** @example 19 */
          vatRate: number;
          /** @example 20 */
          discountRate: number;
          /** @example 100 */
          discountAmount: number;
          /** @example "€1.00" */
          discountAmountFormatted: string;
        };
      }[];
      /**
       * A list of items representing custom charges to be applied to the invoice (e.g. shipping fees, excise duties, eco-taxes).
       * @minItems 0
       */
      customItems?: {
        /** The type of item. */
        type?: ConfirmOrderPayOrderByBrandPublicTypeEnum;
        /**
         * The VAT rate applied to this item (expressed as a percentage).
         * @min 0
         * @max 100
         * @example 12.5
         */
        vatRate?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, excluding VAT and expressed in the customer's currency.
         * @min 0
         */
        amount?: number;
        /**
         * The total amount of VAT to collect for this item, in cents.
         * @min 0
         */
        amountVat?: number;
        /**
         * The integer amount in cents representing how much to charge for this custom item, including VAT and expressed in the customer's currency (amount + amountVat).
         * @min 0
         */
        amountWithVat?: number;
      }[];
      status?: ConfirmOrderPayOrderByBrandPublicStatusEnum;
      /** @example "EACN9214515" */
      masterOrderReference?: string | null;
      /**
       * A client-specified ID to associate an entity in another system with this order, such as the Shopify order ID if this is a Shopify order. This reference appears on the invoice issued to the customer.
       * @maxLength 64
       */
      customReference?: string | null;
      /** Total amounts of the order. */
      amounts: {
        /** @example "EUR" */
        brandCurrency: string;
        /** @example 1 */
        brandCurrencyRate: number;
        /** @example 54620 */
        brandTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        brandTotalAmountBeforeDiscountFormatted: string;
        /** @example 0 */
        brandTotalDiscountAmount: number;
        /** @example "€0.00" */
        brandTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        brandTotalAmount: number;
        /** @example "€546.20" */
        brandTotalAmountFormatted: string;
        /** @example 12633 */
        brandTotalAmountVat: number;
        /** @example "€126.33" */
        brandTotalAmountVatFormatted: string;
        /** @example 67253 */
        brandTotalAmountWithVat: number;
        /** @example "€672.53" */
        brandTotalAmountWithVatFormatted: string;
        /** @example "EUR" */
        customerCurrency: string;
        /** @example 1 */
        customerCurrencyRate: number;
        /** @example 54620 */
        customerTotalAmountBeforeDiscount: number;
        /** @example "€546.20" */
        customerTotalAmountBeforeDiscountFormatted: string;
        /** @example 54620 */
        customerTotalDiscountAmount: number;
        /** @example "€0.00" */
        customerTotalDiscountAmountFormatted: string;
        /** @example 54620 */
        customerTotalAmount: number;
        /** @example "€546.20" */
        customerTotalAmountFormatted: string;
        /** @example 12633 */
        customerTotalAmountVat: number;
        /** @example "€126.33" */
        customerTotalAmountVatFormatted: string;
        /** @example 67253 */
        customerTotalAmountWithVat: number;
        /** @example "€672.53" */
        customerTotalAmountWithVatFormatted: string;
        /** @example 220 */
        shippingFeesAmount: number;
        /** @example "€2.20" */
        shippingFeesAmountFormatted: string;
        /** @example 44 */
        shippingFeesAmountVat: number;
        /** @example "€0.44" */
        shippingFeesAmountVatFormatted: string;
        /** @example 264 */
        shippingFeesAmountWithVat: number;
        /** @example "€2.64" */
        shippingFeesAmountWithVatFormatted: string;
        /** @example 54840 */
        customerGrandTotalAmount: number;
        /** @example "€548.40" */
        customerGrandTotalAmountFormatted: string;
        /** @example 12677 */
        customerGrandTotalAmountVat: number;
        /** @example "€126.77" */
        customerGrandTotalAmountVatFormatted: string;
        /** @example 67517 */
        customerGrandTotalAmountWithVat: number;
        /** @example "€675.17" */
        customerGrandTotalAmountWithVatFormatted: string;
      };
      shipping: {
        /** @example "fulfillment" */
        shippingMethod: ConfirmOrderPayOrderByBrandPublicShippingMethodEnum;
        shippingAddress: {
          /** @example "FR" */
          countryCode: string;
          /** @example "92100" */
          postalCode: string;
          /** @example "Boulogne-Billancourt" */
          city: string;
          /** @example "105, rue de Sevres" */
          street: string;
          addressLine?: string | null;
        };
        contactPerson: {
          /** @example "etienne.guillou@roy.com" */
          email: string;
          /** @example "Etienne" */
          firstName: string;
          /** @example "Guillou" */
          lastName: string;
          company?: string | null;
          phoneNumber?: string | null;
        };
      };
      tracking?: {
        /** @example "1Z999AA10123456784" */
        trackingNumber: string;
        /** @example "https://www.ups.com/track?loc=en_US&tracknum=1Z999AA10123456784" */
        trackingLink?: string;
        /** @example "shipped" */
        status: string;
        /** @example false */
        isDelivered: boolean;
      };
    };
  };
  included?: (
    | {
        /** @default "order-pay-payments" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * External order uuid
           * @format uuid
           */
          orderUuid: string;
          /**
           * OrderPay customer uuid (external)
           * @format uuid
           */
          customerUuid: string;
          /**
           * Brand uuid
           * @format uuid
           */
          brandUuid: string;
          /**
           * Creation date of the payment
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider selected for the payment */
          psp: ConfirmOrderPayOrderByBrandPublicPspEnum;
          /** Status of the payment */
          status: ConfirmOrderPayOrderByBrandPublicStatusEnum1;
          amount: number;
          /**
           * ISO 3-Letter Currency Code
           * @example "EUR"
           */
          currency: string;
          /** @format float */
          currencyRate: number;
          /** The payment method selected for the payment */
          paymentMethod: ConfirmOrderPayOrderByBrandPublicPaymentMethodEnum;
          fundedBy?: string | null;
          paymentTerms?: string | null;
        };
        relationships?: {
          transactions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-pay-transactions" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /**
           * Creation date of the transaction
           * @format date-time
           */
          createdAt: string;
          /** The payment service provider transaction id */
          pspId: string;
          amount: number;
          currency: string;
          type: string;
          status: string;
          pspData?: {
            client_secret?: string;
            iban?: {
              bic?: string;
              iban?: string;
              country?: string;
              reference?: string;
            };
          };
        };
      }
  )[];
}

export enum ListOrderShippingQuotesPublicCollectionMethodEnum {
  Pickup = 'pickup',
  DropOff = 'drop-off',
}

export interface ListOrderShippingQuotesPublicData {
  data: {
    /** The unique identifier for the quote as an uuid */
    quoteUuid?: string;
    /** The carrier code for the quote */
    carrierCode?: string;
    /** The service code for the quote */
    serviceCode?: string;
    /** The commercial name of the service */
    serviceCommercialName?: string;
    /** The collection method for the quote */
    collectionMethod?: ListOrderShippingQuotesPublicCollectionMethodEnum[];
    shippingCost?: {
      /** The amount of the shipping cost */
      amount?: number;
      /** The currency of the shipping cost */
      currency?: string;
    };
    /** Delivery estimation information if provided by carrier */
    timeInTransit?: {
      /**
       * Estimation of delivery date by the carrier
       * @format date
       */
      estimatedDeliveryDate?: null | string;
      /**
       * Pickup date considered for the estimation
       * @format date
       */
      pickupDate?: null | string;
      /** Number of business days the shipment is in transit */
      businessDaysInTransit?: null | number;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * This field is not required. If you don't' define it we will use the default label format as well.
 * @default "default"
 */
export enum ConfirmOrderShippingQuotePublicLabelFormatEnum {
  FullPage = 'full_page',
  Default = 'default',
}

export interface ConfirmOrderShippingQuotePublicData {
  data?: {
    id?: string;
    uuid?: string;
    orderUuid?: string;
    provider?: string;
    currency?: string;
    /** Shipping cost subtracted from total amount for ankorstore quote - Available only for ankorstore quote */
    shippingCost?: string;
    /** Refund done to the brand for custom quote - Available only for custom quote */
    refund?: string;
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** @example "ankor_confirmed" */
export enum ShipInternalOrderSchedulePickupPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum ShipInternalOrderSchedulePickupPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum ShipInternalOrderSchedulePickupPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum ShipInternalOrderSchedulePickupPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum ShipInternalOrderSchedulePickupPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum ShipInternalOrderSchedulePickupPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum ShipInternalOrderSchedulePickupPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum ShipInternalOrderSchedulePickupPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum ShipInternalOrderSchedulePickupPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum ShipInternalOrderSchedulePickupPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum ShipInternalOrderSchedulePickupPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum ShipInternalOrderSchedulePickupPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum ShipInternalOrderSchedulePickupPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

/** Order Get */
export interface ShipInternalOrderSchedulePickupPublicData {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: ShipInternalOrderSchedulePickupPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: ShipInternalOrderSchedulePickupPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: ShipInternalOrderSchedulePickupPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: ShipInternalOrderSchedulePickupPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: ShipInternalOrderSchedulePickupPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: ShipInternalOrderSchedulePickupPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: ShipInternalOrderSchedulePickupPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: ShipInternalOrderSchedulePickupPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: ShipInternalOrderSchedulePickupPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: ShipInternalOrderSchedulePickupPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: ShipInternalOrderSchedulePickupPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: ShipInternalOrderSchedulePickupPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: ShipInternalOrderSchedulePickupPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface GetBrandsShippingSettingsPublicData {
  /** ShippingSettingsResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      publicAddress: {
        street: string;
        postalCode: string;
        city: string;
        countryCode: string;
      };
      shippingAddress: {
        street: string;
        postalCode: string;
        city: string;
        countryCode: string;
      };
      billingAddress: {
        street: string;
        postalCode: string;
        city: string;
        countryCode: string;
      };
      eoriNumber: string;
      lucidNumber: string;
      averageLeadTime: string;
      /** List of country iso codes */
      whitelistCountries: string[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/**
 * Average lead time range in business days. Must be one of: 0-2, 3-5, 6-10, 11-20, 21-30
 * @example "3-5"
 */
export enum UpdateBrandsShippingSettingsPublicAverageLeadTimeEnum {
  Value02 = '0-2',
  Value35 = '3-5',
  Value610 = '6-10',
  Value1120 = '11-20',
  Value2130 = '21-30',
}

export interface UpdateBrandsShippingSettingsPublicData {
  /** ShippingSettingsResource */
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      publicAddress: {
        street: string;
        postalCode: string;
        city: string;
        countryCode: string;
      };
      shippingAddress: {
        street: string;
        postalCode: string;
        city: string;
        countryCode: string;
      };
      billingAddress: {
        street: string;
        postalCode: string;
        city: string;
        countryCode: string;
      };
      eoriNumber: string;
      lucidNumber: string;
      averageLeadTime: string;
      /** List of country iso codes */
      whitelistCountries: string[];
    };
  };
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum GetBrandsFuturlogIntegrationPublicTypeEnum {
  FuturlogIntegration = 'futurlog-integration',
}

export interface GetBrandsFuturlogIntegrationPublicData {
  data: null | {
    type: GetBrandsFuturlogIntegrationPublicTypeEnum;
    /** @format uuid */
    id: string;
    attributes: {
      merchantCode: string;
    };
  };
}

export enum UpsertBrandsFuturlogIntegrationPublicTypeEnum {
  FuturlogIntegration = 'futurlog-integration',
}

export enum UpsertBrandsFuturlogIntegrationPublicTypeEnum1 {
  FuturlogIntegration = 'futurlog-integration',
}

export enum UpsertBrandsFuturlogIntegrationPublicTypeEnum2 {
  FuturlogIntegration = 'futurlog-integration',
}

export interface UpsertBrandsFuturlogIntegrationPublicData {
  data: {
    type: UpsertBrandsFuturlogIntegrationPublicTypeEnum;
    /** @format uuid */
    id: string;
    attributes: {
      merchantCode: string;
    };
  };
}

export type DeleteBrandsFuturlogIntegrationPublicData = any;

export interface FulfillmentListBundlesPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
}

export interface FulfillmentListBundlesPublicData {
  data: {
    /** @default "fulfillment-bundle" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      productVariantId?: string;
      items?: {
        /** @format uuid */
        fulfillmentItemId?: string;
        /** The number of items in the bundle */
        quantity?: number;
      }[];
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentListOrdersPublicStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum FulfillmentListOrdersPublicRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum FulfillmentListOrdersPublicServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum FulfillmentListOrdersPublicStatusEnum1 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

export interface FulfillmentListOrdersPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /** Request a specific status only */
  'filter[status]'?: FilterStatusEnum3;
  /** List of fulfillment orders uuids */
  'filter[uuid]'?: string[];
  /**
   * Specify what attribute(s) to sort by
   * @default "-createdAt"
   */
  sort?: SortEnum6;
  /** A comma-separated list of resources to include (e.g: statusUpdates) */
  include?: IncludeEnum23;
}

/** Request a specific status only */
export enum FilterStatusEnum3 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * Specify what attribute(s) to sort by
 * @default "-createdAt"
 */
export enum SortEnum6 {
  CreatedAt = 'createdAt',
  ValueCreatedAt = '-createdAt',
}

/** A comma-separated list of resources to include (e.g: statusUpdates) */
export enum IncludeEnum23 {
  StatusUpdates = 'statusUpdates',
}

export interface FulfillmentListOrdersPublicData {
  data: {
    /** @default "fulfillment-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Unique human readable reference for the fulfillment order, used for communication with the warehouse
       * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
       */
      reference?: string;
      status?: FulfillmentListOrdersPublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        /** quantity in batches */
        quantity: number;
        lotNumber?: null | string;
        /** @format date-time */
        expiryDate?: null | string;
      }[];
      shippedItems?: {
        /** @format uuid */
        fulfillableId: string;
        batchQuantity: number;
        unitQuantity: number;
        lotNumber?: null | string;
        /** @format date-time */
        expiryDate?: null | string;
      }[];
      /**
       * The type of recipient for a fulfillment order
       * @default "business"
       */
      recipientType?: FulfillmentListOrdersPublicRecipientTypeEnum;
      externalReference?: string | null;
      /**
       * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
       * @deprecated
       */
      instructionText?: string | null;
      instructions?: {
        externalReference?: string | null;
        deliverySchedule?: {
          /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
          timeSlots:
            | {
                /**
                 * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "09:30"
                 */
                startTime: string;
                /**
                 * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "12:30"
                 */
                endTime: string;
              }[]
            | null;
          /**
           * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
           * @minItems 1
           * @uniqueItems true
           * @example [1,2,3]
           */
          openDays: number[];
        } | null;
        packingInstruction?: {
          /**
           * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
           * @minItems 1
           */
          services: FulfillmentListOrdersPublicServicesEnum[];
          /** Instruction text for packing the order. */
          instruction?: string;
        } | null;
      } | null;
    };
    links?: {
      order?: string;
    };
    relationships?: {
      statusUpdates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** @default "fulfillment-order-status-updates" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    /** Fulfillment order status update */
    attributes?: {
      status?: FulfillmentListOrdersPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string;
    };
  }[];
}

/** Request a specific status only */
export enum FulfillmentListOrdersPublicParams1FilterStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * Specify what attribute(s) to sort by
 * @default "-createdAt"
 */
export enum FulfillmentListOrdersPublicParams1SortEnum {
  CreatedAt = 'createdAt',
  ValueCreatedAt = '-createdAt',
}

/** A comma-separated list of resources to include (e.g: statusUpdates) */
export enum FulfillmentListOrdersPublicParams1IncludeEnum {
  StatusUpdates = 'statusUpdates',
}

export enum FulfillmentGetOrderPublicStatusEnum {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

/**
 * The type of recipient for a fulfillment order
 * @default "business"
 */
export enum FulfillmentGetOrderPublicRecipientTypeEnum {
  Consumer = 'consumer',
  Business = 'business',
}

export enum FulfillmentGetOrderPublicServicesEnum {
  PALLETISE = 'PALLETISE',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  DOCS = 'DOCS',
}

export enum FulfillmentGetOrderPublicStatusEnum1 {
  Internal = 'internal',
  Requested = 'requested',
  Created = 'created',
  Scheduled = 'scheduled',
  Released = 'released',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  CancellationRequested = 'cancellation_requested',
}

export interface FulfillmentGetOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: statusUpdates) */
  include?: IncludeEnum24;
  /**
   * Fulfillment order ID
   * @format uuid
   */
  id: string;
}

/** A comma-separated list of resources to include (e.g: statusUpdates) */
export enum IncludeEnum24 {
  StatusUpdates = 'statusUpdates',
}

export interface FulfillmentGetOrderPublicData {
  data: {
    /** @default "fulfillment-orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * Unique human readable reference for the fulfillment order, used for communication with the warehouse
       * @pattern ^O_[0-9]{1,18}|[A-HJ-NP-TV-Z0-9]+(_\d+)?$
       */
      reference?: string;
      status?: FulfillmentGetOrderPublicStatusEnum;
      /** @format date-time */
      createdAt?: string;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        /** quantity in batches */
        quantity: number;
        lotNumber?: null | string;
        /** @format date-time */
        expiryDate?: null | string;
      }[];
      shippedItems?: {
        /** @format uuid */
        fulfillableId: string;
        batchQuantity: number;
        unitQuantity: number;
        lotNumber?: null | string;
        /** @format date-time */
        expiryDate?: null | string;
      }[];
      /**
       * The type of recipient for a fulfillment order
       * @default "business"
       */
      recipientType?: FulfillmentGetOrderPublicRecipientTypeEnum;
      externalReference?: string | null;
      /**
       * [Deprecated] This field is deprecated and will be removed in a future version. Use instructions.externalReference instead
       * @deprecated
       */
      instructionText?: string | null;
      instructions?: {
        externalReference?: string | null;
        deliverySchedule?: {
          /** Opening times for the customer's business. The time slots when the customer is available for delivery expressed as ranges in 24-hour time format. When null, the customer can be delivered anytime. */
          timeSlots:
            | {
                /**
                 * Start of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "09:30"
                 */
                startTime: string;
                /**
                 * End of the opening time expressed in a 24-hour time format (e.g. `14:00`).
                 * @example "12:30"
                 */
                endTime: string;
              }[]
            | null;
          /**
           * The opening days for the customer's business. ISO 8601 numeric representation of the day of the week (`1` for Monday through `7` for Sunday).
           * @minItems 1
           * @uniqueItems true
           * @example [1,2,3]
           */
          openDays: number[];
        } | null;
        packingInstruction?: {
          /**
           * List of services to be performed on the order. Either `PALLETISE`, `DOCS` or `CUSTOM_BUILD`
           * @minItems 1
           */
          services: FulfillmentGetOrderPublicServicesEnum[];
          /** Instruction text for packing the order. */
          instruction?: string;
        } | null;
      } | null;
    };
    links?: {
      order?: string;
    };
    relationships?: {
      statusUpdates?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: {
    /** @default "fulfillment-order-status-updates" */
    type?: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id?: string;
    /** Fulfillment order status update */
    attributes?: {
      status?: FulfillmentGetOrderPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string;
    };
  }[];
}

/** A comma-separated list of resources to include (e.g: statusUpdates) */
export enum FulfillmentGetOrderPublicParams1IncludeEnum {
  StatusUpdates = 'statusUpdates',
}

export enum FulfillmentListFulfillablePublicStatusEnum {
  Created = 'created',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
  Synced = 'synced',
}

export interface FulfillmentListFulfillablePublicParams {
  /**
   * A set of UUIDs representing the fulfillables to check availability for
   * @minItems 1
   */
  'fulfillableIds[]': string[];
  /** A comma-separated list of resources to include (e.g: item,lots) */
  include?: IncludeEnum25;
}

/** A comma-separated list of resources to include (e.g: item,lots) */
export enum IncludeEnum25 {
  Item = 'item',
  Lots = 'lots',
}

export interface FulfillmentListFulfillablePublicData {
  data: {
    /** @default "fulfillment-fulfillables" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** A fulfillable entity, which can be either an item or a bundle (set of items) */
    attributes: {
      /** @format uuid */
      fulfillableId: string;
      /** quantity in batches */
      batchQuantity: number;
      /** quantity in units */
      unitQuantity: number;
    };
    relationships?: {
      item?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } | null;
      };
      lots?: {
        /** An array of objects each containing `type` and `id` members for to-many relationships. */
        data?:
          | {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[]
          | null;
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  included?: (
    | {
        /** @default "fulfillment-lots" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** @format uuid */
          fulfillmentItemId: string;
          availableQuantity: number;
          /**
           * Optional expiry date of the lot
           * @format date-time
           */
          expiryDate?: string | null;
          /**
           * If the lot can expire, last point in time when this lot can be used to fulfill an order
           * @format date-time
           */
          sellByDate?: string | null;
          lotNumber: string;
        };
        relationships?: object;
      }
    | {
        /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        /**
         * FulfillmentItem
         * Fulfillment item as exposed on the public API. Stock information (availableQuantity, stockStatus) is not included — use the stock API instead.
         */
        attributes: {
          /** @format uuid */
          productVariantId: string;
          barcode: string;
          unitsPerBatch: number;
          /** @format float */
          unitCostMargin: number;
          /** @format float */
          unitCost: number;
          sku: string;
          productName: string;
          categoryName: string;
          classificationCode?: string | null;
          expiryTracked?: boolean;
          shelfLife?: number | null;
          lotTracked?: boolean;
          isFragile?: boolean | null;
          isOrganic?: boolean | null;
          needRepack?: boolean | null;
          needRelabel?: boolean | null;
          alcoholCode?: number | null;
          /** @format float */
          alcoholPercentage?: number | null;
          /** @format float */
          volumeOfLiquidPerPack?: number | null;
          icpeCode?: number | null;
          packingRules?: object | null;
          status?: FulfillmentListFulfillablePublicStatusEnum;
          expectedStockForDays?: number | null;
          referenceId?: string;
        };
      }
  )[];
}

/** A comma-separated list of resources to include (e.g: item,lots) */
export enum FulfillmentListFulfillablePublicParams1IncludeEnum {
  Item = 'item',
  Lots = 'lots',
}

export enum FulfillmentListItemsPublicStatusEnum {
  Created = 'created',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
  Synced = 'synced',
}

export interface FulfillmentListItemsPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /**
   * Filter by fulfillment item UUIDs
   * @minItems 1
   */
  'filter[id]'?: string[];
  /**
   * Filter items by product variant UUIDs
   * @minItems 1
   */
  'filter[productVariantIds]'?: string[];
  /**
   * Filter by item status. Accepts either a single status or an array of statuses
   * (e.g. `filter[status][]=synced&filter[status][]=pending_measurements`).
   */
  'filter[status]'?: FilterStatusEnum4 | FilterStatusEnum5[];
  /** Specify what attribute(s) to sort by */
  sort?: SortEnum7;
}

export enum FilterStatusEnum4 {
  Synced = 'synced',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
}

export enum FilterStatusEnum5 {
  Synced = 'synced',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
}

/** Specify what attribute(s) to sort by */
export enum SortEnum7 {
  ExpectZeroStockAt = 'expectZeroStockAt',
  ValueExpectZeroStockAt = '-expectZeroStockAt',
}

export interface FulfillmentListItemsPublicData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /**
     * FulfillmentItem
     * Fulfillment item as exposed on the public API. Stock information (availableQuantity, stockStatus) is not included — use the stock API instead.
     */
    attributes: {
      /** @format uuid */
      productVariantId: string;
      barcode: string;
      unitsPerBatch: number;
      /** @format float */
      unitCostMargin: number;
      /** @format float */
      unitCost: number;
      sku: string;
      productName: string;
      categoryName: string;
      classificationCode?: string | null;
      expiryTracked?: boolean;
      shelfLife?: number | null;
      lotTracked?: boolean;
      isFragile?: boolean | null;
      isOrganic?: boolean | null;
      needRepack?: boolean | null;
      needRelabel?: boolean | null;
      alcoholCode?: number | null;
      /** @format float */
      alcoholPercentage?: number | null;
      /** @format float */
      volumeOfLiquidPerPack?: number | null;
      icpeCode?: number | null;
      packingRules?: object | null;
      status?: FulfillmentListItemsPublicStatusEnum;
      expectedStockForDays?: number | null;
      referenceId?: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentListItemsPublicParams1FilterStatusEnum {
  Synced = 'synced',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
}

export enum FulfillmentListItemsPublicParams1FilterStatusEnum1 {
  Synced = 'synced',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
}

/** Specify what attribute(s) to sort by */
export enum FulfillmentListItemsPublicParams1SortEnum {
  ExpectZeroStockAt = 'expectZeroStockAt',
  ValueExpectZeroStockAt = '-expectZeroStockAt',
}

export enum FulfillmentCreateItemPublicStatusEnum {
  Created = 'created',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
  Synced = 'synced',
}

export interface FulfillmentCreateItemPublicData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /**
     * FulfillmentItem
     * Fulfillment item as exposed on the public API. Stock information (availableQuantity, stockStatus) is not included — use the stock API instead.
     */
    attributes: {
      /** @format uuid */
      productVariantId: string;
      barcode: string;
      unitsPerBatch: number;
      /** @format float */
      unitCostMargin: number;
      /** @format float */
      unitCost: number;
      sku: string;
      productName: string;
      categoryName: string;
      classificationCode?: string | null;
      expiryTracked?: boolean;
      shelfLife?: number | null;
      lotTracked?: boolean;
      isFragile?: boolean | null;
      isOrganic?: boolean | null;
      needRepack?: boolean | null;
      needRelabel?: boolean | null;
      alcoholCode?: number | null;
      /** @format float */
      alcoholPercentage?: number | null;
      /** @format float */
      volumeOfLiquidPerPack?: number | null;
      icpeCode?: number | null;
      packingRules?: object | null;
      status?: FulfillmentCreateItemPublicStatusEnum;
      expectedStockForDays?: number | null;
      referenceId?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentGetItemPublicStatusEnum {
  Created = 'created',
  Pending = 'pending',
  PendingMeasurements = 'pending_measurements',
  Synced = 'synced',
}

export interface FulfillmentGetItemPublicData {
  data: {
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /**
     * FulfillmentItem
     * Fulfillment item as exposed on the public API. Stock information (availableQuantity, stockStatus) is not included — use the stock API instead.
     */
    attributes: {
      /** @format uuid */
      productVariantId: string;
      barcode: string;
      unitsPerBatch: number;
      /** @format float */
      unitCostMargin: number;
      /** @format float */
      unitCost: number;
      sku: string;
      productName: string;
      categoryName: string;
      classificationCode?: string | null;
      expiryTracked?: boolean;
      shelfLife?: number | null;
      lotTracked?: boolean;
      isFragile?: boolean | null;
      isOrganic?: boolean | null;
      needRepack?: boolean | null;
      needRelabel?: boolean | null;
      alcoholCode?: number | null;
      /** @format float */
      alcoholPercentage?: number | null;
      /** @format float */
      volumeOfLiquidPerPack?: number | null;
      icpeCode?: number | null;
      packingRules?: object | null;
      status?: FulfillmentGetItemPublicStatusEnum;
      expectedStockForDays?: number | null;
      referenceId?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface FulfillmentListItemLotsPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /** Specify what attribute(s) to sort by */
  sort?: SortEnum8;
  /**
   * Fulfillment item ID
   * @format uuid
   */
  id: string;
}

/** Specify what attribute(s) to sort by */
export enum SortEnum8 {
  CreatedAt = 'createdAt',
}

export interface FulfillmentListItemLotsPublicData {
  data: {
    /** @default "fulfillment-lots" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      fulfillmentItemId: string;
      availableQuantity: number;
      /**
       * Optional expiry date of the lot
       * @format date-time
       */
      expiryDate?: string | null;
      /**
       * If the lot can expire, last point in time when this lot can be used to fulfill an order
       * @format date-time
       */
      sellByDate?: string | null;
      lotNumber: string;
    };
    relationships?: object;
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Specify what attribute(s) to sort by */
export enum FulfillmentListItemLotsPublicParams1SortEnum {
  CreatedAt = 'createdAt',
}

export interface FulfillmentListItemLotsRelationshipsPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /** Specify what attribute(s) to sort by */
  sort?: SortEnum9;
  /**
   * Fulfillment item ID
   * @format uuid
   */
  id: string;
}

/** Specify what attribute(s) to sort by */
export enum SortEnum9 {
  CreatedAt = 'createdAt',
}

export interface FulfillmentListItemLotsRelationshipsPublicData {
  /**
   * An array of objects each containing `type` and `id` members for to-many relationships.
   * @uniqueItems true
   */
  data: {
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
    type: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Specify what attribute(s) to sort by */
export enum FulfillmentListItemLotsRelationshipsPublicParams1SortEnum {
  CreatedAt = 'createdAt',
}

export interface FulfillmentListLotsPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /** Specify what attribute(s) to sort by */
  sort?: SortEnum10;
  /** Request instances with a available quantity greater or equal to a given value */
  'filter[minAvailableQuantity]'?: number;
  /**
   * Request instances with a last sell by date greater or equal to a given value
   * @format datetime
   */
  'filter[minSellByDate]'?: string;
  /**
   * Request instances with a last sell by date smaller or equal to a given value
   * @format datetime
   */
  'filter[maxSellByDate]'?: string;
  /** A comma-separated list of resources to include (e.g: fulfillmentItem) */
  include?: any;
}

/** Specify what attribute(s) to sort by */
export enum SortEnum10 {
  AvailableQuantity = 'availableQuantity',
  ExpiryDate = 'expiryDate',
  LotNumber = 'lotNumber',
  SellByDate = 'sellByDate',
  FulfillmentItemsProductName = 'fulfillmentItems.productName',
  ValueAvailableQuantity = '-availableQuantity',
  ValueExpiryDate = '-expiryDate',
  ValueLotNumber = '-lotNumber',
  ValueSellByDate = '-sellByDate',
  ValueFulfillmentItemsProductName = '-fulfillmentItems.productName',
}

export interface FulfillmentListLotsPublicData {
  data: {
    /** @default "fulfillment-lots" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      fulfillmentItemId: string;
      availableQuantity: number;
      /**
       * Optional expiry date of the lot
       * @format date-time
       */
      expiryDate?: string | null;
      /**
       * If the lot can expire, last point in time when this lot can be used to fulfill an order
       * @format date-time
       */
      sellByDate?: string | null;
      lotNumber: string;
    };
    relationships?: object;
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Specify what attribute(s) to sort by */
export enum FulfillmentListLotsPublicParams1SortEnum {
  AvailableQuantity = 'availableQuantity',
  ExpiryDate = 'expiryDate',
  LotNumber = 'lotNumber',
  SellByDate = 'sellByDate',
  FulfillmentItemsProductName = 'fulfillmentItems.productName',
  ValueAvailableQuantity = '-availableQuantity',
  ValueExpiryDate = '-expiryDate',
  ValueLotNumber = '-lotNumber',
  ValueSellByDate = '-sellByDate',
  ValueFulfillmentItemsProductName = '-fulfillmentItems.productName',
}

export enum FulfillmentCostsGetSpecificationsPublicCategoryEnum {
  Shipping = 'shipping',
  OrderPickLt4U = 'order pick lt 4u',
  OrderPickLt40U = 'order pick lt 40u',
  OrderPickGt40U = 'order pick gt 40u',
  UnitPickLt4U = 'unit pick lt 4u',
  UnitPickLt40U = 'unit pick lt 40u',
  UnitPickGt40U = 'unit pick gt 40u',
}

export enum FulfillmentCostsGetSpecificationsPublicTypeEnum {
  FulfillmentOrderCostsSpecification = 'fulfillment-order-costs-specification',
}

/** Type of package, used to route to the parcel or pallet pricing grid. When omitted, it is estimated from the parcel dimensions. */
export enum FulfillmentCostsGetSpecificationsPublicPackageTypeEnum {
  Parcel = 'parcel',
  Pallet = 'pallet',
}

export interface FulfillmentCostsGetSpecificationsPublicData {
  data: {
    /** @default "fulfillment-order-costs" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      category?: FulfillmentCostsGetSpecificationsPublicCategoryEnum;
      /** @min 0 */
      quantity?: number;
      /** @min 0 */
      unitAmount?: number;
      /** @min 0 */
      totalAmount?: number;
      /**
       * @format double
       * @min 0
       * @max 100
       * @example 20
       */
      vatRate?: number;
      /** @min 0 */
      totalAmountWithVat?: number;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** Machine-readable reason code */
export enum FulfillmentFeasibilityCheckPublicDetailEnum {
  NotAFulfillmentBrand = 'not_a_fulfillment_brand',
  UnavailableItems = 'unavailable_items',
  MissingHsCodeForInternationalOrder = 'missing_hs_code_for_international_order',
}

export enum FulfillmentFeasibilityCheckPublicTypeEnum {
  FeasibilityCheck = 'feasibility-check',
}

export type FulfillmentFeasibilityCheckPublicData = any;

export enum FulfillmentListReplenishmentsPublicShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum FulfillmentListReplenishmentsPublicStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum FulfillmentListReplenishmentsPublicStatusEnum1 {
  Created = 'created',
  Sent = 'sent',
  Received = 'received',
  Confirmed = 'confirmed',
  Delivered = 'delivered',
}

export enum FulfillmentListReplenishmentsPublicStatusEnum2 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export interface FulfillmentListReplenishmentsPublicParams {
  'page[limit]'?: number;
  'page[offset]'?: number;
  /**
   * Specify what attribute(s) to sort by
   * @default "-submittedAt"
   */
  sort?: string;
}

export interface FulfillmentListReplenishmentsPublicData {
  data: {
    /** @default "replenishments" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * deprecated, use fulfillmentBrandId instead
       * @deprecated
       */
      brandId?: number;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /** @format uuid */
      warehouseId?: string;
      shippingCarrierName: string;
      shipmentType: FulfillmentListReplenishmentsPublicShipmentTypeEnum;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        quantity: number;
        status?: FulfillmentListReplenishmentsPublicStatusEnum;
      }[];
    } & {
      reference?: string;
      status?: FulfillmentListReplenishmentsPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string | null;
      /** @format date-time */
      deliveredAt?: string | null;
      /** @format date-time */
      confirmedAt?: string | null;
      /** @format date-time */
      submittedAt?: string | null;
      /** @format date-time */
      createdAt?: string;
      receipts?: {
        receiptId?: string;
        /** @format date-time */
        receivedAt?: string;
        items?: {
          /** @format uuid */
          fulfillmentItemId: string;
          quantity: number;
          status?: FulfillmentListReplenishmentsPublicStatusEnum2;
        }[];
      }[];
    };
    relationships?: {
      fulfillmentBrand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      warehouse?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentCreateReplenishmentPublicShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum FulfillmentCreateReplenishmentPublicStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum FulfillmentCreateReplenishmentPublicStatusEnum1 {
  Created = 'created',
  Sent = 'sent',
  Received = 'received',
  Confirmed = 'confirmed',
  Delivered = 'delivered',
}

export enum FulfillmentCreateReplenishmentPublicStatusEnum2 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum FulfillmentCreateReplenishmentPublicShipmentTypeEnum1 {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum FulfillmentCreateReplenishmentPublicStatusEnum3 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export interface FulfillmentCreateReplenishmentPublicData {
  data: {
    /** @default "replenishments" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * deprecated, use fulfillmentBrandId instead
       * @deprecated
       */
      brandId?: number;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /** @format uuid */
      warehouseId?: string;
      shippingCarrierName: string;
      shipmentType: FulfillmentCreateReplenishmentPublicShipmentTypeEnum;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        quantity: number;
        status?: FulfillmentCreateReplenishmentPublicStatusEnum;
      }[];
    } & {
      reference?: string;
      status?: FulfillmentCreateReplenishmentPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string | null;
      /** @format date-time */
      deliveredAt?: string | null;
      /** @format date-time */
      confirmedAt?: string | null;
      /** @format date-time */
      submittedAt?: string | null;
      /** @format date-time */
      createdAt?: string;
      receipts?: {
        receiptId?: string;
        /** @format date-time */
        receivedAt?: string;
        items?: {
          /** @format uuid */
          fulfillmentItemId: string;
          quantity: number;
          status?: FulfillmentCreateReplenishmentPublicStatusEnum2;
        }[];
      }[];
    };
    relationships?: {
      fulfillmentBrand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      warehouse?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentGetReplenishmentPublicShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum FulfillmentGetReplenishmentPublicStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum FulfillmentGetReplenishmentPublicStatusEnum1 {
  Created = 'created',
  Sent = 'sent',
  Received = 'received',
  Confirmed = 'confirmed',
  Delivered = 'delivered',
}

export enum FulfillmentGetReplenishmentPublicStatusEnum2 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export interface FulfillmentGetReplenishmentPublicData {
  data: {
    /** @default "replenishments" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * deprecated, use fulfillmentBrandId instead
       * @deprecated
       */
      brandId?: number;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /** @format uuid */
      warehouseId?: string;
      shippingCarrierName: string;
      shipmentType: FulfillmentGetReplenishmentPublicShipmentTypeEnum;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        quantity: number;
        status?: FulfillmentGetReplenishmentPublicStatusEnum;
      }[];
    } & {
      reference?: string;
      status?: FulfillmentGetReplenishmentPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string | null;
      /** @format date-time */
      deliveredAt?: string | null;
      /** @format date-time */
      confirmedAt?: string | null;
      /** @format date-time */
      submittedAt?: string | null;
      /** @format date-time */
      createdAt?: string;
      receipts?: {
        receiptId?: string;
        /** @format date-time */
        receivedAt?: string;
        items?: {
          /** @format uuid */
          fulfillmentItemId: string;
          quantity: number;
          status?: FulfillmentGetReplenishmentPublicStatusEnum2;
        }[];
      }[];
    };
    relationships?: {
      fulfillmentBrand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      warehouse?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum FulfillmentPatchReplenishmentPublicShipmentTypeEnum {
  Value = '',
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum FulfillmentPatchReplenishmentPublicStatusEnum {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum FulfillmentPatchReplenishmentPublicStatusEnum1 {
  Created = 'created',
  Sent = 'sent',
  Received = 'received',
  Confirmed = 'confirmed',
  Delivered = 'delivered',
}

export enum FulfillmentPatchReplenishmentPublicStatusEnum2 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export enum FulfillmentPatchReplenishmentPublicShipmentTypeEnum1 {
  LTL = 'LTL',
  FTL = 'FTL',
  PARCEL = 'PARCEL',
}

export enum FulfillmentPatchReplenishmentPublicStatusEnum3 {
  Sent = 'sent',
}

export enum FulfillmentPatchReplenishmentPublicStatusEnum4 {
  Available = 'available',
  Blocked = 'blocked',
  Incoming = 'incoming',
  QualityControl = 'qualityControl',
  Reserved = 'reserved',
  Damaged = 'damaged',
}

export interface FulfillmentPatchReplenishmentPublicData {
  data: {
    /** @default "replenishments" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * deprecated, use fulfillmentBrandId instead
       * @deprecated
       */
      brandId?: number;
      /** @format uuid */
      fulfillmentBrandId?: string;
      /** @format uuid */
      warehouseId?: string;
      shippingCarrierName: string;
      shipmentType: FulfillmentPatchReplenishmentPublicShipmentTypeEnum;
      items: {
        /** @format uuid */
        fulfillmentItemId: string;
        quantity: number;
        status?: FulfillmentPatchReplenishmentPublicStatusEnum;
      }[];
    } & {
      reference?: string;
      status?: FulfillmentPatchReplenishmentPublicStatusEnum1;
      /** @format date-time */
      receivedAt?: string | null;
      /** @format date-time */
      deliveredAt?: string | null;
      /** @format date-time */
      confirmedAt?: string | null;
      /** @format date-time */
      submittedAt?: string | null;
      /** @format date-time */
      createdAt?: string;
      receipts?: {
        receiptId?: string;
        /** @format date-time */
        receivedAt?: string;
        items?: {
          /** @format uuid */
          fulfillmentItemId: string;
          quantity: number;
          status?: FulfillmentPatchReplenishmentPublicStatusEnum2;
        }[];
      }[];
    };
    relationships?: {
      fulfillmentBrand?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      warehouse?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface FulfillmentDeleteDraftReplenishmentPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export interface ListBrandsFrancoPublicParams {
  /** @minItems 1 */
  'filter[brandId]': string[];
}

export interface ListBrandsFrancoPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: 'franco';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format uuid */
      brandId: string;
      amount: number;
      fee: number;
      maxFee: number;
      currency: string;
    };
  }[];
}

export interface ListBrandsFrancoSettingsPublicParams {
  /** Flag to indicate if the request is part of the brand onboarding process */
  isOnboarding?: boolean;
}

export interface ListBrandsFrancoSettingsPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: 'franco-settings';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      corridor: string;
      amount: number;
      currency: string;
      fee: number;
    };
    meta: {
      amountOptions: {
        amount: number;
        currency: string;
        isSpecialDeal: boolean;
        isDefault: boolean;
      }[];
      feeOptions: {
        amount: number;
        currency: string;
        isSpecialDeal: boolean;
        isDefault: boolean;
      }[];
      defaultMaxFeeAmount: number;
      [key: string]: any;
    };
  }[];
}

export enum CreateBrandsFrancoSettingsPublicTypeEnum {
  FrancoSettings = 'franco-settings',
}

export enum CreateBrandsFrancoSettingsPublicCorridorEnum {
  Domestic = 'domestic',
  Eu8 = 'eu8',
  International = 'international',
}

export interface CreateBrandsFrancoSettingsPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** FrancoSettingsResource */
  data: {
    type: 'franco-settings';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      corridor: string;
      amount: number;
      currency: string;
      fee: number;
    };
    meta: {
      amountOptions: {
        amount: number;
        currency: string;
        isSpecialDeal: boolean;
        isDefault: boolean;
      }[];
      feeOptions: {
        amount: number;
        currency: string;
        isSpecialDeal: boolean;
        isDefault: boolean;
      }[];
      defaultMaxFeeAmount: number;
      [key: string]: any;
    };
  };
}

export interface GetBrandRetailerPublicData {
  data: {
    /** @default "brand-retailers" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      automaticOrderValidationMode?: boolean | null;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum CreateBrandContactPublicPurposesEnum {
  Finance = 'finance',
}

export enum CreateBrandContactPublicPurposesEnum1 {
  Finance = 'finance',
}

export enum CreateBrandContactPublicTypeEnum {
  BrandContacts = 'brand-contacts',
}

export enum CreateBrandContactPublicPurposesEnum2 {
  Finance = 'finance',
}

export interface CreateBrandContactPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** BrandContactResource */
  data: {
    type: 'brand-contacts';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format email */
      email: string;
      /** @minItems 1 */
      purposes: CreateBrandContactPublicPurposesEnum[];
    };
  };
}

export enum UpdateBrandContactPublicPurposesEnum {
  Finance = 'finance',
}

export enum UpdateBrandContactPublicTypeEnum {
  BrandContacts = 'brand-contacts',
}

export enum UpdateBrandContactPublicPurposesEnum1 {
  Finance = 'finance',
}

export interface UpdateBrandContactPublicData {
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** BrandContactResource */
  data: {
    type: 'brand-contacts';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** @format email */
      email: string;
      /** @minItems 1 */
      purposes: UpdateBrandContactPublicPurposesEnum[];
    };
  };
}

export type DeleteBrandContactPublicData = any;

export enum PostAuthApiBrandRegistrationPublicTypeEnum {
  BrandRegistrations = 'brand-registrations',
}

export interface PostAuthApiBrandRegistrationPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  /** Non-standard meta-information that can not be represented as an attribute or relationship. */
  meta: Record<string, any>;
}

export enum GetApiV1BrandRegistrationOptionsPublicTypeEnum {
  BrandRegistrationOptions = 'brand-registration-options',
}

export interface GetApiV1BrandRegistrationOptionsPublicData {
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
  data: {
    type: GetApiV1BrandRegistrationOptionsPublicTypeEnum;
    /** @example "default" */
    id: string;
    attributes: {
      /** @example ["home_kitchen","jewellery","fashion_accessories"] */
      categories: string[];
      /**
       * Category value -> its allowed subcategory values (dependent picklist).
       * @example {"home_kitchen":["furniture_decoration","high_tech","pets"]}
       */
      subcategoriesByCategory: Record<string, string[]>;
      /** @example ["days_0_2","days_3_5","days_6_10"] */
      shippingLeadTimes: string[];
      /** @example ["turnover_0_99k","turnover_100k_249k","turnover_250k_499k"] */
      annualTurnovers: string[];
      /** @example ["retailers_none","retailers_1_10","retailers_11_50"] */
      currentRetailers: string[];
      /** @example ["growing_my_business","managing_b2b_network","logistics_services"] */
      goals: string[];
      /** @example ["google","facebook","instagram"] */
      acquisitionChannels: string[];
    };
  };
}

export enum PostApiV1BrandRegistrationChecksPublicTypeEnum {
  BrandRegistrations = 'brand-registrations',
}

export type PostApiV1BrandRegistrationChecksPublicData = any;

export interface GetPlatformConfigPublicData {
  data: {
    /** @default "platform-configs" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      cdn?: string;
      stripePublicKey?: string;
    };
  };
  /** An object describing the server's implementation */
  jsonapi: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum ListApplicationsPublicEventsEnum {
  OrderBrandCreated = 'order.brand_created',
  OrderBrandAccepted = 'order.brand_accepted',
  OrderBrandRejected = 'order.brand_rejected',
  OrderShippingLabelsGenerated = 'order.shipping_labels_generated',
  OrderShipped = 'order.shipped',
  OrderShipmentReceived = 'order.shipment_received',
  OrderShipmentRefused = 'order.shipment_refused',
  OrderBrandPaid = 'order.brand_paid',
  OrderCancelled = 'order.cancelled',
}

export interface ListApplicationsPublicParams {
  /** A comma-separated list of resources to include (e.g: webhookSubscriptions) */
  include?: IncludeEnum26;
}

/** A comma-separated list of resources to include (e.g: webhookSubscriptions) */
export enum IncludeEnum26 {
  WebhookSubscriptions = 'webhookSubscriptions',
}

export interface ListApplicationsPublicData {
  /**
   * ApplicationResource
   * @example {"id":"43efbfbd-bfbd-1eef-1e6a-6200efbfbdef","type":"application","attributes":{"name":"My sandbox","developerEmail":"dev@my-app.com","clientId":"k322k7frs87e8w7hri3jkke7ry7","clientSecret":null}}
   */
  data: {
    type: 'application';
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /** Application given name */
      name: string;
      /**
       * Email of the developer to contact
       * @format email
       * @example "developer@application.com"
       */
      developerEmail: string;
      /** Client ID generated for this application */
      clientId: string;
      /** Secret to be used for access token issuance. Can be invoked only once on application creation */
      clientSecret: null;
    };
    /** Only presented if asked explicitly in the request */
    relationships?: {
      webhookSubscriptions?: {
        /**
         * An array of objects each containing `type` and `id` members for to-many relationships.
         * @uniqueItems true
         */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        }[];
      };
    };
  };
  included?: {
    /** @default "webhook-subscriptions" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /**
       * List of subscribed event types:
       * - `order.brand_created` — A new order has been created and is pending brand confirmation
       * - `order.brand_accepted` — The brand has accepted the order
       * - `order.brand_rejected` — The brand has rejected the order
       * - `order.shipping_labels_generated` — Shipping labels have been generated for the order
       * - `order.shipped` — The order has been shipped
       * - `order.shipment_received` — The retailer has confirmed receipt of the order
       * - `order.shipment_refused` — The retailer has refused the shipment
       * - `order.brand_paid` — Payment has been transferred to the brand
       * - `order.cancelled` — The order has been cancelled
       * @uniqueItems true
       */
      events: ListApplicationsPublicEventsEnum[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: webhookSubscriptions) */
export enum ListApplicationsPublicParams1IncludeEnum {
  WebhookSubscriptions = 'webhookSubscriptions',
}

export interface GetAvailableWebhookEventsPublicData {
  data: {
    /** @default "webhook-events" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
  }[];
}

export enum AddApplicationWebhookSubscriptionPublicEventsEnum {
  OrderBrandCreated = 'order.brand_created',
  OrderBrandAccepted = 'order.brand_accepted',
  OrderBrandRejected = 'order.brand_rejected',
  OrderShippingLabelsGenerated = 'order.shipping_labels_generated',
  OrderShipped = 'order.shipped',
  OrderShipmentReceived = 'order.shipment_received',
  OrderShipmentRefused = 'order.shipment_refused',
  OrderBrandPaid = 'order.brand_paid',
  OrderCancelled = 'order.cancelled',
}

/** @example "webhook-subscription" */
export enum AddApplicationWebhookSubscriptionPublicTypeEnum {
  WebhookSubscription = 'webhook-subscription',
}

export enum AddApplicationWebhookSubscriptionPublicEventsEnum1 {
  OrderBrandCreated = 'order.brand_created',
  OrderBrandAccepted = 'order.brand_accepted',
  OrderBrandRejected = 'order.brand_rejected',
  OrderShippingLabelsGenerated = 'order.shipping_labels_generated',
  OrderShipped = 'order.shipped',
  OrderShipmentReceived = 'order.shipment_received',
  OrderShipmentRefused = 'order.shipment_refused',
  OrderBrandPaid = 'order.brand_paid',
  OrderCancelled = 'order.cancelled',
}

export interface AddApplicationWebhookSubscriptionPublicData {
  /** ApplicationWebhookSubscriptionResource object */
  data: {
    /** @default "webhook-subscriptions" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /**
       * List of subscribed event types:
       * - `order.brand_created` — A new order has been created and is pending brand confirmation
       * - `order.brand_accepted` — The brand has accepted the order
       * - `order.brand_rejected` — The brand has rejected the order
       * - `order.shipping_labels_generated` — Shipping labels have been generated for the order
       * - `order.shipped` — The order has been shipped
       * - `order.shipment_received` — The retailer has confirmed receipt of the order
       * - `order.shipment_refused` — The retailer has refused the shipment
       * - `order.brand_paid` — Payment has been transferred to the brand
       * - `order.cancelled` — The order has been cancelled
       * @uniqueItems true
       */
      events: AddApplicationWebhookSubscriptionPublicEventsEnum[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export enum UpdateApplicationWebhookSubscriptionPublicEventsEnum {
  OrderBrandCreated = 'order.brand_created',
  OrderBrandAccepted = 'order.brand_accepted',
  OrderBrandRejected = 'order.brand_rejected',
  OrderShippingLabelsGenerated = 'order.shipping_labels_generated',
  OrderShipped = 'order.shipped',
  OrderShipmentReceived = 'order.shipment_received',
  OrderShipmentRefused = 'order.shipment_refused',
  OrderBrandPaid = 'order.brand_paid',
  OrderCancelled = 'order.cancelled',
}

/**
 * Available webhook event types:
 * - `order.brand_created` — A new order has been created and is pending brand confirmation
 * - `order.brand_accepted` — The brand has accepted the order
 * - `order.brand_rejected` — The brand has rejected the order
 * - `order.shipping_labels_generated` — Shipping labels have been generated for the order
 * - `order.shipped` — The order has been shipped
 * - `order.shipment_received` — The retailer has confirmed receipt of the order
 * - `order.shipment_refused` — The retailer has refused the shipment
 * - `order.brand_paid` — Payment has been transferred to the brand
 * - `order.cancelled` — The order has been cancelled
 * @example "order.brand_created"
 */
export enum UpdateApplicationWebhookSubscriptionPublicEventsEnum1 {
  OrderBrandCreated = 'order.brand_created',
  OrderBrandAccepted = 'order.brand_accepted',
  OrderBrandRejected = 'order.brand_rejected',
  OrderShippingLabelsGenerated = 'order.shipping_labels_generated',
  OrderShipped = 'order.shipped',
  OrderShipmentReceived = 'order.shipment_received',
  OrderShipmentRefused = 'order.shipment_refused',
  OrderBrandPaid = 'order.brand_paid',
  OrderCancelled = 'order.cancelled',
}

export interface UpdateApplicationWebhookSubscriptionPublicData {
  /** ApplicationWebhookSubscriptionResource object */
  data: {
    /** @default "webhook-subscriptions" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes: {
      /**
       * URL of the service where webhook request will be sent when one of the events from the list occurs
       * @format uri
       * @example "https://my.app/webhook/listener"
       */
      webhookUrl: string;
      /**
       * List of subscribed event types:
       * - `order.brand_created` — A new order has been created and is pending brand confirmation
       * - `order.brand_accepted` — The brand has accepted the order
       * - `order.brand_rejected` — The brand has rejected the order
       * - `order.shipping_labels_generated` — Shipping labels have been generated for the order
       * - `order.shipped` — The order has been shipped
       * - `order.shipment_received` — The retailer has confirmed receipt of the order
       * - `order.shipment_refused` — The retailer has refused the shipment
       * - `order.brand_paid` — Payment has been transferred to the brand
       * - `order.cancelled` — The order has been cancelled
       * @uniqueItems true
       */
      events: UpdateApplicationWebhookSubscriptionPublicEventsEnum[];
      signingSecret: string;
    };
  }[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

export type DeleteApplicationWebhookSubscriptionPublicData = any;

export enum PostApiV1OperationsPublicOpEnum {
  Update = 'update',
}

/**
 * Whether a retailer can order this variant for which stock is not
 * available. Only `deny` is accepted in combination with
 * `isAlwaysInStock=true`: an always-in-stock variant has no stock
 * tracking, so the policy is irrelevant and `continue` cannot be
 * set. Use the `stockQuantity` form of this endpoint to set
 * `continue`.
 * @default "deny"
 */
export enum PostApiV1OperationsPublicInventoryPolicyEnum {
  Deny = 'deny',
}

/**
 * Whether a retailer can order this variant for which stock is not
 * available. `deny` (default) rejects any quantity larger than the
 * available stock quantity; `continue` lets the retailer order any
 * quantity, even when stock is insufficient or the variant is out
 * of stock. Only valid alongside a tracked stock update (this
 * schema). Omit to preserve the variant's current policy.
 * @default "deny"
 */
export enum PostApiV1OperationsPublicInventoryPolicyEnum1 {
  Deny = 'deny',
  Continue = 'continue',
}

export interface PostApiV1OperationsPublicData {
  'atomic:results'?: {
    data: {
      /** @default "product-variants" */
      type: string;
      /**
       * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
       * @format uuid
       */
      id: string;
      attributes?: object;
    };
  }[];
}

/** @example "ankor_confirmed" */
export enum BrandCreateTestOrderPublicStatusEnum {
  AnkorConfirmed = 'ankor_confirmed',
  Rejected = 'rejected',
  BrandConfirmed = 'brand_confirmed',
  ShippingLabelsGenerated = 'shipping_labels_generated',
  FulfillmentRequested = 'fulfillment_requested',
  Shipped = 'shipped',
  ReceptionRefused = 'reception_refused',
  Received = 'received',
  Invoiced = 'invoiced',
  BrandPaid = 'brand_paid',
  Cancelled = 'cancelled',
}

/** The chosen shipping method after going through the shipping process */
export enum BrandCreateTestOrderPublicShippingMethodEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

export enum BrandCreateTestOrderPublicAvailableShippingMethodsEnum {
  Ankorstore = 'ankorstore',
  Custom = 'custom',
}

/** The company providing the shipping service */
export enum BrandCreateTestOrderPublicProviderEnum {
  Ups = 'ups',
  Tnt = 'tnt',
  Gls = 'gls',
  Dpd = 'dpd',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Colissimo = 'colissimo',
  Chronopost = 'chronopost',
}

/**
 * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
 * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
 */
export enum BrandCreateTestOrderPublicProviderEnum1 {
  Custom = 'custom',
  Ups = 'ups',
}

/** The provider of the rate for `rateAmount`. */
export enum BrandCreateTestOrderPublicRateProviderEnum {
  Ups = 'ups',
  Ankorstore = 'ankorstore',
}

/**
 * Type of shipping costs:
 * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
 * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
 */
export enum BrandCreateTestOrderPublicTypeEnum {
  Refund = 'refund',
  Fee = 'fee',
}

/** The unit of distance */
export enum BrandCreateTestOrderPublicDistanceUnitEnum {
  Cm = 'cm',
}

/** The unit of mass */
export enum BrandCreateTestOrderPublicMassUnitEnum {
  G = 'g',
}

/** The current status of the order/parcel */
export enum BrandCreateTestOrderPublicStatusEnum1 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/** The current status of the order/parcel */
export enum BrandCreateTestOrderPublicStatusEnum2 {
  UNKNOWN = 'UNKNOWN',
  PRE_TRANSIT = 'PRE_TRANSIT',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  FAILURE = 'FAILURE',
}

/**
 * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
 *
 * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
 *
 * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
 *
 * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
 *
 * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
 */
export enum BrandCreateTestOrderPublicTypeEnum1 {
  BrandPlatformFees = 'brand_platform_fees',
  BrandNewCustomerFees = 'brand_new_customer_fees',
  BrandPaymentFees = 'brand_payment_fees',
  BrandFastPayment = 'brand_fast_payment',
  BrandFlatShippingFees = 'brand_flat_shipping_fees',
  BrandShippingFees = 'brand_shipping_fees',
  BrandShippingFeesRefund = 'brand_shipping_fees_refund',
  BrandShippingFeesDiscount = 'brand_shipping_fees_discount',
}

/**
 * Whether a retailer can order a product variant for which stock is not
 * available.
 *
 * - `deny` (default): no. A retailer cannot order a quantity larger than
 *
 *
 *   the currently available stock quantity, so the variant cannot be
 *   ordered when it is out of stock, or when the desired quantity exceeds
 *   the available quantity.
 * - `continue`: yes. The retailer can order any quantity, even when stock
 *
 *
 *   is insufficient (desired quantity > available quantity > 0) or the
 *   variant is out of stock (available quantity <= 0).
 *
 * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
 * @default "deny"
 */
export enum BrandCreateTestOrderPublicInventoryPolicyEnum {
  Deny = 'deny',
  Continue = 'continue',
}

export interface BrandCreateTestOrderPublicParams {
  /** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
  include?: IncludeEnum27;
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum IncludeEnum27 {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}

/** Order Get */
export interface BrandCreateTestOrderPublicData {
  /**
   * Order Resource
   * The resource object for Order
   */
  data: {
    /** @default "orders" */
    type: string;
    /**
     * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
     * @format uuid
     */
    id: string;
    attributes?: {
      /**
       * The identifier of the linked master order
       * @format uuid
       */
      masterOrderId?: string;
      /** @example "ankor_confirmed" */
      status?: BrandCreateTestOrderPublicStatusEnum;
      /** The order reference used on shipping labels, communication etc */
      reference?: number;
      /** The currency the brand is paid in */
      brandCurrency?: string;
      /** The amount the brand is paid (total - fees - shipping cost + shipping refund). You may find the Ankorstore fees and the other amounts by including the orders billing items. */
      brandNetAmount?: number;
      /** The total of all order items not including VAT */
      brandTotalAmount?: number;
      /** The total VAT of all order items */
      brandTotalAmountVat?: number;
      /** The total of all order items including VAT */
      brandTotalAmountWithVat?: number;
      /** The chosen shipping method after going through the shipping process */
      shippingMethod?: BrandCreateTestOrderPublicShippingMethodEnum;
      /**
       * Order Resource -> Shipping Overview
       * Contains all information related to either shipping method (`ankorstore` or `custom`). This field is ONLY included when fetching a single order at a time.
       */
      shippingOverview?: {
        /** Available shipping methods to use. Custom is ship with your own carrier outside of Ankorstore. */
        availableShippingMethods: BrandCreateTestOrderPublicAvailableShippingMethodsEnum[];
        /** The address the order needs to be shipped to */
        shipToAddress: {
          /** The first and last name of the recipient */
          name?: null | string;
          /** The organisational name of the recipient */
          organisationName?: null | string;
          street: null | string;
          city: null | string;
          postalCode: null | string;
          countryCode?: null | string;
        };
        /** The minimum and maximum expected shipping dates */
        expectedShippingDates: {
          /** @format datetime */
          minimum: string;
          /** @format datetime */
          maximum: string;
          /** @format datetime */
          updatedMaximum?: null | string;
        };
        /** The company providing the shipping service */
        provider?: BrandCreateTestOrderPublicProviderEnum;
        /** Tracking details of the order */
        tracking?: {
          number?: string;
          /**
           * A URL to view the tracking status
           * @format url
           */
          link?: string;
        };
        /**
         * The quote is the price of the parcel(s) shipping.
         * If this object is null then no quote has been generated.
         */
        latestQuote?: {
          /** Id of the last quote generated. Every time a ship call is done, a new calculation is made based on parcels dimensions and weight sent */
          id: string;
          /**
           * Provider responsible for the calculation. If custom, the calculation is done by Ankorstore and refunded.
           * If any other, the calculation is done by the provider and the shipping price is covered by Ankorstore (most of the case, see shippingCostsOverview section).
           */
          provider: BrandCreateTestOrderPublicProviderEnum1;
          /** The provider of the rate for `rateAmount`. */
          rateProvider?: BrandCreateTestOrderPublicRateProviderEnum;
          /** Amount calculated for the parcels provided. */
          rateAmount?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
          };
          /** Overview of costs related to shipping. This object is displayed only if a shipping cost fee or a refund exists */
          shippingCostsOverview?: {
            /** Lowest denomination of the currency this amount belongs to. */
            amount?: number;
            currency?: string;
            /**
             * Type of shipping costs:
             * If type = `refund` the amount will be refunded to the brand (added to brand net amount).
             * if type = `fee` the amount will be subtracted from brand net amount as a contribution to shipping costs.
             */
            type?: BrandCreateTestOrderPublicTypeEnum;
          };
        };
        /** @uniqueItems true */
        parcels?: {
          /** @max 274 */
          length: number;
          /** @max 274 */
          width: number;
          /** @max 274 */
          height: number;
          /** The unit of distance */
          distanceUnit: BrandCreateTestOrderPublicDistanceUnitEnum;
          /**
           * @min 1
           * @max 30000
           */
          weight: number;
          /** The unit of mass */
          massUnit: BrandCreateTestOrderPublicMassUnitEnum;
          /** The tracking per parcel */
          trackedPackage: {
            /**
             * The URL to download the shipping label
             * @format url
             */
            labelUrl: null | string;
            /** @format datetime */
            eta: null | string;
            trackingNumber?: string;
            trackingLink: string;
            currentStatus: {
              /** The current status of the order/parcel */
              status?: BrandCreateTestOrderPublicStatusEnum1;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        }[];
        transaction?: {
          /** The scheduled pickup, requires an API call to be made after the shipping labels have been generated. */
          pickup: {
            /**
             * The date of the pickup
             * @format datetime
             */
            pickupDate: string;
            /** Opening time of pickup Eg: 10:00:00 */
            readyTime: string;
            /** Close time (pickup required to happen before this time) Eg: 13:00:00 */
            closeTime: string;
            /** The reference number for this pickup */
            externalReferenceId: string;
          };
          /** The tracking details for the overall shipment */
          tracking: {
            /**
             * The estimated time of arrival for the order
             * @format datetime
             */
            eta?: null | string;
            /** The tracking number of the order */
            trackingNumber?: string;
            /**
             * The tracking link for the order
             * @format url
             */
            trackingLink?: string;
            currentStatus?: {
              /** The current status of the order/parcel */
              status?: BrandCreateTestOrderPublicStatusEnum2;
              /** Human readable version of status */
              statusDetails?: string | null;
              /**
               * Last time the status was updated
               * @format datetime
               */
              updatedAt?: string;
              /** Last known location */
              location?: {
                city?: null | string;
                state?: null | string;
                zip?: null | string;
                country?: null | string;
              };
            };
          };
        };
      };
      /** The reason the brand has given for rejecting the order */
      brandRejectReason?: null | string;
      /** The reason the retailer rejected the reception of the order */
      retailerRejectReason?: null | string;
      /** The reason the retailer has given for a cancellation request */
      retailerCancellationRequestReason?: null | string;
      /** The billing address name */
      billingName?: null | string;
      /** The billing address organisation name */
      billingOrganisationName?: null | string;
      /** The billing address street name */
      billingStreet?: null | string;
      /** The billing address postal code */
      billingPostalCode?: null | string;
      /** The billing address city */
      billingCity?: null | string;
      /** The billing address country code - ISO format */
      billingCountryCode?: null | string;
      /**
       * The timestamp of when the order was submitted (order is placed)
       * @format datetime
       */
      submittedAt?: string;
      /**
       * The timestamp of when the order was shipped
       * @format datetime
       */
      shippedAt?: null | string;
      /**
       * The timestamp of when the brand was paid
       * @format datetime
       */
      brandPaidAt?: null | string;
      /**
       * (deprecated) The timestamp of when the order was created (before retailer payment)
       * @format datetime
       */
      createdAt?: string;
      /**
       * The timestamp of when the order was updated (does not include other resources)
       * @format datetime
       */
      updatedAt?: string;
    };
    relationships?: {
      /** Related Retailer Resource */
      retailer?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'retailers';
        };
      };
      /** Related Billing Item Resources */
      billingItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'billing-items';
        })[];
      };
      /** Related Order Item Resources */
      orderItems?: {
        /** @uniqueItems true */
        data?: ({
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        } & {
          type?: 'order-items';
        })[];
      };
      /** Schema: Order Item -> Product Option Resource */
      'orderItems-productOption'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Option Resource -> Product */
      'orderItems-productOption-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource */
      'orderItems-productVariant'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
      /** Schema: Order Item -> Product Variant Resource -> Product */
      'orderItems-productVariant-product'?: {
        /** Resource identification present in Resource Objects and Resource Identifier Objects. */
        data?: {
          /**
           * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
           * @format uuid
           */
          id: string;
          /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
          type: string;
          /** Non-standard meta-information that can not be represented as an attribute or relationship. */
          meta?: Record<string, any>;
        };
      };
    };
  };
  /**
   * To reduce the number of HTTP requests, servers **MAY** allow responses that include related resources along with the requested primary resources. Such responses are called `compound documents`.
   * @uniqueItems true
   */
  included?: (
    | {
        /** @default "retailers" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes: {
          /** The registered company of the retailer */
          companyName?: string | null;
          /** The name of the store */
          storeName?: string;
          /**
           * The store's website
           * @format url
           */
          storeUrl?: string | null;
          /**
           * Contact email for the retailer
           * @format email
           */
          email?: string;
          /** Retailer's first name */
          firstName?: string;
          /** Retailer's last name */
          lastName?: string;
          /** Retailer's tax number */
          taxNumber?: string;
          /** Retailer's VAT number */
          vatNumber?: string;
          /** Retailer's EORI number */
          eoriNumber?: string | null;
          /** Retailer's phone number (E164 format) */
          phoneNumberE164?: string;
          /** The tax field to use - tax or vat number. If the retailer is a sole trader, this field will instead be their sole trading number */
          businessIdentifier?: string;
          /**
           * The timestamp when the retailer was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the retailer was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** The order's belonging to a retailer. See [Order Resource](https://ankorstore.github.io/api-docs/#tag/Order/operation/list-orders) */
          orders?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
    | {
        /** @default "order-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The currency of the amounts for the brand */
          brandCurrency?: string;
          /** The ordered quantity of the product */
          quantity?: number;
          /** Some products are sold in fixed quantities, e.g a case of 6 wine bottles. If the quantity was 2, the multiplied quantity of wine bottles would be 12 (6 x 2). This "unitMultiplier" can be found on the product. */
          multipliedQuantity?: number;
          /**
           * The VAT percentage rate of the order item (0-100)
           * @format float
           */
          vatRate?: number;
          /** The amount due to the brand for this item */
          brandAmount?: number;
          /** The VAT amount due to the brand for this item */
          brandAmountVat?: number;
          /** The amount + VAT due to the brand for this item */
          brandAmountWithVat?: number;
          /** The cost of a single unit of this item */
          brandUnitPrice?: number;
          /**
           * The timestamp this order item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp this order item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOptions?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
        /** Non-standard meta-information that can not be represented as an attribute or relationship. */
        meta?: Record<string, any>;
      }
    | {
        /** @default "billing-items" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /**
           * The `brand_platform_fees` is a commission for using our platform. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_new_customer_fees` is a commission on the first Order between brand and retailer. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_payment_fees` is a commission to guarantee Payment for brand. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_fast_payment` is a commission for using our fast payment feature. It will be a negative amount which reduces the total amount paid to the brand.
           *
           * The `brand_flat_shipping_fees` is the shipping cost collected from the retailer when the order is below brand Franco. It is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees` is a shipping cost. This type reduces the amount paid to the brand (but will be a positive value).
           *
           * The `brand_shipping_fees_refund` is a refund from Ankorstore to brand for shipping. This type is positive and adds to the total amount paid.
           *
           * The `brand_shipping_fees_discount` is a referral shipping offer. This type is positive and adds to the total amount paid.
           *
           * There still might also be legacy types which are not listed here but they will be removed in the nearest future.
           */
          type?: BrandCreateTestOrderPublicTypeEnum1;
          /** The currency of the billing item */
          currency?: string;
          /**
           * The VAT percentage rate of the billing item, (from 0 - 100).
           * @format float
           */
          vatRate?: number;
          /**
           * If the currency is not in EUR, this is the conversion rate used
           * @format float
           */
          currencyRate?: number;
          /** The amount for the billing item */
          amount?: number;
          /** The VAT amount for the billing item */
          amountVat?: number;
          /** The amount including VAT for the billing item */
          amountWithVat?: number;
          /**
           * The timestamp when the billing item was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the billing item was updated
           * @format datetime
           */
          updatedAt?: string;
        };
      }
    | {
        /** @default "product-options" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the option */
          name?: string;
          /** The SKU of the option */
          sku?: string;
          /** The IAN (EAN) of the option, can be null */
          ian?: null | string;
          /** Whether the product is in stock or not */
          outOfStock?: boolean;
          /**
           * Timestamp of when this option was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this option was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this option was archived */
          archivedAt?: null | string;
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "product-variants" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product variant */
          name?: string;
          /** The SKU of the product variant */
          sku?: string;
          /** The IAN (EAN) of the product variant, can be null */
          ian?: null | string;
          /**
           * Timestamp of when this product variant was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * Timestamp of when this product variant was updated
           * @format datetime
           */
          updatedAt?: string;
          /** Timestamp of when this product variant was archived */
          archivedAt?: null | string;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /** Number of units that are available to order */
          availableQuantity?: null | number;
          /** Number of units in stock that are reserved */
          reservedQuantity?: number;
          /** Total number of units in stock (available + reserved) */
          stockQuantity?: null | number;
          /**
           * Whether stock is tracked at all for this product variant.
           *
           * - `true`: stock is not tracked — a retailer can order as much of
           *
           *
           *   this variant as they want, with no restriction at all.
           * - `false`: stock is tracked — whether a retailer can order the
           *
           *
           *   variant depends on the available stock quantity and the
           *   `inventoryPolicy`.
           */
          isAlwaysInStock?: boolean;
          /**
           * Whether a retailer can order a product variant for which stock is not
           * available.
           *
           * - `deny` (default): no. A retailer cannot order a quantity larger than
           *
           *
           *   the currently available stock quantity, so the variant cannot be
           *   ordered when it is out of stock, or when the desired quantity exceeds
           *   the available quantity.
           * - `continue`: yes. The retailer can order any quantity, even when stock
           *
           *
           *   is insufficient (desired quantity > available quantity > 0) or the
           *   variant is out of stock (available quantity <= 0).
           *
           * Only meaningful when stock is tracked (`isAlwaysInStock=false`).
           * @default "deny"
           */
          inventoryPolicy?: BrandCreateTestOrderPublicInventoryPolicyEnum;
          /**
           * Resource ID used for interacting with the fulfillment service
           * @format uuid
           */
          fulfillableId?: null | string;
          /**
           * Shipping date(in future) of a preorder product e.g. 2028-12-01
           * @format date
           */
          availableAt?: string | null;
          /** List of variant images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the variant image */
            url?: string;
          }[];
        };
        relationships?: {
          /** Reference: Product Resource */
          product?: {
            /** Resource identification present in Resource Objects and Resource Identifier Objects. */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            };
          };
        };
      }
    | {
        /** @default "products" */
        type: string;
        /**
         * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
         * @format uuid
         */
        id: string;
        attributes?: {
          /** The name of the product */
          name?: string;
          /** The description of the product */
          description?: string;
          /** The language of the title and description */
          language?: string;
          /** The human readable dimensions of the product */
          dimensions?: string;
          /** The weight of the product itself */
          netWeight?: string;
          /** eg. Capacity in weight eg 100g */
          capacity?: string;
          /** The position of the product in the brands catalog, lower the higher it is */
          position?: number;
          /** How many products are shipped together, ie a case of 6 wine bottles. Presented options then would be 6, 12, 18 etc. */
          unitMultiplier?: number;
          /**
           * The VAT rate of the product
           * @format float
           */
          vatRate?: number;
          /**
           * The percentage discount if a brand is offering one (0 - 1)
           * @format float
           */
          discountRate?: number;
          /**
           * Product Type ID
           * <div class="warning"> <b>Deprecation Notice</b><br/> <p>This attribute is deprecated and will be removed in a future release.</p> <p> We strongly encourage all users to update their integrations accordingly to ensure continued compatibility. If you have any questions or need assistance, please contact support. </p> </div>
           * @format integer
           */
          productTypeId?: number;
          /** Whether the product is active or not */
          active?: boolean;
          /** Whether the product is out of stock or not */
          outOfStock?: boolean;
          /** Whether the product is archived or not */
          archived?: boolean;
          /** The suggested retail price of the product */
          retailPrice?: number;
          /** The wholesale price after the discount rate is applied */
          wholesalePrice?: number;
          /** The original wholesale price set by the brand */
          originalWholesalePrice?: number;
          /**
           * The timestamp when the product was created
           * @format datetime
           */
          createdAt?: string;
          /**
           * The timestamp when the product was indexed
           * @format datetime
           */
          indexedAt?: null | string;
          /**
           * The timestamp when the product was updated
           * @format datetime
           */
          updatedAt?: string;
          /** List of product images ordered by display priority */
          images?: {
            /** Display order of the image (lower is higher priority) */
            order?: number;
            /** URL of the product image */
            url?: string;
          }[];
          /** List of tags associated with the product */
          tags?: string[];
        };
        relationships?: {
          /** Reference: Product Option Resource */
          productOption?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
          /** Reference: Product Variant Resource */
          productVariant?: {
            /**
             * An array of objects each containing `type` and `id` members for to-many relationships.
             * @uniqueItems true
             */
            data?: {
              /**
               * [resource object identifier (uuid)](https://jsonapi.org/format/#document-resource-object-identification)
               * @format uuid
               */
              id: string;
              /** [resource object type](https://jsonapi.org/format/#document-resource-object-identification) */
              type: string;
              /** Non-standard meta-information that can not be represented as an attribute or relationship. */
              meta?: Record<string, any>;
            }[];
          };
        };
      }
  )[];
  /** An object describing the server's implementation */
  jsonapi?: {
    version?: string;
    /** Non-standard meta-information that can not be represented as an attribute or relationship. */
    meta?: Record<string, any>;
  };
}

/** A comma-separated list of resources to include (e.g: retailer,billingItems,orderItems.productVariant.product). If you include orderItems.productVariant you do not need to specify orderItems separately, it will be automatically included. */
export enum BrandCreateTestOrderPublicParams1IncludeEnum {
  Retailer = 'retailer',
  BillingItems = 'billingItems',
  OrderItems = 'orderItems',
  OrderItemsProductVariant = 'orderItems.productVariant',
  OrderItemsProductVariantProduct = 'orderItems.productVariant.product',
}
